import Vue from 'vue';

const PropValidator = {
  color: String,
  size: [String, Number],
  weight: {
    type: String
  },
  mirrored: Boolean
};
const ContextGetter = {
  contextWeight: {
    from: "weight",
    default: "regular"
  },
  contextSize: {
    from: "size",
    default: "1em"
  },
  contextColor: {
    from: "color",
    default: "currentColor"
  },
  contextMirrored: {
    from: "mirrored",
    default: false
  }
};

var script$gm = Vue.extend({
  name: "PhActivity",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$gm = script$gm;
/* template */

var __vue_render__$gm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 56 128 96 40 160 208 200 128 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 56 128 96 40 160 208 200 128 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,216h-.4a8.1,8.1,0,0,1-7.1-5.2L95.4,60.8,63.3,131.3A8,8,0,0,1,56,136H24a8,8,0,0,1,0-16H50.9L88.7,36.7A8.2,8.2,0,0,1,96.3,32a8,8,0,0,1,7.2,5.2L161,188.1l31.8-63.7A8.2,8.2,0,0,1,200,120h32a8,8,0,0,1,0,16H204.9l-37.7,75.6A8.2,8.2,0,0,1,160,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 56 128 96 40 160 208 200 128 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 56 128 96 40 160 208 200 128 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 56 128 96 40 160 208 200 128 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gm = [];
/* style */

const __vue_inject_styles__$gm = undefined;
/* scoped */

const __vue_scope_id__$gm = undefined;
/* module identifier */

const __vue_module_identifier__$gm = undefined;
/* functional template */

const __vue_is_functional_template__$gm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gm,
  staticRenderFns: __vue_staticRenderFns__$gm
}, __vue_inject_styles__$gm, __vue_script__$gm, __vue_scope_id__$gm, __vue_is_functional_template__$gm, __vue_module_identifier__$gm, false, undefined, undefined, undefined);

var script$gl = Vue.extend({
  name: "PhAddressBook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gl = script$gl;
/* template */

var __vue_render__$gl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "116",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "56",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "56",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "56",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "56",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,167.2a60,60,0,0,1,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H64a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V40A8,8,0,0,0,208,32ZM136,144a32,32,0,1,1,32-32A32,32,0,0,1,136,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "56",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "56",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "56",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "56",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,168a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,112a24,24,0,1,1-24-24A24.1,24.1,0,0,1,160,112Zm64-72V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V196H32a8,8,0,0,1,0-16H48V156H32a8,8,0,0,1,0-16H48V116H32a8,8,0,0,1,0-16H48V76H32a8,8,0,0,1,0-16H48V40A16,16,0,0,1,64,24H208A16,16,0,0,1,224,40ZM190.4,163.2A67.8,67.8,0,0,0,163,141.5a40,40,0,1,0-54,0,67.8,67.8,0,0,0-27.4,21.7,8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,88,176a8,8,0,0,0,6.4-3.2,52,52,0,0,1,83.2,0,8.1,8.1,0,0,0,11.2,1.6A8,8,0,0,0,190.4,163.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "56",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "56",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "56",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "56",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,168a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "56",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "56",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "56",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "56",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,168a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "136",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "56",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "56",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "56",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "56",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,168a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(264 -8) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gl = [];
/* style */

const __vue_inject_styles__$gl = undefined;
/* scoped */

const __vue_scope_id__$gl = undefined;
/* module identifier */

const __vue_module_identifier__$gl = undefined;
/* functional template */

const __vue_is_functional_template__$gl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gl,
  staticRenderFns: __vue_staticRenderFns__$gl
}, __vue_inject_styles__$gl, __vue_script__$gl, __vue_scope_id__$gl, __vue_is_functional_template__$gl, __vue_module_identifier__$gl, false, undefined, undefined, undefined);

var script$gk = Vue.extend({
  name: "PhAirplane",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gk = script$gk;
/* template */

var __vue_render__$gk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.2,136v32a7.8,7.8,0,0,1-2.9,6.2,7.9,7.9,0,0,1-6.6,1.6l-70.5-14v26.9l13.5,13.7A7.9,7.9,0,0,1,176,208v24a7.9,7.9,0,0,1-3.5,6.6A8.2,8.2,0,0,1,168,240a8,8,0,0,1-3-.6l-37-14.8L91,239.4a8,8,0,0,1-7.5-.8A7.9,7.9,0,0,1,80,232V208a8.1,8.1,0,0,1,2.3-5.7L96,188.7V161.8l-70.4,14A7.9,7.9,0,0,1,16,168V136a8.2,8.2,0,0,1,4.4-7.2L96,91V48a32,32,0,0,1,64,0V91l75.6,37.8A8.2,8.2,0,0,1,240.2,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gk = [];
/* style */

const __vue_inject_styles__$gk = undefined;
/* scoped */

const __vue_scope_id__$gk = undefined;
/* module identifier */

const __vue_module_identifier__$gk = undefined;
/* functional template */

const __vue_is_functional_template__$gk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gk,
  staticRenderFns: __vue_staticRenderFns__$gk
}, __vue_inject_styles__$gk, __vue_script__$gk, __vue_scope_id__$gk, __vue_is_functional_template__$gk, __vue_module_identifier__$gk, false, undefined, undefined, undefined);

var script$gj = Vue.extend({
  name: "PhAirplaneInFlight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gj = script$gj;
/* template */

var __vue_render__$gj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a8,8,0,0,1-8,8H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216ZM208,100H153.8L110.9,53.3A3.9,3.9,0,0,0,108,52H91.1a11.6,11.6,0,0,0-9.7,5,11.9,11.9,0,0,0-1.7,10.8L90.5,100H65.9L47.1,77.4A4.1,4.1,0,0,0,44,76H26.8a12.1,12.1,0,0,0-9.7,4.8,11.9,11.9,0,0,0-1.8,10.6l14,46.9A35.8,35.8,0,0,0,63.8,164H240a4,4,0,0,0,4-4V136A36,36,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gj = [];
/* style */

const __vue_inject_styles__$gj = undefined;
/* scoped */

const __vue_scope_id__$gj = undefined;
/* module identifier */

const __vue_module_identifier__$gj = undefined;
/* functional template */

const __vue_is_functional_template__$gj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gj,
  staticRenderFns: __vue_staticRenderFns__$gj
}, __vue_inject_styles__$gj, __vue_script__$gj, __vue_scope_id__$gj, __vue_is_functional_template__$gj, __vue_module_identifier__$gj, false, undefined, undefined, undefined);

var script$gi = Vue.extend({
  name: "PhAirplaneLanding",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gi = script$gi;
/* template */

var __vue_render__$gi = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,216a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16H240A8,8,0,0,1,248,216Zm-24-28a4.1,4.1,0,0,0,2.4-.8A4,4,0,0,0,228,184V148.3a36.1,36.1,0,0,0-26.4-34.7l-46.9-13L123.5,46a4.3,4.3,0,0,0-2.2-1.8l-13.5-4.5A11.9,11.9,0,0,0,97,41.4a11.6,11.6,0,0,0-5,9.7V82.6L66.8,74.7,51.5,46.1a4.1,4.1,0,0,0-2.2-1.9L35.8,39.7A11.9,11.9,0,0,0,25,41.4a11.6,11.6,0,0,0-5,9.7v52.6a36.1,36.1,0,0,0,26.3,34.7l176.6,49.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gi = [];
/* style */

const __vue_inject_styles__$gi = undefined;
/* scoped */

const __vue_scope_id__$gi = undefined;
/* module identifier */

const __vue_module_identifier__$gi = undefined;
/* functional template */

const __vue_is_functional_template__$gi = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gi = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gi,
  staticRenderFns: __vue_staticRenderFns__$gi
}, __vue_inject_styles__$gi, __vue_script__$gi, __vue_scope_id__$gi, __vue_is_functional_template__$gi, __vue_module_identifier__$gi, false, undefined, undefined, undefined);

var script$gh = Vue.extend({
  name: "PhAirplaneTakeoff",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gh = script$gh;
/* template */

var __vue_render__$gh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,216a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16H168A8,8,0,0,1,176,216ZM247.1,89.5,228.5,66.7a35.9,35.9,0,0,0-46.2-8.2L139.5,83.6,81.3,64.2a4.1,4.1,0,0,0-2.9.1L61.9,71.4a12,12,0,0,0-3.3,19.9l26.6,24L63.7,127.5,37.6,116.3a4.4,4.4,0,0,0-3.2,0l-16.7,7.2a12,12,0,0,0-3.5,19.8h0l37.7,35.3a35.8,35.8,0,0,0,42.7,4.9L246,95.5a4,4,0,0,0,1.9-2.8A4.1,4.1,0,0,0,247.1,89.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gh = [];
/* style */

const __vue_inject_styles__$gh = undefined;
/* scoped */

const __vue_scope_id__$gh = undefined;
/* module identifier */

const __vue_module_identifier__$gh = undefined;
/* functional template */

const __vue_is_functional_template__$gh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gh,
  staticRenderFns: __vue_staticRenderFns__$gh
}, __vue_inject_styles__$gh, __vue_script__$gh, __vue_scope_id__$gh, __vue_is_functional_template__$gh, __vue_module_identifier__$gh, false, undefined, undefined, undefined);

var script$gg = Vue.extend({
  name: "PhAirplaneTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gg = script$gg;
/* template */

var __vue_render__$gg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215,86.2l-29.8,28,30.2,83.1a8,8,0,0,1-1.9,8.4l-24,24a8.2,8.2,0,0,1-6.4,2.3,8.1,8.1,0,0,1-5.8-3.5l-42.6-62.3-18.8,17.3V204a8.2,8.2,0,0,1-2.4,5.7l-20,20a7.9,7.9,0,0,1-5.6,2.3l-1.8-.2a8,8,0,0,1-5.8-5.2L67.4,188.5,29.3,175.6a8,8,0,0,1-5.2-5.8,8.3,8.3,0,0,1,2.1-7.5l20-20a8.1,8.1,0,0,1,5.7-2.3H72.6l18.7-18.8L27.4,78.7a8.7,8.7,0,0,1-3.5-5.9,8.2,8.2,0,0,1,2.3-6.5l24-24a7.9,7.9,0,0,1,8.4-1.8l83.1,30.2,26.6-28.2a5.2,5.2,0,0,1,1-1.1,32,32,0,0,1,47,43.3A6.4,6.4,0,0,1,215,86.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gg = [];
/* style */

const __vue_inject_styles__$gg = undefined;
/* scoped */

const __vue_scope_id__$gg = undefined;
/* module identifier */

const __vue_module_identifier__$gg = undefined;
/* functional template */

const __vue_is_functional_template__$gg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gg,
  staticRenderFns: __vue_staticRenderFns__$gg
}, __vue_inject_styles__$gg, __vue_script__$gg, __vue_scope_id__$gg, __vue_is_functional_template__$gg, __vue_module_identifier__$gg, false, undefined, undefined, undefined);

var script$gf = Vue.extend({
  name: "PhAirplay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gf = script$gf;
/* template */

var __vue_render__$gf = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 176 216 80 216 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,192a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A16,16,0,0,0,32,64V176a16,16,0,0,0,16,16h52.6L128,160l27.4,32H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 160 176 216 80 216 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M182.1,210.8A8,8,0,0,1,176,224H80a8,8,0,0,1-6.1-13.2l48-56a8,8,0,0,1,12.2,0ZM208,40H48A23.9,23.9,0,0,0,24,64V176a23.9,23.9,0,0,0,24,24H60.3a4.1,4.1,0,0,0,3-1.4l46.5-54.2a23.9,23.9,0,0,1,36.4,0l46.5,54.2a4.1,4.1,0,0,0,3,1.4H208a23.9,23.9,0,0,0,24-24V64A23.9,23.9,0,0,0,208,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 176 216 80 216 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 176 216 80 216 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 176 216 80 216 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gf = [];
/* style */

const __vue_inject_styles__$gf = undefined;
/* scoped */

const __vue_scope_id__$gf = undefined;
/* module identifier */

const __vue_module_identifier__$gf = undefined;
/* functional template */

const __vue_is_functional_template__$gf = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gf = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gf,
  staticRenderFns: __vue_staticRenderFns__$gf
}, __vue_inject_styles__$gf, __vue_script__$gf, __vue_scope_id__$gf, __vue_is_functional_template__$gf, __vue_module_identifier__$gf, false, undefined, undefined, undefined);

var script$ge = Vue.extend({
  name: "PhAlarm",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ge = script$ge;
/* template */

var __vue_render__$ge = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 80 128 128 176 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "201.5",
      "y1": "20.5",
      "x2": "235.5",
      "y2": "54.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.5",
      "y1": "54.5",
      "x2": "54.5",
      "y2": "20.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "26.2",
      "x2": "229.8",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.2",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "26.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.5,54.5l-34-34a8,8,0,1,0-11.3,11.3l34,34a8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3A8,8,0,0,0,235.5,54.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,20.5a8,8,0,0,0-11.3,0l-34,34a8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l34-34A8,8,0,0,0,65.8,20.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,125.2a14.8,14.8,0,0,1-.1-2.1h0A96,96,0,0,0,133,32.1H123A96,96,0,0,0,32.1,123h0a14.8,14.8,0,0,1-.1,2.1v5.6a14.8,14.8,0,0,1,.1,2.1h0A96,96,0,0,0,123,223.9h10A96,96,0,0,0,223.9,133h0a14.8,14.8,0,0,1,.1-2.1v-5.6ZM184,136H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "26.2",
      "x2": "229.8",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.2",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "26.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "26.2",
      "x2": "229.8",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.2",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "26.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "26.2",
      "x2": "229.8",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "26.2",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "26.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ge = [];
/* style */

const __vue_inject_styles__$ge = undefined;
/* scoped */

const __vue_scope_id__$ge = undefined;
/* module identifier */

const __vue_module_identifier__$ge = undefined;
/* functional template */

const __vue_is_functional_template__$ge = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ge = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ge,
  staticRenderFns: __vue_staticRenderFns__$ge
}, __vue_inject_styles__$ge, __vue_script__$ge, __vue_scope_id__$ge, __vue_is_functional_template__$ge, __vue_module_identifier__$ge, false, undefined, undefined, undefined);

var script$gd = Vue.extend({
  name: "PhAlien",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gd = script$gd;
/* template */

var __vue_render__$gd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,140a24.1,24.1,0,0,1-24-24v-4a24.1,24.1,0,0,1,24,24Z",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,140v-4a24.1,24.1,0,0,1,24-24v4a24.1,24.1,0,0,1-24,24Z",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "184",
      "x2": "140",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a88,88,0,0,0-88,88c0,48.6,56,120,88,120s88-71.4,88-120A88,88,0,0,0,128,24ZM112,140a8,8,0,0,1-8,8,32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8,32,32,0,0,1,32,32Zm72-24a32,32,0,0,1-32,32,8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32,8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
      "transform": "translate(184 252) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4A32,32,0,0,1,176,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,16a96.2,96.2,0,0,0-96,96c0,24,12.6,55.1,33.6,83s44.5,45,62.4,45,41.2-16.8,62.4-45S224,136,224,112A96.2,96.2,0,0,0,128,16ZM64,116v-4a12,12,0,0,1,12-12,36,36,0,0,1,36,36v4a12,12,0,0,1-12,12A36,36,0,0,1,64,116Zm80,84H112a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Zm48-84a36,36,0,0,1-36,36,12,12,0,0,1-12-12v-4a36,36,0,0,1,36-36,12,12,0,0,1,12,12Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4A8,8,0,0,1,80,104Z",
      "transform": "translate(184 252) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
      "transform": "translate(184 252) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
      "transform": "translate(184 252) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gd = [];
/* style */

const __vue_inject_styles__$gd = undefined;
/* scoped */

const __vue_scope_id__$gd = undefined;
/* module identifier */

const __vue_module_identifier__$gd = undefined;
/* functional template */

const __vue_is_functional_template__$gd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gd,
  staticRenderFns: __vue_staticRenderFns__$gd
}, __vue_inject_styles__$gd, __vue_script__$gd, __vue_scope_id__$gd, __vue_is_functional_template__$gd, __vue_module_identifier__$gd, false, undefined, undefined, undefined);

var script$gc = Vue.extend({
  name: "PhAlignBottom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gc = script$gc;
/* template */

var __vue_render__$gc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "122",
      "y": "98",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(50 298) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "52",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216Zm-72-24h40a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H152a16,16,0,0,0-16,16v96A16,16,0,0,0,152,192Zm-88,0h40a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V176A16,16,0,0,0,64,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(44 300) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gc = [];
/* style */

const __vue_inject_styles__$gc = undefined;
/* scoped */

const __vue_scope_id__$gc = undefined;
/* module identifier */

const __vue_module_identifier__$gc = undefined;
/* functional template */

const __vue_is_functional_template__$gc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gc,
  staticRenderFns: __vue_staticRenderFns__$gc
}, __vue_inject_styles__$gc, __vue_script__$gc, __vue_scope_id__$gc, __vue_is_functional_template__$gc, __vue_module_identifier__$gc, false, undefined, undefined, undefined);

var script$gb = Vue.extend({
  name: "PhAlignBottomSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$gb = script$gb;
/* template */

var __vue_render__$gb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "168",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,232a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,232ZM96,208h64a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H96A16,16,0,0,0,80,40V192A16,16,0,0,0,96,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "32",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$gb = [];
/* style */

const __vue_inject_styles__$gb = undefined;
/* scoped */

const __vue_scope_id__$gb = undefined;
/* module identifier */

const __vue_module_identifier__$gb = undefined;
/* functional template */

const __vue_is_functional_template__$gb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$gb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$gb,
  staticRenderFns: __vue_staticRenderFns__$gb
}, __vue_inject_styles__$gb, __vue_script__$gb, __vue_scope_id__$gb, __vue_is_functional_template__$gb, __vue_module_identifier__$gb, false, undefined, undefined, undefined);

var script$ga = Vue.extend({
  name: "PhAlignCenterHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ga = script$ga;
/* template */

var __vue_render__$ga = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "204",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "52",
      "width": "128",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "148",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,152v40a16,16,0,0,1-16,16H136v16a8,8,0,0,1-16,0V208H48a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16h72V120H72a16,16,0,0,1-16-16V64A16,16,0,0,1,72,48h48V32a8,8,0,0,1,16,0V48h48a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H136v16h72A16,16,0,0,1,224,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ga = [];
/* style */

const __vue_inject_styles__$ga = undefined;
/* scoped */

const __vue_scope_id__$ga = undefined;
/* module identifier */

const __vue_module_identifier__$ga = undefined;
/* functional template */

const __vue_is_functional_template__$ga = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ga = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ga,
  staticRenderFns: __vue_staticRenderFns__$ga
}, __vue_inject_styles__$ga, __vue_script__$ga, __vue_scope_id__$ga, __vue_is_functional_template__$ga, __vue_module_identifier__$ga, false, undefined, undefined, undefined);

var script$g9 = Vue.extend({
  name: "PhAlignCenterHorizontalSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g9 = script$g9;
/* template */

var __vue_render__$g9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96v64a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V176H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80h72V48a8,8,0,0,1,16,0V80h72A16,16,0,0,1,224,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g9 = [];
/* style */

const __vue_inject_styles__$g9 = undefined;
/* scoped */

const __vue_scope_id__$g9 = undefined;
/* module identifier */

const __vue_module_identifier__$g9 = undefined;
/* functional template */

const __vue_is_functional_template__$g9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g9,
  staticRenderFns: __vue_staticRenderFns__$g9
}, __vue_inject_styles__$g9, __vue_script__$g9, __vue_scope_id__$g9, __vue_is_functional_template__$g9, __vue_module_identifier__$g9, false, undefined, undefined, undefined);

var script$g8 = Vue.extend({
  name: "PhAlignCenterVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g8 = script$g8;
/* template */

var __vue_render__$g8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "204",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "128",
      "x2": "108",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "112",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(304 -48) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "112",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128a8,8,0,0,1-8,8H208v48a16,16,0,0,1-16,16H152a16,16,0,0,1-16-16V136H120v72a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V136H32a8,8,0,0,1,0-16H48V48A16,16,0,0,1,64,32h40a16,16,0,0,1,16,16v72h16V72a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16v48h16A8,8,0,0,1,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "112",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "112",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "112",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "128",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "56",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g8 = [];
/* style */

const __vue_inject_styles__$g8 = undefined;
/* scoped */

const __vue_scope_id__$g8 = undefined;
/* module identifier */

const __vue_module_identifier__$g8 = undefined;
/* functional template */

const __vue_is_functional_template__$g8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g8,
  staticRenderFns: __vue_staticRenderFns__$g8
}, __vue_inject_styles__$g8, __vue_script__$g8, __vue_scope_id__$g8, __vue_is_functional_template__$g8, __vue_module_identifier__$g8, false, undefined, undefined, undefined);

var script$g7 = Vue.extend({
  name: "PhAlignCenterVerticalSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g7 = script$g7;
/* template */

var __vue_render__$g7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,128a8,8,0,0,1-8,8H176v72a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16V136H48a8,8,0,0,1,0-16H80V48A16,16,0,0,1,96,32h64a16,16,0,0,1,16,16v72h32A8,8,0,0,1,216,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "80",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g7 = [];
/* style */

const __vue_inject_styles__$g7 = undefined;
/* scoped */

const __vue_scope_id__$g7 = undefined;
/* module identifier */

const __vue_module_identifier__$g7 = undefined;
/* functional template */

const __vue_is_functional_template__$g7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g7,
  staticRenderFns: __vue_staticRenderFns__$g7
}, __vue_inject_styles__$g7, __vue_script__$g7, __vue_scope_id__$g7, __vue_is_functional_template__$g7, __vue_module_identifier__$g7, false, undefined, undefined, undefined);

var script$g6 = Vue.extend({
  name: "PhAlignLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g6 = script$g6;
/* template */

var __vue_render__$g6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "56",
      "width": "104",
      "height": "52",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "148",
      "width": "144",
      "height": "52",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm32,80h96a16,16,0,0,0,16-16V64a16,16,0,0,0-16-16H80A16,16,0,0,0,64,64v40A16,16,0,0,0,80,120Zm136,16H80a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V152A16,16,0,0,0,216,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g6 = [];
/* style */

const __vue_inject_styles__$g6 = undefined;
/* scoped */

const __vue_scope_id__$g6 = undefined;
/* module identifier */

const __vue_module_identifier__$g6 = undefined;
/* functional template */

const __vue_is_functional_template__$g6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g6,
  staticRenderFns: __vue_staticRenderFns__$g6
}, __vue_inject_styles__$g6, __vue_script__$g6, __vue_scope_id__$g6, __vue_is_functional_template__$g6, __vue_module_identifier__$g6, false, undefined, undefined, undefined);

var script$g5 = Vue.extend({
  name: "PhAlignLeftSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g5 = script$g5;
/* template */

var __vue_render__$g5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "32",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "88",
      "width": "160",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "32",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM224,80H72A16,16,0,0,0,56,96v64a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V96A16,16,0,0,0,224,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "32",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "32",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "32",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g5 = [];
/* style */

const __vue_inject_styles__$g5 = undefined;
/* scoped */

const __vue_scope_id__$g5 = undefined;
/* module identifier */

const __vue_module_identifier__$g5 = undefined;
/* functional template */

const __vue_is_functional_template__$g5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g5,
  staticRenderFns: __vue_staticRenderFns__$g5
}, __vue_inject_styles__$g5, __vue_script__$g5, __vue_scope_id__$g5, __vue_is_functional_template__$g5, __vue_module_identifier__$g5, false, undefined, undefined, undefined);

var script$g4 = Vue.extend({
  name: "PhAlignRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g4 = script$g4;
/* template */

var __vue_render__$g4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(248 164) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "148",
      "width": "144",
      "height": "52",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm-48,8H80A16,16,0,0,0,64,64v40a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V64A16,16,0,0,0,176,48Zm0,88H40a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V152A16,16,0,0,0,176,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "56",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(256 168) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "144",
      "width": "152",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g4 = [];
/* style */

const __vue_inject_styles__$g4 = undefined;
/* scoped */

const __vue_scope_id__$g4 = undefined;
/* module identifier */

const __vue_module_identifier__$g4 = undefined;
/* functional template */

const __vue_is_functional_template__$g4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g4,
  staticRenderFns: __vue_staticRenderFns__$g4
}, __vue_inject_styles__$g4, __vue_script__$g4, __vue_scope_id__$g4, __vue_is_functional_template__$g4, __vue_module_identifier__$g4, false, undefined, undefined, undefined);

var script$g3 = Vue.extend({
  name: "PhAlignRightSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g3 = script$g3;
/* template */

var __vue_render__$g3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "224",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "160",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "224",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM184,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V96A16,16,0,0,0,184,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "224",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "224",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "224",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "88",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g3 = [];
/* style */

const __vue_inject_styles__$g3 = undefined;
/* scoped */

const __vue_scope_id__$g3 = undefined;
/* module identifier */

const __vue_module_identifier__$g3 = undefined;
/* functional template */

const __vue_is_functional_template__$g3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g3,
  staticRenderFns: __vue_staticRenderFns__$g3
}, __vue_inject_styles__$g3, __vue_script__$g3, __vue_scope_id__$g3, __vue_is_functional_template__$g3, __vue_module_identifier__$g3, false, undefined, undefined, undefined);

var script$g2 = Vue.extend({
  name: "PhAlignTop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g2 = script$g2;
/* template */

var __vue_render__$g2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "122",
      "y": "106",
      "width": "104",
      "height": "52",
      "rx": "8",
      "transform": "translate(306 -42) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "52",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,40a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40ZM192,64H152a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V80A16,16,0,0,0,192,64Zm-88,0H64A16,16,0,0,0,48,80V216a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V80A16,16,0,0,0,104,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "116",
      "y": "100",
      "width": "112",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "72",
      "width": "56",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g2 = [];
/* style */

const __vue_inject_styles__$g2 = undefined;
/* scoped */

const __vue_scope_id__$g2 = undefined;
/* module identifier */

const __vue_module_identifier__$g2 = undefined;
/* functional template */

const __vue_is_functional_template__$g2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g2,
  staticRenderFns: __vue_staticRenderFns__$g2
}, __vue_inject_styles__$g2, __vue_script__$g2, __vue_scope_id__$g2, __vue_is_functional_template__$g2, __vue_module_identifier__$g2, false, undefined, undefined, undefined);

var script$g1 = Vue.extend({
  name: "PhAlignTopSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g1 = script$g1;
/* template */

var __vue_render__$g1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "32",
      "x2": "200",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "72",
      "width": "80",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "64",
      "width": "80",
      "height": "168",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "32",
      "x2": "200",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "64",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,32ZM160,56H96A16,16,0,0,0,80,72V224a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V72A16,16,0,0,0,160,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "32",
      "x2": "200",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "64",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "32",
      "x2": "200",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "64",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "32",
      "x2": "200",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "64",
      "width": "80",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g1 = [];
/* style */

const __vue_inject_styles__$g1 = undefined;
/* scoped */

const __vue_scope_id__$g1 = undefined;
/* module identifier */

const __vue_module_identifier__$g1 = undefined;
/* functional template */

const __vue_is_functional_template__$g1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g1,
  staticRenderFns: __vue_staticRenderFns__$g1
}, __vue_inject_styles__$g1, __vue_script__$g1, __vue_scope_id__$g1, __vue_is_functional_template__$g1, __vue_module_identifier__$g1, false, undefined, undefined, undefined);

var script$g0 = Vue.extend({
  name: "PhAnchor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g0 = script$g0;
/* template */

var __vue_render__$g0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136a8,8,0,0,0-8,8,40,40,0,0,1-40,40,47.9,47.9,0,0,0-32,12.3V120h32a8,8,0,0,0,0-16H136V78.8a28,28,0,1,0-16,0V104H88a8,8,0,0,0,0,16h32v76.3A47.9,47.9,0,0,0,88,184a40,40,0,0,1-40-40,8,8,0,0,0-16,0,56,56,0,0,0,56,56,32.1,32.1,0,0,1,32,32,8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,56,56,0,0,0,56-56A8,8,0,0,0,216,136ZM116,52a12,12,0,1,1,12,12A12,12,0,0,1,116,52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g0 = [];
/* style */

const __vue_inject_styles__$g0 = undefined;
/* scoped */

const __vue_scope_id__$g0 = undefined;
/* module identifier */

const __vue_module_identifier__$g0 = undefined;
/* functional template */

const __vue_is_functional_template__$g0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g0,
  staticRenderFns: __vue_staticRenderFns__$g0
}, __vue_inject_styles__$g0, __vue_script__$g0, __vue_scope_id__$g0, __vue_is_functional_template__$g0, __vue_module_identifier__$g0, false, undefined, undefined, undefined);

var script$f$ = Vue.extend({
  name: "PhAnchorSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f$ = script$f$;
/* template */

var __vue_render__$f$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120H32a96,96,0,0,0,192,0H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120H32a96,96,0,0,0,192,0H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,112H200a8,8,0,0,0,0,16h15.6A88,88,0,0,1,136,207.6V95a32,32,0,1,0-16,0V207.6A88,88,0,0,1,40.4,128H56a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8,104,104,0,0,0,208,0A8,8,0,0,0,224,112ZM112,64a16,16,0,1,1,16,16A16,16,0,0,1,112,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120H32a96,96,0,0,0,192,0H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120H32a96,96,0,0,0,192,0H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120H32a96,96,0,0,0,192,0H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f$ = [];
/* style */

const __vue_inject_styles__$f$ = undefined;
/* scoped */

const __vue_scope_id__$f$ = undefined;
/* module identifier */

const __vue_module_identifier__$f$ = undefined;
/* functional template */

const __vue_is_functional_template__$f$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f$,
  staticRenderFns: __vue_staticRenderFns__$f$
}, __vue_inject_styles__$f$, __vue_script__$f$, __vue_scope_id__$f$, __vue_is_functional_template__$f$, __vue_module_identifier__$f$, false, undefined, undefined, undefined);

var script$f_ = Vue.extend({
  name: "PhAndroidLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f_ = script$f_;
/* template */

var __vue_render__$f_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "63.1",
      "y2": "87.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "193.1",
      "y2": "86.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "63.1",
      "y2": "87.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "193.1",
      "y2": "86.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.1,88.7l-2.3-2.2,24.9-24.8a8.1,8.1,0,0,0-11.4-11.4l-25.9,26a111.5,111.5,0,0,0-128.6.2L37.7,50.3A8.1,8.1,0,0,0,26.3,61.7l25.1,25A113.4,113.4,0,0,0,16,169.1V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V168A111.2,111.2,0,0,0,207.1,88.7ZM92,168a12,12,0,1,1,12-12A12,12,0,0,1,92,168Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "63.1",
      "y2": "87.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "193.1",
      "y2": "86.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "63.1",
      "y2": "87.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "193.1",
      "y2": "86.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "56",
      "x2": "63.1",
      "y2": "87.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "193.1",
      "y2": "86.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f_ = [];
/* style */

const __vue_inject_styles__$f_ = undefined;
/* scoped */

const __vue_scope_id__$f_ = undefined;
/* module identifier */

const __vue_module_identifier__$f_ = undefined;
/* functional template */

const __vue_is_functional_template__$f_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f_,
  staticRenderFns: __vue_staticRenderFns__$f_
}, __vue_inject_styles__$f_, __vue_script__$f_, __vue_scope_id__$f_, __vue_is_functional_template__$f_, __vue_module_identifier__$f_, false, undefined, undefined, undefined);

var script$fZ = Vue.extend({
  name: "PhAngularLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fZ = script$fZ;
/* template */

var __vue_render__$fZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 160 128 88 92 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100.7",
      "y1": "142.7",
      "x2": "155.3",
      "y2": "142.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 160 128 88 92 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.7",
      "y1": "138.7",
      "x2": "153.3",
      "y2": "138.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.1,64.6l-96-40a8.3,8.3,0,0,0-6.2,0l-96,40a8.1,8.1,0,0,0-4.8,8.5l16,120a8.1,8.1,0,0,0,4.3,6.1l80,40a8.5,8.5,0,0,0,7.2,0l80-40a8.1,8.1,0,0,0,4.3-6.1l16-120A8.1,8.1,0,0,0,227.1,64.6ZM167.6,167.2a9.4,9.4,0,0,1-3.6.8,8.1,8.1,0,0,1-7.2-4.4l-8.4-16.9H107.6l-8.4,16.9a8,8,0,0,1-14.4-7.2l36-72a8.1,8.1,0,0,1,14.4,0l36,72A8.2,8.2,0,0,1,167.6,167.2ZM128,105.9l12.4,24.8H115.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 160 128 88 92 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.7",
      "y1": "138.7",
      "x2": "153.3",
      "y2": "138.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 160 128 88 92 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.7",
      "y1": "138.7",
      "x2": "153.3",
      "y2": "138.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 160 128 88 92 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.7",
      "y1": "138.7",
      "x2": "153.3",
      "y2": "138.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fZ = [];
/* style */

const __vue_inject_styles__$fZ = undefined;
/* scoped */

const __vue_scope_id__$fZ = undefined;
/* module identifier */

const __vue_module_identifier__$fZ = undefined;
/* functional template */

const __vue_is_functional_template__$fZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fZ,
  staticRenderFns: __vue_staticRenderFns__$fZ
}, __vue_inject_styles__$fZ, __vue_script__$fZ, __vue_scope_id__$fZ, __vue_is_functional_template__$fZ, __vue_module_identifier__$fZ, false, undefined, undefined, undefined);

var script$fY = Vue.extend({
  name: "PhAperture",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fY = script$fY;
/* template */

var __vue_render__$fY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.7",
      "y2": "134.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "80",
      "x2": "152.1",
      "y2": "99.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "176",
      "x2": "115.5",
      "y2": "92.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3",
      "y2": "121.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "176",
      "x2": "103.9",
      "y2": "156.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "140.5",
      "y2": "163.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,60.1a96,96,0,1,0,0,135.8A96,96,0,0,0,195.9,60.1Zm-31.2,74.6-24.2,28.4h0l-36.6-6.7h0L91.3,121.3h0l24.2-28.4h0l36.6,6.7h0l12.6,35.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.7",
      "y2": "134.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "80",
      "x2": "152.1",
      "y2": "99.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "176",
      "x2": "115.5",
      "y2": "92.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3",
      "y2": "121.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "176",
      "x2": "103.9",
      "y2": "156.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "140.5",
      "y2": "163.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A104.1,104.1,0,0,0,128,24,104.1,104.1,0,0,0,24,128,104.1,104.1,0,0,0,128,232h.1A104.1,104.1,0,0,0,232,128ZM49.2,88.9l51.2,9.4L46.7,161.5A88,88,0,0,1,49.2,88.9Zm160.1,5.6a88,88,0,0,1-2.5,72.6l-51.2-9.4Zm-8-15.2L167.6,119l-28-78.2a86.8,86.8,0,0,1,50.6,25A88.5,88.5,0,0,1,201.3,79.3ZM122.4,40.2l17.5,49L58.3,74.3a99.2,99.2,0,0,1,7.5-8.5A87.1,87.1,0,0,1,122.4,40.2ZM54.7,176.7,88.4,137l28,78.2a86.8,86.8,0,0,1-50.6-25A88.5,88.5,0,0,1,54.7,176.7Zm78.9,39.1-17.5-49,23,4.2h.1l58.5,10.7a99.2,99.2,0,0,1-7.5,8.5A87.1,87.1,0,0,1,133.6,215.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.7",
      "y2": "134.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "80",
      "x2": "152.1",
      "y2": "99.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "176",
      "x2": "115.5",
      "y2": "92.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3",
      "y2": "121.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "176",
      "x2": "103.9",
      "y2": "156.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "140.5",
      "y2": "163.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.7",
      "y2": "134.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "80",
      "x2": "152.1",
      "y2": "99.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "176",
      "x2": "115.5",
      "y2": "92.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3",
      "y2": "121.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "176",
      "x2": "103.9",
      "y2": "156.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "140.5",
      "y2": "163.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "164.7",
      "y2": "134.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "80",
      "x2": "152.1",
      "y2": "99.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.9",
      "y1": "176",
      "x2": "115.5",
      "y2": "92.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "91.3",
      "y2": "121.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "176",
      "x2": "103.9",
      "y2": "156.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "140.5",
      "y2": "163.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fY = [];
/* style */

const __vue_inject_styles__$fY = undefined;
/* scoped */

const __vue_scope_id__$fY = undefined;
/* module identifier */

const __vue_module_identifier__$fY = undefined;
/* functional template */

const __vue_is_functional_template__$fY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fY,
  staticRenderFns: __vue_staticRenderFns__$fY
}, __vue_inject_styles__$fY, __vue_script__$fY, __vue_scope_id__$fY, __vue_is_functional_template__$fY, __vue_module_identifier__$fY, false, undefined, undefined, undefined);

var script$fX = Vue.extend({
  name: "PhAppStoreLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fX = script$fX;
/* template */

var __vue_render__$fX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "128",
      "y2": "80.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "40",
      "x2": "76.4",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.6",
      "y1": "168",
      "x2": "232",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.2",
      "y1": "119.9",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "168",
      "x2": "133.2",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.7",
      "y1": "208",
      "x2": "48",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "146.6",
      "y1": "112.1",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "128",
      "y2": "80.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.5",
      "y1": "200",
      "x2": "48",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "40",
      "x2": "76.4",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.6",
      "y1": "168",
      "x2": "232",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "168",
      "x2": "142.5",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64.3,204.1l-9.4,16A8.1,8.1,0,0,1,48,224a8.7,8.7,0,0,1-4.1-1.1,8.1,8.1,0,0,1-2.8-11l9.5-16a8,8,0,1,1,13.7,8.2ZM232,160H184.2l-30.7-52a8,8,0,0,0-11-2.8,7.9,7.9,0,0,0-2.8,10.9l61.4,104A8.1,8.1,0,0,0,208,224a8.7,8.7,0,0,0,4.1-1.1,8.1,8.1,0,0,0,2.8-11L193.7,176H232a8,8,0,0,0,0-16Zm-89.5,0H90.4l44.4-75.2h.1l24-40.6a8,8,0,0,0-13.8-8.2L128,64.9l-17.1-29a8,8,0,1,0-13.8,8.2l21.6,36.5L71.8,160H24a8,8,0,0,0,0,16H142.5a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "146.6",
      "y1": "112.1",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "128",
      "y2": "80.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.5",
      "y1": "200",
      "x2": "48",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "40",
      "x2": "76.4",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.6",
      "y1": "168",
      "x2": "232",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "168",
      "x2": "142.5",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "146.6",
      "y1": "112.1",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "128",
      "y2": "80.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.5",
      "y1": "200",
      "x2": "48",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "40",
      "x2": "76.4",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.6",
      "y1": "168",
      "x2": "232",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "168",
      "x2": "142.5",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "146.6",
      "y1": "112.1",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "128",
      "y2": "80.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.5",
      "y1": "200",
      "x2": "48",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "40",
      "x2": "76.4",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.6",
      "y1": "168",
      "x2": "232",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "168",
      "x2": "142.5",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fX = [];
/* style */

const __vue_inject_styles__$fX = undefined;
/* scoped */

const __vue_scope_id__$fX = undefined;
/* module identifier */

const __vue_module_identifier__$fX = undefined;
/* functional template */

const __vue_is_functional_template__$fX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fX,
  staticRenderFns: __vue_staticRenderFns__$fX
}, __vue_inject_styles__$fX, __vue_script__$fX, __vue_scope_id__$fX, __vue_is_functional_template__$fX, __vue_module_identifier__$fX, false, undefined, undefined, undefined);

var script$fW = Vue.extend({
  name: "PhAppWindow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fW = script$fW;
/* template */

var __vue_render__$fW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "92",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM68,96A12,12,0,1,1,80,84,12,12,0,0,1,68,96Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fW = [];
/* style */

const __vue_inject_styles__$fW = undefined;
/* scoped */

const __vue_scope_id__$fW = undefined;
/* module identifier */

const __vue_module_identifier__$fW = undefined;
/* functional template */

const __vue_is_functional_template__$fW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fW,
  staticRenderFns: __vue_staticRenderFns__$fW
}, __vue_inject_styles__$fW, __vue_script__$fW, __vue_scope_id__$fW, __vue_is_functional_template__$fW, __vue_module_identifier__$fW, false, undefined, undefined, undefined);

var script$fV = Vue.extend({
  name: "PhAppleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fV = script$fV;
/* template */

var __vue_render__$fV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143.5,23.4A31.9,31.9,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.1,32.5A32,32,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M130.7,29.6A40.2,40.2,0,0,1,168,4a8,8,0,0,1,0,16,24.1,24.1,0,0,0-22.4,15.4,8,8,0,0,1-7.5,5.1,9.2,9.2,0,0,1-2.8-.5A8,8,0,0,1,130.7,29.6ZM222,155.8a40,40,0,0,1-2.7-70A8.2,8.2,0,0,0,221.5,74,68,68,0,0,0,128,61,68,68,0,0,0,20,116a135,135,0,0,0,22.9,74c14.4,21.3,32.7,34,49.1,34h72c22.5,0,47.9-23.9,61.9-58A7.9,7.9,0,0,0,222,155.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.1,32.5A32,32,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.1,32.5A32,32,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.1,32.5A32,32,0,0,1,168,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fV = [];
/* style */

const __vue_inject_styles__$fV = undefined;
/* scoped */

const __vue_scope_id__$fV = undefined;
/* module identifier */

const __vue_module_identifier__$fV = undefined;
/* functional template */

const __vue_is_functional_template__$fV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fV,
  staticRenderFns: __vue_staticRenderFns__$fV
}, __vue_inject_styles__$fV, __vue_script__$fV, __vue_scope_id__$fV, __vue_is_functional_template__$fV, __vue_module_identifier__$fV, false, undefined, undefined, undefined);

var script$fU = Vue.extend({
  name: "PhApplePodcastsLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fU = script$fU;
/* template */

var __vue_render__$fU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "108",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134.6,224H121.4a16,16,0,0,1-15.8-13.1l-10.2-56A16,16,0,0,1,111.2,136h33.6a16,16,0,0,1,15.8,18.9l-10.2,56A16,16,0,0,1,134.6,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134.6,224H121.4a16,16,0,0,1-15.8-13.1l-10.2-56A16,16,0,0,1,111.2,136h33.6a16,16,0,0,1,15.8,18.9l-10.2,56A16,16,0,0,1,134.6,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.7,198.4a96,96,0,1,1,130.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.3,151.2a64,64,0,1,1,119.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.4,208.9a96,96,0,1,1,103.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,144a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,144Zm12.5,0h-25a19.9,19.9,0,0,0-15.4,7.3,19.6,19.6,0,0,0-4.2,16.6l9.6,48A20.1,20.1,0,0,0,125.1,232h5.8a20.1,20.1,0,0,0,19.6-16.1l9.6-48a19.6,19.6,0,0,0-4.2-16.6A19.9,19.9,0,0,0,140.5,144Zm39.7,4.3a8,8,0,0,0,14.9,5.8A70.7,70.7,0,0,0,200,128a72,72,0,0,0-144,0,70.3,70.3,0,0,0,4.9,26.1,8,8,0,0,0,7.4,5.1,7.2,7.2,0,0,0,2.9-.6,8,8,0,0,0,4.6-10.3,56,56,0,1,1,104.4,0ZM128,24A104,104,0,0,0,72,215.7a8,8,0,0,0,8.7-13.5,88,88,0,1,1,94.6,0,8,8,0,0,0,4.4,14.7,8.8,8.8,0,0,0,4.3-1.2A104,104,0,0,0,128,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.3,151.2a64,64,0,1,1,119.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.4,208.9a96,96,0,1,1,103.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.3,151.2a64,64,0,1,1,119.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.4,208.9a96,96,0,1,1,103.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.3,151.2a64,64,0,1,1,119.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.4,208.9a96,96,0,1,1,103.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fU = [];
/* style */

const __vue_inject_styles__$fU = undefined;
/* scoped */

const __vue_scope_id__$fU = undefined;
/* module identifier */

const __vue_module_identifier__$fU = undefined;
/* functional template */

const __vue_is_functional_template__$fU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fU,
  staticRenderFns: __vue_staticRenderFns__$fU
}, __vue_inject_styles__$fU, __vue_script__$fU, __vue_scope_id__$fU, __vue_is_functional_template__$fU, __vue_module_identifier__$fU, false, undefined, undefined, undefined);

var script$fT = Vue.extend({
  name: "PhArchive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fT = script$fT;
/* template */

var __vue_render__$fT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm-72,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm72-56H32V64H224V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "152",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fT = [];
/* style */

const __vue_inject_styles__$fT = undefined;
/* scoped */

const __vue_scope_id__$fT = undefined;
/* module identifier */

const __vue_module_identifier__$fT = undefined;
/* functional template */

const __vue_is_functional_template__$fT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fT,
  staticRenderFns: __vue_staticRenderFns__$fT
}, __vue_inject_styles__$fT, __vue_script__$fT, __vue_scope_id__$fT, __vue_is_functional_template__$fT, __vue_module_identifier__$fT, false, undefined, undefined, undefined);

var script$fS = Vue.extend({
  name: "PhArchiveBox",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fS = script$fS;
/* template */

var __vue_render__$fS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V76L56,40H200l16,36V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "76",
      "x2": "216",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 151.7 128 180 156.3 151.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 150.1 128 184 161.9 150.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.2,68.4l-16-32A8.2,8.2,0,0,0,200,32H56a8.2,8.2,0,0,0-7.2,4.4l-16,32A9,9,0,0,0,32,72V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V72A9,9,0,0,0,223.2,68.4Zm-55.6,87.3-33.9,34a8.2,8.2,0,0,1-11.4,0l-33.9-34a8,8,0,0,1,11.3-11.3L120,164.7V104a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3ZM52.9,64l8-16H195.1l8,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 150.1 128 184 161.9 150.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 150.1 128 184 161.9 150.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 150.1 128 184 161.9 150.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fS = [];
/* style */

const __vue_inject_styles__$fS = undefined;
/* scoped */

const __vue_scope_id__$fS = undefined;
/* module identifier */

const __vue_module_identifier__$fS = undefined;
/* functional template */

const __vue_is_functional_template__$fS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fS,
  staticRenderFns: __vue_staticRenderFns__$fS
}, __vue_inject_styles__$fS, __vue_script__$fS, __vue_scope_id__$fS, __vue_is_functional_template__$fS, __vue_module_identifier__$fS, false, undefined, undefined, undefined);

var script$fR = Vue.extend({
  name: "PhArchiveTray",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fR = script$fR;
/* template */

var __vue_render__$fR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 115.7 128 144 156.3 115.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "76",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,156H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M76.7,160a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 118.1 128 152 161.9 118.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V159.9h0V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88.4,112.4a8,8,0,0,1,11.3,0L120,132.7V72a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3l-33.9,34h-.2l-.4.4h-.2l-.5.3c0,.1-.1.1-.1.2l-.5.3h-.2l-.5.3H131l-.7.3h-4.6l-.7-.3h-.1l-.5-.3h-.2l-.5-.3c0-.1-.1-.1-.1-.2l-.5-.3h-.2l-.4-.4h-.2l-33.9-34A8,8,0,0,1,88.4,112.4ZM208,208H48V168H76.7L96,187.3a15.9,15.9,0,0,0,11.3,4.7h41.4a15.9,15.9,0,0,0,11.3-4.7L179.3,168H208v40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 118.1 128 152 161.9 118.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 118.1 128 152 161.9 118.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 118.1 128 152 161.9 118.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fR = [];
/* style */

const __vue_inject_styles__$fR = undefined;
/* scoped */

const __vue_scope_id__$fR = undefined;
/* module identifier */

const __vue_module_identifier__$fR = undefined;
/* functional template */

const __vue_is_functional_template__$fR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fR,
  staticRenderFns: __vue_staticRenderFns__$fR
}, __vue_inject_styles__$fR, __vue_script__$fR, __vue_scope_id__$fR, __vue_is_functional_template__$fR, __vue_module_identifier__$fR, false, undefined, undefined, undefined);

var script$fQ = Vue.extend({
  name: "PhArmchair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fQ = script$fQ;
/* template */

var __vue_render__$fQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92",
      "y1": "136",
      "x2": "164",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164,164V128a40,40,0,1,1,44,39.8V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V167.8A40,40,0,1,1,92,128v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,88.2V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V88.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,160v40a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V160h0a32,32,0,0,1,0-64V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96a32,32,0,0,1,0,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,159v41a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V159a32,32,0,1,1,40-31v40a8,8,0,0,0,16,0V136h64v32a8,8,0,0,0,16,0V128a32,32,0,1,1,40,31ZM95.3,120h65.4A48,48,0,0,1,208,80h3.7a3.9,3.9,0,0,0,4.3-3.9V72a40,40,0,0,0-40-40H80A40,40,0,0,0,40,72v4.2a3.9,3.9,0,0,0,4.3,3.9H48A48,48,0,0,1,95.3,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fQ = [];
/* style */

const __vue_inject_styles__$fQ = undefined;
/* scoped */

const __vue_scope_id__$fQ = undefined;
/* module identifier */

const __vue_module_identifier__$fQ = undefined;
/* functional template */

const __vue_is_functional_template__$fQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fQ,
  staticRenderFns: __vue_staticRenderFns__$fQ
}, __vue_inject_styles__$fQ, __vue_script__$fQ, __vue_scope_id__$fQ, __vue_is_functional_template__$fQ, __vue_module_identifier__$fQ, false, undefined, undefined, undefined);

var script$fP = Vue.extend({
  name: "PhArrowArcLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fP = script$fP;
/* template */

var __vue_render__$fP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.1 148.1 28.1 148.1 28.1 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.1 148.1 28.1 148.1 28.1 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,71.7,116.4l26.1,26.1a8,8,0,0,1,1.7,8.7,7.9,7.9,0,0,1-7.4,4.9h-64a8,8,0,0,1-8-8v-64a8,8,0,0,1,13.7-5.6L60.3,105a104,104,0,0,1,141.2,5.5A102.9,102.9,0,0,1,232,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.1 148.1 28.1 148.1 28.1 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.1 148.1 28.1 148.1 28.1 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "92.1 148.1 28.1 148.1 28.1 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fP = [];
/* style */

const __vue_inject_styles__$fP = undefined;
/* scoped */

const __vue_scope_id__$fP = undefined;
/* module identifier */

const __vue_module_identifier__$fP = undefined;
/* functional template */

const __vue_is_functional_template__$fP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fP,
  staticRenderFns: __vue_staticRenderFns__$fP
}, __vue_inject_styles__$fP, __vue_script__$fP, __vue_scope_id__$fP, __vue_is_functional_template__$fP, __vue_module_identifier__$fP, false, undefined, undefined, undefined);

var script$fO = Vue.extend({
  name: "PhArrowArcRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fO = script$fO;
/* template */

var __vue_render__$fO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.9 148.1 227.9 148.1 227.9 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.9-67.9l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.9 148.1 227.9 148.1 227.9 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.9-67.9l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.9,84.1v64a8,8,0,0,1-8,8h-64a7.9,7.9,0,0,1-7.4-4.9,8,8,0,0,1,1.7-8.7l26.1-26.1A88,88,0,0,0,40,184a8,8,0,0,1-16,0A104.1,104.1,0,0,1,128,80a103.3,103.3,0,0,1,67.7,25l26.5-26.5a8,8,0,0,1,13.7,5.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.9 148.1 227.9 148.1 227.9 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.9-67.9l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.9 148.1 227.9 148.1 227.9 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.9-67.9l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "163.9 148.1 227.9 148.1 227.9 84.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184a96,96,0,0,1,163.9-67.9l32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fO = [];
/* style */

const __vue_inject_styles__$fO = undefined;
/* scoped */

const __vue_scope_id__$fO = undefined;
/* module identifier */

const __vue_module_identifier__$fO = undefined;
/* functional template */

const __vue_is_functional_template__$fO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fO,
  staticRenderFns: __vue_staticRenderFns__$fO
}, __vue_inject_styles__$fO, __vue_script__$fO, __vue_scope_id__$fO, __vue_is_functional_template__$fO, __vue_module_identifier__$fO, false, undefined, undefined, undefined);

var script$fN = Vue.extend({
  name: "PhArrowBendDoubleUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fN = script$fN;
/* template */

var __vue_render__$fN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 88 104 136 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M85.7,146.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-48-48a8.1,8.1,0,0,1,0-11.4l48-48A8.1,8.1,0,0,1,85.7,61.7L43.3,104Zm50.3-50V56a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-48,48a8.1,8.1,0,0,0,0,11.4l48,48A8.3,8.3,0,0,0,128,160a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,136,152V112.4A88.1,88.1,0,0,1,216,200a8,8,0,0,0,16,0A104.1,104.1,0,0,0,136,96.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 80 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fN = [];
/* style */

const __vue_inject_styles__$fN = undefined;
/* scoped */

const __vue_scope_id__$fN = undefined;
/* module identifier */

const __vue_module_identifier__$fN = undefined;
/* functional template */

const __vue_is_functional_template__$fN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fN,
  staticRenderFns: __vue_staticRenderFns__$fN
}, __vue_inject_styles__$fN, __vue_script__$fN, __vue_scope_id__$fN, __vue_is_functional_template__$fN, __vue_module_identifier__$fN, false, undefined, undefined, undefined);

var script$fM = Vue.extend({
  name: "PhArrowBendDoubleUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fM = script$fM;
/* template */

var __vue_render__$fM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 152 168 104 120 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,109.7l-48,48a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L212.7,104,170.3,61.7a8.1,8.1,0,0,1,11.4-11.4l48,48A8.1,8.1,0,0,1,229.7,109.7Zm-48-11.4-48-48a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,120,56V96.3A104.1,104.1,0,0,0,24,200a8,8,0,0,0,16,0,88.1,88.1,0,0,1,80-87.6V152a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l48-48A8.1,8.1,0,0,0,181.7,98.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 176 104 128 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fM = [];
/* style */

const __vue_inject_styles__$fM = undefined;
/* scoped */

const __vue_scope_id__$fM = undefined;
/* module identifier */

const __vue_module_identifier__$fM = undefined;
/* functional template */

const __vue_is_functional_template__$fM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fM,
  staticRenderFns: __vue_staticRenderFns__$fM
}, __vue_inject_styles__$fM, __vue_script__$fM, __vue_scope_id__$fM, __vue_is_functional_template__$fM, __vue_module_identifier__$fM, false, undefined, undefined, undefined);

var script$fL = Vue.extend({
  name: "PhArrowBendDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fL = script$fL;
/* template */

var __vue_render__$fL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56A104.2,104.2,0,0,1,128,160H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,104v40h40a88.1,88.1,0,0,0,88-88,8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 104 32 152 80 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,56a96,96,0,0,1-96,96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fL = [];
/* style */

const __vue_inject_styles__$fL = undefined;
/* scoped */

const __vue_scope_id__$fL = undefined;
/* module identifier */

const __vue_module_identifier__$fL = undefined;
/* functional template */

const __vue_is_functional_template__$fL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fL,
  staticRenderFns: __vue_staticRenderFns__$fL
}, __vue_inject_styles__$fL, __vue_script__$fL, __vue_scope_id__$fL, __vue_is_functional_template__$fL, __vue_module_identifier__$fL, false, undefined, undefined, undefined);

var script$fK = Vue.extend({
  name: "PhArrowBendDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fK = script$fK;
/* template */

var __vue_render__$fK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,157.7l-48,48A8.3,8.3,0,0,1,176,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,200V160H128A104.2,104.2,0,0,1,24,56a8,8,0,0,1,16,0,88.1,88.1,0,0,0,88,88h40V104a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,157.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 224 152 176 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56a96,96,0,0,0,96,96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fK = [];
/* style */

const __vue_inject_styles__$fK = undefined;
/* scoped */

const __vue_scope_id__$fK = undefined;
/* module identifier */

const __vue_module_identifier__$fK = undefined;
/* functional template */

const __vue_is_functional_template__$fK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fK,
  staticRenderFns: __vue_staticRenderFns__$fK
}, __vue_inject_styles__$fK, __vue_script__$fK, __vue_scope_id__$fK, __vue_is_functional_template__$fK, __vue_module_identifier__$fK, false, undefined, undefined, undefined);

var script$fJ = Vue.extend({
  name: "PhArrowBendLeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fJ = script$fJ;
/* template */

var __vue_render__$fJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32a8,8,0,0,1-8,8,88.1,88.1,0,0,0-88,88v40h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,168H96V128A104.2,104.2,0,0,1,200,24,8,8,0,0,1,208,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 176 104 224 56 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,32a96,96,0,0,0-96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fJ = [];
/* style */

const __vue_inject_styles__$fJ = undefined;
/* scoped */

const __vue_scope_id__$fJ = undefined;
/* module identifier */

const __vue_module_identifier__$fJ = undefined;
/* functional template */

const __vue_is_functional_template__$fJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fJ,
  staticRenderFns: __vue_staticRenderFns__$fJ
}, __vue_inject_styles__$fJ, __vue_script__$fJ, __vue_scope_id__$fJ, __vue_is_functional_template__$fJ, __vue_module_identifier__$fJ, false, undefined, undefined, undefined);

var script$fI = Vue.extend({
  name: "PhArrowBendLeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fI = script$fI;
/* template */

var __vue_render__$fI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,224a8,8,0,0,1-8,8A104.2,104.2,0,0,1,96,128V88H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,152,88H112v40a88.1,88.1,0,0,0,88,88A8,8,0,0,1,208,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 80 104 32 56 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a96,96,0,0,1-96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fI = [];
/* style */

const __vue_inject_styles__$fI = undefined;
/* scoped */

const __vue_scope_id__$fI = undefined;
/* module identifier */

const __vue_module_identifier__$fI = undefined;
/* functional template */

const __vue_is_functional_template__$fI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fI,
  staticRenderFns: __vue_staticRenderFns__$fI
}, __vue_inject_styles__$fI, __vue_script__$fI, __vue_scope_id__$fI, __vue_is_functional_template__$fI, __vue_module_identifier__$fI, false, undefined, undefined, undefined);

var script$fH = Vue.extend({
  name: "PhArrowBendRightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fH = script$fH;
/* template */

var __vue_render__$fH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.7,181.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,104,168h40V128A88.1,88.1,0,0,0,56,40a8,8,0,0,1,0-16A104.2,104.2,0,0,1,160,128v40h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,205.7,181.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 176 152 224 200 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,32a96,96,0,0,1,96,96v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fH = [];
/* style */

const __vue_inject_styles__$fH = undefined;
/* scoped */

const __vue_scope_id__$fH = undefined;
/* module identifier */

const __vue_module_identifier__$fH = undefined;
/* functional template */

const __vue_is_functional_template__$fH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fH,
  staticRenderFns: __vue_staticRenderFns__$fH
}, __vue_inject_styles__$fH, __vue_script__$fH, __vue_scope_id__$fH, __vue_is_functional_template__$fH, __vue_module_identifier__$fH, false, undefined, undefined, undefined);

var script$fG = Vue.extend({
  name: "PhArrowBendRightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fG = script$fG;
/* template */

var __vue_render__$fG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.4,83.1A8,8,0,0,1,200,88H160v40A104.2,104.2,0,0,1,56,232a8,8,0,0,1,0-16,88.1,88.1,0,0,0,88-88V88H104a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,207.4,83.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 80 152 32 200 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224a96,96,0,0,0,96-96V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fG = [];
/* style */

const __vue_inject_styles__$fG = undefined;
/* scoped */

const __vue_scope_id__$fG = undefined;
/* module identifier */

const __vue_module_identifier__$fG = undefined;
/* functional template */

const __vue_is_functional_template__$fG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fG,
  staticRenderFns: __vue_staticRenderFns__$fG
}, __vue_inject_styles__$fG, __vue_script__$fG, __vue_scope_id__$fG, __vue_is_functional_template__$fG, __vue_module_identifier__$fG, false, undefined, undefined, undefined);

var script$fF = Vue.extend({
  name: "PhArrowBendUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fF = script$fF;
/* template */

var __vue_render__$fF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,200a8,8,0,0,1-16,0,88.1,88.1,0,0,0-88-88H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,56V96h40A104.2,104.2,0,0,1,232,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 152 32 104 80 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200a96,96,0,0,0-96-96H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fF = [];
/* style */

const __vue_inject_styles__$fF = undefined;
/* scoped */

const __vue_scope_id__$fF = undefined;
/* module identifier */

const __vue_module_identifier__$fF = undefined;
/* functional template */

const __vue_is_functional_template__$fF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fF,
  staticRenderFns: __vue_staticRenderFns__$fF
}, __vue_inject_styles__$fF, __vue_script__$fF, __vue_scope_id__$fF, __vue_is_functional_template__$fF, __vue_module_identifier__$fF, false, undefined, undefined, undefined);

var script$fE = Vue.extend({
  name: "PhArrowBendUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fE = script$fE;
/* template */

var __vue_render__$fE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,109.7l-48,48A8.3,8.3,0,0,1,176,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,152V112H128a88.1,88.1,0,0,0-88,88,8,8,0,0,1-16,0A104.2,104.2,0,0,1,128,96h40V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,109.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a96,96,0,0,1,96-96h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fE = [];
/* style */

const __vue_inject_styles__$fE = undefined;
/* scoped */

const __vue_scope_id__$fE = undefined;
/* module identifier */

const __vue_module_identifier__$fE = undefined;
/* functional template */

const __vue_is_functional_template__$fE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fE,
  staticRenderFns: __vue_staticRenderFns__$fE
}, __vue_inject_styles__$fE, __vue_script__$fE, __vue_scope_id__$fE, __vue_is_functional_template__$fE, __vue_module_identifier__$fE, false, undefined, undefined, undefined);

var script$fD = Vue.extend({
  name: "PhArrowCircleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fD = script$fD;
/* template */

var __vue_render__$fD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm39.6,115.7-33.9,34a8.2,8.2,0,0,1-11.4,0l-33.9-34a8,8,0,0,1,11.3-11.3L120,148.7V88a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fD = [];
/* style */

const __vue_inject_styles__$fD = undefined;
/* scoped */

const __vue_scope_id__$fD = undefined;
/* module identifier */

const __vue_module_identifier__$fD = undefined;
/* functional template */

const __vue_is_functional_template__$fD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fD,
  staticRenderFns: __vue_staticRenderFns__$fD
}, __vue_inject_styles__$fD, __vue_script__$fD, __vue_scope_id__$fD, __vue_is_functional_template__$fD, __vue_module_identifier__$fD, false, undefined, undefined, undefined);

var script$fC = Vue.extend({
  name: "PhArrowCircleDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fC = script$fC;
/* template */

var __vue_render__$fC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.7,81.7L119.3,148H148a8,8,0,0,1,0,16H100a8.5,8.5,0,0,1-3.1-.6,8.2,8.2,0,0,1-4.3-4.3A8.5,8.5,0,0,1,92,156V108a8,8,0,0,1,16,0v28.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 108 100 156 148 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fC = [];
/* style */

const __vue_inject_styles__$fC = undefined;
/* scoped */

const __vue_scope_id__$fC = undefined;
/* module identifier */

const __vue_module_identifier__$fC = undefined;
/* functional template */

const __vue_is_functional_template__$fC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fC,
  staticRenderFns: __vue_staticRenderFns__$fC
}, __vue_inject_styles__$fC, __vue_script__$fC, __vue_scope_id__$fC, __vue_is_functional_template__$fC, __vue_module_identifier__$fC, false, undefined, undefined, undefined);

var script$fB = Vue.extend({
  name: "PhArrowCircleDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fB = script$fB;
/* template */

var __vue_render__$fB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,132a8.5,8.5,0,0,1-.6,3.1,8.2,8.2,0,0,1-4.3,4.3,8.5,8.5,0,0,1-3.1.6H108a8,8,0,0,1,0-16h28.7L94.3,105.7a8.1,8.1,0,0,1,11.4-11.4L148,136.7V108a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fB = [];
/* style */

const __vue_inject_styles__$fB = undefined;
/* scoped */

const __vue_scope_id__$fB = undefined;
/* module identifier */

const __vue_module_identifier__$fB = undefined;
/* functional template */

const __vue_is_functional_template__$fB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fB,
  staticRenderFns: __vue_staticRenderFns__$fB
}, __vue_inject_styles__$fB, __vue_script__$fB, __vue_scope_id__$fB, __vue_is_functional_template__$fB, __vue_module_identifier__$fB, false, undefined, undefined, undefined);

var script$fA = Vue.extend({
  name: "PhArrowCircleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fA = script$fA;
/* template */

var __vue_render__$fA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 161.9 88 128 121.9 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 161.9 88 128 121.9 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H107.3l20.3,20.3a8,8,0,0,1,0,11.3,7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3L82.4,133.7a8.7,8.7,0,0,1-1.8-2.6,8.3,8.3,0,0,1,0-6.2,8.7,8.7,0,0,1,1.8-2.6l33.9-33.9a8,8,0,0,1,11.3,11.3L107.3,120H168a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 161.9 88 128 121.9 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 161.9 88 128 121.9 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 161.9 88 128 121.9 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fA = [];
/* style */

const __vue_inject_styles__$fA = undefined;
/* scoped */

const __vue_scope_id__$fA = undefined;
/* module identifier */

const __vue_module_identifier__$fA = undefined;
/* functional template */

const __vue_is_functional_template__$fA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fA,
  staticRenderFns: __vue_staticRenderFns__$fA
}, __vue_inject_styles__$fA, __vue_script__$fA, __vue_scope_id__$fA, __vue_is_functional_template__$fA, __vue_module_identifier__$fA, false, undefined, undefined, undefined);

var script$fz = Vue.extend({
  name: "PhArrowCircleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fz = script$fz;
/* template */

var __vue_render__$fz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 161.9 168 128 134.1 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 161.9 168 128 134.1 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm47.4,107.1a8.7,8.7,0,0,1-1.8,2.6l-33.9,33.9a7.6,7.6,0,0,1-5.6,2.3,7.8,7.8,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L148.7,136H88a8,8,0,0,1,0-16h60.7L128.4,99.7a8,8,0,0,1,11.3-11.3l33.9,33.9a8.7,8.7,0,0,1,1.8,2.6A8.3,8.3,0,0,1,175.4,131.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 161.9 168 128 134.1 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 161.9 168 128 134.1 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 161.9 168 128 134.1 94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fz = [];
/* style */

const __vue_inject_styles__$fz = undefined;
/* scoped */

const __vue_scope_id__$fz = undefined;
/* module identifier */

const __vue_module_identifier__$fz = undefined;
/* functional template */

const __vue_is_functional_template__$fz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fz,
  staticRenderFns: __vue_staticRenderFns__$fz
}, __vue_inject_styles__$fz, __vue_script__$fz, __vue_scope_id__$fz, __vue_is_functional_template__$fz, __vue_module_identifier__$fz, false, undefined, undefined, undefined);

var script$fy = Vue.extend({
  name: "PhArrowCircleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fy = script$fy;
/* template */

var __vue_render__$fy = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm39.6,103.6a7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3L136,107.3V168a8,8,0,0,1-16,0V107.3L99.7,127.6a8,8,0,0,1-11.3-11.3l33.9-33.9a8.7,8.7,0,0,1,2.6-1.8,8.3,8.3,0,0,1,6.2,0,8.7,8.7,0,0,1,2.6,1.8l33.9,33.9A8,8,0,0,1,167.6,127.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fy = [];
/* style */

const __vue_inject_styles__$fy = undefined;
/* scoped */

const __vue_scope_id__$fy = undefined;
/* module identifier */

const __vue_module_identifier__$fy = undefined;
/* functional template */

const __vue_is_functional_template__$fy = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fy = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fy,
  staticRenderFns: __vue_staticRenderFns__$fy
}, __vue_inject_styles__$fy, __vue_script__$fy, __vue_scope_id__$fy, __vue_is_functional_template__$fy, __vue_module_identifier__$fy, false, undefined, undefined, undefined);

var script$fx = Vue.extend({
  name: "PhArrowCircleUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fx = script$fx;
/* template */

var __vue_render__$fx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.7,137.7a8.2,8.2,0,0,1-11.4,0L108,119.3V148a8,8,0,0,1-16,0V100a8.5,8.5,0,0,1,.6-3.1,8.2,8.2,0,0,1,4.3-4.3A8.5,8.5,0,0,1,100,92h48a8,8,0,0,1,0,16H119.3l42.4,42.3A8.1,8.1,0,0,1,161.7,161.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fx = [];
/* style */

const __vue_inject_styles__$fx = undefined;
/* scoped */

const __vue_scope_id__$fx = undefined;
/* module identifier */

const __vue_module_identifier__$fx = undefined;
/* functional template */

const __vue_is_functional_template__$fx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fx,
  staticRenderFns: __vue_staticRenderFns__$fx
}, __vue_inject_styles__$fx, __vue_script__$fx, __vue_scope_id__$fx, __vue_is_functional_template__$fx, __vue_module_identifier__$fx, false, undefined, undefined, undefined);

var script$fw = Vue.extend({
  name: "PhArrowCircleUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fw = script$fw;
/* template */

var __vue_render__$fw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5ZM164,148a8,8,0,0,1-16,0V119.3l-42.3,42.4A8.5,8.5,0,0,1,100,164a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L136.7,108H108a8,8,0,0,1,0-16h48a7.7,7.7,0,0,1,3,.6,8.1,8.1,0,0,1,4.4,4.3,8.5,8.5,0,0,1,.6,3.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fw = [];
/* style */

const __vue_inject_styles__$fw = undefined;
/* scoped */

const __vue_scope_id__$fw = undefined;
/* module identifier */

const __vue_module_identifier__$fw = undefined;
/* functional template */

const __vue_is_functional_template__$fw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fw,
  staticRenderFns: __vue_staticRenderFns__$fw
}, __vue_inject_styles__$fw, __vue_script__$fw, __vue_scope_id__$fw, __vue_is_functional_template__$fw, __vue_module_identifier__$fw, false, undefined, undefined, undefined);

var script$fv = Vue.extend({
  name: "PhArrowClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fv = script$fv;
/* template */

var __vue_render__$fv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.2,51.7v48a8,8,0,0,1-8,8h-48a8,8,0,0,1-5.7-13.6l18.4-18.4-4.3-4.3a80,80,0,1,0,0,113.2,7.9,7.9,0,0,1,11.3,0,8,8,0,0,1,0,11.3,96,96,0,1,1,0-135.8l4.3,4.3,18.3-18.3a8,8,0,0,1,8.7-1.8A8.2,8.2,0,0,1,232.2,51.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fv = [];
/* style */

const __vue_inject_styles__$fv = undefined;
/* scoped */

const __vue_scope_id__$fv = undefined;
/* module identifier */

const __vue_module_identifier__$fv = undefined;
/* functional template */

const __vue_is_functional_template__$fv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fv,
  staticRenderFns: __vue_staticRenderFns__$fv
}, __vue_inject_styles__$fv, __vue_script__$fv, __vue_scope_id__$fv, __vue_is_functional_template__$fv, __vue_module_identifier__$fv, false, undefined, undefined, undefined);

var script$fu = Vue.extend({
  name: "PhArrowCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fu = script$fu;
/* template */

var __vue_render__$fu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,195.9a96.1,96.1,0,0,1-135.8,0,8,8,0,0,1,0-11.3,7.9,7.9,0,0,1,11.3,0,80,80,0,1,0,0-113.2l-4.3,4.3L85.5,94.1a8,8,0,0,1-5.7,13.6h-48a8,8,0,0,1-8-8v-48a8.2,8.2,0,0,1,5-7.4,8,8,0,0,1,8.7,1.8L55.8,64.4l4.3-4.3A96,96,0,0,1,195.9,195.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fu = [];
/* style */

const __vue_inject_styles__$fu = undefined;
/* scoped */

const __vue_scope_id__$fu = undefined;
/* module identifier */

const __vue_module_identifier__$fu = undefined;
/* functional template */

const __vue_is_functional_template__$fu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fu,
  staticRenderFns: __vue_staticRenderFns__$fu
}, __vue_inject_styles__$fu, __vue_script__$fu, __vue_scope_id__$fu, __vue_is_functional_template__$fu, __vue_module_identifier__$fu, false, undefined, undefined, undefined);

var script$ft = Vue.extend({
  name: "PhArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ft = script$ft;
/* template */

var __vue_render__$ft = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.7,149.7l-72,72a8.2,8.2,0,0,1-11.4,0l-72-72a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,205.7,149.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 216 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ft = [];
/* style */

const __vue_inject_styles__$ft = undefined;
/* scoped */

const __vue_scope_id__$ft = undefined;
/* module identifier */

const __vue_module_identifier__$ft = undefined;
/* functional template */

const __vue_is_functional_template__$ft = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ft = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ft,
  staticRenderFns: __vue_staticRenderFns__$ft
}, __vue_inject_styles__$ft, __vue_script__$ft, __vue_scope_id__$ft, __vue_is_functional_template__$ft, __vue_module_identifier__$ft, false, undefined, undefined, undefined);

var script$fs = Vue.extend({
  name: "PhArrowDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fs = script$fs;
/* template */

var __vue_render__$fs = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.7,69.7,127.3,140l46.4,46.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,168,200H64a8,8,0,0,1-8-8V88a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L116,128.7l70.3-70.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "64",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 192 64 192 64 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fs = [];
/* style */

const __vue_inject_styles__$fs = undefined;
/* scoped */

const __vue_scope_id__$fs = undefined;
/* module identifier */

const __vue_module_identifier__$fs = undefined;
/* functional template */

const __vue_is_functional_template__$fs = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fs = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fs,
  staticRenderFns: __vue_staticRenderFns__$fs
}, __vue_inject_styles__$fs, __vue_script__$fs, __vue_scope_id__$fs, __vue_is_functional_template__$fs, __vue_module_identifier__$fs, false, undefined, undefined, undefined);

var script$fr = Vue.extend({
  name: "PhArrowDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fr = script$fr;
/* template */

var __vue_render__$fr = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,88V192a8,8,0,0,1-8,8H88a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L128.7,140,58.3,69.7A8.1,8.1,0,0,1,69.7,58.3L140,128.7l46.3-46.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,200,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 192 192 192 192 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fr = [];
/* style */

const __vue_inject_styles__$fr = undefined;
/* scoped */

const __vue_scope_id__$fr = undefined;
/* module identifier */

const __vue_module_identifier__$fr = undefined;
/* functional template */

const __vue_is_functional_template__$fr = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fr = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fr,
  staticRenderFns: __vue_staticRenderFns__$fr
}, __vue_inject_styles__$fr, __vue_script__$fr, __vue_scope_id__$fr, __vue_is_functional_template__$fr, __vue_module_identifier__$fr, false, undefined, undefined, undefined);

var script$fq = Vue.extend({
  name: "PhArrowElbowDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fq = script$fq;
/* template */

var __vue_render__$fq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32V176a8,8,0,0,1-8,8H104v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 176 96 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 32 192 176 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fq = [];
/* style */

const __vue_inject_styles__$fq = undefined;
/* scoped */

const __vue_scope_id__$fq = undefined;
/* module identifier */

const __vue_module_identifier__$fq = undefined;
/* functional template */

const __vue_is_functional_template__$fq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fq,
  staticRenderFns: __vue_staticRenderFns__$fq
}, __vue_inject_styles__$fq, __vue_script__$fq, __vue_scope_id__$fq, __vue_is_functional_template__$fq, __vue_module_identifier__$fq, false, undefined, undefined, undefined);

var script$fp = Vue.extend({
  name: "PhArrowElbowDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fp = script$fp;
/* template */

var __vue_render__$fp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,181.7l-48,48A8.3,8.3,0,0,1,160,232a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,152,224V184H64a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,213.7,181.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 176 160 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 32 64 176 208 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fp = [];
/* style */

const __vue_inject_styles__$fp = undefined;
/* scoped */

const __vue_scope_id__$fp = undefined;
/* module identifier */

const __vue_module_identifier__$fp = undefined;
/* functional template */

const __vue_is_functional_template__$fp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fp,
  staticRenderFns: __vue_staticRenderFns__$fp
}, __vue_inject_styles__$fp, __vue_script__$fp, __vue_scope_id__$fp, __vue_is_functional_template__$fp, __vue_module_identifier__$fp, false, undefined, undefined, undefined);

var script$fo = Vue.extend({
  name: "PhArrowElbowLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fo = script$fo;
/* template */

var __vue_render__$fo = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,101.7l-96,96a8.2,8.2,0,0,1-11.4,0L60,127.3,29.7,157.7A8.3,8.3,0,0,1,24,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,16,152V80a8,8,0,0,1,8-8H96a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L71.3,116,136,180.7l90.3-90.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 80 24 80 24 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 96 136 192 24 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fo = [];
/* style */

const __vue_inject_styles__$fo = undefined;
/* scoped */

const __vue_scope_id__$fo = undefined;
/* module identifier */

const __vue_module_identifier__$fo = undefined;
/* functional template */

const __vue_is_functional_template__$fo = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fo = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fo,
  staticRenderFns: __vue_staticRenderFns__$fo
}, __vue_inject_styles__$fo, __vue_script__$fo, __vue_scope_id__$fo, __vue_is_functional_template__$fo, __vue_module_identifier__$fo, false, undefined, undefined, undefined);

var script$fn = Vue.extend({
  name: "PhArrowElbowLeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fn = script$fn;
/* template */

var __vue_render__$fn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64a8,8,0,0,1-8,8H88v80h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,152H72V64a8,8,0,0,1,8-8H224A8,8,0,0,1,232,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 80 208 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 64 80 64 80 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fn = [];
/* style */

const __vue_inject_styles__$fn = undefined;
/* scoped */

const __vue_scope_id__$fn = undefined;
/* module identifier */

const __vue_module_identifier__$fn = undefined;
/* functional template */

const __vue_is_functional_template__$fn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fn,
  staticRenderFns: __vue_staticRenderFns__$fn
}, __vue_inject_styles__$fn, __vue_script__$fn, __vue_scope_id__$fn, __vue_is_functional_template__$fn, __vue_module_identifier__$fn, false, undefined, undefined, undefined);

var script$fm = Vue.extend({
  name: "PhArrowElbowLeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fm = script$fm;
/* template */

var __vue_render__$fm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,192a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V104H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,128,104H88v80H224A8,8,0,0,1,232,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 80 48 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 192 80 192 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fm = [];
/* style */

const __vue_inject_styles__$fm = undefined;
/* scoped */

const __vue_scope_id__$fm = undefined;
/* module identifier */

const __vue_module_identifier__$fm = undefined;
/* functional template */

const __vue_is_functional_template__$fm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fm,
  staticRenderFns: __vue_staticRenderFns__$fm
}, __vue_inject_styles__$fm, __vue_script__$fm, __vue_scope_id__$fm, __vue_is_functional_template__$fm, __vue_module_identifier__$fm, false, undefined, undefined, undefined);

var script$fl = Vue.extend({
  name: "PhArrowElbowRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fl = script$fl;
/* template */

var __vue_render__$fl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,80v72a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L196,127.3l-70.3,70.4a8.2,8.2,0,0,1-11.4,0l-96-96A8.1,8.1,0,0,1,29.7,90.3L120,180.7,184.7,116,154.3,85.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,160,72h72A8,8,0,0,1,240,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 232 80 232 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 96 120 192 232 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fl = [];
/* style */

const __vue_inject_styles__$fl = undefined;
/* scoped */

const __vue_scope_id__$fl = undefined;
/* module identifier */

const __vue_module_identifier__$fl = undefined;
/* functional template */

const __vue_is_functional_template__$fl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fl,
  staticRenderFns: __vue_staticRenderFns__$fl
}, __vue_inject_styles__$fl, __vue_script__$fl, __vue_scope_id__$fl, __vue_is_functional_template__$fl, __vue_module_identifier__$fl, false, undefined, undefined, undefined);

var script$fk = Vue.extend({
  name: "PhArrowElbowRightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fk = script$fk;
/* template */

var __vue_render__$fk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,165.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,128,152h40V72H32a8,8,0,0,1,0-16H176a8,8,0,0,1,8,8v88h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,165.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 160 176 208 224 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 64 176 64 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fk = [];
/* style */

const __vue_inject_styles__$fk = undefined;
/* scoped */

const __vue_scope_id__$fk = undefined;
/* module identifier */

const __vue_module_identifier__$fk = undefined;
/* functional template */

const __vue_is_functional_template__$fk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fk,
  staticRenderFns: __vue_staticRenderFns__$fk
}, __vue_inject_styles__$fk, __vue_script__$fk, __vue_scope_id__$fk, __vue_is_functional_template__$fk, __vue_module_identifier__$fk, false, undefined, undefined, undefined);

var script$fj = Vue.extend({
  name: "PhArrowElbowRightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fj = script$fj;
/* template */

var __vue_render__$fj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.4,99.1A8,8,0,0,1,224,104H184v88a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16H168V104H128a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,231.4,99.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 96 176 48 224 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 192 176 192 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fj = [];
/* style */

const __vue_inject_styles__$fj = undefined;
/* scoped */

const __vue_scope_id__$fj = undefined;
/* module identifier */

const __vue_module_identifier__$fj = undefined;
/* functional template */

const __vue_is_functional_template__$fj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fj,
  staticRenderFns: __vue_staticRenderFns__$fj
}, __vue_inject_styles__$fj, __vue_script__$fj, __vue_scope_id__$fj, __vue_is_functional_template__$fj, __vue_module_identifier__$fj, false, undefined, undefined, undefined);

var script$fi = Vue.extend({
  name: "PhArrowElbowUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fi = script$fi;
/* template */

var __vue_render__$fi = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,80V224a8,8,0,0,1-16,0V88H104v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,104,32V72h88A8,8,0,0,1,200,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 128 48 80 96 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 224 192 80 48 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fi = [];
/* style */

const __vue_inject_styles__$fi = undefined;
/* scoped */

const __vue_scope_id__$fi = undefined;
/* module identifier */

const __vue_module_identifier__$fi = undefined;
/* functional template */

const __vue_is_functional_template__$fi = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fi = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fi,
  staticRenderFns: __vue_staticRenderFns__$fi
}, __vue_inject_styles__$fi, __vue_script__$fi, __vue_scope_id__$fi, __vue_is_functional_template__$fi, __vue_module_identifier__$fi, false, undefined, undefined, undefined);

var script$fh = Vue.extend({
  name: "PhArrowElbowUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fh = script$fh;
/* template */

var __vue_render__$fh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,85.7l-48,48A8.3,8.3,0,0,1,160,136a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,152,128V88H72V224a8,8,0,0,1-16,0V80a8,8,0,0,1,8-8h88V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,213.7,85.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 128 208 80 160 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 64 80 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fh = [];
/* style */

const __vue_inject_styles__$fh = undefined;
/* scoped */

const __vue_scope_id__$fh = undefined;
/* module identifier */

const __vue_module_identifier__$fh = undefined;
/* functional template */

const __vue_is_functional_template__$fh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fh,
  staticRenderFns: __vue_staticRenderFns__$fh
}, __vue_inject_styles__$fh, __vue_script__$fh, __vue_scope_id__$fh, __vue_is_functional_template__$fh, __vue_module_identifier__$fh, false, undefined, undefined, undefined);

var script$fg = Vue.extend({
  name: "PhArrowFatDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fg = script$fg;
/* template */

var __vue_render__$fg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V48A16,16,0,0,1,88,32h80a16,16,0,0,1,16,16v80h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fg = [];
/* style */

const __vue_inject_styles__$fg = undefined;
/* scoped */

const __vue_scope_id__$fg = undefined;
/* module identifier */

const __vue_module_identifier__$fg = undefined;
/* functional template */

const __vue_is_functional_template__$fg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fg,
  staticRenderFns: __vue_staticRenderFns__$fg
}, __vue_inject_styles__$fg, __vue_script__$fg, __vue_scope_id__$fg, __vue_is_functional_template__$fg, __vue_module_identifier__$fg, false, undefined, undefined, undefined);

var script$ff = Vue.extend({
  name: "PhArrowFatLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ff = script$ff;
/* template */

var __vue_render__$ff = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h80a16,16,0,0,1,16,16v80a16,16,0,0,1-16,16H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ff = [];
/* style */

const __vue_inject_styles__$ff = undefined;
/* scoped */

const __vue_scope_id__$ff = undefined;
/* module identifier */

const __vue_module_identifier__$ff = undefined;
/* functional template */

const __vue_is_functional_template__$ff = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ff = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ff,
  staticRenderFns: __vue_staticRenderFns__$ff
}, __vue_inject_styles__$ff, __vue_script__$ff, __vue_scope_id__$ff, __vue_is_functional_template__$ff, __vue_module_identifier__$ff, false, undefined, undefined, undefined);

var script$fe = Vue.extend({
  name: "PhArrowFatLineDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fe = script$fe;
/* template */

var __vue_render__$fe = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 80 80 80 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v56h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7ZM184,40a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fe = [];
/* style */

const __vue_inject_styles__$fe = undefined;
/* scoped */

const __vue_scope_id__$fe = undefined;
/* module identifier */

const __vue_module_identifier__$fe = undefined;
/* functional template */

const __vue_is_functional_template__$fe = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fe = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fe,
  staticRenderFns: __vue_staticRenderFns__$fe
}, __vue_inject_styles__$fe, __vue_script__$fe, __vue_scope_id__$fe, __vue_is_functional_template__$fe, __vue_module_identifier__$fe, false, undefined, undefined, undefined);

var script$fd = Vue.extend({
  name: "PhArrowFatLineLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fd = script$fd;
/* template */

var __vue_render__$fd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 176 176 176 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h56a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7ZM216,184a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,216,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fd = [];
/* style */

const __vue_inject_styles__$fd = undefined;
/* scoped */

const __vue_scope_id__$fd = undefined;
/* module identifier */

const __vue_module_identifier__$fd = undefined;
/* functional template */

const __vue_is_functional_template__$fd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fd,
  staticRenderFns: __vue_staticRenderFns__$fd
}, __vue_inject_styles__$fd, __vue_script__$fd, __vue_scope_id__$fd, __vue_is_functional_template__$fd, __vue_module_identifier__$fd, false, undefined, undefined, undefined);

var script$fc = Vue.extend({
  name: "PhArrowFatLineRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fc = script$fc;
/* template */

var __vue_render__$fc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 80 176 80 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.9,231.4A8,8,0,0,1,128,224V184H72a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h56V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fc = [];
/* style */

const __vue_inject_styles__$fc = undefined;
/* scoped */

const __vue_scope_id__$fc = undefined;
/* module identifier */

const __vue_module_identifier__$fc = undefined;
/* functional template */

const __vue_is_functional_template__$fc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fc,
  staticRenderFns: __vue_staticRenderFns__$fc
}, __vue_inject_styles__$fc, __vue_script__$fc, __vue_scope_id__$fc, __vue_is_functional_template__$fc, __vue_module_identifier__$fc, false, undefined, undefined, undefined);

var script$fb = Vue.extend({
  name: "PhArrowFatLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fb = script$fb;
/* template */

var __vue_render__$fb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 176 80 176 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.4,123.1A8,8,0,0,1,224,128H184v56a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fb = [];
/* style */

const __vue_inject_styles__$fb = undefined;
/* scoped */

const __vue_scope_id__$fb = undefined;
/* module identifier */

const __vue_module_identifier__$fb = undefined;
/* functional template */

const __vue_is_functional_template__$fb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fb,
  staticRenderFns: __vue_staticRenderFns__$fb
}, __vue_inject_styles__$fb, __vue_script__$fb, __vue_scope_id__$fb, __vue_is_functional_template__$fb, __vue_module_identifier__$fb, false, undefined, undefined, undefined);

var script$fa = Vue.extend({
  name: "PhArrowFatLinesDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$fa = script$fa;
/* template */

var __vue_render__$fa = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 116 80 116 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "44",
      "x2": "80",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V104a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v24h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7ZM184,40a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,40Zm0,32a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "72",
      "x2": "80",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$fa = [];
/* style */

const __vue_inject_styles__$fa = undefined;
/* scoped */

const __vue_scope_id__$fa = undefined;
/* module identifier */

const __vue_module_identifier__$fa = undefined;
/* functional template */

const __vue_is_functional_template__$fa = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$fa = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$fa,
  staticRenderFns: __vue_staticRenderFns__$fa
}, __vue_inject_styles__$fa, __vue_script__$fa, __vue_scope_id__$fa, __vue_is_functional_template__$fa, __vue_module_identifier__$fa, false, undefined, undefined, undefined);

var script$f9 = Vue.extend({
  name: "PhArrowFatLinesLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f9 = script$f9;
/* template */

var __vue_render__$f9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 140 176 140 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "176",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h24a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7ZM216,184a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,216,184Zm-32,0a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,184,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "176",
      "x2": "216",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "176",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f9 = [];
/* style */

const __vue_inject_styles__$f9 = undefined;
/* scoped */

const __vue_scope_id__$f9 = undefined;
/* module identifier */

const __vue_module_identifier__$f9 = undefined;
/* functional template */

const __vue_is_functional_template__$f9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f9,
  staticRenderFns: __vue_staticRenderFns__$f9
}, __vue_inject_styles__$f9, __vue_script__$f9, __vue_scope_id__$f9, __vue_is_functional_template__$f9, __vue_module_identifier__$f9, false, undefined, undefined, undefined);

var script$f8 = Vue.extend({
  name: "PhArrowFatLinesRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f8 = script$f8;
/* template */

var __vue_render__$f8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 116 176 116 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "176",
      "x2": "44",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.9,231.4A8,8,0,0,1,128,224V184H104a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h24V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Zm32,0V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "40",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "176",
      "x2": "72",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f8 = [];
/* style */

const __vue_inject_styles__$f8 = undefined;
/* scoped */

const __vue_scope_id__$f8 = undefined;
/* module identifier */

const __vue_module_identifier__$f8 = undefined;
/* functional template */

const __vue_is_functional_template__$f8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f8,
  staticRenderFns: __vue_staticRenderFns__$f8
}, __vue_inject_styles__$f8, __vue_script__$f8, __vue_scope_id__$f8, __vue_is_functional_template__$f8, __vue_module_identifier__$f8, false, undefined, undefined, undefined);

var script$f7 = Vue.extend({
  name: "PhArrowFatLinesUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f7 = script$f7;
/* template */

var __vue_render__$f7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 140 80 140 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "212",
      "x2": "80",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.4,123.1A8,8,0,0,1,224,128H184v24a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0-32H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "216",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "184",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f7 = [];
/* style */

const __vue_inject_styles__$f7 = undefined;
/* scoped */

const __vue_scope_id__$f7 = undefined;
/* module identifier */

const __vue_module_identifier__$f7 = undefined;
/* functional template */

const __vue_is_functional_template__$f7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f7,
  staticRenderFns: __vue_staticRenderFns__$f7
}, __vue_inject_styles__$f7, __vue_script__$f7, __vue_scope_id__$f7, __vue_is_functional_template__$f7, __vue_module_identifier__$f7, false, undefined, undefined, undefined);

var script$f6 = Vue.extend({
  name: "PhArrowFatRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f6 = script$f6;
/* template */

var __vue_render__$f6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.9,231.4A8,8,0,0,1,128,224V184H48a16,16,0,0,1-16-16V88A16,16,0,0,1,48,72h80V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f6 = [];
/* style */

const __vue_inject_styles__$f6 = undefined;
/* scoped */

const __vue_scope_id__$f6 = undefined;
/* module identifier */

const __vue_module_identifier__$f6 = undefined;
/* functional template */

const __vue_is_functional_template__$f6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f6,
  staticRenderFns: __vue_staticRenderFns__$f6
}, __vue_inject_styles__$f6, __vue_script__$f6, __vue_scope_id__$f6, __vue_is_functional_template__$f6, __vue_module_identifier__$f6, false, undefined, undefined, undefined);

var script$f5 = Vue.extend({
  name: "PhArrowFatUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f5 = script$f5;
/* template */

var __vue_render__$f5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.4,123.1A8,8,0,0,1,224,128H184v80a16,16,0,0,1-16,16H88a16,16,0,0,1-16-16V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f5 = [];
/* style */

const __vue_inject_styles__$f5 = undefined;
/* scoped */

const __vue_scope_id__$f5 = undefined;
/* module identifier */

const __vue_module_identifier__$f5 = undefined;
/* functional template */

const __vue_is_functional_template__$f5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f5,
  staticRenderFns: __vue_staticRenderFns__$f5
}, __vue_inject_styles__$f5, __vue_script__$f5, __vue_scope_id__$f5, __vue_is_functional_template__$f5, __vue_module_identifier__$f5, false, undefined, undefined, undefined);

var script$f4 = Vue.extend({
  name: "PhArrowLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f4 = script$f4;
/* template */

var __vue_render__$f4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H120v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-72-72a8.1,8.1,0,0,1,0-11.4l72-72a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,120,56v64h96A8,8,0,0,1,224,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 40 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f4 = [];
/* style */

const __vue_inject_styles__$f4 = undefined;
/* scoped */

const __vue_scope_id__$f4 = undefined;
/* module identifier */

const __vue_module_identifier__$f4 = undefined;
/* functional template */

const __vue_is_functional_template__$f4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f4,
  staticRenderFns: __vue_staticRenderFns__$f4
}, __vue_inject_styles__$f4, __vue_script__$f4, __vue_scope_id__$f4, __vue_is_functional_template__$f4, __vue_module_identifier__$f4, false, undefined, undefined, undefined);

var script$f3 = Vue.extend({
  name: "PhArrowLineDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f3 = script$f3;
/* template */

var __vue_render__$f3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 104 128 176 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 184 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.3,117.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,104h64V32a8,8,0,0,1,16,0v72h64a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-72,72a8.2,8.2,0,0,1-11.4,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 184 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 184 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 184 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f3 = [];
/* style */

const __vue_inject_styles__$f3 = undefined;
/* scoped */

const __vue_scope_id__$f3 = undefined;
/* module identifier */

const __vue_module_identifier__$f3 = undefined;
/* functional template */

const __vue_is_functional_template__$f3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f3,
  staticRenderFns: __vue_staticRenderFns__$f3
}, __vue_inject_styles__$f3, __vue_script__$f3, __vue_scope_id__$f3, __vue_is_functional_template__$f3, __vue_module_identifier__$f3, false, undefined, undefined, undefined);

var script$f2 = Vue.extend({
  name: "PhArrowLineDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f2 = script$f2;
/* template */

var __vue_render__$f2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M181.7,82.3a8.1,8.1,0,0,1,0,11.4L125.3,150l44.4,44.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,164,208H64a8,8,0,0,1-8-8V100a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L114,138.7l56.3-56.4A8.1,8.1,0,0,1,181.7,82.3ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 100 64 200 164 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f2 = [];
/* style */

const __vue_inject_styles__$f2 = undefined;
/* scoped */

const __vue_scope_id__$f2 = undefined;
/* module identifier */

const __vue_module_identifier__$f2 = undefined;
/* functional template */

const __vue_is_functional_template__$f2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f2,
  staticRenderFns: __vue_staticRenderFns__$f2
}, __vue_inject_styles__$f2, __vue_script__$f2, __vue_scope_id__$f2, __vue_is_functional_template__$f2, __vue_module_identifier__$f2, false, undefined, undefined, undefined);

var script$f1 = Vue.extend({
  name: "PhArrowLineDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f1 = script$f1;
/* template */

var __vue_render__$f1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,100V200a8,8,0,0,1-8,8H92a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L130.7,150,74.3,93.7A8.1,8.1,0,0,1,85.7,82.3L142,138.7l44.3-44.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,200,100Zm16-68H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 100 192 200 92 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f1 = [];
/* style */

const __vue_inject_styles__$f1 = undefined;
/* scoped */

const __vue_scope_id__$f1 = undefined;
/* module identifier */

const __vue_module_identifier__$f1 = undefined;
/* functional template */

const __vue_is_functional_template__$f1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f1,
  staticRenderFns: __vue_staticRenderFns__$f1
}, __vue_inject_styles__$f1, __vue_script__$f1, __vue_scope_id__$f1, __vue_is_functional_template__$f1, __vue_module_identifier__$f1, false, undefined, undefined, undefined);

var script$f0 = Vue.extend({
  name: "PhArrowLineLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f0 = script$f0;
/* template */

var __vue_render__$f0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 56 80 128 152 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 72 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128a8,8,0,0,1-8,8H152v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-72-72a8.1,8.1,0,0,1,0-11.4l72-72a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,152,56v64h72A8,8,0,0,1,232,128ZM40,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,40,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 72 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 72 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 72 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f0 = [];
/* style */

const __vue_inject_styles__$f0 = undefined;
/* scoped */

const __vue_scope_id__$f0 = undefined;
/* module identifier */

const __vue_module_identifier__$f0 = undefined;
/* functional template */

const __vue_is_functional_template__$f0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f0,
  staticRenderFns: __vue_staticRenderFns__$f0
}, __vue_inject_styles__$f0, __vue_script__$f0, __vue_scope_id__$f0, __vue_is_functional_template__$f0, __vue_module_identifier__$f0, false, undefined, undefined, undefined);

var script$e$ = Vue.extend({
  name: "PhArrowLineRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e$ = script$e$;
/* template */

var __vue_render__$e$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 56 176 128 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 184 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M189.7,122.3a8.1,8.1,0,0,1,0,11.4l-72,72A8.3,8.3,0,0,1,112,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,104,200V136H32a8,8,0,0,1,0-16h72V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 184 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 184 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 56 184 128 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "40",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e$ = [];
/* style */

const __vue_inject_styles__$e$ = undefined;
/* scoped */

const __vue_scope_id__$e$ = undefined;
/* module identifier */

const __vue_module_identifier__$e$ = undefined;
/* functional template */

const __vue_is_functional_template__$e$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e$,
  staticRenderFns: __vue_staticRenderFns__$e$
}, __vue_inject_styles__$e$, __vue_script__$e$, __vue_scope_id__$e$, __vue_is_functional_template__$e$, __vue_module_identifier__$e$, false, undefined, undefined, undefined);

var script$e_ = Vue.extend({
  name: "PhArrowLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e_ = script$e_;
/* template */

var __vue_render__$e_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 128 80 200 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 72 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.7,138.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,200,152H136v72a8,8,0,0,1-16,0V152H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l72-72a8.1,8.1,0,0,1,11.4,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 72 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 72 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 144 128 72 200 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "40",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e_ = [];
/* style */

const __vue_inject_styles__$e_ = undefined;
/* scoped */

const __vue_scope_id__$e_ = undefined;
/* module identifier */

const __vue_module_identifier__$e_ = undefined;
/* functional template */

const __vue_is_functional_template__$e_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e_,
  staticRenderFns: __vue_staticRenderFns__$e_
}, __vue_inject_styles__$e_, __vue_script__$e_, __vue_scope_id__$e_, __vue_is_functional_template__$e_, __vue_module_identifier__$e_, false, undefined, undefined, undefined);

var script$eZ = Vue.extend({
  name: "PhArrowLineUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eZ = script$eZ;
/* template */

var __vue_render__$eZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,156V56a8,8,0,0,1,8-8H164a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L125.3,106l56.4,56.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L114,117.3,69.7,161.7A8.3,8.3,0,0,1,64,164a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,56,156Zm160,52H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "64",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 156 64 56 164 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eZ = [];
/* style */

const __vue_inject_styles__$eZ = undefined;
/* scoped */

const __vue_scope_id__$eZ = undefined;
/* module identifier */

const __vue_module_identifier__$eZ = undefined;
/* functional template */

const __vue_is_functional_template__$eZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eZ,
  staticRenderFns: __vue_staticRenderFns__$eZ
}, __vue_inject_styles__$eZ, __vue_script__$eZ, __vue_scope_id__$eZ, __vue_is_functional_template__$eZ, __vue_module_identifier__$eZ, false, undefined, undefined, undefined);

var script$eY = Vue.extend({
  name: "PhArrowLineUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eY = script$eY;
/* template */

var __vue_render__$eY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M74.3,173.7a8.1,8.1,0,0,1,0-11.4L130.7,106,86.3,61.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,92,48H192a8,8,0,0,1,8,8V156a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L142,117.3,85.7,173.7a8.2,8.2,0,0,1-11.4,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 156 192 56 92 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eY = [];
/* style */

const __vue_inject_styles__$eY = undefined;
/* scoped */

const __vue_scope_id__$eY = undefined;
/* module identifier */

const __vue_module_identifier__$eY = undefined;
/* functional template */

const __vue_is_functional_template__$eY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eY,
  staticRenderFns: __vue_staticRenderFns__$eY
}, __vue_inject_styles__$eY, __vue_script__$eY, __vue_scope_id__$eY, __vue_is_functional_template__$eY, __vue_module_identifier__$eY, false, undefined, undefined, undefined);

var script$eX = Vue.extend({
  name: "PhArrowRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eX = script$eX;
/* template */

var __vue_render__$eX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.7,133.7l-72,72A8.3,8.3,0,0,1,144,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l72,72A8.1,8.1,0,0,1,221.7,133.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 56 216 128 144 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eX = [];
/* style */

const __vue_inject_styles__$eX = undefined;
/* scoped */

const __vue_scope_id__$eX = undefined;
/* module identifier */

const __vue_module_identifier__$eX = undefined;
/* functional template */

const __vue_is_functional_template__$eX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eX,
  staticRenderFns: __vue_staticRenderFns__$eX
}, __vue_inject_styles__$eX, __vue_script__$eX, __vue_scope_id__$eX, __vue_is_functional_template__$eX, __vue_module_identifier__$eX, false, undefined, undefined, undefined);

var script$eW = Vue.extend({
  name: "PhArrowSquareDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eW = script$eW;
/* template */

var __vue_render__$eW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM167.6,139.7l-33.9,33.9a8,8,0,0,1-2.7,1.8,7.7,7.7,0,0,1-3,.6,8.5,8.5,0,0,1-3.1-.6,8.7,8.7,0,0,1-2.6-1.8L88.4,139.7a8,8,0,0,1,11.3-11.3L120,148.7V88a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 134.1 128 168 161.9 134.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eW = [];
/* style */

const __vue_inject_styles__$eW = undefined;
/* scoped */

const __vue_scope_id__$eW = undefined;
/* module identifier */

const __vue_module_identifier__$eW = undefined;
/* functional template */

const __vue_is_functional_template__$eW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eW,
  staticRenderFns: __vue_staticRenderFns__$eW
}, __vue_inject_styles__$eW, __vue_script__$eW, __vue_scope_id__$eW, __vue_is_functional_template__$eW, __vue_module_identifier__$eW, false, undefined, undefined, undefined);

var script$eV = Vue.extend({
  name: "PhArrowSquareDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eV = script$eV;
/* template */

var __vue_render__$eV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-46.3,73.7L119.3,148H148a8,8,0,0,1,0,16H100a8,8,0,0,1-8-8V108a8,8,0,0,1,16,0v28.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 156 100 156 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eV = [];
/* style */

const __vue_inject_styles__$eV = undefined;
/* scoped */

const __vue_scope_id__$eV = undefined;
/* module identifier */

const __vue_module_identifier__$eV = undefined;
/* functional template */

const __vue_is_functional_template__$eV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eV,
  staticRenderFns: __vue_staticRenderFns__$eV
}, __vue_inject_styles__$eV, __vue_script__$eV, __vue_scope_id__$eV, __vue_is_functional_template__$eV, __vue_module_identifier__$eV, false, undefined, undefined, undefined);

var script$eU = Vue.extend({
  name: "PhArrowSquareDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eU = script$eU;
/* template */

var __vue_render__$eU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM164,156a8,8,0,0,1-8,8H108a8,8,0,0,1,0-16h28.7L94.3,105.7a8.1,8.1,0,0,1,11.4-11.4L148,136.7V108a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 156 156 156 156 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eU = [];
/* style */

const __vue_inject_styles__$eU = undefined;
/* scoped */

const __vue_scope_id__$eU = undefined;
/* module identifier */

const __vue_module_identifier__$eU = undefined;
/* functional template */

const __vue_is_functional_template__$eU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eU,
  staticRenderFns: __vue_staticRenderFns__$eU
}, __vue_inject_styles__$eU, __vue_script__$eU, __vue_scope_id__$eU, __vue_is_functional_template__$eU, __vue_module_identifier__$eU, false, undefined, undefined, undefined);

var script$eT = Vue.extend({
  name: "PhArrowSquareIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eT = script$eT;
/* template */

var __vue_render__$eT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 112 144 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "112",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "40",
      "width": "152",
      "height": "152",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 204 112 144 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "112",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,144v60a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L82,185.3,45.6,221.7A8,8,0,0,1,40,224a8.3,8.3,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L70.7,174,46.3,149.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,52,136h60A8,8,0,0,1,120,144ZM208,32H72A16,16,0,0,0,56,48V96a8,8,0,0,0,16,0V48H208V184H160a8,8,0,0,0,0,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 112 144 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "112",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 112 144 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "112",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 204 112 144 52 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "112",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eT = [];
/* style */

const __vue_inject_styles__$eT = undefined;
/* scoped */

const __vue_scope_id__$eT = undefined;
/* module identifier */

const __vue_module_identifier__$eT = undefined;
/* functional template */

const __vue_is_functional_template__$eT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eT,
  staticRenderFns: __vue_staticRenderFns__$eT
}, __vue_inject_styles__$eT, __vue_script__$eT, __vue_scope_id__$eT, __vue_is_functional_template__$eT, __vue_module_identifier__$eT, false, undefined, undefined, undefined);

var script$eS = Vue.extend({
  name: "PhArrowSquareLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eS = script$eS;
/* template */

var __vue_render__$eS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 94.1 88 128 121.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 94.1 88 128 121.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,208V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208A16,16,0,0,0,224,208ZM116.3,167.6,82.4,133.7a8,8,0,0,1-1.8-2.7,7.7,7.7,0,0,1-.6-3,8.5,8.5,0,0,1,.6-3.1,8.7,8.7,0,0,1,1.8-2.6l33.9-33.9a8,8,0,0,1,11.3,11.3L107.3,120H168a8,8,0,0,1,0,16H107.3l20.3,20.3a8,8,0,0,1-11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 94.1 88 128 121.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 94.1 88 128 121.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "121.9 94.1 88 128 121.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eS = [];
/* style */

const __vue_inject_styles__$eS = undefined;
/* scoped */

const __vue_scope_id__$eS = undefined;
/* module identifier */

const __vue_module_identifier__$eS = undefined;
/* functional template */

const __vue_is_functional_template__$eS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eS,
  staticRenderFns: __vue_staticRenderFns__$eS
}, __vue_inject_styles__$eS, __vue_script__$eS, __vue_scope_id__$eS, __vue_is_functional_template__$eS, __vue_module_identifier__$eS, false, undefined, undefined, undefined);

var script$eR = Vue.extend({
  name: "PhArrowSquareOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eR = script$eR;
/* template */

var __vue_render__$eR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 216 40 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 100 216 40 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,100a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L186,81.3l-36.4,36.4A8,8,0,0,1,144,120a8.3,8.3,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L174.7,70,150.3,45.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,156,32h60a8,8,0,0,1,8,8Zm-40,36a8,8,0,0,0-8,8v64H48V80h64a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V144A8,8,0,0,0,184,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 216 40 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 216 40 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 100 216 40 156 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eR = [];
/* style */

const __vue_inject_styles__$eR = undefined;
/* scoped */

const __vue_scope_id__$eR = undefined;
/* module identifier */

const __vue_module_identifier__$eR = undefined;
/* functional template */

const __vue_is_functional_template__$eR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eR,
  staticRenderFns: __vue_staticRenderFns__$eR
}, __vue_inject_styles__$eR, __vue_script__$eR, __vue_scope_id__$eR, __vue_is_functional_template__$eR, __vue_module_identifier__$eR, false, undefined, undefined, undefined);

var script$eQ = Vue.extend({
  name: "PhArrowSquareRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eQ = script$eQ;
/* template */

var __vue_render__$eQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 94.1 168 128 134.1 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 94.1 168 128 134.1 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,224H208a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208A16,16,0,0,0,48,224Zm80.4-56.4a8,8,0,0,1,0-11.3L148.7,136H88a8,8,0,0,1,0-16h60.7L128.4,99.7a8,8,0,0,1,11.3-11.3l33.9,33.9a8.7,8.7,0,0,1,1.8,2.6,8.5,8.5,0,0,1,.6,3.1,7.7,7.7,0,0,1-.6,3,8,8,0,0,1-1.8,2.7l-33.9,33.9A8,8,0,0,1,128.4,167.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 94.1 168 128 134.1 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 94.1 168 128 134.1 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "134.1 94.1 168 128 134.1 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eQ = [];
/* style */

const __vue_inject_styles__$eQ = undefined;
/* scoped */

const __vue_scope_id__$eQ = undefined;
/* module identifier */

const __vue_module_identifier__$eQ = undefined;
/* functional template */

const __vue_is_functional_template__$eQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eQ,
  staticRenderFns: __vue_staticRenderFns__$eQ
}, __vue_inject_styles__$eQ, __vue_script__$eQ, __vue_scope_id__$eQ, __vue_is_functional_template__$eQ, __vue_module_identifier__$eQ, false, undefined, undefined, undefined);

var script$eP = Vue.extend({
  name: "PhArrowSquareUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eP = script$eP;
/* template */

var __vue_render__$eP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,208V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208A16,16,0,0,0,224,208Zm-56.4-80.4a8,8,0,0,1-11.3,0L136,107.3V168a8,8,0,0,1-16,0V107.3L99.7,127.6a8,8,0,0,1-11.3-11.3l33.9-33.9a8.7,8.7,0,0,1,2.6-1.8A8.5,8.5,0,0,1,128,80a7.7,7.7,0,0,1,3,.6,8,8,0,0,1,2.7,1.8l33.9,33.9A8,8,0,0,1,167.6,127.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "94.1 121.9 128 88 161.9 121.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eP = [];
/* style */

const __vue_inject_styles__$eP = undefined;
/* scoped */

const __vue_scope_id__$eP = undefined;
/* module identifier */

const __vue_module_identifier__$eP = undefined;
/* functional template */

const __vue_is_functional_template__$eP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eP,
  staticRenderFns: __vue_staticRenderFns__$eP
}, __vue_inject_styles__$eP, __vue_script__$eP, __vue_scope_id__$eP, __vue_is_functional_template__$eP, __vue_module_identifier__$eP, false, undefined, undefined, undefined);

var script$eO = Vue.extend({
  name: "PhArrowSquareUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eO = script$eO;
/* template */

var __vue_render__$eO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM161.7,161.7a8.2,8.2,0,0,1-11.4,0L108,119.3V148a8,8,0,0,1-16,0V100a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H119.3l42.4,42.3A8.1,8.1,0,0,1,161.7,161.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 100 100 100 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "156",
      "x2": "100",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eO = [];
/* style */

const __vue_inject_styles__$eO = undefined;
/* scoped */

const __vue_scope_id__$eO = undefined;
/* module identifier */

const __vue_module_identifier__$eO = undefined;
/* functional template */

const __vue_is_functional_template__$eO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eO,
  staticRenderFns: __vue_staticRenderFns__$eO
}, __vue_inject_styles__$eO, __vue_script__$eO, __vue_scope_id__$eO, __vue_is_functional_template__$eO, __vue_module_identifier__$eO, false, undefined, undefined, undefined);

var script$eN = Vue.extend({
  name: "PhArrowSquareUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eN = script$eN;
/* template */

var __vue_render__$eN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM164,148a8,8,0,0,1-16,0V119.3l-42.3,42.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L136.7,108H108a8,8,0,0,1,0-16h48a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "transform": "translate(0 256) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 156 100 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "156",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eN = [];
/* style */

const __vue_inject_styles__$eN = undefined;
/* scoped */

const __vue_scope_id__$eN = undefined;
/* module identifier */

const __vue_module_identifier__$eN = undefined;
/* functional template */

const __vue_is_functional_template__$eN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eN,
  staticRenderFns: __vue_staticRenderFns__$eN
}, __vue_inject_styles__$eN, __vue_script__$eN, __vue_scope_id__$eN, __vue_is_functional_template__$eN, __vue_module_identifier__$eN, false, undefined, undefined, undefined);

var script$eM = Vue.extend({
  name: "PhArrowUDownLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eM = script$eM;
/* template */

var __vue_render__$eM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,112a64.1,64.1,0,0,1-64,64H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,120v40h80a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.1,64.1,0,0,1,232,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 120 32 168 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eM = [];
/* style */

const __vue_inject_styles__$eM = undefined;
/* scoped */

const __vue_scope_id__$eM = undefined;
/* module identifier */

const __vue_module_identifier__$eM = undefined;
/* functional template */

const __vue_is_functional_template__$eM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eM,
  staticRenderFns: __vue_staticRenderFns__$eM
}, __vue_inject_styles__$eM, __vue_script__$eM, __vue_scope_id__$eM, __vue_is_functional_template__$eM, __vue_module_identifier__$eM, false, undefined, undefined, undefined);

var script$eL = Vue.extend({
  name: "PhArrowUDownRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eL = script$eL;
/* template */

var __vue_render__$eL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,173.7l-48,48A8.3,8.3,0,0,1,176,224a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,216V176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96h80V120a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,173.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 120 224 168 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eL = [];
/* style */

const __vue_inject_styles__$eL = undefined;
/* scoped */

const __vue_scope_id__$eL = undefined;
/* module identifier */

const __vue_module_identifier__$eL = undefined;
/* functional template */

const __vue_is_functional_template__$eL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eL,
  staticRenderFns: __vue_staticRenderFns__$eL
}, __vue_inject_styles__$eL, __vue_script__$eL, __vue_scope_id__$eL, __vue_is_functional_template__$eL, __vue_module_identifier__$eL, false, undefined, undefined, undefined);

var script$eK = Vue.extend({
  name: "PhArrowULeftDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eK = script$eK;
/* template */

var __vue_render__$eK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,88v88a8,8,0,0,1-16,0V88a48,48,0,0,0-96,0v80h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,40,168H80V88a64,64,0,0,1,128,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 176 88 224 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eK = [];
/* style */

const __vue_inject_styles__$eK = undefined;
/* scoped */

const __vue_scope_id__$eK = undefined;
/* module identifier */

const __vue_module_identifier__$eK = undefined;
/* functional template */

const __vue_is_functional_template__$eK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eK,
  staticRenderFns: __vue_staticRenderFns__$eK
}, __vue_inject_styles__$eK, __vue_script__$eK, __vue_scope_id__$eK, __vue_is_functional_template__$eK, __vue_module_identifier__$eK, false, undefined, undefined, undefined);

var script$eJ = Vue.extend({
  name: "PhArrowULeftUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eJ = script$eJ;
/* template */

var __vue_render__$eJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80v88a64,64,0,0,1-128,0V88H40a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,136,88H96v80a48,48,0,0,0,96,0V80a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "136 80 88 32 40 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eJ = [];
/* style */

const __vue_inject_styles__$eJ = undefined;
/* scoped */

const __vue_scope_id__$eJ = undefined;
/* module identifier */

const __vue_module_identifier__$eJ = undefined;
/* functional template */

const __vue_is_functional_template__$eJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eJ,
  staticRenderFns: __vue_staticRenderFns__$eJ
}, __vue_inject_styles__$eJ, __vue_script__$eJ, __vue_scope_id__$eJ, __vue_is_functional_template__$eJ, __vue_module_identifier__$eJ, false, undefined, undefined, undefined);

var script$eI = Vue.extend({
  name: "PhArrowURightDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eI = script$eI;
/* template */

var __vue_render__$eI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.7,181.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,120,168h40V88a48,48,0,0,0-96,0v88a8,8,0,0,1-16,0V88a64,64,0,0,1,128,0v80h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,221.7,181.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 176 168 224 216 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eI = [];
/* style */

const __vue_inject_styles__$eI = undefined;
/* scoped */

const __vue_scope_id__$eI = undefined;
/* module identifier */

const __vue_module_identifier__$eI = undefined;
/* functional template */

const __vue_is_functional_template__$eI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eI,
  staticRenderFns: __vue_staticRenderFns__$eI
}, __vue_inject_styles__$eI, __vue_script__$eI, __vue_scope_id__$eI, __vue_is_functional_template__$eI, __vue_module_identifier__$eI, false, undefined, undefined, undefined);

var script$eH = Vue.extend({
  name: "PhArrowURightUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eH = script$eH;
/* template */

var __vue_render__$eH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.4,83.1A8,8,0,0,1,216,88H176v80a64,64,0,0,1-128,0V80a8,8,0,0,1,16,0v88a48,48,0,0,0,96,0V88H120a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,223.4,83.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 80 168 32 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eH = [];
/* style */

const __vue_inject_styles__$eH = undefined;
/* scoped */

const __vue_scope_id__$eH = undefined;
/* module identifier */

const __vue_module_identifier__$eH = undefined;
/* functional template */

const __vue_is_functional_template__$eH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eH,
  staticRenderFns: __vue_staticRenderFns__$eH
}, __vue_inject_styles__$eH, __vue_script__$eH, __vue_scope_id__$eH, __vue_is_functional_template__$eH, __vue_module_identifier__$eH, false, undefined, undefined, undefined);

var script$eG = Vue.extend({
  name: "PhArrowUUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eG = script$eG;
/* template */

var __vue_render__$eG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,144a64.1,64.1,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,40V80h80A64.1,64.1,0,0,1,232,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 136 32 88 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eG = [];
/* style */

const __vue_inject_styles__$eG = undefined;
/* scoped */

const __vue_scope_id__$eG = undefined;
/* module identifier */

const __vue_module_identifier__$eG = undefined;
/* functional template */

const __vue_is_functional_template__$eG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eG,
  staticRenderFns: __vue_staticRenderFns__$eG
}, __vue_inject_styles__$eG, __vue_script__$eG, __vue_scope_id__$eG, __vue_is_functional_template__$eG, __vue_module_identifier__$eG, false, undefined, undefined, undefined);

var script$eF = Vue.extend({
  name: "PhArrowUUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eF = script$eF;
/* template */

var __vue_render__$eF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48a8.1,8.1,0,0,1,0,11.4l-48,48A8.3,8.3,0,0,1,176,144a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 136 224 88 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eF = [];
/* style */

const __vue_inject_styles__$eF = undefined;
/* scoped */

const __vue_scope_id__$eF = undefined;
/* module identifier */

const __vue_module_identifier__$eF = undefined;
/* functional template */

const __vue_is_functional_template__$eF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eF,
  staticRenderFns: __vue_staticRenderFns__$eF
}, __vue_inject_styles__$eF, __vue_script__$eF, __vue_scope_id__$eF, __vue_is_functional_template__$eF, __vue_module_identifier__$eF, false, undefined, undefined, undefined);

var script$eE = Vue.extend({
  name: "PhArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eE = script$eE;
/* template */

var __vue_render__$eE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.4,115.1A8,8,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l72-72a8.1,8.1,0,0,1,11.4,0l72,72A8.4,8.4,0,0,1,207.4,115.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "216",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 112 128 40 200 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eE = [];
/* style */

const __vue_inject_styles__$eE = undefined;
/* scoped */

const __vue_scope_id__$eE = undefined;
/* module identifier */

const __vue_module_identifier__$eE = undefined;
/* functional template */

const __vue_is_functional_template__$eE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eE,
  staticRenderFns: __vue_staticRenderFns__$eE
}, __vue_inject_styles__$eE, __vue_script__$eE, __vue_scope_id__$eE, __vue_is_functional_template__$eE, __vue_module_identifier__$eE, false, undefined, undefined, undefined);

var script$eD = Vue.extend({
  name: "PhArrowUpLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eD = script$eD;
/* template */

var __vue_render__$eD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.7,197.7a8.2,8.2,0,0,1-11.4,0L116,127.3,69.7,173.7A8.3,8.3,0,0,1,64,176a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,56,168V64a8,8,0,0,1,8-8H168a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L127.3,116l70.4,70.3A8.1,8.1,0,0,1,197.7,197.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "192",
      "x2": "64",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 64 64 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eD = [];
/* style */

const __vue_inject_styles__$eD = undefined;
/* scoped */

const __vue_scope_id__$eD = undefined;
/* module identifier */

const __vue_module_identifier__$eD = undefined;
/* functional template */

const __vue_is_functional_template__$eD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eD,
  staticRenderFns: __vue_staticRenderFns__$eD
}, __vue_inject_styles__$eD, __vue_script__$eD, __vue_scope_id__$eD, __vue_is_functional_template__$eD, __vue_module_identifier__$eD, false, undefined, undefined, undefined);

var script$eC = Vue.extend({
  name: "PhArrowUpRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eC = script$eC;
/* template */

var __vue_render__$eC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,64V168a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L140,127.3,69.7,197.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L128.7,116,82.3,69.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,88,56H192A8,8,0,0,1,200,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 64 192 64 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eC = [];
/* style */

const __vue_inject_styles__$eC = undefined;
/* scoped */

const __vue_scope_id__$eC = undefined;
/* module identifier */

const __vue_module_identifier__$eC = undefined;
/* functional template */

const __vue_is_functional_template__$eC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eC,
  staticRenderFns: __vue_staticRenderFns__$eC
}, __vue_inject_styles__$eC, __vue_script__$eC, __vue_scope_id__$eC, __vue_is_functional_template__$eC, __vue_module_identifier__$eC, false, undefined, undefined, undefined);

var script$eB = Vue.extend({
  name: "PhArrowsClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eB = script$eB;
/* template */

var __vue_render__$eB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.8 156.3 31.8 156.3 31.8 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.8 156.3 31.8 156.3 31.8 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.2,51.7v48a8,8,0,0,1-8,8h-48a8,8,0,0,1-5.7-13.6l18.4-18.4-4.3-4.3a80.2,80.2,0,0,0-113.2,0,7.9,7.9,0,0,1-11.3,0,8,8,0,0,1,0-11.3,96.2,96.2,0,0,1,135.8,0l4.3,4.3,18.3-18.3a8,8,0,0,1,8.7-1.8A8.2,8.2,0,0,1,232.2,51.7ZM184.6,184.6a80.2,80.2,0,0,1-113.2,0l-4.3-4.3,18.4-18.4a8,8,0,0,0-5.7-13.6h-48a8,8,0,0,0-8,8v48a8.2,8.2,0,0,0,5,7.4,8,8,0,0,0,3,.6,7.8,7.8,0,0,0,5.7-2.4l18.3-18.3,4.3,4.3a96.1,96.1,0,0,0,135.8,0,8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,184.6,184.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.8 156.3 31.8 156.3 31.8 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.8 156.3 31.8 156.3 31.8 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176.2 99.7 224.2 99.7 224.2 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79.8 156.3 31.8 156.3 31.8 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eB = [];
/* style */

const __vue_inject_styles__$eB = undefined;
/* scoped */

const __vue_scope_id__$eB = undefined;
/* module identifier */

const __vue_module_identifier__$eB = undefined;
/* functional template */

const __vue_is_functional_template__$eB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eB,
  staticRenderFns: __vue_staticRenderFns__$eB
}, __vue_inject_styles__$eB, __vue_script__$eB, __vue_scope_id__$eB, __vue_is_functional_template__$eB, __vue_module_identifier__$eB, false, undefined, undefined, undefined);

var script$eA = Vue.extend({
  name: "PhArrowsCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eA = script$eA;
/* template */

var __vue_render__$eA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.2 156.3 224.2 156.3 224.2 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.2 156.3 224.2 156.3 224.2 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M79.8,107.7h-48a8,8,0,0,1-8-8v-48a8.2,8.2,0,0,1,5-7.4,8,8,0,0,1,8.7,1.8L55.8,64.4l4.3-4.3a96.2,96.2,0,0,1,135.8,0,8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0,80.2,80.2,0,0,0-113.2,0l-4.3,4.3L85.5,94.1a8,8,0,0,1-5.7,13.6Zm144.4,40.6h-48a8,8,0,0,0-5.7,13.6l18.4,18.4-4.3,4.3a80.2,80.2,0,0,1-113.2,0,7.9,7.9,0,0,0-11.3,0,8,8,0,0,0,0,11.3,96.1,96.1,0,0,0,135.8,0l4.3-4.3,18.3,18.3a7.8,7.8,0,0,0,5.7,2.4,8,8,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4v-48A8,8,0,0,0,224.2,148.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.2 156.3 224.2 156.3 224.2 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.2 156.3 224.2 156.3 224.2 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "79.8 99.7 31.8 99.7 31.8 51.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.2 156.3 224.2 156.3 224.2 204.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eA = [];
/* style */

const __vue_inject_styles__$eA = undefined;
/* scoped */

const __vue_scope_id__$eA = undefined;
/* module identifier */

const __vue_module_identifier__$eA = undefined;
/* functional template */

const __vue_is_functional_template__$eA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eA,
  staticRenderFns: __vue_staticRenderFns__$eA
}, __vue_inject_styles__$eA, __vue_script__$eA, __vue_scope_id__$eA, __vue_is_functional_template__$eA, __vue_module_identifier__$eA, false, undefined, undefined, undefined);

var script$ez = Vue.extend({
  name: "PhArrowsDownUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ez = script$ez;
/* template */

var __vue_render__$ez = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208",
      "x2": "176",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208",
      "x2": "176",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.4,172.9a8.4,8.4,0,0,1-1.7,8.8l-32,32a8.2,8.2,0,0,1-11.4,0l-32-32a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,48,168H72V48a8,8,0,0,1,16,0V168h24A8,8,0,0,1,119.4,172.9Zm94.3-98.6-32-32a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8,8,0,0,0,7.4-4.9A8.4,8.4,0,0,0,213.7,74.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208",
      "x2": "176",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208",
      "x2": "176",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "112 176 80 208 48 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 80 176 48 208 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "208",
      "x2": "176",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ez = [];
/* style */

const __vue_inject_styles__$ez = undefined;
/* scoped */

const __vue_scope_id__$ez = undefined;
/* module identifier */

const __vue_module_identifier__$ez = undefined;
/* functional template */

const __vue_is_functional_template__$ez = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ez = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ez,
  staticRenderFns: __vue_staticRenderFns__$ez
}, __vue_inject_styles__$ez, __vue_script__$ez, __vue_scope_id__$ez, __vue_is_functional_template__$ez, __vue_module_identifier__$ez, false, undefined, undefined, undefined);

var script$ey = Vue.extend({
  name: "PhArrowsHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ey = script$ey;
/* template */

var __vue_render__$ey = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "60 96 28 128 60 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 96 228 128 196 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 96 24 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 96 232 128 200 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,133.7l-32,32A8.3,8.3,0,0,1,200,168a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,160V136H64v24a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,64,96v24H192V96a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l32,32A8.1,8.1,0,0,1,237.7,133.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 96 24 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 96 232 128 200 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 96 24 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 96 232 128 200 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 96 24 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 96 232 128 200 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ey = [];
/* style */

const __vue_inject_styles__$ey = undefined;
/* scoped */

const __vue_scope_id__$ey = undefined;
/* module identifier */

const __vue_module_identifier__$ey = undefined;
/* functional template */

const __vue_is_functional_template__$ey = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ey = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ey,
  staticRenderFns: __vue_staticRenderFns__$ey
}, __vue_inject_styles__$ey, __vue_script__$ey, __vue_scope_id__$ey, __vue_is_functional_template__$ey, __vue_module_identifier__$ey, false, undefined, undefined, undefined);

var script$ex = Vue.extend({
  name: "PhArrowsIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ex = script$ex;
/* template */

var __vue_render__$ex = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,104V64a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L172,72.7l30.3-30.4a8.1,8.1,0,0,1,11.4,11.4L183.3,84l14.4,14.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,192,112H152A8,8,0,0,1,144,104Zm-40,40H64a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L72.7,172,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L84,183.3l14.3,14.4A8.3,8.3,0,0,0,104,200a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,112,192V152A8,8,0,0,0,104,144Zm79.3,28,14.4-14.3a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,192,144H152a8,8,0,0,0-8,8v40a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3L172,183.3l30.3,30.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM107.1,56.6a8.4,8.4,0,0,0-8.8,1.7L84,72.7,53.7,42.3A8.1,8.1,0,0,0,42.3,53.7L72.7,84,58.3,98.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,64,112h40a8,8,0,0,0,8-8V64A8,8,0,0,0,107.1,56.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "192 104 152 104 152 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 152 104 152 104 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 192 152 152 192 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "208",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 64 104 104 64 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "104",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ex = [];
/* style */

const __vue_inject_styles__$ex = undefined;
/* scoped */

const __vue_scope_id__$ex = undefined;
/* module identifier */

const __vue_module_identifier__$ex = undefined;
/* functional template */

const __vue_is_functional_template__$ex = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ex = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ex,
  staticRenderFns: __vue_staticRenderFns__$ex
}, __vue_inject_styles__$ex, __vue_script__$ex, __vue_scope_id__$ex, __vue_is_functional_template__$ex, __vue_module_identifier__$ex, false, undefined, undefined, undefined);

var script$ew = Vue.extend({
  name: "PhArrowsInCardinal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ew = script$ew;
/* template */

var __vue_render__$ew = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 188.3 128 160 99.7 188.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 67.7 128 96 156.3 67.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.7 156.3 96 128 67.7 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.3 99.7 160 128 188.3 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 188.3 128 160 99.7 188.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 67.7 128 96 156.3 67.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.7 156.3 96 128 67.7 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.3 99.7 160 128 188.3 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.9,182.6a8,8,0,0,1-5.6,13.7H136V232a8,8,0,0,1-16,0V196.3H99.7a8,8,0,0,1-5.6-13.7l28.2-28.3a8.1,8.1,0,0,1,11.4,0Zm-39.6-80.9a8.2,8.2,0,0,0,11.4,0l28.2-28.3a8,8,0,0,0-5.6-13.7H136V24a8,8,0,0,0-16,0V59.7H99.7a8,8,0,0,0-5.6,13.7Zm-20.6,20.6L73.4,94.1a8,8,0,0,0-13.7,5.6V120H24a8,8,0,0,0,0,16H59.7v20.3a8.2,8.2,0,0,0,5,7.4,7.7,7.7,0,0,0,3,.6,8,8,0,0,0,5.7-2.4l28.3-28.2A8.1,8.1,0,0,0,101.7,122.3ZM232,120H196.3V99.7a8,8,0,0,0-13.7-5.6l-28.3,28.2a8.1,8.1,0,0,0,0,11.4l28.3,28.2a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4V136H232a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 188.3 128 160 99.7 188.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 67.7 128 96 156.3 67.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.7 156.3 96 128 67.7 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.3 99.7 160 128 188.3 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 188.3 128 160 99.7 188.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 67.7 128 96 156.3 67.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.7 156.3 96 128 67.7 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.3 99.7 160 128 188.3 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 188.3 128 160 99.7 188.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 67.7 128 96 156.3 67.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "67.7 156.3 96 128 67.7 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188.3 99.7 160 128 188.3 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ew = [];
/* style */

const __vue_inject_styles__$ew = undefined;
/* scoped */

const __vue_scope_id__$ew = undefined;
/* module identifier */

const __vue_module_identifier__$ew = undefined;
/* functional template */

const __vue_is_functional_template__$ew = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ew = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ew,
  staticRenderFns: __vue_staticRenderFns__$ew
}, __vue_inject_styles__$ew, __vue_script__$ew, __vue_scope_id__$ew, __vue_is_functional_template__$ew, __vue_module_identifier__$ew, false, undefined, undefined, undefined);

var script$ev = Vue.extend({
  name: "PhArrowsInLineHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ev = script$ev;
/* template */

var __vue_render__$ev = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 96 88 128 56 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 160 168 128 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM69.7,90.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,56,96v24H16a8,8,0,0,0,0,16H56v24a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l32-32a8.1,8.1,0,0,0,0-11.4ZM240,120H200V96a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4l32,32A8.3,8.3,0,0,0,192,168a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,200,160V136h40a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "96",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 96 96 128 64 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 160 128 192 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ev = [];
/* style */

const __vue_inject_styles__$ev = undefined;
/* scoped */

const __vue_scope_id__$ev = undefined;
/* module identifier */

const __vue_module_identifier__$ev = undefined;
/* functional template */

const __vue_is_functional_template__$ev = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ev = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ev,
  staticRenderFns: __vue_staticRenderFns__$ev
}, __vue_inject_styles__$ev, __vue_script__$ev, __vue_scope_id__$ev, __vue_is_functional_template__$ev, __vue_module_identifier__$ev, false, undefined, undefined, undefined);

var script$eu = Vue.extend({
  name: "PhArrowsInLineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eu = script$eu;
/* template */

var __vue_render__$eu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "12",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 128 88 96 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "244",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 200 128 168 160 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.3,101.7a8.2,8.2,0,0,0,11.4,0l32-32a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,160,56H136V16a8,8,0,0,0-16,0V56H96a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8Zm11.4,52.6a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,96,200h24v40a8,8,0,0,0,16,0V200h24a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 64 128 96 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 192 128 160 160 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eu = [];
/* style */

const __vue_inject_styles__$eu = undefined;
/* scoped */

const __vue_scope_id__$eu = undefined;
/* module identifier */

const __vue_module_identifier__$eu = undefined;
/* functional template */

const __vue_is_functional_template__$eu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eu,
  staticRenderFns: __vue_staticRenderFns__$eu
}, __vue_inject_styles__$eu, __vue_script__$eu, __vue_scope_id__$eu, __vue_is_functional_template__$eu, __vue_module_identifier__$eu, false, undefined, undefined, undefined);

var script$et = Vue.extend({
  name: "PhArrowsInSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$et = script$et;
/* template */

var __vue_render__$et = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,53.7,187.3,80l18.4,18.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,200,112H152a8,8,0,0,1-8-8V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L176,68.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4ZM104,144H56a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L68.7,176,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L80,187.3l18.3,18.4A8.3,8.3,0,0,0,104,208a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,112,200V152A8,8,0,0,0,104,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 56 152 104 200 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "152",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 152 104 152 104 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "104",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$et = [];
/* style */

const __vue_inject_styles__$et = undefined;
/* scoped */

const __vue_scope_id__$et = undefined;
/* module identifier */

const __vue_module_identifier__$et = undefined;
/* functional template */

const __vue_is_functional_template__$et = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$et = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$et,
  staticRenderFns: __vue_staticRenderFns__$et
}, __vue_inject_styles__$et, __vue_script__$et, __vue_scope_id__$et, __vue_is_functional_template__$et, __vue_module_identifier__$et, false, undefined, undefined, undefined);

var script$es = Vue.extend({
  name: "PhArrowsLeftRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$es = script$es;
/* template */

var __vue_render__$es = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,181.7l-32,32A8.3,8.3,0,0,1,176,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,208V184H48a8,8,0,0,1,0-16H168V144a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l32,32A8.1,8.1,0,0,1,213.7,181.7Zm-139.4-64A8.3,8.3,0,0,0,80,120a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,88,112V88H208a8,8,0,0,0,0-16H88V48a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 144 208 176 176 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 112 48 80 80 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$es = [];
/* style */

const __vue_inject_styles__$es = undefined;
/* scoped */

const __vue_scope_id__$es = undefined;
/* module identifier */

const __vue_module_identifier__$es = undefined;
/* functional template */

const __vue_is_functional_template__$es = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$es = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$es,
  staticRenderFns: __vue_staticRenderFns__$es
}, __vue_inject_styles__$es, __vue_script__$es, __vue_scope_id__$es, __vue_is_functional_template__$es, __vue_module_identifier__$es, false, undefined, undefined, undefined);

var script$er = Vue.extend({
  name: "PhArrowsOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$er = script$er;
/* template */

var __vue_render__$er = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,79.3l-30.3,30.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L176.7,68,162.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48ZM98.3,146.3,68,176.7,53.7,162.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,168v40a8,8,0,0,0,8,8H88a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L79.3,188l30.4-30.3a8.1,8.1,0,0,0-11.4-11.4Zm112.8,14.3a8.4,8.4,0,0,0-8.8,1.7L188,176.7l-30.3-30.4a8.1,8.1,0,0,0-11.4,11.4L176.7,188l-14.4,14.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM79.3,68,93.7,53.7a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,88,40H48a8,8,0,0,0-8,8V88a8,8,0,0,0,4.9,7.4A8.5,8.5,0,0,0,48,96a8.3,8.3,0,0,0,5.7-2.3L68,79.3l30.3,30.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "152",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "48",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$er = [];
/* style */

const __vue_inject_styles__$er = undefined;
/* scoped */

const __vue_scope_id__$er = undefined;
/* module identifier */

const __vue_module_identifier__$er = undefined;
/* functional template */

const __vue_is_functional_template__$er = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$er = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$er,
  staticRenderFns: __vue_staticRenderFns__$er
}, __vue_inject_styles__$er, __vue_script__$er, __vue_scope_id__$er, __vue_is_functional_template__$er, __vue_module_identifier__$er, false, undefined, undefined, undefined);

var script$eq = Vue.extend({
  name: "PhArrowsOutCardinal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eq = script$eq;
/* template */

var __vue_render__$eq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 203.7 128 232 99.7 203.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 52.3 128 24 156.3 52.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.3 156.3 24 128 52.3 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.7 99.7 232 128 203.7 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 203.7 128 232 99.7 203.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 52.3 128 24 156.3 52.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.3 156.3 24 128 52.3 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.7 99.7 232 128 203.7 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.7,200.7a8.1,8.1,0,0,1-1.8,8.7l-28.2,28.3a8.2,8.2,0,0,1-11.4,0L94.1,209.4a8,8,0,0,1,5.6-13.7H120V160a8,8,0,0,1,16,0v35.7h20.3A8.2,8.2,0,0,1,163.7,200.7ZM99.7,60.3H120V96a8,8,0,0,0,16,0V60.3h20.3a8,8,0,0,0,5.6-13.7L133.7,18.3a8.2,8.2,0,0,0-11.4,0L94.1,46.6a8,8,0,0,0,5.6,13.7ZM96,136a8,8,0,0,0,0-16H60.3V99.7a8,8,0,0,0-13.7-5.6L18.3,122.3a8.1,8.1,0,0,0,0,11.4l28.3,28.2a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4V136Zm141.7-13.7L209.4,94.1a8,8,0,0,0-13.7,5.6V120H160a8,8,0,0,0,0,16h35.7v20.3a8.2,8.2,0,0,0,5,7.4,7.7,7.7,0,0,0,3,.6,8,8,0,0,0,5.7-2.4l28.3-28.2A8.1,8.1,0,0,0,237.7,122.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 203.7 128 232 99.7 203.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 52.3 128 24 156.3 52.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.3 156.3 24 128 52.3 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.7 99.7 232 128 203.7 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 203.7 128 232 99.7 203.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 52.3 128 24 156.3 52.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.3 156.3 24 128 52.3 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.7 99.7 232 128 203.7 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "156.3 203.7 128 232 99.7 203.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "99.7 52.3 128 24 156.3 52.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52.3 156.3 24 128 52.3 99.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "203.7 99.7 232 128 203.7 156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eq = [];
/* style */

const __vue_inject_styles__$eq = undefined;
/* scoped */

const __vue_scope_id__$eq = undefined;
/* module identifier */

const __vue_module_identifier__$eq = undefined;
/* functional template */

const __vue_is_functional_template__$eq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eq,
  staticRenderFns: __vue_staticRenderFns__$eq
}, __vue_inject_styles__$eq, __vue_script__$eq, __vue_scope_id__$eq, __vue_is_functional_template__$eq, __vue_module_identifier__$eq, false, undefined, undefined, undefined);

var script$ep = Vue.extend({
  name: "PhArrowsOutLineHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ep = script$ep;
/* template */

var __vue_render__$ep = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 96 12 128 44 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 160 244 128 212 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H56V96a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4l32,32A8.3,8.3,0,0,0,48,168a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,56,160V136H96a8,8,0,0,0,0-16Zm149.7,2.3-32-32a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,96v24H160a8,8,0,0,0,0,16h40v24a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l32-32A8.1,8.1,0,0,0,245.7,122.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 16 128 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 96 240 128 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ep = [];
/* style */

const __vue_inject_styles__$ep = undefined;
/* scoped */

const __vue_scope_id__$ep = undefined;
/* module identifier */

const __vue_module_identifier__$ep = undefined;
/* functional template */

const __vue_is_functional_template__$ep = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ep = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ep,
  staticRenderFns: __vue_staticRenderFns__$ep
}, __vue_inject_styles__$ep, __vue_script__$ep, __vue_scope_id__$ep, __vue_is_functional_template__$ep, __vue_module_identifier__$ep, false, undefined, undefined, undefined);

var script$eo = Vue.extend({
  name: "PhArrowsOutLineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eo = script$eo;
/* template */

var __vue_render__$eo = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 44 128 12 96 44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "244",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 212 128 244 160 212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM96,56h24V96a8,8,0,0,0,16,0V56h24a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-32-32a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,96,56Zm64,144H136V160a8,8,0,0,0-16,0v40H96a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l32,32a8.2,8.2,0,0,0,11.4,0l32-32a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,160,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 128 16 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 128 240 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eo = [];
/* style */

const __vue_inject_styles__$eo = undefined;
/* scoped */

const __vue_scope_id__$eo = undefined;
/* module identifier */

const __vue_module_identifier__$eo = undefined;
/* functional template */

const __vue_is_functional_template__$eo = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eo = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eo,
  staticRenderFns: __vue_staticRenderFns__$eo
}, __vue_inject_styles__$eo, __vue_script__$eo, __vue_scope_id__$eo, __vue_is_functional_template__$eo, __vue_module_identifier__$eo, false, undefined, undefined, undefined);

var script$en = Vue.extend({
  name: "PhArrowsOutSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$en = script$en;
/* template */

var __vue_render__$en = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V96a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L184,83.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L172.7,72,154.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,160,40h48A8,8,0,0,1,216,48ZM98.3,146.3,72,172.7,53.7,154.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,160v48a8,8,0,0,0,8,8H96a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L83.3,184l26.4-26.3a8.1,8.1,0,0,0-11.4-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 48 208 48 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 208 48 208 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$en = [];
/* style */

const __vue_inject_styles__$en = undefined;
/* scoped */

const __vue_scope_id__$en = undefined;
/* module identifier */

const __vue_module_identifier__$en = undefined;
/* functional template */

const __vue_is_functional_template__$en = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$en = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$en,
  staticRenderFns: __vue_staticRenderFns__$en
}, __vue_inject_styles__$en, __vue_script__$en, __vue_scope_id__$en, __vue_is_functional_template__$en, __vue_module_identifier__$en, false, undefined, undefined, undefined);

var script$em = Vue.extend({
  name: "PhArrowsVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$em = script$em;
/* template */

var __vue_render__$em = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 60 128 28 160 60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "228",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 196 128 228 96 196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 56 128 24 160 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 200 128 232 96 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.4,196.9a8.4,8.4,0,0,1-1.7,8.8l-32,32a8.2,8.2,0,0,1-11.4,0l-32-32a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,96,192h24V64H96a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,160,64H136V192h24A8,8,0,0,1,167.4,196.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 56 128 24 160 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 200 128 232 96 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 56 128 24 160 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 200 128 232 96 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 56 128 24 160 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 200 128 232 96 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$em = [];
/* style */

const __vue_inject_styles__$em = undefined;
/* scoped */

const __vue_scope_id__$em = undefined;
/* module identifier */

const __vue_module_identifier__$em = undefined;
/* functional template */

const __vue_is_functional_template__$em = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$em = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$em,
  staticRenderFns: __vue_staticRenderFns__$em
}, __vue_inject_styles__$em, __vue_script__$em, __vue_scope_id__$em, __vue_is_functional_template__$em, __vue_module_identifier__$em, false, undefined, undefined, undefined);

var script$el = Vue.extend({
  name: "PhArticle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$el = script$el;
/* template */

var __vue_render__$el = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "92",
      "x2": "180",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "164",
      "x2": "180",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM180,168H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "96",
      "x2": "180",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "160",
      "x2": "180",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$el = [];
/* style */

const __vue_inject_styles__$el = undefined;
/* scoped */

const __vue_scope_id__$el = undefined;
/* module identifier */

const __vue_module_identifier__$el = undefined;
/* functional template */

const __vue_is_functional_template__$el = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$el = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$el,
  staticRenderFns: __vue_staticRenderFns__$el
}, __vue_inject_styles__$el, __vue_script__$el, __vue_scope_id__$el, __vue_is_functional_template__$el, __vue_module_identifier__$el, false, undefined, undefined, undefined);

var script$ek = Vue.extend({
  name: "PhArticleMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ek = script$ek;
/* template */

var __vue_render__$ek = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "48",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "48",
      "x2": "136",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "240",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 128 40 48 80 112 120 48 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "56",
      "x2": "136",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "136",
      "x2": "48",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "136",
      "x2": "136",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 136 40 56 80 120 120 56 120 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,136a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16h8V64H24a8,8,0,0,1,0-16H40a8,8,0,0,1,6.8,3.8L80,104.9l33.2-53.1A8,8,0,0,1,120,48h16a8,8,0,0,1,0,16h-8v64h8a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16V83.9L86.8,124.2a8,8,0,0,1-13.6,0L48,83.9V128A8,8,0,0,1,56,136Zm112-24h72a8,8,0,0,0,0-16H168a8,8,0,0,0,0,16Zm72,16H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "56",
      "x2": "136",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "136",
      "x2": "48",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "136",
      "x2": "136",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 136 40 56 80 120 120 56 120 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "56",
      "x2": "136",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "136",
      "x2": "48",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "136",
      "x2": "136",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 136 40 56 80 120 120 56 120 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "56",
      "x2": "40.1",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120.1",
      "y1": "56",
      "x2": "136.1",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "136",
      "x2": "48.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112.1",
      "y1": "136",
      "x2": "136.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.1",
      "y1": "136",
      "x2": "240.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40.1 136 40.1 56 80.1 120 120.1 56 120.1 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "56",
      "x2": "136",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "136",
      "x2": "48",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "136",
      "x2": "136",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 136 40 56 80 120 120 56 120 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ek = [];
/* style */

const __vue_inject_styles__$ek = undefined;
/* scoped */

const __vue_scope_id__$ek = undefined;
/* module identifier */

const __vue_module_identifier__$ek = undefined;
/* functional template */

const __vue_is_functional_template__$ek = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ek = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ek,
  staticRenderFns: __vue_staticRenderFns__$ek
}, __vue_inject_styles__$ek, __vue_script__$ek, __vue_scope_id__$ek, __vue_is_functional_template__$ek, __vue_module_identifier__$ek, false, undefined, undefined, undefined);

var script$ej = Vue.extend({
  name: "PhArticleNyTimes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ej = script$ej;
/* template */

var __vue_render__$ej = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "240",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,131.6A48,48,0,1,1,79.9,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9",
      "y1": "114.5",
      "x2": "79.9",
      "y2": "167.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,131.6A48,48,0,1,1,79.9,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9",
      "y1": "114.5",
      "x2": "79.9",
      "y2": "167.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,104a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H160A8,8,0,0,1,152,104Zm88,24H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM79.9,176A55.9,55.9,0,0,1,30.4,93.9,28,28,0,0,1,47.9,44a8.2,8.2,0,0,1,4.3,1.2L114,83.8A12,12,0,0,0,111.9,60a8,8,0,0,1,0-16,28,28,0,0,1,0,56,7.9,7.9,0,0,1-4.2-1.2l-30-18.7a40,40,0,0,0-5.8,79.1V114.5a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8v44.7a40,40,0,0,0,30.9-29.5,7.9,7.9,0,0,1,9.6-5.8,8,8,0,0,1,5.9,9.6A56,56,0,0,1,79.9,176Zm-40-95.1A56.3,56.3,0,0,1,58.7,68.2l-12.8-8A12,12,0,0,0,35.9,72,11.8,11.8,0,0,0,39.9,80.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,131.6A48,48,0,1,1,79.9,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9",
      "y1": "114.5",
      "x2": "79.9",
      "y2": "167.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,131.6A48,48,0,1,1,79.9,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9",
      "y1": "114.5",
      "x2": "79.9",
      "y2": "167.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "168",
      "x2": "240",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,131.6A48,48,0,1,1,79.9,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.9",
      "y1": "114.5",
      "x2": "79.9",
      "y2": "167.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ej = [];
/* style */

const __vue_inject_styles__$ej = undefined;
/* scoped */

const __vue_scope_id__$ej = undefined;
/* module identifier */

const __vue_module_identifier__$ej = undefined;
/* functional template */

const __vue_is_functional_template__$ej = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ej = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ej,
  staticRenderFns: __vue_staticRenderFns__$ej
}, __vue_inject_styles__$ej, __vue_script__$ej, __vue_scope_id__$ej, __vue_is_functional_template__$ej, __vue_module_identifier__$ej, false, undefined, undefined, undefined);

var script$ei = Vue.extend({
  name: "PhAsterisk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ei = script$ei;
/* template */

var __vue_render__$ei = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "84",
      "x2": "204.2",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "172",
      "x2": "204.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "84",
      "x2": "204.2",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "172",
      "x2": "204.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.2,165.1,144,128l64.2-37.1a8,8,0,1,0-8-13.8l-64.2,37V40a8,8,0,0,0-16,0v74.1l-64.2-37a8,8,0,0,0-8,13.8L112,128,47.8,165.1A8,8,0,0,0,44.9,176a7.7,7.7,0,0,0,6.9,4,7.3,7.3,0,0,0,4-1.1l64.2-37V216a8,8,0,0,0,16,0V141.9l64.2,37a7.3,7.3,0,0,0,4,1.1,7.7,7.7,0,0,0,6.9-4A8,8,0,0,0,208.2,165.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "84",
      "x2": "204.2",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "172",
      "x2": "204.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "84",
      "x2": "204.2",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "172",
      "x2": "204.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "84",
      "x2": "204.2",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.8",
      "y1": "172",
      "x2": "204.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ei = [];
/* style */

const __vue_inject_styles__$ei = undefined;
/* scoped */

const __vue_scope_id__$ei = undefined;
/* module identifier */

const __vue_module_identifier__$ei = undefined;
/* functional template */

const __vue_is_functional_template__$ei = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ei = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ei,
  staticRenderFns: __vue_staticRenderFns__$ei
}, __vue_inject_styles__$ei, __vue_script__$ei, __vue_scope_id__$ei, __vue_is_functional_template__$ei, __vue_module_identifier__$ei, false, undefined, undefined, undefined);

var script$eh = Vue.extend({
  name: "PhAsteriskSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eh = script$eh;
/* template */

var __vue_render__$eh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.3",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.3",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.7",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.7",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.3",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.3",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.7",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.7",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M214.2,108.4l-73.3,23.8,45.3,62.3a8,8,0,1,1-12.9,9.4L128,141.6,82.7,203.9a8,8,0,1,1-12.9-9.4l45.3-62.3L41.8,108.4a8,8,0,0,1,5-15.2L120,117V40a8,8,0,0,1,16,0v77l73.2-23.8a8,8,0,0,1,5,15.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.3",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.3",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.7",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.7",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.3",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.3",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.7",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.7",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44.3",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.3",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.7",
      "y1": "199.2",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.7",
      "y1": "100.8",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eh = [];
/* style */

const __vue_inject_styles__$eh = undefined;
/* scoped */

const __vue_scope_id__$eh = undefined;
/* module identifier */

const __vue_module_identifier__$eh = undefined;
/* functional template */

const __vue_is_functional_template__$eh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eh,
  staticRenderFns: __vue_staticRenderFns__$eh
}, __vue_inject_styles__$eh, __vue_script__$eh, __vue_scope_id__$eh, __vue_is_functional_template__$eh, __vue_module_identifier__$eh, false, undefined, undefined, undefined);

var script$eg = Vue.extend({
  name: "PhAt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eg = script$eg;
/* template */

var __vue_render__$eg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104.1,104.1,0,0,0,24.1,132.1c2.1,54.7,47,98.8,101.8,99.9a104,104,0,0,0,91.4-50.8,4,4,0,0,0-4.1-6,52.5,52.5,0,0,1-9.2.8c-18.3,0-28.5-8-33.9-14.7a43.9,43.9,0,0,1-3.4-5A48,48,0,1,1,128,80a47.4,47.4,0,0,1,32,12.3v-4a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v40c0,14.6,4.9,32,28,32s27.6-16.2,28-30.5V128A104.1,104.1,0,0,0,128,24Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eg = [];
/* style */

const __vue_inject_styles__$eg = undefined;
/* scoped */

const __vue_scope_id__$eg = undefined;
/* module identifier */

const __vue_module_identifier__$eg = undefined;
/* functional template */

const __vue_is_functional_template__$eg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eg,
  staticRenderFns: __vue_staticRenderFns__$eg
}, __vue_inject_styles__$eg, __vue_script__$eg, __vue_scope_id__$eg, __vue_is_functional_template__$eg, __vue_module_identifier__$eg, false, undefined, undefined, undefined);

var script$ef = Vue.extend({
  name: "PhAtom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ef = script$ef;
/* template */

var __vue_render__$ef = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M196.1,128a195.3,195.3,0,0,0,19.2-32.7c11.1-24.6,11.2-44.2.4-55C198.2,22.9,162.5,35.4,128,60,93.5,35.4,57.8,22.9,40.3,40.3c-10.8,10.8-10.7,30.4.4,55A195.3,195.3,0,0,0,59.9,128a195.3,195.3,0,0,0-19.2,32.7c-11.1,24.6-11.2,44.2-.4,55,5.6,5.6,13.1,8.1,21.9,8.1,18.4,0,42.4-11.1,65.8-27.8,23.4,16.7,47.4,27.8,65.8,27.8,8.8,0,16.3-2.5,21.9-8.1,10.8-10.8,10.7-30.4-.4-55A195.3,195.3,0,0,0,196.1,128Zm-2.3-79.7c4.8,0,8.4,1.1,10.6,3.3,5.6,5.7,4.2,19.5-3.7,37.1a169.7,169.7,0,0,1-14.8,25.9c-6.4-7.9-13.5-15.7-21.1-23.4s-15.4-14.5-23.5-21.1C163.2,55.2,182,48.3,193.8,48.3ZM176.1,128a277.3,277.3,0,0,1-22.6,25.5A314.1,314.1,0,0,1,128,176.2a314.1,314.1,0,0,1-25.5-22.7A277.3,277.3,0,0,1,79.9,128a277.3,277.3,0,0,1,22.6-25.5A314.1,314.1,0,0,1,128,79.8a314.1,314.1,0,0,1,25.5,22.7A277.3,277.3,0,0,1,176.1,128ZM55.3,88.7C47.4,71.1,46,57.3,51.6,51.6c2.2-2.2,5.8-3.3,10.6-3.3,11.8,0,30.6,6.9,52.5,21.8-8.1,6.6-16,13.7-23.5,21.1s-14.7,15.5-21.1,23.4A169.7,169.7,0,0,1,55.3,88.7ZM51.6,204.4c-5.6-5.7-4.2-19.5,3.7-37.1a169.7,169.7,0,0,1,14.8-25.9c6.4,7.9,13.5,15.7,21.1,23.4s15.4,14.5,23.5,21.1C83.9,206.8,59.2,212,51.6,204.4Zm152.8,0c-2.2,2.2-5.8,3.3-10.6,3.3-11.8,0-30.6-6.9-52.5-21.8,8.1-6.6,16-13.7,23.5-21.1s14.7-15.5,21.1-23.4a169.7,169.7,0,0,1,14.8,25.9C208.6,184.9,210,198.7,204.4,204.4ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "44",
      "ry": "116",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "116",
      "ry": "44",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ef = [];
/* style */

const __vue_inject_styles__$ef = undefined;
/* scoped */

const __vue_scope_id__$ef = undefined;
/* module identifier */

const __vue_module_identifier__$ef = undefined;
/* functional template */

const __vue_is_functional_template__$ef = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ef = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ef,
  staticRenderFns: __vue_staticRenderFns__$ef
}, __vue_inject_styles__$ef, __vue_script__$ef, __vue_scope_id__$ef, __vue_is_functional_template__$ef, __vue_module_identifier__$ef, false, undefined, undefined, undefined);

var script$ee = Vue.extend({
  name: "PhBaby",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ee = script$ee;
/* template */

var __vue_render__$ee = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,168a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,16,16,16.7,16.7,0,0,0,8-2.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,168a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M134.2,24.2a3.9,3.9,0,0,0-3.6,1.8C120.3,41.6,120,55.9,120,56a7.9,7.9,0,0,0,9.7,7.8c3.7-.7,6.2-4.2,6.3-8a8.1,8.1,0,0,1,8.8-7.8,8.2,8.2,0,0,1,7.2,8.3,24,24,0,0,1-48-.3c0-.6.1-10.8,5.4-24a4,4,0,0,0-4.6-5.4A104.1,104.1,0,0,0,24.1,131.7C26,186.8,71.2,231.1,126.3,232a104,104,0,0,0,7.9-207.8ZM80,128a12,12,0,1,1,12,12A12,12,0,0,1,80,128Zm79,46.7a56.3,56.3,0,0,1-62,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.3,39.8,39.8,0,0,0,44.2,0,8,8,0,0,1,11.1,2.3A8.1,8.1,0,0,1,159,174.7Zm5-34.7a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,168a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,168a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,168a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ee = [];
/* style */

const __vue_inject_styles__$ee = undefined;
/* scoped */

const __vue_scope_id__$ee = undefined;
/* module identifier */

const __vue_module_identifier__$ee = undefined;
/* functional template */

const __vue_is_functional_template__$ee = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ee = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ee,
  staticRenderFns: __vue_staticRenderFns__$ee
}, __vue_inject_styles__$ee, __vue_script__$ee, __vue_scope_id__$ee, __vue_is_functional_template__$ee, __vue_module_identifier__$ee, false, undefined, undefined, undefined);

var script$ed = Vue.extend({
  name: "PhBackpack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ed = script$ed;
/* template */

var __vue_render__$ed = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92,60h72a48,48,0,0,1,48,48V220a8,8,0,0,1-8,8H52a8,8,0,0,1-8-8V108A48,48,0,0,1,92,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,228V152a16,16,0,0,1,16-16h56a16,16,0,0,1,16,16v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,60V36a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "100",
      "x2": "148",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "172",
      "x2": "172",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "172",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,48H96A48,48,0,0,0,48,96V216a8,8,0,0,0,8,8H80V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72h24a8,8,0,0,0,8-8V96A48,48,0,0,0,160,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "144",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "168",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.6V32A24.1,24.1,0,0,0,144,8H112A24.1,24.1,0,0,0,88,32v8.6A56,56,0,0,0,40,96V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V96A56,56,0,0,0,168,40.6ZM104,32a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8v8H104Zm8,40h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16Zm64,144H80V176h56v8a8,8,0,0,0,16,0v-8h24Zm0-56H80v-8a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "144",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "168",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "144",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "168",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "144",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "168",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ed = [];
/* style */

const __vue_inject_styles__$ed = undefined;
/* scoped */

const __vue_scope_id__$ed = undefined;
/* module identifier */

const __vue_module_identifier__$ed = undefined;
/* functional template */

const __vue_is_functional_template__$ed = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ed = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ed,
  staticRenderFns: __vue_staticRenderFns__$ed
}, __vue_inject_styles__$ed, __vue_script__$ed, __vue_scope_id__$ed, __vue_is_functional_template__$ed, __vue_module_identifier__$ed, false, undefined, undefined, undefined);

var script$ec = Vue.extend({
  name: "PhBackspace",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ec = script$ec;
/* template */

var __vue_render__$ec = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "112",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "112",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H68.5a16.2,16.2,0,0,0-13.7,7.8L9.1,123.9a8,8,0,0,0,0,8.2l45.7,76.1h0A16.1,16.1,0,0,0,68.5,216H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM165.7,146.3a8.1,8.1,0,0,1,0,11.4A8.5,8.5,0,0,1,160,160a8.3,8.3,0,0,1-5.7-2.3L136,139.3l-18.3,18.4A8.5,8.5,0,0,1,112,160a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L124.7,128l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4L136,116.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L147.3,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "112",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "112",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "112",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "152",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ec = [];
/* style */

const __vue_inject_styles__$ec = undefined;
/* scoped */

const __vue_scope_id__$ec = undefined;
/* module identifier */

const __vue_module_identifier__$ec = undefined;
/* functional template */

const __vue_is_functional_template__$ec = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ec = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ec,
  staticRenderFns: __vue_staticRenderFns__$ec
}, __vue_inject_styles__$ec, __vue_script__$ec, __vue_scope_id__$ec, __vue_is_functional_template__$ec, __vue_module_identifier__$ec, false, undefined, undefined, undefined);

var script$eb = Vue.extend({
  name: "PhBag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$eb = script$eb;
/* template */

var __vue_render__$eb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H175.3a48,48,0,0,0-94.6,0H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$eb = [];
/* style */

const __vue_inject_styles__$eb = undefined;
/* scoped */

const __vue_scope_id__$eb = undefined;
/* module identifier */

const __vue_module_identifier__$eb = undefined;
/* functional template */

const __vue_is_functional_template__$eb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$eb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$eb,
  staticRenderFns: __vue_staticRenderFns__$eb
}, __vue_inject_styles__$eb, __vue_script__$eb, __vue_scope_id__$eb, __vue_is_functional_template__$eb, __vue_module_identifier__$eb, false, undefined, undefined, undefined);

var script$ea = Vue.extend({
  name: "PhBagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ea = script$ea;
/* template */

var __vue_render__$ea = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H175.3a48,48,0,0,0-94.6,0H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ea = [];
/* style */

const __vue_inject_styles__$ea = undefined;
/* scoped */

const __vue_scope_id__$ea = undefined;
/* module identifier */

const __vue_module_identifier__$ea = undefined;
/* functional template */

const __vue_is_functional_template__$ea = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ea = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ea,
  staticRenderFns: __vue_staticRenderFns__$ea
}, __vue_inject_styles__$ea, __vue_script__$ea, __vue_scope_id__$ea, __vue_is_functional_template__$ea, __vue_module_identifier__$ea, false, undefined, undefined, undefined);

var script$e9 = Vue.extend({
  name: "PhBalloon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e9 = script$e9;
/* template */

var __vue_render__$e9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104c0,44.2-35.8,92-80,92s-80-47.8-80-92a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.7 193.7 160 232 96 232 111.3 193.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,70a36.8,36.8,0,0,1,22,22",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104a80,80,0,0,0-160,0c0,40.5,30.1,87.5,69.2,95h0L104,232h48l-13.2-33h0C177.9,191.5,208,144.5,208,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "138.8 199 152 232 104 232 117.2 199",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,56.7A47.8,47.8,0,0,1,175.3,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,16a88.1,88.1,0,0,0-88,88c0,23.4,9.4,49.4,25.1,69.5,11.9,15.2,26.2,25.7,41.3,30.9L96.6,229a8,8,0,0,0,.8,7.5A7.9,7.9,0,0,0,104,240h48a7.9,7.9,0,0,0,6.6-3.5,8,8,0,0,0,.8-7.5l-9.8-24.6c15.1-5.2,29.4-15.7,41.3-30.9C206.6,153.4,216,127.4,216,104A88.1,88.1,0,0,0,128,16Zm48.7,87.9h-1.4a8.1,8.1,0,0,1-7.9-6.7,39.7,39.7,0,0,0-32.7-32.7,8.1,8.1,0,0,1-6.6-9.3,7.9,7.9,0,0,1,9.2-6.5,55.9,55.9,0,0,1,45.9,45.9A7.9,7.9,0,0,1,176.7,103.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "138.8 199 152 232 104 232 117.2 199",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,56.7A47.8,47.8,0,0,1,175.3,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "138.8 199 152 232 104 232 117.2 199",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,56.7A47.8,47.8,0,0,1,175.3,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "138.8 199 152 232 104 232 117.2 199",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,56.7A47.8,47.8,0,0,1,175.3,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e9 = [];
/* style */

const __vue_inject_styles__$e9 = undefined;
/* scoped */

const __vue_scope_id__$e9 = undefined;
/* module identifier */

const __vue_module_identifier__$e9 = undefined;
/* functional template */

const __vue_is_functional_template__$e9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e9,
  staticRenderFns: __vue_staticRenderFns__$e9
}, __vue_inject_styles__$e9, __vue_script__$e9, __vue_scope_id__$e9, __vue_is_functional_template__$e9, __vue_module_identifier__$e9, false, undefined, undefined, undefined);

var script$e8 = Vue.extend({
  name: "PhBandaids",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e8 = script$e8;
/* template */

var __vue_render__$e8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,94.6a32,32,0,0,0-45.2-45.2L128,82.7,173.3,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.4,161.4a32,32,0,0,0,45.2,45.2L128,173.3,82.7,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.6,49.4A32,32,0,0,0,49.4,94.6L82.7,128,128,82.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,128,128,173.3l33.4,33.3a32,32,0,0,0,45.2-45.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,128l27.7-27.7a40,40,0,0,0-56.6-56.6L128,71.4,100.3,43.7a40,40,0,0,0-56.6,56.6L71.4,128,43.7,155.7a40,40,0,0,0,56.6,56.6L128,184.6l27.7,27.7a40,40,0,0,0,56.6-56.6ZM128,94.1,161.9,128,128,161.9,94.1,128ZM167,55a24,24,0,0,1,34,34l-27.7,27.7-34-34ZM89,201a24,24,0,0,1-34-34l27.7-27.7,34,34Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16",
      "opacity": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e8 = [];
/* style */

const __vue_inject_styles__$e8 = undefined;
/* scoped */

const __vue_scope_id__$e8 = undefined;
/* module identifier */

const __vue_module_identifier__$e8 = undefined;
/* functional template */

const __vue_is_functional_template__$e8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e8,
  staticRenderFns: __vue_staticRenderFns__$e8
}, __vue_inject_styles__$e8, __vue_script__$e8, __vue_scope_id__$e8, __vue_is_functional_template__$e8, __vue_module_identifier__$e8, false, undefined, undefined, undefined);

var script$e7 = Vue.extend({
  name: "PhBank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e7 = script$e7;
/* template */

var __vue_render__$e7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "56",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "56",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208ZM16.3,98.2a8,8,0,0,1,3.5-9l104-64a7.9,7.9,0,0,1,8.4,0l104,64A8,8,0,0,1,232,104H208v64h16a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H48V104H24A8,8,0,0,1,16.3,98.2ZM144,160a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "56",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "56",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 96 232 96 128 32 24 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "56",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "240",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e7 = [];
/* style */

const __vue_inject_styles__$e7 = undefined;
/* scoped */

const __vue_scope_id__$e7 = undefined;
/* module identifier */

const __vue_module_identifier__$e7 = undefined;
/* functional template */

const __vue_is_functional_template__$e7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e7,
  staticRenderFns: __vue_staticRenderFns__$e7
}, __vue_inject_styles__$e7, __vue_script__$e7, __vue_scope_id__$e7, __vue_is_functional_template__$e7, __vue_module_identifier__$e7, false, undefined, undefined, undefined);

var script$e6 = Vue.extend({
  name: "PhBarbell",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e6 = script$e6;
/* template */

var __vue_render__$e6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "60",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,80h28a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "156",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,120h-8V88a16,16,0,0,0-16-16H208V64a16,16,0,0,0-16-16H168a16,16,0,0,0-16,16v56H104V64A16,16,0,0,0,88,48H64A16,16,0,0,0,48,64v8H32A16,16,0,0,0,16,88v32H8a8,8,0,0,0,0,16h8v32a16,16,0,0,0,16,16H48v8a16,16,0,0,0,16,16H88a16,16,0,0,0,16-16V136h48v56a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16v-8h16a16,16,0,0,0,16-16V136h8a8,8,0,0,0,0-16ZM32,168V88H48v80Zm192,0H208V88h16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "40",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "24",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e6 = [];
/* style */

const __vue_inject_styles__$e6 = undefined;
/* scoped */

const __vue_scope_id__$e6 = undefined;
/* module identifier */

const __vue_module_identifier__$e6 = undefined;
/* functional template */

const __vue_is_functional_template__$e6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e6,
  staticRenderFns: __vue_staticRenderFns__$e6
}, __vue_inject_styles__$e6, __vue_script__$e6, __vue_scope_id__$e6, __vue_is_functional_template__$e6, __vue_module_identifier__$e6, false, undefined, undefined, undefined);

var script$e5 = Vue.extend({
  name: "PhBarcode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e5 = script$e5;
/* template */

var __vue_render__$e5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "180 52 220 52 220 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "76 204 36 204 36 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "220 164 220 204 180 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36 92 36 52 76 52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "92",
      "x2": "168",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,40H184a8,8,0,0,0,0,16h32V88a8,8,0,0,0,16,0V48A8,8,0,0,0,224,40Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,168V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "184 48 224 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 208 32 208 32 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 168 224 208 184 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 88 32 48 72 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "88",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "144",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "112",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e5 = [];
/* style */

const __vue_inject_styles__$e5 = undefined;
/* scoped */

const __vue_scope_id__$e5 = undefined;
/* module identifier */

const __vue_module_identifier__$e5 = undefined;
/* functional template */

const __vue_is_functional_template__$e5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e5,
  staticRenderFns: __vue_staticRenderFns__$e5
}, __vue_inject_styles__$e5, __vue_script__$e5, __vue_scope_id__$e5, __vue_is_functional_template__$e5, __vue_module_identifier__$e5, false, undefined, undefined, undefined);

var script$e4 = Vue.extend({
  name: "PhBarricade",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e4 = script$e4;
/* template */

var __vue_render__$e4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "72",
      "x2": "172",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "232",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "84",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "160",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,72l76,76V80a8,8,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,72l88,88H100L24,84V80a8,8,0,0,1,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "72",
      "x2": "172",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "232",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "84",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "160",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,64H32A16,16,0,0,0,16,80v72a16,16,0,0,0,16,16H56v32a8,8,0,0,0,16,0V168H184v32a8,8,0,0,0,16,0V168h24a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64ZM32,92l60,60H32Zm192,60H164L92,80h72l60,60v12Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "72",
      "x2": "172",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "232",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "84",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "160",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "72",
      "x2": "172",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "232",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "84",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "160",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "72",
      "x2": "172",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "232",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "84",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "160",
      "x2": "64",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e4 = [];
/* style */

const __vue_inject_styles__$e4 = undefined;
/* scoped */

const __vue_scope_id__$e4 = undefined;
/* module identifier */

const __vue_module_identifier__$e4 = undefined;
/* functional template */

const __vue_is_functional_template__$e4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e4,
  staticRenderFns: __vue_staticRenderFns__$e4
}, __vue_inject_styles__$e4, __vue_script__$e4, __vue_scope_id__$e4, __vue_is_functional_template__$e4, __vue_module_identifier__$e4, false, undefined, undefined, undefined);

var script$e3 = Vue.extend({
  name: "PhBaseball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e3 = script$e3;
/* template */

var __vue_render__$e3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.2,79.4A98.3,98.3,0,0,1,196,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.8a98.3,98.3,0,0,1-14.8-19.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.7,140a117.3,117.3,0,0,1-.7-12,117.3,117.3,0,0,1,.7-12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.8,79.4A98.3,98.3,0,0,0,60,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,195.8a98.3,98.3,0,0,0,14.8-19.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.3,140a117.3,117.3,0,0,0,.7-12,117.3,117.3,0,0,0-.7-12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a95.5,95.5,0,0,1,28,67.7,95.8,95.8,0,0,1-28,67.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a96,96,0,0,1,0,135.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.2,113A94.7,94.7,0,0,1,173,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.8,113A94.7,94.7,0,0,0,83,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,158.5A94.7,94.7,0,0,0,86.8,143",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.9,63.9a4,4,0,0,0-6,.3,103.9,103.9,0,0,0,0,127.6,4,4,0,0,0,6,.3l7.3-7.3a8,8,0,0,1,6.2-2.8,7.9,7.9,0,0,1,5.2,2,8.2,8.2,0,0,1,.6,11.4,99.9,99.9,0,0,1-7.8,8.2,3.9,3.9,0,0,0,.2,6,103.8,103.8,0,0,0,128.8,0,3.9,3.9,0,0,0,.2-6,103.3,103.3,0,0,1-7.9-8.3,8,8,0,1,1,12.1-10.5l7.3,7.3a4,4,0,0,0,6-.3,103.9,103.9,0,0,0,0-127.6,4,4,0,0,0-6-.3l-7.3,7.3a8.1,8.1,0,0,1-6.1,2.8,7.6,7.6,0,0,1-5.3-2,8.2,8.2,0,0,1-.6-11.4,99.9,99.9,0,0,1,7.8-8.2,3.9,3.9,0,0,0-.2-6,103.8,103.8,0,0,0-128.8,0,3.9,3.9,0,0,0-.2,6,99.9,99.9,0,0,1,7.8,8.2A8,8,0,0,1,65.3,74h0a8.1,8.1,0,0,1-6.1-2.8ZM79.2,88.2a9.6,9.6,0,0,1,2.8-.7,8.1,8.1,0,0,1,7.9,5.3,105.7,105.7,0,0,1,4.4,16.5,8,8,0,0,1-5.9,9.4,6.3,6.3,0,0,1-1.9.3h0a8,8,0,0,1-7.9-6.6,83.8,83.8,0,0,0-3.7-13.9C73.5,94.5,75.2,89.8,79.2,88.2Zm15.1,58.5a105.7,105.7,0,0,1-4.4,16.5,8.1,8.1,0,0,1-7.6,5.3h0a7,7,0,0,1-3.1-.7,8.2,8.2,0,0,1-4.3-10.3,83.8,83.8,0,0,0,3.7-13.9,8.1,8.1,0,0,1,7.7-6.6l2,.2A8.2,8.2,0,0,1,94.3,146.7Zm82.5,21.1a7,7,0,0,1-3.1.7,8.1,8.1,0,0,1-7.6-5.3,105.7,105.7,0,0,1-4.4-16.5,8.2,8.2,0,0,1,5.4-9.3,8.1,8.1,0,0,1,10.3,6.2,83.8,83.8,0,0,0,3.7,13.9A8.2,8.2,0,0,1,176.8,167.8Zm3.6-68a23.6,23.6,0,0,0-2.9,11.4,8,8,0,0,1-8,7.8l-1.4-.2c-4.3-.7-7.2-5.3-6.4-9.6A109,109,0,0,1,166,93.1a8.3,8.3,0,0,1,9.8-5.3A8,8,0,0,1,180.4,99.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.2,113A94.7,94.7,0,0,1,173,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.8,113A94.7,94.7,0,0,0,83,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,158.5A94.7,94.7,0,0,0,86.8,143",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.2,113A94.7,94.7,0,0,1,173,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.8,113A94.7,94.7,0,0,0,83,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,158.5A94.7,94.7,0,0,0,86.8,143",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.2,113A94.7,94.7,0,0,1,173,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.8,113A94.7,94.7,0,0,0,83,97.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,158.5A94.7,94.7,0,0,0,86.8,143",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e3 = [];
/* style */

const __vue_inject_styles__$e3 = undefined;
/* scoped */

const __vue_scope_id__$e3 = undefined;
/* module identifier */

const __vue_module_identifier__$e3 = undefined;
/* functional template */

const __vue_is_functional_template__$e3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e3,
  staticRenderFns: __vue_staticRenderFns__$e3
}, __vue_inject_styles__$e3, __vue_script__$e3, __vue_scope_id__$e3, __vue_is_functional_template__$e3, __vue_module_identifier__$e3, false, undefined, undefined, undefined);

var script$e2 = Vue.extend({
  name: "PhBasketball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e2 = script$e2;
/* template */

var __vue_render__$e2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.2a96.1,96.1,0,0,0,0,135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a95.5,95.5,0,0,1,28,67.7,95.8,95.8,0,0,1-28,67.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a96,96,0,0,1,0,135.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.2a96.1,96.1,0,0,0,0,135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M63.6,46.4a104.3,104.3,0,0,1,52-21.7,4,4,0,0,1,4.4,4V120H95.7A104.1,104.1,0,0,0,63.4,52.4,3.9,3.9,0,0,1,63.6,46.4ZM46,64.1a104.8,104.8,0,0,0-21.3,51.4,4.1,4.1,0,0,0,4,4.5H79.6A88,88,0,0,0,51.9,63.6,4,4,0,0,0,46,64.1ZM192.4,46.4a104.3,104.3,0,0,0-52-21.7,4,4,0,0,0-4.4,4V120h24.3a104.1,104.1,0,0,1,32.3-67.6A3.9,3.9,0,0,0,192.4,46.4Zm38.9,69.1A104.8,104.8,0,0,0,210,64.1a4,4,0,0,0-5.9-.5A88,88,0,0,0,176.4,120h50.9A4.1,4.1,0,0,0,231.3,115.5Zm-206.6,25A104.8,104.8,0,0,0,46,191.9a4,4,0,0,0,5.9.5A88,88,0,0,0,79.6,136H28.7A4.1,4.1,0,0,0,24.7,140.5ZM210,191.9a104.8,104.8,0,0,0,21.3-51.4,4.1,4.1,0,0,0-4-4.5H176.4a88,88,0,0,0,27.7,56.4A4,4,0,0,0,210,191.9ZM63.6,209.6a104.3,104.3,0,0,0,52,21.7,4,4,0,0,0,4.4-4V136H95.7a104.1,104.1,0,0,1-32.3,67.6A3.9,3.9,0,0,0,63.6,209.6ZM160.3,136H136v91.3a4,4,0,0,0,4.4,4,104.3,104.3,0,0,0,52-21.7,3.9,3.9,0,0,0,.2-6A104.1,104.1,0,0,1,160.3,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.2a96.1,96.1,0,0,0,0,135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.2a96.1,96.1,0,0,0,0,135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,60.2a96.1,96.1,0,0,0,0,135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e2 = [];
/* style */

const __vue_inject_styles__$e2 = undefined;
/* scoped */

const __vue_scope_id__$e2 = undefined;
/* module identifier */

const __vue_module_identifier__$e2 = undefined;
/* functional template */

const __vue_is_functional_template__$e2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e2,
  staticRenderFns: __vue_staticRenderFns__$e2
}, __vue_inject_styles__$e2, __vue_script__$e2, __vue_scope_id__$e2, __vue_is_functional_template__$e2, __vue_module_identifier__$e2, false, undefined, undefined, undefined);

var script$e1 = Vue.extend({
  name: "PhBathtub",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e1 = script$e1;
/* template */

var __vue_render__$e1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "192",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "184",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,104V52a20,20,0,0,1,40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "96",
      "width": "64",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,104H200v40H136V104H24a8,8,0,0,0-8,8v32a48,48,0,0,0,48,48H192a48,48,0,0,0,48-48V112A8,8,0,0,0,232,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "192",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "184",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,104V52a20,20,0,0,1,40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "96",
      "width": "64",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,96H212a8,8,0,0,0-8-8H132a8,8,0,0,0-8,8H64V52a12,12,0,0,1,24,0,8,8,0,0,0,16,0,28,28,0,0,0-56,0V96H24A16,16,0,0,0,8,112v32a56,56,0,0,0,56,56v16a8,8,0,0,0,16,0V200h96v16a8,8,0,0,0,16,0V200a56,56,0,0,0,56-56V112A16,16,0,0,0,232,96Zm-36,8v36H140V104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "192",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "184",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,104V52a20,20,0,0,1,40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "96",
      "width": "64",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "192",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "184",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,104V52a20,20,0,0,1,40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "96",
      "width": "64",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "192",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "184",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,104V52a20,20,0,0,1,40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "96",
      "width": "64",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e1 = [];
/* style */

const __vue_inject_styles__$e1 = undefined;
/* scoped */

const __vue_scope_id__$e1 = undefined;
/* module identifier */

const __vue_module_identifier__$e1 = undefined;
/* functional template */

const __vue_is_functional_template__$e1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e1,
  staticRenderFns: __vue_staticRenderFns__$e1
}, __vue_inject_styles__$e1, __vue_script__$e1, __vue_scope_id__$e1, __vue_is_functional_template__$e1, __vue_module_identifier__$e1, false, undefined, undefined, undefined);

var script$e0 = Vue.extend({
  name: "PhBatteryCharging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e0 = script$e0;
/* template */

var __vue_render__$e0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118 168 134 128 102 128 118 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm-52.6,83-16,40a7.9,7.9,0,0,1-7.4,5,8,8,0,0,1-3-.6,7.9,7.9,0,0,1-4.4-10.4l11.6-29H108a7.9,7.9,0,0,1-6.6-3.5,8,8,0,0,1-.8-7.5l16-40a8,8,0,1,1,14.8,6l-11.6,29H140a7.9,7.9,0,0,1,6.6,3.5A8,8,0,0,1,147.4,131Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 168 140 128 108 128 124 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e0 = [];
/* style */

const __vue_inject_styles__$e0 = undefined;
/* scoped */

const __vue_scope_id__$e0 = undefined;
/* module identifier */

const __vue_module_identifier__$e0 = undefined;
/* functional template */

const __vue_is_functional_template__$e0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e0,
  staticRenderFns: __vue_staticRenderFns__$e0
}, __vue_inject_styles__$e0, __vue_script__$e0, __vue_scope_id__$e0, __vue_is_functional_template__$e0, __vue_module_identifier__$e0, false, undefined, undefined, undefined);

var script$d$ = Vue.extend({
  name: "PhBatteryChargingVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d$ = script$d$;
/* template */

var __vue_render__$d$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "100",
      "y1": "12",
      "x2": "156",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "180",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 178 144 138 112 138 128 98",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,16h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,32H72A24.1,24.1,0,0,0,48,56V208a24.1,24.1,0,0,0,24,24H184a24.1,24.1,0,0,0,24-24V56A24.1,24.1,0,0,0,184,32ZM151.4,135l-16,40a7.9,7.9,0,0,1-7.4,5,8,8,0,0,1-3-.6,7.9,7.9,0,0,1-4.4-10.4l11.6-29H112a7.9,7.9,0,0,1-6.6-3.5,8,8,0,0,1-.8-7.5l16-40a8,8,0,1,1,14.8,6l-11.6,29H144a7.9,7.9,0,0,1,6.6,3.5A8,8,0,0,1,151.4,135Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 172 144 132 112 132 128 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d$ = [];
/* style */

const __vue_inject_styles__$d$ = undefined;
/* scoped */

const __vue_scope_id__$d$ = undefined;
/* module identifier */

const __vue_module_identifier__$d$ = undefined;
/* functional template */

const __vue_is_functional_template__$d$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d$,
  staticRenderFns: __vue_staticRenderFns__$d$
}, __vue_inject_styles__$d$, __vue_script__$d$, __vue_scope_id__$d$, __vue_is_functional_template__$d$, __vue_module_identifier__$d$, false, undefined, undefined, undefined);

var script$d_ = Vue.extend({
  name: "PhBatteryEmpty",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d_ = script$d_;
/* template */

var __vue_render__$d_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d_ = [];
/* style */

const __vue_inject_styles__$d_ = undefined;
/* scoped */

const __vue_scope_id__$d_ = undefined;
/* module identifier */

const __vue_module_identifier__$d_ = undefined;
/* functional template */

const __vue_is_functional_template__$d_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d_,
  staticRenderFns: __vue_staticRenderFns__$d_
}, __vue_inject_styles__$d_, __vue_script__$d_, __vue_scope_id__$d_, __vue_is_functional_template__$d_, __vue_module_identifier__$d_, false, undefined, undefined, undefined);

var script$dZ = Vue.extend({
  name: "PhBatteryFull",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dZ = script$dZ;
/* template */

var __vue_render__$dZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "164",
      "x2": "136",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "164",
      "x2": "172",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168",
      "x2": "179.2",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "136",
      "height": "96",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168",
      "x2": "179.2",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168",
      "x2": "179.2",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "179.2",
      "y1": "168",
      "x2": "179.2",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dZ = [];
/* style */

const __vue_inject_styles__$dZ = undefined;
/* scoped */

const __vue_scope_id__$dZ = undefined;
/* module identifier */

const __vue_module_identifier__$dZ = undefined;
/* functional template */

const __vue_is_functional_template__$dZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dZ,
  staticRenderFns: __vue_staticRenderFns__$dZ
}, __vue_inject_styles__$dZ, __vue_script__$dZ, __vue_scope_id__$dZ, __vue_is_functional_template__$dZ, __vue_module_identifier__$dZ, false, undefined, undefined, undefined);

var script$dY = Vue.extend({
  name: "PhBatteryHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dY = script$dY;
/* template */

var __vue_render__$dY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "164",
      "x2": "136",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "142.4",
      "y1": "168",
      "x2": "142.4",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dY = [];
/* style */

const __vue_inject_styles__$dY = undefined;
/* scoped */

const __vue_scope_id__$dY = undefined;
/* module identifier */

const __vue_module_identifier__$dY = undefined;
/* functional template */

const __vue_is_functional_template__$dY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dY,
  staticRenderFns: __vue_staticRenderFns__$dY
}, __vue_inject_styles__$dY, __vue_script__$dY, __vue_scope_id__$dY, __vue_is_functional_template__$dY, __vue_module_identifier__$dY, false, undefined, undefined, undefined);

var script$dX = Vue.extend({
  name: "PhBatteryLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dX = script$dX;
/* template */

var __vue_render__$dX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "32",
      "height": "96",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dX = [];
/* style */

const __vue_inject_styles__$dX = undefined;
/* scoped */

const __vue_scope_id__$dX = undefined;
/* module identifier */

const __vue_module_identifier__$dX = undefined;
/* functional template */

const __vue_is_functional_template__$dX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dX,
  staticRenderFns: __vue_staticRenderFns__$dX
}, __vue_inject_styles__$dX, __vue_script__$dX, __vue_scope_id__$dX, __vue_is_functional_template__$dX, __vue_module_identifier__$dX, false, undefined, undefined, undefined);

var script$dW = Vue.extend({
  name: "PhBatteryMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dW = script$dW;
/* template */

var __vue_render__$dW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "64",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "164",
      "x2": "100",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "80",
      "width": "72",
      "height": "96",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "105.6",
      "y1": "168",
      "x2": "105.6",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "168",
      "x2": "68.8",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dW = [];
/* style */

const __vue_inject_styles__$dW = undefined;
/* scoped */

const __vue_scope_id__$dW = undefined;
/* module identifier */

const __vue_module_identifier__$dW = undefined;
/* functional template */

const __vue_is_functional_template__$dW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dW,
  staticRenderFns: __vue_staticRenderFns__$dW
}, __vue_inject_styles__$dW, __vue_script__$dW, __vue_scope_id__$dW, __vue_is_functional_template__$dW, __vue_module_identifier__$dW, false, undefined, undefined, undefined);

var script$dV = Vue.extend({
  name: "PhBatteryPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dV = script$dV;
/* template */

var __vue_render__$dV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "104",
      "x2": "124",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "104",
      "x2": "124",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0ZM224,72V184a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V72A24.1,24.1,0,0,1,48,48H200A24.1,24.1,0,0,1,224,72Zm-68,56a8,8,0,0,0-8-8H132V104a8,8,0,0,0-16,0v16H100a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V136h16A8,8,0,0,0,156,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "104",
      "x2": "124",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "104",
      "x2": "124",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "104",
      "x2": "124",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dV = [];
/* style */

const __vue_inject_styles__$dV = undefined;
/* scoped */

const __vue_scope_id__$dV = undefined;
/* module identifier */

const __vue_module_identifier__$dV = undefined;
/* functional template */

const __vue_is_functional_template__$dV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dV,
  staticRenderFns: __vue_staticRenderFns__$dV
}, __vue_inject_styles__$dV, __vue_script__$dV, __vue_scope_id__$dV, __vue_is_functional_template__$dV, __vue_module_identifier__$dV, false, undefined, undefined, undefined);

var script$dU = Vue.extend({
  name: "PhBatteryWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dU = script$dU;
/* template */

var __vue_render__$dU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "38",
      "width": "144",
      "height": "180",
      "rx": "16",
      "transform": "translate(246 10) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "244",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "92",
      "x2": "116",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "160",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0ZM224,72V184a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V72A24.1,24.1,0,0,1,48,48H200A24.1,24.1,0,0,1,224,72ZM116,128a8,8,0,0,0,16,0V88a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12,12,0,0,0,136,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "124",
      "y1": "88",
      "x2": "124",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "248",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "36",
      "width": "144",
      "height": "184",
      "rx": "16",
      "transform": "translate(252 4) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dU = [];
/* style */

const __vue_inject_styles__$dU = undefined;
/* scoped */

const __vue_scope_id__$dU = undefined;
/* module identifier */

const __vue_module_identifier__$dU = undefined;
/* functional template */

const __vue_is_functional_template__$dU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dU,
  staticRenderFns: __vue_staticRenderFns__$dU
}, __vue_inject_styles__$dU, __vue_script__$dU, __vue_scope_id__$dU, __vue_is_functional_template__$dU, __vue_module_identifier__$dU, false, undefined, undefined, undefined);

var script$dT = Vue.extend({
  name: "PhBatteryWarningVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dT = script$dT;
/* template */

var __vue_render__$dT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "100",
      "y1": "12",
      "x2": "156",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "180",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,8a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,8ZM208,56V208a24.1,24.1,0,0,1-24,24H72a24.1,24.1,0,0,1-24-24V56A24.1,24.1,0,0,1,72,32H184A24.1,24.1,0,0,1,208,56Zm-88,76a8,8,0,0,0,16,0V92a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12,12,0,0,0,140,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "8",
      "x2": "160",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "40",
      "width": "144",
      "height": "184",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dT = [];
/* style */

const __vue_inject_styles__$dT = undefined;
/* scoped */

const __vue_scope_id__$dT = undefined;
/* module identifier */

const __vue_module_identifier__$dT = undefined;
/* functional template */

const __vue_is_functional_template__$dT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dT,
  staticRenderFns: __vue_staticRenderFns__$dT
}, __vue_inject_styles__$dT, __vue_script__$dT, __vue_scope_id__$dT, __vue_is_functional_template__$dT, __vue_module_identifier__$dT, false, undefined, undefined, undefined);

var script$dS = Vue.extend({
  name: "PhBed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dS = script$dS;
/* template */

var __vue_render__$dS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,80H208a32,32,0,0,1,32,32v56a0,0,0,0,1,0,0H104a0,0,0,0,1,0,0V80A0,0,0,0,1,104,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,72H24V48A8,8,0,0,0,8,48V208a8,8,0,0,0,16,0V176H232v32a8,8,0,0,0,16,0V112A40,40,0,0,0,208,72ZM24,88H96v72H24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168V80H208a32,32,0,0,1,32,32v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "208",
      "x2": "16",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 168 240 168 240 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "80",
      "x2": "16",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dS = [];
/* style */

const __vue_inject_styles__$dS = undefined;
/* scoped */

const __vue_scope_id__$dS = undefined;
/* module identifier */

const __vue_module_identifier__$dS = undefined;
/* functional template */

const __vue_is_functional_template__$dS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dS,
  staticRenderFns: __vue_staticRenderFns__$dS
}, __vue_inject_styles__$dS, __vue_script__$dS, __vue_scope_id__$dS, __vue_is_functional_template__$dS, __vue_module_identifier__$dS, false, undefined, undefined, undefined);

var script$dR = Vue.extend({
  name: "PhBeerBottle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dR = script$dR;
/* template */

var __vue_render__$dR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "208",
      "y1": "16",
      "x2": "240",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "212",
      "x2": "44",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "60.4",
      "y": "110.7",
      "width": "79.2",
      "height": "90.51",
      "transform": "translate(-81 116.4) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "16",
      "x2": "240",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "40",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.7,42.3l-32-32a8.1,8.1,0,0,0-11.4,11.4l1.5,1.4L148.7,64.5l-38.3,7.7a8.5,8.5,0,0,0-4.1,2.1l-16,16h0l-56,56h0L21.7,159a23.9,23.9,0,0,0,0,34L63,234.3a23.9,23.9,0,0,0,34,0l12.7-12.6h0l56-56h0l16-16a8.5,8.5,0,0,0,2.1-4.1l7.7-38.3,41.4-55.1,1.4,1.5a8.2,8.2,0,0,0,11.4,0A8.1,8.1,0,0,0,245.7,42.3ZM74.3,223,33,181.7a8,8,0,0,1,0-11.4l7-7L92.7,216l-7,7A8.1,8.1,0,0,1,74.3,223ZM177.6,99.2a8.3,8.3,0,0,0-1.4,3.2l-7.6,37.7-8.6,8.6L107.3,96l8.6-8.6,37.7-7.6a8.3,8.3,0,0,0,3.2-1.4l58.4-43.8,6.2,6.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "208",
      "y1": "16",
      "x2": "240",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "40",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "208",
      "y1": "16",
      "x2": "240",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "40",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "208",
      "y1": "16",
      "x2": "240",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "40",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dR = [];
/* style */

const __vue_inject_styles__$dR = undefined;
/* scoped */

const __vue_scope_id__$dR = undefined;
/* module identifier */

const __vue_module_identifier__$dR = undefined;
/* functional template */

const __vue_is_functional_template__$dR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dR,
  staticRenderFns: __vue_staticRenderFns__$dR
}, __vue_inject_styles__$dR, __vue_script__$dR, __vue_scope_id__$dR, __vue_is_functional_template__$dR, __vue_module_identifier__$dR, false, undefined, undefined, undefined);

var script$dQ = Vue.extend({
  name: "PhBehanceLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dQ = script$dQ;
/* template */

var __vue_render__$dQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "76",
      "x2": "232",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28,124H90a34,34,0,0,1,0,68H28V64H78a30,30,0,0,1,0,60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152h80a40,40,0,1,0-40,40,39.5,39.5,0,0,0,17.5-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H168A8,8,0,0,1,160,80Zm88,72a8,8,0,0,1-8,8H169a32.1,32.1,0,0,0,31,24,31.5,31.5,0,0,0,22.6-9.4,8,8,0,0,1,11.3,0,7.9,7.9,0,0,1,0,11.3A47.4,47.4,0,0,1,200,200a48,48,0,1,1,48-48Zm-17-8a32,32,0,0,0-62,0Zm-91,14a42,42,0,0,1-42,42H32a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H86a38,38,0,0,1,28.3,63.3A42,42,0,0,1,140,158ZM40,116H86a22,22,0,0,0,0-44H40Zm84,42a26.1,26.1,0,0,0-26-26H40v52H98A26.1,26.1,0,0,0,124,158Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dQ = [];
/* style */

const __vue_inject_styles__$dQ = undefined;
/* scoped */

const __vue_scope_id__$dQ = undefined;
/* module identifier */

const __vue_module_identifier__$dQ = undefined;
/* functional template */

const __vue_is_functional_template__$dQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dQ,
  staticRenderFns: __vue_staticRenderFns__$dQ
}, __vue_inject_styles__$dQ, __vue_script__$dQ, __vue_scope_id__$dQ, __vue_is_functional_template__$dQ, __vue_module_identifier__$dQ, false, undefined, undefined, undefined);

var script$dP = Vue.extend({
  name: "PhBell",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dP = script$dP;
/* template */

var __vue_render__$dP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.8,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.5-80.6-79.2-80.9H128a79.9,79.9,0,0,0-79.8,80v8c0,34.3-7.1,53.7-13,63.9A16,16,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8A16.2,16.2,0,0,0,220.8,175.9ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dP = [];
/* style */

const __vue_inject_styles__$dP = undefined;
/* scoped */

const __vue_scope_id__$dP = undefined;
/* module identifier */

const __vue_module_identifier__$dP = undefined;
/* functional template */

const __vue_is_functional_template__$dP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dP,
  staticRenderFns: __vue_staticRenderFns__$dP
}, __vue_inject_styles__$dP, __vue_script__$dP, __vue_scope_id__$dP, __vue_is_functional_template__$dP, __vue_module_identifier__$dP, false, undefined, undefined, undefined);

var script$dO = Vue.extend({
  name: "PhBellRinging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dO = script$dO;
/* template */

var __vue_render__$dO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.7,17.2a111.1,111.1,0,0,1,40.8,45.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.5,62.6A111.1,111.1,0,0,1,68.3,17.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.8,112a79.7,79.7,0,0,0-79.2-80H128a79.9,79.9,0,0,0-79.8,80c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8,16.2,16.2,0,0,0-.1-16.1C214.9,165.7,207.8,146.3,207.8,112ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224ZM224.9,73.3a9.3,9.3,0,0,1-3.5.8,7.9,7.9,0,0,1-7.2-4.5,97,97,0,0,0-35-38.8,8,8,0,0,1,8.5-13.6,111.7,111.7,0,0,1,40.8,45.4A8,8,0,0,1,224.9,73.3Zm-190.3.8a9.3,9.3,0,0,1-3.5-.8,8,8,0,0,1-3.6-10.7A111.7,111.7,0,0,1,68.3,17.2a8,8,0,0,1,8.5,13.6,97,97,0,0,0-35,38.8A7.9,7.9,0,0,1,34.6,74.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dO = [];
/* style */

const __vue_inject_styles__$dO = undefined;
/* scoped */

const __vue_scope_id__$dO = undefined;
/* module identifier */

const __vue_module_identifier__$dO = undefined;
/* functional template */

const __vue_is_functional_template__$dO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dO,
  staticRenderFns: __vue_staticRenderFns__$dO
}, __vue_inject_styles__$dO, __vue_script__$dO, __vue_scope_id__$dO, __vue_is_functional_template__$dO, __vue_module_identifier__$dO, false, undefined, undefined, undefined);

var script$dN = Vue.extend({
  name: "PhBellSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dN = script$dN;
/* template */

var __vue_render__$dN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V108c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,104a72,72,0,0,1,72.5-72c39.8.3,71.5,33.2,71.5,72.9V112c0,35.8,7.5,56.6,14.1,68a7.9,7.9,0,0,1-6.9,12H48.8a7.9,7.9,0,0,1-6.9-12C48.5,168.6,56,147.8,56,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.6-80.6-79.4-80.9H128a79.9,79.9,0,0,0-80,80v8c0,34.3-7.1,53.7-13,63.9a15.8,15.8,0,0,0-.1,16.1,15.9,15.9,0,0,0,13.9,8H207.2a15.9,15.9,0,0,0,13.9-8A15.8,15.8,0,0,0,221,175.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.9,216h-64a8,8,0,1,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "224",
      "x2": "159.9",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dN = [];
/* style */

const __vue_inject_styles__$dN = undefined;
/* scoped */

const __vue_scope_id__$dN = undefined;
/* module identifier */

const __vue_module_identifier__$dN = undefined;
/* functional template */

const __vue_is_functional_template__$dN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dN,
  staticRenderFns: __vue_staticRenderFns__$dN
}, __vue_inject_styles__$dN, __vue_script__$dN, __vue_scope_id__$dN, __vue_is_functional_template__$dN, __vue_module_identifier__$dN, false, undefined, undefined, undefined);

var script$dM = Vue.extend({
  name: "PhBellSimpleRinging",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dM = script$dM;
/* template */

var __vue_render__$dM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,52.6,14.1,64a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-28.2,14.1-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.7,17.2a111.1,111.1,0,0,1,40.8,45.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.5,62.6A111.1,111.1,0,0,1,68.3,17.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224Zm39.8-112a79.7,79.7,0,0,0-79.2-80H128a79.9,79.9,0,0,0-79.8,80c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H207a15.9,15.9,0,0,0,13.9-8,16.2,16.2,0,0,0-.1-16.1C214.9,165.7,207.8,146.3,207.8,112Zm20.7-49.4a111.7,111.7,0,0,0-40.8-45.4,8,8,0,0,0-8.5,13.6,97,97,0,0,1,35,38.8,7.9,7.9,0,0,0,7.2,4.5,9.3,9.3,0,0,0,3.5-.8A8,8,0,0,0,228.5,62.6Zm-186.7,7a97,97,0,0,1,35-38.8,8,8,0,0,0-8.5-13.6A111.7,111.7,0,0,0,27.5,62.6a8,8,0,0,0,3.6,10.7,9.3,9.3,0,0,0,3.5.8A7.9,7.9,0,0,0,41.8,69.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "224",
      "x2": "159.9",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.4,24a105,105,0,0,1,38,42.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.6,66.1A105,105,0,0,1,72.6,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dM = [];
/* style */

const __vue_inject_styles__$dM = undefined;
/* scoped */

const __vue_scope_id__$dM = undefined;
/* module identifier */

const __vue_module_identifier__$dM = undefined;
/* functional template */

const __vue_is_functional_template__$dM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dM,
  staticRenderFns: __vue_staticRenderFns__$dM
}, __vue_inject_styles__$dM, __vue_script__$dM, __vue_scope_id__$dM, __vue_is_functional_template__$dM, __vue_module_identifier__$dM, false, undefined, undefined, undefined);

var script$dL = Vue.extend({
  name: "PhBellSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dL = script$dL;
/* template */

var __vue_render__$dL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.5,188H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-4A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,37.7A69.4,69.4,0,0,1,128.5,32c39.6.3,71.3,33.2,71.3,72.9V108c0,19,2.1,33.7,5.1,45.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,104a72,72,0,0,1,72.5-72c39.8.3,71.5,33.2,71.5,72.9V112c0,35.8,7.5,56.6,14.1,68a7.9,7.9,0,0,1-6.9,12H48.8a7.9,7.9,0,0,1-6.9-12C48.5,168.6,56,147.8,56,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A71.8,71.8,0,0,1,68.9,63.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6L182.6,200H49a16,16,0,0,1-13.8-24.1c5.9-10.2,13-29.6,13-63.9v-8A80.2,80.2,0,0,1,58.9,63.9L42.1,45.4A8,8,0,0,1,53.9,34.6ZM160,216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm42.9-41.3a8,8,0,0,0,5.9,2.6,7.9,7.9,0,0,0,4.2-1.2,8,8,0,0,0,3.3-9.7c-5.6-14.2-8.5-32.6-8.5-54.4v-7.1c0-44.3-35.5-80.6-79.2-80.9A80.2,80.2,0,0,0,88.5,34.4a8,8,0,0,0-3.9,5.7,8.2,8.2,0,0,0,2,6.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dL = [];
/* style */

const __vue_inject_styles__$dL = undefined;
/* scoped */

const __vue_scope_id__$dL = undefined;
/* module identifier */

const __vue_module_identifier__$dL = undefined;
/* functional template */

const __vue_is_functional_template__$dL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dL,
  staticRenderFns: __vue_staticRenderFns__$dL
}, __vue_inject_styles__$dL, __vue_script__$dL, __vue_scope_id__$dL, __vue_is_functional_template__$dL, __vue_module_identifier__$dL, false, undefined, undefined, undefined);

var script$dK = Vue.extend({
  name: "PhBellSimpleZ",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dK = script$dK;
/* template */

var __vue_render__$dK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "228",
      "x2": "160",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V108c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224Zm52.9-32a15.9,15.9,0,0,1-13.9,8H49a15.9,15.9,0,0,1-13.9-8,16.2,16.2,0,0,1,.1-16.1c5.9-10.2,13-29.6,13-63.9v-8A79.9,79.9,0,0,1,128,24h.6c43.7.3,79.2,36.6,79.2,80.9V112c0,34.3,7.1,53.7,13,63.9A16.2,16.2,0,0,1,220.9,192ZM156,144a8,8,0,0,0-8-8H125.1l29-34.9a7.8,7.8,0,0,0,1.1-8.5A7.9,7.9,0,0,0,148,88H108a8,8,0,0,0,0,16h22.9l-29,34.9a7.8,7.8,0,0,0-1.1,8.5A7.9,7.9,0,0,0,108,152h40A8,8,0,0,0,156,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dK = [];
/* style */

const __vue_inject_styles__$dK = undefined;
/* scoped */

const __vue_scope_id__$dK = undefined;
/* module identifier */

const __vue_module_identifier__$dK = undefined;
/* functional template */

const __vue_is_functional_template__$dK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dK,
  staticRenderFns: __vue_staticRenderFns__$dK
}, __vue_inject_styles__$dK, __vue_script__$dK, __vue_scope_id__$dK, __vue_is_functional_template__$dK, __vue_module_identifier__$dK, false, undefined, undefined, undefined);

var script$dJ = Vue.extend({
  name: "PhBellSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dJ = script$dJ;
/* template */

var __vue_render__$dJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,37.7A71.1,71.1,0,0,1,128.5,32c39.6.3,71.3,33.2,71.3,72.9V112a187.1,187.1,0,0,0,3.8,39.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.8,71.8,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,67.9A8,8,0,0,1,207,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L58.9,63.9A80.2,80.2,0,0,0,48.2,104v8c0,34.3-7.1,53.7-13,63.9A16,16,0,0,0,49,200H88a40,40,0,0,0,80,0h14.6l19.5,21.4A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224ZM86.6,46.8a8.1,8.1,0,0,1,1.9-12.4A80.2,80.2,0,0,1,128.6,24c43.7.3,79.2,36.6,79.2,80.9V112c0,21.9,2.8,40.1,8.4,54.4a8,8,0,0,1-13.3,8.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dJ = [];
/* style */

const __vue_inject_styles__$dJ = undefined;
/* scoped */

const __vue_scope_id__$dJ = undefined;
/* module identifier */

const __vue_module_identifier__$dJ = undefined;
/* functional template */

const __vue_is_functional_template__$dJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dJ,
  staticRenderFns: __vue_staticRenderFns__$dJ
}, __vue_inject_styles__$dJ, __vue_script__$dJ, __vue_scope_id__$dJ, __vue_is_functional_template__$dJ, __vue_module_identifier__$dJ, false, undefined, undefined, undefined);

var script$dI = Vue.extend({
  name: "PhBellZ",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dI = script$dI;
/* template */

var __vue_render__$dI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.8,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.5-80.6-79.2-80.9H128a79.9,79.9,0,0,0-79.8,80v8c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8A16.2,16.2,0,0,0,220.8,175.9ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224Zm20-72H108a7.9,7.9,0,0,1-7.2-4.6,7.8,7.8,0,0,1,1.1-8.5l29-34.9H108a8,8,0,0,1,0-16h40a7.9,7.9,0,0,1,7.2,4.6,7.8,7.8,0,0,1-1.1,8.5l-29,34.9H148a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,192v8a32,32,0,0,0,64,0v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 96 148 96 108 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dI = [];
/* style */

const __vue_inject_styles__$dI = undefined;
/* scoped */

const __vue_scope_id__$dI = undefined;
/* module identifier */

const __vue_module_identifier__$dI = undefined;
/* functional template */

const __vue_is_functional_template__$dI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dI,
  staticRenderFns: __vue_staticRenderFns__$dI
}, __vue_inject_styles__$dI, __vue_script__$dI, __vue_scope_id__$dI, __vue_is_functional_template__$dI, __vue_module_identifier__$dI, false, undefined, undefined, undefined);

var script$dH = Vue.extend({
  name: "PhBezierCurve",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dH = script$dH;
/* template */

var __vue_render__$dH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "80",
      "x2": "104",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "80",
      "x2": "104",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221,144.4A95.9,95.9,0,0,0,181,88h59a8,8,0,0,0,0-16H159a32,32,0,0,0-62,0H16a8,8,0,0,0,0,16H75a95.9,95.9,0,0,0-40,56.4A32,32,0,1,0,71,184H185a32,32,0,1,0,36-39.6ZM40,192a16,16,0,1,1,16-16A16,16,0,0,1,40,192ZM128,64a16,16,0,1,1-16,16A16,16,0,0,1,128,64Zm88,128a16,16,0,1,1,16-16A16,16,0,0,1,216,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "80",
      "x2": "104",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "80",
      "x2": "104",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "80",
      "x2": "104",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "176",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dH = [];
/* style */

const __vue_inject_styles__$dH = undefined;
/* scoped */

const __vue_scope_id__$dH = undefined;
/* module identifier */

const __vue_module_identifier__$dH = undefined;
/* functional template */

const __vue_is_functional_template__$dH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dH,
  staticRenderFns: __vue_staticRenderFns__$dH
}, __vue_inject_styles__$dH, __vue_script__$dH, __vue_scope_id__$dH, __vue_is_functional_template__$dH, __vue_module_identifier__$dH, false, undefined, undefined, undefined);

var script$dG = Vue.extend({
  name: "PhBicycle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dG = script$dG;
/* template */

var __vue_render__$dG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H148l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "204",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "166.7 96 102.7 96 52 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "52 64 84 64 128.3 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.1 96 94.7 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,160a48,48,0,1,1-78.7-36.8L201.1,164a8,8,0,1,0,13.8-8l-23.8-40.9A47,47,0,0,1,208,112,48,48,0,0,1,256,160ZM48,168a8.2,8.2,0,0,1-4.7-1.5,8,8,0,0,1-1.8-11.2l27.9-38.2A46.6,46.6,0,0,0,48,112a48.1,48.1,0,1,0,34.3,14.5L54.5,164.7A7.9,7.9,0,0,1,48,168ZM165.9,72H192a8,8,0,0,1,8,8,8,8,0,0,0,16,0,24.1,24.1,0,0,0-24-24H152a7.8,7.8,0,0,0-6.9,4,7.7,7.7,0,0,0,0,8l11.6,20H99.3L82.9,60A7.9,7.9,0,0,0,76,56H48a8,8,0,0,0,0,16H71.4L85.1,95.5,69.4,117.1a48.1,48.1,0,0,1,12.9,9.4l11.6-15.9L125.1,164a8,8,0,1,0,13.8-8l-30.3-52h57.5l11.2,19.2a46.5,46.5,0,0,1,13.8-8.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.1 96 94.7 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.1 96 94.7 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a16,16,0,0,0-16-16H152l56,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "160",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 64 76 64 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "170.1 96 94.7 96 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dG = [];
/* style */

const __vue_inject_styles__$dG = undefined;
/* scoped */

const __vue_scope_id__$dG = undefined;
/* module identifier */

const __vue_module_identifier__$dG = undefined;
/* functional template */

const __vue_is_functional_template__$dG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dG,
  staticRenderFns: __vue_staticRenderFns__$dG
}, __vue_inject_styles__$dG, __vue_script__$dG, __vue_scope_id__$dG, __vue_is_functional_template__$dG, __vue_module_identifier__$dG, false, undefined, undefined, undefined);

var script$dF = Vue.extend({
  name: "PhBinoculars",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dF = script$dF;
/* template */

var __vue_render__$dF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "92",
      "x2": "152",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "92",
      "x2": "152",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.2,151.9h0c0-.1-.1-.1-.1-.2a42.3,42.3,0,0,0-2.3-5.3L193.3,51.8a8.1,8.1,0,0,0-1.7-2.4,32,32,0,0,0-45.3,0A7.9,7.9,0,0,0,144,55V84H112V55a7.9,7.9,0,0,0-2.3-5.6,32,32,0,0,0-45.3,0,8.1,8.1,0,0,0-1.7,2.4L21.2,146.3a42.3,42.3,0,0,0-2.3,5.3c0,.1-.1.1-.1.2h0A48,48,0,1,0,112,167.8V100h32v67.8a48,48,0,1,0,93.2-15.9Zm-143.1,27a32,32,0,0,1-60.2-21.7l1.8-4.1A32,32,0,0,1,96,167.9h0A32.1,32.1,0,0,1,94.1,178.9Zm108.8,19.2A32,32,0,0,1,160,168h0a32,32,0,0,1,60.3-14.8l1.8,4.1A32,32,0,0,1,202.9,198.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "92",
      "x2": "152",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "92",
      "x2": "152",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "92",
      "x2": "152",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "168",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dF = [];
/* style */

const __vue_inject_styles__$dF = undefined;
/* scoped */

const __vue_scope_id__$dF = undefined;
/* module identifier */

const __vue_module_identifier__$dF = undefined;
/* functional template */

const __vue_is_functional_template__$dF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dF,
  staticRenderFns: __vue_staticRenderFns__$dF
}, __vue_inject_styles__$dF, __vue_script__$dF, __vue_scope_id__$dF, __vue_is_functional_template__$dF, __vue_module_identifier__$dF, false, undefined, undefined, undefined);

var script$dE = Vue.extend({
  name: "PhBird",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dE = script$dE;
/* template */

var __vue_render__$dE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "160",
      "cy": "72",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H12L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.7",
      "y1": "176",
      "x2": "121.3",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.4,73.3,213.2,57.9A60,60,0,0,0,96,76V93.2L1.8,211A8,8,0,0,0,8,224H112A104.2,104.2,0,0,0,216,120V100.3l20.4-13.6a8,8,0,0,0,0-13.4ZM110.1,141.1l-40,48a8,8,0,0,1-12.2-10.2l40-48a8,8,0,1,1,12.2,10.2ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "68",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "136",
      "x2": "80",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dE = [];
/* style */

const __vue_inject_styles__$dE = undefined;
/* scoped */

const __vue_scope_id__$dE = undefined;
/* module identifier */

const __vue_module_identifier__$dE = undefined;
/* functional template */

const __vue_is_functional_template__$dE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dE,
  staticRenderFns: __vue_staticRenderFns__$dE
}, __vue_inject_styles__$dE, __vue_script__$dE, __vue_scope_id__$dE, __vue_is_functional_template__$dE, __vue_module_identifier__$dE, false, undefined, undefined, undefined);

var script$dD = Vue.extend({
  name: "PhBluetooth",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dD = script$dD;
/* template */

var __vue_render__$dD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,169.6,133.3,128l55.5-41.6a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32v80L60.8,73.6a8.1,8.1,0,0,0-11.2,1.6,8,8,0,0,0,1.6,11.2L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,48l42.7,32L128,112Zm0,160V144l42.7,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dD = [];
/* style */

const __vue_inject_styles__$dD = undefined;
/* scoped */

const __vue_scope_id__$dD = undefined;
/* module identifier */

const __vue_module_identifier__$dD = undefined;
/* functional template */

const __vue_is_functional_template__$dD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dD,
  staticRenderFns: __vue_staticRenderFns__$dD
}, __vue_inject_styles__$dD, __vue_script__$dD, __vue_scope_id__$dD, __vue_is_functional_template__$dD, __vue_module_identifier__$dD, false, undefined, undefined, undefined);

var script$dC = Vue.extend({
  name: "PhBluetoothConnected",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dC = script$dC;
/* template */

var __vue_render__$dC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,169.6,133.3,128l55.5-41.6a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32v80L60.8,73.6a8,8,0,0,0-9.6,12.8L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,48l42.7,32L128,112Zm0,160V144l42.7,32Zm80-80a12,12,0,1,1-12-12A12,12,0,0,1,208,128ZM52,140a12,12,0,1,1,12-12A12,12,0,0,1,52,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dC = [];
/* style */

const __vue_inject_styles__$dC = undefined;
/* scoped */

const __vue_scope_id__$dC = undefined;
/* module identifier */

const __vue_module_identifier__$dC = undefined;
/* functional template */

const __vue_is_functional_template__$dC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dC,
  staticRenderFns: __vue_staticRenderFns__$dC
}, __vue_inject_styles__$dC, __vue_script__$dC, __vue_scope_id__$dC, __vue_is_functional_template__$dC, __vue_module_identifier__$dC, false, undefined, undefined, undefined);

var script$dB = Vue.extend({
  name: "PhBluetoothSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dB = script$dB;
/* template */

var __vue_render__$dB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.6 181.5 120 224 120 119.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 59.7 120 32 184 80 156.9 100.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 71.6 120 32 184 80 150.5 105.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.7 181.5 120 224 120 128 145.2 146.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.9,210.6l-31.4-34.5h0l-31.3-34.5h-.1L53.9,34.6A8,8,0,0,0,42.1,45.4l70.8,77.9L51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9,9,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l50.8-38.1,26.5,29.1A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1A7.9,7.9,0,0,0,213.9,210.6ZM128,208V144l11.8,8.8,25,27.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,79.6a8,8,0,0,0,8-8V48l42.7,32-25,18.7a7.9,7.9,0,0,0-1.6,11.2,7.8,7.8,0,0,0,6.4,3.2,8.1,8.1,0,0,0,4.8-1.6l33.5-25.1a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32V71.6A8,8,0,0,0,120,79.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 71.6 120 32 184 80 150.5 105.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.6 181.5 120 224 120 128 145.2 146.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 71.6 120 32 184 80 150.5 105.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.6 181.5 120 224 120 128 145.2 146.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 71.6 120 32 184 80 150.5 105.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176.6 181.5 120 224 120 128 145.2 146.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dB = [];
/* style */

const __vue_inject_styles__$dB = undefined;
/* scoped */

const __vue_scope_id__$dB = undefined;
/* module identifier */

const __vue_module_identifier__$dB = undefined;
/* functional template */

const __vue_is_functional_template__$dB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dB,
  staticRenderFns: __vue_staticRenderFns__$dB
}, __vue_inject_styles__$dB, __vue_script__$dB, __vue_scope_id__$dB, __vue_is_functional_template__$dB, __vue_module_identifier__$dB, false, undefined, undefined, undefined);

var script$dA = Vue.extend({
  name: "PhBluetoothX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dA = script$dA;
/* template */

var __vue_render__$dA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144.4 109.7 120 128 120 32 144.4 50.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 32 184 80 120 128 120 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104 120 128 120 32 152 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,169.6,133.3,128l23.5-17.6a8,8,0,0,0,1.6-11.2,8.1,8.1,0,0,0-11.2-1.6L128,112V48l19.2,14.4a8,8,0,0,0,11.2-1.6,8.1,8.1,0,0,0-1.6-11.2l-32-24A8,8,0,0,0,112,32v80L60.8,73.6a8.1,8.1,0,0,0-11.2,1.6,8,8,0,0,0,1.6,11.2L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,208V144l42.7,32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.3,80l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L208,68.7,189.7,50.3a8.1,8.1,0,0,0-11.4,11.4L196.7,80,178.3,98.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L208,91.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104 120 128 120 32 152 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104 120 128 120 32 152 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 128 184 176 120 224 120 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "80",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "56",
      "x2": "184",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "104",
      "x2": "184",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 104 120 128 120 32 152 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dA = [];
/* style */

const __vue_inject_styles__$dA = undefined;
/* scoped */

const __vue_scope_id__$dA = undefined;
/* module identifier */

const __vue_module_identifier__$dA = undefined;
/* functional template */

const __vue_is_functional_template__$dA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dA,
  staticRenderFns: __vue_staticRenderFns__$dA
}, __vue_inject_styles__$dA, __vue_script__$dA, __vue_scope_id__$dA, __vue_is_functional_template__$dA, __vue_module_identifier__$dA, false, undefined, undefined, undefined);

var script$dz = Vue.extend({
  name: "PhBoat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dz = script$dz;
/* template */

var __vue_render__$dz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.1,110.6,208,106.2V56a16,16,0,0,0-16-16H136V24a8,8,0,0,0-16,0V40H64A16,16,0,0,0,48,56v50.2l-13.1,4.4A16,16,0,0,0,24,125.8V160a8.3,8.3,0,0,0,.3,2.2c15.7,55,86.1,74,100.1,77.2a16.4,16.4,0,0,0,7.2,0c14-3.2,84.4-22.2,100.1-77.2a8.3,8.3,0,0,0,.3-2.2V125.8A16,16,0,0,0,221.1,110.6ZM136,168a8,8,0,0,1-16,0V112.4a8,8,0,0,1,16,0Zm56-67.1L133.1,81.3a16.2,16.2,0,0,0-10.2,0L64,100.9V56H192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dz = [];
/* style */

const __vue_inject_styles__$dz = undefined;
/* scoped */

const __vue_scope_id__$dz = undefined;
/* module identifier */

const __vue_module_identifier__$dz = undefined;
/* functional template */

const __vue_is_functional_template__$dz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dz,
  staticRenderFns: __vue_staticRenderFns__$dz
}, __vue_inject_styles__$dz, __vue_script__$dz, __vue_scope_id__$dz, __vue_is_functional_template__$dz, __vue_module_identifier__$dz, false, undefined, undefined, undefined);

var script$dy = Vue.extend({
  name: "PhBook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dy = script$dy;
/* template */

var __vue_render__$dy = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,208a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 208 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32V192a8,8,0,0,1-8,8H72a16,16,0,0,0-16,16H192a8,8,0,0,1,0,16H48a8,8,0,0,1-8-8V56A32.1,32.1,0,0,1,72,24H208A8,8,0,0,1,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dy = [];
/* style */

const __vue_inject_styles__$dy = undefined;
/* scoped */

const __vue_scope_id__$dy = undefined;
/* module identifier */

const __vue_module_identifier__$dy = undefined;
/* functional template */

const __vue_is_functional_template__$dy = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dy = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dy,
  staticRenderFns: __vue_staticRenderFns__$dy
}, __vue_inject_styles__$dy, __vue_script__$dy, __vue_scope_id__$dy, __vue_is_functional_template__$dy, __vue_module_identifier__$dy, false, undefined, undefined, undefined);

var script$dx = Vue.extend({
  name: "PhBookBookmark",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dx = script$dx;
/* template */

var __vue_render__$dx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 32 172 128 140 104 108 128 108 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,208a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 208 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32v96l-32-24-32,24V32H72A23.9,23.9,0,0,0,48,56V216a23.9,23.9,0,0,1,24-24H208V32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 32 176 128 144 104 112 128 112 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,24H72A32.1,32.1,0,0,0,40,56V224a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16H56a16,16,0,0,1,16-16H208a8,8,0,0,0,8-8V32A8,8,0,0,0,208,24Zm-24,96-25.6-19.2a3.9,3.9,0,0,0-4.8,0L128,120V40h56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 32 176 128 144 104 112 128 112 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 32 176 128 144 104 112 128 112 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 32 176 128 144 104 112 128 112 32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 216 48 224 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dx = [];
/* style */

const __vue_inject_styles__$dx = undefined;
/* scoped */

const __vue_scope_id__$dx = undefined;
/* module identifier */

const __vue_module_identifier__$dx = undefined;
/* functional template */

const __vue_is_functional_template__$dx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dx,
  staticRenderFns: __vue_staticRenderFns__$dx
}, __vue_inject_styles__$dx, __vue_script__$dx, __vue_scope_id__$dx, __vue_is_functional_template__$dx, __vue_module_identifier__$dx, false, undefined, undefined, undefined);

var script$dw = Vue.extend({
  name: "PhBookOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dw = script$dw;
/* template */

var __vue_render__$dw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,56H160a32,32,0,0,0-32,32A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32,32,32,0,0,1,32-32h64a8,8,0,0,0,8-8V64A8,8,0,0,0,224,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208a24.1,24.1,0,0,1,24,24,8,8,0,0,0,16,0,24.1,24.1,0,0,1,24-24h64a16,16,0,0,0,16-16V64a16,16,0,0,0-16-16H176a40,40,0,0,0-40,40v80a8,8,0,0,1-16,0V88A40,40,0,0,0,80,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dw = [];
/* style */

const __vue_inject_styles__$dw = undefined;
/* scoped */

const __vue_scope_id__$dw = undefined;
/* module identifier */

const __vue_module_identifier__$dw = undefined;
/* functional template */

const __vue_is_functional_template__$dw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dw,
  staticRenderFns: __vue_staticRenderFns__$dw
}, __vue_inject_styles__$dw, __vue_script__$dw, __vue_scope_id__$dw, __vue_is_functional_template__$dw, __vue_module_identifier__$dw, false, undefined, undefined, undefined);

var script$dv = Vue.extend({
  name: "PhBookmark",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dv = script$dv;
/* template */

var __vue_render__$dv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 128 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "192 176 128 136 64 176 64 224 128 184 192 224 192 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 128 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,32H72A16,16,0,0,0,56,48V224a8.1,8.1,0,0,0,4.1,7,7.6,7.6,0,0,0,3.9,1,7.9,7.9,0,0,0,4.2-1.2L128,193.4l59.7,37.4a8.3,8.3,0,0,0,8.2.2,8.1,8.1,0,0,0,4.1-7V48A16,16,0,0,0,184,32ZM132.2,177.2A8.1,8.1,0,0,0,128,176a8.2,8.2,0,0,0-4.3,1.2L72,209.6V180.4l56-35,56,35v29.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 128 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 128 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 176 128 136 64 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dv = [];
/* style */

const __vue_inject_styles__$dv = undefined;
/* scoped */

const __vue_scope_id__$dv = undefined;
/* module identifier */

const __vue_module_identifier__$dv = undefined;
/* functional template */

const __vue_is_functional_template__$dv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dv,
  staticRenderFns: __vue_staticRenderFns__$dv
}, __vue_inject_styles__$dv, __vue_script__$dv, __vue_scope_id__$dv, __vue_is_functional_template__$dv, __vue_module_identifier__$dv, false, undefined, undefined, undefined);

var script$du = Vue.extend({
  name: "PhBookmarkSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$du = script$du;
/* template */

var __vue_render__$du = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,32H72A16,16,0,0,0,56,48V224a8.1,8.1,0,0,0,4.1,7,7.6,7.6,0,0,0,3.9,1,7.9,7.9,0,0,0,4.2-1.2L128,193.4l59.7,37.4a8.3,8.3,0,0,0,8.2.2,8.1,8.1,0,0,0,4.1-7V48A16,16,0,0,0,184,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$du = [];
/* style */

const __vue_inject_styles__$du = undefined;
/* scoped */

const __vue_scope_id__$du = undefined;
/* module identifier */

const __vue_module_identifier__$du = undefined;
/* functional template */

const __vue_is_functional_template__$du = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$du = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$du,
  staticRenderFns: __vue_staticRenderFns__$du
}, __vue_inject_styles__$du, __vue_script__$du, __vue_scope_id__$du, __vue_is_functional_template__$du, __vue_module_identifier__$du, false, undefined, undefined, undefined);

var script$dt = Vue.extend({
  name: "PhBookmarks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dt = script$dt;
/* template */

var __vue_render__$dt = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,224l-52-40L56,224V80a8,8,0,0,1,8-8h88a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V184l-40-30.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H96a8,8,0,0,0-8,8V64h72a8,8,0,0,1,8,8v97.1L200,192V40A8,8,0,0,0,192,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H96A16,16,0,0,0,80,40V56H64A16,16,0,0,0,48,72V224a8,8,0,0,0,8,8,8.2,8.2,0,0,0,4.7-1.5L112,193.8l51.4,36.7a7.8,7.8,0,0,0,8.3.6A8.1,8.1,0,0,0,176,224V184.7l19.4,13.8A7.7,7.7,0,0,0,200,200a8,8,0,0,0,8-8V40A16,16,0,0,0,192,24Zm0,152.5L176,165V72a16,16,0,0,0-16-16H96V40h96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dt = [];
/* style */

const __vue_inject_styles__$dt = undefined;
/* scoped */

const __vue_scope_id__$dt = undefined;
/* module identifier */

const __vue_module_identifier__$dt = undefined;
/* functional template */

const __vue_is_functional_template__$dt = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dt = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dt,
  staticRenderFns: __vue_staticRenderFns__$dt
}, __vue_inject_styles__$dt, __vue_script__$dt, __vue_scope_id__$dt, __vue_is_functional_template__$dt, __vue_module_identifier__$dt, false, undefined, undefined, undefined);

var script$ds = Vue.extend({
  name: "PhBookmarksSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ds = script$ds;
/* template */

var __vue_render__$ds = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164,228l-56-40L52,228V76a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,28H196a8,8,0,0,1,8,8V188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,32H192a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,56H64A16,16,0,0,0,48,72V224a8.1,8.1,0,0,0,4.3,7.1,8.4,8.4,0,0,0,3.7.9,8.2,8.2,0,0,0,4.7-1.5L112,193.8l51.4,36.7a7.8,7.8,0,0,0,8.3.6A8.1,8.1,0,0,0,176,224V72A16,16,0,0,0,160,56Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,24H88a8,8,0,0,0,0,16H192V192a8,8,0,0,0,16,0V40A16,16,0,0,0,192,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,32H192a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,32H192a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,32H192a8,8,0,0,1,8,8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ds = [];
/* style */

const __vue_inject_styles__$ds = undefined;
/* scoped */

const __vue_scope_id__$ds = undefined;
/* module identifier */

const __vue_module_identifier__$ds = undefined;
/* functional template */

const __vue_is_functional_template__$ds = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ds = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ds,
  staticRenderFns: __vue_staticRenderFns__$ds
}, __vue_inject_styles__$ds, __vue_script__$ds, __vue_scope_id__$ds, __vue_is_functional_template__$ds, __vue_module_identifier__$ds, false, undefined, undefined, undefined);

var script$dr = Vue.extend({
  name: "PhBooks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dr = script$dr;
/* template */

var __vue_render__$dr = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.6",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.6 51.4) rotate(-15)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.2",
      "y1": "179.2",
      "x2": "217.6",
      "y2": "166.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.4",
      "y1": "86.4",
      "x2": "192.8",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,80H88V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,176h48V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M171.2,179.2l46.4-12.5,8.3,30.9a8,8,0,0,1-5.7,9.8l-30.9,8.3a8,8,0,0,1-9.8-5.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.4,86.4,192.8,74l-8.3-30.9a8.1,8.1,0,0,0-9.8-5.7l-30.9,8.3a8.1,8.1,0,0,0-5.7,9.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.6",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.6 51.4) rotate(-15)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.2",
      "y1": "179.2",
      "x2": "217.6",
      "y2": "166.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.4",
      "y1": "86.4",
      "x2": "192.8",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M233.6,195.6,192.2,41a16,16,0,0,0-19.6-11.3L141.7,38l-1,.3A16,16,0,0,0,128,32H96a15.8,15.8,0,0,0-8,2.2A15.8,15.8,0,0,0,80,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H80a15.8,15.8,0,0,0,8-2.2,15.8,15.8,0,0,0,8,2.2h32a16,16,0,0,0,16-16V108.4l27.8,103.7A16,16,0,0,0,187.3,224a19.9,19.9,0,0,0,4.1-.5l30.9-8.3A16,16,0,0,0,233.6,195.6ZM176.7,45.2,183,68.3l-30.9,8.3-6.3-23.1ZM128,48V168H96V48ZM80,48V72H48V48Zm48,160H96V184h32v24Zm90.2-8.3L187.3,208,181,184.8l31-8.3,6.2,23.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.6",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "matrix(0.97, -0.26, 0.26, 0.97, -26.56, 51.42)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.2",
      "y1": "179.2",
      "x2": "217.6",
      "y2": "166.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.4",
      "y1": "86.4",
      "x2": "192.8",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.6",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "translate(-26.6 51.4) rotate(-15)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.2",
      "y1": "179.2",
      "x2": "217.6",
      "y2": "166.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.4",
      "y1": "86.4",
      "x2": "192.8",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "80",
      "x2": "88",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "40",
      "width": "48",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "136",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "158",
      "y": "38.6",
      "width": "48",
      "height": "176",
      "rx": "8",
      "transform": "matrix(0.97, -0.26, 0.26, 0.97, -26.56, 51.42)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.2",
      "y1": "179.2",
      "x2": "217.6",
      "y2": "166.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "146.4",
      "y1": "86.4",
      "x2": "192.8",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dr = [];
/* style */

const __vue_inject_styles__$dr = undefined;
/* scoped */

const __vue_scope_id__$dr = undefined;
/* module identifier */

const __vue_module_identifier__$dr = undefined;
/* functional template */

const __vue_is_functional_template__$dr = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dr = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dr,
  staticRenderFns: __vue_staticRenderFns__$dr
}, __vue_inject_styles__$dr, __vue_script__$dr, __vue_scope_id__$dr, __vue_is_functional_template__$dr, __vue_module_identifier__$dr, false, undefined, undefined, undefined);

var script$dq = Vue.extend({
  name: "PhBoundingBox",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dq = script$dq;
/* template */

var __vue_render__$dq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96V48A16,16,0,0,0,80,32H48A16,16,0,0,0,32,48V80A16,16,0,0,0,48,96h8v64H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16v-8h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V96Zm-24,64h-8a16,16,0,0,0-16,16v8H96v-8a16,16,0,0,0-16-16H72V96h8A16,16,0,0,0,96,80V72h64v8a16,16,0,0,0,16,16h8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "168",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "168",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "168",
      "width": "48",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "168",
      "x2": "64",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "88",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "88",
      "x2": "192",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "168",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dq = [];
/* style */

const __vue_inject_styles__$dq = undefined;
/* scoped */

const __vue_scope_id__$dq = undefined;
/* module identifier */

const __vue_module_identifier__$dq = undefined;
/* functional template */

const __vue_is_functional_template__$dq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dq,
  staticRenderFns: __vue_staticRenderFns__$dq
}, __vue_inject_styles__$dq, __vue_script__$dq, __vue_scope_id__$dq, __vue_is_functional_template__$dq, __vue_module_identifier__$dq, false, undefined, undefined, undefined);

var script$dp = Vue.extend({
  name: "PhBracketsAngle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dp = script$dp;
/* template */

var __vue_render__$dp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M86.7,44.3,33.5,128l53.2,83.7a7.9,7.9,0,0,1-2.4,11A7.5,7.5,0,0,1,80,224a7.9,7.9,0,0,1-6.7-3.7l-56-88a7.9,7.9,0,0,1,0-8.6l56-88a8,8,0,1,1,13.4,8.6Zm152,79.4-56-88a8,8,0,1,0-13.4,8.6L222.5,128l-53.2,83.7a7.9,7.9,0,0,0,2.4,11A7.5,7.5,0,0,0,176,224a7.9,7.9,0,0,0,6.7-3.7l56-88A7.9,7.9,0,0,0,238.7,123.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 24 128 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 232 128 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dp = [];
/* style */

const __vue_inject_styles__$dp = undefined;
/* scoped */

const __vue_scope_id__$dp = undefined;
/* module identifier */

const __vue_module_identifier__$dp = undefined;
/* functional template */

const __vue_is_functional_template__$dp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dp,
  staticRenderFns: __vue_staticRenderFns__$dp
}, __vue_inject_styles__$dp, __vue_script__$dp, __vue_scope_id__$dp, __vue_is_functional_template__$dp, __vue_module_identifier__$dp, false, undefined, undefined, undefined);

var script$do = Vue.extend({
  name: "PhBracketsCurly",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$do = script$do;
/* template */

var __vue_render__$do = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M43.2,128a30.4,30.4,0,0,1,8,10.3c4.8,9.9,4.8,22,4.8,33.7,0,24.3,1,36,24,36a8,8,0,0,1,0,16c-17.5,0-29.3-6.1-35.2-18.3C40,195.8,40,183.7,40,172c0-24.3-1-36-24-36a8,8,0,0,1,0-16c23,0,24-11.7,24-36,0-11.7,0-23.8,4.8-33.7C50.7,38.1,62.5,32,80,32a8,8,0,0,1,0,16C57,48,56,59.7,56,84c0,11.7,0,23.8-4.8,33.7A30.4,30.4,0,0,1,43.2,128ZM240,120c-23,0-24-11.7-24-36,0-11.7,0-23.8-4.8-33.7C205.3,38.1,193.5,32,176,32a8,8,0,0,0,0,16c23,0,24,11.7,24,36,0,11.7,0,23.8,4.8,33.7a30.4,30.4,0,0,0,8,10.3,30.4,30.4,0,0,0-8,10.3c-4.8,9.9-4.8,22-4.8,33.7,0,24.3-1,36-24,36a8,8,0,0,0,0,16c17.5,0,29.3-6.1,35.2-18.3,4.8-9.9,4.8-22,4.8-33.7,0-24.3,1-36,24-36a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$do = [];
/* style */

const __vue_inject_styles__$do = undefined;
/* scoped */

const __vue_scope_id__$do = undefined;
/* module identifier */

const __vue_module_identifier__$do = undefined;
/* functional template */

const __vue_is_functional_template__$do = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$do = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$do,
  staticRenderFns: __vue_staticRenderFns__$do
}, __vue_inject_styles__$do, __vue_script__$do, __vue_scope_id__$do, __vue_is_functional_template__$do, __vue_module_identifier__$do, false, undefined, undefined, undefined);

var script$dn = Vue.extend({
  name: "PhBracketsRound",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dn = script$dn;
/* template */

var __vue_render__$dn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,128c0,58.3,34.7,80.3,36.2,81.2A8,8,0,0,1,72,224a8.7,8.7,0,0,1-4.1-1.1C66.1,221.8,24,195.8,24,128S66.1,34.2,67.9,33.1a8.1,8.1,0,0,1,11,2.8,8,8,0,0,1-2.8,10.9C74.5,47.8,40,69.8,40,128ZM188.1,33.1a8,8,0,0,0-8.3,13.7c1.5.9,36.2,22.9,36.2,81.2s-34.7,80.3-36.1,81.1A8,8,0,0,0,184,224a8.7,8.7,0,0,0,4.1-1.1c1.8-1.1,43.9-27.1,43.9-94.9S189.9,34.2,188.1,33.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,40S32,64,32,128s40,88,40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40s40,24,40,88-40,88-40,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dn = [];
/* style */

const __vue_inject_styles__$dn = undefined;
/* scoped */

const __vue_scope_id__$dn = undefined;
/* module identifier */

const __vue_module_identifier__$dn = undefined;
/* functional template */

const __vue_is_functional_template__$dn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dn,
  staticRenderFns: __vue_staticRenderFns__$dn
}, __vue_inject_styles__$dn, __vue_script__$dn, __vue_scope_id__$dn, __vue_is_functional_template__$dn, __vue_module_identifier__$dn, false, undefined, undefined, undefined);

var script$dm = Vue.extend({
  name: "PhBracketsSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dm = script$dm;
/* template */

var __vue_render__$dm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 40 40 40 216 80 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dm = [];
/* style */

const __vue_inject_styles__$dm = undefined;
/* scoped */

const __vue_scope_id__$dm = undefined;
/* module identifier */

const __vue_module_identifier__$dm = undefined;
/* functional template */

const __vue_is_functional_template__$dm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dm,
  staticRenderFns: __vue_staticRenderFns__$dm
}, __vue_inject_styles__$dm, __vue_script__$dm, __vue_scope_id__$dm, __vue_is_functional_template__$dm, __vue_module_identifier__$dm, false, undefined, undefined, undefined);

var script$dl = Vue.extend({
  name: "PhBrain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dl = script$dl;
/* template */

var __vue_render__$dl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,88v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,147.3A40,40,0,1,1,48,184v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,147.3A40,40,0,1,0,208,184v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,86.7V72a40,40,0,0,0-80,0,40,40,0,0,0-80,0V86.7a48.1,48.1,0,0,0,0,90.6h0V184a40,40,0,0,0,80,0,40,40,0,0,0,80,0v-6.7h0a48.1,48.1,0,0,0,0-90.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,132a56,56,0,0,0-32-50.6V72a48,48,0,0,0-88-26.5A48,48,0,0,0,40,72v9.4a56,56,0,0,0,0,101.2V184a48,48,0,0,0,88,26.5A48,48,0,0,0,216,184v-1.4A56.1,56.1,0,0,0,248,132ZM88,216a32,32,0,0,1-31.8-28.6,49.3,49.3,0,0,0,7.8.6h8a8,8,0,0,0,0-16H64A40,40,0,0,1,50.7,94.3,8.1,8.1,0,0,0,56,86.7V72a32,32,0,0,1,64,0v76.3A47.4,47.4,0,0,0,88,136a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a49.3,49.3,0,0,0,7.8-.6A32,32,0,1,1,168,152a8,8,0,0,0,0-16,47.4,47.4,0,0,0-32,12.3V72a32,32,0,0,1,64,0V86.7a8.1,8.1,0,0,0,5.3,7.6A40,40,0,0,1,192,172ZM60,128a8,8,0,0,1,0-16A20.1,20.1,0,0,0,80,92V84a8,8,0,0,1,16,0v8A36,36,0,0,1,60,128Zm144-8a8,8,0,0,1-8,8,36,36,0,0,1-36-36V84a8,8,0,0,1,16,0v8a20.1,20.1,0,0,0,20,20A8,8,0,0,1,204,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144a40,40,0,1,1-40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,144a40,40,0,1,0,40,40v-6.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84v8a28,28,0,0,1-28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,84v8a28,28,0,0,0,28,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dl = [];
/* style */

const __vue_inject_styles__$dl = undefined;
/* scoped */

const __vue_scope_id__$dl = undefined;
/* module identifier */

const __vue_module_identifier__$dl = undefined;
/* functional template */

const __vue_is_functional_template__$dl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dl,
  staticRenderFns: __vue_staticRenderFns__$dl
}, __vue_inject_styles__$dl, __vue_script__$dl, __vue_scope_id__$dl, __vue_is_functional_template__$dl, __vue_module_identifier__$dl, false, undefined, undefined, undefined);

var script$dk = Vue.extend({
  name: "PhBrandy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dk = script$dk;
/* template */

var __vue_render__$dk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.8,40A88,88,0,1,1,54.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,88A88,88,0,0,1,40,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.8,40A88,88,0,1,1,54.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88a96.2,96.2,0,0,0-15.5-52.4,8.2,8.2,0,0,0-6.7-3.6H54.2a8.2,8.2,0,0,0-6.7,3.6A96.1,96.1,0,0,0,120,183.7V216H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.7A96.2,96.2,0,0,0,224,88ZM58.7,48H197.3a78.8,78.8,0,0,1,10.3,32H48.4A78.8,78.8,0,0,1,58.7,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.8,40A88,88,0,1,1,54.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.8,40A88,88,0,1,1,54.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "224",
      "x2": "168",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.8,40A88,88,0,1,1,54.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dk = [];
/* style */

const __vue_inject_styles__$dk = undefined;
/* scoped */

const __vue_scope_id__$dk = undefined;
/* module identifier */

const __vue_module_identifier__$dk = undefined;
/* functional template */

const __vue_is_functional_template__$dk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dk,
  staticRenderFns: __vue_staticRenderFns__$dk
}, __vue_inject_styles__$dk, __vue_script__$dk, __vue_scope_id__$dk, __vue_is_functional_template__$dk, __vue_module_identifier__$dk, false, undefined, undefined, undefined);

var script$dj = Vue.extend({
  name: "PhBriefcase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dj = script$dj;
/* template */

var __vue_render__$dj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,122.3A191.3,191.3,0,0,1,128,148a190.3,190.3,0,0,1-96-25.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "112",
      "x2": "140",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,152a190.3,190.3,0,0,1-96-25.7V208a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V126.3A191.3,191.3,0,0,1,128,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,80v41.6A183.6,183.6,0,0,1,128,144a183.6,183.6,0,0,1-88-22.4V80ZM108,120a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16H116A8,8,0,0,1,108,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "120",
      "x2": "140",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dj = [];
/* style */

const __vue_inject_styles__$dj = undefined;
/* scoped */

const __vue_scope_id__$dj = undefined;
/* module identifier */

const __vue_module_identifier__$dj = undefined;
/* functional template */

const __vue_is_functional_template__$dj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dj,
  staticRenderFns: __vue_staticRenderFns__$dj
}, __vue_inject_styles__$dj, __vue_script__$dj, __vue_scope_id__$dj, __vue_is_functional_template__$dj, __vue_module_identifier__$dj, false, undefined, undefined, undefined);

var script$di = Vue.extend({
  name: "PhBriefcaseMetal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$di = script$di;
/* template */

var __vue_render__$di = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,112H224V80a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,176H224v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M28,120H228a4,4,0,0,1,4,4v40a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V124A4,4,0,0,1,28,120Zm-4,88a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V188a4,4,0,0,0-4-4H28a4,4,0,0,0-4,4ZM232,80v20a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V80A16,16,0,0,1,40,64H80V56a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v8h40A16,16,0,0,1,232,80ZM160,56a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v8h64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "224",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$di = [];
/* style */

const __vue_inject_styles__$di = undefined;
/* scoped */

const __vue_scope_id__$di = undefined;
/* module identifier */

const __vue_module_identifier__$di = undefined;
/* functional template */

const __vue_is_functional_template__$di = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$di = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$di,
  staticRenderFns: __vue_staticRenderFns__$di
}, __vue_inject_styles__$di, __vue_script__$di, __vue_scope_id__$di, __vue_is_functional_template__$di, __vue_module_identifier__$di, false, undefined, undefined, undefined);

var script$dh = Vue.extend({
  name: "PhBroadcast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dh = script$dh;
/* template */

var __vue_render__$dh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,82.7a7.9,7.9,0,0,0,0-11.3,8,8,0,0,0-11.3,0A80,80,0,0,0,54.3,96.9a79.9,79.9,0,0,0,0,62.2,80,80,0,0,0,17.1,25.5,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3,7.9,7.9,0,0,0,0-11.3A65.4,65.4,0,0,1,69,152.9a64.5,64.5,0,0,1,0-49.8A65.4,65.4,0,0,1,82.7,82.7Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128a78.6,78.6,0,0,0-6.3-31.1,80,80,0,0,0-17.1-25.5,8,8,0,0,0-11.3,0,7.9,7.9,0,0,0,0,11.3A65.4,65.4,0,0,1,187,103.1a64.5,64.5,0,0,1,0,49.8,65.4,65.4,0,0,1-13.7,20.4,7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,80,80,0,0,0,17.1-25.5A78.6,78.6,0,0,0,208,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.2,168.5a104.1,104.1,0,0,1,0-81,101.3,101.3,0,0,1,22.3-33A8.1,8.1,0,0,0,43.1,43.1,121.8,121.8,0,0,0,17.4,81.3a120.7,120.7,0,0,0,0,93.4,121.8,121.8,0,0,0,25.7,38.2,8.5,8.5,0,0,0,5.7,2.3,8.3,8.3,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4A101.3,101.3,0,0,1,32.2,168.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M238.6,81.3a121.8,121.8,0,0,0-25.7-38.2,8.1,8.1,0,1,0-11.4,11.4A103.5,103.5,0,0,1,232,128a103.5,103.5,0,0,1-30.5,73.5,8.1,8.1,0,0,0,0,11.4,8.3,8.3,0,0,0,5.7,2.3,8.5,8.5,0,0,0,5.7-2.3,121.8,121.8,0,0,0,25.7-38.2,120.7,120.7,0,0,0,0-93.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dh = [];
/* style */

const __vue_inject_styles__$dh = undefined;
/* scoped */

const __vue_scope_id__$dh = undefined;
/* module identifier */

const __vue_module_identifier__$dh = undefined;
/* functional template */

const __vue_is_functional_template__$dh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dh,
  staticRenderFns: __vue_staticRenderFns__$dh
}, __vue_inject_styles__$dh, __vue_script__$dh, __vue_scope_id__$dh, __vue_is_functional_template__$dh, __vue_module_identifier__$dh, false, undefined, undefined, undefined);

var script$dg = Vue.extend({
  name: "PhBrowser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dg = script$dg;
/* template */

var __vue_render__$dg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96H224V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V88H40V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dg = [];
/* style */

const __vue_inject_styles__$dg = undefined;
/* scoped */

const __vue_scope_id__$dg = undefined;
/* module identifier */

const __vue_module_identifier__$dg = undefined;
/* functional template */

const __vue_is_functional_template__$dg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dg,
  staticRenderFns: __vue_staticRenderFns__$dg
}, __vue_inject_styles__$dg, __vue_script__$dg, __vue_scope_id__$dg, __vue_is_functional_template__$dg, __vue_module_identifier__$dg, false, undefined, undefined, undefined);

var script$df = Vue.extend({
  name: "PhBrowsers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$df = script$df;
/* template */

var __vue_render__$df = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "28",
      "y": "84",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,84V52a8,8,0,0,1,8-8H220a8,8,0,0,1,8,8V164a8,8,0,0,1-8,8H188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "124",
      "x2": "188",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H72a8,8,0,0,0-8,8V80H184a8,8,0,0,1,8,8v88h24a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,88v16H40V88Zm32,80H200V88a16,16,0,0,0-16-16H72V56H216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$df = [];
/* style */

const __vue_inject_styles__$df = undefined;
/* scoped */

const __vue_scope_id__$df = undefined;
/* module identifier */

const __vue_module_identifier__$df = undefined;
/* functional template */

const __vue_is_functional_template__$df = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$df = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$df,
  staticRenderFns: __vue_staticRenderFns__$df
}, __vue_inject_styles__$df, __vue_script__$df, __vue_scope_id__$df, __vue_is_functional_template__$df, __vue_module_identifier__$df, false, undefined, undefined, undefined);

var script$de = Vue.extend({
  name: "PhBug",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$de = script$de;
/* template */

var __vue_render__$de = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "188",
      "x2": "203.2",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "68",
      "x2": "203.2",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "68",
      "x2": "52.8",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "188",
      "x2": "52.8",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v16a80,80,0,0,1-160,0V128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.9",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.9",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "188",
      "x2": "203.2",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "68",
      "x2": "203.2",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "68",
      "x2": "52.8",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "188",
      "x2": "52.8",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M167.9,92a12,12,0,1,1-12-12A12,12,0,0,1,167.9,92Zm-68-12a12,12,0,1,0,12,12A12,12,0,0,0,99.9,80ZM252,128a8,8,0,0,1-8,8H216v8a88.1,88.1,0,0,1-3.2,23.7l23.1,13.4a8,8,0,0,1-4,14.9,7.6,7.6,0,0,1-4-1.1L207,182.8a88,88,0,0,1-158,0L28.1,194.9a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l23.1-13.4A88.1,88.1,0,0,1,40,144v-8H12a8,8,0,0,1,0-16H40v-8a88.1,88.1,0,0,1,3.2-23.7L20.1,74.9a8,8,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9L49,73.2a88,88,0,0,1,158,0l20.9-12.1a8.1,8.1,0,0,1,11,2.9,8,8,0,0,1-3,10.9L212.8,88.3A88.1,88.1,0,0,1,216,112v8h28A8,8,0,0,1,252,128ZM136,144a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm64-32a72,72,0,0,0-144,0v8H200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "188",
      "x2": "203.2",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "68",
      "x2": "203.2",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "68",
      "x2": "52.8",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "188",
      "x2": "52.8",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "188",
      "x2": "203.2",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "68",
      "x2": "203.2",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "68",
      "x2": "52.8",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "188",
      "x2": "52.8",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "188",
      "x2": "203.2",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "231.9",
      "y1": "68",
      "x2": "203.2",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "68",
      "x2": "52.8",
      "y2": "84.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24.1",
      "y1": "188",
      "x2": "52.8",
      "y2": "171.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$de = [];
/* style */

const __vue_inject_styles__$de = undefined;
/* scoped */

const __vue_scope_id__$de = undefined;
/* module identifier */

const __vue_module_identifier__$de = undefined;
/* functional template */

const __vue_is_functional_template__$de = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$de = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$de,
  staticRenderFns: __vue_staticRenderFns__$de
}, __vue_inject_styles__$de, __vue_script__$de, __vue_scope_id__$de, __vue_is_functional_template__$de, __vue_module_identifier__$de, false, undefined, undefined, undefined);

var script$dd = Vue.extend({
  name: "PhBugBeetle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dd = script$dd;
/* template */

var __vue_render__$dd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "79.7",
      "y2": "50.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "176.2",
      "y2": "50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "63.5",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192.5",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,104v48a72,72,0,0,1-72,72h0a72,72,0,0,1-72-72V104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.8",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.2",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "79.7",
      "y2": "50.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "176.2",
      "y2": "50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.4,33.8a8,8,0,0,1,11-11.6L80.1,40a79.8,79.8,0,0,1,95.7-.1l18.6-17.7a8,8,0,0,1,11.3.3,7.9,7.9,0,0,1-.3,11.3L187.6,50.7a79.6,79.6,0,0,1,20,45.3H48.4A79.9,79.9,0,0,1,68.3,50.8ZM32,96a8,8,0,0,0,0,16H48V96Zm176,56a70.3,70.3,0,0,1-.4,8H224a8,8,0,0,1,0,16H204.3a80,80,0,0,1-152.6,0H32a8,8,0,0,1,0-16H48.4a70.3,70.3,0,0,1-.4-8v-8H32a8,8,0,0,1,0-16H48V112H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm96-32a8,8,0,0,0-8-8H208v16h16A8,8,0,0,0,232,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.8",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.2",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "79.7",
      "y2": "50.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "176.2",
      "y2": "50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.8",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.2",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "79.7",
      "y2": "50.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "176.2",
      "y2": "50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "32",
      "width": "144",
      "height": "192",
      "rx": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "224",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "57.8",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.2",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "79.7",
      "y2": "50.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "176.2",
      "y2": "50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dd = [];
/* style */

const __vue_inject_styles__$dd = undefined;
/* scoped */

const __vue_scope_id__$dd = undefined;
/* module identifier */

const __vue_module_identifier__$dd = undefined;
/* functional template */

const __vue_is_functional_template__$dd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dd,
  staticRenderFns: __vue_staticRenderFns__$dd
}, __vue_inject_styles__$dd, __vue_script__$dd, __vue_scope_id__$dd, __vue_is_functional_template__$dd, __vue_module_identifier__$dd, false, undefined, undefined, undefined);

var script$dc = Vue.extend({
  name: "PhBugDroid",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$dc = script$dc;
/* template */

var __vue_render__$dc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.9",
      "y1": "128",
      "x2": "47.9",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "76.2",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "179.6",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M47.9,128h160v20a80,80,0,0,1-160,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.9",
      "y1": "128",
      "x2": "47.9",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "155.9",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99.9",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "76.2",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "179.6",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M191.3,47l14.1-13.1a8.2,8.2,0,0,0,.4-11.4,8,8,0,0,0-11.3-.4L179.1,36.5a87.7,87.7,0,0,0-102.4,0L61.4,22.1A8,8,0,0,0,50.5,33.9L64.6,47a87.4,87.4,0,0,0-24.7,61v40a88,88,0,0,0,176,0V108A87.7,87.7,0,0,0,191.3,47ZM127.9,36a72.1,72.1,0,0,1,72,72v12H55.9V108A72.1,72.1,0,0,1,127.9,36Zm16,56a12,12,0,1,1,12,12A12,12,0,0,1,143.9,92Zm-56,0a12,12,0,1,1,12,12A12,12,0,0,1,87.9,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.9",
      "y1": "128",
      "x2": "47.9",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "76.2",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "179.6",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.9",
      "y1": "128",
      "x2": "47.9",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "55.9",
      "y1": "28",
      "x2": "76.2",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "199.9",
      "y1": "28",
      "x2": "179.6",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "128",
      "x2": "48",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "28",
      "x2": "76.3",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "28",
      "x2": "179.7",
      "y2": "46.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$dc = [];
/* style */

const __vue_inject_styles__$dc = undefined;
/* scoped */

const __vue_scope_id__$dc = undefined;
/* module identifier */

const __vue_module_identifier__$dc = undefined;
/* functional template */

const __vue_is_functional_template__$dc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$dc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$dc,
  staticRenderFns: __vue_staticRenderFns__$dc
}, __vue_inject_styles__$dc, __vue_script__$dc, __vue_scope_id__$dc, __vue_is_functional_template__$dc, __vue_module_identifier__$dc, false, undefined, undefined, undefined);

var script$db = Vue.extend({
  name: "PhBuildings",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$db = script$db;
/* template */

var __vue_render__$db = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,216V104a8,8,0,0,0-8-8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "108",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "176",
      "x2": "188",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "136",
      "x2": "188",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,216V104a8,8,0,0,0-8-8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "112",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "192",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "136",
      "x2": "192",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,208h-8V104a16,16,0,0,0-16-16H152V40a16,16,0,0,0-16-16H40A16,16,0,0,0,24,40V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM120,136a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h32A8,8,0,0,1,120,136ZM64,64H96a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm0,104H96a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm88-64h64V208H152Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,168H176a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,144h16a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,216V104a8,8,0,0,0-8-8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "112",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "192",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "136",
      "x2": "192",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,216V104a8,8,0,0,0-8-8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "112",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "192",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "136",
      "x2": "192",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,216V104a8,8,0,0,0-8-8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "112",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "192",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "136",
      "x2": "192",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$db = [];
/* style */

const __vue_inject_styles__$db = undefined;
/* scoped */

const __vue_scope_id__$db = undefined;
/* module identifier */

const __vue_module_identifier__$db = undefined;
/* functional template */

const __vue_is_functional_template__$db = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$db = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$db,
  staticRenderFns: __vue_staticRenderFns__$db
}, __vue_inject_styles__$db, __vue_script__$db, __vue_scope_id__$db, __vue_is_functional_template__$db, __vue_module_identifier__$db, false, undefined, undefined, undefined);

var script$da = Vue.extend({
  name: "PhBus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$da = script$da;
/* template */

var __vue_render__$da = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "80",
      "x2": "214",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "132",
      "x2": "214",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,184H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,184v32a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,184v32a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192Z",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192Z",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "42",
      "y": "72",
      "width": "172",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M190,32H66A32.1,32.1,0,0,0,34,64V216a16,16,0,0,0,16,16H74a16,16,0,0,0,16-16V200h76v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V64A32.1,32.1,0,0,0,190,32ZM82,168a12,12,0,1,1,12-12A12,12,0,0,1,82,168Zm92,0a12,12,0,1,1,12-12A12,12,0,0,1,174,168Zm32-48H50V72H206Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "42",
      "y1": "72",
      "x2": "214",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42",
      "y1": "120",
      "x2": "214",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$da = [];
/* style */

const __vue_inject_styles__$da = undefined;
/* scoped */

const __vue_scope_id__$da = undefined;
/* module identifier */

const __vue_module_identifier__$da = undefined;
/* functional template */

const __vue_is_functional_template__$da = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$da = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$da,
  staticRenderFns: __vue_staticRenderFns__$da
}, __vue_inject_styles__$da, __vue_script__$da, __vue_scope_id__$da, __vue_is_functional_template__$da, __vue_module_identifier__$da, false, undefined, undefined, undefined);

var script$d9 = Vue.extend({
  name: "PhButterfly",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d9 = script$d9;
/* template */

var __vue_render__$d9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120c-7.8,31.1-29,32.8-36.9,32.4h0A36,36,0,1,1,128,180a36,36,0,1,1-59.1-27.6h0c-7.9.4-29.1-1.3-36.9-32.4S17.1,48,48,48s80,48,80,80c0-32,49.1-80,80-80S232,88,224,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,87.5V56a8,8,0,0,0-16,0V87.5a98.7,98.7,0,0,1,8,12.7A98.7,98.7,0,0,1,136,87.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M231.4,50.4C227.7,45.6,220.7,40,208,40c-16.7,0-38.1,11.3-57.2,30.3A144.2,144.2,0,0,0,136,87.5V172a8,8,0,0,1-16,0V87.5a144.2,144.2,0,0,0-14.8-17.2C86.1,51.3,64.7,40,48,40c-12.7,0-19.7,5.6-23.4,10.4-6.8,8.7-12.2,24.1-.4,71.5,6.6,26.3,22,34.9,33.5,37.5a40,40,0,1,0,70.3,38,40,40,0,1,0,70.3-38c11.5-2.6,26.9-11.2,33.5-37.5S243.6,66,231.4,50.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d9 = [];
/* style */

const __vue_inject_styles__$d9 = undefined;
/* scoped */

const __vue_scope_id__$d9 = undefined;
/* module identifier */

const __vue_module_identifier__$d9 = undefined;
/* functional template */

const __vue_is_functional_template__$d9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d9,
  staticRenderFns: __vue_staticRenderFns__$d9
}, __vue_inject_styles__$d9, __vue_script__$d9, __vue_scope_id__$d9, __vue_is_functional_template__$d9, __vue_module_identifier__$d9, false, undefined, undefined, undefined);

var script$d8 = Vue.extend({
  name: "PhCactus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d8 = script$d8;
/* template */

var __vue_render__$d8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H88V140H84A68.1,68.1,0,0,1,16,72a28,28,0,0,1,56,0A12,12,0,0,0,84,84h4V56a40,40,0,0,1,80,0v68h4a12,12,0,0,0,12-12,28,28,0,0,1,56,0,68.1,68.1,0,0,1-68,68h-4v28h48A8,8,0,0,1,224,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d8 = [];
/* style */

const __vue_inject_styles__$d8 = undefined;
/* scoped */

const __vue_scope_id__$d8 = undefined;
/* module identifier */

const __vue_module_identifier__$d8 = undefined;
/* functional template */

const __vue_is_functional_template__$d8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d8,
  staticRenderFns: __vue_staticRenderFns__$d8
}, __vue_inject_styles__$d8, __vue_script__$d8, __vue_scope_id__$d8, __vue_is_functional_template__$d8, __vue_module_identifier__$d8, false, undefined, undefined, undefined);

var script$d7 = Vue.extend({
  name: "PhCake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d7 = script$d7;
/* template */

var __vue_render__$d7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c56-24,0-76,0-76S72,64,128,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0,34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206,80H136V69.4c11.5-5.1,18.2-12.5,20.1-22C160.2,26,136,4.3,133.2,2a7.8,7.8,0,0,0-10.3-.1C120,4.2,95.1,25.7,99.1,47.2c1.8,9.7,8.9,17.2,20.9,22.3V80H50a32.1,32.1,0,0,0-32,32v13.3A43.3,43.3,0,0,0,30.9,156l1.1,1v51a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V157l1.1-1A43.3,43.3,0,0,0,238,125.3V112A32.1,32.1,0,0,0,206,80Zm2,128H48V166.2A39.3,39.3,0,0,0,60.8,168,42.2,42.2,0,0,0,94,150.6a41.9,41.9,0,0,0,68,0A42.2,42.2,0,0,0,195.2,168h.8a40.6,40.6,0,0,0,12-1.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162,126a34,34,0,0,1-68,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d7 = [];
/* style */

const __vue_inject_styles__$d7 = undefined;
/* scoped */

const __vue_scope_id__$d7 = undefined;
/* module identifier */

const __vue_module_identifier__$d7 = undefined;
/* functional template */

const __vue_is_functional_template__$d7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d7,
  staticRenderFns: __vue_staticRenderFns__$d7
}, __vue_inject_styles__$d7, __vue_script__$d7, __vue_scope_id__$d7, __vue_is_functional_template__$d7, __vue_module_identifier__$d7, false, undefined, undefined, undefined);

var script$d6 = Vue.extend({
  name: "PhCalculator",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d6 = script$d6;
/* template */

var __vue_render__$d6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "76",
      "x2": "164",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM88,200a12,12,0,1,1,12-12A12,12,0,0,1,88,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,88,160Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,128,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,128,160Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,168,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,168,160Zm16-56a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "64",
      "width": "96",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "188",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d6 = [];
/* style */

const __vue_inject_styles__$d6 = undefined;
/* scoped */

const __vue_scope_id__$d6 = undefined;
/* module identifier */

const __vue_module_identifier__$d6 = undefined;
/* functional template */

const __vue_is_functional_template__$d6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d6,
  staticRenderFns: __vue_staticRenderFns__$d6
}, __vue_inject_styles__$d6, __vue_script__$d6, __vue_scope_id__$d6, __vue_is_functional_template__$d6, __vue_module_identifier__$d6, false, undefined, undefined, undefined);

var script$d5 = Vue.extend({
  name: "PhCalendar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d5 = script$d5;
/* template */

var __vue_render__$d5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,128h28l-16,20a16,16,0,1,1-11.3,27.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 140 164 128 164 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 140 160 128 160 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM104,188a24.2,24.2,0,0,1-17-7,8,8,0,0,1,0-11.3,7.9,7.9,0,0,1,11.3,0A8.3,8.3,0,0,0,104,172a8,8,0,0,0,0-16h-2.5l-.4-.2h-.3l-.5-.2h-.1l-.6-.4h-.2l-.4-.3h0l-.4-.3-.2-.2-.3-.3a8.6,8.6,0,0,1-1.3-2,5.8,5.8,0,0,1-.6-1.7h0c-.1-.1-.1-.2-.1-.4a.4.4,0,0,0-.1-.3V148h0v-.7c0-.2.1-.3.1-.4v-.4a.6.6,0,0,0,.1-.4c.1-.1.1-.2.1-.4l.2-.3c0-.2,0-.3.1-.4l.2-.4v-.3l.2-.4.2-.3.3-.4.2-.2,5.6-7H92a8,8,0,0,1,0-16h28a8,8,0,0,1,6.2,13l-8.8,11.1A24,24,0,0,1,104,188Zm64-8a8,8,0,0,1-16,0V144l-3.2,2.4a8.1,8.1,0,0,1-11.2-1.6,8,8,0,0,1,1.6-11.2l16-12A8,8,0,0,1,168,128ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 140 160 128 160 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 140 160 128 160 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 140 160 128 160 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d5 = [];
/* style */

const __vue_inject_styles__$d5 = undefined;
/* scoped */

const __vue_scope_id__$d5 = undefined;
/* module identifier */

const __vue_module_identifier__$d5 = undefined;
/* functional template */

const __vue_is_functional_template__$d5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d5,
  staticRenderFns: __vue_staticRenderFns__$d5
}, __vue_inject_styles__$d5, __vue_script__$d5, __vue_scope_id__$d5, __vue_is_functional_template__$d5, __vue_module_identifier__$d5, false, undefined, undefined, undefined);

var script$d4 = Vue.extend({
  name: "PhCalendarBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d4 = script$d4;
/* template */

var __vue_render__$d4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,48H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d4 = [];
/* style */

const __vue_inject_styles__$d4 = undefined;
/* scoped */

const __vue_scope_id__$d4 = undefined;
/* module identifier */

const __vue_module_identifier__$d4 = undefined;
/* functional template */

const __vue_is_functional_template__$d4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d4,
  staticRenderFns: __vue_staticRenderFns__$d4
}, __vue_inject_styles__$d4, __vue_script__$d4, __vue_scope_id__$d4, __vue_is_functional_template__$d4, __vue_module_identifier__$d4, false, undefined, undefined, undefined);

var script$d3 = Vue.extend({
  name: "PhCalendarCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d3 = script$d3;
/* template */

var __vue_render__$d3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 128 117.3 172 92 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 128 117.3 172 92 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM169.5,133.8l-46.7,44a7.7,7.7,0,0,1-5.5,2.2,7.9,7.9,0,0,1-5.5-2.2l-25.3-24a8,8,0,1,1,11-11.6L117.3,161l41.2-38.8a7.9,7.9,0,0,1,11.3.3A8,8,0,0,1,169.5,133.8ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 128 117.3 172 92 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 128 117.3 172 92 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 128 117.3 172 92 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d3 = [];
/* style */

const __vue_inject_styles__$d3 = undefined;
/* scoped */

const __vue_scope_id__$d3 = undefined;
/* module identifier */

const __vue_module_identifier__$d3 = undefined;
/* functional template */

const __vue_is_functional_template__$d3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d3,
  staticRenderFns: __vue_staticRenderFns__$d3
}, __vue_inject_styles__$d3, __vue_script__$d3, __vue_scope_id__$d3, __vue_is_functional_template__$d3, __vue_module_identifier__$d3, false, undefined, undefined, undefined);

var script$d2 = Vue.extend({
  name: "PhCalendarPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d2 = script$d2;
/* template */

var __vue_render__$d2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM156,160H136v20a8,8,0,0,1-16,0V160H100a8,8,0,0,1,0-16h20V124a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Zm52-80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "152",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d2 = [];
/* style */

const __vue_inject_styles__$d2 = undefined;
/* scoped */

const __vue_scope_id__$d2 = undefined;
/* module identifier */

const __vue_module_identifier__$d2 = undefined;
/* functional template */

const __vue_is_functional_template__$d2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d2,
  staticRenderFns: __vue_staticRenderFns__$d2
}, __vue_inject_styles__$d2, __vue_script__$d2, __vue_scope_id__$d2, __vue_is_functional_template__$d2, __vue_module_identifier__$d2, false, undefined, undefined, undefined);

var script$d1 = Vue.extend({
  name: "PhCalendarX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d1 = script$d1;
/* template */

var __vue_render__$d1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "20",
      "x2": "176",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "20",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM157.7,170.3a8.1,8.1,0,0,1,0,11.4A8.5,8.5,0,0,1,152,184a8.3,8.3,0,0,1-5.7-2.3L128,163.3l-18.3,18.4A8.5,8.5,0,0,1,104,184a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L116.7,152,98.3,133.7a8.1,8.1,0,0,1,11.4-11.4L128,140.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L139.3,152ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "88",
      "x2": "216",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "176",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d1 = [];
/* style */

const __vue_inject_styles__$d1 = undefined;
/* scoped */

const __vue_scope_id__$d1 = undefined;
/* module identifier */

const __vue_module_identifier__$d1 = undefined;
/* functional template */

const __vue_is_functional_template__$d1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d1,
  staticRenderFns: __vue_staticRenderFns__$d1
}, __vue_inject_styles__$d1, __vue_script__$d1, __vue_scope_id__$d1, __vue_is_functional_template__$d1, __vue_module_identifier__$d1, false, undefined, undefined, undefined);

var script$d0 = Vue.extend({
  name: "PhCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d0 = script$d0;
/* template */

var __vue_render__$d0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,64H176L160,40H96L80,64H48A16,16,0,0,0,32,80V192a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V80A16,16,0,0,0,208,64ZM128,168a36,36,0,1,1,36-36A36,36,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,56H180.3L166.7,35.6A7.9,7.9,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6L75.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V80A24.1,24.1,0,0,0,208,56Zm-44,76a36,36,0,1,1-36-36A36,36,0,0,1,164,132Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d0 = [];
/* style */

const __vue_inject_styles__$d0 = undefined;
/* scoped */

const __vue_scope_id__$d0 = undefined;
/* module identifier */

const __vue_module_identifier__$d0 = undefined;
/* functional template */

const __vue_is_functional_template__$d0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d0,
  staticRenderFns: __vue_staticRenderFns__$d0
}, __vue_inject_styles__$d0, __vue_script__$d0, __vue_scope_id__$d0, __vue_is_functional_template__$d0, __vue_module_identifier__$d0, false, undefined, undefined, undefined);

var script$c$ = Vue.extend({
  name: "PhCameraRotate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c$ = script$c$;
/* template */

var __vue_render__$c$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 96 172 120 148 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 140 84 144 80 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 96 172 120 148 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 140 84 144 80 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,56H180.3L166.7,35.6A7.9,7.9,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6L75.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V80A24.1,24.1,0,0,0,208,56ZM161.9,165.9a47.8,47.8,0,0,1-67.8,0H94L89.3,161l-1.4,8.3A8.1,8.1,0,0,1,80,176H78.7a8,8,0,0,1-6.6-9.2l4-24a8.1,8.1,0,0,1,6.6-6.6l24-4a8,8,0,1,1,2.6,15.8l-9,1.5,5.1,5.3A32,32,0,0,0,128,164a31.5,31.5,0,0,0,22.6-9.4,8,8,0,0,1,11.3,0A7.9,7.9,0,0,1,161.9,165.9Zm22-68.6-4,24a8.1,8.1,0,0,1-6.6,6.6l-24,4H148a8.1,8.1,0,0,1-7.9-6.7,8,8,0,0,1,6.6-9.2l9-1.5-5.1-5.3A32,32,0,0,0,128,100a31.5,31.5,0,0,0-22.6,9.4,8,8,0,0,1-11.3,0,7.9,7.9,0,0,1,0-11.3,47.8,47.8,0,0,1,67.8,0c.1,0,.1,0,.1.1l4.7,4.8,1.4-8.3a8,8,0,0,1,15.8,2.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 96 172 120 148 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 140 84 144 80 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 96 172 120 148 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 140 84 144 80 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 96 172 120 148 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 140 84 144 80 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c$ = [];
/* style */

const __vue_inject_styles__$c$ = undefined;
/* scoped */

const __vue_scope_id__$c$ = undefined;
/* module identifier */

const __vue_module_identifier__$c$ = undefined;
/* functional template */

const __vue_is_functional_template__$c$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c$,
  staticRenderFns: __vue_staticRenderFns__$c$
}, __vue_inject_styles__$c$, __vue_script__$c$, __vue_scope_id__$c$, __vue_is_functional_template__$c$, __vue_module_identifier__$c$, false, undefined, undefined, undefined);

var script$c_ = Vue.extend({
  name: "PhCameraSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c_ = script$c_;
/* template */

var __vue_render__$c_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.1,156.8a36,36,0,1,1-48.3-53.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.1,40H160l16,24h32a16,16,0,0,1,16,16v94.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,64H176L160,40H96L80,64H48A16,16,0,0,0,32,80V192a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V80A16,16,0,0,0,208,64ZM128,168a36,36,0,1,1,36-36A36,36,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.1,156.8a36,36,0,1,1-48.3-53.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.4,18.6a7.9,7.9,0,0,0-11.3-.5,8,8,0,0,0-.6,11.3L51.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H197.2l19.4,21.4a8.2,8.2,0,0,0,5.9,2.6,7.8,7.8,0,0,0,5.4-2.1,8,8,0,0,0,.6-11.3ZM128,168a36,36,0,0,1-36-36,36.4,36.4,0,0,1,8.1-22.8L148,161.9A35.3,35.3,0,0,1,128,168Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,56H180.3L166.6,35.6A7.6,7.6,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6l-2,3a8,8,0,0,0,.8,9.8l130,143A7.9,7.9,0,0,0,224,194a7.4,7.4,0,0,0,2.9-.5A8,8,0,0,0,232,186V80A24.1,24.1,0,0,0,208,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.1,156.8a36,36,0,1,1-48.3-53.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.1,156.8a36,36,0,1,1-48.3-53.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.1,156.8a36,36,0,1,1-48.3-53.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c_ = [];
/* style */

const __vue_inject_styles__$c_ = undefined;
/* scoped */

const __vue_scope_id__$c_ = undefined;
/* module identifier */

const __vue_module_identifier__$c_ = undefined;
/* functional template */

const __vue_is_functional_template__$c_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c_,
  staticRenderFns: __vue_staticRenderFns__$c_
}, __vue_inject_styles__$c_, __vue_script__$c_, __vue_scope_id__$c_, __vue_is_functional_template__$c_, __vue_module_identifier__$c_, false, undefined, undefined, undefined);

var script$cZ = Vue.extend({
  name: "PhCampfire",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cZ = script$cZ;
/* template */

var __vue_render__$cZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "168",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "40",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32S76,64,76,108a52,52,0,0,0,52,52,23.9,23.9,0,0,1-24-24c0-24,24-40,24-40s24,16,24,40a23.9,23.9,0,0,1-24,24,52,52,0,0,0,52-52C180,64,128,32,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "168",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "40",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.2,25.2a7.9,7.9,0,0,0-8.4,0A153.5,153.5,0,0,0,96.2,48C77.8,67.1,68,87.9,68,108a60,60,0,0,0,120,0C188,60.1,134.5,26.6,132.2,25.2ZM128,152a23.9,23.9,0,0,1-24-24c0-24,24-40,24-40s24,16,24,40A23.9,23.9,0,0,1,128,152Zm95.6,74.4A8,8,0,0,1,216,232a6.7,6.7,0,0,1-2.4-.4L128,204.4,42.4,231.6a6.7,6.7,0,0,1-2.4.4,8,8,0,0,1-7.6-5.6,7.9,7.9,0,0,1,5.2-10l64-20.4-64-20.4a8,8,0,1,1,4.8-15.2L128,187.6l85.6-27.2a8,8,0,1,1,4.8,15.2l-64,20.4,64,20.4A7.9,7.9,0,0,1,223.6,226.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "168",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "40",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "168",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "40",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "168",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "40",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cZ = [];
/* style */

const __vue_inject_styles__$cZ = undefined;
/* scoped */

const __vue_scope_id__$cZ = undefined;
/* module identifier */

const __vue_module_identifier__$cZ = undefined;
/* functional template */

const __vue_is_functional_template__$cZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cZ,
  staticRenderFns: __vue_staticRenderFns__$cZ
}, __vue_inject_styles__$cZ, __vue_script__$cZ, __vue_scope_id__$cZ, __vue_is_functional_template__$cZ, __vue_module_identifier__$cZ, false, undefined, undefined, undefined);

var script$cY = Vue.extend({
  name: "PhCar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cY = script$cY;
/* template */

var __vue_render__$cY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,176v32a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v56H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,112H229.2L201.4,49.5A15.9,15.9,0,0,0,186.8,40H69.2a15.9,15.9,0,0,0-14.6,9.5L26.8,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm96,0a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cY = [];
/* style */

const __vue_inject_styles__$cY = undefined;
/* scoped */

const __vue_scope_id__$cY = undefined;
/* module identifier */

const __vue_module_identifier__$cY = undefined;
/* functional template */

const __vue_is_functional_template__$cY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cY,
  staticRenderFns: __vue_staticRenderFns__$cY
}, __vue_inject_styles__$cY, __vue_script__$cY, __vue_scope_id__$cY, __vue_is_functional_template__$cY, __vue_module_identifier__$cY, false, undefined, undefined, undefined);

var script$cX = Vue.extend({
  name: "PhCarSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cX = script$cX;
/* template */

var __vue_render__$cX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120,61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,112H229.2L201.4,49.5A15.9,15.9,0,0,0,186.8,40H69.2a15.9,15.9,0,0,0-14.6,9.5L26.8,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cX = [];
/* style */

const __vue_inject_styles__$cX = undefined;
/* scoped */

const __vue_scope_id__$cX = undefined;
/* module identifier */

const __vue_module_identifier__$cX = undefined;
/* functional template */

const __vue_is_functional_template__$cX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cX,
  staticRenderFns: __vue_staticRenderFns__$cX
}, __vue_inject_styles__$cX, __vue_script__$cX, __vue_scope_id__$cX, __vue_is_functional_template__$cX, __vue_module_identifier__$cX, false, undefined, undefined, undefined);

var script$cW = Vue.extend({
  name: "PhCardholder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cW = script$cW;
/* template */

var __vue_render__$cW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,100H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224V72a16,16,0,0,0-16-16H48A16,16,0,0,0,32,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,208,48Zm-56.5,76.8a24,24,0,0,1-47,0A16.1,16.1,0,0,0,88.8,112H40V96H216v16H167.2A16.1,16.1,0,0,0,151.5,124.8ZM48,64H208a8,8,0,0,1,8,8v8H40V72A8,8,0,0,1,48,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cW = [];
/* style */

const __vue_inject_styles__$cW = undefined;
/* scoped */

const __vue_scope_id__$cW = undefined;
/* module identifier */

const __vue_module_identifier__$cW = undefined;
/* functional template */

const __vue_is_functional_template__$cW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cW,
  staticRenderFns: __vue_staticRenderFns__$cW
}, __vue_inject_styles__$cW, __vue_script__$cW, __vue_scope_id__$cW, __vue_is_functional_template__$cW, __vue_module_identifier__$cW, false, undefined, undefined, undefined);

var script$cV = Vue.extend({
  name: "PhCards",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cV = script$cV;
/* template */

var __vue_render__$cV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "28",
      "y": "84",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,44H220a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,48H216a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "176",
      "height": "144",
      "rx": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,40H64a8,8,0,0,0,0,16H216V176a8,8,0,0,0,16,0V56A16,16,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,48H216a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,48H216a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "160",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,48H216a8,8,0,0,1,8,8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cV = [];
/* style */

const __vue_inject_styles__$cV = undefined;
/* scoped */

const __vue_scope_id__$cV = undefined;
/* module identifier */

const __vue_module_identifier__$cV = undefined;
/* functional template */

const __vue_is_functional_template__$cV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cV,
  staticRenderFns: __vue_staticRenderFns__$cV
}, __vue_inject_styles__$cV, __vue_script__$cV, __vue_scope_id__$cV, __vue_is_functional_template__$cV, __vue_module_identifier__$cV, false, undefined, undefined, undefined);

var script$cU = Vue.extend({
  name: "PhCaretCircleDoubleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cU = script$cU;
/* template */

var __vue_render__$cU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,54.5a104,104,0,1,0,147,0A103.9,103.9,0,0,0,54.5,54.5Zm99.8,83.8a8.1,8.1,0,0,1,11.4,0,8.2,8.2,0,0,1,0,11.4l-32,32a8.1,8.1,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,11.4-11.4L128,164.7Zm0-56a8.1,8.1,0,0,1,11.4,0,8.2,8.2,0,0,1,0,11.4l-32,32a8.1,8.1,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,11.4-11.4L128,108.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 88 128 120 96 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 176 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cU = [];
/* style */

const __vue_inject_styles__$cU = undefined;
/* scoped */

const __vue_scope_id__$cU = undefined;
/* module identifier */

const __vue_module_identifier__$cU = undefined;
/* functional template */

const __vue_is_functional_template__$cU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cU,
  staticRenderFns: __vue_staticRenderFns__$cU
}, __vue_inject_styles__$cU, __vue_script__$cU, __vue_scope_id__$cU, __vue_is_functional_template__$cU, __vue_module_identifier__$cU, false, undefined, undefined, undefined);

var script$cT = Vue.extend({
  name: "PhCaretCircleDoubleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cT = script$cT;
/* template */

var __vue_render__$cT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5Zm-83.8,99.8a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,11.4L91.3,128Zm56,0a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,11.4L147.3,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 160 136 128 168 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 160 80 128 112 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cT = [];
/* style */

const __vue_inject_styles__$cT = undefined;
/* scoped */

const __vue_scope_id__$cT = undefined;
/* module identifier */

const __vue_module_identifier__$cT = undefined;
/* functional template */

const __vue_is_functional_template__$cT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cT,
  staticRenderFns: __vue_staticRenderFns__$cT
}, __vue_inject_styles__$cT, __vue_script__$cT, __vue_scope_id__$cT, __vue_is_functional_template__$cT, __vue_module_identifier__$cT, false, undefined, undefined, undefined);

var script$cS = Vue.extend({
  name: "PhCaretCircleDoubleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cS = script$cS;
/* template */

var __vue_render__$cS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5Zm-75.8,79.2-32,32a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L108.7,128,82.3,101.7A8.1,8.1,0,0,1,93.7,90.3l32,32A8.1,8.1,0,0,1,125.7,133.7Zm56,0-32,32a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L164.7,128l-26.4-26.3a8.1,8.1,0,0,1,11.4-11.4l32,32A8.1,8.1,0,0,1,181.7,133.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 160 120 128 88 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 160 176 128 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cS = [];
/* style */

const __vue_inject_styles__$cS = undefined;
/* scoped */

const __vue_scope_id__$cS = undefined;
/* module identifier */

const __vue_module_identifier__$cS = undefined;
/* functional template */

const __vue_is_functional_template__$cS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cS,
  staticRenderFns: __vue_staticRenderFns__$cS
}, __vue_inject_styles__$cS, __vue_script__$cS, __vue_scope_id__$cS, __vue_is_functional_template__$cS, __vue_module_identifier__$cS, false, undefined, undefined, undefined);

var script$cR = Vue.extend({
  name: "PhCaretCircleDoubleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cR = script$cR;
/* template */

var __vue_render__$cR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,201.5a104,104,0,1,0-147,0A103.9,103.9,0,0,0,201.5,201.5Zm-99.8-83.8a8.1,8.1,0,0,1-11.4,0,8.2,8.2,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.1,8.1,0,0,1-11.4,11.4L128,91.3Zm0,56a8.1,8.1,0,0,1-11.4,0,8.2,8.2,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.1,8.1,0,0,1-11.4,11.4L128,147.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 168 128 136 160 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 80 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cR = [];
/* style */

const __vue_inject_styles__$cR = undefined;
/* scoped */

const __vue_scope_id__$cR = undefined;
/* module identifier */

const __vue_module_identifier__$cR = undefined;
/* functional template */

const __vue_is_functional_template__$cR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cR,
  staticRenderFns: __vue_staticRenderFns__$cR
}, __vue_inject_styles__$cR, __vue_script__$cR, __vue_scope_id__$cR, __vue_is_functional_template__$cR, __vue_module_identifier__$cR, false, undefined, undefined, undefined);

var script$cQ = Vue.extend({
  name: "PhCaretCircleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cQ = script$cQ;
/* template */

var __vue_render__$cQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm41.9,97.4-36,40a8,8,0,0,1-11.8,0l-36-40a8,8,0,0,1,11.8-10.8L128,144l30.1-33.4a8,8,0,1,1,11.8,10.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 116 128 156 92 116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cQ = [];
/* style */

const __vue_inject_styles__$cQ = undefined;
/* scoped */

const __vue_scope_id__$cQ = undefined;
/* module identifier */

const __vue_module_identifier__$cQ = undefined;
/* functional template */

const __vue_is_functional_template__$cQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cQ,
  staticRenderFns: __vue_staticRenderFns__$cQ
}, __vue_inject_styles__$cQ, __vue_script__$cQ, __vue_scope_id__$cQ, __vue_is_functional_template__$cQ, __vue_module_identifier__$cQ, false, undefined, undefined, undefined);

var script$cP = Vue.extend({
  name: "PhCaretCircleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cP = script$cP;
/* template */

var __vue_render__$cP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm21.4,134.1a8,8,0,0,1,.5,11.3A7.9,7.9,0,0,1,144,172a8.2,8.2,0,0,1-5.4-2.1l-40-36a8,8,0,0,1,0-11.8l40-36a8,8,0,1,1,10.8,11.8L116,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 92 104 128 144 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cP = [];
/* style */

const __vue_inject_styles__$cP = undefined;
/* scoped */

const __vue_scope_id__$cP = undefined;
/* module identifier */

const __vue_module_identifier__$cP = undefined;
/* functional template */

const __vue_is_functional_template__$cP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cP,
  staticRenderFns: __vue_staticRenderFns__$cP
}, __vue_inject_styles__$cP, __vue_script__$cP, __vue_scope_id__$cP, __vue_is_functional_template__$cP, __vue_module_identifier__$cP, false, undefined, undefined, undefined);

var script$cO = Vue.extend({
  name: "PhCaretCircleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cO = script$cO;
/* template */

var __vue_render__$cO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.4,109.9-40,36A8.2,8.2,0,0,1,116,172a7.9,7.9,0,0,1-5.9-2.6,8,8,0,0,1,.5-11.3L144,128,110.6,97.9a8,8,0,0,1,10.8-11.8l40,36a8,8,0,0,1,0,11.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 92 156 128 116 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cO = [];
/* style */

const __vue_inject_styles__$cO = undefined;
/* scoped */

const __vue_scope_id__$cO = undefined;
/* module identifier */

const __vue_module_identifier__$cO = undefined;
/* functional template */

const __vue_is_functional_template__$cO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cO,
  staticRenderFns: __vue_staticRenderFns__$cO
}, __vue_inject_styles__$cO, __vue_script__$cO, __vue_scope_id__$cO, __vue_is_functional_template__$cO, __vue_module_identifier__$cO, false, undefined, undefined, undefined);

var script$cN = Vue.extend({
  name: "PhCaretCircleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cN = script$cN;
/* template */

var __vue_render__$cN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm41.4,125.9A8.2,8.2,0,0,1,164,152a7.9,7.9,0,0,1-5.9-2.6L128,116,97.9,149.4a8,8,0,0,1-11.8-10.8l36-40a8.3,8.3,0,0,1,11.8,0l36,40A8,8,0,0,1,169.4,149.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 144 128 104 92 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cN = [];
/* style */

const __vue_inject_styles__$cN = undefined;
/* scoped */

const __vue_scope_id__$cN = undefined;
/* module identifier */

const __vue_module_identifier__$cN = undefined;
/* functional template */

const __vue_is_functional_template__$cN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cN,
  staticRenderFns: __vue_staticRenderFns__$cN
}, __vue_inject_styles__$cN, __vue_script__$cN, __vue_scope_id__$cN, __vue_is_functional_template__$cN, __vue_module_identifier__$cN, false, undefined, undefined, undefined);

var script$cM = Vue.extend({
  name: "PhCaretDoubleDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cM = script$cM;
/* template */

var __vue_render__$cM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "208 48 128 128 48 48 208 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "208 48 128 128 48 48 208 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,120H147.3l66.4-66.3a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,40H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L108.7,120H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l80,80a8.2,8.2,0,0,0,11.4,0l80-80a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 128 128 208 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 128 128 48 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cM = [];
/* style */

const __vue_inject_styles__$cM = undefined;
/* scoped */

const __vue_scope_id__$cM = undefined;
/* module identifier */

const __vue_module_identifier__$cM = undefined;
/* functional template */

const __vue_is_functional_template__$cM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cM,
  staticRenderFns: __vue_staticRenderFns__$cM
}, __vue_inject_styles__$cM, __vue_script__$cM, __vue_scope_id__$cM, __vue_is_functional_template__$cM, __vue_module_identifier__$cM, false, undefined, undefined, undefined);

var script$cL = Vue.extend({
  name: "PhCaretDoubleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cL = script$cL;
/* template */

var __vue_render__$cL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "200 208 120 128 200 48 200 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "200 208 120 128 200 48 200 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M203.1,40.6a8.4,8.4,0,0,0-8.8,1.7L128,108.7V48a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-80,80a8.1,8.1,0,0,0,0,11.4l80,80A8.3,8.3,0,0,0,120,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,128,208V147.3l66.3,66.4A8.3,8.3,0,0,0,200,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,208,208V48A8,8,0,0,0,203.1,40.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 208 120 128 200 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 208 40 128 120 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cL = [];
/* style */

const __vue_inject_styles__$cL = undefined;
/* scoped */

const __vue_scope_id__$cL = undefined;
/* module identifier */

const __vue_module_identifier__$cL = undefined;
/* functional template */

const __vue_is_functional_template__$cL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cL,
  staticRenderFns: __vue_staticRenderFns__$cL
}, __vue_inject_styles__$cL, __vue_script__$cL, __vue_scope_id__$cL, __vue_is_functional_template__$cL, __vue_module_identifier__$cL, false, undefined, undefined, undefined);

var script$cK = Vue.extend({
  name: "PhCaretDoubleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cK = script$cK;
/* template */

var __vue_render__$cK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 48 136 128 56 208 56 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "56 48 136 128 56 208 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.7,122.3l-80-80a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,128,48v60.7L61.7,42.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,48,48V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3L128,147.3V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l80-80A8.1,8.1,0,0,0,221.7,122.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "56 48 136 128 56 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 48 216 128 136 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cK = [];
/* style */

const __vue_inject_styles__$cK = undefined;
/* scoped */

const __vue_scope_id__$cK = undefined;
/* module identifier */

const __vue_module_identifier__$cK = undefined;
/* functional template */

const __vue_is_functional_template__$cK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cK,
  staticRenderFns: __vue_staticRenderFns__$cK
}, __vue_inject_styles__$cK, __vue_script__$cK, __vue_scope_id__$cK, __vue_is_functional_template__$cK, __vue_module_identifier__$cK, false, undefined, undefined, undefined);

var script$cJ = Vue.extend({
  name: "PhCaretDoubleUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cJ = script$cJ;
/* template */

var __vue_render__$cJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "48 208 128 128 208 208 48 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 208 128 128 208 208 48 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M147.3,136H208a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-80-80a8.1,8.1,0,0,0-11.4,0l-80,80a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,136h60.7L42.3,202.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,216H208a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 208 128 128 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 128 128 48 208 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cJ = [];
/* style */

const __vue_inject_styles__$cJ = undefined;
/* scoped */

const __vue_scope_id__$cJ = undefined;
/* module identifier */

const __vue_module_identifier__$cJ = undefined;
/* functional template */

const __vue_is_functional_template__$cJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cJ,
  staticRenderFns: __vue_staticRenderFns__$cJ
}, __vue_inject_styles__$cJ, __vue_script__$cJ, __vue_scope_id__$cJ, __vue_is_functional_template__$cJ, __vue_module_identifier__$cJ, false, undefined, undefined, undefined);

var script$cI = Vue.extend({
  name: "PhCaretDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cI = script$cI;
/* template */

var __vue_render__$cI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "208 96 128 176 48 96 208 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "208 96 128 176 48 96 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.4,92.9A8,8,0,0,0,208,88H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l80,80a8.2,8.2,0,0,0,11.4,0l80-80A8.4,8.4,0,0,0,215.4,92.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 128 176 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cI = [];
/* style */

const __vue_inject_styles__$cI = undefined;
/* scoped */

const __vue_scope_id__$cI = undefined;
/* module identifier */

const __vue_module_identifier__$cI = undefined;
/* functional template */

const __vue_is_functional_template__$cI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cI,
  staticRenderFns: __vue_staticRenderFns__$cI
}, __vue_inject_styles__$cI, __vue_script__$cI, __vue_scope_id__$cI, __vue_is_functional_template__$cI, __vue_module_identifier__$cI, false, undefined, undefined, undefined);

var script$cH = Vue.extend({
  name: "PhCaretLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cH = script$cH;
/* template */

var __vue_render__$cH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 208 80 128 160 48 160 208",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 208 80 128 160 48 160 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.1,40.6a8.4,8.4,0,0,0-8.8,1.7l-80,80a8.1,8.1,0,0,0,0,11.4l80,80A8.3,8.3,0,0,0,160,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,168,208V48A8,8,0,0,0,163.1,40.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 208 80 128 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cH = [];
/* style */

const __vue_inject_styles__$cH = undefined;
/* scoped */

const __vue_scope_id__$cH = undefined;
/* module identifier */

const __vue_module_identifier__$cH = undefined;
/* functional template */

const __vue_is_functional_template__$cH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cH,
  staticRenderFns: __vue_staticRenderFns__$cH
}, __vue_inject_styles__$cH, __vue_script__$cH, __vue_scope_id__$cH, __vue_is_functional_template__$cH, __vue_module_identifier__$cH, false, undefined, undefined, undefined);

var script$cG = Vue.extend({
  name: "PhCaretRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cG = script$cG;
/* template */

var __vue_render__$cG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 48 176 128 96 208 96 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "96 48 176 128 96 208 96 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M181.7,122.3l-80-80a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,88,48V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l80-80A8.1,8.1,0,0,0,181.7,122.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 48 176 128 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cG = [];
/* style */

const __vue_inject_styles__$cG = undefined;
/* scoped */

const __vue_scope_id__$cG = undefined;
/* module identifier */

const __vue_module_identifier__$cG = undefined;
/* functional template */

const __vue_is_functional_template__$cG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cG,
  staticRenderFns: __vue_staticRenderFns__$cG
}, __vue_inject_styles__$cG, __vue_script__$cG, __vue_scope_id__$cG, __vue_is_functional_template__$cG, __vue_module_identifier__$cG, false, undefined, undefined, undefined);

var script$cF = Vue.extend({
  name: "PhCaretUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cF = script$cF;
/* template */

var __vue_render__$cF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "48 160 128 80 208 160 48 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 160 128 80 208 160 48 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,154.3l-80-80a8.1,8.1,0,0,0-11.4,0l-80,80a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,168H208a8,8,0,0,0,7.4-4.9A8.4,8.4,0,0,0,213.7,154.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 160 128 80 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cF = [];
/* style */

const __vue_inject_styles__$cF = undefined;
/* scoped */

const __vue_scope_id__$cF = undefined;
/* module identifier */

const __vue_module_identifier__$cF = undefined;
/* functional template */

const __vue_is_functional_template__$cF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cF,
  staticRenderFns: __vue_staticRenderFns__$cF
}, __vue_inject_styles__$cF, __vue_script__$cF, __vue_scope_id__$cF, __vue_is_functional_template__$cF, __vue_module_identifier__$cF, false, undefined, undefined, undefined);

var script$cE = Vue.extend({
  name: "PhCat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cE = script$cE;
/* template */

var __vue_render__$cE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "49.9",
      "x2": "108",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "49.9",
      "x2": "148",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.4,36.3a16.3,16.3,0,0,0-17,4L187.5,57.2a111.5,111.5,0,0,0-119,0L51.6,40.3a16.3,16.3,0,0,0-17-4A15.9,15.9,0,0,0,24,51.3V136c0,49.1,40.1,89.6,91.6,95.3a4,4,0,0,0,4.4-4v-32l-13.4-13.4a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L128,180.7l10.3-10.4a8.1,8.1,0,0,1,11.5.2,8.3,8.3,0,0,1-.4,11.4L136,195.3v32a4,4,0,0,0,4.4,4c51.5-5.7,91.6-46.2,91.6-95.3V51.3A15.9,15.9,0,0,0,221.4,36.3ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,0,1-16,0V69a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "53",
      "x2": "96",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "53",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cE = [];
/* style */

const __vue_inject_styles__$cE = undefined;
/* scoped */

const __vue_scope_id__$cE = undefined;
/* module identifier */

const __vue_module_identifier__$cE = undefined;
/* functional template */

const __vue_is_functional_template__$cE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cE,
  staticRenderFns: __vue_staticRenderFns__$cE
}, __vue_inject_styles__$cE, __vue_script__$cE, __vue_scope_id__$cE, __vue_is_functional_template__$cE, __vue_module_identifier__$cE, false, undefined, undefined, undefined);

var script$cD = Vue.extend({
  name: "PhCellSignalFull",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cD = script$cD;
/* template */

var __vue_render__$cD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L16,196.7A16,16,0,0,0,27.3,224H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cD = [];
/* style */

const __vue_inject_styles__$cD = undefined;
/* scoped */

const __vue_scope_id__$cD = undefined;
/* module identifier */

const __vue_module_identifier__$cD = undefined;
/* functional template */

const __vue_is_functional_template__$cD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cD,
  staticRenderFns: __vue_staticRenderFns__$cD
}, __vue_inject_styles__$cD, __vue_script__$cD, __vue_scope_id__$cD, __vue_is_functional_template__$cD, __vue_module_identifier__$cD, false, undefined, undefined, undefined);

var script$cC = Vue.extend({
  name: "PhCellSignalHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cC = script$cC;
/* template */

var __vue_render__$cC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,216H27.3a8,8,0,0,1-5.6-13.7L160,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L16,196.7a15.7,15.7,0,0,0-4.7,11.6,4.9,4.9,0,0,0,.1,1.2,14.7,14.7,0,0,0,1.1,4.6,16,16,0,0,0,6.9,7.8l1,.6,2.2.8a14.9,14.9,0,0,0,4.7.7H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H168V67.3l24-24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "64",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cC = [];
/* style */

const __vue_inject_styles__$cC = undefined;
/* scoped */

const __vue_scope_id__$cC = undefined;
/* module identifier */

const __vue_module_identifier__$cC = undefined;
/* functional template */

const __vue_is_functional_template__$cC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cC,
  staticRenderFns: __vue_staticRenderFns__$cC
}, __vue_inject_styles__$cC, __vue_script__$cC, __vue_scope_id__$cC, __vue_is_functional_template__$cC, __vue_module_identifier__$cC, false, undefined, undefined, undefined);

var script$cB = Vue.extend({
  name: "PhCellSignalLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cB = script$cB;
/* template */

var __vue_render__$cB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216H27.3a8,8,0,0,1-5.6-13.7L80,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L74.3,138.3h0L16,196.7A16,16,0,0,0,27.3,224H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H88V147.3l104-104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cB = [];
/* style */

const __vue_inject_styles__$cB = undefined;
/* scoped */

const __vue_scope_id__$cB = undefined;
/* module identifier */

const __vue_module_identifier__$cB = undefined;
/* functional template */

const __vue_is_functional_template__$cB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cB,
  staticRenderFns: __vue_staticRenderFns__$cB
}, __vue_inject_styles__$cB, __vue_script__$cB, __vue_scope_id__$cB, __vue_is_functional_template__$cB, __vue_module_identifier__$cB, false, undefined, undefined, undefined);

var script$cA = Vue.extend({
  name: "PhCellSignalMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cA = script$cA;
/* template */

var __vue_render__$cA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,216H27.3a8,8,0,0,1-5.6-13.7L120,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L114.3,98.3h0L16,196.7a15.7,15.7,0,0,0-4.7,11.6,4.9,4.9,0,0,0,.1,1.2,14.7,14.7,0,0,0,1.1,4.6,16,16,0,0,0,6.9,7.8l1,.6,2.2.8a14.9,14.9,0,0,0,4.7.7H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H128V107.3l64-64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "104",
      "x2": "120",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cA = [];
/* style */

const __vue_inject_styles__$cA = undefined;
/* scoped */

const __vue_scope_id__$cA = undefined;
/* module identifier */

const __vue_module_identifier__$cA = undefined;
/* functional template */

const __vue_is_functional_template__$cA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cA,
  staticRenderFns: __vue_staticRenderFns__$cA
}, __vue_inject_styles__$cA, __vue_script__$cA, __vue_scope_id__$cA, __vue_is_functional_template__$cA, __vue_module_identifier__$cA, false, undefined, undefined, undefined);

var script$cz = Vue.extend({
  name: "PhCellSignalNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cz = script$cz;
/* template */

var __vue_render__$cz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,224H27.3A16,16,0,0,1,16,196.7L180.7,32A16,16,0,0,1,208,43.3V208A16,16,0,0,1,192,224ZM27.3,208H192V43.3L27.3,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cz = [];
/* style */

const __vue_inject_styles__$cz = undefined;
/* scoped */

const __vue_scope_id__$cz = undefined;
/* module identifier */

const __vue_module_identifier__$cz = undefined;
/* functional template */

const __vue_is_functional_template__$cz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cz,
  staticRenderFns: __vue_staticRenderFns__$cz
}, __vue_inject_styles__$cz, __vue_script__$cz, __vue_scope_id__$cz, __vue_is_functional_template__$cz, __vue_module_identifier__$cz, false, undefined, undefined, undefined);

var script$cy = Vue.extend({
  name: "PhCellSignalSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cy = script$cy;
/* template */

var __vue_render__$cy = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.1,82.9l45.2-45.2A8,8,0,0,1,200,43.3V147.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a7.9,7.9,0,0,1-5.6-13.6L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.5,94a8,8,0,0,1,.3-11.1L180.7,32A16,16,0,0,1,208,43.3V159.6a8,8,0,0,1-5.1,7.5,7.4,7.4,0,0,1-2.9.5,7.9,7.9,0,0,1-5.9-2.6Zm84.4,116.6-160-176a8,8,0,0,0-11.3-.5,7.9,7.9,0,0,0-.5,11.3L101.7,111,16,196.7A16,16,0,0,0,27.3,224H208a8.2,8.2,0,0,0,5.4-2.1A8,8,0,0,0,213.9,210.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cy = [];
/* style */

const __vue_inject_styles__$cy = undefined;
/* scoped */

const __vue_scope_id__$cy = undefined;
/* module identifier */

const __vue_module_identifier__$cy = undefined;
/* functional template */

const __vue_is_functional_template__$cy = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cy = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cy,
  staticRenderFns: __vue_staticRenderFns__$cy
}, __vue_inject_styles__$cy, __vue_script__$cy, __vue_scope_id__$cy, __vue_is_functional_template__$cy, __vue_module_identifier__$cy, false, undefined, undefined, undefined);

var script$cx = Vue.extend({
  name: "PhCellSignalX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cx = script$cx;
/* template */

var __vue_render__$cx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,184v24a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,146.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L200,139.3l-18.3,18.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L188.7,128l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4L200,116.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L211.3,128Zm-26.9,18.5a3.9,3.9,0,0,0-5.6,0L193,169a24,24,0,0,1-17,7,23.6,23.6,0,0,1-17.2-7.3c-9.2-9.5-8.7-24.7.6-34.1l6.7-6.6-6.7-6.6c-9.5-9.6-9.7-25.4,0-34.7A24.1,24.1,0,0,1,193,87l4.2,4.2a3.9,3.9,0,0,0,5.6,0L207,87h0a2.9,2.9,0,0,0,1-2.3V43.8a16.6,16.6,0,0,0-9.2-15A15.9,15.9,0,0,0,180.7,32L16.3,196.4a16.3,16.3,0,0,0-4,17,15.9,15.9,0,0,0,15,10.6H192a16,16,0,0,0,16-16V171.2a3,3,0,0,0-1-2.2h0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cx = [];
/* style */

const __vue_inject_styles__$cx = undefined;
/* scoped */

const __vue_scope_id__$cx = undefined;
/* module identifier */

const __vue_module_identifier__$cx = undefined;
/* functional template */

const __vue_is_functional_template__$cx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cx,
  staticRenderFns: __vue_staticRenderFns__$cx
}, __vue_inject_styles__$cx, __vue_script__$cx, __vue_scope_id__$cx, __vue_is_functional_template__$cx, __vue_module_identifier__$cx, false, undefined, undefined, undefined);

var script$cw = Vue.extend({
  name: "PhChalkboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cw = script$cw;
/* template */

var __vue_render__$cw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 160 184 160 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 200 72 88 184 88 184 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "120 168 192 168 192 80 64 80 64 200 120 200 120 168",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,192h-8V56a16,16,0,0,0-16-16H40A16,16,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-24,0H144V176a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Zm0-48a8,8,0,0,1-16,0V72H56V184a8,8,0,0,1-16,0V64a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 192 168 192 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 200 64 80 192 80 192 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cw = [];
/* style */

const __vue_inject_styles__$cw = undefined;
/* scoped */

const __vue_scope_id__$cw = undefined;
/* module identifier */

const __vue_module_identifier__$cw = undefined;
/* functional template */

const __vue_is_functional_template__$cw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cw,
  staticRenderFns: __vue_staticRenderFns__$cw
}, __vue_inject_styles__$cw, __vue_script__$cw, __vue_scope_id__$cw, __vue_is_functional_template__$cw, __vue_module_identifier__$cw, false, undefined, undefined, undefined);

var script$cv = Vue.extend({
  name: "PhChalkboardSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cv = script$cv;
/* template */

var __vue_render__$cv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,160V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 160 184 160 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "120",
      "y": "168",
      "width": "64",
      "height": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,192h-8V56a16,16,0,0,0-16-16H40A16,16,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-40,0H128V176a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "200",
      "x2": "240",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 200 120 168 184 168 184 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cv = [];
/* style */

const __vue_inject_styles__$cv = undefined;
/* scoped */

const __vue_scope_id__$cv = undefined;
/* module identifier */

const __vue_module_identifier__$cv = undefined;
/* functional template */

const __vue_is_functional_template__$cv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cv,
  staticRenderFns: __vue_staticRenderFns__$cv
}, __vue_inject_styles__$cv, __vue_script__$cv, __vue_scope_id__$cv, __vue_is_functional_template__$cv, __vue_module_identifier__$cv, false, undefined, undefined, undefined);

var script$cu = Vue.extend({
  name: "PhChalkboardTeacher",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cu = script$cu;
/* template */

var __vue_render__$cu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 172 188 84 68 84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.3,208H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H58.7a48.1,48.1,0,0,1,90.6,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,144a32,32,0,1,1,32,32h88V80H64v64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H53.4a7.9,7.9,0,0,0,7.2-4.6,48.1,48.1,0,0,1,86.8,0,7.9,7.9,0,0,0,7.2,4.6H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,168a32,32,0,1,1,32-32A32.1,32.1,0,0,1,104,168Zm112,32H159.4a63.7,63.7,0,0,0-13.1-16H192a8,8,0,0,0,8-8V80a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v96a8,8,0,0,0,6,7.7A64.2,64.2,0,0,0,48.6,200H40V56H216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 176 192 176 192 80 64 80 64 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cu = [];
/* style */

const __vue_inject_styles__$cu = undefined;
/* scoped */

const __vue_scope_id__$cu = undefined;
/* module identifier */

const __vue_module_identifier__$cu = undefined;
/* functional template */

const __vue_is_functional_template__$cu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cu,
  staticRenderFns: __vue_staticRenderFns__$cu
}, __vue_inject_styles__$cu, __vue_script__$cu, __vue_scope_id__$cu, __vue_is_functional_template__$cu, __vue_module_identifier__$cu, false, undefined, undefined, undefined);

var script$ct = Vue.extend({
  name: "PhChartBar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ct = script$ct;
/* template */

var __vue_render__$ct = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228,200h-8V40a8,8,0,0,0-8-8H156a8,8,0,0,0-8,8V80H100a8,8,0,0,0-8,8v40H44a8,8,0,0,0-8,8v64H28a8,8,0,0,0,0,16H228a8,8,0,0,0,0-16ZM108,96h40V200H108ZM52,144H92v56H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "44 208 44 136 100 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "208",
      "x2": "28",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 208 100 88 156 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "56",
      "height": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ct = [];
/* style */

const __vue_inject_styles__$ct = undefined;
/* scoped */

const __vue_scope_id__$ct = undefined;
/* module identifier */

const __vue_module_identifier__$ct = undefined;
/* functional template */

const __vue_is_functional_template__$ct = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ct = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ct,
  staticRenderFns: __vue_staticRenderFns__$ct
}, __vue_inject_styles__$ct, __vue_script__$ct, __vue_scope_id__$ct, __vue_is_functional_template__$ct, __vue_module_identifier__$ct, false, undefined, undefined, undefined);

var script$cs = Vue.extend({
  name: "PhChartBarHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cs = script$cs;
/* template */

var __vue_render__$cs = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,96H176V56a8,8,0,0,0-8-8H48V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a8,8,0,0,0,8-8V160h72a8,8,0,0,0,8-8V104A8,8,0,0,0,216,96ZM160,64V96H48V64ZM128,192H48V160h80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 168 56 168 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "104",
      "width": "176",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 152 136 200 40 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cs = [];
/* style */

const __vue_inject_styles__$cs = undefined;
/* scoped */

const __vue_scope_id__$cs = undefined;
/* module identifier */

const __vue_module_identifier__$cs = undefined;
/* functional template */

const __vue_is_functional_template__$cs = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cs = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cs,
  staticRenderFns: __vue_staticRenderFns__$cs
}, __vue_inject_styles__$cs, __vue_script__$cs, __vue_scope_id__$cs, __vue_is_functional_template__$cs, __vue_module_identifier__$cs, false, undefined, undefined, undefined);

var script$cr = Vue.extend({
  name: "PhChartLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cr = script$cr;
/* template */

var __vue_render__$cr = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 160 152 96 104 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 160 152 96 104 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,200H40V163.6l56.4-49.3,58.8,44.1a8,8,0,0,0,10.1-.4l64-56a8,8,0,1,0-10.6-12l-59.1,51.7L100.8,97.6a8,8,0,0,0-10.1.4L40,142.4V48a8,8,0,0,0-16,0V208a8,8,0,0,0,8,8H224a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 160 152 96 104 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 160 152 96 104 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 160 152 96 104 32 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cr = [];
/* style */

const __vue_inject_styles__$cr = undefined;
/* scoped */

const __vue_scope_id__$cr = undefined;
/* module identifier */

const __vue_module_identifier__$cr = undefined;
/* functional template */

const __vue_is_functional_template__$cr = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cr = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cr,
  staticRenderFns: __vue_staticRenderFns__$cr
}, __vue_inject_styles__$cr, __vue_script__$cr, __vue_scope_id__$cr, __vue_is_functional_template__$cr, __vue_module_identifier__$cr, false, undefined, undefined, undefined);

var script$cq = Vue.extend({
  name: "PhChartLineUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cq = script$cq;
/* template */

var __vue_render__$cq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 64 128 144 96 112 32 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 104 208 64 168 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 64 128 144 96 112 32 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 104 208 64 168 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.7l50.3-50.4a8.1,8.1,0,0,1,11.4,0L128,132.7,176.7,84,162.3,69.7a8.4,8.4,0,0,1-1.7-8.8A8.1,8.1,0,0,1,168,56h40a8,8,0,0,1,8,8v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,95.3l-54.3,54.4a8.1,8.1,0,0,1-11.4,0L96,123.3l-56,56V200H224A8,8,0,0,1,232,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 64 128 144 96 112 32 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 104 208 64 168 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 64 128 144 96 112 32 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 104 208 64 168 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 208 32 208 32 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 64 128 144 96 112 32 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 104 208 64 168 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cq = [];
/* style */

const __vue_inject_styles__$cq = undefined;
/* scoped */

const __vue_scope_id__$cq = undefined;
/* module identifier */

const __vue_module_identifier__$cq = undefined;
/* functional template */

const __vue_is_functional_template__$cq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cq,
  staticRenderFns: __vue_staticRenderFns__$cq
}, __vue_inject_styles__$cq, __vue_script__$cq, __vue_scope_id__$cq, __vue_is_functional_template__$cq, __vue_module_identifier__$cq, false, undefined, undefined, undefined);

var script$cp = Vue.extend({
  name: "PhChartPie",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cp = script$cp;
/* template */

var __vue_render__$cp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,44.9,176h-.1A96.1,96.1,0,0,1,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.3,76.4a.8.8,0,0,1-.2-.4l-.4-.5a104,104,0,0,0-180,104.1l.2.4.3.4a104,104,0,0,0,180.1-104Zm-18.4.9L136,114.1V40.4A88.2,88.2,0,0,1,199.9,77.3ZM128,216a88,88,0,0,1-71.9-37.3L207.9,91.1A88,88,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cp = [];
/* style */

const __vue_inject_styles__$cp = undefined;
/* scoped */

const __vue_scope_id__$cp = undefined;
/* module identifier */

const __vue_module_identifier__$cp = undefined;
/* functional template */

const __vue_is_functional_template__$cp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cp,
  staticRenderFns: __vue_staticRenderFns__$cp
}, __vue_inject_styles__$cp, __vue_script__$cp, __vue_scope_id__$cp, __vue_is_functional_template__$cp, __vue_module_identifier__$cp, false, undefined, undefined, undefined);

var script$co = Vue.extend({
  name: "PhChartPieSlice",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$co = script$co;
/* template */

var __vue_render__$co = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.2,176.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,106.1,32.5,138.2c-.3-3.4-.5-6.8-.5-10.2A96,96,0,0,1,88,40.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.2,176.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M100,116.5a8.1,8.1,0,0,0,4-7v-72a8,8,0,0,0-10.7-7.6A104.3,104.3,0,0,0,24,128a109.1,109.1,0,0,0,1.7,19,8.1,8.1,0,0,0,4.5,5.8,8.4,8.4,0,0,0,3.4.8,8,8,0,0,0,4-1.1ZM88,49.6v55.3L40.1,132.6c-.1-1.6-.1-3.1-.1-4.6A88.3,88.3,0,0,1,88,49.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.3,76.4a.8.8,0,0,1-.2-.4l-.4-.5A103.9,103.9,0,0,0,128,24a8,8,0,0,0-8,8v91.4L40.9,169.1a7.9,7.9,0,0,0-3,10.9v.2l.3.5A104,104,0,0,0,232,128,103.5,103.5,0,0,0,218.3,76.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.2,176.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.2,176.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "211.1",
      "y1": "80",
      "x2": "44.9",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A96,96,0,1,1,45.2,176.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$co = [];
/* style */

const __vue_inject_styles__$co = undefined;
/* scoped */

const __vue_scope_id__$co = undefined;
/* module identifier */

const __vue_module_identifier__$co = undefined;
/* functional template */

const __vue_is_functional_template__$co = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$co = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$co,
  staticRenderFns: __vue_staticRenderFns__$co
}, __vue_inject_styles__$co, __vue_script__$co, __vue_scope_id__$co, __vue_is_functional_template__$co, __vue_module_identifier__$co, false, undefined, undefined, undefined);

var script$cn = Vue.extend({
  name: "PhChat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cn = script$cn;
/* template */

var __vue_render__$cn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,16,16,0,0,0,17-2.2L82,208.4l134-.4a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cn = [];
/* style */

const __vue_inject_styles__$cn = undefined;
/* scoped */

const __vue_scope_id__$cn = undefined;
/* module identifier */

const __vue_module_identifier__$cn = undefined;
/* functional template */

const __vue_is_functional_template__$cn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cn,
  staticRenderFns: __vue_staticRenderFns__$cn
}, __vue_inject_styles__$cn, __vue_script__$cn, __vue_scope_id__$cn, __vue_is_functional_template__$cn, __vue_module_identifier__$cn, false, undefined, undefined, undefined);

var script$cm = Vue.extend({
  name: "PhChatCentered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cm = script$cm;
/* template */

var __vue_render__$cm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cm = [];
/* style */

const __vue_inject_styles__$cm = undefined;
/* scoped */

const __vue_scope_id__$cm = undefined;
/* module identifier */

const __vue_module_identifier__$cm = undefined;
/* functional template */

const __vue_is_functional_template__$cm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cm,
  staticRenderFns: __vue_staticRenderFns__$cm
}, __vue_inject_styles__$cm, __vue_script__$cm, __vue_scope_id__$cm, __vue_is_functional_template__$cm, __vue_module_identifier__$cm, false, undefined, undefined, undefined);

var script$cl = Vue.extend({
  name: "PhChatCenteredDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cl = script$cl;
/* template */

var __vue_render__$cl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "120",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "120",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM80,132a12,12,0,1,1,12-12A12,12,0,0,1,80,132Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,132Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,132Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "120",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cl = [];
/* style */

const __vue_inject_styles__$cl = undefined;
/* scoped */

const __vue_scope_id__$cl = undefined;
/* module identifier */

const __vue_module_identifier__$cl = undefined;
/* functional template */

const __vue_is_functional_template__$cl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cl,
  staticRenderFns: __vue_staticRenderFns__$cl
}, __vue_inject_styles__$cl, __vue_script__$cl, __vue_scope_id__$cl, __vue_is_functional_template__$cl, __vue_module_identifier__$cl, false, undefined, undefined, undefined);

var script$ck = Vue.extend({
  name: "PhChatCenteredText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ck = script$ck;
/* template */

var __vue_render__$ck = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "100",
      "x2": "160",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "140",
      "x2": "160",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "104",
      "x2": "160",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM160,144H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "104",
      "x2": "160",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "104",
      "x2": "160",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "104",
      "x2": "160",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ck = [];
/* style */

const __vue_inject_styles__$ck = undefined;
/* scoped */

const __vue_scope_id__$ck = undefined;
/* module identifier */

const __vue_module_identifier__$ck = undefined;
/* functional template */

const __vue_is_functional_template__$ck = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ck = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ck,
  staticRenderFns: __vue_staticRenderFns__$ck
}, __vue_inject_styles__$ck, __vue_script__$ck, __vue_scope_id__$ck, __vue_is_functional_template__$ck, __vue_module_identifier__$ck, false, undefined, undefined, undefined);

var script$cj = Vue.extend({
  name: "PhChatCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cj = script$cj;
/* template */

var __vue_render__$cj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cj = [];
/* style */

const __vue_inject_styles__$cj = undefined;
/* scoped */

const __vue_scope_id__$cj = undefined;
/* module identifier */

const __vue_module_identifier__$cj = undefined;
/* functional template */

const __vue_is_functional_template__$cj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cj,
  staticRenderFns: __vue_staticRenderFns__$cj
}, __vue_inject_styles__$cj, __vue_script__$cj, __vue_scope_id__$cj, __vue_is_functional_template__$cj, __vue_module_identifier__$cj, false, undefined, undefined, undefined);

var script$ci = Vue.extend({
  name: "PhChatCircleDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ci = script$ci;
/* template */

var __vue_render__$ci = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,0,0,36.8,178l-8.5,29.9a16.1,16.1,0,0,0,4,15.8,15.8,15.8,0,0,0,15.7,4l30-8.5A104,104,0,1,0,128,24ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ci = [];
/* style */

const __vue_inject_styles__$ci = undefined;
/* scoped */

const __vue_scope_id__$ci = undefined;
/* module identifier */

const __vue_module_identifier__$ci = undefined;
/* functional template */

const __vue_is_functional_template__$ci = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ci = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ci,
  staticRenderFns: __vue_staticRenderFns__$ci
}, __vue_inject_styles__$ci, __vue_script__$ci, __vue_scope_id__$ci, __vue_is_functional_template__$ci, __vue_module_identifier__$ci, false, undefined, undefined, undefined);

var script$ch = Vue.extend({
  name: "PhChatCircleText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ch = script$ch;
/* template */

var __vue_render__$ch = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "148",
      "x2": "160",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,0,0,36.8,178l-8.5,29.9a16.1,16.1,0,0,0,4,15.8,15.8,15.8,0,0,0,15.7,4l30-8.5A104,104,0,1,0,128,24Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ch = [];
/* style */

const __vue_inject_styles__$ch = undefined;
/* scoped */

const __vue_scope_id__$ch = undefined;
/* module identifier */

const __vue_module_identifier__$ch = undefined;
/* functional template */

const __vue_is_functional_template__$ch = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ch = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ch,
  staticRenderFns: __vue_staticRenderFns__$ch
}, __vue_inject_styles__$ch, __vue_script__$ch, __vue_scope_id__$ch, __vue_is_functional_template__$ch, __vue_module_identifier__$ch, false, undefined, undefined, undefined);

var script$cg = Vue.extend({
  name: "PhChatDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cg = script$cg;
/* template */

var __vue_render__$cg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,14.7,14.7,0,0,0,6.7,1.6,16,16,0,0,0,10.3-3.8l31.8-26.7L216,208a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cg = [];
/* style */

const __vue_inject_styles__$cg = undefined;
/* scoped */

const __vue_scope_id__$cg = undefined;
/* module identifier */

const __vue_module_identifier__$cg = undefined;
/* functional template */

const __vue_is_functional_template__$cg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cg,
  staticRenderFns: __vue_staticRenderFns__$cg
}, __vue_inject_styles__$cg, __vue_script__$cg, __vue_scope_id__$cg, __vue_is_functional_template__$cg, __vue_module_identifier__$cg, false, undefined, undefined, undefined);

var script$cf = Vue.extend({
  name: "PhChatTeardrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cf = script$cf;
/* template */

var __vue_render__$cf = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cf = [];
/* style */

const __vue_inject_styles__$cf = undefined;
/* scoped */

const __vue_scope_id__$cf = undefined;
/* module identifier */

const __vue_module_identifier__$cf = undefined;
/* functional template */

const __vue_is_functional_template__$cf = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cf = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cf,
  staticRenderFns: __vue_staticRenderFns__$cf
}, __vue_inject_styles__$cf, __vue_script__$cf, __vue_scope_id__$cf, __vue_is_functional_template__$cf, __vue_module_identifier__$cf, false, undefined, undefined, undefined);

var script$ce = Vue.extend({
  name: "PhChatTeardropDots",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ce = script$ce;
/* template */

var __vue_render__$ce = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,132,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,180,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ce = [];
/* style */

const __vue_inject_styles__$ce = undefined;
/* scoped */

const __vue_scope_id__$ce = undefined;
/* module identifier */

const __vue_module_identifier__$ce = undefined;
/* functional template */

const __vue_is_functional_template__$ce = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ce = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ce,
  staticRenderFns: __vue_staticRenderFns__$ce
}, __vue_inject_styles__$ce, __vue_script__$ce, __vue_scope_id__$ce, __vue_is_functional_template__$ce, __vue_module_identifier__$ce, false, undefined, undefined, undefined);

var script$cd = Vue.extend({
  name: "PhChatTeardropText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cd = script$cd;
/* template */

var __vue_render__$cd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "148",
      "x2": "160",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200Zm28,128H100a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Zm0-32H100a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cd = [];
/* style */

const __vue_inject_styles__$cd = undefined;
/* scoped */

const __vue_scope_id__$cd = undefined;
/* module identifier */

const __vue_module_identifier__$cd = undefined;
/* functional template */

const __vue_is_functional_template__$cd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cd,
  staticRenderFns: __vue_staticRenderFns__$cd
}, __vue_inject_styles__$cd, __vue_script__$cd, __vue_scope_id__$cd, __vue_is_functional_template__$cd, __vue_module_identifier__$cd, false, undefined, undefined, undefined);

var script$cc = Vue.extend({
  name: "PhChatText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cc = script$cc;
/* template */

var __vue_render__$cc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "148",
      "x2": "160",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,16,16,0,0,0,17-2.2L82,208.4l134-.4a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM160,152H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "160",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cc = [];
/* style */

const __vue_inject_styles__$cc = undefined;
/* scoped */

const __vue_scope_id__$cc = undefined;
/* module identifier */

const __vue_module_identifier__$cc = undefined;
/* functional template */

const __vue_is_functional_template__$cc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cc,
  staticRenderFns: __vue_staticRenderFns__$cc
}, __vue_inject_styles__$cc, __vue_script__$cc, __vue_scope_id__$cc, __vue_is_functional_template__$cc, __vue_module_identifier__$cc, false, undefined, undefined, undefined);

var script$cb = Vue.extend({
  name: "PhChats",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$cb = script$cb;
/* template */

var __vue_render__$cb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176v48a8,8,0,0,1-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,96a16,16,0,0,0-16-16H184V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V176a7.9,7.9,0,0,0,4.6,7.2,7.8,7.8,0,0,0,8.4-1l35-28.3V184a16,16,0,0,0,16,16h93.6L219,230.2a7.8,7.8,0,0,0,8.4,1A7.9,7.9,0,0,0,232,224Zm-42.6,89.8a7.7,7.7,0,0,0-5-1.8H88V152h80a16,16,0,0,0,16-16V96h32V207.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$cb = [];
/* style */

const __vue_inject_styles__$cb = undefined;
/* scoped */

const __vue_scope_id__$cb = undefined;
/* module identifier */

const __vue_module_identifier__$cb = undefined;
/* functional template */

const __vue_is_functional_template__$cb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$cb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$cb,
  staticRenderFns: __vue_staticRenderFns__$cb
}, __vue_inject_styles__$cb, __vue_script__$cb, __vue_scope_id__$cb, __vue_is_functional_template__$cb, __vue_module_identifier__$cb, false, undefined, undefined, undefined);

var script$ca = Vue.extend({
  name: "PhChatsCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ca = script$ca;
/* template */

var __vue_render__$ca = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6h0A70.2,70.2,0,0,1,168,104a72,72,0,0,1-72,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.5,189.8A80,80,0,0,0,169.6,72.6,80,80,0,1,0,25.5,141.8l-6.2,21.6a13.9,13.9,0,0,0,17.3,17.3l21.6-6.2a80.8,80.8,0,0,0,28.2,8.9,80,80,0,0,0,111.4,39.1l21.6,6.2a13.9,13.9,0,0,0,17.3-17.3Zm-15.4-5.1a7.6,7.6,0,0,0-.9,6.2l6.2,21.5-21.5-6.2a7.6,7.6,0,0,0-6.2.9,64.2,64.2,0,0,1-88.4-23.5A80.2,80.2,0,0,0,176,104a83.6,83.6,0,0,0-1.3-14.3A64,64,0,0,1,224,152,64.8,64.8,0,0,1,215.1,184.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ca = [];
/* style */

const __vue_inject_styles__$ca = undefined;
/* scoped */

const __vue_scope_id__$ca = undefined;
/* module identifier */

const __vue_module_identifier__$ca = undefined;
/* functional template */

const __vue_is_functional_template__$ca = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ca = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ca,
  staticRenderFns: __vue_staticRenderFns__$ca
}, __vue_inject_styles__$ca, __vue_script__$ca, __vue_scope_id__$ca, __vue_is_functional_template__$ca, __vue_module_identifier__$ca, false, undefined, undefined, undefined);

var script$c9 = Vue.extend({
  name: "PhChatsTeardrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c9 = script$c9;
/* template */

var __vue_render__$c9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M163.9,80.1A70.2,70.2,0,0,1,168,104h0a72,72,0,0,1-72,72H92.1A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M169.6,72.6A80,80,0,0,0,16,104v66a14,14,0,0,0,14,14H86.7A80.2,80.2,0,0,0,160,232h66a14,14,0,0,0,14-14V152A79.8,79.8,0,0,0,169.6,72.6ZM224,216H160a64.2,64.2,0,0,1-55.7-32.4A80.2,80.2,0,0,0,176,104a83.6,83.6,0,0,0-1.3-14.3A64,64,0,0,1,224,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c9 = [];
/* style */

const __vue_inject_styles__$c9 = undefined;
/* scoped */

const __vue_scope_id__$c9 = undefined;
/* module identifier */

const __vue_module_identifier__$c9 = undefined;
/* functional template */

const __vue_is_functional_template__$c9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c9,
  staticRenderFns: __vue_staticRenderFns__$c9
}, __vue_inject_styles__$c9, __vue_script__$c9, __vue_scope_id__$c9, __vue_is_functional_template__$c9, __vue_module_identifier__$c9, false, undefined, undefined, undefined);

var script$c8 = Vue.extend({
  name: "PhCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c8 = script$c8;
/* template */

var __vue_render__$c8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72 104 184 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72 104 184 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,192a8.5,8.5,0,0,1-5.7-2.3l-56-56a8.1,8.1,0,0,1,11.4-11.4L104,172.7,210.3,66.3a8.1,8.1,0,0,1,11.4,11.4l-112,112A8.5,8.5,0,0,1,104,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72 104 184 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72 104 184 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 72 104 184 48 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c8 = [];
/* style */

const __vue_inject_styles__$c8 = undefined;
/* scoped */

const __vue_scope_id__$c8 = undefined;
/* module identifier */

const __vue_module_identifier__$c8 = undefined;
/* functional template */

const __vue_is_functional_template__$c8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c8,
  staticRenderFns: __vue_staticRenderFns__$c8
}, __vue_inject_styles__$c8, __vue_script__$c8, __vue_scope_id__$c8, __vue_is_functional_template__$c8, __vue_module_identifier__$c8, false, undefined, undefined, undefined);

var script$c7 = Vue.extend({
  name: "PhCheckCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c7 = script$c7;
/* template */

var __vue_render__$c7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm49.5,85.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.7,7.7,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c7 = [];
/* style */

const __vue_inject_styles__$c7 = undefined;
/* scoped */

const __vue_scope_id__$c7 = undefined;
/* module identifier */

const __vue_module_identifier__$c7 = undefined;
/* functional template */

const __vue_is_functional_template__$c7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c7,
  staticRenderFns: __vue_staticRenderFns__$c7
}, __vue_inject_styles__$c7, __vue_script__$c7, __vue_scope_id__$c7, __vue_is_functional_template__$c7, __vue_module_identifier__$c7, false, undefined, undefined, undefined);

var script$c6 = Vue.extend({
  name: "PhCheckSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c6 = script$c6;
/* template */

var __vue_render__$c6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-30.5,77.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c6 = [];
/* style */

const __vue_inject_styles__$c6 = undefined;
/* scoped */

const __vue_scope_id__$c6 = undefined;
/* module identifier */

const __vue_module_identifier__$c6 = undefined;
/* functional template */

const __vue_is_functional_template__$c6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c6,
  staticRenderFns: __vue_staticRenderFns__$c6
}, __vue_inject_styles__$c6, __vue_script__$c6, __vue_scope_id__$c6, __vue_is_functional_template__$c6, __vue_module_identifier__$c6, false, undefined, undefined, undefined);

var script$c5 = Vue.extend({
  name: "PhCheckSquareOffset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c5 = script$c5;
/* template */

var __vue_render__$c5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "44 44 44 196 60 212 212 212 212 44 44 44",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16,16,0,0,0,36,52v91.3a8,8,0,0,0,16,0V52H204V204H135.6a8,8,0,0,0,0,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,146.3a8.1,8.1,0,0,0-11.4,0L64,204.7,37.7,178.3a8.1,8.1,0,0,0-11.4,11.4l32,32a8.2,8.2,0,0,0,11.4,0l64-64A8.1,8.1,0,0,0,133.7,146.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 152 64 216 32 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c5 = [];
/* style */

const __vue_inject_styles__$c5 = undefined;
/* scoped */

const __vue_scope_id__$c5 = undefined;
/* module identifier */

const __vue_module_identifier__$c5 = undefined;
/* functional template */

const __vue_is_functional_template__$c5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c5,
  staticRenderFns: __vue_staticRenderFns__$c5
}, __vue_inject_styles__$c5, __vue_script__$c5, __vue_scope_id__$c5, __vue_is_functional_template__$c5, __vue_module_identifier__$c5, false, undefined, undefined, undefined);

var script$c4 = Vue.extend({
  name: "PhChecks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c4 = script$c4;
/* template */

var __vue_render__$c4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 84 56 172 12 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "244 84 156 172 139.9 155.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.6 148.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M153.7,89.7l-88,88a8.2,8.2,0,0,1-11.4,0l-44-44a8.1,8.1,0,0,1,11.4-11.4L60,160.7l82.3-82.4a8.1,8.1,0,0,1,11.4,11.4Zm92-11.4a8.1,8.1,0,0,0-11.4,0L152,160.7,134.3,143A8,8,0,0,0,123,154.3l23.3,23.4a8.2,8.2,0,0,0,11.4,0l88-88A8.1,8.1,0,0,0,245.7,78.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.6 148.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.6 148.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 84 60 172 16 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "240 84 152 172 128.6 148.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c4 = [];
/* style */

const __vue_inject_styles__$c4 = undefined;
/* scoped */

const __vue_scope_id__$c4 = undefined;
/* module identifier */

const __vue_module_identifier__$c4 = undefined;
/* functional template */

const __vue_is_functional_template__$c4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c4,
  staticRenderFns: __vue_staticRenderFns__$c4
}, __vue_inject_styles__$c4, __vue_script__$c4, __vue_scope_id__$c4, __vue_is_functional_template__$c4, __vue_module_identifier__$c4, false, undefined, undefined, undefined);

var script$c3 = Vue.extend({
  name: "PhCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c3 = script$c3;
/* template */

var __vue_render__$c3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "104"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c3 = [];
/* style */

const __vue_inject_styles__$c3 = undefined;
/* scoped */

const __vue_scope_id__$c3 = undefined;
/* module identifier */

const __vue_module_identifier__$c3 = undefined;
/* functional template */

const __vue_is_functional_template__$c3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c3,
  staticRenderFns: __vue_staticRenderFns__$c3
}, __vue_inject_styles__$c3, __vue_script__$c3, __vue_scope_id__$c3, __vue_is_functional_template__$c3, __vue_module_identifier__$c3, false, undefined, undefined, undefined);

var script$c2 = Vue.extend({
  name: "PhCircleDashed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c2 = script$c2;
/* template */

var __vue_render__$c2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M65.8,54.5a8,8,0,0,1,0,11.3A87.7,87.7,0,0,0,43,105.2a8.1,8.1,0,0,1-7.7,6l-2.1-.3a8,8,0,0,1-5.7-9.8,103.2,103.2,0,0,1,27-46.6A7.9,7.9,0,0,1,65.8,54.5ZM43,150.8a8,8,0,0,0-15.5,4.1,104.8,104.8,0,0,0,27,46.7,8,8,0,0,0,5.6,2.3,8.1,8.1,0,0,0,5.7-13.7A87.6,87.6,0,0,1,43,150.8ZM150.8,213a88.1,88.1,0,0,1-45.6,0,8,8,0,0,0-4.1,15.5,107,107,0,0,0,27,3.5,105.4,105.4,0,0,0,26.8-3.5,8,8,0,0,0-4.1-15.5Zm72-67.9a8,8,0,0,0-9.8,5.7,87.7,87.7,0,0,1-22.8,39.4,8.1,8.1,0,0,0,5.7,13.7,7.7,7.7,0,0,0,5.6-2.4,103.2,103.2,0,0,0,27-46.6A8,8,0,0,0,222.8,145.1ZM213,105.2a8.1,8.1,0,0,0,7.7,6l2.1-.3a8,8,0,0,0,5.7-9.8,104.8,104.8,0,0,0-27-46.7,7.9,7.9,0,0,0-11.3.1,8,8,0,0,0,0,11.3A87.6,87.6,0,0,1,213,105.2ZM105.2,43a88.1,88.1,0,0,1,45.6,0,7.6,7.6,0,0,0,2.1.3,8,8,0,0,0,2-15.8,104.4,104.4,0,0,0-53.8,0A8,8,0,0,0,105.2,43Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c2 = [];
/* style */

const __vue_inject_styles__$c2 = undefined;
/* scoped */

const __vue_scope_id__$c2 = undefined;
/* module identifier */

const __vue_module_identifier__$c2 = undefined;
/* functional template */

const __vue_is_functional_template__$c2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c2,
  staticRenderFns: __vue_staticRenderFns__$c2
}, __vue_inject_styles__$c2, __vue_script__$c2, __vue_scope_id__$c2, __vue_is_functional_template__$c2, __vue_module_identifier__$c2, false, undefined, undefined, undefined);

var script$c1 = Vue.extend({
  name: "PhCircleHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c1 = script$c1;
/* template */

var __vue_render__$c1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "44.8",
      "x2": "176",
      "y2": "211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,0,1,0,192",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM40,128a88.1,88.1,0,0,1,88-88V216A88.1,88.1,0,0,1,40,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "56.5",
      "x2": "192",
      "y2": "199.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "37.5",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "56.5",
      "x2": "192",
      "y2": "199.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "37.5",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "56.5",
      "x2": "192",
      "y2": "199.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "37.5",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c1 = [];
/* style */

const __vue_inject_styles__$c1 = undefined;
/* scoped */

const __vue_scope_id__$c1 = undefined;
/* module identifier */

const __vue_module_identifier__$c1 = undefined;
/* functional template */

const __vue_is_functional_template__$c1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c1,
  staticRenderFns: __vue_staticRenderFns__$c1
}, __vue_inject_styles__$c1, __vue_script__$c1, __vue_scope_id__$c1, __vue_is_functional_template__$c1, __vue_module_identifier__$c1, false, undefined, undefined, undefined);

var script$c0 = Vue.extend({
  name: "PhCircleHalfTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c0 = script$c0;
/* template */

var __vue_render__$c0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188",
      "y1": "68",
      "x2": "188",
      "y2": "202.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "108",
      "x2": "148",
      "y2": "221.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "148",
      "x2": "108",
      "y2": "221.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,60.1A96,96,0,0,1,60.1,195.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM40,128A88,88,0,0,1,190.2,65.8L65.8,190.2A87.7,87.7,0,0,1,40,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "192",
      "y2": "199.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "96",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "192",
      "y2": "199.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "96",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "64",
      "x2": "192",
      "y2": "199.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "160",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "96",
      "y2": "218.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c0 = [];
/* style */

const __vue_inject_styles__$c0 = undefined;
/* scoped */

const __vue_scope_id__$c0 = undefined;
/* module identifier */

const __vue_module_identifier__$c0 = undefined;
/* functional template */

const __vue_is_functional_template__$c0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c0,
  staticRenderFns: __vue_staticRenderFns__$c0
}, __vue_inject_styles__$c0, __vue_script__$c0, __vue_scope_id__$c0, __vue_is_functional_template__$c0, __vue_module_identifier__$c0, false, undefined, undefined, undefined);

var script$b$ = Vue.extend({
  name: "PhCircleNotch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b$ = script$b$;
/* template */

var __vue_render__$b$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.7a96,96,0,1,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.7a96,96,0,1,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A104,104,0,1,1,84.7,33.4a8.1,8.1,0,0,1,10.6,4,8,8,0,0,1-4,10.6,88,88,0,1,0,73.4,0,8,8,0,0,1-4-10.6,8.1,8.1,0,0,1,10.6-4A104.4,104.4,0,0,1,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.7a96,96,0,1,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.7a96,96,0,1,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,40.7a96,96,0,1,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b$ = [];
/* style */

const __vue_inject_styles__$b$ = undefined;
/* scoped */

const __vue_scope_id__$b$ = undefined;
/* module identifier */

const __vue_module_identifier__$b$ = undefined;
/* functional template */

const __vue_is_functional_template__$b$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b$,
  staticRenderFns: __vue_staticRenderFns__$b$
}, __vue_inject_styles__$b$, __vue_script__$b$, __vue_scope_id__$b$, __vue_is_functional_template__$b$, __vue_module_identifier__$b$, false, undefined, undefined, undefined);

var script$b_ = Vue.extend({
  name: "PhCircleWavy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b_ = script$b_;
/* template */

var __vue_render__$b_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,128c0,10.4-7.5,18.3-14.1,25.2-3.8,3.9-7.7,8-9.2,11.5s-1.4,8.7-1.5,14c-.1,9.7-.3,20.8-8,28.5s-18.8,7.9-28.5,8c-5.3.1-10.7.2-14,1.5s-7.6,5.4-11.5,9.2c-6.9,6.6-14.8,14.1-25.2,14.1s-18.3-7.5-25.2-14.1c-3.9-3.8-8-7.7-11.5-9.2s-8.7-1.4-14-1.5c-9.7-.1-20.8-.3-28.5-8s-7.9-18.8-8-28.5c-.1-5.3-.2-10.7-1.5-14s-5.4-7.6-9.2-11.5C23.5,146.3,16,138.4,16,128s7.5-18.3,14.1-25.2c3.8-3.9,7.7-8,9.2-11.5s1.4-8.7,1.5-14c.1-9.7.3-20.8,8-28.5s18.8-7.9,28.5-8c5.3-.1,10.7-.2,14-1.5s7.6-5.4,11.5-9.2C109.7,23.5,117.6,16,128,16s18.3,7.5,25.2,14.1c3.9,3.8,8,7.7,11.5,9.2s8.7,1.4,14,1.5c9.7.1,20.8.3,28.5,8s7.9,18.8,8,28.5c.1,5.3.2,10.7,1.5,14s5.4,7.6,9.2,11.5C232.5,109.7,240,117.6,240,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b_ = [];
/* style */

const __vue_inject_styles__$b_ = undefined;
/* scoped */

const __vue_scope_id__$b_ = undefined;
/* module identifier */

const __vue_module_identifier__$b_ = undefined;
/* functional template */

const __vue_is_functional_template__$b_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b_,
  staticRenderFns: __vue_staticRenderFns__$b_
}, __vue_inject_styles__$b_, __vue_script__$b_, __vue_scope_id__$b_, __vue_is_functional_template__$b_, __vue_module_identifier__$b_, false, undefined, undefined, undefined);

var script$bZ = Vue.extend({
  name: "PhCircleWavyCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bZ = script$bZ;
/* template */

var __vue_render__$bZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8Zm-48.4,7-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bZ = [];
/* style */

const __vue_inject_styles__$bZ = undefined;
/* scoped */

const __vue_scope_id__$bZ = undefined;
/* module identifier */

const __vue_module_identifier__$bZ = undefined;
/* functional template */

const __vue_is_functional_template__$bZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bZ,
  staticRenderFns: __vue_staticRenderFns__$bZ
}, __vue_inject_styles__$bZ, __vue_script__$bZ, __vue_scope_id__$bZ, __vue_is_functional_template__$bZ, __vue_module_identifier__$bZ, false, undefined, undefined, undefined);

var script$bY = Vue.extend({
  name: "PhCircleWavyQuestion",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bY = script$bY;
/* template */

var __vue_render__$bY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,136a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.9v.9a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bY = [];
/* style */

const __vue_inject_styles__$bY = undefined;
/* scoped */

const __vue_scope_id__$bY = undefined;
/* module identifier */

const __vue_module_identifier__$bY = undefined;
/* functional template */

const __vue_is_functional_template__$bY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bY,
  staticRenderFns: __vue_staticRenderFns__$bY
}, __vue_inject_styles__$bY, __vue_script__$bY, __vue_scope_id__$bY, __vue_is_functional_template__$bY, __vue_module_identifier__$bY, false, undefined, undefined, undefined);

var script$bX = Vue.extend({
  name: "PhCircleWavyWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bX = script$bX;
/* template */

var __vue_render__$bX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bX = [];
/* style */

const __vue_inject_styles__$bX = undefined;
/* scoped */

const __vue_scope_id__$bX = undefined;
/* module identifier */

const __vue_module_identifier__$bX = undefined;
/* functional template */

const __vue_is_functional_template__$bX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bX,
  staticRenderFns: __vue_staticRenderFns__$bX
}, __vue_inject_styles__$bX, __vue_script__$bX, __vue_scope_id__$bX, __vue_is_functional_template__$bX, __vue_module_identifier__$bX, false, undefined, undefined, undefined);

var script$bW = Vue.extend({
  name: "PhCirclesFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bW = script$bW;
/* template */

var __vue_render__$bW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "74",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "74",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "44"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bW = [];
/* style */

const __vue_inject_styles__$bW = undefined;
/* scoped */

const __vue_scope_id__$bW = undefined;
/* module identifier */

const __vue_module_identifier__$bW = undefined;
/* functional template */

const __vue_is_functional_template__$bW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bW,
  staticRenderFns: __vue_staticRenderFns__$bW
}, __vue_inject_styles__$bW, __vue_script__$bW, __vue_scope_id__$bW, __vue_is_functional_template__$bW, __vue_module_identifier__$bW, false, undefined, undefined, undefined);

var script$bV = Vue.extend({
  name: "PhCirclesThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bV = script$bV;
/* template */

var __vue_render__$bV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "48"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "48"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "48"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "172",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bV = [];
/* style */

const __vue_inject_styles__$bV = undefined;
/* scoped */

const __vue_scope_id__$bV = undefined;
/* module identifier */

const __vue_module_identifier__$bV = undefined;
/* functional template */

const __vue_is_functional_template__$bV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bV,
  staticRenderFns: __vue_staticRenderFns__$bV
}, __vue_inject_styles__$bV, __vue_script__$bV, __vue_scope_id__$bV, __vue_is_functional_template__$bV, __vue_module_identifier__$bV, false, undefined, undefined, undefined);

var script$bU = Vue.extend({
  name: "PhCirclesThreePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bU = script$bU;
/* template */

var __vue_render__$bU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "74",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "74",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "74",
      "cy": "182",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "182",
      "y1": "156",
      "x2": "182",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "182",
      "x2": "156",
      "y2": "182",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,172H188V152a8,8,0,0,0-16,0v20H152a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V188h20a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "152",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bU = [];
/* style */

const __vue_inject_styles__$bU = undefined;
/* scoped */

const __vue_scope_id__$bU = undefined;
/* module identifier */

const __vue_module_identifier__$bU = undefined;
/* functional template */

const __vue_is_functional_template__$bU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bU,
  staticRenderFns: __vue_staticRenderFns__$bU
}, __vue_inject_styles__$bU, __vue_script__$bU, __vue_scope_id__$bU, __vue_is_functional_template__$bU, __vue_module_identifier__$bU, false, undefined, undefined, undefined);

var script$bT = Vue.extend({
  name: "PhClipboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bT = script$bT;
/* template */

var __vue_render__$bT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40a40,40,0,0,1,8,24v8H88V64a40,40,0,0,1,8-24H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H163.7a47.8,47.8,0,0,0-71.4,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32.1,32.1,0,0,1,32,32H96A32.1,32.1,0,0,1,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bT = [];
/* style */

const __vue_inject_styles__$bT = undefined;
/* scoped */

const __vue_scope_id__$bT = undefined;
/* module identifier */

const __vue_module_identifier__$bT = undefined;
/* functional template */

const __vue_is_functional_template__$bT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bT,
  staticRenderFns: __vue_staticRenderFns__$bT
}, __vue_inject_styles__$bT, __vue_script__$bT, __vue_scope_id__$bT, __vue_is_functional_template__$bT, __vue_module_identifier__$bT, false, undefined, undefined, undefined);

var script$bS = Vue.extend({
  name: "PhClipboardText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bS = script$bS;
/* template */

var __vue_render__$bS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "156",
      "x2": "160",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "116",
      "x2": "160",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,40a40,40,0,0,1,8,24v8H88V64a40,40,0,0,1,8-24H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H163.7a47.8,47.8,0,0,0-71.4,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32.1,32.1,0,0,1,32,32H96A32.1,32.1,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "160",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72V64a40,40,0,0,1,80,0v8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bS = [];
/* style */

const __vue_inject_styles__$bS = undefined;
/* scoped */

const __vue_scope_id__$bS = undefined;
/* module identifier */

const __vue_module_identifier__$bS = undefined;
/* functional template */

const __vue_is_functional_template__$bS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bS,
  staticRenderFns: __vue_staticRenderFns__$bS
}, __vue_inject_styles__$bS, __vue_script__$bS, __vue_scope_id__$bS, __vue_is_functional_template__$bS, __vue_module_identifier__$bS, false, undefined, undefined, undefined);

var script$bR = Vue.extend({
  name: "PhClock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bR = script$bR;
/* template */

var __vue_render__$bR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56,112H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 128 128 184 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bR = [];
/* style */

const __vue_inject_styles__$bR = undefined;
/* scoped */

const __vue_scope_id__$bR = undefined;
/* module identifier */

const __vue_module_identifier__$bR = undefined;
/* functional template */

const __vue_is_functional_template__$bR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bR,
  staticRenderFns: __vue_staticRenderFns__$bR
}, __vue_inject_styles__$bR, __vue_script__$bR, __vue_scope_id__$bR, __vue_is_functional_template__$bR, __vue_module_identifier__$bR, false, undefined, undefined, undefined);

var script$bQ = Vue.extend({
  name: "PhClockAfternoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bQ = script$bQ;
/* template */

var __vue_render__$bQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56,112H147.3l26,25.9a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-39.6-39.6A8.4,8.4,0,0,1,120,128a8,8,0,0,1,8-8h56a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bQ = [];
/* style */

const __vue_inject_styles__$bQ = undefined;
/* scoped */

const __vue_scope_id__$bQ = undefined;
/* module identifier */

const __vue_module_identifier__$bQ = undefined;
/* functional template */

const __vue_is_functional_template__$bQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bQ,
  staticRenderFns: __vue_staticRenderFns__$bQ
}, __vue_inject_styles__$bQ, __vue_script__$bQ, __vue_scope_id__$bQ, __vue_is_functional_template__$bQ, __vue_module_identifier__$bQ, false, undefined, undefined, undefined);

var script$bP = Vue.extend({
  name: "PhClockClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bP = script$bP;
/* template */

var __vue_render__$bP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.2 99.7 224.2 99.7 224.2 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.2 99.7 224.2 99.7 224.2 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,80v43.4l37.6,21.7a8,8,0,0,1-4,14.9,7.1,7.1,0,0,1-4-1.1l-41.6-24h-.2l-.4-.2-.3-.3-.3-.2-.3-.3-.2-.2c-.2-.1-.3-.3-.4-.4l-.2-.2-.2-.4-.2-.3-.2-.3a.5.5,0,0,1-.2-.4l-.2-.3c0-.1-.1-.2-.1-.4a.4.4,0,0,1-.1-.3l-.2-.4a.4.4,0,0,0-.1-.3c0-.2,0-.3-.1-.4v-.4c0-.2-.1-.3-.1-.4V80a8,8,0,0,1,16,0Zm91.2-27.7a8,8,0,0,0-8.7,1.8L204.2,68.4l-8.3-8.3a96,96,0,1,0,0,135.8,8,8,0,0,0,0-11.3,7.9,7.9,0,0,0-11.3,0,80,80,0,1,1,0-113.2l8.3,8.3L178.5,94.1a8,8,0,0,0,5.7,13.6h40a8,8,0,0,0,8-8v-40A8.2,8.2,0,0,0,227.2,52.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.2 99.7 224.2 99.7 224.2 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.2 99.7 224.2 99.7 224.2 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184.2 99.7 224.2 99.7 224.2 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bP = [];
/* style */

const __vue_inject_styles__$bP = undefined;
/* scoped */

const __vue_scope_id__$bP = undefined;
/* module identifier */

const __vue_module_identifier__$bP = undefined;
/* functional template */

const __vue_is_functional_template__$bP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bP,
  staticRenderFns: __vue_staticRenderFns__$bP
}, __vue_inject_styles__$bP, __vue_script__$bP, __vue_scope_id__$bP, __vue_is_functional_template__$bP, __vue_module_identifier__$bP, false, undefined, undefined, undefined);

var script$bO = Vue.extend({
  name: "PhClockCounterClockwise",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bO = script$bO;
/* template */

var __vue_render__$bO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.8 99.7 31.8 99.7 31.8 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.8 99.7 31.8 99.7 31.8 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,80v43.4l37.6,21.7a8,8,0,0,1-4,14.9,7.1,7.1,0,0,1-4-1.1l-41.6-24h-.2l-.4-.2-.3-.3-.3-.2-.3-.3-.2-.2c-.2-.1-.3-.3-.4-.4l-.2-.2-.2-.4-.2-.3-.2-.3a.5.5,0,0,1-.2-.4l-.2-.3c0-.1-.1-.2-.1-.4a.4.4,0,0,1-.1-.3l-.2-.4a.4.4,0,0,0-.1-.3c0-.2,0-.3-.1-.4v-.4c0-.2-.1-.3-.1-.4V80a8,8,0,0,1,16,0Zm59.9-19.9a96.2,96.2,0,0,0-135.8,0l-8.3,8.3L37.5,54.1a8,8,0,0,0-8.7-1.8,8.2,8.2,0,0,0-5,7.4v40a8,8,0,0,0,8,8h40a8,8,0,0,0,5.7-13.6L63.1,79.7l8.3-8.3a80,80,0,1,1,0,113.2,7.9,7.9,0,0,0-11.3,0,8,8,0,0,0,0,11.3A96,96,0,0,0,195.9,60.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.8 99.7 31.8 99.7 31.8 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.8 99.7 31.8 99.7 31.8 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "152",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "71.8 99.7 31.8 99.7 31.8 59.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bO = [];
/* style */

const __vue_inject_styles__$bO = undefined;
/* scoped */

const __vue_scope_id__$bO = undefined;
/* module identifier */

const __vue_module_identifier__$bO = undefined;
/* functional template */

const __vue_is_functional_template__$bO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bO,
  staticRenderFns: __vue_staticRenderFns__$bO
}, __vue_inject_styles__$bO, __vue_script__$bO, __vue_scope_id__$bO, __vue_is_functional_template__$bO, __vue_module_identifier__$bO, false, undefined, undefined, undefined);

var script$bN = Vue.extend({
  name: "PhClosedCaptioning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bN = script$bN;
/* template */

var __vue_render__$bN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,152.8a28.4,28.4,0,0,1-13,3.2,28,28,0,0,1,0-56,28.4,28.4,0,0,1,13,3.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,152.8a28.4,28.4,0,0,1-13,3.2,28,28,0,0,1,0-56,28.4,28.4,0,0,1,13,3.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM96,148a19.8,19.8,0,0,0,14.3-6,8,8,0,0,1,11.4,11.2A35.4,35.4,0,0,1,96,164a36,36,0,0,1,0-72,35.4,35.4,0,0,1,25.7,10.8A8,8,0,0,1,110.3,114,19.8,19.8,0,0,0,96,108a20,20,0,0,0,0,40Zm72,0a19.8,19.8,0,0,0,14.3-6,8,8,0,0,1,11.4,11.2A35.4,35.4,0,0,1,168,164a36,36,0,0,1,0-72,35.4,35.4,0,0,1,25.7,10.8A8,8,0,0,1,182.3,114a19.8,19.8,0,0,0-14.3-6,20,20,0,0,0,0,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,147.6a28,28,0,1,1,0-39.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bN = [];
/* style */

const __vue_inject_styles__$bN = undefined;
/* scoped */

const __vue_scope_id__$bN = undefined;
/* module identifier */

const __vue_module_identifier__$bN = undefined;
/* functional template */

const __vue_is_functional_template__$bN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bN,
  staticRenderFns: __vue_staticRenderFns__$bN
}, __vue_inject_styles__$bN, __vue_script__$bN, __vue_scope_id__$bN, __vue_is_functional_template__$bN, __vue_module_identifier__$bN, false, undefined, undefined, undefined);

var script$bM = Vue.extend({
  name: "PhCloud",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bM = script$bM;
/* template */

var __vue_render__$bM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bM = [];
/* style */

const __vue_inject_styles__$bM = undefined;
/* scoped */

const __vue_scope_id__$bM = undefined;
/* module identifier */

const __vue_module_identifier__$bM = undefined;
/* functional template */

const __vue_is_functional_template__$bM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bM,
  staticRenderFns: __vue_staticRenderFns__$bM
}, __vue_inject_styles__$bM, __vue_script__$bM, __vue_scope_id__$bM, __vue_is_functional_template__$bM, __vue_module_identifier__$bM, false, undefined, undefined, undefined);

var script$bL = Vue.extend({
  name: "PhCloudArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bL = script$bL;
/* template */

var __vue_render__$bL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.1 174.1 152 208 185.9 174.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 174.1 152 208 185.9 174.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm31.5,123.7-33.9,34A8.5,8.5,0,0,1,152,200a8.3,8.3,0,0,1-5.7-2.3l-33.9-34a8,8,0,0,1,11.3-11.3L144,172.7V112a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.1 174.1 152 208 185.9 174.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.1 174.1 152 208 185.9 174.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "118.1 174.1 152 208 185.9 174.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bL = [];
/* style */

const __vue_inject_styles__$bL = undefined;
/* scoped */

const __vue_scope_id__$bL = undefined;
/* module identifier */

const __vue_module_identifier__$bL = undefined;
/* functional template */

const __vue_is_functional_template__$bL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bL,
  staticRenderFns: __vue_staticRenderFns__$bL
}, __vue_inject_styles__$bL, __vue_script__$bL, __vue_scope_id__$bL, __vue_is_functional_template__$bL, __vue_module_identifier__$bL, false, undefined, undefined, undefined);

var script$bK = Vue.extend({
  name: "PhCloudArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bK = script$bK;
/* template */

var __vue_render__$bK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 161.9 152 128 185.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 161.9 152 128 185.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm31.5,111.6a8.3,8.3,0,0,1-5.7,2.3,8,8,0,0,1-5.6-2.3L160,131.3V192a8,8,0,0,1-16,0V131.3l-20.3,20.3a8,8,0,0,1-11.3-11.3l33.9-34a8.1,8.1,0,0,1,11.4,0l33.9,34A8,8,0,0,1,191.6,151.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 161.9 152 128 185.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 161.9 152 128 185.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.1 161.9 152 128 185.9 161.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bK = [];
/* style */

const __vue_inject_styles__$bK = undefined;
/* scoped */

const __vue_scope_id__$bK = undefined;
/* module identifier */

const __vue_module_identifier__$bK = undefined;
/* functional template */

const __vue_is_functional_template__$bK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bK,
  staticRenderFns: __vue_staticRenderFns__$bK
}, __vue_inject_styles__$bK, __vue_script__$bK, __vue_scope_id__$bK, __vue_is_functional_template__$bK, __vue_module_identifier__$bK, false, undefined, undefined, undefined);

var script$bJ = Vue.extend({
  name: "PhCloudCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bJ = script$bJ;
/* template */

var __vue_render__$bJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm37.6,81.7-48,48a8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,11.4-11.4L144,152.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 116 144 164 120 140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bJ = [];
/* style */

const __vue_inject_styles__$bJ = undefined;
/* scoped */

const __vue_scope_id__$bJ = undefined;
/* module identifier */

const __vue_module_identifier__$bJ = undefined;
/* functional template */

const __vue_is_functional_template__$bJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bJ,
  staticRenderFns: __vue_staticRenderFns__$bJ
}, __vue_inject_styles__$bJ, __vue_script__$bJ, __vue_scope_id__$bJ, __vue_is_functional_template__$bJ, __vue_module_identifier__$bJ, false, undefined, undefined, undefined);

var script$bI = Vue.extend({
  name: "PhCloudFog",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bI = script$bI;
/* template */

var __vue_render__$bI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "200",
      "x2": "72",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "240",
      "x2": "104",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h56A8,8,0,0,1,168,224Zm-40-32a8,8,0,0,0-8-8H72a8,8,0,0,0,0,16h48A8,8,0,0,0,128,192Zm56-8H160a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM159.3,16.1A76.1,76.1,0,0,0,85,64.8h0a76.4,76.4,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a88.2,88.2,0,0,1,2.5-21.1,4,4,0,0,0-5-4.8A52,52,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168H156a76,76,0,0,0,3.3-151.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "160",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "104",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bI = [];
/* style */

const __vue_inject_styles__$bI = undefined;
/* scoped */

const __vue_scope_id__$bI = undefined;
/* module identifier */

const __vue_module_identifier__$bI = undefined;
/* functional template */

const __vue_is_functional_template__$bI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bI,
  staticRenderFns: __vue_staticRenderFns__$bI
}, __vue_inject_styles__$bI, __vue_script__$bI, __vue_scope_id__$bI, __vue_is_functional_template__$bI, __vue_module_identifier__$bI, false, undefined, undefined, undefined);

var script$bH = Vue.extend({
  name: "PhCloudLightning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bH = script$bH;
/* template */

var __vue_render__$bH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.3 200 104 200 130.3 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 240 154.3 200 104 200 130.3 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M134.6,168l-15.8,24H154a8,8,0,0,1,6.2,2.7,7.8,7.8,0,0,1,.7,9.7l-26.2,40A8.2,8.2,0,0,1,128,248a8.4,8.4,0,0,1-5.1-1.8,8.3,8.3,0,0,1-1.5-10.8l18-27.4H104.2a8.3,8.3,0,0,1-6.2-2.7,8.1,8.1,0,0,1-.7-9.7L115.4,168H76.8c-28.7,0-52.6-23-52.8-51.7A52,52,0,0,1,61.5,66.1a4,4,0,0,1,5,4.7,91.4,91.4,0,0,0-2.5,21,8.3,8.3,0,0,0,7.5,8.2A8,8,0,0,0,80,92a76.4,76.4,0,0,1,5-27.2h0A76,76,0,1,1,156,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.3 200 104 200 130.3 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.3 200 104 200 130.3 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "128 240 154.3 200 104 200 130.3 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bH = [];
/* style */

const __vue_inject_styles__$bH = undefined;
/* scoped */

const __vue_scope_id__$bH = undefined;
/* module identifier */

const __vue_module_identifier__$bH = undefined;
/* functional template */

const __vue_is_functional_template__$bH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bH,
  staticRenderFns: __vue_staticRenderFns__$bH
}, __vue_inject_styles__$bH, __vue_script__$bH, __vue_scope_id__$bH, __vue_is_functional_template__$bH, __vue_module_identifier__$bH, false, undefined, undefined, undefined);

var script$bG = Vue.extend({
  name: "PhCloudMoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bG = script$bG;
/* template */

var __vue_render__$bG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50,136.5A63.9,63.9,0,0,1,17.6,94.4h0A68.3,68.3,0,0,0,32,96,64.1,64.1,0,0,0,96,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,144,80v1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M90.3,130.4a67.9,67.9,0,0,1,45.5-47.3h.1c.1-1,.1-2,.1-3A64,64,0,0,0,86.4,17.6h0A68.3,68.3,0,0,1,88,32,64.1,64.1,0,0,1,24,96,68.3,68.3,0,0,1,9.6,94.4h0A64.1,64.1,0,0,0,47,138.9h0A43.7,43.7,0,0,1,76,128a42.5,42.5,0,0,1,14.3,2.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,72a85.2,85.2,0,0,0-12.4,1A71.8,71.8,0,0,0,88.2,9.8a8,8,0,0,0-9.6,9.6A58.6,58.6,0,0,1,80,32,56,56,0,0,1,24,88a58.6,58.6,0,0,1-12.6-1.4,8,8,0,0,0-9.6,9.6,71.9,71.9,0,0,0,32.3,45A52,52,0,0,0,76,224h80a76,76,0,0,0,0-152ZM21.4,104H24A72.1,72.1,0,0,0,96,32V29.3a55.6,55.6,0,0,1,31.9,48.1A76.3,76.3,0,0,0,85,120.8a53.8,53.8,0,0,0-9-.8,51.8,51.8,0,0,0-30,9.6A55.9,55.9,0,0,1,21.4,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bG = [];
/* style */

const __vue_inject_styles__$bG = undefined;
/* scoped */

const __vue_scope_id__$bG = undefined;
/* module identifier */

const __vue_module_identifier__$bG = undefined;
/* functional template */

const __vue_is_functional_template__$bG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bG,
  staticRenderFns: __vue_staticRenderFns__$bG
}, __vue_inject_styles__$bG, __vue_script__$bG, __vue_scope_id__$bG, __vue_is_functional_template__$bG, __vue_module_identifier__$bG, false, undefined, undefined, undefined);

var script$bF = Vue.extend({
  name: "PhCloudRain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bF = script$bF;
/* template */

var __vue_render__$bF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.3",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.7",
      "y1": "208",
      "x2": "130.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.3",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.7",
      "y1": "208",
      "x2": "130.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160.9,204.4l-26.2,40A8.2,8.2,0,0,1,128,248a8,8,0,0,1-6.7-12.4l26.3-40a8,8,0,1,1,13.3,8.8ZM159.3,16.1A76.1,76.1,0,0,0,85,64.8h0a74.8,74.8,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a91.6,91.6,0,0,1,2.4-21.1,4,4,0,0,0-5-4.8A52.1,52.1,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168h38.6L92.2,203.4A8,8,0,0,0,98.7,216a8,8,0,0,0,6.7-3.6L134.6,168H156a76,76,0,0,0,3.3-151.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.3",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.7",
      "y1": "208",
      "x2": "130.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.3",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.7",
      "y1": "208",
      "x2": "130.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "240",
      "x2": "154.3",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.7",
      "y1": "208",
      "x2": "130.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bF = [];
/* style */

const __vue_inject_styles__$bF = undefined;
/* scoped */

const __vue_scope_id__$bF = undefined;
/* module identifier */

const __vue_module_identifier__$bF = undefined;
/* functional template */

const __vue_is_functional_template__$bF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bF,
  staticRenderFns: __vue_staticRenderFns__$bF
}, __vue_inject_styles__$bF, __vue_script__$bF, __vue_scope_id__$bF, __vue_is_functional_template__$bF, __vue_module_identifier__$bF, false, undefined, undefined, undefined);

var script$bE = Vue.extend({
  name: "PhCloudSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bE = script$bE;
/* template */

var __vue_render__$bE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79,79,0,0,1,91.1,87.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.4,59.1A79,79,0,0,1,160,48a80.1,80.1,0,0,1,64.8,127",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,127.6a80,80,0,1,1,80,80H72a56,56,0,0,1,0-112,53,53,0,0,1,13.9,1.8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,63.5A80,80,0,0,1,219.7,181.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79,79,0,0,1,91.1,87.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L81.3,88.5v.2A58.2,58.2,0,0,0,72,88a64,64,0,0,0,0,128h88a87.9,87.9,0,0,0,31.8-5.9l10.3,11.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a87.2,87.2,0,0,0-52.1,17.1,7.9,7.9,0,0,0-3.2,5.6,7.8,7.8,0,0,0,2,6.2L213.8,186.7a8.1,8.1,0,0,0,5.9,2.6h0a7.8,7.8,0,0,0,5.9-2.7A88,88,0,0,0,160,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,63.5A80,80,0,0,1,219.7,181.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79,79,0,0,1,91.1,87.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,63.5A80,80,0,0,1,219.7,181.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79,79,0,0,1,91.1,87.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,63.5A80,80,0,0,1,219.7,181.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128A79,79,0,0,1,91.1,87.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bE = [];
/* style */

const __vue_inject_styles__$bE = undefined;
/* scoped */

const __vue_scope_id__$bE = undefined;
/* module identifier */

const __vue_module_identifier__$bE = undefined;
/* functional template */

const __vue_is_functional_template__$bE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bE,
  staticRenderFns: __vue_staticRenderFns__$bE
}, __vue_inject_styles__$bE, __vue_script__$bE, __vue_scope_id__$bE, __vue_is_functional_template__$bE, __vue_module_identifier__$bE, false, undefined, undefined, undefined);

var script$bD = Vue.extend({
  name: "PhCloudSnow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bD = script$bD;
/* template */

var __vue_render__$bD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,96a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "112",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "216",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,196a12,12,0,1,1-12-12A12,12,0,0,1,176,196ZM76,184a12,12,0,1,0,12,12A12,12,0,0,0,76,184Zm40,16a12,12,0,1,0,12,12A12,12,0,0,0,116,200ZM68,224a12,12,0,1,0,12,12A12,12,0,0,0,68,224Zm88,0a12,12,0,1,0,12,12A12,12,0,0,0,156,224Zm3.3-207.9A76.1,76.1,0,0,0,85,64.8h0a74.8,74.8,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a91.6,91.6,0,0,1,2.4-21.1,4,4,0,0,0-5-4.8A52.1,52.1,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168H156a76,76,0,0,0,3.3-151.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "212",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "236",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "236",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bD = [];
/* style */

const __vue_inject_styles__$bD = undefined;
/* scoped */

const __vue_scope_id__$bD = undefined;
/* module identifier */

const __vue_module_identifier__$bD = undefined;
/* functional template */

const __vue_is_functional_template__$bD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bD,
  staticRenderFns: __vue_staticRenderFns__$bD
}, __vue_inject_styles__$bD, __vue_script__$bD, __vue_scope_id__$bD, __vue_is_functional_template__$bD, __vue_module_identifier__$bD, false, undefined, undefined, undefined);

var script$bC = Vue.extend({
  name: "PhCloudSun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bC = script$bC;
/* template */

var __vue_render__$bC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.7",
      "y1": "56.7",
      "x2": "75.5",
      "y2": "33.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.7",
      "y1": "76.5",
      "x2": "29",
      "y2": "62.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.7",
      "y1": "112.3",
      "x2": "17.1",
      "y2": "116.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.5",
      "y1": "64.7",
      "x2": "129.3",
      "y2": "45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M131.8,84.4a48,48,0,0,0-91.1,27.9,49.1,49.1,0,0,0,10.9,23.1h0A43.6,43.6,0,0,1,76,128a42.5,42.5,0,0,1,14.3,2.4h0a68.3,68.3,0,0,1,41.5-46Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.7",
      "y1": "56.7",
      "x2": "75.5",
      "y2": "33.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.7",
      "y1": "76.5",
      "x2": "29",
      "y2": "62.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.7",
      "y1": "112.3",
      "x2": "17.1",
      "y2": "116.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.5",
      "y1": "64.7",
      "x2": "129.3",
      "y2": "45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,72a78.8,78.8,0,0,0-20.2,2.7,58.9,58.9,0,0,0-9.4-11.5l9.4-13.6a7.9,7.9,0,0,0-1.9-11.1,8,8,0,0,0-11.2,1.9L113.2,54a55,55,0,0,0-26.9-6L83.4,31.7a8,8,0,1,0-15.8,2.8l2.9,16.3A55.7,55.7,0,0,0,47.2,65.6L33.6,56.1a8,8,0,0,0-11.1,2,7.9,7.9,0,0,0,1.9,11.1L38,78.7a55.1,55.1,0,0,0-6,27l-16.3,2.9a8,8,0,0,0,1.4,15.9h1.4l16.3-2.9a52.3,52.3,0,0,0,5.9,12.4A51.9,51.9,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48.6,111.1v-.4a39.6,39.6,0,0,1,6.5-29.5V81h.1A40.1,40.1,0,0,1,80.8,64.6h.5a39.5,39.5,0,0,1,29.1,6.3l.5.3.4.3a37.4,37.4,0,0,1,9.3,9.3,76.6,76.6,0,0,0-35.6,40,53.8,53.8,0,0,0-9-.8,52.6,52.6,0,0,0-22.1,4.9A40,40,0,0,1,48.6,111.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.7",
      "y1": "56.7",
      "x2": "75.5",
      "y2": "33.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.7",
      "y1": "76.5",
      "x2": "29",
      "y2": "62.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.7",
      "y1": "112.3",
      "x2": "17.1",
      "y2": "116.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.5",
      "y1": "64.7",
      "x2": "129.3",
      "y2": "45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.7",
      "y1": "56.7",
      "x2": "75.5",
      "y2": "33.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.7",
      "y1": "76.5",
      "x2": "29",
      "y2": "62.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.7",
      "y1": "112.3",
      "x2": "17.1",
      "y2": "116.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.5",
      "y1": "64.7",
      "x2": "129.3",
      "y2": "45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "79.7",
      "y1": "56.7",
      "x2": "75.5",
      "y2": "33.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.7",
      "y1": "76.5",
      "x2": "29",
      "y2": "62.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.7",
      "y1": "112.3",
      "x2": "17.1",
      "y2": "116.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.5",
      "y1": "64.7",
      "x2": "129.3",
      "y2": "45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bC = [];
/* style */

const __vue_inject_styles__$bC = undefined;
/* scoped */

const __vue_scope_id__$bC = undefined;
/* module identifier */

const __vue_module_identifier__$bC = undefined;
/* functional template */

const __vue_is_functional_template__$bC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bC,
  staticRenderFns: __vue_staticRenderFns__$bC
}, __vue_inject_styles__$bC, __vue_script__$bC, __vue_scope_id__$bC, __vue_is_functional_template__$bC, __vue_module_identifier__$bC, false, undefined, undefined, undefined);

var script$bB = Vue.extend({
  name: "PhClub",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bB = script$bB;
/* template */

var __vue_render__$bB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104.5,186.6A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-28.5,86.6L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,148a52,52,0,0,1-80.5,43.5l10.7,34.1a7.8,7.8,0,0,1-1.2,7.1,7.9,7.9,0,0,1-6.4,3.3H101.4a7.9,7.9,0,0,1-6.4-3.3,7.8,7.8,0,0,1-1.2-7.1l10.7-34.1a51.7,51.7,0,0,1-30,8.5c-27.7-.8-50.4-24-50.5-51.8A52.1,52.1,0,0,1,76,96l4,.2a53.3,53.3,0,0,1-3.9-23.4,52,52,0,1,1,99.8,23.4A51.5,51.5,0,0,1,232,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bB = [];
/* style */

const __vue_inject_styles__$bB = undefined;
/* scoped */

const __vue_scope_id__$bB = undefined;
/* module identifier */

const __vue_module_identifier__$bB = undefined;
/* functional template */

const __vue_is_functional_template__$bB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bB,
  staticRenderFns: __vue_staticRenderFns__$bB
}, __vue_inject_styles__$bB, __vue_script__$bB, __vue_scope_id__$bB, __vue_is_functional_template__$bB, __vue_module_identifier__$bB, false, undefined, undefined, undefined);

var script$bA = Vue.extend({
  name: "PhCoatHanger",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bA = script$bA;
/* template */

var __vue_render__$bA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.6,171.2,141.3,96l23.5-17.6A8.1,8.1,0,0,0,168,72a40,40,0,0,0-80,0,8,8,0,0,0,16,0,24,24,0,0,1,47.7-3.8L123.3,89.5l-.2.2L14.4,171.2A16,16,0,0,0,24,200H232a16,16,0,0,0,9.6-28.8ZM24,184l104-78,104,78H24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bA = [];
/* style */

const __vue_inject_styles__$bA = undefined;
/* scoped */

const __vue_scope_id__$bA = undefined;
/* module identifier */

const __vue_module_identifier__$bA = undefined;
/* functional template */

const __vue_is_functional_template__$bA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bA,
  staticRenderFns: __vue_staticRenderFns__$bA
}, __vue_inject_styles__$bA, __vue_script__$bA, __vue_scope_id__$bA, __vue_is_functional_template__$bA, __vue_module_identifier__$bA, false, undefined, undefined, undefined);

var script$bz = Vue.extend({
  name: "PhCode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bz = script$bz;
/* template */

var __vue_render__$bz = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.1,82.9a7.8,7.8,0,0,0-11.2-1l-48,40a7.9,7.9,0,0,0,0,12.2l48,40a7.8,7.8,0,0,0,11.2-1,7.8,7.8,0,0,0-1-11.2L28.5,128,69.1,94.1A7.8,7.8,0,0,0,70.1,82.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M245.1,121.9l-48-40a8,8,0,0,0-10.2,12.2L227.5,128l-40.6,33.9A8,8,0,0,0,192,176a7.7,7.7,0,0,0,5.1-1.9l48-40a7.9,7.9,0,0,0,0-12.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162.7,32.5a7.9,7.9,0,0,0-10.2,4.8l-64,176a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3l64-176A7.9,7.9,0,0,0,162.7,32.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 88 16 128 64 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 88 240 128 192 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bz = [];
/* style */

const __vue_inject_styles__$bz = undefined;
/* scoped */

const __vue_scope_id__$bz = undefined;
/* module identifier */

const __vue_module_identifier__$bz = undefined;
/* functional template */

const __vue_is_functional_template__$bz = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bz = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bz,
  staticRenderFns: __vue_staticRenderFns__$bz
}, __vue_inject_styles__$bz, __vue_script__$bz, __vue_scope_id__$bz, __vue_is_functional_template__$bz, __vue_module_identifier__$bz, false, undefined, undefined, undefined);

var script$by = Vue.extend({
  name: "PhCodeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$by = script$by;
/* template */

var __vue_render__$by = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94,58.7A8,8,0,0,0,82.7,58l-72,64a8,8,0,0,0,0,12l72,64a8.1,8.1,0,0,0,5.3,2,8,8,0,0,0,5.3-14L28,128,93.3,70A8,8,0,0,0,94,58.7Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M245.3,122l-72-64a8,8,0,0,0-10.6,12L228,128l-65.3,58a8,8,0,0,0,5.3,14,8.1,8.1,0,0,0,5.3-2l72-64a8,8,0,0,0,0-12Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "88 64 16 128 88 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 64 240 128 168 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$by = [];
/* style */

const __vue_inject_styles__$by = undefined;
/* scoped */

const __vue_scope_id__$by = undefined;
/* module identifier */

const __vue_module_identifier__$by = undefined;
/* functional template */

const __vue_is_functional_template__$by = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$by = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$by,
  staticRenderFns: __vue_staticRenderFns__$by
}, __vue_inject_styles__$by, __vue_script__$by, __vue_scope_id__$by, __vue_is_functional_template__$by, __vue_module_identifier__$by, false, undefined, undefined, undefined);

var script$bx = Vue.extend({
  name: "PhCodepenLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bx = script$bx;
/* template */

var __vue_render__$bx = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "101",
      "x2": "232",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "101",
      "x2": "24",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "222.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "43.2",
      "x2": "128",
      "y2": "106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "101",
      "x2": "232",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "101",
      "x2": "24",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "222.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "43.2",
      "x2": "128",
      "y2": "106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,101v64a8,8,0,0,1-4.1,7L142,225.3a4,4,0,0,1-6-3.5V164.7L191.8,133,224,151.3V114.7L191.8,133l-16.2-9.2L215.8,101,136,55.7v45.6l39.6,22.5-47.6,27-47.6-27L120,101.3V55.7L40.2,101l40.2,22.8L64.2,133,32,114.7v36.6L64.2,133,120,164.7v57.1a4,4,0,0,1-6,3.5L20.1,172a8,8,0,0,1-4.1-7V101a8,8,0,0,1,4.1-7l100-56.7a15.9,15.9,0,0,1,15.8,0L235.9,94A8,8,0,0,1,240,101Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "101",
      "x2": "232",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "101",
      "x2": "24",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "222.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "43.2",
      "x2": "128",
      "y2": "106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "101",
      "x2": "232",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "101",
      "x2": "24",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "222.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "43.2",
      "x2": "128",
      "y2": "106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "101",
      "x2": "232",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "101",
      "x2": "24",
      "y2": "165",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "222.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "43.2",
      "x2": "128",
      "y2": "106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bx = [];
/* style */

const __vue_inject_styles__$bx = undefined;
/* scoped */

const __vue_scope_id__$bx = undefined;
/* module identifier */

const __vue_module_identifier__$bx = undefined;
/* functional template */

const __vue_is_functional_template__$bx = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bx = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bx,
  staticRenderFns: __vue_staticRenderFns__$bx
}, __vue_inject_styles__$bx, __vue_script__$bx, __vue_scope_id__$bx, __vue_is_functional_template__$bx, __vue_module_identifier__$bx, false, undefined, undefined, undefined);

var script$bw = Vue.extend({
  name: "PhCodesandboxLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bw = script$bw;
/* template */

var __vue_render__$bw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 47.5 128 75.1 79 47.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 209 176 153.9 224 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 209 80 153.9 32 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M79,47.5l49,27.6,49-27.6L131.9,22.2a7.8,7.8,0,0,0-7.8,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,209V153.9l48-27v50.4a8.1,8.1,0,0,1-4.1,7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,209V153.9l-48-27v50.4a8.1,8.1,0,0,0,4.1,7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 47.5 128 75.1 79 47.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 209 176 153.9 224 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 209 80 153.9 32 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,126.8V78.7a15.6,15.6,0,0,0-2.1-7.9h-.1a15.5,15.5,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v48.1h0v50.5a16.1,16.1,0,0,0,8.2,14l44,24.7h0l44,24.8a16.5,16.5,0,0,0,7.2,2h1.3a16.1,16.1,0,0,0,7.1-2l44-24.8h0l44-24.7a16.1,16.1,0,0,0,8.2-14V126.8ZM83.9,147,40,122.2V87.6l80.9,45.1-.8,89.7L88,204.3V153.9A7.9,7.9,0,0,0,83.9,147ZM79,56.7,124.1,82a7.5,7.5,0,0,0,7.8,0L177,56.7,207.7,74l-78.8,44.8L48.4,74Zm57.9,76,79.1-45v34.5L172.1,147a7.9,7.9,0,0,0-4.1,6.9v50.4l-31.9,18Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 47.5 128 75.1 79 47.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 209 176 153.9 224 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 209 80 153.9 32 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 47.5 128 75.1 79 47.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 209 176 153.9 224 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 209 80 153.9 32 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 47.5 128 75.1 79 47.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 209 176 153.9 224 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 209 80 153.9 32 126.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bw = [];
/* style */

const __vue_inject_styles__$bw = undefined;
/* scoped */

const __vue_scope_id__$bw = undefined;
/* module identifier */

const __vue_module_identifier__$bw = undefined;
/* functional template */

const __vue_is_functional_template__$bw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bw,
  staticRenderFns: __vue_staticRenderFns__$bw
}, __vue_inject_styles__$bw, __vue_script__$bw, __vue_scope_id__$bw, __vue_is_functional_template__$bw, __vue_module_identifier__$bw, false, undefined, undefined, undefined);

var script$bv = Vue.extend({
  name: "PhCoffee",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bv = script$bv;
/* template */

var __vue_render__$bv = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h4a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-7.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "24",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56V24a8,8,0,0,1,16,0V56a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,120,64Zm32,0a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,152,64Zm96,56v8a40,40,0,0,1-37.5,39.9,98,98,0,0,1-27,40.1H208a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H56.5A96.4,96.4,0,0,1,24,136V88a8,8,0,0,1,8-8H208A40,40,0,0,1,248,120Zm-16,0a24,24,0,0,0-16-22.6V136a92.9,92.9,0,0,1-1.2,15A24,24,0,0,0,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "24",
      "x2": "120",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bv = [];
/* style */

const __vue_inject_styles__$bv = undefined;
/* scoped */

const __vue_scope_id__$bv = undefined;
/* module identifier */

const __vue_module_identifier__$bv = undefined;
/* functional template */

const __vue_is_functional_template__$bv = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bv = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bv,
  staticRenderFns: __vue_staticRenderFns__$bv
}, __vue_inject_styles__$bv, __vue_script__$bv, __vue_scope_id__$bv, __vue_is_functional_template__$bv, __vue_module_identifier__$bv, false, undefined, undefined, undefined);

var script$bu = Vue.extend({
  name: "PhCoin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bu = script$bu;
/* template */

var __vue_render__$bu = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.1",
      "x2": "192",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.1",
      "x2": "64",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.1",
      "x2": "192",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.1",
      "x2": "64",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207.6,63.8C186.8,53.5,159.3,48,128,48S69.2,53.5,48.4,63.8,16,88.8,16,104v48c0,15.2,11.8,29.9,32.4,40.2S96.7,208,128,208s58.8-5.5,79.6-15.8S240,167.2,240,152V104C240,88.8,228.2,74.1,207.6,63.8ZM120,159.9v32c-19-.7-35-3.5-48-7.5V153C86.3,157,102.5,159.3,120,159.9Zm16,0c17.5-.6,33.7-2.9,48-6.9v31.4c-13,4-29,6.8-48,7.5ZM32,152V133.5a84.5,84.5,0,0,0,16.4,10.7l7.6,3.4V178C40.2,170.2,32,160.3,32,152Zm168,26V147.6l7.6-3.4A84.5,84.5,0,0,0,224,133.5V152C224,160.3,215.8,170.2,200,178Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.1",
      "x2": "192",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.1",
      "x2": "64",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.1",
      "x2": "192",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.1",
      "x2": "64",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "rx": "104",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "142.1",
      "x2": "192",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "142.1",
      "x2": "64",
      "y2": "190.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bu = [];
/* style */

const __vue_inject_styles__$bu = undefined;
/* scoped */

const __vue_scope_id__$bu = undefined;
/* module identifier */

const __vue_module_identifier__$bu = undefined;
/* functional template */

const __vue_is_functional_template__$bu = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bu = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bu,
  staticRenderFns: __vue_staticRenderFns__$bu
}, __vue_inject_styles__$bu, __vue_script__$bu, __vue_scope_id__$bu, __vue_is_functional_template__$bu, __vue_module_identifier__$bu, false, undefined, undefined, undefined);

var script$bt = Vue.extend({
  name: "PhCoinVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bt = script$bt;
/* template */

var __vue_render__$bt = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.5",
      "y1": "184",
      "x2": "197.5",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.5",
      "y1": "72",
      "x2": "197.5",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "64",
      "x2": "193.7",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "192",
      "x2": "193.7",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M198.5,56.1C186.4,35.4,169.9,24,152,24H104C86.1,24,69.6,35.4,57.5,56.1S40,101,40,128s6.2,52.6,17.5,71.9S86.1,232,104,232h48c17.9,0,34.4-11.4,46.5-32.1S216,155,216,128,209.8,75.4,198.5,56.1Zm1.3,63.9h-32c-.8-17.2-4.1-33.7-9.7-48h30.6C194.8,85.4,198.9,102,199.8,120ZM179.2,56H150.5a89,89,0,0,0-12-16H152C162,40,171.4,46,179.2,56ZM152,216H138.5a89,89,0,0,0,12-16h28.7C171.4,210,162,216,152,216Zm36.7-32H158.1c5.6-14.3,8.9-30.8,9.7-48h32C198.9,154,194.8,170.6,188.7,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "64",
      "x2": "193.7",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "192",
      "x2": "193.7",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "64",
      "x2": "193.7",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "192",
      "x2": "193.7",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "104",
      "cy": "128",
      "rx": "56",
      "ry": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "64",
      "x2": "193.7",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "145.7",
      "y1": "192",
      "x2": "193.7",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bt = [];
/* style */

const __vue_inject_styles__$bt = undefined;
/* scoped */

const __vue_scope_id__$bt = undefined;
/* module identifier */

const __vue_module_identifier__$bt = undefined;
/* functional template */

const __vue_is_functional_template__$bt = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bt = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bt,
  staticRenderFns: __vue_staticRenderFns__$bt
}, __vue_inject_styles__$bt, __vue_script__$bt, __vue_scope_id__$bt, __vue_is_functional_template__$bt, __vue_module_identifier__$bt, false, undefined, undefined, undefined);

var script$bs = Vue.extend({
  name: "PhCoins",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bs = script$bs;
/* template */

var __vue_render__$bs = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "117",
      "x2": "64",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "165",
      "x2": "192",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "117",
      "x2": "128",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4h0C146.8,156.9,176,142,176,124Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "117",
      "x2": "64",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "165",
      "x2": "192",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "117",
      "x2": "128",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,89.6V84c0-25.1-37.8-44-88-44S8,58.9,8,84v40c0,20.9,26.2,37.5,64,42.5V172c0,25.1,37.8,44,88,44s88-18.9,88-44V132C248,111.3,222.6,94.7,184,89.6ZM72,150.2V126.5A184,184,0,0,0,96,128a184,184,0,0,0,24-1.5v23.7A151.1,151.1,0,0,1,96,152,151.1,151.1,0,0,1,72,150.2Zm96-40.3V124c0,8.4-12.4,17.4-32,22.9V123.5C148.9,120.4,159.8,115.7,168,109.9ZM24,124V109.9c8.2,5.8,19.1,10.5,32,13.6v23.4C36.4,141.4,24,132.4,24,124Zm64,48v-4.2l8,.2q5.9,0,11.4-.3c4,1.4,8.2,2.6,12.6,3.7v23.5C100.4,189.4,88,180.4,88,172Zm48,26.2V174.4a188.4,188.4,0,0,0,24,1.6,184,184,0,0,0,24-1.5v23.7a160.9,160.9,0,0,1-48,0Zm64-3.3V171.5c12.9-3.1,23.8-7.8,32-13.6V172C232,180.4,219.6,189.4,200,194.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "117",
      "x2": "64",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "165",
      "x2": "192",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "117",
      "x2": "128",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "117",
      "x2": "64",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "165",
      "x2": "192",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "117",
      "x2": "128",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "rx": "80",
      "ry": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "117",
      "x2": "64",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "165",
      "x2": "192",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "117",
      "x2": "128",
      "y2": "205",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bs = [];
/* style */

const __vue_inject_styles__$bs = undefined;
/* scoped */

const __vue_scope_id__$bs = undefined;
/* module identifier */

const __vue_module_identifier__$bs = undefined;
/* functional template */

const __vue_is_functional_template__$bs = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bs = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bs,
  staticRenderFns: __vue_staticRenderFns__$bs
}, __vue_inject_styles__$bs, __vue_script__$bs, __vue_scope_id__$bs, __vue_is_functional_template__$bs, __vue_module_identifier__$bs, false, undefined, undefined, undefined);

var script$br = Vue.extend({
  name: "PhColumns",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$br = script$br;
/* template */

var __vue_render__$br = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-6",
      "y": "102",
      "width": "176",
      "height": "52",
      "rx": "8",
      "transform": "translate(210 46) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "86",
      "y": "102",
      "width": "176",
      "height": "52",
      "rx": "8",
      "transform": "translate(302 -46) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,48V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V48A16,16,0,0,1,64,32h40A16,16,0,0,1,120,48Zm72-16H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "-4",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(212 44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "100",
      "width": "176",
      "height": "56",
      "rx": "8",
      "transform": "translate(300 -44) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$br = [];
/* style */

const __vue_inject_styles__$br = undefined;
/* scoped */

const __vue_scope_id__$br = undefined;
/* module identifier */

const __vue_module_identifier__$br = undefined;
/* functional template */

const __vue_is_functional_template__$br = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$br = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$br,
  staticRenderFns: __vue_staticRenderFns__$br
}, __vue_inject_styles__$br, __vue_script__$br, __vue_scope_id__$br, __vue_is_functional_template__$br, __vue_module_identifier__$br, false, undefined, undefined, undefined);

var script$bq = Vue.extend({
  name: "PhCommand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bq = script$bq;
/* template */

var __vue_render__$bq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76A28,28,0,0,1,180,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76A28,28,0,0,1,180,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20.1,20.1,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20.1,20.1,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
      "transform": "translate(152 152) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
      "transform": "translate(152 360) rotate(-180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bq = [];
/* style */

const __vue_inject_styles__$bq = undefined;
/* scoped */

const __vue_scope_id__$bq = undefined;
/* module identifier */

const __vue_module_identifier__$bq = undefined;
/* functional template */

const __vue_is_functional_template__$bq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bq,
  staticRenderFns: __vue_staticRenderFns__$bq
}, __vue_inject_styles__$bq, __vue_script__$bq, __vue_scope_id__$bq, __vue_is_functional_template__$bq, __vue_module_identifier__$bq, false, undefined, undefined, undefined);

var script$bp = Vue.extend({
  name: "PhCompass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bp = script$bp;
/* template */

var __vue_render__$bp = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "145 145 167.4 88.5 111 111 88.4 167.6 145 145",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm17,113L85.6,170.4,111,111l62.1-28.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm52.3,62.1-28,62.2a8.2,8.2,0,0,1-4.2,4L88.7,177.8a8.5,8.5,0,0,1-3.1.6,8.1,8.1,0,0,1-5.7-2.3,8,8,0,0,1-1.7-8.8l25.5-59.4a8.2,8.2,0,0,1,4-4.2l62-28.2a8.1,8.1,0,0,1,9,1.7A7.8,7.8,0,0,1,180.3,86.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bp = [];
/* style */

const __vue_inject_styles__$bp = undefined;
/* scoped */

const __vue_scope_id__$bp = undefined;
/* module identifier */

const __vue_module_identifier__$bp = undefined;
/* functional template */

const __vue_is_functional_template__$bp = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bp = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bp,
  staticRenderFns: __vue_staticRenderFns__$bp
}, __vue_inject_styles__$bp, __vue_script__$bp, __vue_scope_id__$bp, __vue_is_functional_template__$bp, __vue_module_identifier__$bp, false, undefined, undefined, undefined);

var script$bo = Vue.extend({
  name: "PhComputerTower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bo = script$bo;
/* template */

var __vue_render__$bo = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "76",
      "x2": "96",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "116",
      "x2": "96",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "184",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A16,16,0,0,0,48,40V216a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V40A16,16,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "104",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "transform": "translate(256 0) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bo = [];
/* style */

const __vue_inject_styles__$bo = undefined;
/* scoped */

const __vue_scope_id__$bo = undefined;
/* module identifier */

const __vue_module_identifier__$bo = undefined;
/* functional template */

const __vue_is_functional_template__$bo = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bo = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bo,
  staticRenderFns: __vue_staticRenderFns__$bo
}, __vue_inject_styles__$bo, __vue_script__$bo, __vue_scope_id__$bo, __vue_is_functional_template__$bo, __vue_module_identifier__$bo, false, undefined, undefined, undefined);

var script$bn = Vue.extend({
  name: "PhConfetti",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bn = script$bn;
/* template */

var __vue_render__$bn = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.5,168.6,48.1,218.1a7.9,7.9,0,0,1-10.2-10.2L87.4,71.5a8,8,0,0,1,13.2-2.9l86.8,86.8A8,8,0,0,1,184.5,168.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164,76s0-24,24-24,24-24,24-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.4",
      "y1": "198.4",
      "x2": "57.6",
      "y2": "153.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "16",
      "x2": "136",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "120",
      "x2": "232",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "240",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74.7",
      "y1": "106.7",
      "x2": "149.3",
      "y2": "181.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M102.4,198.4,57.6,153.6,37.9,207.9a7.9,7.9,0,0,0,10.2,10.2Z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.8,100.8l78.4,78.4,41-14.9a8,8,0,0,0,2.9-13.2L104.9,56.9a8,8,0,0,0-13.2,2.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72s0-24,24-24,24-24,24-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.4",
      "y1": "198.4",
      "x2": "57.6",
      "y2": "153.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "16",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "80",
      "x2": "240",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.8",
      "y1": "100.8",
      "x2": "155.2",
      "y2": "179.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M110.5,51.2a15.7,15.7,0,0,0-14.7-4.3A16,16,0,0,0,84.2,57.1L30.3,205.2h0a16.1,16.1,0,0,0,15,21.4,17.1,17.1,0,0,0,5.5-.9l148.1-53.9a16,16,0,0,0,10.2-11.6,15.7,15.7,0,0,0-4.3-14.7ZM63.8,159.8,83,107l66,66L96.2,192.2ZM160,72a38.2,38.2,0,0,1,3.8-15.6C169.1,45.8,179.1,40,192,40c6.7,0,11-2.3,13.7-7.2a22.3,22.3,0,0,0,2.3-8.9,7.9,7.9,0,0,1,8-7.9,8,8,0,0,1,8,8c0,12.9-8.5,32-32,32-6.7,0-11,2.3-13.7,7.2a22.3,22.3,0,0,0-2.3,8.9,7.9,7.9,0,0,1-8,7.9A8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.7,82.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-16-16a8.1,8.1,0,0,1,11.4-11.4Zm4.8-42.7-24,8a7.3,7.3,0,0,1-2.5.4,8,8,0,0,1-2.5-15.6l24-8a8,8,0,0,1,5,15.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72s0-24,24-24,24-24,24-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.4",
      "y1": "198.4",
      "x2": "57.6",
      "y2": "153.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "16",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "80",
      "x2": "240",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.8",
      "y1": "100.8",
      "x2": "155.2",
      "y2": "179.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72s0-24,24-24,24-24,24-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.4",
      "y1": "198.4",
      "x2": "57.6",
      "y2": "153.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "16",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "80",
      "x2": "240",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.8",
      "y1": "100.8",
      "x2": "155.2",
      "y2": "179.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72s0-24,24-24,24-24,24-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.4",
      "y1": "198.4",
      "x2": "57.6",
      "y2": "153.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "16",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "80",
      "x2": "240",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76.8",
      "y1": "100.8",
      "x2": "155.2",
      "y2": "179.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bn = [];
/* style */

const __vue_inject_styles__$bn = undefined;
/* scoped */

const __vue_scope_id__$bn = undefined;
/* module identifier */

const __vue_module_identifier__$bn = undefined;
/* functional template */

const __vue_is_functional_template__$bn = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bn = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bn,
  staticRenderFns: __vue_staticRenderFns__$bn
}, __vue_inject_styles__$bn, __vue_script__$bn, __vue_scope_id__$bn, __vue_is_functional_template__$bn, __vue_module_identifier__$bn, false, undefined, undefined, undefined);

var script$bm = Vue.extend({
  name: "PhCookie",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bm = script$bm;
/* template */

var __vue_render__$bm = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.9,114.9a15.8,15.8,0,0,0-13.4-3.1,23.9,23.9,0,0,1-29.3-23.1,16,16,0,0,0-15.9-15.9,23.9,23.9,0,0,1-23.1-29.3A16.1,16.1,0,0,0,128.6,24H128A104.1,104.1,0,0,0,24,128.7a104,104,0,0,0,208-1.3h0A15.7,15.7,0,0,0,225.9,114.9ZM75.5,99.5a12,12,0,1,1,0,17A12,12,0,0,1,75.5,99.5Zm25,73a12,12,0,1,1,0-17A12,12,0,0,1,100.5,172.5Zm27-40a12,12,0,1,1,17,0A12,12,0,0,1,127.5,132.5Zm37,48a12,12,0,1,1,0-17A12,12,0,0,1,164.5,180.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "136",
      "cy": "124",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bm = [];
/* style */

const __vue_inject_styles__$bm = undefined;
/* scoped */

const __vue_scope_id__$bm = undefined;
/* module identifier */

const __vue_module_identifier__$bm = undefined;
/* functional template */

const __vue_is_functional_template__$bm = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bm = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bm,
  staticRenderFns: __vue_staticRenderFns__$bm
}, __vue_inject_styles__$bm, __vue_script__$bm, __vue_scope_id__$bm, __vue_is_functional_template__$bm, __vue_module_identifier__$bm, false, undefined, undefined, undefined);

var script$bl = Vue.extend({
  name: "PhCookingPot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bl = script$bl;
/* template */

var __vue_render__$bl = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "16",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "16",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,80H204a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H68a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,52,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "244",
      "y1": "96",
      "x2": "212",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "96",
      "x2": "44",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,128,56Zm32,0a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,160,56Zm94.4,35.2a8,8,0,0,0-11.2-1.6L224,104V88a16,16,0,0,0-16-16H48A16,16,0,0,0,32,88v16L12.8,89.6a8,8,0,0,0-9.6,12.8L32,124v60a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V124l28.8-21.6A8,8,0,0,0,254.4,91.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "16",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "16",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "248",
      "y1": "96",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "96",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bl = [];
/* style */

const __vue_inject_styles__$bl = undefined;
/* scoped */

const __vue_scope_id__$bl = undefined;
/* module identifier */

const __vue_module_identifier__$bl = undefined;
/* functional template */

const __vue_is_functional_template__$bl = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bl = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bl,
  staticRenderFns: __vue_staticRenderFns__$bl
}, __vue_inject_styles__$bl, __vue_script__$bl, __vue_scope_id__$bl, __vue_is_functional_template__$bl, __vue_module_identifier__$bl, false, undefined, undefined, undefined);

var script$bk = Vue.extend({
  name: "PhCopy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bk = script$bk;
/* template */

var __vue_render__$bk = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 168 216 168 216 40 88 40 88 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "168 88 168 168 216 168 216 40 88 40 88 88 168 88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 168 216 168 216 40 88 40 88 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 168 216 168 216 40 88 40 88 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 168 216 168 216 40 88 40 88 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 168 216 168 216 40 88 40 88 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bk = [];
/* style */

const __vue_inject_styles__$bk = undefined;
/* scoped */

const __vue_scope_id__$bk = undefined;
/* module identifier */

const __vue_module_identifier__$bk = undefined;
/* functional template */

const __vue_is_functional_template__$bk = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bk = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bk,
  staticRenderFns: __vue_staticRenderFns__$bk
}, __vue_inject_styles__$bk, __vue_script__$bk, __vue_scope_id__$bk, __vue_is_functional_template__$bk, __vue_module_identifier__$bk, false, undefined, undefined, undefined);

var script$bj = Vue.extend({
  name: "PhCopySimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bj = script$bj;
/* template */

var __vue_render__$bj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "220 176 220 36 80 36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "76",
      "width": "140",
      "height": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 184 216 40 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32H72a8,8,0,0,0,0,16H208V184a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "64",
      "width": "160",
      "height": "160",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 184 216 40 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 184 216 40 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "216 184 216 40 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "72",
      "width": "144",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bj = [];
/* style */

const __vue_inject_styles__$bj = undefined;
/* scoped */

const __vue_scope_id__$bj = undefined;
/* module identifier */

const __vue_module_identifier__$bj = undefined;
/* functional template */

const __vue_is_functional_template__$bj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bj,
  staticRenderFns: __vue_staticRenderFns__$bj
}, __vue_inject_styles__$bj, __vue_script__$bj, __vue_scope_id__$bj, __vue_is_functional_template__$bj, __vue_module_identifier__$bj, false, undefined, undefined, undefined);

var script$bi = Vue.extend({
  name: "PhCopyleft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bi = script$bi;
/* template */

var __vue_render__$bi = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,104a40,40,0,1,1,0,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,104a40,40,0,1,1,0,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm0,120a47.7,47.7,0,0,1-38.4-19.2,8,8,0,1,1,12.8-9.6,32,32,0,1,0,0-38.4,8.1,8.1,0,0,1-11.2,1.6,8,8,0,0,1-1.6-11.2A48,48,0,1,1,128,176Zm0-156A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,104a40,40,0,1,1,0,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,104a40,40,0,1,1,0,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,104a40,40,0,1,1,0,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bi = [];
/* style */

const __vue_inject_styles__$bi = undefined;
/* scoped */

const __vue_scope_id__$bi = undefined;
/* module identifier */

const __vue_module_identifier__$bi = undefined;
/* functional template */

const __vue_is_functional_template__$bi = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bi = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bi,
  staticRenderFns: __vue_staticRenderFns__$bi
}, __vue_inject_styles__$bi, __vue_script__$bi, __vue_scope_id__$bi, __vue_is_functional_template__$bi, __vue_module_identifier__$bi, false, undefined, undefined, undefined);

var script$bh = Vue.extend({
  name: "PhCopyright",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bh = script$bh;
/* template */

var __vue_render__$bh = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152a40,40,0,1,1,0-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152a40,40,0,1,1,0-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,20A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-160a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm0,104a31.8,31.8,0,0,0,25.6-12.8,8.1,8.1,0,0,1,11.2-1.6,8,8,0,0,1,1.6,11.2,48,48,0,1,1,0-57.6,8,8,0,0,1-1.6,11.2,8.1,8.1,0,0,1-11.2-1.6A32,32,0,1,0,128,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152a40,40,0,1,1,0-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152a40,40,0,1,1,0-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,152a40,40,0,1,1,0-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bh = [];
/* style */

const __vue_inject_styles__$bh = undefined;
/* scoped */

const __vue_scope_id__$bh = undefined;
/* module identifier */

const __vue_module_identifier__$bh = undefined;
/* functional template */

const __vue_is_functional_template__$bh = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bh = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bh,
  staticRenderFns: __vue_staticRenderFns__$bh
}, __vue_inject_styles__$bh, __vue_script__$bh, __vue_scope_id__$bh, __vue_is_functional_template__$bh, __vue_module_identifier__$bh, false, undefined, undefined, undefined);

var script$bg = Vue.extend({
  name: "PhCornersIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bg = script$bg;
/* template */

var __vue_render__$bg = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,96V48a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,208,104H160A8,8,0,0,1,152,96ZM96,152H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l48,48A8.3,8.3,0,0,0,96,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,104,208V160A8,8,0,0,0,96,152ZM99.1,40.6a8.4,8.4,0,0,0-8.8,1.7l-48,48a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,104H96a8,8,0,0,0,8-8V48A8,8,0,0,0,99.1,40.6ZM208,152H160a8,8,0,0,0-8,8v48a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l48-48a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "208 96 160 96 160 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 160 96 160 96 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 208 160 160 208 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 48 96 96 48 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bg = [];
/* style */

const __vue_inject_styles__$bg = undefined;
/* scoped */

const __vue_scope_id__$bg = undefined;
/* module identifier */

const __vue_module_identifier__$bg = undefined;
/* functional template */

const __vue_is_functional_template__$bg = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bg = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bg,
  staticRenderFns: __vue_staticRenderFns__$bg
}, __vue_inject_styles__$bg, __vue_script__$bg, __vue_scope_id__$bg, __vue_is_functional_template__$bg, __vue_module_identifier__$bg, false, undefined, undefined, undefined);

var script$bf = Vue.extend({
  name: "PhCornersOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bf = script$bf;
/* template */

var __vue_render__$bf = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-40-40a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48ZM53.7,162.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,168v40a8,8,0,0,0,8,8H88a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Zm157.4-1.7a8.4,8.4,0,0,0-8.8,1.7l-40,40a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM88,40H48a8,8,0,0,0-8,8V88a8,8,0,0,0,4.9,7.4A8.5,8.5,0,0,0,48,96a8.3,8.3,0,0,0,5.7-2.3l40-40a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,88,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "88 208 48 208 48 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 48 88 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bf = [];
/* style */

const __vue_inject_styles__$bf = undefined;
/* scoped */

const __vue_scope_id__$bf = undefined;
/* module identifier */

const __vue_module_identifier__$bf = undefined;
/* functional template */

const __vue_is_functional_template__$bf = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bf = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bf,
  staticRenderFns: __vue_staticRenderFns__$bf
}, __vue_inject_styles__$bf, __vue_script__$bf, __vue_scope_id__$bf, __vue_is_functional_template__$bf, __vue_module_identifier__$bf, false, undefined, undefined, undefined);

var script$be = Vue.extend({
  name: "PhCpu",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$be = script$be;
/* template */

var __vue_render__$be = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,48H56a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V56A8,8,0,0,0,200,48ZM156,156H100V100h56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,144H216V112h16a8,8,0,0,0,0-16H216V56a16,16,0,0,0-16-16H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H56A16,16,0,0,0,40,56V96H24a8,8,0,0,0,0,16H40v32H24a8,8,0,0,0,0,16H40v40a16,16,0,0,0,16,16H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h40a16,16,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-68,12a8,8,0,0,1-8,8H100a8,8,0,0,1-8-8V100a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Zm-56-48h40v40H108Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "100",
      "y": "100",
      "width": "56",
      "height": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "160",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "232",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "152",
      "x2": "232",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "104",
      "x2": "48",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "152",
      "x2": "48",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "208",
      "x2": "104",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "24",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "24",
      "x2": "104",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$be = [];
/* style */

const __vue_inject_styles__$be = undefined;
/* scoped */

const __vue_scope_id__$be = undefined;
/* module identifier */

const __vue_module_identifier__$be = undefined;
/* functional template */

const __vue_is_functional_template__$be = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$be = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$be,
  staticRenderFns: __vue_staticRenderFns__$be
}, __vue_inject_styles__$be, __vue_script__$be, __vue_scope_id__$be, __vue_is_functional_template__$be, __vue_module_identifier__$be, false, undefined, undefined, undefined);

var script$bd = Vue.extend({
  name: "PhCreditCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bd = script$bd;
/* template */

var __vue_render__$bd = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "164",
      "x2": "196",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "164",
      "x2": "124",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "96.9",
      "x2": "232",
      "y2": "96.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,96.9H232V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "136",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "96.9",
      "x2": "232",
      "y2": "96.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32A16,16,0,0,0,16,64V96.9h0v95a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM136,176H120a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm64,0H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM32,88.9V64H224V88.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "136",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "96.9",
      "x2": "232",
      "y2": "96.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "136",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "96.9",
      "x2": "232",
      "y2": "96.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "136",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "96.9",
      "x2": "232",
      "y2": "96.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bd = [];
/* style */

const __vue_inject_styles__$bd = undefined;
/* scoped */

const __vue_scope_id__$bd = undefined;
/* module identifier */

const __vue_module_identifier__$bd = undefined;
/* functional template */

const __vue_is_functional_template__$bd = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bd = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bd,
  staticRenderFns: __vue_staticRenderFns__$bd
}, __vue_inject_styles__$bd, __vue_script__$bd, __vue_scope_id__$bd, __vue_is_functional_template__$bd, __vue_module_identifier__$bd, false, undefined, undefined, undefined);

var script$bc = Vue.extend({
  name: "PhCrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bc = script$bc;
/* template */

var __vue_render__$bc = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "24",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 24 64 192 232 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 152 192 64 104 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "232",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "24",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 24 64 192 232 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 192 64 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "232",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,192a8,8,0,0,1-8,8H200v32a8,8,0,0,1-16,0V200H64a8,8,0,0,1-8-8V72H24a8,8,0,0,1,0-16H56V24a8,8,0,0,1,16,0V184H232A8,8,0,0,1,240,192ZM96,72h88v88a8,8,0,0,0,16,0V64a8,8,0,0,0-8-8H96a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "24",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 24 64 192 232 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 192 64 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "232",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "24",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 24 64 192 232 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 192 64 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "232",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "24",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 24 64 192 232 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192 160 192 64 96 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "232",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bc = [];
/* style */

const __vue_inject_styles__$bc = undefined;
/* scoped */

const __vue_scope_id__$bc = undefined;
/* module identifier */

const __vue_module_identifier__$bc = undefined;
/* functional template */

const __vue_is_functional_template__$bc = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bc = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bc,
  staticRenderFns: __vue_staticRenderFns__$bc
}, __vue_inject_styles__$bc, __vue_script__$bc, __vue_scope_id__$bc, __vue_is_functional_template__$bc, __vue_module_identifier__$bc, false, undefined, undefined, undefined);

var script$bb = Vue.extend({
  name: "PhCrosshair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$bb = script$bb;
/* template */

var __vue_render__$bb = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236,120H223.7A96.2,96.2,0,0,0,136,32.3V20a8,8,0,0,0-16,0V32.3A96.2,96.2,0,0,0,32.3,120H20a8,8,0,0,0,0,16H32.3A96.2,96.2,0,0,0,120,223.7V236a8,8,0,0,0,16,0V223.7A96.2,96.2,0,0,0,223.7,136H236a8,8,0,0,0,0-16Zm-40,16h11.6A80.3,80.3,0,0,1,136,207.6V196a8,8,0,0,0-16,0v11.6A80.3,80.3,0,0,1,48.4,136H60a8,8,0,0,0,0-16H48.4A80.3,80.3,0,0,1,120,48.4V60a8,8,0,0,0,16,0V48.4A80.3,80.3,0,0,1,207.6,120H196a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "20",
      "x2": "128",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "128",
      "x2": "60",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "236",
      "x2": "128",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "128",
      "x2": "196",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$bb = [];
/* style */

const __vue_inject_styles__$bb = undefined;
/* scoped */

const __vue_scope_id__$bb = undefined;
/* module identifier */

const __vue_module_identifier__$bb = undefined;
/* functional template */

const __vue_is_functional_template__$bb = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$bb = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$bb,
  staticRenderFns: __vue_staticRenderFns__$bb
}, __vue_inject_styles__$bb, __vue_script__$bb, __vue_scope_id__$bb, __vue_is_functional_template__$bb, __vue_module_identifier__$bb, false, undefined, undefined, undefined);

var script$ba = Vue.extend({
  name: "PhCrosshairSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ba = script$ba;
/* template */

var __vue_render__$ba = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,28A100,100,0,1,0,228,128,100.2,100.2,0,0,0,128,28Zm8,183.6V180a8,8,0,0,0-16,0v31.6A84.2,84.2,0,0,1,44.4,136H76a8,8,0,0,0,0-16H44.4A84.2,84.2,0,0,1,120,44.4V76a8,8,0,0,0,16,0V44.4A84.2,84.2,0,0,1,211.6,120H180a8,8,0,0,0,0,16h31.6A84.2,84.2,0,0,1,136,211.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ba = [];
/* style */

const __vue_inject_styles__$ba = undefined;
/* scoped */

const __vue_scope_id__$ba = undefined;
/* module identifier */

const __vue_module_identifier__$ba = undefined;
/* functional template */

const __vue_is_functional_template__$ba = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ba = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ba,
  staticRenderFns: __vue_staticRenderFns__$ba
}, __vue_inject_styles__$ba, __vue_script__$ba, __vue_scope_id__$ba, __vue_is_functional_template__$ba, __vue_module_identifier__$ba, false, undefined, undefined, undefined);

var script$b9 = Vue.extend({
  name: "PhCrown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b9 = script$b9;
/* template */

var __vue_render__$b9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,153.6a325.9,325.9,0,0,1,64,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,161.7a297.7,297.7,0,0,1,64,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.7,73.5A15.9,15.9,0,0,0,222,71.2L171.4,93.7,142,40.7a16.1,16.1,0,0,0-28,0l-29.4,53L34,71.2A16,16,0,0,0,11.9,89.5L37.3,197.8a15.9,15.9,0,0,0,7.4,10.1,16.2,16.2,0,0,0,8.3,2.3,15.2,15.2,0,0,0,4.2-.6,265.5,265.5,0,0,1,141.5,0,16.5,16.5,0,0,0,12.5-1.7,15.6,15.6,0,0,0,7.4-10.1L244.1,89.5A16,16,0,0,0,238.7,73.5Zm-70.7,89a8.1,8.1,0,0,1-8,7.2h-.8a309.8,309.8,0,0,0-62.4,0,8,8,0,0,1-8.8-7.1,8.1,8.1,0,0,1,7.2-8.8,312.7,312.7,0,0,1,65.6,0A8.1,8.1,0,0,1,168,162.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,161.7a297.7,297.7,0,0,1,64,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,161.7a297.7,297.7,0,0,1,64,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,161.7a297.7,297.7,0,0,1,64,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b9 = [];
/* style */

const __vue_inject_styles__$b9 = undefined;
/* scoped */

const __vue_scope_id__$b9 = undefined;
/* module identifier */

const __vue_module_identifier__$b9 = undefined;
/* functional template */

const __vue_is_functional_template__$b9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b9,
  staticRenderFns: __vue_staticRenderFns__$b9
}, __vue_inject_styles__$b9, __vue_script__$b9, __vue_scope_id__$b9, __vue_is_functional_template__$b9, __vue_module_identifier__$b9, false, undefined, undefined, undefined);

var script$b8 = Vue.extend({
  name: "PhCrownSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b8 = script$b8;
/* template */

var __vue_render__$b8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.7,73.5A15.9,15.9,0,0,0,222,71.2L171.4,93.7,142,40.7a16.1,16.1,0,0,0-28,0l-29.4,53L34,71.2A16,16,0,0,0,11.9,89.5L37.3,197.8a15.9,15.9,0,0,0,7.4,10.1,16.2,16.2,0,0,0,8.3,2.3,15.2,15.2,0,0,0,4.2-.6,265.5,265.5,0,0,1,141.5,0,16.5,16.5,0,0,0,12.5-1.7,15.6,15.6,0,0,0,7.4-10.1L244.1,89.5A16,16,0,0,0,238.7,73.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b8 = [];
/* style */

const __vue_inject_styles__$b8 = undefined;
/* scoped */

const __vue_scope_id__$b8 = undefined;
/* module identifier */

const __vue_module_identifier__$b8 = undefined;
/* functional template */

const __vue_is_functional_template__$b8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b8,
  staticRenderFns: __vue_staticRenderFns__$b8
}, __vue_inject_styles__$b8, __vue_script__$b8, __vue_scope_id__$b8, __vue_is_functional_template__$b8, __vue_module_identifier__$b8, false, undefined, undefined, undefined);

var script$b7 = Vue.extend({
  name: "PhCube",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b7 = script$b7;
/* template */

var __vue_render__$b7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.1,74.6A8.1,8.1,0,0,0,32,78.7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.6,7.6,0,0,0,3.9,1h0l.9-106.8L33.1,74.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.9,70.8h0a.1.1,0,0,1-.1-.1,16.2,16.2,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v98.6a16.1,16.1,0,0,0,8.2,14l88,49.5a16.5,16.5,0,0,0,7.2,2h1.4a16.1,16.1,0,0,0,7-2l88-49.5a16.1,16.1,0,0,0,8.2-14V78.7A15.6,15.6,0,0,0,229.9,70.8Zm-101,48L48.4,74,128,29.2,207.7,74ZM216,177.3l-79.9,45,.8-89.6,79.1-45Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b7 = [];
/* style */

const __vue_inject_styles__$b7 = undefined;
/* scoped */

const __vue_scope_id__$b7 = undefined;
/* module identifier */

const __vue_module_identifier__$b7 = undefined;
/* functional template */

const __vue_is_functional_template__$b7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b7,
  staticRenderFns: __vue_staticRenderFns__$b7
}, __vue_inject_styles__$b7, __vue_script__$b7, __vue_scope_id__$b7, __vue_is_functional_template__$b7, __vue_module_identifier__$b7, false, undefined, undefined, undefined);

var script$b6 = Vue.extend({
  name: "PhCurrencyBtc",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b6 = script$b6;
/* template */

var __vue_render__$b6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "48",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "80",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "48",
      "x2": "100",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "140",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "224",
      "x2": "100",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "224",
      "x2": "140",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "48",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "80",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M170.5,115.7A44,44,0,0,0,144,40.2V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H64a8,8,0,0,0,0,16h8V192H64a8,8,0,0,0,0,16H96v16a8,8,0,0,0,16,0V208h16v16a8,8,0,0,0,16,0V208h8a48,48,0,0,0,18.5-92.3ZM168,84a28.1,28.1,0,0,1-28,28H88V56h52A28.1,28.1,0,0,1,168,84ZM152,192H88V128h64a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "48",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "80",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "48",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "80",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "48",
      "x2": "80",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "80",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "48",
      "x2": "136",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "224",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "224",
      "x2": "136",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b6 = [];
/* style */

const __vue_inject_styles__$b6 = undefined;
/* scoped */

const __vue_scope_id__$b6 = undefined;
/* module identifier */

const __vue_module_identifier__$b6 = undefined;
/* functional template */

const __vue_is_functional_template__$b6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b6,
  staticRenderFns: __vue_staticRenderFns__$b6
}, __vue_inject_styles__$b6, __vue_script__$b6, __vue_scope_id__$b6, __vue_is_functional_template__$b6, __vue_module_identifier__$b6, false, undefined, undefined, undefined);

var script$b5 = Vue.extend({
  name: "PhCurrencyCircleDollar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b5 = script$b5;
/* template */

var __vue_render__$b5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm12,152h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24a28,28,0,0,1,0,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b5 = [];
/* style */

const __vue_inject_styles__$b5 = undefined;
/* scoped */

const __vue_scope_id__$b5 = undefined;
/* module identifier */

const __vue_module_identifier__$b5 = undefined;
/* functional template */

const __vue_is_functional_template__$b5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b5,
  staticRenderFns: __vue_staticRenderFns__$b5
}, __vue_inject_styles__$b5, __vue_script__$b5, __vue_scope_id__$b5, __vue_is_functional_template__$b5, __vue_module_identifier__$b5, false, undefined, undefined, undefined);

var script$b4 = Vue.extend({
  name: "PhCurrencyCny",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b4 = script$b4;
/* template */

var __vue_render__$b4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64.1,64.1,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64.1,64.1,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,64a8,8,0,0,1,8-8H192a8,8,0,0,1,0,16H64A8,8,0,0,1,56,64ZM216,168a8,8,0,0,0-8,8v16H176a16,16,0,0,1-16-16V128h48a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16H96v8a56,56,0,0,1-56,56,8,8,0,0,0,0,16,72.1,72.1,0,0,0,72-72v-8h32v48a32.1,32.1,0,0,0,32,32h40a8,8,0,0,0,8-8V176A8,8,0,0,0,216,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64.1,64.1,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64.1,64.1,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "120",
      "x2": "208",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v16a64.1,64.1,0,0,1-64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b4 = [];
/* style */

const __vue_inject_styles__$b4 = undefined;
/* scoped */

const __vue_scope_id__$b4 = undefined;
/* module identifier */

const __vue_module_identifier__$b4 = undefined;
/* functional template */

const __vue_is_functional_template__$b4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b4,
  staticRenderFns: __vue_staticRenderFns__$b4
}, __vue_inject_styles__$b4, __vue_script__$b4, __vue_scope_id__$b4, __vue_is_functional_template__$b4, __vue_module_identifier__$b4, false, undefined, undefined, undefined);

var script$b3 = Vue.extend({
  name: "PhCurrencyDollar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b3 = script$b3;
/* template */

var __vue_render__$b3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,120H136V56h8a32.1,32.1,0,0,1,32,32,8,8,0,0,0,16,0,48,48,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40H108a48,48,0,0,0,0,96h12v64H104a32.1,32.1,0,0,1-32-32,8,8,0,0,0-16,0,48,48,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-32,0H108a32,32,0,0,1,0-64h12Zm32,80H136V136h16a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b3 = [];
/* style */

const __vue_inject_styles__$b3 = undefined;
/* scoped */

const __vue_scope_id__$b3 = undefined;
/* module identifier */

const __vue_module_identifier__$b3 = undefined;
/* functional template */

const __vue_is_functional_template__$b3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b3,
  staticRenderFns: __vue_staticRenderFns__$b3
}, __vue_inject_styles__$b3, __vue_script__$b3, __vue_scope_id__$b3, __vue_is_functional_template__$b3, __vue_module_identifier__$b3, false, undefined, undefined, undefined);

var script$b2 = Vue.extend({
  name: "PhCurrencyDollarSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b2 = script$b2;
/* template */

var __vue_render__$b2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,168a48,48,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48,48,0,0,1-48-48,8,8,0,0,1,16,0,32.1,32.1,0,0,0,32,32h48a32,32,0,0,0,0-64H108a48,48,0,0,1,0-96h12V24a8,8,0,0,1,16,0V40h8a48,48,0,0,1,48,48,8,8,0,0,1-16,0,32.1,32.1,0,0,0-32-32H108a32,32,0,0,0,0,64h44A48,48,0,0,1,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b2 = [];
/* style */

const __vue_inject_styles__$b2 = undefined;
/* scoped */

const __vue_scope_id__$b2 = undefined;
/* module identifier */

const __vue_module_identifier__$b2 = undefined;
/* functional template */

const __vue_is_functional_template__$b2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b2,
  staticRenderFns: __vue_staticRenderFns__$b2
}, __vue_inject_styles__$b2, __vue_script__$b2, __vue_scope_id__$b2, __vue_is_functional_template__$b2, __vue_module_identifier__$b2, false, undefined, undefined, undefined);

var script$b1 = Vue.extend({
  name: "PhCurrencyEth",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b1 = script$b1;
/* template */

var __vue_render__$b1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 128 128 168 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 216 128 128 240 40 128 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "40 128 128 240 216 128 128 168 40 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 128 128 168 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 216 128 128 240 40 128 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222.3,123.1l-88-112a8,8,0,0,0-12.6,0l-88,112a7.8,7.8,0,0,0,0,9.8l88,112a8,8,0,0,0,12.6,0l88-112A7.8,7.8,0,0,0,222.3,123.1ZM136,155.6V39.1l67.4,85.8Zm-16,0L52.6,124.9,120,39.1Zm0,17.6v43.7l-53.4-68Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 128 128 168 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 216 128 128 240 40 128 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 128 128 168 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 216 128 128 240 40 128 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "16",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 128 128 168 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 216 128 128 240 40 128 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b1 = [];
/* style */

const __vue_inject_styles__$b1 = undefined;
/* scoped */

const __vue_scope_id__$b1 = undefined;
/* module identifier */

const __vue_module_identifier__$b1 = undefined;
/* functional template */

const __vue_is_functional_template__$b1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b1,
  staticRenderFns: __vue_staticRenderFns__$b1
}, __vue_inject_styles__$b1, __vue_script__$b1, __vue_scope_id__$b1, __vue_is_functional_template__$b1, __vue_module_identifier__$b1, false, undefined, undefined, undefined);

var script$b0 = Vue.extend({
  name: "PhCurrencyEur",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b0 = script$b0;
/* template */

var __vue_render__$b0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "136",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "120",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192.6,189.3a8,8,0,0,1,0,11.3A80,80,0,0,1,56.4,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.4A80,80,0,0,1,192.6,55.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,0,0,72.5,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.5a64.1,64.1,0,0,0,108.8,37.3A7.9,7.9,0,0,1,192.6,189.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "136",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "120",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b0 = [];
/* style */

const __vue_inject_styles__$b0 = undefined;
/* scoped */

const __vue_scope_id__$b0 = undefined;
/* module identifier */

const __vue_module_identifier__$b0 = undefined;
/* functional template */

const __vue_is_functional_template__$b0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b0,
  staticRenderFns: __vue_staticRenderFns__$b0
}, __vue_inject_styles__$b0, __vue_script__$b0, __vue_scope_id__$b0, __vue_is_functional_template__$b0, __vue_module_identifier__$b0, false, undefined, undefined, undefined);

var script$a$ = Vue.extend({
  name: "PhCurrencyGbp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a$ = script$a$;
/* template */

var __vue_render__$a$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,208a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16,28.1,28.1,0,0,0,28-28V140H56a8,8,0,0,1,0-16H84V84a52,52,0,0,1,88.8-36.8,8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A36.1,36.1,0,0,0,100,84v40h36a8,8,0,0,1,0,16H100v32a43.8,43.8,0,0,1-10.1,28H184A8,8,0,0,1,192,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "132",
      "x2": "136",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a$ = [];
/* style */

const __vue_inject_styles__$a$ = undefined;
/* scoped */

const __vue_scope_id__$a$ = undefined;
/* module identifier */

const __vue_module_identifier__$a$ = undefined;
/* functional template */

const __vue_is_functional_template__$a$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a$,
  staticRenderFns: __vue_staticRenderFns__$a$
}, __vue_inject_styles__$a$, __vue_script__$a$, __vue_scope_id__$a$, __vue_is_functional_template__$a$, __vue_module_identifier__$a$, false, undefined, undefined, undefined);

var script$a_ = Vue.extend({
  name: "PhCurrencyInr",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a_ = script$a_;
/* template */

var __vue_render__$a_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80a8,8,0,0,1-8,8H167.9c0,1.3.1,2.7.1,4a60,60,0,0,1-60,60H92.7l72.7,66.1a7.9,7.9,0,0,1,.5,11.3A8,8,0,0,1,160,232a8.2,8.2,0,0,1-5.4-2.1l-88-80A8,8,0,0,1,72,136h36a44,44,0,0,0,44-44c0-1.3-.1-2.7-.2-4H72a8,8,0,0,1,0-16h75.2A44.1,44.1,0,0,0,108,48H72a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16H148.7a60.2,60.2,0,0,1,15.9,24H200A8,8,0,0,1,208,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "80",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "40",
      "x2": "200",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,40a52,52,0,0,1,0,104H72l88,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a_ = [];
/* style */

const __vue_inject_styles__$a_ = undefined;
/* scoped */

const __vue_scope_id__$a_ = undefined;
/* module identifier */

const __vue_module_identifier__$a_ = undefined;
/* functional template */

const __vue_is_functional_template__$a_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a_,
  staticRenderFns: __vue_staticRenderFns__$a_
}, __vue_inject_styles__$a_, __vue_script__$a_, __vue_scope_id__$a_, __vue_is_functional_template__$a_, __vue_module_identifier__$a_, false, undefined, undefined, undefined);

var script$aZ = Vue.extend({
  name: "PhCurrencyJpy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aZ = script$aZ;
/* template */

var __vue_render__$aZ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.2,53.1,144.9,128H176a8,8,0,0,1,0,16H136v16h40a8,8,0,0,1,0,16H136v40a8,8,0,0,1-16,0V176H80a8,8,0,0,1,0-16h40V144H80a8,8,0,0,1,0-16h31.1L49.8,53.1A8,8,0,0,1,62.2,42.9L128,123.4l65.8-80.5a8,8,0,0,1,12.4,10.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "136",
      "x2": "176",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 48 128 136 56 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aZ = [];
/* style */

const __vue_inject_styles__$aZ = undefined;
/* scoped */

const __vue_scope_id__$aZ = undefined;
/* module identifier */

const __vue_module_identifier__$aZ = undefined;
/* functional template */

const __vue_is_functional_template__$aZ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aZ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aZ,
  staticRenderFns: __vue_staticRenderFns__$aZ
}, __vue_inject_styles__$aZ, __vue_script__$aZ, __vue_scope_id__$aZ, __vue_is_functional_template__$aZ, __vue_module_identifier__$aZ, false, undefined, undefined, undefined);

var script$aY = Vue.extend({
  name: "PhCurrencyKrw",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aY = script$aY;
/* template */

var __vue_render__$aY = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,128H217.9l21.5-53a8,8,0,1,0-14.8-6l-24,59H159.4l-24-59a8,8,0,0,0-14.8,0l-24,59H55.4l-24-59a8,8,0,1,0-14.8,6l21.5,53H16a8,8,0,0,0,0,16H44.6l24,59a8,8,0,0,0,14.8,0l24-59h41.2l24,59a8,8,0,0,0,14.8,0l24-59H240a8,8,0,0,0,0-16ZM76,178.7,61.9,144H90.1ZM113.9,128,128,93.3,142.1,128ZM180,178.7,165.9,144h28.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 72 76 200 128 72 180 200 232 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "136",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aY = [];
/* style */

const __vue_inject_styles__$aY = undefined;
/* scoped */

const __vue_scope_id__$aY = undefined;
/* module identifier */

const __vue_module_identifier__$aY = undefined;
/* functional template */

const __vue_is_functional_template__$aY = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aY = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aY,
  staticRenderFns: __vue_staticRenderFns__$aY
}, __vue_inject_styles__$aY, __vue_script__$aY, __vue_scope_id__$aY, __vue_is_functional_template__$aY, __vue_module_identifier__$aY, false, undefined, undefined, undefined);

var script$aX = Vue.extend({
  name: "PhCurrencyKzt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aX = script$aX;
/* template */

var __vue_render__$aX = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "100",
      "x2": "200",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "52",
      "x2": "200",
      "y2": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "100",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96a8,8,0,0,1-8,8H136V216a8,8,0,0,1-16,0V104H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM56,64H200a8,8,0,0,0,0-16H56a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aX = [];
/* style */

const __vue_inject_styles__$aX = undefined;
/* scoped */

const __vue_scope_id__$aX = undefined;
/* module identifier */

const __vue_module_identifier__$aX = undefined;
/* functional template */

const __vue_is_functional_template__$aX = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aX = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aX,
  staticRenderFns: __vue_staticRenderFns__$aX
}, __vue_inject_styles__$aX, __vue_script__$aX, __vue_scope_id__$aX, __vue_is_functional_template__$aX, __vue_module_identifier__$aX, false, undefined, undefined, undefined);

var script$aW = Vue.extend({
  name: "PhCurrencyNgn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aW = script$aW;
/* template */

var __vue_render__$aW = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 210 64 46 192 210 192 46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "216",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 210 64 46 192 210 192 46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136H200V120h16a8,8,0,0,0,0-16H200V46a8,8,0,0,0-16,0v58H119.4L70.3,41.1A8,8,0,0,0,56,46v58H40a8,8,0,0,0,0,16H56v16H40a8,8,0,0,0,0,16H56v58a8,8,0,0,0,16,0V152h64.6l49.1,62.9a8.1,8.1,0,0,0,8.9,2.7A8.1,8.1,0,0,0,200,210V152h16a8,8,0,0,0,0-16Zm-32-16v16H144.4l-12.5-16ZM72,69.3,99.1,104H72ZM72,136V120h39.6l12.5,16Zm112,50.7L156.9,152H184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "216",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 210 64 46 192 210 192 46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "216",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 210 64 46 192 210 192 46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "144",
      "x2": "216",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 210 64 46 192 210 192 46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aW = [];
/* style */

const __vue_inject_styles__$aW = undefined;
/* scoped */

const __vue_scope_id__$aW = undefined;
/* module identifier */

const __vue_module_identifier__$aW = undefined;
/* functional template */

const __vue_is_functional_template__$aW = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aW = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aW,
  staticRenderFns: __vue_staticRenderFns__$aW
}, __vue_inject_styles__$aW, __vue_script__$aW, __vue_scope_id__$aW, __vue_is_functional_template__$aW, __vue_module_identifier__$aW, false, undefined, undefined, undefined);

var script$aV = Vue.extend({
  name: "PhCurrencyRub",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aV = script$aV;
/* template */

var __vue_render__$aV = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "184",
      "x2": "144",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,152a60,60,0,0,0,0-120H88a8,8,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,216V40h60a52,52,0,0,1,0,104H56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aV = [];
/* style */

const __vue_inject_styles__$aV = undefined;
/* scoped */

const __vue_scope_id__$aV = undefined;
/* module identifier */

const __vue_module_identifier__$aV = undefined;
/* functional template */

const __vue_is_functional_template__$aV = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aV = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aV,
  staticRenderFns: __vue_staticRenderFns__$aV
}, __vue_inject_styles__$aV, __vue_script__$aV, __vue_scope_id__$aV, __vue_is_functional_template__$aV, __vue_module_identifier__$aV, false, undefined, undefined, undefined);

var script$aU = Vue.extend({
  name: "PhCursor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aU = script$aU;
/* template */

var __vue_render__$aU = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.6",
      "y1": "136.6",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.6",
      "y1": "136.6",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150.5,139.2l55.9-20.3a16,16,0,0,0,.1-30L51.3,30.7A16,16,0,0,0,30.7,51.3h0L88.9,206.5a15.9,15.9,0,0,0,15,10.4h.1a15.9,15.9,0,0,0,14.9-10.5l20.3-55.9,63.1,63.2A8.5,8.5,0,0,0,208,216a8.3,8.3,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.6",
      "y1": "136.6",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.6",
      "y1": "136.6",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136.6",
      "y1": "136.6",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aU = [];
/* style */

const __vue_inject_styles__$aU = undefined;
/* scoped */

const __vue_scope_id__$aU = undefined;
/* module identifier */

const __vue_module_identifier__$aU = undefined;
/* functional template */

const __vue_is_functional_template__$aU = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aU = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aU,
  staticRenderFns: __vue_staticRenderFns__$aU
}, __vue_inject_styles__$aU, __vue_script__$aU, __vue_scope_id__$aU, __vue_is_functional_template__$aU, __vue_module_identifier__$aU, false, undefined, undefined, undefined);

var script$aT = Vue.extend({
  name: "PhCursorText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aT = script$aT;
/* template */

var __vue_render__$aT = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24.1,24.1,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24.1,24.1,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24.1,24.1,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24.1,24.1,0,0,0,24,24h16A8,8,0,0,1,184,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aT = [];
/* style */

const __vue_inject_styles__$aT = undefined;
/* scoped */

const __vue_scope_id__$aT = undefined;
/* module identifier */

const __vue_module_identifier__$aT = undefined;
/* functional template */

const __vue_is_functional_template__$aT = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aT = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aT,
  staticRenderFns: __vue_staticRenderFns__$aT
}, __vue_inject_styles__$aT, __vue_script__$aT, __vue_scope_id__$aT, __vue_is_functional_template__$aT, __vue_module_identifier__$aT, false, undefined, undefined, undefined);

var script$aS = Vue.extend({
  name: "PhCylinder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aS = script$aS;
/* template */

var __vue_render__$aS = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,16C87.6,16,56,34.4,56,58V198c0,23.6,31.6,42,72,42s72-18.4,72-42V58C200,34.4,168.4,16,128,16Zm0,208c-33,0-56-13.7-56-26V84.7c13.1,9.4,33.1,15.3,56,15.3s42.9-5.9,56-15.3V198C184,210.3,161,224,128,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "58",
      "rx": "64",
      "ry": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aS = [];
/* style */

const __vue_inject_styles__$aS = undefined;
/* scoped */

const __vue_scope_id__$aS = undefined;
/* module identifier */

const __vue_module_identifier__$aS = undefined;
/* functional template */

const __vue_is_functional_template__$aS = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aS = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aS,
  staticRenderFns: __vue_staticRenderFns__$aS
}, __vue_inject_styles__$aS, __vue_script__$aS, __vue_scope_id__$aS, __vue_is_functional_template__$aS, __vue_module_identifier__$aS, false, undefined, undefined, undefined);

var script$aR = Vue.extend({
  name: "PhDatabase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aR = script$aR;
/* template */

var __vue_render__$aR = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24C74.2,24,32,48.6,32,80v96c0,31.4,42.2,56,96,56s96-24.6,96-56V80C224,48.6,181.8,24,128,24Zm80,104c0,9.6-7.9,19.4-21.6,26.9C170.9,163.4,150.2,168,128,168s-42.9-4.6-58.4-13.1C55.9,147.4,48,137.6,48,128V111.4C65.1,126.3,94.2,136,128,136s62.9-9.7,80-24.6Zm-21.6,74.9C170.9,211.4,150.2,216,128,216s-42.9-4.6-58.4-13.1C55.9,195.4,48,185.6,48,176V159.4C65.1,174.3,94.2,184,128,184s62.9-9.7,80-24.6V176C208,185.6,200.1,195.4,186.4,202.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "rx": "88",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aR = [];
/* style */

const __vue_inject_styles__$aR = undefined;
/* scoped */

const __vue_scope_id__$aR = undefined;
/* module identifier */

const __vue_module_identifier__$aR = undefined;
/* functional template */

const __vue_is_functional_template__$aR = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aR = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aR,
  staticRenderFns: __vue_staticRenderFns__$aR
}, __vue_inject_styles__$aR, __vue_script__$aR, __vue_scope_id__$aR, __vue_is_functional_template__$aR, __vue_module_identifier__$aR, false, undefined, undefined, undefined);

var script$aQ = Vue.extend({
  name: "PhDesktop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aQ = script$aQ;
/* template */

var __vue_render__$aQ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "140",
      "rx": "16",
      "transform": "translate(256 236) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "224",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,152V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16v88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A24.1,24.1,0,0,0,24,64V176a24.1,24.1,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24.1,24.1,0,0,0,24-24V64A24.1,24.1,0,0,0,208,40Zm0,144H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aQ = [];
/* style */

const __vue_inject_styles__$aQ = undefined;
/* scoped */

const __vue_scope_id__$aQ = undefined;
/* module identifier */

const __vue_module_identifier__$aQ = undefined;
/* functional template */

const __vue_is_functional_template__$aQ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aQ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aQ,
  staticRenderFns: __vue_staticRenderFns__$aQ
}, __vue_inject_styles__$aQ, __vue_script__$aQ, __vue_scope_id__$aQ, __vue_is_functional_template__$aQ, __vue_module_identifier__$aQ, false, undefined, undefined, undefined);

var script$aP = Vue.extend({
  name: "PhDesktopTower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aP = script$aP;
/* template */

var __vue_render__$aP = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,180H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "216",
      "x2": "68",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "76",
      "x2": "180",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "112",
      "x2": "180",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "180",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,80V184a8,8,0,0,1-8,8H96v16h16a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H80V192H32A24.1,24.1,0,0,1,8,168V96A24.1,24.1,0,0,1,32,72h80A8,8,0,0,1,120,80ZM248,48V208a16,16,0,0,1-16,16H152a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h80A16,16,0,0,1,248,48ZM204,180a12,12,0,1,0-12,12A12,12,0,0,0,204,180Zm20-76a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8,8,0,0,0,224,104Zm0-32a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8,8,0,0,0,224,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "104",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "96",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aP = [];
/* style */

const __vue_inject_styles__$aP = undefined;
/* scoped */

const __vue_scope_id__$aP = undefined;
/* module identifier */

const __vue_module_identifier__$aP = undefined;
/* functional template */

const __vue_is_functional_template__$aP = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aP = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aP,
  staticRenderFns: __vue_staticRenderFns__$aP
}, __vue_inject_styles__$aP, __vue_script__$aP, __vue_scope_id__$aP, __vue_is_functional_template__$aP, __vue_module_identifier__$aP, false, undefined, undefined, undefined);

var script$aO = Vue.extend({
  name: "PhDetective",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aO = script$aO;
/* template */

var __vue_render__$aO = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "74",
      "cy": "182",
      "r": "26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "182",
      "cy": "182",
      "r": "26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "182",
      "x2": "156",
      "y2": "182",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "120",
      "x2": "244",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "120",
      "x2": "248",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,180a36,36,0,0,1-71.1,8H111.1a36,36,0,1,1,0-16h33.8a36,36,0,0,1,71.1,8Zm32-68H220.2L173.3,45a16.1,16.1,0,0,0-26.5.3L128,73.6,109.2,45.3A16.1,16.1,0,0,0,82.7,45L35.8,112H8a8,8,0,0,0,0,16H248a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "120",
      "x2": "248",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "120",
      "x2": "248",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "180",
      "x2": "152",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "120",
      "x2": "248",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aO = [];
/* style */

const __vue_inject_styles__$aO = undefined;
/* scoped */

const __vue_scope_id__$aO = undefined;
/* module identifier */

const __vue_module_identifier__$aO = undefined;
/* functional template */

const __vue_is_functional_template__$aO = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aO = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aO,
  staticRenderFns: __vue_staticRenderFns__$aO
}, __vue_inject_styles__$aO, __vue_script__$aO, __vue_scope_id__$aO, __vue_is_functional_template__$aO, __vue_module_identifier__$aO, false, undefined, undefined, undefined);

var script$aN = Vue.extend({
  name: "PhDeviceMobile",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aN = script$aN;
/* template */

var __vue_render__$aN = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "56",
      "width": "128",
      "height": "144",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM80,32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "24",
      "width": "128",
      "height": "208",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "192",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aN = [];
/* style */

const __vue_inject_styles__$aN = undefined;
/* scoped */

const __vue_scope_id__$aN = undefined;
/* module identifier */

const __vue_module_identifier__$aN = undefined;
/* functional template */

const __vue_is_functional_template__$aN = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aN = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aN,
  staticRenderFns: __vue_staticRenderFns__$aN
}, __vue_inject_styles__$aN, __vue_script__$aN, __vue_scope_id__$aN, __vue_is_functional_template__$aN, __vue_module_identifier__$aN, false, undefined, undefined, undefined);

var script$aM = Vue.extend({
  name: "PhDeviceMobileCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aM = script$aM;
/* template */

var __vue_render__$aM = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM128,72a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aM = [];
/* style */

const __vue_inject_styles__$aM = undefined;
/* scoped */

const __vue_scope_id__$aM = undefined;
/* module identifier */

const __vue_module_identifier__$aM = undefined;
/* functional template */

const __vue_is_functional_template__$aM = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aM = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aM,
  staticRenderFns: __vue_staticRenderFns__$aM
}, __vue_inject_styles__$aM, __vue_script__$aM, __vue_scope_id__$aM, __vue_is_functional_template__$aM, __vue_module_identifier__$aM, false, undefined, undefined, undefined);

var script$aL = Vue.extend({
  name: "PhDeviceMobileSpeaker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aL = script$aL;
/* template */

var __vue_render__$aL = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "152",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "64",
      "width": "208",
      "height": "128",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "160",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aL = [];
/* style */

const __vue_inject_styles__$aL = undefined;
/* scoped */

const __vue_scope_id__$aL = undefined;
/* module identifier */

const __vue_module_identifier__$aL = undefined;
/* functional template */

const __vue_is_functional_template__$aL = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aL = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aL,
  staticRenderFns: __vue_staticRenderFns__$aL
}, __vue_inject_styles__$aL, __vue_script__$aL, __vue_scope_id__$aL, __vue_is_functional_template__$aL, __vue_module_identifier__$aL, false, undefined, undefined, undefined);

var script$aK = Vue.extend({
  name: "PhDeviceTablet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aK = script$aK;
/* template */

var __vue_render__$aK = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "72",
      "x2": "208",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "64",
      "width": "160",
      "height": "128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM64,40H192a8,8,0,0,1,8,8v8H56V48A8,8,0,0,1,64,40ZM192,216H64a8,8,0,0,1-8-8v-8H200v8A8,8,0,0,1,192,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "208",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "208",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aK = [];
/* style */

const __vue_inject_styles__$aK = undefined;
/* scoped */

const __vue_scope_id__$aK = undefined;
/* module identifier */

const __vue_module_identifier__$aK = undefined;
/* functional template */

const __vue_is_functional_template__$aK = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aK = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aK,
  staticRenderFns: __vue_staticRenderFns__$aK
}, __vue_inject_styles__$aK, __vue_script__$aK, __vue_scope_id__$aK, __vue_is_functional_template__$aK, __vue_module_identifier__$aK, false, undefined, undefined, undefined);

var script$aJ = Vue.extend({
  name: "PhDeviceTabletCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aJ = script$aJ;
/* template */

var __vue_render__$aJ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM128,80a12,12,0,1,1,12-12A12,12,0,0,1,128,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "68",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aJ = [];
/* style */

const __vue_inject_styles__$aJ = undefined;
/* scoped */

const __vue_scope_id__$aJ = undefined;
/* module identifier */

const __vue_module_identifier__$aJ = undefined;
/* functional template */

const __vue_is_functional_template__$aJ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aJ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aJ,
  staticRenderFns: __vue_staticRenderFns__$aJ
}, __vue_inject_styles__$aJ, __vue_script__$aJ, __vue_scope_id__$aJ, __vue_is_functional_template__$aJ, __vue_module_identifier__$aJ, false, undefined, undefined, undefined);

var script$aI = Vue.extend({
  name: "PhDeviceTabletSpeaker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aI = script$aI;
/* template */

var __vue_render__$aI = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "160",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM160,72H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aI = [];
/* style */

const __vue_inject_styles__$aI = undefined;
/* scoped */

const __vue_scope_id__$aI = undefined;
/* module identifier */

const __vue_module_identifier__$aI = undefined;
/* functional template */

const __vue_is_functional_template__$aI = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aI = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aI,
  staticRenderFns: __vue_staticRenderFns__$aI
}, __vue_inject_styles__$aI, __vue_script__$aI, __vue_scope_id__$aI, __vue_is_functional_template__$aI, __vue_module_identifier__$aI, false, undefined, undefined, undefined);

var script$aH = Vue.extend({
  name: "PhDiamond",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aH = script$aH;
/* template */

var __vue_render__$aH = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236,139.3,139.3,236a15.9,15.9,0,0,1-22.6,0L20,139.3a16.1,16.1,0,0,1,0-22.6L116.7,20a16.1,16.1,0,0,1,22.6,0L236,116.7A16.1,16.1,0,0,1,236,139.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "51.6",
      "y": "51.6",
      "width": "152.7",
      "height": "152.74",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aH = [];
/* style */

const __vue_inject_styles__$aH = undefined;
/* scoped */

const __vue_scope_id__$aH = undefined;
/* module identifier */

const __vue_module_identifier__$aH = undefined;
/* functional template */

const __vue_is_functional_template__$aH = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aH = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aH,
  staticRenderFns: __vue_staticRenderFns__$aH
}, __vue_inject_styles__$aH, __vue_script__$aH, __vue_scope_id__$aH, __vue_is_functional_template__$aH, __vue_module_identifier__$aH, false, undefined, undefined, undefined);

var script$aG = Vue.extend({
  name: "PhDiamondsFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aG = script$aG;
/* template */

var __vue_render__$aG = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "101.1",
      "y": "35.1",
      "width": "53.7",
      "height": "53.74",
      "rx": "8",
      "transform": "translate(-6.4 108.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "167.1",
      "y": "101.1",
      "width": "53.7",
      "height": "53.74",
      "rx": "8",
      "transform": "translate(-33.7 174.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.1",
      "y": "101.1",
      "width": "53.7",
      "height": "53.74",
      "rx": "8",
      "transform": "translate(-72.4 81.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "101.1",
      "y": "167.1",
      "width": "53.7",
      "height": "53.74",
      "rx": "8",
      "transform": "translate(-99.7 147.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "99.7",
      "y": "35.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-7.8 109.3) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "163.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-34.3 173.3) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-71.8 82.7) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "163.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-98.3 146.7) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "35.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-7.8 109.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "163.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-34.3 173.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-71.8 82.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "163.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-98.3 146.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,75.3a16.1,16.1,0,0,1,0-22.6L116.7,24a15.9,15.9,0,0,1,22.6,0L168,52.7a16.1,16.1,0,0,1,0,22.6L139.3,104a15.9,15.9,0,0,1-22.6,0Zm144,41.4L203.3,88a15.9,15.9,0,0,0-22.6,0L152,116.7a16.1,16.1,0,0,0,0,22.6L180.7,168a15.9,15.9,0,0,0,22.6,0L232,139.3A16.1,16.1,0,0,0,232,116.7Zm-128,0L75.3,88a15.9,15.9,0,0,0-22.6,0L24,116.7a16.1,16.1,0,0,0,0,22.6L52.7,168a15.9,15.9,0,0,0,22.6,0L104,139.3A16.1,16.1,0,0,0,104,116.7ZM139.3,152a15.9,15.9,0,0,0-22.6,0L88,180.7a16.1,16.1,0,0,0,0,22.6L116.7,232a15.9,15.9,0,0,0,22.6,0L168,203.3a16.1,16.1,0,0,0,0-22.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "99.7",
      "y": "35.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-7.8 109.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "163.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-34.3 173.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-71.8 82.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "163.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-98.3 146.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "99.7",
      "y": "35.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-7.8 109.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "163.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-34.3 173.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-71.8 82.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "163.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-98.3 146.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "99.7",
      "y": "35.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-7.8 109.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "163.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-34.3 173.3) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "35.7",
      "y": "99.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-71.8 82.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "99.7",
      "y": "163.7",
      "width": "56.6",
      "height": "56.57",
      "rx": "8",
      "transform": "translate(-98.3 146.7) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aG = [];
/* style */

const __vue_inject_styles__$aG = undefined;
/* scoped */

const __vue_scope_id__$aG = undefined;
/* module identifier */

const __vue_module_identifier__$aG = undefined;
/* functional template */

const __vue_is_functional_template__$aG = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aG = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aG,
  staticRenderFns: __vue_staticRenderFns__$aG
}, __vue_inject_styles__$aG, __vue_script__$aG, __vue_scope_id__$aG, __vue_is_functional_template__$aG, __vue_module_identifier__$aG, false, undefined, undefined, undefined);

var script$aF = Vue.extend({
  name: "PhDiceFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aF = script$aF;
/* template */

var __vue_render__$aF = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,176a12,12,0,1,1,12-12A12,12,0,0,1,92,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,164,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aF = [];
/* style */

const __vue_inject_styles__$aF = undefined;
/* scoped */

const __vue_scope_id__$aF = undefined;
/* module identifier */

const __vue_module_identifier__$aF = undefined;
/* functional template */

const __vue_is_functional_template__$aF = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aF = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aF,
  staticRenderFns: __vue_staticRenderFns__$aF
}, __vue_inject_styles__$aF, __vue_script__$aF, __vue_scope_id__$aF, __vue_is_functional_template__$aF, __vue_module_identifier__$aF, false, undefined, undefined, undefined);

var script$aE = Vue.extend({
  name: "PhDiceFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aE = script$aE;
/* template */

var __vue_render__$aE = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "96",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM100,168a12,12,0,1,1,12-12A12,12,0,0,1,100,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,100,112Zm56,56a12,12,0,1,1,12-12A12,12,0,0,1,156,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,156,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "156",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "156",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aE = [];
/* style */

const __vue_inject_styles__$aE = undefined;
/* scoped */

const __vue_scope_id__$aE = undefined;
/* module identifier */

const __vue_module_identifier__$aE = undefined;
/* functional template */

const __vue_is_functional_template__$aE = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aE = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aE,
  staticRenderFns: __vue_staticRenderFns__$aE
}, __vue_inject_styles__$aE, __vue_script__$aE, __vue_scope_id__$aE, __vue_is_functional_template__$aE, __vue_module_identifier__$aE, false, undefined, undefined, undefined);

var script$aD = Vue.extend({
  name: "PhDiceOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aD = script$aD;
/* template */

var __vue_render__$aD = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aD = [];
/* style */

const __vue_inject_styles__$aD = undefined;
/* scoped */

const __vue_scope_id__$aD = undefined;
/* module identifier */

const __vue_module_identifier__$aD = undefined;
/* functional template */

const __vue_is_functional_template__$aD = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aD = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aD,
  staticRenderFns: __vue_staticRenderFns__$aD
}, __vue_inject_styles__$aD, __vue_script__$aD, __vue_scope_id__$aD, __vue_is_functional_template__$aD, __vue_module_identifier__$aD, false, undefined, undefined, undefined);

var script$aC = Vue.extend({
  name: "PhDiceSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aC = script$aC;
/* template */

var __vue_render__$aC = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "84",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "172",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,184a12,12,0,1,1,12-12A12,12,0,0,1,92,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,96Zm72,88a12,12,0,1,1,12-12A12,12,0,0,1,164,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "84",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aC = [];
/* style */

const __vue_inject_styles__$aC = undefined;
/* scoped */

const __vue_scope_id__$aC = undefined;
/* module identifier */

const __vue_module_identifier__$aC = undefined;
/* functional template */

const __vue_is_functional_template__$aC = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aC = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aC,
  staticRenderFns: __vue_staticRenderFns__$aC
}, __vue_inject_styles__$aC, __vue_script__$aC, __vue_scope_id__$aC, __vue_is_functional_template__$aC, __vue_module_identifier__$aC, false, undefined, undefined, undefined);

var script$aB = Vue.extend({
  name: "PhDiceThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aB = script$aB;
/* template */

var __vue_render__$aB = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,104a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aB = [];
/* style */

const __vue_inject_styles__$aB = undefined;
/* scoped */

const __vue_scope_id__$aB = undefined;
/* module identifier */

const __vue_module_identifier__$aB = undefined;
/* functional template */

const __vue_is_functional_template__$aB = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aB = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aB,
  staticRenderFns: __vue_staticRenderFns__$aB
}, __vue_inject_styles__$aB, __vue_script__$aB, __vue_scope_id__$aB, __vue_is_functional_template__$aB, __vue_module_identifier__$aB, false, undefined, undefined, undefined);

var script$aA = Vue.extend({
  name: "PhDiceTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aA = script$aA;
/* template */

var __vue_render__$aA = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "104",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32Zm-84,88a12,12,0,1,1,12-12A12,12,0,0,1,108,120Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,148,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "148",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aA = [];
/* style */

const __vue_inject_styles__$aA = undefined;
/* scoped */

const __vue_scope_id__$aA = undefined;
/* module identifier */

const __vue_module_identifier__$aA = undefined;
/* functional template */

const __vue_is_functional_template__$aA = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aA = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aA,
  staticRenderFns: __vue_staticRenderFns__$aA
}, __vue_inject_styles__$aA, __vue_script__$aA, __vue_scope_id__$aA, __vue_is_functional_template__$aA, __vue_module_identifier__$aA, false, undefined, undefined, undefined);

var script$az = Vue.extend({
  name: "PhDisc",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$az = script$az;
/* template */

var __vue_render__$az = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "150.6",
      "y2": "105.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,128a32.1,32.1,0,1,1-9.4-22.6h0l45.3-45.3h0A96,96,0,1,0,224,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "150.6",
      "y2": "105.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.3,43.3l-.6-.5-.8-.4A102.9,102.9,0,0,0,128,24a104.1,104.1,0,1,0,60.3,19.3ZM128,152a24,24,0,1,1,24-24A24.1,24.1,0,0,1,128,152Zm88-24c0,2.5-.1,4.9-.3,7.3L168,126.9a39.8,39.8,0,0,0-11-26.4l27.8-39.7A87.9,87.9,0,0,1,216,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "150.6",
      "y2": "105.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "150.6",
      "y2": "105.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "150.6",
      "y2": "105.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$az = [];
/* style */

const __vue_inject_styles__$az = undefined;
/* scoped */

const __vue_scope_id__$az = undefined;
/* module identifier */

const __vue_module_identifier__$az = undefined;
/* functional template */

const __vue_is_functional_template__$az = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$az = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$az,
  staticRenderFns: __vue_staticRenderFns__$az
}, __vue_inject_styles__$az, __vue_script__$az, __vue_scope_id__$az, __vue_is_functional_template__$az, __vue_module_identifier__$az, false, undefined, undefined, undefined);

var script$ay = Vue.extend({
  name: "PhDiscordLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ay = script$ay;
/* template */

var __vue_render__$ay = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.3,174.6l15.8,31.5a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3L151.5,81.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.7,174.6,88.9,206.1a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l10.5,31.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.1,168c-15.2,5.1-33.5,8-53.1,8s-37.9-2.9-53.1-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,86.4A173.7,173.7,0,0,0,128,80a173.7,173.7,0,0,0-48,6.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9h0a190.1,190.1,0,0,1,52.2,0h0L162,49.9a8.1,8.1,0,0,1,9.4-5.3A176.4,176.4,0,0,1,201,53.8a7.7,7.7,0,0,1,4.7,5.1l33.9,113.2a8.1,8.1,0,0,1-2.4,8.4c-15.4,13.4-36.6,23.8-61.1,29.8a7.8,7.8,0,0,1-9-4.2l-12.1-24a195,195,0,0,1-27,1.9,195,195,0,0,1-27-1.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.3,169.8l-34-113.2a15.6,15.6,0,0,0-9.2-10.2h-.6l.6-.2A192.4,192.4,0,0,0,169.6,36a8,8,0,0,0-9.4,6.3,7.9,7.9,0,0,0,6.2,9.4c4.5.9,8.9,2,13.2,3.2A8,8,0,0,1,176,70h-.8A185.4,185.4,0,0,0,128,64a181.8,181.8,0,0,0-46.1,5.8,8,8,0,0,1-5.6-14.9h.1c4.3-1.2,8.7-2.3,13.2-3.2a8,8,0,0,0,6.3-9.4A8.1,8.1,0,0,0,86.5,36,191.2,191.2,0,0,0,51.9,46.4a15.6,15.6,0,0,0-9.2,10.2L8.7,169.8a16,16,0,0,0,4.9,16.7,34.7,34.7,0,0,0,2.9,2.5h.1c16.2,13.2,37.5,23.3,61.5,29.1a6.3,6.3,0,0,0,1.9.3,8,8,0,0,0,1.9-15.8,160.3,160.3,0,0,1-31.3-11.1h0a8,8,0,0,1,8.6-13.2c19,8.4,42.9,13.7,68.8,13.7s49.8-5.3,68.8-13.7a8,8,0,0,1,8.6,13.2h0a160.3,160.3,0,0,1-31.3,11.1,8,8,0,0,0,1.9,15.8,6.3,6.3,0,0,0,1.9-.3c24-5.8,45.3-15.9,61.5-29.1h.1a34.7,34.7,0,0,0,2.9-2.5A16,16,0,0,0,247.3,169.8ZM96,156a12,12,0,1,1,12-12A12,12,0,0,1,96,156Zm64,0a12,12,0,1,1,12-12A12,12,0,0,1,160,156Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ay = [];
/* style */

const __vue_inject_styles__$ay = undefined;
/* scoped */

const __vue_scope_id__$ay = undefined;
/* module identifier */

const __vue_module_identifier__$ay = undefined;
/* functional template */

const __vue_is_functional_template__$ay = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ay = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ay,
  staticRenderFns: __vue_staticRenderFns__$ay
}, __vue_inject_styles__$ay, __vue_script__$ay, __vue_scope_id__$ay, __vue_is_functional_template__$ay, __vue_module_identifier__$ay, false, undefined, undefined, undefined);

var script$ax = Vue.extend({
  name: "PhDivide",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ax = script$ax;
/* template */

var __vue_render__$ax = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "20"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16,16,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16,16,0,0,0,128,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "14"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ax = [];
/* style */

const __vue_inject_styles__$ax = undefined;
/* scoped */

const __vue_scope_id__$ax = undefined;
/* module identifier */

const __vue_module_identifier__$ax = undefined;
/* functional template */

const __vue_is_functional_template__$ax = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ax = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ax,
  staticRenderFns: __vue_staticRenderFns__$ax
}, __vue_inject_styles__$ax, __vue_script__$ax, __vue_scope_id__$ax, __vue_is_functional_template__$ax, __vue_module_identifier__$ax, false, undefined, undefined, undefined);

var script$aw = Vue.extend({
  name: "PhDog",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aw = script$aw;
/* template */

var __vue_render__$aw = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "136",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "136",
      "r": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3L104,48h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm68.7,16a16.1,16.1,0,0,1-6.7,1.4,15.6,15.6,0,0,1-10-3.6V184a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V141.8a15.6,15.6,0,0,1-10,3.6,16.1,16.1,0,0,1-6.7-1.4,15.8,15.8,0,0,1-9.1-17.6L30.6,38.9A16.1,16.1,0,0,1,50.2,26.3L105,40h46l54.8-13.7a16.1,16.1,0,0,1,19.6,12.6l16.4,87.5A15.8,15.8,0,0,1,232.7,144ZM200,184V122L148.1,56H107.9L56,122v62a24.1,24.1,0,0,0,24,24h40V195.3l-13.7-13.6a8.1,8.1,0,0,1,11.4-11.4L128,180.7l10.3-10.4a8.1,8.1,0,0,1,11.4,11.4L136,195.3V208h40A24.1,24.1,0,0,0,200,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 176 128 192 112 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "152",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aw = [];
/* style */

const __vue_inject_styles__$aw = undefined;
/* scoped */

const __vue_scope_id__$aw = undefined;
/* module identifier */

const __vue_module_identifier__$aw = undefined;
/* functional template */

const __vue_is_functional_template__$aw = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aw = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aw,
  staticRenderFns: __vue_staticRenderFns__$aw
}, __vue_inject_styles__$aw, __vue_script__$aw, __vue_scope_id__$aw, __vue_is_functional_template__$aw, __vue_module_identifier__$aw, false, undefined, undefined, undefined);

var script$av = Vue.extend({
  name: "PhDoor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$av = script$av;
/* template */

var __vue_render__$av = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-68-76a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "24",
      "y1": "224",
      "x2": "232",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$av = [];
/* style */

const __vue_inject_styles__$av = undefined;
/* scoped */

const __vue_scope_id__$av = undefined;
/* module identifier */

const __vue_module_identifier__$av = undefined;
/* functional template */

const __vue_is_functional_template__$av = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$av = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$av,
  staticRenderFns: __vue_staticRenderFns__$av
}, __vue_inject_styles__$av, __vue_script__$av, __vue_scope_id__$av, __vue_is_functional_template__$av, __vue_module_identifier__$av, false, undefined, undefined, undefined);

var script$au = Vue.extend({
  name: "PhDotsNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$au = script$au;
/* template */

var __vue_render__$au = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60,48A12,12,0,1,0,72,60,12,12,0,0,0,60,48Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,48Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72ZM60,184a12,12,0,1,0,12,12A12,12,0,0,0,60,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,184ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$au = [];
/* style */

const __vue_inject_styles__$au = undefined;
/* scoped */

const __vue_scope_id__$au = undefined;
/* module identifier */

const __vue_module_identifier__$au = undefined;
/* functional template */

const __vue_is_functional_template__$au = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$au = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$au,
  staticRenderFns: __vue_staticRenderFns__$au
}, __vue_inject_styles__$au, __vue_script__$au, __vue_scope_id__$au, __vue_is_functional_template__$au, __vue_module_identifier__$au, false, undefined, undefined, undefined);

var script$at = Vue.extend({
  name: "PhDotsSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$at = script$at;
/* template */

var __vue_render__$at = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,92A12,12,0,1,1,60,80,12,12,0,0,1,72,92Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104ZM60,152a12,12,0,1,0,12,12A12,12,0,0,0,60,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "164",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$at = [];
/* style */

const __vue_inject_styles__$at = undefined;
/* scoped */

const __vue_scope_id__$at = undefined;
/* module identifier */

const __vue_module_identifier__$at = undefined;
/* functional template */

const __vue_is_functional_template__$at = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$at = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$at,
  staticRenderFns: __vue_staticRenderFns__$at
}, __vue_inject_styles__$at, __vue_script__$at, __vue_scope_id__$at, __vue_is_functional_template__$at, __vue_module_identifier__$at, false, undefined, undefined, undefined);

var script$as = Vue.extend({
  name: "PhDotsSixVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$as = script$as;
/* template */

var __vue_render__$as = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "196",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$as = [];
/* style */

const __vue_inject_styles__$as = undefined;
/* scoped */

const __vue_scope_id__$as = undefined;
/* module identifier */

const __vue_module_identifier__$as = undefined;
/* functional template */

const __vue_is_functional_template__$as = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$as = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$as,
  staticRenderFns: __vue_staticRenderFns__$as
}, __vue_inject_styles__$as, __vue_script__$as, __vue_scope_id__$as, __vue_is_functional_template__$as, __vue_module_identifier__$as, false, undefined, undefined, undefined);

var script$ar = Vue.extend({
  name: "PhDotsThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ar = script$ar;
/* template */

var __vue_render__$ar = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm52-12a12,12,0,1,0,12,12A12,12,0,0,0,192,116ZM64,116a12,12,0,1,0,12,12A12,12,0,0,0,64,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ar = [];
/* style */

const __vue_inject_styles__$ar = undefined;
/* scoped */

const __vue_scope_id__$ar = undefined;
/* module identifier */

const __vue_module_identifier__$ar = undefined;
/* functional template */

const __vue_is_functional_template__$ar = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ar = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ar,
  staticRenderFns: __vue_staticRenderFns__$ar
}, __vue_inject_styles__$ar, __vue_script__$ar, __vue_scope_id__$ar, __vue_is_functional_template__$ar, __vue_module_identifier__$ar, false, undefined, undefined, undefined);

var script$aq = Vue.extend({
  name: "PhDotsThreeCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aq = script$aq;
/* template */

var __vue_render__$aq = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aq = [];
/* style */

const __vue_inject_styles__$aq = undefined;
/* scoped */

const __vue_scope_id__$aq = undefined;
/* module identifier */

const __vue_module_identifier__$aq = undefined;
/* functional template */

const __vue_is_functional_template__$aq = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aq = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aq,
  staticRenderFns: __vue_staticRenderFns__$aq
}, __vue_inject_styles__$aq, __vue_script__$aq, __vue_scope_id__$aq, __vue_is_functional_template__$aq, __vue_module_identifier__$aq, false, undefined, undefined, undefined);

var script$ap = Vue.extend({
  name: "PhDotsThreeCircleVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ap = script$ap;
/* template */

var __vue_render__$ap = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "100",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "156",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A104,104,0,1,0,128,232,104.2,104.2,0,0,0,232,128ZM116,80a12,12,0,1,1,12,12A12,12,0,0,1,116,80Zm0,48a12,12,0,1,1,12,12A12,12,0,0,1,116,128Zm0,48a12,12,0,1,1,12,12A12,12,0,0,1,116,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ap = [];
/* style */

const __vue_inject_styles__$ap = undefined;
/* scoped */

const __vue_scope_id__$ap = undefined;
/* module identifier */

const __vue_module_identifier__$ap = undefined;
/* functional template */

const __vue_is_functional_template__$ap = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ap = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ap,
  staticRenderFns: __vue_staticRenderFns__$ap
}, __vue_inject_styles__$ap, __vue_script__$ap, __vue_scope_id__$ap, __vue_is_functional_template__$ap, __vue_module_identifier__$ap, false, undefined, undefined, undefined);

var script$ao = Vue.extend({
  name: "PhDotsThreeOutline",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ao = script$ao;
/* template */

var __vue_render__$ao = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,128a28,28,0,1,1-28-28A28.1,28.1,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28.1,28.1,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28.1,28.1,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ao = [];
/* style */

const __vue_inject_styles__$ao = undefined;
/* scoped */

const __vue_scope_id__$ao = undefined;
/* module identifier */

const __vue_module_identifier__$ao = undefined;
/* functional template */

const __vue_is_functional_template__$ao = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ao = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ao,
  staticRenderFns: __vue_staticRenderFns__$ao
}, __vue_inject_styles__$ao, __vue_script__$ao, __vue_scope_id__$ao, __vue_is_functional_template__$ao, __vue_module_identifier__$ao, false, undefined, undefined, undefined);

var script$an = Vue.extend({
  name: "PhDotsThreeOutlineVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$an = script$an;
/* template */

var __vue_render__$an = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "opacity": "0.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,128a28,28,0,1,1-28-28A28.1,28.1,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28.1,28.1,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28.1,28.1,0,0,0,128,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$an = [];
/* style */

const __vue_inject_styles__$an = undefined;
/* scoped */

const __vue_scope_id__$an = undefined;
/* module identifier */

const __vue_module_identifier__$an = undefined;
/* functional template */

const __vue_is_functional_template__$an = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$an = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$an,
  staticRenderFns: __vue_staticRenderFns__$an
}, __vue_inject_styles__$an, __vue_script__$an, __vue_scope_id__$an, __vue_is_functional_template__$an, __vue_module_identifier__$an, false, undefined, undefined, undefined);

var script$am = Vue.extend({
  name: "PhDotsThreeVertical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$am = script$am;
/* template */

var __vue_render__$am = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,76a12,12,0,1,0-12-12A12,12,0,0,0,128,76Zm0,104a12,12,0,1,0,12,12A12,12,0,0,0,128,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$am = [];
/* style */

const __vue_inject_styles__$am = undefined;
/* scoped */

const __vue_scope_id__$am = undefined;
/* module identifier */

const __vue_module_identifier__$am = undefined;
/* functional template */

const __vue_is_functional_template__$am = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$am = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$am,
  staticRenderFns: __vue_staticRenderFns__$am
}, __vue_inject_styles__$am, __vue_script__$am, __vue_scope_id__$am, __vue_is_functional_template__$am, __vue_module_identifier__$am, false, undefined, undefined, undefined);

var script$al = Vue.extend({
  name: "PhDownload",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$al = script$al;
/* template */

var __vue_render__$al = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,128H224a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H71.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "128",
      "width": "208",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M74.3,85.7A8.1,8.1,0,0,1,85.7,74.3L120,108.7V24a8,8,0,0,1,16,0v84.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4l-48,48a8.2,8.2,0,0,1-11.4,0ZM240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H84.4a3.6,3.6,0,0,1,2.8,1.2L111,145a24.1,24.1,0,0,0,34,0l23.8-23.8a3.6,3.6,0,0,1,2.8-1.2H224A16,16,0,0,1,240,136Zm-40,32a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 80 128 128 176 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$al = [];
/* style */

const __vue_inject_styles__$al = undefined;
/* scoped */

const __vue_scope_id__$al = undefined;
/* module identifier */

const __vue_module_identifier__$al = undefined;
/* functional template */

const __vue_is_functional_template__$al = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$al = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$al,
  staticRenderFns: __vue_staticRenderFns__$al
}, __vue_inject_styles__$al, __vue_script__$al, __vue_scope_id__$al, __vue_is_functional_template__$al, __vue_module_identifier__$al, false, undefined, undefined, undefined);

var script$ak = Vue.extend({
  name: "PhDownloadSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ak = script$ak;
/* template */

var __vue_render__$ak = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110 128 152 170 110",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110 128 152 170 110",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.3,115.7a8.2,8.2,0,0,1-1.7-8.7,8,8,0,0,1,7.4-5h34V40a8,8,0,0,1,16,0v62h34a8,8,0,0,1,7.4,5,8.2,8.2,0,0,1-1.7,8.7l-42,42a8.2,8.2,0,0,1-11.4,0ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110 128 152 170 110",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110 128 152 170 110",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 110 128 152 170 110",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ak = [];
/* style */

const __vue_inject_styles__$ak = undefined;
/* scoped */

const __vue_scope_id__$ak = undefined;
/* module identifier */

const __vue_module_identifier__$ak = undefined;
/* functional template */

const __vue_is_functional_template__$ak = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ak = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ak,
  staticRenderFns: __vue_staticRenderFns__$ak
}, __vue_inject_styles__$ak, __vue_script__$ak, __vue_scope_id__$ak, __vue_is_functional_template__$ak, __vue_module_identifier__$ak, false, undefined, undefined, undefined);

var script$aj = Vue.extend({
  name: "PhDribbbleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aj = script$aj;
/* template */

var __vue_render__$aj = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.3,36.9a4,4,0,0,1,.8-7.2,103.7,103.7,0,0,1,88.6,9.9,4,4,0,0,1,1.1,5.9,156.1,156.1,0,0,1-41.9,37A169,169,0,0,0,93.3,36.9ZM127.6,90a154.2,154.2,0,0,0-56-46.9,4.3,4.3,0,0,0-4.1.3A105.1,105.1,0,0,0,29.2,95.5a4,4,0,0,0,3,5.1A151.1,151.1,0,0,0,64,104,150.6,150.6,0,0,0,127.6,90Zm103.8,26.7a104,104,0,0,0-29.2-61.5,4.1,4.1,0,0,0-6,.3,168.3,168.3,0,0,1-45.7,40.4,171.5,171.5,0,0,1,13.6,29.9A167.3,167.3,0,0,1,208,120a171.5,171.5,0,0,1,19,1.1A4,4,0,0,0,231.4,116.7Zm-62.9,24.5a169,169,0,0,1,4.4,38.5,168.1,168.1,0,0,1-4.1,36.8,4,4,0,0,0,5.7,4.5,104.1,104.1,0,0,0,56.6-79.2,4,4,0,0,0-3.5-4.5A141.3,141.3,0,0,0,208,136,151.2,151.2,0,0,0,168.5,141.2Zm-19.7-10.4a142.6,142.6,0,0,0-12.4-27.2A167.2,167.2,0,0,1,64,120a167.3,167.3,0,0,1-34.9-3.7,4,4,0,0,0-4.8,3.6q-.3,4-.3,8.1a103.7,103.7,0,0,0,33,75.9,3.9,3.9,0,0,0,6.1-.9A168.8,168.8,0,0,1,148.8,130.8ZM75.7,213.2a4,4,0,0,0,1.5,5.5A102.9,102.9,0,0,0,128,232a98.3,98.3,0,0,0,18.1-1.6,3.8,3.8,0,0,0,3-2.6,151,151,0,0,0,7.8-48.1,154.2,154.2,0,0,0-3.7-33.5A153.2,153.2,0,0,0,75.7,213.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aj = [];
/* style */

const __vue_inject_styles__$aj = undefined;
/* scoped */

const __vue_scope_id__$aj = undefined;
/* module identifier */

const __vue_module_identifier__$aj = undefined;
/* functional template */

const __vue_is_functional_template__$aj = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aj = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aj,
  staticRenderFns: __vue_staticRenderFns__$aj
}, __vue_inject_styles__$aj, __vue_script__$aj, __vue_scope_id__$aj, __vue_is_functional_template__$aj, __vue_module_identifier__$aj, false, undefined, undefined, undefined);

var script$ai = Vue.extend({
  name: "PhDrop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ai = script$ai;
/* template */

var __vue_render__$ai = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,152A35.8,35.8,0,0,1,136,179.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8Zm9.2,105.6a55.8,55.8,0,0,1-45.8,45.7h-1.3a8,8,0,0,1-1.3-15.9,39.7,39.7,0,0,0,32.6-32.6,8,8,0,0,1,9.3-6.5A7.9,7.9,0,0,1,183.2,153.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ai = [];
/* style */

const __vue_inject_styles__$ai = undefined;
/* scoped */

const __vue_scope_id__$ai = undefined;
/* module identifier */

const __vue_module_identifier__$ai = undefined;
/* functional template */

const __vue_is_functional_template__$ai = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ai = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ai,
  staticRenderFns: __vue_staticRenderFns__$ai
}, __vue_inject_styles__$ai, __vue_script__$ai, __vue_scope_id__$ai, __vue_is_functional_template__$ai, __vue_module_identifier__$ai, false, undefined, undefined, undefined);

var script$ah = Vue.extend({
  name: "PhDropHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ah = script$ah;
/* template */

var __vue_render__$ah = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "132",
      "x2": "207.3",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "194.7",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "172",
      "x2": "203",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,224a80,80,0,0,0,80-80c0-72-80-128-80-128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8ZM56,144c0-57.2,55.5-105,72-118V216A72.1,72.1,0,0,1,56,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "196.6",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "177",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "196.6",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "177",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "196.6",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "177",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ah = [];
/* style */

const __vue_inject_styles__$ah = undefined;
/* scoped */

const __vue_scope_id__$ah = undefined;
/* module identifier */

const __vue_module_identifier__$ah = undefined;
/* functional template */

const __vue_is_functional_template__$ah = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ah = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ah,
  staticRenderFns: __vue_staticRenderFns__$ah
}, __vue_inject_styles__$ah, __vue_script__$ah, __vue_scope_id__$ah, __vue_is_functional_template__$ah, __vue_module_identifier__$ah, false, undefined, undefined, undefined);

var script$ag = Vue.extend({
  name: "PhDropHalfBottom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ag = script$ag;
/* template */

var __vue_render__$ag = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56.5",
      "y1": "180",
      "x2": "199.5",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48.1",
      "y1": "140",
      "x2": "207.9",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M49.3,128A105.7,105.7,0,0,0,48,144a80,80,0,0,0,160,0,105.7,105.7,0,0,0-1.3-16H49.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.3",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8ZM128,26c14.2,11.1,56.9,47.8,68.8,94H59.2C71.1,73.8,113.8,37.1,128,26Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.3",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.6",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.3",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.6",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.3",
      "y1": "128",
      "x2": "206.7",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "49.6",
      "y1": "160",
      "x2": "206.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "192",
      "x2": "192",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ag = [];
/* style */

const __vue_inject_styles__$ag = undefined;
/* scoped */

const __vue_scope_id__$ag = undefined;
/* module identifier */

const __vue_module_identifier__$ag = undefined;
/* functional template */

const __vue_is_functional_template__$ag = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ag = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ag,
  staticRenderFns: __vue_staticRenderFns__$ag
}, __vue_inject_styles__$ag, __vue_script__$ag, __vue_scope_id__$ag, __vue_is_functional_template__$ag, __vue_module_identifier__$ag, false, undefined, undefined, undefined);

var script$af = Vue.extend({
  name: "PhEar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$af = script$af;
/* template */

var __vue_render__$af = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.3,160a20,20,0,0,1-38.3-8c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0C208,144,209,169,161.9,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,152a28,28,0,0,1-56,0c0-15.7,9.3-23.7,16.8-30.1S160,111.9,160,104a32,32,0,0,0-64,0,8,8,0,0,1-16,0,48,48,0,0,1,96,0c0,15.7-9.3,23.7-16.8,30.1S148,144.1,148,152a12,12,0,0,0,24,0,8,8,0,0,1,16,0ZM128,16a88.1,88.1,0,0,0-88,88c0,33.5,12.5,45.5,22.5,55.2,7.8,7.5,13.5,13,13.5,28.8a52,52,0,0,0,92.1,33.1,8.1,8.1,0,0,0-1.1-11.3,7.9,7.9,0,0,0-11.2,1.1A36,36,0,0,1,92,188c0-22.6-9.8-32-18.4-40.4S56,130.7,56,104a72,72,0,0,1,144,0,8,8,0,0,0,16,0A88.1,88.1,0,0,0,128,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$af = [];
/* style */

const __vue_inject_styles__$af = undefined;
/* scoped */

const __vue_scope_id__$af = undefined;
/* module identifier */

const __vue_module_identifier__$af = undefined;
/* functional template */

const __vue_is_functional_template__$af = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$af = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$af,
  staticRenderFns: __vue_staticRenderFns__$af
}, __vue_inject_styles__$af, __vue_script__$af, __vue_scope_id__$af, __vue_is_functional_template__$af, __vue_module_identifier__$af, false, undefined, undefined, undefined);

var script$ae = Vue.extend({
  name: "PhEarSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ae = script$ae;
/* template */

var __vue_render__$ae = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.4,87.8A39.5,39.5,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.3,31.4A80.1,80.1,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167,111.4a27.6,27.6,0,0,0,1-7.4,40,40,0,0,0-40-40l-3.9.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0C208,144,209,169,161.9,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.4,87.8A39.5,39.5,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87,35.3A80,80,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-37.9-41.7a29.7,29.7,0,0,1-4.2.3,28.1,28.1,0,0,1-28-28,31.1,31.1,0,0,1,.7-6.9L96,104.7a8,8,0,0,1-16-.7,50.4,50.4,0,0,1,2.2-14.5L64.5,70A71.4,71.4,0,0,0,56,104c0,26.7,8.5,34.9,17.6,43.6S92,165.4,92,188a36,36,0,0,0,63.8,22.9,7.9,7.9,0,0,1,11.2-1.1,8.1,8.1,0,0,1,1.1,11.3A52,52,0,0,1,76,188c0-15.8-5.7-21.3-13.5-28.8C52.5,149.5,40,137.5,40,104A87.8,87.8,0,0,1,53.2,57.6L42.1,45.4A8,8,0,0,1,53.9,34.6L69.2,51.5h.1l28,30.8h0l75.4,83h0ZM91.1,42.2A72,72,0,0,1,200,104a8,8,0,0,0,16,0A88,88,0,0,0,82.9,28.4a8,8,0,0,0-2.8,11A8.1,8.1,0,0,0,91.1,42.2Zm67.2,83.2a7.7,7.7,0,0,0,4.8,1.6,8,8,0,0,0,6.4-3.2A31.6,31.6,0,0,0,176,104a48,48,0,0,0-48-48,48.6,48.6,0,0,0-15.6,2.6,8,8,0,0,0,5.2,15.1A32.9,32.9,0,0,1,128,72a32.1,32.1,0,0,1,32,32,16,16,0,0,1-3.3,10.2A7.9,7.9,0,0,0,158.3,125.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.4,87.8A39.5,39.5,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87,35.3A80,80,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.4,87.8A39.5,39.5,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87,35.3A80,80,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.4,87.8A39.5,39.5,0,0,0,88,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87,35.3A80,80,0,0,1,208,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ae = [];
/* style */

const __vue_inject_styles__$ae = undefined;
/* scoped */

const __vue_scope_id__$ae = undefined;
/* module identifier */

const __vue_module_identifier__$ae = undefined;
/* functional template */

const __vue_is_functional_template__$ae = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ae = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ae,
  staticRenderFns: __vue_staticRenderFns__$ae
}, __vue_inject_styles__$ae, __vue_script__$ae, __vue_scope_id__$ae, __vue_is_functional_template__$ae, __vue_module_identifier__$ae, false, undefined, undefined, undefined);

var script$ad = Vue.extend({
  name: "PhEgg",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ad = script$ad;
/* template */

var __vue_render__$ad = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,152a88,88,0,0,1-176,0c0-30.8,10.7-64.5,29.3-92.4S109.5,16,128,16s40.5,16.3,58.7,43.6S216,121.2,216,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ad = [];
/* style */

const __vue_inject_styles__$ad = undefined;
/* scoped */

const __vue_scope_id__$ad = undefined;
/* module identifier */

const __vue_module_identifier__$ad = undefined;
/* functional template */

const __vue_is_functional_template__$ad = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ad = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ad,
  staticRenderFns: __vue_staticRenderFns__$ad
}, __vue_inject_styles__$ad, __vue_script__$ad, __vue_scope_id__$ad, __vue_is_functional_template__$ad, __vue_module_identifier__$ad, false, undefined, undefined, undefined);

var script$ac = Vue.extend({
  name: "PhEggCrack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ac = script$ac;
/* template */

var __vue_render__$ac = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.7,59.6l-.7-1.1a4.1,4.1,0,0,0-6.3-.4L143.5,98.4l18,7a8.1,8.1,0,0,1,5,9l-7.2,37.1a8.1,8.1,0,0,1-7.9,6.5h-1.5a8.4,8.4,0,0,1-6.3-9.7l5.9-30.3-22.6-8.7a8.3,8.3,0,0,1-4.9-5.6,8.1,8.1,0,0,1,1.8-7.2l46.6-51.9a4,4,0,0,0-.1-5.5c-14.1-14.7-29-23-42.3-23-18.5,0-40.5,16.3-58.7,43.6s-28,57.6-29.2,86.8C38,197,77.6,240.1,128.2,240A88.1,88.1,0,0,0,216,152C216,121.2,205.3,87.5,186.7,59.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ac = [];
/* style */

const __vue_inject_styles__$ac = undefined;
/* scoped */

const __vue_scope_id__$ac = undefined;
/* module identifier */

const __vue_module_identifier__$ac = undefined;
/* functional template */

const __vue_is_functional_template__$ac = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ac = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ac,
  staticRenderFns: __vue_staticRenderFns__$ac
}, __vue_inject_styles__$ac, __vue_script__$ac, __vue_scope_id__$ac, __vue_is_functional_template__$ac, __vue_module_identifier__$ac, false, undefined, undefined, undefined);

var script$ab = Vue.extend({
  name: "PhEject",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$ab = script$ab;
/* template */

var __vue_render__$ab = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.1,38.4,45,118.5A8,8,0,0,0,50.8,132H205.2a8,8,0,0,0,5.8-13.5L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.6,134.4a15.8,15.8,0,0,1,2.9-17.3l77.7-84.2h0a16.2,16.2,0,0,1,23.6,0l77.7,84.2A16,16,0,0,1,205.7,144H50.3A15.9,15.9,0,0,1,35.6,134.4ZM208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "100",
      "width": "40",
      "height": "176",
      "rx": "8",
      "transform": "translate(-60 316) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$ab = [];
/* style */

const __vue_inject_styles__$ab = undefined;
/* scoped */

const __vue_scope_id__$ab = undefined;
/* module identifier */

const __vue_module_identifier__$ab = undefined;
/* functional template */

const __vue_is_functional_template__$ab = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$ab = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$ab,
  staticRenderFns: __vue_staticRenderFns__$ab
}, __vue_inject_styles__$ab, __vue_script__$ab, __vue_scope_id__$ab, __vue_is_functional_template__$ab, __vue_module_identifier__$ab, false, undefined, undefined, undefined);

var script$aa = Vue.extend({
  name: "PhEjectSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$aa = script$aa;
/* template */

var __vue_render__$aa = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M26.4,158.9a15.9,15.9,0,0,1,2-17L115.6,34.6a16,16,0,0,1,24.8,0l87.2,107.3A16,16,0,0,1,215.2,168H40.8A15.8,15.8,0,0,1,26.4,158.9ZM224,200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "208",
      "x2": "32",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$aa = [];
/* style */

const __vue_inject_styles__$aa = undefined;
/* scoped */

const __vue_scope_id__$aa = undefined;
/* module identifier */

const __vue_module_identifier__$aa = undefined;
/* functional template */

const __vue_is_functional_template__$aa = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$aa = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$aa,
  staticRenderFns: __vue_staticRenderFns__$aa
}, __vue_inject_styles__$aa, __vue_script__$aa, __vue_scope_id__$aa, __vue_is_functional_template__$aa, __vue_module_identifier__$aa, false, undefined, undefined, undefined);

var script$a9 = Vue.extend({
  name: "PhEnvelope",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a9 = script$a9;
/* template */

var __vue_render__$a9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a0,0,0,0,1,0,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "128",
      "x2": "34.5",
      "y2": "197.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "197.7",
      "x2": "145.5",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 56 128 144 32 56 224 56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "128",
      "x2": "34.5",
      "y2": "197.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "197.7",
      "x2": "145.5",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM98.7,128,40,181.8V74.2Zm11.8,10.9,12.1,11a8,8,0,0,0,10.8,0l12.1-11L203.4,192H52.6ZM157.3,128,216,74.2V181.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "128",
      "x2": "34.5",
      "y2": "197.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "197.7",
      "x2": "145.5",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "128",
      "x2": "34.5",
      "y2": "197.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "197.7",
      "x2": "145.5",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "128",
      "x2": "34.5",
      "y2": "197.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "197.7",
      "x2": "145.5",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a9 = [];
/* style */

const __vue_inject_styles__$a9 = undefined;
/* scoped */

const __vue_scope_id__$a9 = undefined;
/* module identifier */

const __vue_module_identifier__$a9 = undefined;
/* functional template */

const __vue_is_functional_template__$a9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a9,
  staticRenderFns: __vue_staticRenderFns__$a9
}, __vue_inject_styles__$a9, __vue_script__$a9, __vue_scope_id__$a9, __vue_is_functional_template__$a9, __vue_module_identifier__$a9, false, undefined, undefined, undefined);

var script$a8 = Vue.extend({
  name: "PhEnvelopeOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a8 = script$a8;
/* template */

var __vue_render__$a8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "152",
      "x2": "34.5",
      "y2": "205.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "205.7",
      "x2": "145.5",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96 128 32 224 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "152",
      "x2": "34.5",
      "y2": "205.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "205.7",
      "x2": "145.5",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.4,89.3l-96-64a8.2,8.2,0,0,0-8.8,0l-96,64A7.9,7.9,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A7.9,7.9,0,0,0,228.4,89.3ZM96.7,152,40,192V111.5Zm16.4,8h29.8l56.6,40H56.5Zm46.2-8L216,111.5V192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "152",
      "x2": "34.5",
      "y2": "205.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "205.7",
      "x2": "145.5",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "152",
      "x2": "34.5",
      "y2": "205.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "205.7",
      "x2": "145.5",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.5",
      "y1": "152",
      "x2": "34.5",
      "y2": "205.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "221.5",
      "y1": "205.7",
      "x2": "145.5",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a8 = [];
/* style */

const __vue_inject_styles__$a8 = undefined;
/* scoped */

const __vue_scope_id__$a8 = undefined;
/* module identifier */

const __vue_module_identifier__$a8 = undefined;
/* functional template */

const __vue_is_functional_template__$a8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a8,
  staticRenderFns: __vue_staticRenderFns__$a8
}, __vue_inject_styles__$a8, __vue_script__$a8, __vue_scope_id__$a8, __vue_is_functional_template__$a8, __vue_module_identifier__$a8, false, undefined, undefined, undefined);

var script$a7 = Vue.extend({
  name: "PhEnvelopeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a7 = script$a7;
/* template */

var __vue_render__$a7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 56 128 144 32 56 224 56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-8,144H40V74.2l82.6,75.7a8,8,0,0,0,10.8,0L216,74.2V192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 56 128 144 32 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a7 = [];
/* style */

const __vue_inject_styles__$a7 = undefined;
/* scoped */

const __vue_scope_id__$a7 = undefined;
/* module identifier */

const __vue_module_identifier__$a7 = undefined;
/* functional template */

const __vue_is_functional_template__$a7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a7,
  staticRenderFns: __vue_staticRenderFns__$a7
}, __vue_inject_styles__$a7, __vue_script__$a7, __vue_scope_id__$a7, __vue_is_functional_template__$a7, __vue_module_identifier__$a7, false, undefined, undefined, undefined);

var script$a6 = Vue.extend({
  name: "PhEnvelopeSimpleOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a6 = script$a6;
/* template */

var __vue_render__$a6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96 128 32 224 96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.4,89.3l-96-64a8.2,8.2,0,0,0-8.8,0l-96,64A7.9,7.9,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A7.9,7.9,0,0,0,228.4,89.3ZM40,200V111.5l65.9,47a7.9,7.9,0,0,0,4.6,1.5h35a7.9,7.9,0,0,0,4.6-1.5l65.9-47V200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 96 145.5 152 110.5 152 32 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a6 = [];
/* style */

const __vue_inject_styles__$a6 = undefined;
/* scoped */

const __vue_scope_id__$a6 = undefined;
/* module identifier */

const __vue_module_identifier__$a6 = undefined;
/* functional template */

const __vue_is_functional_template__$a6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a6,
  staticRenderFns: __vue_staticRenderFns__$a6
}, __vue_inject_styles__$a6, __vue_script__$a6, __vue_scope_id__$a6, __vue_is_functional_template__$a6, __vue_module_identifier__$a6, false, undefined, undefined, undefined);

var script$a5 = Vue.extend({
  name: "PhEqualizer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a5 = script$a5;
/* template */

var __vue_render__$a5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "108",
      "x2": "72",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "148",
      "x2": "72",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "192",
      "x2": "72",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "148",
      "x2": "146",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "192",
      "x2": "146",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "68",
      "x2": "220",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "108",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "148",
      "x2": "220",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "188",
      "x2": "220",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "96",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "160",
      "x2": "76",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "192",
      "x2": "76",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "160",
      "x2": "148",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "192",
      "x2": "148",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "220",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "64",
      "x2": "220",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "220",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "160",
      "x2": "220",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "192",
      "x2": "220",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,96a8,8,0,0,1-8,8H36a8,8,0,0,1,0-16H76A8,8,0,0,1,84,96Zm-8,24H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm0,32H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm0,32H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm72-64H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm72-96H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16ZM180,72h40a8,8,0,0,0,0-16H180a8,8,0,0,0,0,16Zm40,48H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "96",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "160",
      "x2": "76",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "192",
      "x2": "76",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "160",
      "x2": "148",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "192",
      "x2": "148",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "220",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "64",
      "x2": "220",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "220",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "160",
      "x2": "220",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "192",
      "x2": "220",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "96",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "160",
      "x2": "76",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "192",
      "x2": "76",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "160",
      "x2": "148",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "192",
      "x2": "148",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "220",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "64",
      "x2": "220",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "220",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "160",
      "x2": "220",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "192",
      "x2": "220",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "96",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "160",
      "x2": "76",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "192",
      "x2": "76",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "160",
      "x2": "148",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "192",
      "x2": "148",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "220",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "64",
      "x2": "220",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "220",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "160",
      "x2": "220",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "192",
      "x2": "220",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a5 = [];
/* style */

const __vue_inject_styles__$a5 = undefined;
/* scoped */

const __vue_scope_id__$a5 = undefined;
/* module identifier */

const __vue_module_identifier__$a5 = undefined;
/* functional template */

const __vue_is_functional_template__$a5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a5,
  staticRenderFns: __vue_staticRenderFns__$a5
}, __vue_inject_styles__$a5, __vue_script__$a5, __vue_scope_id__$a5, __vue_is_functional_template__$a5, __vue_module_identifier__$a5, false, undefined, undefined, undefined);

var script$a4 = Vue.extend({
  name: "PhEquals",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a4 = script$a4;
/* template */

var __vue_render__$a4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,152H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a4 = [];
/* style */

const __vue_inject_styles__$a4 = undefined;
/* scoped */

const __vue_scope_id__$a4 = undefined;
/* module identifier */

const __vue_module_identifier__$a4 = undefined;
/* functional template */

const __vue_is_functional_template__$a4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a4,
  staticRenderFns: __vue_staticRenderFns__$a4
}, __vue_inject_styles__$a4, __vue_script__$a4, __vue_scope_id__$a4, __vue_is_functional_template__$a4, __vue_module_identifier__$a4, false, undefined, undefined, undefined);

var script$a3 = Vue.extend({
  name: "PhEraser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a3 = script$a3;
/* template */

var __vue_render__$a3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.5",
      "y1": "99.5",
      "x2": "159.4",
      "y2": "167.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M111,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L91.5,99.5l67.9,67.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.5",
      "y1": "99.5",
      "x2": "159.4",
      "y2": "167.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,207.8H130.3l34.8-34.7h0l56.6-56.6a24.1,24.1,0,0,0,0-33.9L176.4,37.3a24,24,0,0,0-33.9,0L85.9,93.9h0L29.3,150.5a24,24,0,0,0,0,33.9l37.1,37.1a7.9,7.9,0,0,0,5.7,2.3H216a8,8,0,0,0,0-16ZM153.8,48.6a8.1,8.1,0,0,1,11.3,0l45.2,45.3a7.9,7.9,0,0,1,0,11.3l-50.9,50.9L102.9,99.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.5",
      "y1": "99.5",
      "x2": "159.4",
      "y2": "167.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.5",
      "y1": "99.5",
      "x2": "159.4",
      "y2": "167.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.5",
      "y1": "99.5",
      "x2": "159.4",
      "y2": "167.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a3 = [];
/* style */

const __vue_inject_styles__$a3 = undefined;
/* scoped */

const __vue_scope_id__$a3 = undefined;
/* module identifier */

const __vue_module_identifier__$a3 = undefined;
/* functional template */

const __vue_is_functional_template__$a3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a3,
  staticRenderFns: __vue_staticRenderFns__$a3
}, __vue_inject_styles__$a3, __vue_script__$a3, __vue_scope_id__$a3, __vue_is_functional_template__$a3, __vue_module_identifier__$a3, false, undefined, undefined, undefined);

var script$a2 = Vue.extend({
  name: "PhExam",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a2 = script$a2;
/* template */

var __vue_render__$a2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "68 160 100 96 132 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "144",
      "x2": "124",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "128",
      "x2": "188",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "112",
      "x2": "172",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 160 104 96 136 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "108",
      "x2": "172",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M100,113.9,111.1,136H88.9ZM232,56V216a7.9,7.9,0,0,1-3.8,6.8,8,8,0,0,1-7.8.4L192,208.9l-28.4,14.3a8.5,8.5,0,0,1-7.2,0L128,208.9,99.6,223.2a8.3,8.3,0,0,1-7.2,0L64,208.9,35.6,223.2a8,8,0,0,1-7.8-.4A7.9,7.9,0,0,1,24,216V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM139.2,156.4l-32-64a8.1,8.1,0,0,0-14.4,0l-32,64a8,8,0,0,0,14.4,7.2L80.9,152h38.2l5.7,11.6A8.1,8.1,0,0,0,132,168a9.4,9.4,0,0,0,3.6-.8A8.2,8.2,0,0,0,139.2,156.4ZM204,128a8,8,0,0,0-8-8H184V108a8,8,0,0,0-16,0v12H156a8,8,0,0,0,0,16h12v12a8,8,0,0,0,16,0V136h12A8,8,0,0,0,204,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 160 104 96 136 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "108",
      "x2": "172",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 160 104 96 136 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "108",
      "x2": "172",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 160 104 96 136 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "144",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "108",
      "x2": "172",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a2 = [];
/* style */

const __vue_inject_styles__$a2 = undefined;
/* scoped */

const __vue_scope_id__$a2 = undefined;
/* module identifier */

const __vue_module_identifier__$a2 = undefined;
/* functional template */

const __vue_is_functional_template__$a2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a2,
  staticRenderFns: __vue_staticRenderFns__$a2
}, __vue_inject_styles__$a2, __vue_script__$a2, __vue_scope_id__$a2, __vue_is_functional_template__$a2, __vue_module_identifier__$a2, false, undefined, undefined, undefined);

var script$a1 = Vue.extend({
  name: "PhExport",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a1 = script$a1;
/* template */

var __vue_render__$a1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 58 128 16 170 58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,100h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V108a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "96",
      "width": "160",
      "height": "120",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "86 58 128 16 170 58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,88H120V35.3L91.7,63.6A8,8,0,0,1,80.3,52.3l42-42a8.1,8.1,0,0,1,11.4,0l42,42a8,8,0,0,1,0,11.3,8,8,0,0,1-11.4,0L136,35.3Zm64,0H136v40a8,8,0,0,1-16,0V88H56a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V104A16,16,0,0,0,200,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 58 128 16 170 58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 58 128 16 170 58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 58 128 16 170 58",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a1 = [];
/* style */

const __vue_inject_styles__$a1 = undefined;
/* scoped */

const __vue_scope_id__$a1 = undefined;
/* module identifier */

const __vue_module_identifier__$a1 = undefined;
/* functional template */

const __vue_is_functional_template__$a1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a1,
  staticRenderFns: __vue_staticRenderFns__$a1
}, __vue_inject_styles__$a1, __vue_script__$a1, __vue_scope_id__$a1, __vue_is_functional_template__$a1, __vue_module_identifier__$a1, false, undefined, undefined, undefined);

var script$a0 = Vue.extend({
  name: "PhEye",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a0 = script$a0;
/* template */

var __vue_render__$a0 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.3,124.8c-.3-.8-8.8-19.6-27.6-38.5C194.6,61.3,162.9,48,128,48S61.4,61.3,36.3,86.3C17.5,105.2,9,124,8.7,124.8a7.9,7.9,0,0,0,0,6.4c.3.8,8.8,19.6,27.6,38.5C61.4,194.7,93.1,208,128,208s66.6-13.3,91.7-38.3c18.8-18.9,27.3-37.7,27.6-38.5A7.9,7.9,0,0,0,247.3,124.8ZM128,92a36,36,0,1,1-36,36A36,36,0,0,1,128,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a0 = [];
/* style */

const __vue_inject_styles__$a0 = undefined;
/* scoped */

const __vue_scope_id__$a0 = undefined;
/* module identifier */

const __vue_module_identifier__$a0 = undefined;
/* functional template */

const __vue_is_functional_template__$a0 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a0 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a0,
  staticRenderFns: __vue_staticRenderFns__$a0
}, __vue_inject_styles__$a0, __vue_script__$a0, __vue_scope_id__$a0, __vue_is_functional_template__$a0, __vue_module_identifier__$a0, false, undefined, undefined, undefined);

var script$9$ = Vue.extend({
  name: "PhEyeClosed",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9$ = script$9$;
/* template */

var __vue_render__$9$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.1",
      "y1": "127.3",
      "x2": "224",
      "y2": "166.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.2",
      "y1": "149.3",
      "x2": "161.3",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.7",
      "y1": "149.2",
      "x2": "94.6",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.8",
      "y1": "127.3",
      "x2": "31.9",
      "y2": "167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.1",
      "y1": "127.3",
      "x2": "224",
      "y2": "166.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.2",
      "y1": "149.3",
      "x2": "161.3",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.7",
      "y1": "149.2",
      "x2": "94.6",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.8",
      "y1": "127.3",
      "x2": "31.9",
      "y2": "167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.5,129.2a145.8,145.8,0,0,0,18.7-19.3A7.9,7.9,0,0,0,229,98.7a7.9,7.9,0,0,0-11.2,1.1,128.7,128.7,0,0,1-21.3,21h-.2c-16.5,12.8-39,23.1-68.3,23.1a109.7,109.7,0,0,1-68.4-23.1h-.1a128.7,128.7,0,0,1-21.3-21A7.9,7.9,0,0,0,27,98.7a7.9,7.9,0,0,0-1.2,11.2,145.8,145.8,0,0,0,18.7,19.3L25,163a8,8,0,0,0,6.9,12,8.2,8.2,0,0,0,6.9-4l18.5-32.1a122.1,122.1,0,0,0,35.3,16.3l-5.9,33a8.1,8.1,0,0,0,6.5,9.3h1.4a8,8,0,0,0,7.9-6.6l5.7-32.4A139.8,139.8,0,0,0,128,160a137.3,137.3,0,0,0,19.7-1.4l5.7,32.4a8,8,0,0,0,7.9,6.6h1.4a8.1,8.1,0,0,0,6.5-9.3l-5.8-32.9A122.9,122.9,0,0,0,198.6,139L217,170.8a8,8,0,0,0,7,4,7.6,7.6,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.1",
      "y1": "127.3",
      "x2": "224",
      "y2": "166.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.2",
      "y1": "149.3",
      "x2": "161.3",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.7",
      "y1": "149.2",
      "x2": "94.6",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.8",
      "y1": "127.3",
      "x2": "31.9",
      "y2": "167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.1",
      "y1": "127.3",
      "x2": "224",
      "y2": "166.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.2",
      "y1": "149.3",
      "x2": "161.3",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.7",
      "y1": "149.2",
      "x2": "94.6",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.8",
      "y1": "127.3",
      "x2": "31.9",
      "y2": "167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "201.1",
      "y1": "127.3",
      "x2": "224",
      "y2": "166.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.2",
      "y1": "149.3",
      "x2": "161.3",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.7",
      "y1": "149.2",
      "x2": "94.6",
      "y2": "189.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.8",
      "y1": "127.3",
      "x2": "31.9",
      "y2": "167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9$ = [];
/* style */

const __vue_inject_styles__$9$ = undefined;
/* scoped */

const __vue_scope_id__$9$ = undefined;
/* module identifier */

const __vue_module_identifier__$9$ = undefined;
/* functional template */

const __vue_is_functional_template__$9$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9$,
  staticRenderFns: __vue_staticRenderFns__$9$
}, __vue_inject_styles__$9$, __vue_script__$9$, __vue_scope_id__$9$, __vue_is_functional_template__$9$, __vue_module_identifier__$9$, false, undefined, undefined, undefined);

var script$9_ = Vue.extend({
  name: "PhEyeSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9_ = script$9_;
/* template */

var __vue_render__$9_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.4,163.6C232.1,145.7,240,128,240,128S208,56,128,56c-3.8,0-7.4.2-11,.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.3,124.8c-.3-.8-8.8-19.6-27.6-38.5C194.6,61.3,162.9,48,128,48a132.4,132.4,0,0,0-22,1.8,8.1,8.1,0,0,0-4.6,13.3L202.7,174.5a8,8,0,0,0,5.9,2.6,8.6,8.6,0,0,0,5.4-2c22.8-20.5,32.9-42.9,33.3-43.8A8.2,8.2,0,0,0,247.3,124.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L61.3,66.5C25,88.8,9.4,123.2,8.7,124.8a8.2,8.2,0,0,0,0,6.5c.3.7,8.8,19.5,27.6,38.4C61.4,194.7,93.1,208,128,208a126.9,126.9,0,0,0,52.1-10.8l22,24.2A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM128,164a36,36,0,0,1-29.5-56.6l47.2,51.9A35.4,35.4,0,0,1,128,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9_ = [];
/* style */

const __vue_inject_styles__$9_ = undefined;
/* scoped */

const __vue_scope_id__$9_ = undefined;
/* module identifier */

const __vue_module_identifier__$9_ = undefined;
/* functional template */

const __vue_is_functional_template__$9_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9_,
  staticRenderFns: __vue_staticRenderFns__$9_
}, __vue_inject_styles__$9_, __vue_script__$9_, __vue_scope_id__$9_, __vue_is_functional_template__$9_, __vue_module_identifier__$9_, false, undefined, undefined, undefined);

var script$9Z = Vue.extend({
  name: "PhEyedropper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Z = script$9Z;
/* template */

var __vue_render__$9Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.8,107.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-15,15a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l15-15a16.1,16.1,0,0,1,22.6,0l4.9,4.9,19.6-19.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,67.5a35.5,35.5,0,0,0-11.3-25.7c-14-13.2-36.7-12.7-50.6,1.2L140.2,64.9a24.1,24.1,0,0,0-33.2.8l-7,7a16.1,16.1,0,0,0,0,22.6l2.1,2.1L51.7,147.7a40.3,40.3,0,0,0-11,35.8l-9.8,22.4a13.6,13.6,0,0,0,2.9,15.2,15.8,15.8,0,0,0,11.3,4.7,16.3,16.3,0,0,0,6.4-1.3l21-9.2a40.3,40.3,0,0,0,35.8-11l50.3-50.4,2.1,2.1a15.9,15.9,0,0,0,22.6,0l7-7a24.1,24.1,0,0,0,.8-33.2l22.4-22.3A36.2,36.2,0,0,0,224,67.5ZM97,193a24.3,24.3,0,0,1-23.2,6.2,8,8,0,0,0-5.3.4L47,209l9.4-21.5a8,8,0,0,0,.4-5.3A24.3,24.3,0,0,1,63,159l50.4-50.3,33.9,33.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Z = [];
/* style */

const __vue_inject_styles__$9Z = undefined;
/* scoped */

const __vue_scope_id__$9Z = undefined;
/* module identifier */

const __vue_module_identifier__$9Z = undefined;
/* functional template */

const __vue_is_functional_template__$9Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Z,
  staticRenderFns: __vue_staticRenderFns__$9Z
}, __vue_inject_styles__$9Z, __vue_script__$9Z, __vue_scope_id__$9Z, __vue_is_functional_template__$9Z, __vue_module_identifier__$9Z, false, undefined, undefined, undefined);

var script$9Y = Vue.extend({
  name: "PhEyedropperSample",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Y = script$9Y;
/* template */

var __vue_render__$9Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.3",
      "y1": "160",
      "x2": "141.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M141.3,160l-38.7,38.6a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8A31.9,31.9,0,0,1,52.3,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.3",
      "y1": "160",
      "x2": "141.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,67.5a35.5,35.5,0,0,0-11.3-25.7c-14-13.2-36.7-12.7-50.6,1.2L140.2,64.9a24.1,24.1,0,0,0-33.2.8l-7,7a16.1,16.1,0,0,0,0,22.6l2.1,2.1L51.7,147.7a40.3,40.3,0,0,0-11,35.8l-9.8,22.4a13.6,13.6,0,0,0,2.9,15.2,15.8,15.8,0,0,0,11.3,4.7,16.3,16.3,0,0,0,6.4-1.3l21-9.2a40.3,40.3,0,0,0,35.8-11l50.3-50.4,2.1,2.1a15.9,15.9,0,0,0,22.6,0l7-7a24.1,24.1,0,0,0,.8-33.2l22.4-22.3A36.2,36.2,0,0,0,224,67.5ZM137.9,152H70.1l43.3-43.3,33.9,33.9Zm64.2-69.9-28,28a8.1,8.1,0,0,0,0,11.4l4.9,4.8a8.1,8.1,0,0,1,0,11.4l-7,7L111.3,84l7-7a8,8,0,0,1,11.4,0l4.8,4.9a8.1,8.1,0,0,0,11.4,0l27.5-27.6c7.9-7.8,20.6-8.2,28.3-.8A19.7,19.7,0,0,1,208,67.7,19.4,19.4,0,0,1,202.1,82.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.3",
      "y1": "160",
      "x2": "141.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.3",
      "y1": "160",
      "x2": "141.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52.3",
      "y1": "160",
      "x2": "141.3",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Y = [];
/* style */

const __vue_inject_styles__$9Y = undefined;
/* scoped */

const __vue_scope_id__$9Y = undefined;
/* module identifier */

const __vue_module_identifier__$9Y = undefined;
/* functional template */

const __vue_is_functional_template__$9Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Y,
  staticRenderFns: __vue_staticRenderFns__$9Y
}, __vue_inject_styles__$9Y, __vue_script__$9Y, __vue_scope_id__$9Y, __vue_is_functional_template__$9Y, __vue_module_identifier__$9Y, false, undefined, undefined, undefined);

var script$9X = Vue.extend({
  name: "PhEyeglasses",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9X = script$9X;
/* template */

var __vue_render__$9X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "160",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,164V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "160",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,164V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,72v92a44,44,0,0,1-87.8,4H111.8A44,44,0,0,1,24,164V72A32.1,32.1,0,0,1,56,40a8,8,0,0,1,0,16A16,16,0,0,0,40,72v58.1A43.9,43.9,0,0,1,110.3,152h35.4A43.9,43.9,0,0,1,216,130.1V72a16,16,0,0,0-16-16,8,8,0,0,1,0-16A32.1,32.1,0,0,1,232,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "160",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,164V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "160",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,164V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "160",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,164V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9X = [];
/* style */

const __vue_inject_styles__$9X = undefined;
/* scoped */

const __vue_scope_id__$9X = undefined;
/* module identifier */

const __vue_module_identifier__$9X = undefined;
/* functional template */

const __vue_is_functional_template__$9X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9X,
  staticRenderFns: __vue_staticRenderFns__$9X
}, __vue_inject_styles__$9X, __vue_script__$9X, __vue_scope_id__$9X, __vue_is_functional_template__$9X, __vue_module_identifier__$9X, false, undefined, undefined, undefined);

var script$9W = Vue.extend({
  name: "PhFaceMask",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9W = script$9W;
/* template */

var __vue_render__$9W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,136c0,51-66.2,68.8-78.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,204.8,48,187,48,136V77.4A7.9,7.9,0,0,1,53,70l72-28.8a7.8,7.8,0,0,1,6,0L203,70a7.9,7.9,0,0,1,5,7.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.4,152H220a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24H208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.6,152H36a23.9,23.9,0,0,1-24-24V104A23.9,23.9,0,0,1,36,80H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,72h-1a16,16,0,0,0-9.5-9.4l-80-29.1a16,16,0,0,0-11,0l-80,29.1A16,16,0,0,0,33,72H32A32.1,32.1,0,0,0,0,104v24a32.1,32.1,0,0,0,32,32h5.2c6.6,14.4,19.3,27,37.6,37.2,21.1,11.7,43.6,17,49.9,18.3l3.3.3,3.3-.3c6.3-1.3,28.8-6.6,49.9-18.3,18.3-10.2,31-22.8,37.6-37.2H224a32.1,32.1,0,0,0,32-32V104A32.1,32.1,0,0,0,224,72ZM32,144a16,16,0,0,1-16-16V104A16,16,0,0,1,32,88v48a52.9,52.9,0,0,0,.6,8Zm136,8H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm72,8a16,16,0,0,1-16,16h-.6a52.9,52.9,0,0,0,.6-8V88a16,16,0,0,1,16,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "168",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9W = [];
/* style */

const __vue_inject_styles__$9W = undefined;
/* scoped */

const __vue_scope_id__$9W = undefined;
/* module identifier */

const __vue_module_identifier__$9W = undefined;
/* functional template */

const __vue_is_functional_template__$9W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9W,
  staticRenderFns: __vue_staticRenderFns__$9W
}, __vue_inject_styles__$9W, __vue_script__$9W, __vue_scope_id__$9W, __vue_is_functional_template__$9W, __vue_module_identifier__$9W, false, undefined, undefined, undefined);

var script$9V = Vue.extend({
  name: "PhFacebookLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9V = script$9V;
/* template */

var __vue_render__$9V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88H152a23.9,23.9,0,0,0-24,24V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88H152a23.9,23.9,0,0,0-24,24V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128a104.3,104.3,0,0,1-91.5,103.3,4.1,4.1,0,0,1-4.5-4V152h24a8,8,0,0,0,8-8.5,8.2,8.2,0,0,0-8.3-7.5H136V112a16,16,0,0,1,16-16h16a8,8,0,0,0,8-8.5,8.2,8.2,0,0,0-8.3-7.5H152a32,32,0,0,0-32,32v24H96a8,8,0,0,0-8,8.5,8.2,8.2,0,0,0,8.3,7.5H120v75.3a4,4,0,0,1-4.4,4C62.8,224.9,22,179,24.1,124.1A104,104,0,0,1,232,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88H152a23.9,23.9,0,0,0-24,24V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88H152a23.9,23.9,0,0,0-24,24V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88H152a23.9,23.9,0,0,0-24,24V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9V = [];
/* style */

const __vue_inject_styles__$9V = undefined;
/* scoped */

const __vue_scope_id__$9V = undefined;
/* module identifier */

const __vue_module_identifier__$9V = undefined;
/* functional template */

const __vue_is_functional_template__$9V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9V,
  staticRenderFns: __vue_staticRenderFns__$9V
}, __vue_inject_styles__$9V, __vue_script__$9V, __vue_scope_id__$9V, __vue_is_functional_template__$9V, __vue_module_identifier__$9V, false, undefined, undefined, undefined);

var script$9U = Vue.extend({
  name: "PhFactory",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9U = script$9U;
/* template */

var __vue_render__$9U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216 216 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,208H224V136h0v-.5a.8.8,0,0,0-.1-.4h0l-15-105.2A16,16,0,0,0,193.1,16H174.9a16,16,0,0,0-15.8,13.7l-11.6,81L108.8,81.6A8,8,0,0,0,96,88v32L44.8,81.6A8,8,0,0,0,32,88V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM100,184H72a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm84,0H156a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm-13.3-56-8.6-6.4L174.9,32h18.2l13.7,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "108",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "176",
      "x2": "176",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9U = [];
/* style */

const __vue_inject_styles__$9U = undefined;
/* scoped */

const __vue_scope_id__$9U = undefined;
/* module identifier */

const __vue_module_identifier__$9U = undefined;
/* functional template */

const __vue_is_functional_template__$9U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9U,
  staticRenderFns: __vue_staticRenderFns__$9U
}, __vue_inject_styles__$9U, __vue_script__$9U, __vue_scope_id__$9U, __vue_is_functional_template__$9U, __vue_module_identifier__$9U, false, undefined, undefined, undefined);

var script$9T = Vue.extend({
  name: "PhFaders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9T = script$9T;
/* template */

var __vue_render__$9T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "204",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "164",
      "x2": "176",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "172",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "132",
      "x2": "80",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "84",
      "x2": "104",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "168",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "80",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "88",
      "x2": "104",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,112a8,8,0,0,0-8,8v96a8,8,0,0,0,16,0V120A8,8,0,0,0,128,112Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,192a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V200A8,8,0,0,0,200,192Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,160H208V40a8,8,0,0,0-16,0V160H176a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,160a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V168A8,8,0,0,0,56,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128H64V40a8,8,0,0,0-16,0v88H32a8,8,0,0,0,0,16H80a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,80H136V40a8,8,0,0,0-16,0V80H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "168",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "80",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "88",
      "x2": "104",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "168",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "80",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "88",
      "x2": "104",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "168",
      "x2": "176",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "168",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "136",
      "x2": "80",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "88",
      "x2": "104",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9T = [];
/* style */

const __vue_inject_styles__$9T = undefined;
/* scoped */

const __vue_scope_id__$9T = undefined;
/* module identifier */

const __vue_module_identifier__$9T = undefined;
/* functional template */

const __vue_is_functional_template__$9T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9T,
  staticRenderFns: __vue_staticRenderFns__$9T
}, __vue_inject_styles__$9T, __vue_script__$9T, __vue_scope_id__$9T, __vue_is_functional_template__$9T, __vue_module_identifier__$9T, false, undefined, undefined, undefined);

var script$9S = Vue.extend({
  name: "PhFadersHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9S = script$9S;
/* template */

var __vue_render__$9S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "132",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "172",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "108",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "60",
      "x2": "108",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "196",
      "x2": "172",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "168",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "104",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "60",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "196",
      "x2": "168",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,164H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,164H176V148a8,8,0,0,0-16,0v48a8,8,0,0,0,16,0V180h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,92H72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,116a8,8,0,0,0,8-8V92H216a8,8,0,0,0,0-16H112V60a8,8,0,0,0-16,0v48A8,8,0,0,0,104,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "168",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "104",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "60",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "196",
      "x2": "168",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "168",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "104",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "60",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "196",
      "x2": "168",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "168",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "104",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "60",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "196",
      "x2": "168",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9S = [];
/* style */

const __vue_inject_styles__$9S = undefined;
/* scoped */

const __vue_scope_id__$9S = undefined;
/* module identifier */

const __vue_module_identifier__$9S = undefined;
/* functional template */

const __vue_is_functional_template__$9S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9S,
  staticRenderFns: __vue_staticRenderFns__$9S
}, __vue_inject_styles__$9S, __vue_script__$9S, __vue_scope_id__$9S, __vue_is_functional_template__$9S, __vue_module_identifier__$9S, false, undefined, undefined, undefined);

var script$9R = Vue.extend({
  name: "PhFastForward",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9R = script$9R;
/* template */

var __vue_render__$9R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.5,121.3,148.3,63.9A8,8,0,0,0,136,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,237.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M253.2,128a16,16,0,0,1-7.3,13.5l-89.2,57.3A16,16,0,0,1,132,185.3V142.7L44.7,198.8A16,16,0,0,1,20,185.3V70.7A16,16,0,0,1,44.7,57.2L132,113.3V70.7a16,16,0,0,1,24.7-13.5l89.2,57.3A16,16,0,0,1,253.2,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9R = [];
/* style */

const __vue_inject_styles__$9R = undefined;
/* scoped */

const __vue_scope_id__$9R = undefined;
/* module identifier */

const __vue_module_identifier__$9R = undefined;
/* functional template */

const __vue_is_functional_template__$9R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9R,
  staticRenderFns: __vue_staticRenderFns__$9R
}, __vue_inject_styles__$9R, __vue_script__$9R, __vue_scope_id__$9R, __vue_is_functional_template__$9R, __vue_module_identifier__$9R, false, undefined, undefined, undefined);

var script$9Q = Vue.extend({
  name: "PhFastForwardCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9Q = script$9Q;
/* template */

var __vue_render__$9Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "88 156 124 128 88 100 88 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 156 180 128 144 100 144 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM80,160V96l48,32Zm64,0V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "80 160 128 128 80 96 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 160 192 128 144 96 144 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56.6,110.6-40,28A8.6,8.6,0,0,1,140,164a8,8,0,0,1-8-8V128a8.2,8.2,0,0,1-3.4,6.6l-40,28A8.6,8.6,0,0,1,84,164a8,8,0,0,1-8-8V100a8.1,8.1,0,0,1,4.3-7.1,8,8,0,0,1,8.3.5l40,28A8.2,8.2,0,0,1,132,128V100a8.1,8.1,0,0,1,4.3-7.1,8,8,0,0,1,8.3.5l40,28a8.1,8.1,0,0,1,0,13.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "84 160 132 128 84 96 84 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "140 160 188 128 140 96 140 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "84 160 132 128 84 96 84 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "140 160 188 128 140 96 140 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "80 160 128 128 80 96 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "144 160 192 128 144 96 144 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9Q = [];
/* style */

const __vue_inject_styles__$9Q = undefined;
/* scoped */

const __vue_scope_id__$9Q = undefined;
/* module identifier */

const __vue_module_identifier__$9Q = undefined;
/* functional template */

const __vue_is_functional_template__$9Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9Q,
  staticRenderFns: __vue_staticRenderFns__$9Q
}, __vue_inject_styles__$9Q, __vue_script__$9Q, __vue_scope_id__$9Q, __vue_is_functional_template__$9Q, __vue_module_identifier__$9Q, false, undefined, undefined, undefined);

var script$9P = Vue.extend({
  name: "PhFigmaLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9P = script$9P;
/* template */

var __vue_render__$9P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.6,94A42,42,0,0,0,162,18H94A42,42,0,0,0,69.4,94a41.9,41.9,0,0,0,0,68A42,42,0,1,0,136,196V160.9A42,42,0,1,0,186.6,94ZM188,60a26.1,26.1,0,0,1-26,26H136V34h26A26.1,26.1,0,0,1,188,60Zm-26,94a26,26,0,0,1,0-52h0a26,26,0,0,1,0,52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "162",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162V94H94a34,34,0,0,0,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,94V26h34a34,34,0,0,1,0,68Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,162v34a34,34,0,1,1-34-34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9P = [];
/* style */

const __vue_inject_styles__$9P = undefined;
/* scoped */

const __vue_scope_id__$9P = undefined;
/* module identifier */

const __vue_module_identifier__$9P = undefined;
/* functional template */

const __vue_is_functional_template__$9P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9P,
  staticRenderFns: __vue_staticRenderFns__$9P
}, __vue_inject_styles__$9P, __vue_script__$9P, __vue_scope_id__$9P, __vue_is_functional_template__$9P, __vue_module_identifier__$9P, false, undefined, undefined, undefined);

var script$9O = Vue.extend({
  name: "PhFile",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9O = script$9O;
/* template */

var __vue_render__$9O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9O = [];
/* style */

const __vue_inject_styles__$9O = undefined;
/* scoped */

const __vue_scope_id__$9O = undefined;
/* module identifier */

const __vue_module_identifier__$9O = undefined;
/* functional template */

const __vue_is_functional_template__$9O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9O,
  staticRenderFns: __vue_staticRenderFns__$9O
}, __vue_inject_styles__$9O, __vue_script__$9O, __vue_scope_id__$9O, __vue_is_functional_template__$9O, __vue_module_identifier__$9O, false, undefined, undefined, undefined);

var script$9N = Vue.extend({
  name: "PhFileArrowDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9N = script$9N;
/* template */

var __vue_render__$9N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-52,79.4-28,28a8.2,8.2,0,0,1-11.4,0l-28-28a8.1,8.1,0,0,1,11.4-11.4L120,164.7V120a8,8,0,0,1,16,0v44.7l14.3-14.4a8.1,8.1,0,0,1,11.4,11.4ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 156 128 184 156 156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9N = [];
/* style */

const __vue_inject_styles__$9N = undefined;
/* scoped */

const __vue_scope_id__$9N = undefined;
/* module identifier */

const __vue_module_identifier__$9N = undefined;
/* functional template */

const __vue_is_functional_template__$9N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9N,
  staticRenderFns: __vue_staticRenderFns__$9N
}, __vue_inject_styles__$9N, __vue_script__$9N, __vue_scope_id__$9N, __vue_is_functional_template__$9N, __vue_module_identifier__$9N, false, undefined, undefined, undefined);

var script$9M = Vue.extend({
  name: "PhFileArrowUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9M = script$9M;
/* template */

var __vue_render__$9M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 152 128 124 156 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.6,82.3l-55.9-56-.3-.2-.3-.3-.3-.2-.3-.2c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A7.8,7.8,0,0,0,213.6,82.3Zm-51.9,71.4a8.1,8.1,0,0,1-11.4,0L136,139.3V184a8,8,0,0,1-16,0V139.3l-14.3,14.4a8.1,8.1,0,0,1-11.4-11.4l28-28h.1l.5-.5.3-.2.4-.3.3-.2.3-.2h.4l.3-.2h.4l.4-.2h4.6l.4.2h.4l.3.2h.4l.3.2.3.2.4.3.3.2.5.5h.1l28,28A8.1,8.1,0,0,1,161.7,153.7ZM152,88V43.3L196.7,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "100 148 128 120 156 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9M = [];
/* style */

const __vue_inject_styles__$9M = undefined;
/* scoped */

const __vue_scope_id__$9M = undefined;
/* module identifier */

const __vue_module_identifier__$9M = undefined;
/* functional template */

const __vue_is_functional_template__$9M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9M,
  staticRenderFns: __vue_staticRenderFns__$9M
}, __vue_inject_styles__$9M, __vue_script__$9M, __vue_scope_id__$9M, __vue_is_functional_template__$9M, __vue_module_identifier__$9M, false, undefined, undefined, undefined);

var script$9L = Vue.extend({
  name: "PhFileAudio",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9L = script$9L;
/* template */

var __vue_render__$9L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,224h20a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 164 72 164 96 144 96 224 72 204 48 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,163a32,32,0,0,1,0,50",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,163a32,32,0,0,1,0,50",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H168a8,8,0,0,0,0,16h32a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,80V51.3L188.7,80Zm-56,72v72a7.9,7.9,0,0,1-4.6,7.2,6.8,6.8,0,0,1-3.4.8,7.5,7.5,0,0,1-5.1-1.9L69.1,212H48a8,8,0,0,1-8-8V172a8,8,0,0,1,8-8H69.1l21.8-18.1a7.8,7.8,0,0,1,8.5-1.1A7.9,7.9,0,0,1,104,152Zm44,36a39.8,39.8,0,0,1-15,31.2,7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3,8.1,8.1,0,0,1,1.2-11.3,23.9,23.9,0,0,0,0-37.4,8,8,0,0,1,10-12.5A39.8,39.8,0,0,1,148,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,163a32,32,0,0,1,0,50",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,163a32,32,0,0,1,0,50",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,163a32,32,0,0,1,0,50",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9L = [];
/* style */

const __vue_inject_styles__$9L = undefined;
/* scoped */

const __vue_scope_id__$9L = undefined;
/* module identifier */

const __vue_module_identifier__$9L = undefined;
/* functional template */

const __vue_is_functional_template__$9L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9L,
  staticRenderFns: __vue_staticRenderFns__$9L
}, __vue_inject_styles__$9L, __vue_script__$9L, __vue_scope_id__$9L, __vue_is_functional_template__$9L, __vue_module_identifier__$9L, false, undefined, undefined, undefined);

var script$9K = Vue.extend({
  name: "PhFileCloud",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9K = script$9K;
/* template */

var __vue_render__$9K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,224h20a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H176a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,51.3,188.7,80H160ZM160,180a52,52,0,0,1-52,52H60a36,36,0,0,1-9.2-70.8A65.3,65.3,0,0,0,48,180a8,8,0,0,0,16,0,47.4,47.4,0,0,1,4.4-20h0A48,48,0,0,1,160,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9K = [];
/* style */

const __vue_inject_styles__$9K = undefined;
/* scoped */

const __vue_scope_id__$9K = undefined;
/* module identifier */

const __vue_module_identifier__$9K = undefined;
/* functional template */

const __vue_is_functional_template__$9K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9K,
  staticRenderFns: __vue_staticRenderFns__$9K
}, __vue_inject_styles__$9K, __vue_script__$9K, __vue_scope_id__$9K, __vue_is_functional_template__$9K, __vue_module_identifier__$9K, false, undefined, undefined, undefined);

var script$9J = Vue.extend({
  name: "PhFileCode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9J = script$9J;
/* template */

var __vue_render__$9J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 132 172 156 148 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 132 84 156 108 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 128 172 152 148 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 128 84 152 108 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-104,88a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.1,8.1,0,0,1,11.4,11.4L91.3,152Zm72-12.6-24,24a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L164.7,152l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4l24,24A8.1,8.1,0,0,1,181.7,157.7ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 128 172 152 148 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 128 84 152 108 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 128 172 152 148 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 128 84 152 108 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 128 172 152 148 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 128 84 152 108 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9J = [];
/* style */

const __vue_inject_styles__$9J = undefined;
/* scoped */

const __vue_scope_id__$9J = undefined;
/* module identifier */

const __vue_module_identifier__$9J = undefined;
/* functional template */

const __vue_is_functional_template__$9J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9J,
  staticRenderFns: __vue_staticRenderFns__$9J
}, __vue_inject_styles__$9J, __vue_script__$9J, __vue_scope_id__$9J, __vue_is_functional_template__$9J, __vue_module_identifier__$9J, false, undefined, undefined, undefined);

var script$9I = Vue.extend({
  name: "PhFileCss",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9I = script$9I;
/* template */

var __vue_render__$9I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,215.6A24.2,24.2,0,0,1,70,220c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.7,183.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8Zm7.2-5.7h0Zm-19.8,27.8h0ZM52,192c0,8.8,6.3,16,14,16a12.9,12.9,0,0,0,8.6-3.4,7.9,7.9,0,0,1,11.3.6,8,8,0,0,1-.5,11.3A29.3,29.3,0,0,1,66,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a29.3,29.3,0,0,1,19.4,7.5,8,8,0,0,1,.5,11.3,7.9,7.9,0,0,1-11.3.6A12.9,12.9,0,0,0,66,176C58.3,176,52,183.2,52,192Zm141.7-8.2c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,206,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,191,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,176,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,191,225c15.7,0,25-7.9,25-21S202,186,193.7,183.8Zm7.2-5.7h0Zm-19.8,27.8h0Zm20.5-27.2Zm-64,0Zm76.1-96.4-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9I = [];
/* style */

const __vue_inject_styles__$9I = undefined;
/* scoped */

const __vue_scope_id__$9I = undefined;
/* module identifier */

const __vue_module_identifier__$9I = undefined;
/* functional template */

const __vue_is_functional_template__$9I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9I,
  staticRenderFns: __vue_staticRenderFns__$9I
}, __vue_inject_styles__$9I, __vue_script__$9I, __vue_scope_id__$9I, __vue_is_functional_template__$9I, __vue_module_identifier__$9I, false, undefined, undefined, undefined);

var script$9H = Vue.extend({
  name: "PhFileCsv",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9H = script$9H;
/* template */

var __vue_render__$9H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 164 198 220 220 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,215.6A24.2,24.2,0,0,1,62,220c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 168 192 216 212 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.4,171.1l-20,48a8,8,0,0,1-14.8,0l-20-48a8,8,0,1,1,14.8-6.2L192,195.2l12.6-30.3a8,8,0,1,1,14.8,6.2ZM66,176a12.9,12.9,0,0,1,8.6,3.4,7.9,7.9,0,0,0,11.3-.6,8,8,0,0,0-.5-11.3A29.3,29.3,0,0,0,66,160c-16.5,0-30,14.4-30,32s13.5,32,30,32a29.3,29.3,0,0,0,19.4-7.5,8,8,0,0,0,.5-11.3,7.9,7.9,0,0,0-11.3-.6A12.9,12.9,0,0,1,66,208c-7.7,0-14-7.2-14-16S58.3,176,66,176Zm63.7,7.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8ZM40,128V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88v40a8,8,0,0,1-8,8H48A8,8,0,0,1,40,128ZM152,88h44L152,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 168 192 216 212 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 168 192 216 212 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "172 168 192 216 212 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9H = [];
/* style */

const __vue_inject_styles__$9H = undefined;
/* scoped */

const __vue_scope_id__$9H = undefined;
/* module identifier */

const __vue_module_identifier__$9H = undefined;
/* functional template */

const __vue_is_functional_template__$9H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9H,
  staticRenderFns: __vue_staticRenderFns__$9H
}, __vue_inject_styles__$9H, __vue_script__$9H, __vue_scope_id__$9H, __vue_is_functional_template__$9H, __vue_module_identifier__$9H, false, undefined, undefined, undefined);

var script$9G = Vue.extend({
  name: "PhFileDoc",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9G = script$9G;
/* template */

var __vue_render__$9G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28,220V164H44a28,28,0,0,1,0,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,215.6a24.2,24.2,0,0,1-14,4.4c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "130",
      "cy": "192",
      "rx": "26",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M58,216a24,24,0,0,0,0-48H44v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "130",
      "cy": "192",
      "rx": "22",
      "ry": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M58,160H44a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8H58a32,32,0,0,0,0-64Zm0,48H52V176h6a16,16,0,0,1,0,32Zm72-48c-16.5,0-30,14.4-30,32s13.5,32,30,32,30-14.4,30-32S146.5,160,130,160Zm0,48c-7.7,0-14-7.2-14-16s6.3-16,14-16,14,7.2,14,16S137.7,208,130,208Zm87.9-2.8a8,8,0,0,1-.5,11.3A29.3,29.3,0,0,1,198,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a29.3,29.3,0,0,1,19.4,7.5,8,8,0,0,1,.5,11.3,7.9,7.9,0,0,1-11.3.6A12.9,12.9,0,0,0,198,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a12.9,12.9,0,0,0,8.6-3.4A7.9,7.9,0,0,1,217.9,205.2ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M58,216a24,24,0,0,0,0-48H44v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "130",
      "cy": "192",
      "rx": "22",
      "ry": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M58,216a24,24,0,0,0,0-48H44v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "130",
      "cy": "192",
      "rx": "22",
      "ry": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M58,216a24,24,0,0,0,0-48H44v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "130",
      "cy": "192",
      "rx": "22",
      "ry": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9G = [];
/* style */

const __vue_inject_styles__$9G = undefined;
/* scoped */

const __vue_scope_id__$9G = undefined;
/* module identifier */

const __vue_module_identifier__$9G = undefined;
/* functional template */

const __vue_is_functional_template__$9G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9G,
  staticRenderFns: __vue_staticRenderFns__$9G
}, __vue_inject_styles__$9G, __vue_script__$9G, __vue_scope_id__$9G, __vue_is_functional_template__$9G, __vue_module_identifier__$9G, false, undefined, undefined, undefined);

var script$9F = Vue.extend({
  name: "PhFileDotted",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9F = script$9F;
/* template */

var __vue_render__$9F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,224H56a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,64V40a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,224H56a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,64V40a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,224a8,8,0,0,1-8,8H56a16,16,0,0,1-16-16V184a8,8,0,0,1,16,0v32H72A8,8,0,0,1,80,224ZM80,24H56A16,16,0,0,0,40,40V64a8,8,0,0,0,16,0V40H80a8,8,0,0,0,0-16ZM216,88a7.8,7.8,0,0,0-2.4-5.7l-55.9-56h-.2l-.4-.4h-.2l-.4-.3c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H120a8,8,0,0,0,0,16h24V88a8,8,0,0,0,8,8h48v40a8,8,0,0,0,16,0V88Zm-8,80a8,8,0,0,0-8,8v40h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V176A8,8,0,0,0,208,168ZM48,152a8,8,0,0,0,8-8V104a8,8,0,0,0-16,0v40A8,8,0,0,0,48,152Zm104,64H112a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224H56a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,64V40a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224H56a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,64V40a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,224H56a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 32 152 32 208 88 208 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,64V40a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,176v40a8,8,0,0,1-8,8h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "104",
      "x2": "48",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "152",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9F = [];
/* style */

const __vue_inject_styles__$9F = undefined;
/* scoped */

const __vue_scope_id__$9F = undefined;
/* module identifier */

const __vue_module_identifier__$9F = undefined;
/* functional template */

const __vue_is_functional_template__$9F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9F,
  staticRenderFns: __vue_staticRenderFns__$9F
}, __vue_inject_styles__$9F, __vue_script__$9F, __vue_scope_id__$9F, __vue_is_functional_template__$9F, __vue_module_identifier__$9F, false, undefined, undefined, undefined);

var script$9E = Vue.extend({
  name: "PhFileHtml",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9E = script$9E;
/* template */

var __vue_render__$9E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "164",
      "x2": "60",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "220",
      "x2": "100",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "164",
      "x2": "20",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "164",
      "x2": "60",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "192",
      "x2": "60",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "220 164 220 220 244 220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "140 220 140 164 164 196 188 164 188 220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "176",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "176",
      "x2": "36",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "196",
      "x2": "64",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 176 212 216 236 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 216 144 176 164 204 184 176 184 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,168H88a8,8,0,0,0,0,16h8v32a8,8,0,0,0,16,0V184h8a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,168a8,8,0,0,0-8,8v12H44V176a8,8,0,0,0-16,0v40a8,8,0,0,0,16,0V204H56v12a8,8,0,0,0,16,0V176A8,8,0,0,0,64,168Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M236,208H220V176a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.4,168.4a7.8,7.8,0,0,0-8.9,3L164,190.2l-13.5-18.8A8,8,0,0,0,136,176v40a8,8,0,0,0,16,0V201l5.5,7.6a7.9,7.9,0,0,0,13,0L176,201v15a8,8,0,0,0,16,0V176A7.8,7.8,0,0,0,186.4,168.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "176",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "176",
      "x2": "36",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "196",
      "x2": "64",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 176 212 216 236 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 216 144 176 164 204 184 176 184 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "176",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "176",
      "x2": "36",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "196",
      "x2": "64",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 176 212 216 236 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 216 144 176 164 204 184 176 184 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "176",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "176",
      "x2": "36",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "64",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "196",
      "x2": "64",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 176 212 216 236 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 216 144 176 164 204 184 176 184 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9E = [];
/* style */

const __vue_inject_styles__$9E = undefined;
/* scoped */

const __vue_scope_id__$9E = undefined;
/* module identifier */

const __vue_module_identifier__$9E = undefined;
/* functional template */

const __vue_is_functional_template__$9E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9E,
  staticRenderFns: __vue_staticRenderFns__$9E
}, __vue_inject_styles__$9E, __vue_script__$9E, __vue_scope_id__$9E, __vue_is_functional_template__$9E, __vue_module_identifier__$9E, false, undefined, undefined, undefined);

var script$9D = Vue.extend({
  name: "PhFileImage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9D = script$9D;
/* template */

var __vue_render__$9D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,224h4a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v96a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,80V51.3L188.7,80Zm-1.3,139.6a8.3,8.3,0,0,1,.4,8.2A8,8,0,0,1,152,232H24a8,8,0,0,1-7-4.2,7.9,7.9,0,0,1,.3-8.1l32.6-50.8a12,12,0,0,1,20.2,0l6.4,10L94,152.6a12,12,0,0,1,20,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9D = [];
/* style */

const __vue_inject_styles__$9D = undefined;
/* scoped */

const __vue_scope_id__$9D = undefined;
/* module identifier */

const __vue_module_identifier__$9D = undefined;
/* functional template */

const __vue_is_functional_template__$9D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9D,
  staticRenderFns: __vue_staticRenderFns__$9D
}, __vue_inject_styles__$9D, __vue_script__$9D, __vue_scope_id__$9D, __vue_is_functional_template__$9D, __vue_module_identifier__$9D, false, undefined, undefined, undefined);

var script$9C = Vue.extend({
  name: "PhFileJpg",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9C = script$9C;
/* template */

var __vue_render__$9C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,204h16a20,20,0,0,0,0-40H100v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,164v36a20,20,0,0,1-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,198.9h8v8c-4.6,7.9-12.7,13.1-22,13.1-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,200h16a16,16,0,0,0,0-32H104v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,160H104a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16ZM80,168v32a24,24,0,0,1-48,0,8,8,0,0,1,16,0,8,8,0,0,0,16,0V168a8,8,0,0,1,16,0Zm128,26v11.8a7.5,7.5,0,0,1-1.3,4.3A29.4,29.4,0,0,1,182,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a28.4,28.4,0,0,1,16.6,5.4,8,8,0,0,1-9.2,13A12.6,12.6,0,0,0,182,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a13.3,13.3,0,0,0,10-4.8V202h-4a8,8,0,0,1,0-16h12A8,8,0,0,1,208,194Zm5.7-111.7-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,200h16a16,16,0,0,0,0-32H104v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,200h16a16,16,0,0,0,0-32H104v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,200h16a16,16,0,0,0,0-32H104v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9C = [];
/* style */

const __vue_inject_styles__$9C = undefined;
/* scoped */

const __vue_scope_id__$9C = undefined;
/* module identifier */

const __vue_module_identifier__$9C = undefined;
/* functional template */

const __vue_is_functional_template__$9C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9C,
  staticRenderFns: __vue_staticRenderFns__$9C
}, __vue_inject_styles__$9C, __vue_script__$9C, __vue_scope_id__$9C, __vue_is_functional_template__$9C, __vue_module_identifier__$9C, false, undefined, undefined, undefined);

var script$9B = Vue.extend({
  name: "PhFileJs",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9B = script$9B;
/* template */

var __vue_render__$9B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,164v36a20,20,0,0,1-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,204c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,96,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H109a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C109,197,96,193.5,96,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,142,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C130,186,144,189.7,144,204ZM72,160a8,8,0,0,0-8,8v32a8,8,0,0,1-16,0,8,8,0,0,0-16,0,24,24,0,0,0,48,0V168A8,8,0,0,0,72,160ZM216,88V216a16,16,0,0,1-16,16H176a8,8,0,0,1-8-8V144a8,8,0,0,0-8-8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9B = [];
/* style */

const __vue_inject_styles__$9B = undefined;
/* scoped */

const __vue_scope_id__$9B = undefined;
/* module identifier */

const __vue_module_identifier__$9B = undefined;
/* functional template */

const __vue_is_functional_template__$9B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9B,
  staticRenderFns: __vue_staticRenderFns__$9B
}, __vue_inject_styles__$9B, __vue_script__$9B, __vue_scope_id__$9B, __vue_is_functional_template__$9B, __vue_module_identifier__$9B, false, undefined, undefined, undefined);

var script$9A = Vue.extend({
  name: "PhFileJsx",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9A = script$9A;
/* template */

var __vue_render__$9A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "164",
      "x2": "212",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "164",
      "x2": "172",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,164v36a20,20,0,0,1-40,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "164",
      "y1": "168",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "168",
      "x2": "164",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168v32a24,24,0,0,1-48,0,8,8,0,0,1,16,0,8,8,0,0,0,16,0V168a8,8,0,0,1,16,0Zm41.7,15.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,134,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,119,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,104,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,119,225c15.7,0,25-7.9,25-21S130,186,121.7,183.8Zm83.1-22.2a8,8,0,0,0-11.2,1.6L182,178.7l-11.6-15.5a8,8,0,0,0-12.8,9.6L172,192l-14.4,19.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,164,224a8,8,0,0,0,6.4-3.2L182,205.3l11.6,15.5A8,8,0,0,0,200,224a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L192,192l14.4-19.2A8,8,0,0,0,204.8,161.6ZM216,88v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "164",
      "y1": "168",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "168",
      "x2": "164",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "164",
      "y1": "168",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "168",
      "x2": "164",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "164",
      "y1": "168",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "168",
      "x2": "164",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168v32a16,16,0,0,1-32,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9A = [];
/* style */

const __vue_inject_styles__$9A = undefined;
/* scoped */

const __vue_scope_id__$9A = undefined;
/* module identifier */

const __vue_module_identifier__$9A = undefined;
/* functional template */

const __vue_is_functional_template__$9A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9A,
  staticRenderFns: __vue_staticRenderFns__$9A
}, __vue_inject_styles__$9A, __vue_script__$9A, __vue_scope_id__$9A, __vue_is_functional_template__$9A, __vue_module_identifier__$9A, false, undefined, undefined, undefined);

var script$9z = Vue.extend({
  name: "PhFileLock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9z = script$9z;
/* template */

var __vue_render__$9z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,224h28a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "184",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184V168a20,20,0,0,1,40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "180",
      "width": "72",
      "height": "44",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "180",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180V168a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H168a8,8,0,0,0,0,16h32a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,51.3,188.7,80H160ZM128,172h-8v-4a28,28,0,0,0-56,0v4H56a8,8,0,0,0-8,8v44a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V180A8,8,0,0,0,128,172Zm-24,0H80v-4a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "180",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180V168a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "180",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180V168a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "180",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,180V168a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9z = [];
/* style */

const __vue_inject_styles__$9z = undefined;
/* scoped */

const __vue_scope_id__$9z = undefined;
/* module identifier */

const __vue_module_identifier__$9z = undefined;
/* functional template */

const __vue_is_functional_template__$9z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9z,
  staticRenderFns: __vue_staticRenderFns__$9z
}, __vue_inject_styles__$9z, __vue_script__$9z, __vue_scope_id__$9z, __vue_is_functional_template__$9z, __vue_module_identifier__$9z, false, undefined, undefined, undefined);

var script$9y = Vue.extend({
  name: "PhFileMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9y = script$9y;
/* template */

var __vue_render__$9y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,160H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-72V43.3L196.7,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9y = [];
/* style */

const __vue_inject_styles__$9y = undefined;
/* scoped */

const __vue_scope_id__$9y = undefined;
/* module identifier */

const __vue_module_identifier__$9y = undefined;
/* functional template */

const __vue_is_functional_template__$9y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9y,
  staticRenderFns: __vue_staticRenderFns__$9y
}, __vue_inject_styles__$9y, __vue_script__$9y, __vue_scope_id__$9y, __vue_is_functional_template__$9y, __vue_module_identifier__$9y, false, undefined, undefined, undefined);

var script$9x = Vue.extend({
  name: "PhFilePdf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9x = script$9x;
/* template */

var __vue_render__$9x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "228 164 196 164 196 220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "196",
      "x2": "196",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,220V164h16a28,28,0,0,1,0,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,204H52a20,20,0,0,0,0-40H36v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 168 188 168 188 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "196",
      "x2": "188",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216a24,24,0,0,0,0-48H114v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm132-16v12h16a8,8,0,0,1,0,16H196v12a8,8,0,0,1-16,0V168a8,8,0,0,1,8-8h28a8,8,0,0,1,0,16Zm-68-16H114a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h14a32,32,0,0,0,0-64Zm0,48h-6V176h6a16,16,0,0,1,0,32ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 168 188 168 188 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "196",
      "x2": "188",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216a24,24,0,0,0,0-48H114v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 168 188 168 188 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "196",
      "x2": "188",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216a24,24,0,0,0,0-48H114v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 168 188 168 188 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "196",
      "x2": "188",
      "y2": "196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216a24,24,0,0,0,0-48H114v48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9x = [];
/* style */

const __vue_inject_styles__$9x = undefined;
/* scoped */

const __vue_scope_id__$9x = undefined;
/* module identifier */

const __vue_module_identifier__$9x = undefined;
/* functional template */

const __vue_is_functional_template__$9x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9x,
  staticRenderFns: __vue_staticRenderFns__$9x
}, __vue_inject_styles__$9x, __vue_script__$9x, __vue_scope_id__$9x, __vue_is_functional_template__$9x, __vue_module_identifier__$9x, false, undefined, undefined, undefined);

var script$9w = Vue.extend({
  name: "PhFilePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9w = script$9w;
/* template */

var __vue_render__$9w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.3L196.7,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "152",
      "x2": "152",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9w = [];
/* style */

const __vue_inject_styles__$9w = undefined;
/* scoped */

const __vue_scope_id__$9w = undefined;
/* module identifier */

const __vue_module_identifier__$9w = undefined;
/* functional template */

const __vue_is_functional_template__$9w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9w,
  staticRenderFns: __vue_staticRenderFns__$9w
}, __vue_inject_styles__$9w, __vue_script__$9w, __vue_scope_id__$9w, __vue_is_functional_template__$9w, __vue_module_identifier__$9w, false, undefined, undefined, undefined);

var script$9v = Vue.extend({
  name: "PhFilePng",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9v = script$9v;
/* template */

var __vue_render__$9v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 220 108 164 148 220 148 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,204H52a20,20,0,0,0,0-40H36v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,198.9h8v8c-4.6,7.9-12.7,13.1-22,13.1-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,200H60a16,16,0,0,0,0-32H44v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 216 108 168 144 216 144 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M60,160H44a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H52V176h8a8,8,0,0,1,0,16Zm92-24v48a8,8,0,0,1-5.5,7.6,7.3,7.3,0,0,1-2.5.4,7.8,7.8,0,0,1-6.4-3.2L116,192v24a8,8,0,0,1-16,0V168a8,8,0,0,1,5.5-7.6,7.9,7.9,0,0,1,8.9,2.8L136,192V168a8,8,0,0,1,16,0Zm72,37.8a7.5,7.5,0,0,1-1.3,4.3A29.4,29.4,0,0,1,198,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a28.4,28.4,0,0,1,16.6,5.4,8,8,0,0,1-9.2,13A12.6,12.6,0,0,0,198,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a13.3,13.3,0,0,0,10-4.8V202h-4a8,8,0,0,1,0-16h12a8,8,0,0,1,8,8ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,200H60a16,16,0,0,0,0-32H44v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 216 108 168 144 216 144 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,200H60a16,16,0,0,0,0-32H44v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 216 108 168 144 216 144 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,200H60a16,16,0,0,0,0-32H44v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 216 108 168 144 216 144 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9v = [];
/* style */

const __vue_inject_styles__$9v = undefined;
/* scoped */

const __vue_scope_id__$9v = undefined;
/* module identifier */

const __vue_module_identifier__$9v = undefined;
/* functional template */

const __vue_is_functional_template__$9v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9v,
  staticRenderFns: __vue_staticRenderFns__$9v
}, __vue_inject_styles__$9v, __vue_script__$9v, __vue_scope_id__$9v, __vue_is_functional_template__$9v, __vue_module_identifier__$9v, false, undefined, undefined, undefined);

var script$9u = Vue.extend({
  name: "PhFilePpt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9u = script$9u;
/* template */

var __vue_render__$9u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,204H60a20,20,0,0,0,0-40H44v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116,204h16a20,20,0,0,0,0-40H116v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "220",
      "x2": "200",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "164",
      "x2": "180",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,200h16a16,16,0,0,0,0-32H112v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "190",
      "y1": "216",
      "x2": "190",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44ZM64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm64-32H112a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16Zm88-24a8,8,0,0,1-8,8H198v40a8,8,0,0,1-16,0V176H172a8,8,0,0,1,0-16h36A8,8,0,0,1,216,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,200h16a16,16,0,0,0,0-32H112v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "190",
      "y1": "216",
      "x2": "190",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,200h16a16,16,0,0,0,0-32H112v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "190",
      "y1": "216",
      "x2": "190",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,200h16a16,16,0,0,0,0-32H112v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "190",
      "y1": "216",
      "x2": "190",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9u = [];
/* style */

const __vue_inject_styles__$9u = undefined;
/* scoped */

const __vue_scope_id__$9u = undefined;
/* module identifier */

const __vue_module_identifier__$9u = undefined;
/* functional template */

const __vue_is_functional_template__$9u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9u,
  staticRenderFns: __vue_staticRenderFns__$9u
}, __vue_inject_styles__$9u, __vue_script__$9u, __vue_scope_id__$9u, __vue_is_functional_template__$9u, __vue_module_identifier__$9u, false, undefined, undefined, undefined);

var script$9t = Vue.extend({
  name: "PhFileRs",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9t = script$9t;
/* template */

var __vue_render__$9t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,204H52a20,20,0,0,0,0-40H36v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.5",
      "y1": "202.1",
      "x2": "72",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "199.3",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80.1,201.8A24,24,0,0,0,64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h9l8.3,12.4A7.9,7.9,0,0,0,80,224a7.8,7.8,0,0,0,4.4-1.3,8,8,0,0,0,2.2-11.1ZM64,192H56V176h8a8,8,0,0,1,0,16Zm88,12c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,104,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H117a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C117,197,104,193.5,104,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,150,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C138,186,152,189.7,152,204ZM213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H168a8,8,0,0,1,8,8v80a8,8,0,0,0,8,8h16a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "199.3",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "199.3",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,200H64a16,16,0,0,0,0-32H48v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68.8",
      "y1": "199.3",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9t = [];
/* style */

const __vue_inject_styles__$9t = undefined;
/* scoped */

const __vue_scope_id__$9t = undefined;
/* module identifier */

const __vue_module_identifier__$9t = undefined;
/* functional template */

const __vue_is_functional_template__$9t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9t,
  staticRenderFns: __vue_staticRenderFns__$9t
}, __vue_inject_styles__$9t, __vue_script__$9t, __vue_scope_id__$9t, __vue_is_functional_template__$9t, __vue_module_identifier__$9t, false, undefined, undefined, undefined);

var script$9s = Vue.extend({
  name: "PhFileSearch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9s = script$9s;
/* template */

var __vue_render__$9s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "148",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141",
      "y1": "165",
      "x2": "159.8",
      "y2": "183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.8",
      "y1": "167.8",
      "x2": "159.8",
      "y2": "183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.6,82.3l-55.9-56-.3-.2-.3-.3-.3-.2-.3-.2c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A7.8,7.8,0,0,0,213.6,82.3ZM165.4,189.5a8,8,0,0,1-5.6,2.3,8.3,8.3,0,0,1-5.7-2.3l-10.9-11A36.8,36.8,0,0,1,124,184a36,36,0,1,1,36-36,35.8,35.8,0,0,1-5.5,19.2l10.9,10.9A8,8,0,0,1,165.4,189.5ZM152,88V43.3L196.7,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,128a19.9,19.9,0,0,0-14.1,5.9,19.8,19.8,0,0,0,0,28.2,19.9,19.9,0,0,0,28.2,0,19.8,19.8,0,0,0,0-28.2A19.9,19.9,0,0,0,124,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.8",
      "y1": "167.8",
      "x2": "159.8",
      "y2": "183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.8",
      "y1": "167.8",
      "x2": "159.8",
      "y2": "183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143.8",
      "y1": "167.8",
      "x2": "159.8",
      "y2": "183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9s = [];
/* style */

const __vue_inject_styles__$9s = undefined;
/* scoped */

const __vue_scope_id__$9s = undefined;
/* module identifier */

const __vue_module_identifier__$9s = undefined;
/* functional template */

const __vue_is_functional_template__$9s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9s,
  staticRenderFns: __vue_staticRenderFns__$9s
}, __vue_inject_styles__$9s, __vue_script__$9s, __vue_scope_id__$9s, __vue_is_functional_template__$9s, __vue_module_identifier__$9s, false, undefined, undefined, undefined);

var script$9r = Vue.extend({
  name: "PhFileText",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9r = script$9r;
/* template */

var __vue_render__$9r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "132",
      "x2": "160",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "172",
      "x2": "160",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "136",
      "x2": "160",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "168",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9r = [];
/* style */

const __vue_inject_styles__$9r = undefined;
/* scoped */

const __vue_scope_id__$9r = undefined;
/* module identifier */

const __vue_module_identifier__$9r = undefined;
/* functional template */

const __vue_is_functional_template__$9r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9r,
  staticRenderFns: __vue_staticRenderFns__$9r
}, __vue_inject_styles__$9r, __vue_script__$9r, __vue_scope_id__$9r, __vue_is_functional_template__$9r, __vue_module_identifier__$9r, false, undefined, undefined, undefined);

var script$9q = Vue.extend({
  name: "PhFileTs",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9q = script$9q;
/* template */

var __vue_render__$9q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "220",
      "x2": "56",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "164",
      "x2": "36",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92,168a8,8,0,0,1-8,8H74v40a8,8,0,0,1-16,0V176H48a8,8,0,0,1,0-16H84A8,8,0,0,1,92,168Zm37.7,15.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8ZM216,88V216a16,16,0,0,1-16,16H184a8,8,0,0,1-8-8V144a8,8,0,0,0-8-8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9q = [];
/* style */

const __vue_inject_styles__$9q = undefined;
/* scoped */

const __vue_scope_id__$9q = undefined;
/* module identifier */

const __vue_module_identifier__$9q = undefined;
/* functional template */

const __vue_is_functional_template__$9q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9q,
  staticRenderFns: __vue_staticRenderFns__$9q
}, __vue_inject_styles__$9q, __vue_script__$9q, __vue_scope_id__$9q, __vue_is_functional_template__$9q, __vue_module_identifier__$9q, false, undefined, undefined, undefined);

var script$9p = Vue.extend({
  name: "PhFileTsx",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9p = script$9p;
/* template */

var __vue_render__$9p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "164",
      "x2": "212",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "164",
      "x2": "172",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "220",
      "x2": "56",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "164",
      "x2": "36",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44ZM92,168a8,8,0,0,1-8,8H74v40a8,8,0,0,1-16,0V176H48a8,8,0,0,1,0-16H84A8,8,0,0,1,92,168Zm122.4,4.8L200,192l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,208,224a8,8,0,0,1-6.4-3.2L190,205.3l-11.6,15.5A8,8,0,0,1,172,224a7.7,7.7,0,0,1-4.8-1.6,8.1,8.1,0,0,1-1.6-11.2L180,192l-14.4-19.2a8.1,8.1,0,0,1,1.6-11.2,8,8,0,0,1,11.2,1.6L190,178.7l11.6-15.5a8,8,0,1,1,12.8,9.6ZM152,204c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,104,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H117a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C117,197,104,193.5,104,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,150,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C138,186,152,189.7,152,204Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "172",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "172",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "168",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66",
      "y1": "216",
      "x2": "66",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9p = [];
/* style */

const __vue_inject_styles__$9p = undefined;
/* scoped */

const __vue_scope_id__$9p = undefined;
/* module identifier */

const __vue_module_identifier__$9p = undefined;
/* functional template */

const __vue_is_functional_template__$9p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9p,
  staticRenderFns: __vue_staticRenderFns__$9p
}, __vue_inject_styles__$9p, __vue_script__$9p, __vue_scope_id__$9p, __vue_is_functional_template__$9p, __vue_module_identifier__$9p, false, undefined, undefined, undefined);

var script$9o = Vue.extend({
  name: "PhFileVideo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9o = script$9o;
/* template */

var __vue_render__$9o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,224h12a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "160",
      "width": "72",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 176 148 164 148 213.2 112 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,164v49.2L112,196v12a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V168a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8v12Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "160",
      "width": "72",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 180 144 164 144 213.2 112 196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,164v49.2a8.1,8.1,0,0,1-4.5,7.2,8.5,8.5,0,0,1-3.5.8,7.9,7.9,0,0,1-4.9-1.7l-19.1-15V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V168a16,16,0,0,1,16-16h56a16,16,0,0,1,16,16v4l19.2-14.4A8,8,0,0,1,152,164Zm64-76V216a16,16,0,0,1-16,16H168a8,8,0,0,1,0-16h32V96H152a8,8,0,0,1-8-8V40H56v80a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-27.3-8L160,51.3V80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "160",
      "width": "72",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 180 144 164 144 213.2 112 196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "160",
      "width": "72",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 180 144 164 144 213.2 112 196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "160",
      "width": "72",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 180 144 164 144 213.2 112 196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9o = [];
/* style */

const __vue_inject_styles__$9o = undefined;
/* scoped */

const __vue_scope_id__$9o = undefined;
/* module identifier */

const __vue_module_identifier__$9o = undefined;
/* functional template */

const __vue_is_functional_template__$9o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9o,
  staticRenderFns: __vue_staticRenderFns__$9o
}, __vue_inject_styles__$9o, __vue_script__$9o, __vue_scope_id__$9o, __vue_is_functional_template__$9o, __vue_module_identifier__$9o, false, undefined, undefined, undefined);

var script$9n = Vue.extend({
  name: "PhFileVue",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9n = script$9n;
/* template */

var __vue_render__$9n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "220 220 188 220 188 164 220 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "192",
      "x2": "188",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 164 54 220 76 164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,164v36a20,20,0,0,0,40,0V164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "192",
      "x2": "180",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 216 180 216 180 168 208 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 168 64 216 84 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,168v30a18,18,0,0,0,36,0V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,176v8h16a8,8,0,0,1,0,16H188v8h20a8,8,0,0,1,0,16H180a8,8,0,0,1-8-8V168a8,8,0,0,1,8-8h28a8,8,0,0,1,0,16ZM87.1,160.6a8,8,0,0,0-10.5,4.3L64,195.2,51.4,164.9a8,8,0,0,0-14.8,6.2l20,48a8,8,0,0,0,14.8,0l20-48A8,8,0,0,0,87.1,160.6ZM148,160a8,8,0,0,0-8,8v30a10,10,0,0,1-20,0V168a8,8,0,0,0-16,0v30a26,26,0,0,0,52,0V168A8,8,0,0,0,148,160Zm68-72v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "192",
      "x2": "180",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 216 180 216 180 168 208 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 168 64 216 84 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,168v30a18,18,0,0,0,36,0V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "192",
      "x2": "180",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 216 180 216 180 168 208 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 168 64 216 84 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,168v30a18,18,0,0,0,36,0V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "192",
      "x2": "180",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 216 180 216 180 168 208 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 168 64 216 84 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,168v30a18,18,0,0,0,36,0V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9n = [];
/* style */

const __vue_inject_styles__$9n = undefined;
/* scoped */

const __vue_scope_id__$9n = undefined;
/* module identifier */

const __vue_module_identifier__$9n = undefined;
/* functional template */

const __vue_is_functional_template__$9n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9n,
  staticRenderFns: __vue_staticRenderFns__$9n
}, __vue_inject_styles__$9n, __vue_script__$9n, __vue_scope_id__$9n, __vue_is_functional_template__$9n, __vue_module_identifier__$9n, false, undefined, undefined, undefined);

var script$9m = Vue.extend({
  name: "PhFileX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9m = script$9m;
/* template */

var __vue_render__$9m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 32 148 92 208 92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-56,88a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,163.3l-18.3,18.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,152,98.3,133.7a8.1,8.1,0,0,1,11.4-11.4L128,140.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L139.3,152ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "104",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9m = [];
/* style */

const __vue_inject_styles__$9m = undefined;
/* scoped */

const __vue_scope_id__$9m = undefined;
/* module identifier */

const __vue_module_identifier__$9m = undefined;
/* functional template */

const __vue_is_functional_template__$9m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9m,
  staticRenderFns: __vue_staticRenderFns__$9m
}, __vue_inject_styles__$9m, __vue_script__$9m, __vue_scope_id__$9m, __vue_is_functional_template__$9m, __vue_module_identifier__$9m, false, undefined, undefined, undefined);

var script$9l = Vue.extend({
  name: "PhFileXls",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9l = script$9l;
/* template */

var __vue_render__$9l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "164",
      "x2": "84",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "164",
      "x2": "44",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 164 120 220 148 220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 168 120 216 148 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "168",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "52",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.4,172.8,80,192l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,88,224a8,8,0,0,1-6.4-3.2L70,205.3,58.4,220.8A8,8,0,0,1,52,224a7.7,7.7,0,0,1-4.8-1.6,8,8,0,0,1-1.6-11.2L60,192,45.6,172.8a8,8,0,1,1,12.8-9.6L70,178.7l11.6-15.5a8,8,0,0,1,12.8,9.6ZM148,208H128V168a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8h28a8,8,0,0,0,0-16Zm45.7-24.2c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,206,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,191,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,176,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,191,225c15.7,0,25-7.9,25-21S202,186,193.7,183.8ZM216,88v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 168 120 216 148 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "168",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "52",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 168 120 216 148 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "168",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "52",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "120 168 120 216 148 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "168",
      "x2": "88",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "52",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9l = [];
/* style */

const __vue_inject_styles__$9l = undefined;
/* scoped */

const __vue_scope_id__$9l = undefined;
/* module identifier */

const __vue_module_identifier__$9l = undefined;
/* functional template */

const __vue_is_functional_template__$9l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9l,
  staticRenderFns: __vue_staticRenderFns__$9l
}, __vue_inject_styles__$9l, __vue_script__$9l, __vue_scope_id__$9l, __vue_is_functional_template__$9l, __vue_module_identifier__$9l, false, undefined, undefined, undefined);

var script$9k = Vue.extend({
  name: "PhFileZip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9k = script$9k;
/* template */

var __vue_render__$9k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "148 36 148 100 212 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,204h16a20,20,0,0,0,0-40H176v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "164",
      "x2": "128",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "44 164 84 164 44 220 84 220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "152 32 152 88 208 88 152 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,200h16a16,16,0,0,0,0-32H168v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 88 168 56 216 88 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,160H168a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16ZM96,216a8,8,0,0,1-8,8H56a8,8,0,0,1-7.1-4.2,8.3,8.3,0,0,1,.4-8.2L73.1,176H56a8,8,0,0,1,0-16H88a8,8,0,0,1,7.1,4.2,8.3,8.3,0,0,1-.4,8.2L70.9,208H88A8,8,0,0,1,96,216Zm40-48v48a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm77.7-85.7-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,200h16a16,16,0,0,0,0-32H168v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 88 168 56 216 88 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,200h16a16,16,0,0,0,0-32H168v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 88 168 56 216 88 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 32 152 88 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,200h16a16,16,0,0,0,0-32H168v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 88 168 56 216 88 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9k = [];
/* style */

const __vue_inject_styles__$9k = undefined;
/* scoped */

const __vue_scope_id__$9k = undefined;
/* module identifier */

const __vue_module_identifier__$9k = undefined;
/* functional template */

const __vue_is_functional_template__$9k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9k,
  staticRenderFns: __vue_staticRenderFns__$9k
}, __vue_inject_styles__$9k, __vue_script__$9k, __vue_scope_id__$9k, __vue_is_functional_template__$9k, __vue_module_identifier__$9k, false, undefined, undefined, undefined);

var script$9j = Vue.extend({
  name: "PhFiles",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9j = script$9j;
/* template */

var __vue_render__$9j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164,224H56a8,8,0,0,1-8-8V76a8,8,0,0,1,8-8h76l40,40V216A8,8,0,0,1,164,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,68V36a8,8,0,0,1,8-8h80l40,40V176a8,8,0,0,1-8,8H172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "144",
      "x2": "132",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "132",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,192h24a8,8,0,0,0,8-8V72L168,32H88a8,8,0,0,0-8,8V64h56l40,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,66.3l-40-40A8.1,8.1,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8.1,8.1,0,0,0,213.7,66.3ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8.1,8.1,0,0,0-2.3-5.7l-40-40A8.1,8.1,0,0,0,136,56H88V40h76.7L200,75.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "152",
      "x2": "136",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9j = [];
/* style */

const __vue_inject_styles__$9j = undefined;
/* scoped */

const __vue_scope_id__$9j = undefined;
/* module identifier */

const __vue_module_identifier__$9j = undefined;
/* functional template */

const __vue_is_functional_template__$9j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9j,
  staticRenderFns: __vue_staticRenderFns__$9j
}, __vue_inject_styles__$9j, __vue_script__$9j, __vue_scope_id__$9j, __vue_is_functional_template__$9j, __vue_module_identifier__$9j, false, undefined, undefined, undefined);

var script$9i = Vue.extend({
  name: "PhFilmScript",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9i = script$9i;
/* template */

var __vue_render__$9i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "80",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "176",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM76,188a12,12,0,1,1,12-12A12,12,0,0,1,76,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,76,140Zm0-48A12,12,0,1,1,88,80,12,12,0,0,1,76,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "80",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "176",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "80",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "176",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "32",
      "width": "160",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9i = [];
/* style */

const __vue_inject_styles__$9i = undefined;
/* scoped */

const __vue_scope_id__$9i = undefined;
/* module identifier */

const __vue_module_identifier__$9i = undefined;
/* functional template */

const __vue_is_functional_template__$9i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9i,
  staticRenderFns: __vue_staticRenderFns__$9i
}, __vue_inject_styles__$9i, __vue_script__$9i, __vue_scope_id__$9i, __vue_is_functional_template__$9i, __vue_module_identifier__$9i, false, undefined, undefined, undefined);

var script$9h = Vue.extend({
  name: "PhFilmSlate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9h = script$9h;
/* template */

var __vue_render__$9h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.1",
      "y1": "46.4",
      "x2": "179.1",
      "y2": "74.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.6",
      "y1": "65.1",
      "x2": "109.5",
      "y2": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L130.1,46.4l49,28.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M109.5,93.4,60.6,65.1,37.4,71.3a8,8,0,0,0-5.7,9.8L40,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.1",
      "y1": "46.4",
      "x2": "179.1",
      "y2": "74.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.6",
      "y1": "65.1",
      "x2": "109.5",
      "y2": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,104H100.8L212.1,74.2a7.9,7.9,0,0,0,4.8-3.8,7.5,7.5,0,0,0,.8-6l-8.3-30.9a15.8,15.8,0,0,0-19.5-11.3L35.3,63.6A15.9,15.9,0,0,0,24,83.2l8,29.9V200a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V112A8,8,0,0,0,216,104ZM169.3,69.1,99.7,87.7l-29.3-17,69.5-18.6ZM208,200H48V120H208v80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.1",
      "y1": "46.4",
      "x2": "179.1",
      "y2": "74.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.6",
      "y1": "65.1",
      "x2": "109.5",
      "y2": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.1",
      "y1": "46.4",
      "x2": "179.1",
      "y2": "74.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.6",
      "y1": "65.1",
      "x2": "109.5",
      "y2": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.1",
      "y1": "46.4",
      "x2": "179.1",
      "y2": "74.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.6",
      "y1": "65.1",
      "x2": "109.5",
      "y2": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9h = [];
/* style */

const __vue_inject_styles__$9h = undefined;
/* scoped */

const __vue_scope_id__$9h = undefined;
/* module identifier */

const __vue_module_identifier__$9h = undefined;
/* functional template */

const __vue_is_functional_template__$9h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9h,
  staticRenderFns: __vue_staticRenderFns__$9h
}, __vue_inject_styles__$9h, __vue_script__$9h, __vue_scope_id__$9h, __vue_is_functional_template__$9h, __vue_module_identifier__$9h, false, undefined, undefined, undefined);

var script$9g = Vue.extend({
  name: "PhFilmStrip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9g = script$9g;
/* template */

var __vue_render__$9g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "168",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "48",
      "x2": "176",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "168",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,176H224v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,80H32V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "48",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,56h32V72H184Zm-48,0h32V72H136ZM88,56h32V72H88ZM72,200H40V184H72ZM72,72H40V56H72ZM88,200V185.3h32V200Zm48,0V185.3h32V200Zm80,0H184V185.3h9.2V184H216v16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "48",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "48",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "48",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "48",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "80",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9g = [];
/* style */

const __vue_inject_styles__$9g = undefined;
/* scoped */

const __vue_scope_id__$9g = undefined;
/* module identifier */

const __vue_module_identifier__$9g = undefined;
/* functional template */

const __vue_is_functional_template__$9g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9g,
  staticRenderFns: __vue_staticRenderFns__$9g
}, __vue_inject_styles__$9g, __vue_script__$9g, __vue_scope_id__$9g, __vue_is_functional_template__$9g, __vue_module_identifier__$9g, false, undefined, undefined, undefined);

var script$9f = Vue.extend({
  name: "PhFingerprint",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9f = script$9f;
/* template */

var __vue_render__$9f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,128a20,20,0,0,1,40,0,210.5,210.5,0,0,1-25,99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,68a60,60,0,0,1,60,60c0,8.1-.4,16.1-1.1,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.3,192.2A130.4,130.4,0,0,0,68,128,59.7,59.7,0,0,1,88,83.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.3,168A168.7,168.7,0,0,1,83,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.8,192a233.4,233.4,0,0,1-8.4,26.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.3,160A91.7,91.7,0,0,0,28,128h0a100,100,0,0,1,200,0h0a293.3,293.3,0,0,1-7,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a191.2,191.2,0,0,1-24,93",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104.2,104.2,0,0,0,24,128a88,88,0,0,1-5,29.3,8.1,8.1,0,0,0,4.9,10.3,8.2,8.2,0,0,0,2.6.4,8.1,8.1,0,0,0,7.6-5.3A104.5,104.5,0,0,0,40,128a88,88,0,0,1,176,0,283.6,283.6,0,0,1-5.3,54.5,8.1,8.1,0,0,0,6.3,9.4h1.6a7.9,7.9,0,0,0,7.8-6.4A299.9,299.9,0,0,0,232,128,104.1,104.1,0,0,0,128,24Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93,84.3A8,8,0,0,0,83,71.8,71.6,71.6,0,0,0,56,128a118.7,118.7,0,0,1-12.5,53.4,8.1,8.1,0,0,0,3.6,10.7,7.8,7.8,0,0,0,3.6.8,8.1,8.1,0,0,0,7.2-4.4A136.1,136.1,0,0,0,72,128,55.9,55.9,0,0,1,93,84.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a8,8,0,0,0-8,8,183.3,183.3,0,0,1-23,89.1,8.1,8.1,0,0,0,3.2,10.9,7.5,7.5,0,0,0,3.8,1,8,8,0,0,0,7-4.1A199.8,199.8,0,0,0,136,128,8,8,0,0,0,128,120Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88a40.1,40.1,0,0,0-40,40,8,8,0,0,0,16,0,24,24,0,0,1,48,0,214.3,214.3,0,0,1-20.5,92,8,8,0,0,0,3.8,10.7,8.3,8.3,0,0,0,3.4.7,8.1,8.1,0,0,0,7.3-4.6A230,230,0,0,0,168,128,40.1,40.1,0,0,0,128,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.4,152.2a7.9,7.9,0,0,0-9.4,6.2,154.8,154.8,0,0,1-17.2,45.5,8,8,0,0,0,2.9,10.9,8.3,8.3,0,0,0,4,1.1,8.2,8.2,0,0,0,6.9-4,163.2,163.2,0,0,0,19-50.3A7.9,7.9,0,0,0,94.4,152.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,56a68,68,0,0,0-9,.6,8,8,0,1,0,2,15.8c2.3-.2,4.7-.4,7-.4a56,56,0,0,1,56,56,245.7,245.7,0,0,1-1.9,31,7.9,7.9,0,0,0,6.9,8.9h1a8.1,8.1,0,0,0,8-7,279.7,279.7,0,0,0,2-33A72.1,72.1,0,0,0,128,56Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.9,184.3a7.9,7.9,0,0,0-9.7,5.7c-1.5,5.7-3.2,11.4-5,17a7.9,7.9,0,0,0,5,10.1,7.8,7.8,0,0,0,2.6.4,7.9,7.9,0,0,0,7.5-5.4c2-6,3.8-12,5.4-18.1A8,8,0,0,0,185.9,184.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a191.2,191.2,0,0,1-24,93",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a191.2,191.2,0,0,1-24,93",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a191.2,191.2,0,0,1-24,93",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9f = [];
/* style */

const __vue_inject_styles__$9f = undefined;
/* scoped */

const __vue_scope_id__$9f = undefined;
/* module identifier */

const __vue_module_identifier__$9f = undefined;
/* functional template */

const __vue_is_functional_template__$9f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9f,
  staticRenderFns: __vue_staticRenderFns__$9f
}, __vue_inject_styles__$9f, __vue_script__$9f, __vue_scope_id__$9f, __vue_is_functional_template__$9f, __vue_module_identifier__$9f, false, undefined, undefined, undefined);

var script$9e = Vue.extend({
  name: "PhFingerprintSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9e = script$9e;
/* template */

var __vue_render__$9e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128a240.3,240.3,0,0,1-17.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.3,168A95.5,95.5,0,0,0,32,128,95.4,95.4,0,0,1,64,56.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,208c-2.1,4.4-4.3,8.8-6.6,13",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a189.6,189.6,0,0,1-6.1,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128a238.5,238.5,0,0,1-18,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,287.3,287.3,0,0,1-7.2,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.3,168A95.5,95.5,0,0,0,32,128,95.4,95.4,0,0,1,64,56.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,208c-2.1,4.4-4.3,8.8-6.6,13",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a189.6,189.6,0,0,1-6.1,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a8,8,0,0,0-8,8,229.3,229.3,0,0,1-17.4,88.2,8,8,0,0,0,7.4,11,7.9,7.9,0,0,0,7.4-5A246.5,246.5,0,0,0,184,128,8,8,0,0,0,176,120Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88a40.4,40.4,0,0,1,29.8,13.3,8,8,0,0,0,11.3.7,8,8,0,0,0,.6-11.3A56,56,0,0,0,72,128a136.4,136.4,0,0,1-17,65.9,8,8,0,0,0,3.1,10.8,8.1,8.1,0,0,0,3.9,1,7.9,7.9,0,0,0,7-4.1A152.2,152.2,0,0,0,88,128,40.1,40.1,0,0,1,128,88Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.3,62.4A8,8,0,1,0,58.6,50.5,104.2,104.2,0,0,0,24,128a87.6,87.6,0,0,1-8,36.7,8.1,8.1,0,0,0,3.9,10.6,8.3,8.3,0,0,0,3.4.7,7.8,7.8,0,0,0,7.2-4.7A102.4,102.4,0,0,0,40,128,88.3,88.3,0,0,1,69.3,62.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24a104.5,104.5,0,0,0-34.7,5.9,8.1,8.1,0,0,0-4.9,10.2A8,8,0,0,0,98.6,45,88.1,88.1,0,0,1,216,128a281.8,281.8,0,0,1-7,62.2,8.2,8.2,0,0,0,6.1,9.6l1.8.2a7.9,7.9,0,0,0,7.7-6.2A296.3,296.3,0,0,0,232,128,104.2,104.2,0,0,0,128,24Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.9,200.7a8.1,8.1,0,0,0-10.6,4c-1.9,4.2-4.1,8.4-6.3,12.4a8.1,8.1,0,0,0,3.1,10.9,7.8,7.8,0,0,0,3.9,1,8.1,8.1,0,0,0,7-4.1c2.4-4.4,4.7-9,6.8-13.6A8,8,0,0,0,113.9,200.7Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a8,8,0,0,0-8,8,186.5,186.5,0,0,1-5.8,46,8,8,0,0,0,5.7,9.8l2,.2a8.1,8.1,0,0,0,7.8-6,199.8,199.8,0,0,0,6.3-50A8,8,0,0,0,128,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128a240.3,240.3,0,0,1-17.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,208c-2.1,4.4-4.2,8.8-6.6,13",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a189.6,189.6,0,0,1-6.1,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128a240.3,240.3,0,0,1-17.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,208c-2,4.4-4.2,8.8-6.6,13",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a189.6,189.6,0,0,1-6.1,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128a240.3,240.3,0,0,1-17.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,208c-2,4.4-4.2,8.8-6.6,13",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128a189.6,189.6,0,0,1-6.1,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9e = [];
/* style */

const __vue_inject_styles__$9e = undefined;
/* scoped */

const __vue_scope_id__$9e = undefined;
/* module identifier */

const __vue_module_identifier__$9e = undefined;
/* functional template */

const __vue_is_functional_template__$9e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9e,
  staticRenderFns: __vue_staticRenderFns__$9e
}, __vue_inject_styles__$9e, __vue_script__$9e, __vue_scope_id__$9e, __vue_is_functional_template__$9e, __vue_module_identifier__$9e, false, undefined, undefined, undefined);

var script$9d = Vue.extend({
  name: "PhFinnTheHuman",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9d = script$9d;
/* template */

var __vue_render__$9d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "100",
      "width": "144",
      "height": "80",
      "rx": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20,64a24,24,0,0,1,48,0H188a24,24,0,0,1,48,0v88a64.1,64.1,0,0,1-64,64H84a64.1,64.1,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "140",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "140",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40a23.9,23.9,0,0,0-24,24H72a24,24,0,0,0-48,0v80a64.1,64.1,0,0,0,64,64h80a64.1,64.1,0,0,0,64-64V64A23.9,23.9,0,0,0,208,40Zm-8,104a32,32,0,0,1-32,32H88a32,32,0,0,1-32-32v-8a32,32,0,0,1,32-32h80a32,32,0,0,1,32,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "104",
      "width": "144",
      "height": "72",
      "rx": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,140a12,12,0,1,1-12-12A12,12,0,0,1,176,140ZM92,128a12,12,0,1,0,12,12A12,12,0,0,0,92,128ZM240,64v80a72.1,72.1,0,0,1-72,72H88a72.1,72.1,0,0,1-72-72V64a32,32,0,0,1,63-8h98a32,32,0,0,1,63,8Zm-40,72a32,32,0,0,0-32-32H88a32,32,0,0,0-32,32v8a32,32,0,0,0,32,32h80a32,32,0,0,0,32-32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104",
      "width": "144",
      "height": "72",
      "rx": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104",
      "width": "144",
      "height": "72",
      "rx": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "104",
      "width": "144",
      "height": "72",
      "rx": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "140",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9d = [];
/* style */

const __vue_inject_styles__$9d = undefined;
/* scoped */

const __vue_scope_id__$9d = undefined;
/* module identifier */

const __vue_module_identifier__$9d = undefined;
/* functional template */

const __vue_is_functional_template__$9d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9d,
  staticRenderFns: __vue_staticRenderFns__$9d
}, __vue_inject_styles__$9d, __vue_script__$9d, __vue_scope_id__$9d, __vue_is_functional_template__$9d, __vue_module_identifier__$9d, false, undefined, undefined, undefined);

var script$9c = Vue.extend({
  name: "PhFire",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9c = script$9c;
/* template */

var __vue_render__$9c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M171.8,144A44.1,44.1,0,0,1,136,183.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.4,148A52.2,52.2,0,0,1,136,191.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M197.1,66.6c-13-20.8-29.9-38.7-44.6-53.4a8,8,0,0,0-7-2.2,7.9,7.9,0,0,0-5.9,4.4L108.7,80.2,76.5,58.7a8.1,8.1,0,0,0-6-1.2,8,8,0,0,0-5.1,3.4C45.9,90.3,36,116.9,36,140a92,92,0,0,0,184,0C220,115.1,212.5,91.1,197.1,66.6Zm-9.8,82.6a59.6,59.6,0,0,1-50.1,50.1H136a8,8,0,0,1-1.2-15.9,44.4,44.4,0,0,0,36.7-36.7,8,8,0,1,1,15.8,2.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.4,148A52.2,52.2,0,0,1,136,191.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.4,148A52.2,52.2,0,0,1,136,191.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M179.4,148A52.2,52.2,0,0,1,136,191.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9c = [];
/* style */

const __vue_inject_styles__$9c = undefined;
/* scoped */

const __vue_scope_id__$9c = undefined;
/* module identifier */

const __vue_module_identifier__$9c = undefined;
/* functional template */

const __vue_is_functional_template__$9c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9c,
  staticRenderFns: __vue_staticRenderFns__$9c
}, __vue_inject_styles__$9c, __vue_script__$9c, __vue_scope_id__$9c, __vue_is_functional_template__$9c, __vue_module_identifier__$9c, false, undefined, undefined, undefined);

var script$9b = Vue.extend({
  name: "PhFireSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9b = script$9b;
/* template */

var __vue_render__$9b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.9,140a92,92,0,0,1-184,0c0-23.1,9.9-49.7,29.4-79.1a8,8,0,0,1,5-3.4,8.2,8.2,0,0,1,6.1,1.2l32.2,21.5,30.9-64.8a7.9,7.9,0,0,1,5.8-4.4,8.1,8.1,0,0,1,7.1,2.2c14.7,14.7,31.5,32.6,44.6,53.4C212.4,91.1,219.9,115.1,219.9,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9b = [];
/* style */

const __vue_inject_styles__$9b = undefined;
/* scoped */

const __vue_scope_id__$9b = undefined;
/* module identifier */

const __vue_module_identifier__$9b = undefined;
/* functional template */

const __vue_is_functional_template__$9b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9b,
  staticRenderFns: __vue_staticRenderFns__$9b
}, __vue_inject_styles__$9b, __vue_script__$9b, __vue_scope_id__$9b, __vue_is_functional_template__$9b, __vue_module_identifier__$9b, false, undefined, undefined, undefined);

var script$9a = Vue.extend({
  name: "PhFirstAid",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9a = script$9a;
/* template */

var __vue_render__$9a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,104v48a16,16,0,0,1-16,16H168v48a16,16,0,0,1-16,16H104a16,16,0,0,1-16-16V168H40a16,16,0,0,1-16-16V104A16,16,0,0,1,40,88H88V40a16,16,0,0,1,16-16h48a16,16,0,0,1,16,16V88h48A16,16,0,0,1,232,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9a = [];
/* style */

const __vue_inject_styles__$9a = undefined;
/* scoped */

const __vue_scope_id__$9a = undefined;
/* module identifier */

const __vue_module_identifier__$9a = undefined;
/* functional template */

const __vue_is_functional_template__$9a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9a,
  staticRenderFns: __vue_staticRenderFns__$9a
}, __vue_inject_styles__$9a, __vue_script__$9a, __vue_scope_id__$9a, __vue_is_functional_template__$9a, __vue_module_identifier__$9a, false, undefined, undefined, undefined);

var script$99 = Vue.extend({
  name: "PhFirstAidKit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$99 = script$99;
/* template */

var __vue_render__$99 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V52a16,16,0,0,0-16-16H104A16,16,0,0,0,88,52V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm60,96H136v20a8,8,0,0,1-16,0V152H100a8,8,0,0,1,0-16h20V116a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "144",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$99 = [];
/* style */

const __vue_inject_styles__$99 = undefined;
/* scoped */

const __vue_scope_id__$99 = undefined;
/* module identifier */

const __vue_module_identifier__$99 = undefined;
/* functional template */

const __vue_is_functional_template__$99 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$99 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$99,
  staticRenderFns: __vue_staticRenderFns__$99
}, __vue_inject_styles__$99, __vue_script__$99, __vue_scope_id__$99, __vue_is_functional_template__$99, __vue_module_identifier__$99, false, undefined, undefined, undefined);

var script$98 = Vue.extend({
  name: "PhFish",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$98 = script$98;
/* template */

var __vue_render__$98 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.2,153.2,12,176l52,16,16,52,22.8-50.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88.1,69.7c-14.8,17.9-25,44.4-25.9,83.5h0L8,176l56,16,16,56,22.8-54.2h0c39-.9,65.6-11.1,83.5-25.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72,17.7,17.7,0,0,1,88.1,69.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm37.7,83.5c-20.4,25.9-53.2,40.1-97.5,42.1L87.4,251.1A8.1,8.1,0,0,1,80,256h-.5a7.9,7.9,0,0,1-7.2-5.8L57.5,198.5,5.8,183.7a8,8,0,0,1-.9-15.1l49.5-20.8c2-44.3,16.1-77.1,42.1-97.5,41.1-32.4,99.4-23,116.3-19.3A15.9,15.9,0,0,1,225,43.2C228.7,60.1,238.1,118.4,205.7,159.5Zm3.7-112.9c-15.2-3.2-67.4-11.8-103,16.3A74.1,74.1,0,0,0,96,72.7,40.1,40.1,0,0,0,136,112a8,8,0,0,1,8,8,40.1,40.1,0,0,0,39.3,40,80,80,0,0,0,9.8-10.4C221.2,114,212.6,61.8,209.4,46.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$98 = [];
/* style */

const __vue_inject_styles__$98 = undefined;
/* scoped */

const __vue_scope_id__$98 = undefined;
/* module identifier */

const __vue_module_identifier__$98 = undefined;
/* functional template */

const __vue_is_functional_template__$98 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$98 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$98,
  staticRenderFns: __vue_staticRenderFns__$98
}, __vue_inject_styles__$98, __vue_script__$98, __vue_scope_id__$98, __vue_is_functional_template__$98, __vue_module_identifier__$98, false, undefined, undefined, undefined);

var script$97 = Vue.extend({
  name: "PhFishSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$97 = script$97;
/* template */

var __vue_render__$97 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.3,152A96,96,0,0,1,104,54.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,54.6C75.9,75.2,55.7,115.4,64,192h0c76.6,8.3,116.8-11.9,137.4-40h-.1A96,96,0,0,1,104,54.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.3,152A96,96,0,0,1,104,54.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm30.2,92c-26.5,26.4-68.4,37.4-125.1,32.9,1.6,11.8,3.8,24.3,6.7,37.4a7.9,7.9,0,0,1-6.1,9.5L72,248a8,8,0,0,1-7.8-6.3c-3.3-14.9-5.7-29.1-7.4-42.5-13.4-1.7-27.6-4.2-42.5-7.4a8,8,0,0,1,3.4-15.7c13.1,2.9,25.6,5.2,37.4,6.8C50.6,126.2,61.6,84.3,88,57.8c41-41,105.8-30.9,124.7-26.8A15.9,15.9,0,0,1,225,43.3C229.1,62.2,239.2,127,198.2,168ZM209.4,46.7c-15-3.3-62.3-10.9-97.3,12.1a87.9,87.9,0,0,0,85.1,85.1C220.2,108.9,212.6,61.6,209.4,46.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.3,152A96,96,0,0,1,104,54.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.3,152A96,96,0,0,1,104,54.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "156",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.3,152A96,96,0,0,1,104,54.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$97 = [];
/* style */

const __vue_inject_styles__$97 = undefined;
/* scoped */

const __vue_scope_id__$97 = undefined;
/* module identifier */

const __vue_module_identifier__$97 = undefined;
/* functional template */

const __vue_is_functional_template__$97 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$97 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$97,
  staticRenderFns: __vue_staticRenderFns__$97
}, __vue_inject_styles__$97, __vue_script__$97, __vue_scope_id__$97, __vue_is_functional_template__$97, __vue_module_identifier__$97, false, undefined, undefined, undefined);

var script$96 = Vue.extend({
  name: "PhFlag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$96 = script$96;
/* template */

var __vue_render__$96 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.6,40.8a8.2,8.2,0,0,0-8.4.8c-28.3,21.2-52.3,11-80-.9s-60.3-25.9-96,.9h-.1l-.4.3-.2.2-.3.3-.3.3-.2.3-.3.3c0,.1-.1.2-.2.3l-.2.4c0,.1-.1.2-.1.3a.8.8,0,0,0-.2.4c-.1.1-.1.2-.2.4s-.1.2-.1.3-.1.3-.1.4-.1.2-.1.3-.1.3-.1.4V47c0,.1-.1.3-.1.4V216a8,8,0,0,0,16,0V172.1c26.9-18.1,50.1-8.2,76.8,3.3,16.3,6.9,33.8,14.4,52.6,14.4,13.8,0,28.3-4,43.4-15.4A8.1,8.1,0,0,0,224,168V48A8.2,8.2,0,0,0,219.6,40.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$96 = [];
/* style */

const __vue_inject_styles__$96 = undefined;
/* scoped */

const __vue_scope_id__$96 = undefined;
/* module identifier */

const __vue_module_identifier__$96 = undefined;
/* functional template */

const __vue_is_functional_template__$96 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$96 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$96,
  staticRenderFns: __vue_staticRenderFns__$96
}, __vue_inject_styles__$96, __vue_script__$96, __vue_scope_id__$96, __vue_is_functional_template__$96, __vue_module_identifier__$96, false, undefined, undefined, undefined);

var script$95 = Vue.extend({
  name: "PhFlagBanner",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$95 = script$95;
/* template */

var __vue_render__$95 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "40 48 40 48 224 48 176 108 224 168 40 168 40 48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.2,163a8,8,0,0,1-6.2,13H48v40a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8H224a8,8,0,0,1,6.2,13l-44,55Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$95 = [];
/* style */

const __vue_inject_styles__$95 = undefined;
/* scoped */

const __vue_scope_id__$95 = undefined;
/* module identifier */

const __vue_module_identifier__$95 = undefined;
/* functional template */

const __vue_is_functional_template__$95 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$95 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$95,
  staticRenderFns: __vue_staticRenderFns__$95
}, __vue_inject_styles__$95, __vue_script__$95, __vue_scope_id__$95, __vue_is_functional_template__$95, __vue_module_identifier__$95, false, undefined, undefined, undefined);

var script$94 = Vue.extend({
  name: "PhFlagCheckered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$94 = script$94;
/* template */

var __vue_render__$94 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,106.1c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "37.4",
      "x2": "100",
      "y2": "157.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "58.6",
      "x2": "156",
      "y2": "178.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M40,106.1c21.4-16,41-16,60-10.6V37.4C81,32,61.4,32,40,48Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M156,58.6C175,64,194.6,64,216,48v58.1c-21.4,16.1-41,16-60,10.7Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M156,116.8c-18.9-5.4-37.1-15.9-56-21.3v61.9c18.9,5.3,37.1,15.9,56,21.2Z"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,106.1c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "37.4",
      "x2": "100",
      "y2": "157.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "58.6",
      "x2": "156",
      "y2": "178.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.6,40.8a8.2,8.2,0,0,0-8.4.8c-28.3,21.2-52.3,11-80-.9s-60.3-25.9-96,.9A8,8,0,0,0,32,48h0V216a8,8,0,0,0,16,0V172.1c26.9-18.1,50.1-8.2,76.8,3.3,16.3,6.9,33.8,14.4,52.6,14.4,13.8,0,28.3-4,43.4-15.4A8.1,8.1,0,0,0,224,168V48A8.2,8.2,0,0,0,219.6,40.8ZM156,170.3V116.8c-18.9-5.4-37.1-15.9-56-21.3v53.6c-16.3-4.2-33.6-4.8-52,4.5V100.8c18.3-10.6,35.4-10,52-5.3V45.7a243.3,243.3,0,0,1,24.8,9.7c10,4.2,20.4,8.7,31.2,11.5v49.9c16.6,4.7,33.7,5.3,52-5.3v52.4C189.7,176.2,173.1,175.6,156,170.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,106.1c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "37.4",
      "x2": "100",
      "y2": "157.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "58.6",
      "x2": "156",
      "y2": "178.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,106.1c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "37.4",
      "x2": "100",
      "y2": "157.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "58.6",
      "x2": "156",
      "y2": "178.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "40",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,106.1c-64,48-112-48-176,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "37.4",
      "x2": "100",
      "y2": "157.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "58.6",
      "x2": "156",
      "y2": "178.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$94 = [];
/* style */

const __vue_inject_styles__$94 = undefined;
/* scoped */

const __vue_scope_id__$94 = undefined;
/* module identifier */

const __vue_module_identifier__$94 = undefined;
/* functional template */

const __vue_is_functional_template__$94 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$94 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$94,
  staticRenderFns: __vue_staticRenderFns__$94
}, __vue_inject_styles__$94, __vue_script__$94, __vue_scope_id__$94, __vue_is_functional_template__$94, __vue_module_identifier__$94, false, undefined, undefined, undefined);

var script$93 = Vue.extend({
  name: "PhFlame",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$93 = script$93;
/* template */

var __vue_render__$93 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S48,72,48,144a79.9,79.9,0,0,0,77.9,79.9A39.9,39.9,0,0,1,88,184c0-40,40-64,40-64s40,24,40,64a39.9,39.9,0,0,1-37.9,39.9A79.9,79.9,0,0,0,208,144C208,72,128,24,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M173.8,51.5a221.5,221.5,0,0,0-41.7-34.4,8,8,0,0,0-8.2,0A221.5,221.5,0,0,0,82.2,51.5C54.6,80.5,40,112.5,40,144a88,88,0,0,0,176,0C216,112.5,201.4,80.5,173.8,51.5ZM96,184c0-27.7,22.5-47.3,32-54.3,9.5,7,32,26.6,32,54.3a32,32,0,0,1-64,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$93 = [];
/* style */

const __vue_inject_styles__$93 = undefined;
/* scoped */

const __vue_scope_id__$93 = undefined;
/* module identifier */

const __vue_module_identifier__$93 = undefined;
/* functional template */

const __vue_is_functional_template__$93 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$93 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$93,
  staticRenderFns: __vue_staticRenderFns__$93
}, __vue_inject_styles__$93, __vue_script__$93, __vue_scope_id__$93, __vue_is_functional_template__$93, __vue_module_identifier__$93, false, undefined, undefined, undefined);

var script$92 = Vue.extend({
  name: "PhFlashlight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$92 = script$92;
/* template */

var __vue_render__$92 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V64H192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,16H72A16,16,0,0,0,56,32V77.3a15.6,15.6,0,0,0,3.2,9.6L80,114.7V224a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V114.7l20.8-27.8a15.6,15.6,0,0,0,3.2-9.6V32A16,16,0,0,0,184,16ZM136,152a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0ZM72,56V32H184V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$92 = [];
/* style */

const __vue_inject_styles__$92 = undefined;
/* scoped */

const __vue_scope_id__$92 = undefined;
/* module identifier */

const __vue_module_identifier__$92 = undefined;
/* functional template */

const __vue_is_functional_template__$92 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$92 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$92,
  staticRenderFns: __vue_staticRenderFns__$92
}, __vue_inject_styles__$92, __vue_script__$92, __vue_scope_id__$92, __vue_is_functional_template__$92, __vue_module_identifier__$92, false, undefined, undefined, undefined);

var script$91 = Vue.extend({
  name: "PhFlask",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$91 = script$91;
/* template */

var __vue_render__$91 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165,39.3,203.9A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-20.8-34.8h0c-11.4,9.7-32.2,16.8-67.9-1.1-33.3-16.6-53.6-11.7-65.4-3Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.6,199.8,160,93.8V40h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V93.8L55.8,160.7c0,.1-.1.2-.1.3L32.4,199.8A16,16,0,0,0,46.1,224H209.9a16,16,0,0,0,13.7-24.2ZM109.7,102a15.9,15.9,0,0,0,2.3-8.2V40h32V93.8a15.9,15.9,0,0,0,2.3,8.2l38.8,64.8c-13.1,7.1-31.4,5.1-53.5-6-14.3-7.1-32.7-13.5-50.3-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "168",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$91 = [];
/* style */

const __vue_inject_styles__$91 = undefined;
/* scoped */

const __vue_scope_id__$91 = undefined;
/* module identifier */

const __vue_module_identifier__$91 = undefined;
/* functional template */

const __vue_is_functional_template__$91 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$91 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$91,
  staticRenderFns: __vue_staticRenderFns__$91
}, __vue_inject_styles__$91, __vue_script__$91, __vue_scope_id__$91, __vue_is_functional_template__$91, __vue_module_identifier__$91, false, undefined, undefined, undefined);

var script$90 = Vue.extend({
  name: "PhFloppyDisk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$90 = script$90;
/* template */

var __vue_render__$90 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "96",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64h32a8,8,0,0,0,8-8V91.3a7.9,7.9,0,0,0-2.3-5.6L170.3,42.3a7.9,7.9,0,0,0-5.6-2.3H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.3,80,176,36.7A15.9,15.9,0,0,0,164.7,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V91.3A15.9,15.9,0,0,0,219.3,80ZM208,91.3V208H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H164.7L208,91.3ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "96",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$90 = [];
/* style */

const __vue_inject_styles__$90 = undefined;
/* scoped */

const __vue_scope_id__$90 = undefined;
/* module identifier */

const __vue_module_identifier__$90 = undefined;
/* functional template */

const __vue_is_functional_template__$90 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$90 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$90,
  staticRenderFns: __vue_staticRenderFns__$90
}, __vue_inject_styles__$90, __vue_script__$90, __vue_scope_id__$90, __vue_is_functional_template__$90, __vue_module_identifier__$90, false, undefined, undefined, undefined);

var script$8$ = Vue.extend({
  name: "PhFloppyDiskBack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8$ = script$8$;
/* template */

var __vue_render__$8$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 80 160 80 160 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM128,176a28,28,0,1,1,28-28A28,28,0,0,1,128,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80 160 80 160 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H172a4,4,0,0,0-4,4V80a8,8,0,0,1-8,8H96.3A8.2,8.2,0,0,1,88,80.5,8,8,0,0,1,96,72h56V36a4,4,0,0,0-4-4H91.3A15.9,15.9,0,0,0,80,36.7L36.7,80A15.9,15.9,0,0,0,32,91.3V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,176a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80 160 80 160 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80 160 80 160 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 80 160 80 160 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8$ = [];
/* style */

const __vue_inject_styles__$8$ = undefined;
/* scoped */

const __vue_scope_id__$8$ = undefined;
/* module identifier */

const __vue_module_identifier__$8$ = undefined;
/* functional template */

const __vue_is_functional_template__$8$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8$,
  staticRenderFns: __vue_staticRenderFns__$8$
}, __vue_inject_styles__$8$, __vue_script__$8$, __vue_scope_id__$8$, __vue_is_functional_template__$8$, __vue_module_identifier__$8$, false, undefined, undefined, undefined);

var script$8_ = Vue.extend({
  name: "PhFlowArrow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8_ = script$8_;
/* template */

var __vue_render__$8_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.7,85.7l-40,40a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L220.7,88H176a40,40,0,0,0-40,40,56,56,0,0,1-56,56h-.9a36,36,0,1,1,0-16H80a40,40,0,0,0,40-40,56,56,0,0,1,56-56h44.7L194.3,45.7a8.1,8.1,0,0,1,11.4-11.4l40,40A8.1,8.1,0,0,1,245.7,85.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "44",
      "cy": "176",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 40 240 80 200 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8_ = [];
/* style */

const __vue_inject_styles__$8_ = undefined;
/* scoped */

const __vue_scope_id__$8_ = undefined;
/* module identifier */

const __vue_module_identifier__$8_ = undefined;
/* functional template */

const __vue_is_functional_template__$8_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8_,
  staticRenderFns: __vue_staticRenderFns__$8_
}, __vue_inject_styles__$8_, __vue_script__$8_, __vue_scope_id__$8_, __vue_is_functional_template__$8_, __vue_module_identifier__$8_, false, undefined, undefined, undefined);

var script$8Z = Vue.extend({
  name: "PhFlower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Z = script$8Z;
/* template */

var __vue_render__$8Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M115,103.2a28,28,0,0,1,26,0h0c7.3-15.4,15-34.6,15-47.2a28,28,0,0,0-56,0c0,12.6,7.7,31.8,15,47.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8a27.8,27.8,0,0,1,3.8-12.8,26.5,26.5,0,0,1,9.2-9.6h0C103.3,90.3,90.5,74,79.6,67.8a28,28,0,0,0-28,48.4c10.9,6.3,31.4,9.3,48.4,10.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6a26.5,26.5,0,0,1-9.2-9.6,27.8,27.8,0,0,1-3.8-12.8h0c-17,1.3-37.5,4.3-48.4,10.6a28,28,0,1,0,28,48.4c10.9-6.2,23.7-22.5,33.4-36.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8a28,28,0,0,1-26,0h0c-7.3,15.4-15,34.6-15,47.2a28,28,0,0,0,56,0c0-12.6-7.7-31.8-15-47.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2a27.8,27.8,0,0,1-3.8,12.8,26.5,26.5,0,0,1-9.2,9.6h0c9.7,14.1,22.5,30.4,33.4,36.6a28,28,0,0,0,28-48.4c-10.9-6.3-31.4-9.3-48.4-10.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4a26.5,26.5,0,0,1,9.2,9.6,27.8,27.8,0,0,1,3.8,12.8h0c17-1.3,37.5-4.3,48.4-10.6a28,28,0,0,0-28-48.4C165.5,74,152.7,90.3,143,104.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.4,132.8a56.9,56.9,0,0,0-11.5-4.8,56.9,56.9,0,0,0,11.5-4.8,36,36,0,0,0-36-62.4,58.7,58.7,0,0,0-9.9,7.5A58.6,58.6,0,0,0,164,56a36,36,0,0,0-72,0,58.6,58.6,0,0,0,1.5,12.3,58.7,58.7,0,0,0-9.9-7.5,36,36,0,0,0-36,62.4A56.9,56.9,0,0,0,59.1,128a56.9,56.9,0,0,0-11.5,4.8,36,36,0,0,0,36,62.4,58.7,58.7,0,0,0,9.9-7.5A58.6,58.6,0,0,0,92,200a36,36,0,0,0,72,0,58.6,58.6,0,0,0-1.5-12.3,58.7,58.7,0,0,0,9.9,7.5,36,36,0,0,0,36-62.4ZM128,152a24,24,0,1,1,24-24A24.1,24.1,0,0,1,128,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Z = [];
/* style */

const __vue_inject_styles__$8Z = undefined;
/* scoped */

const __vue_scope_id__$8Z = undefined;
/* module identifier */

const __vue_module_identifier__$8Z = undefined;
/* functional template */

const __vue_is_functional_template__$8Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Z,
  staticRenderFns: __vue_staticRenderFns__$8Z
}, __vue_inject_styles__$8Z, __vue_script__$8Z, __vue_scope_id__$8Z, __vue_is_functional_template__$8Z, __vue_module_identifier__$8Z, false, undefined, undefined, undefined);

var script$8Y = Vue.extend({
  name: "PhFlowerLotus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Y = script$8Y;
/* template */

var __vue_render__$8Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c16,0,41.8-.2,72.3-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-19.8-3.6-35.8.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.8,121.7c-16-3.7-28.5-2-35.8-.1a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200s-40-21.8-40-80a106,106,0,0,1,6.1-36.6h0A77.5,77.5,0,0,0,62.8,68.3a7.9,7.9,0,0,0-9.3,5.3c-2.9,8.7-6.3,26,.4,48.2h0c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80a106,106,0,0,0-6.1-36.6h0a77.5,77.5,0,0,1,31.3-15.1,7.9,7.9,0,0,1,9.3,5.3c2.9,8.7,6.3,26-.4,48.2h0c16.4-3.8,29.2-2.1,36.5-.2a7.9,7.9,0,0,1,5.7,9.8c-3.1,11.3-13,33.3-43.4,50.8S144,200,128,200",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M250.5,121.3a15.9,15.9,0,0,0-9.9-7.5,77.1,77.1,0,0,0-27.9-1.8,86.7,86.7,0,0,0-2.6-40.9,15.9,15.9,0,0,0-18.5-10.7,82.3,82.3,0,0,0-26.2,10.8,94.4,94.4,0,0,0-27.8-34.4,15.9,15.9,0,0,0-19.2,0A94.4,94.4,0,0,0,90.6,71.2,82.3,82.3,0,0,0,64.4,60.4,15.9,15.9,0,0,0,45.9,71.1,86.7,86.7,0,0,0,43.3,112a77.1,77.1,0,0,0-27.9,1.8A15.9,15.9,0,0,0,4,133.6c3.5,12.6,14.3,36.7,47.1,55.6S112.5,208,127.9,208h.2c15.4,0,44.2,0,76.8-18.8s43.6-43,47.1-55.6A16,16,0,0,0,250.5,121.3ZM128,49.6c9.6,7.2,32,28.4,32,70.4s-22.4,63.2-32,70.4h0c-9.6-7.2-32-28.4-32-70.4S118.4,56.8,128,49.6ZM19.3,129.3c6.2-1.6,15.9-2.8,28.4-.6a117.1,117.1,0,0,0,9.7,20.9,137.9,137.9,0,0,0,33.2,38.6,123.4,123.4,0,0,1-31.5-12.9C31.3,159.2,22.3,139.5,19.3,129.3Zm177.6,46a123.4,123.4,0,0,1-31.5,12.9,137.9,137.9,0,0,0,33.2-38.6,117.1,117.1,0,0,0,9.7-20.9,68.8,68.8,0,0,1,28.3.5C233.7,139.5,224.7,159.2,196.9,175.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Y = [];
/* style */

const __vue_inject_styles__$8Y = undefined;
/* scoped */

const __vue_scope_id__$8Y = undefined;
/* module identifier */

const __vue_module_identifier__$8Y = undefined;
/* functional template */

const __vue_is_functional_template__$8Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Y,
  staticRenderFns: __vue_staticRenderFns__$8Y
}, __vue_inject_styles__$8Y, __vue_script__$8Y, __vue_scope_id__$8Y, __vue_is_functional_template__$8Y, __vue_module_identifier__$8Y, false, undefined, undefined, undefined);

var script$8X = Vue.extend({
  name: "PhFlyingSaucer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8X = script$8X;
/* template */

var __vue_render__$8X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "170.2",
      "y1": "197",
      "x2": "172.7",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.8",
      "y1": "197",
      "x2": "83.3",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M177,68.8h0A56.7,56.7,0,0,1,184,96v3.9a15.8,15.8,0,0,1-12.4,15.5A191.4,191.4,0,0,1,128,120a191.4,191.4,0,0,1-43.6-4.6A15.8,15.8,0,0,1,72,99.9V96.8a56.8,56.8,0,0,1,7.4-28h0C41.9,76.5,16,93,16,112c0,26.5,50.1,48,112,48s112-21.5,112-48C240,93,214.3,76.6,177,68.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168.8",
      "y1": "188.7",
      "x2": "172.7",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.2",
      "y1": "188.7",
      "x2": "83.3",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180.6,211a8.1,8.1,0,0,1-6.6,9.2h-1.3a8.1,8.1,0,0,1-7.9-6.7l-3.9-23.5a8,8,0,0,1,15.8-2.7ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184Zm-39.5-3.1a7.9,7.9,0,0,0-9.2,6.5L75.4,211a8.1,8.1,0,0,0,6.6,9.2h1.3a8.1,8.1,0,0,0,7.9-6.7l3.9-23.5A8,8,0,0,0,88.5,180.9ZM248,112c0,16.2-13.4,30.9-37.7,41.3C188.2,162.8,159,168,128,168s-60.2-5.2-82.3-14.7C21.4,142.9,8,128.2,8,112c0-8.4,3.7-20.8,21.2-32.5,11.3-7.6,26.9-13.8,45.2-17.9A63.6,63.6,0,0,1,173,50.5a64.7,64.7,0,0,1,9.1,11.2C223.4,71.1,248,89.7,248,112ZM80,96.8v3.1a7.8,7.8,0,0,0,6.1,7.7A189.1,189.1,0,0,0,128,112a189.1,189.1,0,0,0,41.9-4.4,7.8,7.8,0,0,0,6.1-7.7V96a47.5,47.5,0,0,0-6.1-23.4h0a51.7,51.7,0,0,0-8.2-10.7A47.4,47.4,0,0,0,127.4,48C101.2,48.3,80,70.2,80,96.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168.8",
      "y1": "188.7",
      "x2": "172.7",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.2",
      "y1": "188.7",
      "x2": "83.3",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168.8",
      "y1": "188.7",
      "x2": "172.7",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.2",
      "y1": "188.7",
      "x2": "83.3",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168.8",
      "y1": "188.7",
      "x2": "172.7",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "87.2",
      "y1": "188.7",
      "x2": "83.3",
      "y2": "212.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8X = [];
/* style */

const __vue_inject_styles__$8X = undefined;
/* scoped */

const __vue_scope_id__$8X = undefined;
/* module identifier */

const __vue_module_identifier__$8X = undefined;
/* functional template */

const __vue_is_functional_template__$8X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8X,
  staticRenderFns: __vue_staticRenderFns__$8X
}, __vue_inject_styles__$8X, __vue_script__$8X, __vue_scope_id__$8X, __vue_is_functional_template__$8X, __vue_module_identifier__$8X, false, undefined, undefined, undefined);

var script$8W = Vue.extend({
  name: "PhFolder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8W = script$8W;
/* template */

var __vue_render__$8W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8W = [];
/* style */

const __vue_inject_styles__$8W = undefined;
/* scoped */

const __vue_scope_id__$8W = undefined;
/* module identifier */

const __vue_module_identifier__$8W = undefined;
/* functional template */

const __vue_is_functional_template__$8W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8W,
  staticRenderFns: __vue_staticRenderFns__$8W
}, __vue_inject_styles__$8W, __vue_script__$8W, __vue_scope_id__$8W, __vue_is_functional_template__$8W, __vue_module_identifier__$8W, false, undefined, undefined, undefined);

var script$8V = Vue.extend({
  name: "PhFolderDotted",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8V = script$8V;
/* template */

var __vue_render__$8V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,208a8,8,0,0,1-8,8H39.4A15.4,15.4,0,0,1,24,200.6V192a8,8,0,0,1,16,0v8H88A8,8,0,0,1,96,208Zm64-8H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.9A15.2,15.2,0,0,0,232,200.9V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM32,88h96a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V80A8,8,0,0,0,32,88Zm0,72a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8V = [];
/* style */

const __vue_inject_styles__$8V = undefined;
/* scoped */

const __vue_scope_id__$8V = undefined;
/* module identifier */

const __vue_module_identifier__$8V = undefined;
/* functional template */

const __vue_is_functional_template__$8V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8V,
  staticRenderFns: __vue_staticRenderFns__$8V
}, __vue_inject_styles__$8V, __vue_script__$8V, __vue_scope_id__$8V, __vue_is_functional_template__$8V, __vue_module_identifier__$8V, false, undefined, undefined, undefined);

var script$8U = Vue.extend({
  name: "PhFolderLock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8U = script$8U;
/* template */

var __vue_render__$8U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V148a20,20,0,0,1,40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,156h-8v-4a28,28,0,0,0-56,0v4h-8a8,8,0,0,0-8,8v44a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V164A8,8,0,0,0,224,156Zm-48-4a12,12,0,0,1,24,0v4H176Zm40-80H131.3L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216h73.2a8,8,0,1,0,0-16H40V88H216v16a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM92.7,56l16,16H40V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8U = [];
/* style */

const __vue_inject_styles__$8U = undefined;
/* scoped */

const __vue_scope_id__$8U = undefined;
/* module identifier */

const __vue_module_identifier__$8U = undefined;
/* functional template */

const __vue_is_functional_template__$8U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8U,
  staticRenderFns: __vue_staticRenderFns__$8U
}, __vue_inject_styles__$8U, __vue_script__$8U, __vue_scope_id__$8U, __vue_is_functional_template__$8U, __vue_module_identifier__$8U, false, undefined, undefined, undefined);

var script$8T = Vue.extend({
  name: "PhFolderMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8T = script$8T;
/* template */

var __vue_render__$8T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V52a8,8,0,0,1,8-8H92.4a8,8,0,0,1,6,2.7L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Zm112,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8T = [];
/* style */

const __vue_inject_styles__$8T = undefined;
/* scoped */

const __vue_scope_id__$8T = undefined;
/* module identifier */

const __vue_module_identifier__$8T = undefined;
/* functional template */

const __vue_is_functional_template__$8T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8T,
  staticRenderFns: __vue_staticRenderFns__$8T
}, __vue_inject_styles__$8T, __vue_script__$8T, __vue_scope_id__$8T, __vue_is_functional_template__$8T, __vue_module_identifier__$8T, false, undefined, undefined, undefined);

var script$8S = Vue.extend({
  name: "PhFolderNotch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8S = script$8S;
/* template */

var __vue_render__$8S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,64H93.3l21.4,16L93.3,96H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8S = [];
/* style */

const __vue_inject_styles__$8S = undefined;
/* scoped */

const __vue_scope_id__$8S = undefined;
/* module identifier */

const __vue_module_identifier__$8S = undefined;
/* functional template */

const __vue_is_functional_template__$8S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8S,
  staticRenderFns: __vue_staticRenderFns__$8S
}, __vue_inject_styles__$8S, __vue_script__$8S, __vue_scope_id__$8S, __vue_is_functional_template__$8S, __vue_module_identifier__$8S, false, undefined, undefined, undefined);

var script$8R = Vue.extend({
  name: "PhFolderNotchMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8R = script$8R;
/* template */

var __vue_render__$8R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,96V64H93.3l21.4,16L93.3,96Zm112,60H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8R = [];
/* style */

const __vue_inject_styles__$8R = undefined;
/* scoped */

const __vue_scope_id__$8R = undefined;
/* module identifier */

const __vue_module_identifier__$8R = undefined;
/* functional template */

const __vue_is_functional_template__$8R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8R,
  staticRenderFns: __vue_staticRenderFns__$8R
}, __vue_inject_styles__$8R, __vue_script__$8R, __vue_scope_id__$8R, __vue_is_functional_template__$8R, __vue_module_identifier__$8R, false, undefined, undefined, undefined);

var script$8Q = Vue.extend({
  name: "PhFolderNotchOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8Q = script$8Q;
/* template */

var __vue_render__$8Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l29.9-71.1a8.1,8.1,0,0,1,7.4-4.9h48.3a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.3a8,8,0,0,1,7.6,10.6L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.4,128h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3H208V88a8,8,0,0,0-8-8H130.7a8.1,8.1,0,0,1-4.8-1.6L98.1,57.6A8.1,8.1,0,0,0,93.3,56H40a8,8,0,0,0-8,8V208l30-75A7.9,7.9,0,0,1,69.4,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.9,110.6a16.2,16.2,0,0,0-13-6.6H216V88a16,16,0,0,0-16-16H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V208h0a8.2,8.2,0,0,0,1.4,4.5A7.9,7.9,0,0,0,32,216H208a8,8,0,0,0,7.6-5.5l28.5-85.4A16.3,16.3,0,0,0,241.9,110.6ZM93.3,64l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H200v16H146.4a16,16,0,0,0-8.9,2.7L117.6,120H69.4a15.7,15.7,0,0,0-14.8,10.1L40,166.5V64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8Q = [];
/* style */

const __vue_inject_styles__$8Q = undefined;
/* scoped */

const __vue_scope_id__$8Q = undefined;
/* module identifier */

const __vue_module_identifier__$8Q = undefined;
/* functional template */

const __vue_is_functional_template__$8Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8Q,
  staticRenderFns: __vue_staticRenderFns__$8Q
}, __vue_inject_styles__$8Q, __vue_script__$8Q, __vue_scope_id__$8Q, __vue_is_functional_template__$8Q, __vue_module_identifier__$8Q, false, undefined, undefined, undefined);

var script$8P = Vue.extend({
  name: "PhFolderNotchPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8P = script$8P;
/* template */

var __vue_render__$8P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,96V64H93.3l21.4,16L93.3,96Zm112,60H136v16a8,8,0,0,1-16,0V156H104a8,8,0,0,1,0-16h16V124a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "152",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8P = [];
/* style */

const __vue_inject_styles__$8P = undefined;
/* scoped */

const __vue_scope_id__$8P = undefined;
/* module identifier */

const __vue_module_identifier__$8P = undefined;
/* functional template */

const __vue_is_functional_template__$8P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8P,
  staticRenderFns: __vue_staticRenderFns__$8P
}, __vue_inject_styles__$8P, __vue_script__$8P, __vue_scope_id__$8P, __vue_is_functional_template__$8P, __vue_module_identifier__$8P, false, undefined, undefined, undefined);

var script$8O = Vue.extend({
  name: "PhFolderOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8O = script$8O;
/* template */

var __vue_render__$8O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.1-86.6a8.2,8.2,0,0,1,7.6-5.4h159a8,8,0,0,1,7.6,10.6L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H208V88a8,8,0,0,0-8-8H130.7a8.1,8.1,0,0,1-4.8-1.6L98.1,57.6A8.1,8.1,0,0,0,93.3,56H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.9,110.6a16.2,16.2,0,0,0-13-6.6H216V88a16,16,0,0,0-16-16H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V208h0a7.9,7.9,0,0,0,8,8H208a8,8,0,0,0,7.6-5.5l28.5-85.4A16.3,16.3,0,0,0,241.9,110.6ZM93.3,64l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H200v16H69.8a16,16,0,0,0-15.2,10.9L40,158.7V64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8O = [];
/* style */

const __vue_inject_styles__$8O = undefined;
/* scoped */

const __vue_scope_id__$8O = undefined;
/* module identifier */

const __vue_module_identifier__$8O = undefined;
/* functional template */

const __vue_is_functional_template__$8O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8O,
  staticRenderFns: __vue_staticRenderFns__$8O
}, __vue_inject_styles__$8O, __vue_script__$8O, __vue_scope_id__$8O, __vue_is_functional_template__$8O, __vue_module_identifier__$8O, false, undefined, undefined, undefined);

var script$8N = Vue.extend({
  name: "PhFolderPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8N = script$8N;
/* template */

var __vue_render__$8N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V52a8,8,0,0,1,8-8H92.4a8,8,0,0,1,6,2.7L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8N = [];
/* style */

const __vue_inject_styles__$8N = undefined;
/* scoped */

const __vue_scope_id__$8N = undefined;
/* module identifier */

const __vue_module_identifier__$8N = undefined;
/* functional template */

const __vue_is_functional_template__$8N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8N,
  staticRenderFns: __vue_staticRenderFns__$8N
}, __vue_inject_styles__$8N, __vue_script__$8N, __vue_scope_id__$8N, __vue_is_functional_template__$8N, __vue_module_identifier__$8N, false, undefined, undefined, undefined);

var script$8M = Vue.extend({
  name: "PhFolderSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8M = script$8M;
/* template */

var __vue_render__$8M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8M = [];
/* style */

const __vue_inject_styles__$8M = undefined;
/* scoped */

const __vue_scope_id__$8M = undefined;
/* module identifier */

const __vue_module_identifier__$8M = undefined;
/* functional template */

const __vue_is_functional_template__$8M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8M,
  staticRenderFns: __vue_staticRenderFns__$8M
}, __vue_inject_styles__$8M, __vue_script__$8M, __vue_scope_id__$8M, __vue_is_functional_template__$8M, __vue_module_identifier__$8M, false, undefined, undefined, undefined);

var script$8L = Vue.extend({
  name: "PhFolderSimpleDotted",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8L = script$8L;
/* template */

var __vue_render__$8L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,80V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2l29.9,22.4A8,8,0,0,1,128,88a7.7,7.7,0,0,1-4.8-1.6L93.3,64H40V80a8,8,0,0,1-16,0ZM88,200H40v-8a8,8,0,0,0-16,0v8.6A15.4,15.4,0,0,0,39.4,216H88a8,8,0,0,0,0-16Zm72,0H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.9A15.2,15.2,0,0,0,232,200.9V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM32,160a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,80h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "120",
      "x2": "32",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8L = [];
/* style */

const __vue_inject_styles__$8L = undefined;
/* scoped */

const __vue_scope_id__$8L = undefined;
/* module identifier */

const __vue_module_identifier__$8L = undefined;
/* functional template */

const __vue_is_functional_template__$8L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8L,
  staticRenderFns: __vue_staticRenderFns__$8L
}, __vue_inject_styles__$8L, __vue_script__$8L, __vue_scope_id__$8L, __vue_is_functional_template__$8L, __vue_module_identifier__$8L, false, undefined, undefined, undefined);

var script$8K = Vue.extend({
  name: "PhFolderSimpleLock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8K = script$8K;
/* template */

var __vue_render__$8K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V148a20,20,0,0,1,40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,88v16a8,8,0,0,1-16,0V88H130.7a15.6,15.6,0,0,1-9.6-3.2L93.3,64H40V200h72a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2L130.7,72H216A16,16,0,0,1,232,88Zm0,76v44a8,8,0,0,1-8,8H152a8,8,0,0,1-8-8V164a8,8,0,0,1,8-8h8v-4a28,28,0,0,1,56,0v4h8A8,8,0,0,1,232,164Zm-32-12a12,12,0,0,0-24,0v4h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "152",
      "y": "164",
      "width": "72",
      "height": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,164V152a20,20,0,0,1,40,0v12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8K = [];
/* style */

const __vue_inject_styles__$8K = undefined;
/* scoped */

const __vue_scope_id__$8K = undefined;
/* module identifier */

const __vue_module_identifier__$8K = undefined;
/* functional template */

const __vue_is_functional_template__$8K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8K,
  staticRenderFns: __vue_staticRenderFns__$8K
}, __vue_inject_styles__$8K, __vue_script__$8K, __vue_scope_id__$8K, __vue_is_functional_template__$8K, __vue_module_identifier__$8K, false, undefined, undefined, undefined);

var script$8J = Vue.extend({
  name: "PhFolderSimpleMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8J = script$8J;
/* template */

var __vue_render__$8J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Zm-64,80H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8J = [];
/* style */

const __vue_inject_styles__$8J = undefined;
/* scoped */

const __vue_scope_id__$8J = undefined;
/* module identifier */

const __vue_module_identifier__$8J = undefined;
/* functional template */

const __vue_is_functional_template__$8J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8J,
  staticRenderFns: __vue_staticRenderFns__$8J
}, __vue_inject_styles__$8J, __vue_script__$8J, __vue_scope_id__$8J, __vue_is_functional_template__$8J, __vue_module_identifier__$8J, false, undefined, undefined, undefined);

var script$8I = Vue.extend({
  name: "PhFolderSimplePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8I = script$8I;
/* template */

var __vue_render__$8I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Zm-64,80H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8I = [];
/* style */

const __vue_inject_styles__$8I = undefined;
/* scoped */

const __vue_scope_id__$8I = undefined;
/* module identifier */

const __vue_module_identifier__$8I = undefined;
/* functional template */

const __vue_is_functional_template__$8I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8I,
  staticRenderFns: __vue_staticRenderFns__$8I
}, __vue_inject_styles__$8I, __vue_script__$8I, __vue_scope_id__$8I, __vue_is_functional_template__$8I, __vue_module_identifier__$8I, false, undefined, undefined, undefined);

var script$8H = Vue.extend({
  name: "PhFolderSimpleStar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8H = script$8H;
/* template */

var __vue_render__$8H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V200h80a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2L130.7,72H216a16,16,0,0,1,16,16v32a8,8,0,0,1-16,0V88H130.7a15.6,15.6,0,0,1-9.6-3.2L93.3,64Zm203.6,95.2a8.1,8.1,0,0,0-7-5.6l-29.8-2.3-11.5-26.5a8,8,0,0,0-14.6,0l-11.5,26.5-29.8,2.3a8.1,8.1,0,0,0-4.5,14.2l22.5,18.6-6.8,27.7a7.9,7.9,0,0,0,3,8.3,8,8,0,0,0,8.8.5L188,207.8l25.6,15.1a8.7,8.7,0,0,0,4.1,1.1,7.4,7.4,0,0,0,4.7-1.6,7.9,7.9,0,0,0,3-8.3l-6.8-27.7,22.5-18.6A8,8,0,0,0,243.6,159.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8H = [];
/* style */

const __vue_inject_styles__$8H = undefined;
/* scoped */

const __vue_scope_id__$8H = undefined;
/* module identifier */

const __vue_module_identifier__$8H = undefined;
/* functional template */

const __vue_is_functional_template__$8H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8H,
  staticRenderFns: __vue_staticRenderFns__$8H
}, __vue_inject_styles__$8H, __vue_script__$8H, __vue_scope_id__$8H, __vue_is_functional_template__$8H, __vue_module_identifier__$8H, false, undefined, undefined, undefined);

var script$8G = Vue.extend({
  name: "PhFolderSimpleUser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8G = script$8G;
/* template */

var __vue_render__$8G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.7,218a8,8,0,0,1-7.7,10H157a8,8,0,0,1-7.7-10,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,226.7,218ZM216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16h80a8,8,0,0,0,0-16H40V64H93.3l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H216v32a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8G = [];
/* style */

const __vue_inject_styles__$8G = undefined;
/* scoped */

const __vue_scope_id__$8G = undefined;
/* module identifier */

const __vue_module_identifier__$8G = undefined;
/* functional template */

const __vue_is_functional_template__$8G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8G,
  staticRenderFns: __vue_staticRenderFns__$8G
}, __vue_inject_styles__$8G, __vue_script__$8G, __vue_scope_id__$8G, __vue_is_functional_template__$8G, __vue_module_identifier__$8G, false, undefined, undefined, undefined);

var script$8F = Vue.extend({
  name: "PhFolderStar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8F = script$8F;
/* template */

var __vue_render__$8F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.6,200H40V88H216v32a8,8,0,0,0,16,0V88a16,16,0,0,0-16-16H131.3L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216h81.2a8,8,0,1,0,0-16ZM92.7,56l16,16H40V56ZM241.1,167.8l-22.5,18.6,6.8,27.7a7.9,7.9,0,0,1-3,8.3,7.4,7.4,0,0,1-4.7,1.6,8.7,8.7,0,0,1-4.1-1.1L188,207.8l-25.6,15.1a8,8,0,0,1-8.8-.5,7.9,7.9,0,0,1-3-8.3l6.8-27.7-22.5-18.6a8.1,8.1,0,0,1,4.5-14.2l29.8-2.3,11.5-26.5a8,8,0,0,1,14.6,0l11.5,26.5,29.8,2.3a8.1,8.1,0,0,1,4.5,14.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8F = [];
/* style */

const __vue_inject_styles__$8F = undefined;
/* scoped */

const __vue_scope_id__$8F = undefined;
/* module identifier */

const __vue_module_identifier__$8F = undefined;
/* functional template */

const __vue_is_functional_template__$8F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8F,
  staticRenderFns: __vue_staticRenderFns__$8F
}, __vue_inject_styles__$8F, __vue_script__$8F, __vue_scope_id__$8F, __vue_is_functional_template__$8F, __vue_module_identifier__$8F, false, undefined, undefined, undefined);

var script$8E = Vue.extend({
  name: "PhFolderUser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8E = script$8E;
/* template */

var __vue_render__$8E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.7,218a8,8,0,0,1-7.7,10H157a8,8,0,0,1-7.7-10,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,226.7,218ZM232,88v32a8,8,0,0,1-16,0V88H40V200h80.6a8,8,0,1,1,0,16H39.4A15.4,15.4,0,0,1,24,200.6V56A16,16,0,0,1,40,40H92.7A15.9,15.9,0,0,1,104,44.7L131.3,72H216A16,16,0,0,1,232,88ZM40,56V72h68.7l-16-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "172",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157,220a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8E = [];
/* style */

const __vue_inject_styles__$8E = undefined;
/* scoped */

const __vue_scope_id__$8E = undefined;
/* module identifier */

const __vue_module_identifier__$8E = undefined;
/* functional template */

const __vue_is_functional_template__$8E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8E,
  staticRenderFns: __vue_staticRenderFns__$8E
}, __vue_inject_styles__$8E, __vue_script__$8E, __vue_scope_id__$8E, __vue_is_functional_template__$8E, __vue_module_identifier__$8E, false, undefined, undefined, undefined);

var script$8D = Vue.extend({
  name: "PhFolders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8D = script$8D;
/* template */

var __vue_render__$8D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M196,116v88.9a7.1,7.1,0,0,1-7.1,7.1H36a8,8,0,0,1-8-8V92a8,8,0,0,1,8-8H81.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H188A8,8,0,0,1,196,116Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,84V52a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H228a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H196",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,72H154.7a8.1,8.1,0,0,1-4.8-1.6L122.1,49.6a8.1,8.1,0,0,0-4.8-1.6H72a8,8,0,0,0-8,8V80H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192a8,8,0,0,1,8,8v64h24.9a7.1,7.1,0,0,0,7.1-7.1V80A8,8,0,0,0,224,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,64H154.7L126.9,43.2a15.6,15.6,0,0,0-9.6-3.2H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H192.9A15.2,15.2,0,0,0,208,200.9V184h16.9A15.2,15.2,0,0,0,240,168.9V80A16,16,0,0,0,224,64Zm0,104H208V112a16,16,0,0,0-16-16H122.7L94.9,75.2A15.6,15.6,0,0,0,85.3,72H72V56h45.3l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8D = [];
/* style */

const __vue_inject_styles__$8D = undefined;
/* scoped */

const __vue_scope_id__$8D = undefined;
/* module identifier */

const __vue_module_identifier__$8D = undefined;
/* functional template */

const __vue_is_functional_template__$8D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8D,
  staticRenderFns: __vue_staticRenderFns__$8D
}, __vue_inject_styles__$8D, __vue_script__$8D, __vue_scope_id__$8D, __vue_is_functional_template__$8D, __vue_module_identifier__$8D, false, undefined, undefined, undefined);

var script$8C = Vue.extend({
  name: "PhFootball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8C = script$8C;
/* template */

var __vue_render__$8C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.7",
      "y1": "102.1",
      "x2": "153.9",
      "y2": "131.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "124.7",
      "x2": "131.3",
      "y2": "153.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.2",
      "y1": "36.2",
      "x2": "219.8",
      "y2": "107.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.2",
      "y1": "148.2",
      "x2": "107.8",
      "y2": "219.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.7",
      "y1": "102.1",
      "x2": "153.9",
      "y2": "131.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "124.7",
      "x2": "131.3",
      "y2": "153.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.2",
      "y1": "36.2",
      "x2": "219.8",
      "y2": "107.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.2",
      "y1": "148.2",
      "x2": "107.8",
      "y2": "219.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.2,148.2C39,123,48.2,94.7,71.4,71.4S123,39,148.2,36.2h0l71.6,71.6h0c-2.8,25.2-12,53.5-35.2,76.8S133,217,107.8,219.8Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226,56.3A32.3,32.3,0,0,0,199.7,30c-31.4-5.3-90.4-7.7-133.9,35.8S24.7,168.3,30,199.7A32.3,32.3,0,0,0,56.3,226a206.3,206.3,0,0,0,33.3,2.8c31.1,0,69.8-7.7,100.6-38.6C233.7,146.7,231.3,87.7,226,56.3ZM59,210.2A15.9,15.9,0,0,1,45.8,197a178.7,178.7,0,0,1-2.7-30.6l46.5,46.5A179.5,179.5,0,0,1,59,210.2ZM165.7,101.7l-15.1,15,9,9a8,8,0,0,1,0,11.3,8.3,8.3,0,0,1-5.7,2.3,8,8,0,0,1-5.6-2.3l-9-9L128,139.3l9,9a8,8,0,0,1,0,11.3,7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3l-9-9-15,15.1a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l15.1-15-9-9A8,8,0,0,1,107.7,119l9,9L128,116.7l-9-9a8,8,0,0,1,11.3-11.3l9,9,15-15.1a8.1,8.1,0,0,1,11.4,11.4Zm.7-58.6A179.5,179.5,0,0,1,197,45.8,15.9,15.9,0,0,1,210.2,59a178.7,178.7,0,0,1,2.7,30.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.7",
      "y1": "102.1",
      "x2": "153.9",
      "y2": "131.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "124.7",
      "x2": "131.3",
      "y2": "153.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.2",
      "y1": "36.2",
      "x2": "219.8",
      "y2": "107.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.2",
      "y1": "148.2",
      "x2": "107.8",
      "y2": "219.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.7",
      "y1": "102.1",
      "x2": "153.9",
      "y2": "131.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "124.7",
      "x2": "131.3",
      "y2": "153.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.2",
      "y1": "36.2",
      "x2": "219.8",
      "y2": "107.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.2",
      "y1": "148.2",
      "x2": "107.8",
      "y2": "219.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.7",
      "y1": "102.1",
      "x2": "153.9",
      "y2": "131.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "124.7",
      "x2": "131.3",
      "y2": "153.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148.2",
      "y1": "36.2",
      "x2": "219.8",
      "y2": "107.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.2",
      "y1": "148.2",
      "x2": "107.8",
      "y2": "219.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8C = [];
/* style */

const __vue_inject_styles__$8C = undefined;
/* scoped */

const __vue_scope_id__$8C = undefined;
/* module identifier */

const __vue_module_identifier__$8C = undefined;
/* functional template */

const __vue_is_functional_template__$8C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8C,
  staticRenderFns: __vue_staticRenderFns__$8C
}, __vue_inject_styles__$8C, __vue_script__$8C, __vue_scope_id__$8C, __vue_is_functional_template__$8C, __vue_module_identifier__$8C, false, undefined, undefined, undefined);

var script$8B = Vue.extend({
  name: "PhForkKnife",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8B = script$8B;
/* template */

var __vue_render__$8B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,32V80a36,36,0,0,1-72,0V32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,32V224a8,8,0,0,1-16,0V168H148a8.2,8.2,0,0,1-6-2.7,8.1,8.1,0,0,1-2-6.2,412.8,412.8,0,0,1,11.8-59.3c12-42.4,28.7-67.8,49.5-75.3A7.9,7.9,0,0,1,212,32ZM127.9,78.7l-8-48a8,8,0,1,0-15.8,2.6L110.6,72H92V32a8,8,0,0,0-16,0V72H57.4l6.5-38.7a8,8,0,1,0-15.8-2.6l-8,48h0A4.9,4.9,0,0,0,40,80a44.1,44.1,0,0,0,36,43.3V224a8,8,0,0,0,16,0V123.3A44.1,44.1,0,0,0,128,80a4.9,4.9,0,0,0-.1-1.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "32",
      "x2": "84",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "84",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,32l8,48a36,36,0,0,1-72,0l8-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,160H148S160,48,204,32V224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8B = [];
/* style */

const __vue_inject_styles__$8B = undefined;
/* scoped */

const __vue_scope_id__$8B = undefined;
/* module identifier */

const __vue_module_identifier__$8B = undefined;
/* functional template */

const __vue_is_functional_template__$8B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8B,
  staticRenderFns: __vue_staticRenderFns__$8B
}, __vue_inject_styles__$8B, __vue_script__$8B, __vue_scope_id__$8B, __vue_is_functional_template__$8B, __vue_module_identifier__$8B, false, undefined, undefined, undefined);

var script$8A = Vue.extend({
  name: "PhFrameCorners",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8A = script$8A;
/* template */

var __vue_render__$8A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 88 184 88 184 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 168 72 168 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM88,192H56a8,8,0,0,1-8-8V152a8,8,0,0,1,16,0v24H88a8,8,0,0,1,0,16Zm120-88a8,8,0,0,1-16,0V80H168a8,8,0,0,1,0-16h32a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "160 80 192 80 192 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 176 64 176 64 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8A = [];
/* style */

const __vue_inject_styles__$8A = undefined;
/* scoped */

const __vue_scope_id__$8A = undefined;
/* module identifier */

const __vue_module_identifier__$8A = undefined;
/* functional template */

const __vue_is_functional_template__$8A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8A,
  staticRenderFns: __vue_staticRenderFns__$8A
}, __vue_inject_styles__$8A, __vue_script__$8A, __vue_scope_id__$8A, __vue_is_functional_template__$8A, __vue_module_identifier__$8A, false, undefined, undefined, undefined);

var script$8z = Vue.extend({
  name: "PhFramerLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8z = script$8z;
/* template */

var __vue_render__$8z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100V32a8,8,0,0,0-8-8H56a8,8,0,0,0-5.5,13.8L107.9,92H56a8,8,0,0,0-8,8v68a7.9,7.9,0,0,0,2.5,5.8l72,68A8.2,8.2,0,0,0,128,244a7.4,7.4,0,0,0,3.2-.7A7.9,7.9,0,0,0,136,236V176h64a8,8,0,0,0,5.5-13.8L148.1,108H200A8,8,0,0,0,208,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8z = [];
/* style */

const __vue_inject_styles__$8z = undefined;
/* scoped */

const __vue_scope_id__$8z = undefined;
/* module identifier */

const __vue_module_identifier__$8z = undefined;
/* functional template */

const __vue_is_functional_template__$8z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8z,
  staticRenderFns: __vue_staticRenderFns__$8z
}, __vue_inject_styles__$8z, __vue_script__$8z, __vue_scope_id__$8z, __vue_is_functional_template__$8z, __vue_module_identifier__$8z, false, undefined, undefined, undefined);

var script$8y = Vue.extend({
  name: "PhFunction",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8y = script$8y;
/* template */

var __vue_render__$8y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40a8,8,0,0,1-8,8H170.7a24,24,0,0,0-23.6,19.7L137.6,120H184a8,8,0,0,1,0,16H134.7l-10.1,55.2A39.9,39.9,0,0,1,85.3,224H56a8,8,0,0,1,0-16H85.3a24,24,0,0,0,23.6-19.7l9.5-52.3H72a8,8,0,0,1,0-16h49.3l10.1-55.2A39.9,39.9,0,0,1,170.7,32H200A8,8,0,0,1,208,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "184",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8y = [];
/* style */

const __vue_inject_styles__$8y = undefined;
/* scoped */

const __vue_scope_id__$8y = undefined;
/* module identifier */

const __vue_module_identifier__$8y = undefined;
/* functional template */

const __vue_is_functional_template__$8y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8y,
  staticRenderFns: __vue_staticRenderFns__$8y
}, __vue_inject_styles__$8y, __vue_script__$8y, __vue_scope_id__$8y, __vue_is_functional_template__$8y, __vue_module_identifier__$8y, false, undefined, undefined, undefined);

var script$8x = Vue.extend({
  name: "PhFunnel",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8x = script$8x;
/* template */

var __vue_render__$8x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.5,49.5A15.9,15.9,0,0,0,213.9,40H42.1A16.1,16.1,0,0,0,30.2,66.8L96,139.1v78a15.9,15.9,0,0,0,8.5,14.1,16.4,16.4,0,0,0,7.5,1.9,16,16,0,0,0,8.9-2.7l32-21.4a15.9,15.9,0,0,0,7.1-13.3V139.1l65.8-72.3A15.9,15.9,0,0,0,228.5,49.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8x = [];
/* style */

const __vue_inject_styles__$8x = undefined;
/* scoped */

const __vue_scope_id__$8x = undefined;
/* module identifier */

const __vue_module_identifier__$8x = undefined;
/* functional template */

const __vue_is_functional_template__$8x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8x,
  staticRenderFns: __vue_staticRenderFns__$8x
}, __vue_inject_styles__$8x, __vue_script__$8x, __vue_scope_id__$8x, __vue_is_functional_template__$8x, __vue_module_identifier__$8x, false, undefined, undefined, undefined);

var script$8w = Vue.extend({
  name: "PhFunnelSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8w = script$8w;
/* template */

var __vue_render__$8w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,72H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "80",
      "x2": "232",
      "y2": "80",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "176",
      "x2": "152",
      "y2": "176",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8w = [];
/* style */

const __vue_inject_styles__$8w = undefined;
/* scoped */

const __vue_scope_id__$8w = undefined;
/* module identifier */

const __vue_module_identifier__$8w = undefined;
/* functional template */

const __vue_is_functional_template__$8w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8w,
  staticRenderFns: __vue_staticRenderFns__$8w
}, __vue_inject_styles__$8w, __vue_script__$8w, __vue_scope_id__$8w, __vue_is_functional_template__$8w, __vue_module_identifier__$8w, false, undefined, undefined, undefined);

var script$8v = Vue.extend({
  name: "PhGameController",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8v = script$8v;
/* template */

var __vue_render__$8v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M149,159.8h23a52,52,0,0,0,52-52,45,45,0,0,0-.8-9h0l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.5,181.7h-.1L231.1,97.2c0-.1,0-.1-.1-.2a60,60,0,0,0-59-49.3h0L84,48A59.9,59.9,0,0,0,24.9,97.6v.2L8.6,181.6h0a35.9,35.9,0,0,0,29.2,41.7,31.8,31.8,0,0,0,6.2.6,36.4,36.4,0,0,0,25.5-10.5l.4-.5,40.7-45,34.9-.2L186.1,213l.5.5A36,36,0,0,0,212,224a33.6,33.6,0,0,0,6.3-.6A36.1,36.1,0,0,0,247.5,181.7ZM104,116H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V92a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H152A8,8,0,0,1,144,108Zm71.5,99.7a20.1,20.1,0,0,1-17.5-5.4l-31.1-34.5H172a60,60,0,0,0,51-28.3l8.7,45.2A20,20,0,0,1,215.5,207.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "108",
      "x2": "104",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "92",
      "x2": "88",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8v = [];
/* style */

const __vue_inject_styles__$8v = undefined;
/* scoped */

const __vue_scope_id__$8v = undefined;
/* module identifier */

const __vue_module_identifier__$8v = undefined;
/* functional template */

const __vue_is_functional_template__$8v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8v,
  staticRenderFns: __vue_staticRenderFns__$8v
}, __vue_inject_styles__$8v, __vue_script__$8v, __vue_scope_id__$8v, __vue_is_functional_template__$8v, __vue_module_identifier__$8v, false, undefined, undefined, undefined);

var script$8u = Vue.extend({
  name: "PhGasPump",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8u = script$8u;
/* template */

var __vue_render__$8u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h4a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L220,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241,69.7,221.7,50.3a8.1,8.1,0,0,0-11.4,11.4L229.7,81a7.9,7.9,0,0,1,2.3,5.6V168a8,8,0,0,1-16,0V128a24.1,24.1,0,0,0-24-24H176V56a24.1,24.1,0,0,0-24-24H72A24.1,24.1,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8,8,0,0,1,8,8v40a24,24,0,0,0,48,0V86.6A23.8,23.8,0,0,0,241,69.7ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "216",
      "x2": "192",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "112",
      "x2": "88",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8u = [];
/* style */

const __vue_inject_styles__$8u = undefined;
/* scoped */

const __vue_scope_id__$8u = undefined;
/* module identifier */

const __vue_module_identifier__$8u = undefined;
/* functional template */

const __vue_is_functional_template__$8u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8u,
  staticRenderFns: __vue_staticRenderFns__$8u
}, __vue_inject_styles__$8u, __vue_script__$8u, __vue_scope_id__$8u, __vue_is_functional_template__$8u, __vue_module_identifier__$8u, false, undefined, undefined, undefined);

var script$8t = Vue.extend({
  name: "PhGauge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8t = script$8t;
/* template */

var __vue_render__$8t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.5",
      "y1": "133.1",
      "x2": "58.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.5",
      "y1": "133.1",
      "x2": "197.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.4",
      "y1": "192",
      "x2": "171.8",
      "y2": "102.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.5",
      "y1": "133.1",
      "x2": "58.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.5",
      "y1": "133.1",
      "x2": "197.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.4",
      "y1": "192",
      "x2": "171.8",
      "y2": "102.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,160v24a16,16,0,0,1-16,16H115.5a4,4,0,0,1-3.2-6.4L178,108a8.2,8.2,0,0,0-1.1-11.3A7.9,7.9,0,0,0,165.5,98L88.4,198.4a3.8,3.8,0,0,1-3.1,1.6H32a16,16,0,0,1-16-16V161.1a116.1,116.1,0,0,1,2.2-22.2L40.9,145l2.1.2a8,8,0,0,0,7.8-6.2,8.1,8.1,0,0,0-6-9.6l-22.4-6C37,82,74.9,51.5,120,48.3V71.7a8.2,8.2,0,0,0,7.5,8.3,8,8,0,0,0,8.5-8V48.3a111.5,111.5,0,0,1,71.1,32.4,112.7,112.7,0,0,1,26.8,42.6l-22.7,6.1a8.1,8.1,0,0,0-6,9.6,8,8,0,0,0,7.8,6.2l2.1-.2,22.9-6.2A114.5,114.5,0,0,1,240,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.5",
      "y1": "133.1",
      "x2": "58.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.5",
      "y1": "133.1",
      "x2": "197.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.4",
      "y1": "192",
      "x2": "171.8",
      "y2": "102.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.5",
      "y1": "133.1",
      "x2": "58.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.5",
      "y1": "133.1",
      "x2": "197.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.4",
      "y1": "192",
      "x2": "171.8",
      "y2": "102.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "27.5",
      "y1": "133.1",
      "x2": "58.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228.5",
      "y1": "133.1",
      "x2": "197.5",
      "y2": "141.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.4",
      "y1": "192",
      "x2": "171.8",
      "y2": "102.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8t = [];
/* style */

const __vue_inject_styles__$8t = undefined;
/* scoped */

const __vue_scope_id__$8t = undefined;
/* module identifier */

const __vue_module_identifier__$8t = undefined;
/* functional template */

const __vue_is_functional_template__$8t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8t,
  staticRenderFns: __vue_staticRenderFns__$8t
}, __vue_inject_styles__$8t, __vue_script__$8t, __vue_scope_id__$8t, __vue_is_functional_template__$8t, __vue_module_identifier__$8t, false, undefined, undefined, undefined);

var script$8s = Vue.extend({
  name: "PhGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8s = script$8s;
/* template */

var __vue_render__$8s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.2-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.8,133.1c.3-3.4,0-10.2,0-10.2l16.6-22.1a103.2,103.2,0,0,0-10.2-24.6l-27.3-3.9q-3.5-3.7-7.2-7.2l-3.9-27.3a102.2,102.2,0,0,0-24.6-10.2L133.1,44.2a57.9,57.9,0,0,0-10.2,0L100.8,27.6A103.2,103.2,0,0,0,76.2,37.8L72.3,65.1q-3.7,3.5-7.2,7.2L37.8,76.2a102.2,102.2,0,0,0-10.2,24.6l16.6,22.1c-.2,3.4,0,10.2,0,10.2L27.6,155.2a103.2,103.2,0,0,0,10.2,24.6l27.3,3.9q3.5,3.8,7.2,7.2l3.9,27.3a102.2,102.2,0,0,0,24.6,10.2l22.1-16.6a57.9,57.9,0,0,0,10.2,0l22.1,16.6a103.2,103.2,0,0,0,24.6-10.2l3.9-27.3c2.5-2.3,7.2-7.2,7.2-7.2l27.3-3.9a102.2,102.2,0,0,0,10.2-24.6ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.2-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.8,150.4l-14.9-19.8c.1-1.8,0-3.7,0-5.1l14.9-19.9a7.8,7.8,0,0,0,1.3-6.9,114.8,114.8,0,0,0-10.9-26.4,8.2,8.2,0,0,0-5.8-4l-24.5-3.5-3.7-3.7-3.5-24.5a8.4,8.4,0,0,0-3.9-5.8,117.5,117.5,0,0,0-26.5-10.9,7.8,7.8,0,0,0-6.9,1.3L130.6,36h-5.2L105.6,21.2a7.8,7.8,0,0,0-6.9-1.3A114.8,114.8,0,0,0,72.3,30.8a8.2,8.2,0,0,0-4,5.8L64.8,61.1l-3.7,3.7L36.6,68.3a8.2,8.2,0,0,0-5.8,4A114.8,114.8,0,0,0,19.9,98.7a7.8,7.8,0,0,0,1.3,6.9l14.9,19.8v5.1L21.2,150.4a7.8,7.8,0,0,0-1.3,6.9,114.8,114.8,0,0,0,10.9,26.4,8.2,8.2,0,0,0,5.8,4l24.5,3.5,3.7,3.7,3.5,24.5a8.2,8.2,0,0,0,4,5.8,114.8,114.8,0,0,0,26.4,10.9,7.6,7.6,0,0,0,2.1.3,7.7,7.7,0,0,0,4.8-1.6L125.4,220h5.2l19.8,14.8a7.8,7.8,0,0,0,6.9,1.3,113,113,0,0,0,26.4-10.9,8.2,8.2,0,0,0,4-5.8l3.5-24.6c1.2-1.2,2.6-2.5,3.6-3.6l24.6-3.5a8.2,8.2,0,0,0,5.8-4,114.8,114.8,0,0,0,10.9-26.4A7.8,7.8,0,0,0,234.8,150.4ZM128,172a44,44,0,1,1,44-44A44,44,0,0,1,128,172Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8s = [];
/* style */

const __vue_inject_styles__$8s = undefined;
/* scoped */

const __vue_scope_id__$8s = undefined;
/* module identifier */

const __vue_module_identifier__$8s = undefined;
/* functional template */

const __vue_is_functional_template__$8s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8s,
  staticRenderFns: __vue_staticRenderFns__$8s
}, __vue_inject_styles__$8s, __vue_script__$8s, __vue_scope_id__$8s, __vue_is_functional_template__$8s, __vue_module_identifier__$8s, false, undefined, undefined, undefined);

var script$8r = Vue.extend({
  name: "PhGearSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8r = script$8r;
/* template */

var __vue_render__$8r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.6,106,203.7,91.6a73.6,73.6,0,0,0-6.3-10.9l.5-29.7a102.6,102.6,0,0,0-38.2-22L134.3,44.2a88.3,88.3,0,0,0-12.6,0L96.2,28.9A104,104,0,0,0,58.1,51l.5,29.7a73.6,73.6,0,0,0-6.3,10.9L26.3,106a103.6,103.6,0,0,0,.1,44l25.9,14.4a80.1,80.1,0,0,0,6.3,11L58.1,205a102.6,102.6,0,0,0,38.2,22l25.4-15.2a88.3,88.3,0,0,0,12.6,0l25.5,15.3A104,104,0,0,0,197.9,205l-.5-29.7a73.6,73.6,0,0,0,6.3-10.9l26-14.4A102,102,0,0,0,229.6,106ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a103.6,103.6,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.5,104.3a8,8,0,0,0-4-5.3L209.7,85.8q-1.9-3.9-4.2-7.5l.4-27.2a8.3,8.3,0,0,0-2.6-6.1,112,112,0,0,0-41.1-23.7,8.1,8.1,0,0,0-6.6.8l-23.3,14c-2.9-.1-5.7-.1-8.6,0l-23.3-14a8.1,8.1,0,0,0-6.6-.8A111.1,111.1,0,0,0,52.7,45.1a7.9,7.9,0,0,0-2.6,6l.5,27.2c-1.6,2.4-3,4.9-4.4,7.5L22.5,99a7.7,7.7,0,0,0-4,5.3,111.4,111.4,0,0,0,0,47.4,8,8,0,0,0,4,5.3l23.8,13.2a69.3,69.3,0,0,0,4.3,7.5l-.5,27.2a8.3,8.3,0,0,0,2.6,6.1,112.9,112.9,0,0,0,41.1,23.7,8.1,8.1,0,0,0,6.6-.8l23.3-14h8.6l23.4,14a7.3,7.3,0,0,0,4.1,1.2,10,10,0,0,0,2.4-.4,111.1,111.1,0,0,0,41.1-23.8,7.9,7.9,0,0,0,2.6-6l-.4-27.2c1.5-2.4,2.9-4.9,4.3-7.5L233.6,157a7.9,7.9,0,0,0,3.9-5.3A111.4,111.4,0,0,0,237.5,104.3ZM172,128a44,44,0,1,1-44-44A44,44,0,0,1,172,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8r = [];
/* style */

const __vue_inject_styles__$8r = undefined;
/* scoped */

const __vue_scope_id__$8r = undefined;
/* module identifier */

const __vue_module_identifier__$8r = undefined;
/* functional template */

const __vue_is_functional_template__$8r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8r,
  staticRenderFns: __vue_staticRenderFns__$8r
}, __vue_inject_styles__$8r, __vue_script__$8r, __vue_scope_id__$8r, __vue_is_functional_template__$8r, __vue_module_identifier__$8r, false, undefined, undefined, undefined);

var script$8q = Vue.extend({
  name: "PhGenderFemale",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8q = script$8q;
/* template */

var __vue_render__$8q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,96a80,80,0,1,0-88,79.6V200H88a8,8,0,0,0,0,16h32v24a8,8,0,0,0,16,0V216h32a8,8,0,0,0,0-16H136V175.6A80.1,80.1,0,0,0,208,96ZM64,96a64,64,0,1,1,64,64A64.1,64.1,0,0,1,64,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "208",
      "x2": "168",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8q = [];
/* style */

const __vue_inject_styles__$8q = undefined;
/* scoped */

const __vue_scope_id__$8q = undefined;
/* module identifier */

const __vue_module_identifier__$8q = undefined;
/* functional template */

const __vue_is_functional_template__$8q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8q,
  staticRenderFns: __vue_staticRenderFns__$8q
}, __vue_inject_styles__$8q, __vue_script__$8q, __vue_scope_id__$8q, __vue_is_functional_template__$8q, __vue_module_identifier__$8q, false, undefined, undefined, undefined);

var script$8p = Vue.extend({
  name: "PhGenderIntersex",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8p = script$8p;
/* template */

var __vue_render__$8p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 24 208 24 208 60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.4",
      "y1": "67.6",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.4",
      "y1": "67.6",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,16H168a8,8,0,0,0,0,16h20.7L164.3,56.4A68,68,0,1,0,112,175.5V196H88a8,8,0,0,0,0,16h24v20a8,8,0,0,0,16,0V212h24a8,8,0,0,0,0-16H128V175.5A67.9,67.9,0,0,0,175.1,68.2L200,43.3V64a8,8,0,0,0,16,0V24A8,8,0,0,0,208,16ZM120,160a52,52,0,1,1,52-52A52,52,0,0,1,120,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.4",
      "y1": "67.6",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.4",
      "y1": "67.6",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "108",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "204",
      "x2": "152",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 24 208 24 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.4",
      "y1": "67.6",
      "x2": "208",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8p = [];
/* style */

const __vue_inject_styles__$8p = undefined;
/* scoped */

const __vue_scope_id__$8p = undefined;
/* module identifier */

const __vue_module_identifier__$8p = undefined;
/* functional template */

const __vue_is_functional_template__$8p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8p,
  staticRenderFns: __vue_staticRenderFns__$8p
}, __vue_inject_styles__$8p, __vue_script__$8p, __vue_scope_id__$8p, __vue_is_functional_template__$8p, __vue_module_identifier__$8p, false, undefined, undefined, undefined);

var script$8o = Vue.extend({
  name: "PhGenderMale",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8o = script$8o;
/* template */

var __vue_render__$8o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.9",
      "y1": "101.1",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.9",
      "y1": "101.1",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32H168a8,8,0,0,0,0,16h28.7L154.6,90.1a80,80,0,1,0,11.3,11.3L208,59.3V88a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32ZM149.3,197.3a64,64,0,1,1,0-90.6A64.3,64.3,0,0,1,149.3,197.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.9",
      "y1": "101.1",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.9",
      "y1": "101.1",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "152",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "154.9",
      "y1": "101.1",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8o = [];
/* style */

const __vue_inject_styles__$8o = undefined;
/* scoped */

const __vue_scope_id__$8o = undefined;
/* module identifier */

const __vue_module_identifier__$8o = undefined;
/* functional template */

const __vue_is_functional_template__$8o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8o,
  staticRenderFns: __vue_staticRenderFns__$8o
}, __vue_inject_styles__$8o, __vue_script__$8o, __vue_scope_id__$8o, __vue_is_functional_template__$8o, __vue_module_identifier__$8o, false, undefined, undefined, undefined);

var script$8n = Vue.extend({
  name: "PhGenderNeuter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8n = script$8n;
/* template */

var __vue_render__$8n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,104a80,80,0,1,0-88,79.6V232a8,8,0,0,0,16,0V183.6A80.1,80.1,0,0,0,208,104Zm-80,64a64,64,0,1,1,64-64A64.1,64.1,0,0,1,128,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8n = [];
/* style */

const __vue_inject_styles__$8n = undefined;
/* scoped */

const __vue_scope_id__$8n = undefined;
/* module identifier */

const __vue_module_identifier__$8n = undefined;
/* functional template */

const __vue_is_functional_template__$8n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8n,
  staticRenderFns: __vue_staticRenderFns__$8n
}, __vue_inject_styles__$8n, __vue_script__$8n, __vue_scope_id__$8n, __vue_is_functional_template__$8n, __vue_module_identifier__$8n, false, undefined, undefined, undefined);

var script$8m = Vue.extend({
  name: "PhGenderNonbinary",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8m = script$8m;
/* template */

var __vue_render__$8m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.7",
      "y1": "64",
      "x2": "92.3",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.3",
      "y1": "64",
      "x2": "163.7",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.7",
      "y1": "68",
      "x2": "92.3",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.3",
      "y1": "68",
      "x2": "163.7",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,88.4V59l23.3,15.6a7.2,7.2,0,0,0,4.4,1.4,8,8,0,0,0,4.5-14.6L142.3,44l25.9-17.4a8,8,0,1,0-8.9-13.2L128,34.4l-31.3-21a8,8,0,1,0-8.9,13.2L113.7,44,87.8,61.4A8,8,0,0,0,92.3,76a7.2,7.2,0,0,0,4.4-1.4L120,59V88.4a76,76,0,1,0,16,0ZM128,224a60,60,0,1,1,60-60A60,60,0,0,1,128,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.7",
      "y1": "68",
      "x2": "92.3",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.3",
      "y1": "68",
      "x2": "163.7",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.7",
      "y1": "68",
      "x2": "92.3",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.3",
      "y1": "68",
      "x2": "163.7",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "164",
      "r": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.7",
      "y1": "68",
      "x2": "92.3",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.3",
      "y1": "68",
      "x2": "163.7",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8m = [];
/* style */

const __vue_inject_styles__$8m = undefined;
/* scoped */

const __vue_scope_id__$8m = undefined;
/* module identifier */

const __vue_module_identifier__$8m = undefined;
/* functional template */

const __vue_is_functional_template__$8m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8m,
  staticRenderFns: __vue_staticRenderFns__$8m
}, __vue_inject_styles__$8m, __vue_script__$8m, __vue_scope_id__$8m, __vue_is_functional_template__$8m, __vue_module_identifier__$8m, false, undefined, undefined, undefined);

var script$8l = Vue.extend({
  name: "PhGenderTransgender",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8l = script$8l;
/* template */

var __vue_render__$8l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.3",
      "y1": "114.7",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 40 216 40 216 84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.3",
      "y1": "114.7",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,32H168a8,8,0,0,0,0,16h28.7L168,76.7,149.7,58.3a8.1,8.1,0,0,0-11.4,11.4L156.7,88l-15.8,15.8a72.2,72.2,0,1,0,11.3,11.3L168,99.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L179.3,88,208,59.3V88a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32ZM135.6,199.6a56.1,56.1,0,0,1-79.2,0,56,56,0,0,1,79.2-79.2,56,56,0,0,1,0,79.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.3",
      "y1": "114.7",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.3",
      "y1": "114.7",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "160",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "141.3",
      "y1": "114.7",
      "x2": "216",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 40 216 40 216 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8l = [];
/* style */

const __vue_inject_styles__$8l = undefined;
/* scoped */

const __vue_scope_id__$8l = undefined;
/* module identifier */

const __vue_module_identifier__$8l = undefined;
/* functional template */

const __vue_is_functional_template__$8l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8l,
  staticRenderFns: __vue_staticRenderFns__$8l
}, __vue_inject_styles__$8l, __vue_script__$8l, __vue_scope_id__$8l, __vue_is_functional_template__$8l, __vue_module_identifier__$8l, false, undefined, undefined, undefined);

var script$8k = Vue.extend({
  name: "PhGhost",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8k = script$8k;
/* template */

var __vue_render__$8k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a96.2,96.2,0,0,0-96,96v96a8.1,8.1,0,0,0,13.1,6.2l24.2-19.9,24.3,19.9a8,8,0,0,0,10.1,0L128,202.3l24.3,19.9a8,8,0,0,0,10.1,0l24.3-19.9,24.2,19.9a7.9,7.9,0,0,0,8.5,1A7.9,7.9,0,0,0,224,216V120A96.2,96.2,0,0,0,128,24ZM100,128a12,12,0,1,1,12-12A12,12,0,0,1,100,128Zm56,0a12,12,0,1,1,12-12A12,12,0,0,1,156,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8k = [];
/* style */

const __vue_inject_styles__$8k = undefined;
/* scoped */

const __vue_scope_id__$8k = undefined;
/* module identifier */

const __vue_module_identifier__$8k = undefined;
/* functional template */

const __vue_is_functional_template__$8k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8k,
  staticRenderFns: __vue_staticRenderFns__$8k
}, __vue_inject_styles__$8k, __vue_script__$8k, __vue_scope_id__$8k, __vue_is_functional_template__$8k, __vue_module_identifier__$8k, false, undefined, undefined, undefined);

var script$8j = Vue.extend({
  name: "PhGif",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8j = script$8j;
/* template */

var __vue_render__$8j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,132H96v20a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,64a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8,8,0,0,0,136,64Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,64H180a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V136h28a8,8,0,0,0,0-16H188V80h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,120H72a8,8,0,0,0,0,16H88v16a24,24,0,0,1-48,0V104a24,24,0,0,1,47.2-6,8,8,0,0,0,15.5-4A40,40,0,0,0,24,104v48a40,40,0,0,0,80,0V128A8,8,0,0,0,96,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "72",
      "x2": "136",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "228 72 180 72 180 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "180",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8j = [];
/* style */

const __vue_inject_styles__$8j = undefined;
/* scoped */

const __vue_scope_id__$8j = undefined;
/* module identifier */

const __vue_module_identifier__$8j = undefined;
/* functional template */

const __vue_is_functional_template__$8j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8j,
  staticRenderFns: __vue_staticRenderFns__$8j
}, __vue_inject_styles__$8j, __vue_script__$8j, __vue_scope_id__$8j, __vue_is_functional_template__$8j, __vue_module_identifier__$8j, false, undefined, undefined, undefined);

var script$8i = Vue.extend({
  name: "PhGift",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8i = script$8i;
/* template */

var __vue_render__$8i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H181a32,32,0,0,0-47.3-42.9,29.2,29.2,0,0,0-5.7,8.2,29.2,29.2,0,0,0-5.7-8.2A32,32,0,0,0,75,72H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM145,40.4A16,16,0,1,1,167.6,63c-4.9,5-19.2,7.7-31.3,8.7C137.3,59.6,140,45.3,145,40.4Zm-56.6,0a16.1,16.1,0,0,1,22.6,0c5,4.9,7.7,19.2,8.7,31.3-12.1-1-26.4-3.7-31.3-8.7A16.1,16.1,0,0,1,88.4,40.4ZM216,120H136v72a8,8,0,0,1-16,0V120H40V88h80v32h16V88h80v32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "80",
      "width": "192",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8i = [];
/* style */

const __vue_inject_styles__$8i = undefined;
/* scoped */

const __vue_scope_id__$8i = undefined;
/* module identifier */

const __vue_module_identifier__$8i = undefined;
/* functional template */

const __vue_is_functional_template__$8i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8i,
  staticRenderFns: __vue_staticRenderFns__$8i
}, __vue_inject_styles__$8i, __vue_script__$8i, __vue_scope_id__$8i, __vue_is_functional_template__$8i, __vue_module_identifier__$8i, false, undefined, undefined, undefined);

var script$8h = Vue.extend({
  name: "PhGitBranch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8h = script$8h;
/* template */

var __vue_render__$8h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,160v-8a23.9,23.9,0,0,1,24-24h72a24,24,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,68a36,36,0,1,0-44,35.1v.9a16,16,0,0,1-16,16H92a32.2,32.2,0,0,0-16,4.3V103.1a36,36,0,1,0-16,0v49.8a36,36,0,1,0,16,0V152a16,16,0,0,1,16-16h72a32.1,32.1,0,0,0,32-32v-.9A36.1,36.1,0,0,0,224,68ZM48,68A20,20,0,1,1,68,88,20.1,20.1,0,0,1,48,68ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8h = [];
/* style */

const __vue_inject_styles__$8h = undefined;
/* scoped */

const __vue_scope_id__$8h = undefined;
/* module identifier */

const __vue_module_identifier__$8h = undefined;
/* functional template */

const __vue_is_functional_template__$8h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8h,
  staticRenderFns: __vue_staticRenderFns__$8h
}, __vue_inject_styles__$8h, __vue_script__$8h, __vue_scope_id__$8h, __vue_is_functional_template__$8h, __vue_module_identifier__$8h, false, undefined, undefined, undefined);

var script$8g = Vue.extend({
  name: "PhGitCommit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8g = script$8g;
/* template */

var __vue_render__$8g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,120H187.5a60,60,0,0,0-118.9,0H8a8,8,0,0,0,0,16H68.6a60,60,0,0,0,118.9,0H248a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "128",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8g = [];
/* style */

const __vue_inject_styles__$8g = undefined;
/* scoped */

const __vue_scope_id__$8g = undefined;
/* module identifier */

const __vue_module_identifier__$8g = undefined;
/* functional template */

const __vue_is_functional_template__$8g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8g,
  staticRenderFns: __vue_staticRenderFns__$8g
}, __vue_inject_styles__$8g, __vue_script__$8g, __vue_scope_id__$8g, __vue_is_functional_template__$8g, __vue_module_identifier__$8g, false, undefined, undefined, undefined);

var script$8f = Vue.extend({
  name: "PhGitDiff",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8f = script$8f;
/* template */

var __vue_render__$8f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 168 112 208 72 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 168 112 208 72 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,188a36,36,0,1,1-44-35.1v-33a40,40,0,0,0-11.7-28.3L152,67.3V88a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8h40a8,8,0,0,1,0,16H163.3l24.3,24.3A55.5,55.5,0,0,1,204,119.9v33A36.1,36.1,0,0,1,232,188ZM112,160a8,8,0,0,0-8,8v20.7L79.7,164.4A40,40,0,0,1,68,136.1v-33a36,36,0,1,0-16,0v33a55.5,55.5,0,0,0,16.4,39.6L92.7,200H72a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,112,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 168 112 208 72 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 168 112 208 72 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 88 144 48 184 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 168 112 208 72 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8f = [];
/* style */

const __vue_inject_styles__$8f = undefined;
/* scoped */

const __vue_scope_id__$8f = undefined;
/* module identifier */

const __vue_module_identifier__$8f = undefined;
/* functional template */

const __vue_is_functional_template__$8f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8f,
  staticRenderFns: __vue_staticRenderFns__$8f
}, __vue_inject_styles__$8f, __vue_script__$8f, __vue_scope_id__$8f, __vue_is_functional_template__$8f, __vue_module_identifier__$8f, false, undefined, undefined, undefined);

var script$8e = Vue.extend({
  name: "PhGitFork",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8e = script$8e;
/* template */

var __vue_render__$8e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,68a36,36,0,1,0-44,35.1v.9a16,16,0,0,1-16,16H92a16,16,0,0,1-16-16v-.9a36,36,0,1,0-16,0v.9a32.1,32.1,0,0,0,32,32h28v16.9a36,36,0,1,0,16,0V136h28a32.1,32.1,0,0,0,32-32v-.9A36.1,36.1,0,0,0,224,68ZM148,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8e = [];
/* style */

const __vue_inject_styles__$8e = undefined;
/* scoped */

const __vue_scope_id__$8e = undefined;
/* module identifier */

const __vue_module_identifier__$8e = undefined;
/* functional template */

const __vue_is_functional_template__$8e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8e,
  staticRenderFns: __vue_staticRenderFns__$8e
}, __vue_inject_styles__$8e, __vue_script__$8e, __vue_scope_id__$8e, __vue_is_functional_template__$8e, __vue_module_identifier__$8e, false, undefined, undefined, undefined);

var script$8d = Vue.extend({
  name: "PhGitMerge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8d = script$8d;
/* template */

var __vue_render__$8d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,104a36.1,36.1,0,0,0-35.8,32H130.5a40,40,0,0,1-30.8-14.4L82.5,100.9A35.9,35.9,0,1,0,60,103.1v49.8a36,36,0,1,0,16,0V118.1l11.5,13.7a55.4,55.4,0,0,0,43,20.2h23.6A36,36,0,1,0,188,104ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Zm100-28a20,20,0,1,1,20-20A20.1,20.1,0,0,1,188,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "140",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8d = [];
/* style */

const __vue_inject_styles__$8d = undefined;
/* scoped */

const __vue_scope_id__$8d = undefined;
/* module identifier */

const __vue_module_identifier__$8d = undefined;
/* functional template */

const __vue_is_functional_template__$8d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8d,
  staticRenderFns: __vue_staticRenderFns__$8d
}, __vue_inject_styles__$8d, __vue_script__$8d, __vue_scope_id__$8d, __vue_is_functional_template__$8d, __vue_module_identifier__$8d, false, undefined, undefined, undefined);

var script$8c = Vue.extend({
  name: "PhGitPullRequest",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8c = script$8c;
/* template */

var __vue_render__$8c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,68a36,36,0,1,0-44,35.1v49.8a36,36,0,1,0,16,0V103.1A36.1,36.1,0,0,0,104,68ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Zm136,0a36,36,0,1,1-44-35.1v-33a40,40,0,0,0-11.7-28.3L144,67.3V88a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8h40a8,8,0,0,1,0,16H155.3l24.3,24.3A55.5,55.5,0,0,1,196,119.9v33A36.1,36.1,0,0,1,224,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "68",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "68",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 88 136 48 176 48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8c = [];
/* style */

const __vue_inject_styles__$8c = undefined;
/* scoped */

const __vue_scope_id__$8c = undefined;
/* module identifier */

const __vue_module_identifier__$8c = undefined;
/* functional template */

const __vue_is_functional_template__$8c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8c,
  staticRenderFns: __vue_staticRenderFns__$8c
}, __vue_inject_styles__$8c, __vue_script__$8c, __vue_scope_id__$8c, __vue_is_functional_template__$8c, __vue_module_identifier__$8c, false, undefined, undefined, undefined);

var script$8b = Vue.extend({
  name: "PhGithubLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8b = script$8b;
/* template */

var __vue_render__$8b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a23.9,23.9,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a23.9,23.9,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,240a23.9,23.9,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a23.9,23.9,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,224a8,8,0,0,1-8,8,32.1,32.1,0,0,1-32-32v-8a16,16,0,0,0-16-16H156v40a16,16,0,0,0,16,16,8,8,0,0,1,0,16,32.1,32.1,0,0,1-32-32V176H116v40a32.1,32.1,0,0,1-32,32,8,8,0,0,1,0-16,16,16,0,0,0,16-16V176H88a16,16,0,0,0-16,16v8a32.1,32.1,0,0,1-32,32,8,8,0,0,1,0-16,16,16,0,0,0,16-16v-8a32.1,32.1,0,0,1,14.8-27A55.8,55.8,0,0,1,48,120v-8a58,58,0,0,1,7.7-28.3A59.9,59.9,0,0,1,61.1,36,7.8,7.8,0,0,1,68,32a59.7,59.7,0,0,1,48,24h24a59.7,59.7,0,0,1,48-24,7.8,7.8,0,0,1,6.9,4,59.9,59.9,0,0,1,5.4,47.7A58,58,0,0,1,208,112v8a55.8,55.8,0,0,1-22.8,45A32.1,32.1,0,0,1,200,192v8a16,16,0,0,0,16,16A8,8,0,0,1,224,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a23.9,23.9,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a23.9,23.9,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a23.9,23.9,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a23.9,23.9,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M84,240a23.9,23.9,0,0,0,24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,240a23.9,23.9,0,0,1-24-24V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8b = [];
/* style */

const __vue_inject_styles__$8b = undefined;
/* scoped */

const __vue_scope_id__$8b = undefined;
/* module identifier */

const __vue_module_identifier__$8b = undefined;
/* functional template */

const __vue_is_functional_template__$8b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8b,
  staticRenderFns: __vue_staticRenderFns__$8b
}, __vue_inject_styles__$8b, __vue_script__$8b, __vue_scope_id__$8b, __vue_is_functional_template__$8b, __vue_module_identifier__$8b, false, undefined, undefined, undefined);

var script$8a = Vue.extend({
  name: "PhGitlabLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8a = script$8a;
/* template */

var __vue_render__$8a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.7",
      "y1": "230.2",
      "x2": "173",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "83 112 83 112 127.3 230.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.3,230.2,83,112h90L128.7,230.2h0a3.3,3.3,0,0,1-1.4,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.2,112l-16-59.9a4,4,0,0,0-7.6-.4L173,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.8,112l16-59.9a4,4,0,0,1,7.6-.4L83,112H36.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128.7 230.2 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.3 230.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.3,152.5,211,50a12,12,0,0,0-22.9-1.1L167.5,104h-79L67.9,48.9A12,12,0,0,0,45,50L17.7,152.5a16.1,16.1,0,0,0,6.4,17.3l94.8,65.6a15.5,15.5,0,0,0,7.1,2.7h4a15.5,15.5,0,0,0,7.1-2.7l94.8-65.6A16.1,16.1,0,0,0,238.3,152.5ZM33.2,156.6,42.9,120H77.5l34,90.9Zm111.3,54.3,34-90.9h34.6l9.7,36.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128.7 230.2 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.3 230.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128.7 230.2 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.3 230.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128.7 230.2 173 112 219.2 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "36.8 112 83 112 83 112 127.3 230.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8a = [];
/* style */

const __vue_inject_styles__$8a = undefined;
/* scoped */

const __vue_scope_id__$8a = undefined;
/* module identifier */

const __vue_module_identifier__$8a = undefined;
/* functional template */

const __vue_is_functional_template__$8a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8a,
  staticRenderFns: __vue_staticRenderFns__$8a
}, __vue_inject_styles__$8a, __vue_script__$8a, __vue_scope_id__$8a, __vue_is_functional_template__$8a, __vue_module_identifier__$8a, false, undefined, undefined, undefined);

var script$89 = Vue.extend({
  name: "PhGitlabLogoSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$89 = script$89;
/* template */

var __vue_render__$89 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.9,169.8l-94.8,65.6a15.7,15.7,0,0,1-18.2,0L24.1,169.8a16.1,16.1,0,0,1-6.4-17.3L45,50a12,12,0,0,1,22.9-1.1L88.5,104h79l20.6-55.1A12,12,0,0,1,211,50l27.3,102.5A16.1,16.1,0,0,1,231.9,169.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$89 = [];
/* style */

const __vue_inject_styles__$89 = undefined;
/* scoped */

const __vue_scope_id__$89 = undefined;
/* module identifier */

const __vue_module_identifier__$89 = undefined;
/* functional template */

const __vue_is_functional_template__$89 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$89 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$89,
  staticRenderFns: __vue_staticRenderFns__$89
}, __vue_inject_styles__$89, __vue_script__$89, __vue_scope_id__$89, __vue_is_functional_template__$89, __vue_module_identifier__$89, false, undefined, undefined, undefined);

var script$88 = Vue.extend({
  name: "PhGlobe",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$88 = script$88;
/* template */

var __vue_render__$88 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "96",
      "x2": "218.5",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "160",
      "x2": "218.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "96",
      "x2": "218.5",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "160",
      "x2": "218.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.9,163.2l.3-1a103.7,103.7,0,0,0,0-68.4l-.3-1A104.2,104.2,0,0,0,128,24h0A104.2,104.2,0,0,0,30.1,92.8l-.3,1a103.7,103.7,0,0,0,0,68.4l.3,1A104.4,104.4,0,0,0,128,232h0A104.2,104.2,0,0,0,225.9,163.2ZM128,45.6A108.6,108.6,0,0,1,153.5,88h-51A108.6,108.6,0,0,1,128,45.6ZM102.5,168h51A108.6,108.6,0,0,1,128,210.4,108.6,108.6,0,0,1,102.5,168Zm-4.2-16a126.4,126.4,0,0,1,0-48h59.4a126.4,126.4,0,0,1,0,48ZM174,104h38.7a88.9,88.9,0,0,1,0,48H174a145,145,0,0,0,0-48Zm32.4-16h-36a128.7,128.7,0,0,0-24.1-46.1A88.6,88.6,0,0,1,206.4,88ZM146.3,214.1A128.7,128.7,0,0,0,170.4,168h36A88.6,88.6,0,0,1,146.3,214.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "96",
      "x2": "218.5",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "160",
      "x2": "218.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "96",
      "x2": "218.5",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "160",
      "x2": "218.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "96",
      "x2": "218.5",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "37.5",
      "y1": "160",
      "x2": "218.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$88 = [];
/* style */

const __vue_inject_styles__$88 = undefined;
/* scoped */

const __vue_scope_id__$88 = undefined;
/* module identifier */

const __vue_module_identifier__$88 = undefined;
/* functional template */

const __vue_is_functional_template__$88 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$88 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$88,
  staticRenderFns: __vue_staticRenderFns__$88
}, __vue_inject_styles__$88, __vue_script__$88, __vue_scope_id__$88, __vue_is_functional_template__$88, __vue_module_identifier__$88, false, undefined, undefined, undefined);

var script$87 = Vue.extend({
  name: "PhGlobeHemisphereEast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$87 = script$87;
/* template */

var __vue_render__$87 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4l12.1-7.3a8.4,8.4,0,0,0,3.8-6.1l3.7-37a7.3,7.3,0,0,1,1.2-3.5L90.1,98.6A8,8,0,0,1,102,96.8l15.4,12.9a7.8,7.8,0,0,0,6.2,1.8l31.2-4.2a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8h.1a97,97,0,0,1-29.2,38.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4A96,96,0,0,1,182.7,49.1h0l1.1,24.3a8.1,8.1,0,0,1-1.9,5.6l-22.2,25.6a7.8,7.8,0,0,1-4.9,2.7l-31.5,4.3a8.6,8.6,0,0,1-5.8-1.5L97.9,95.9a8.1,8.1,0,0,0-11.5,2.2L66.6,129.2a7.7,7.7,0,0,0-1.3,4.2l-.2,36.1a8,8,0,0,1-3.8,6.8l-11.7,7.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.5,169.2a6.1,6.1,0,0,0,.5-1.2A104,104,0,0,0,187.8,42.9l-1.2-.7A103,103,0,0,0,128,24,104,104,0,0,0,42.6,187.3v.2a10.5,10.5,0,0,0,.8,1.1,104,104,0,0,0,147.8,21.9l1.4-1.1A105.3,105.3,0,0,0,223.5,169.2Zm-162,16.4,3.9-2.4a15.8,15.8,0,0,0,7.7-13.6l.2-33.8a8.3,8.3,0,0,1,1.3-4.3l14-22a8,8,0,0,1,11.4-2.2l12.8,9.3a16.5,16.5,0,0,0,11.6,2.9l31.4-4.3a15.8,15.8,0,0,0,10-5.4l22.1-25.6A15.4,15.4,0,0,0,191.8,73l-.2-5.8A87.7,87.7,0,0,1,216,128a86.4,86.4,0,0,1-3.2,23.4l-15.9-14.6a16.1,16.1,0,0,0-16.9-3l-30.5,12.7a16.1,16.1,0,0,0-9.7,12.4l-2.4,16.2A16.2,16.2,0,0,0,149.2,193l21.5,5.6,4,4a88,88,0,0,1-113.2-17Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$87 = [];
/* style */

const __vue_inject_styles__$87 = undefined;
/* scoped */

const __vue_scope_id__$87 = undefined;
/* module identifier */

const __vue_module_identifier__$87 = undefined;
/* functional template */

const __vue_is_functional_template__$87 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$87 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$87,
  staticRenderFns: __vue_staticRenderFns__$87
}, __vue_inject_styles__$87, __vue_script__$87, __vue_scope_id__$87, __vue_is_functional_template__$87, __vue_module_identifier__$87, false, undefined, undefined, undefined);

var script$86 = Vue.extend({
  name: "PhGlobeHemisphereWest",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$86 = script$86;
/* template */

var __vue_render__$86 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M130.2,224a96.3,96.3,0,0,0,84-53.6h0L159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1l5.4,1.1,8.3-19.7a8.1,8.1,0,0,1,7.4-4.9h21.4a8.6,8.6,0,0,0,3.8-1l12.3-6.8a7.2,7.2,0,0,0,1.5-1.1l26.9-24.3a8.1,8.1,0,0,0,1.6-9.8l-9.3-16.8h0A98.5,98.5,0,0,0,128,32,95.4,95.4,0,0,0,65,55.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,173.3A102.9,102.9,0,0,0,232,128,104.2,104.2,0,0,0,154.8,27.5h-.5A103.8,103.8,0,0,0,60.4,49l-1.3,1.2A103.9,103.9,0,0,0,128,232h2.4A104.3,104.3,0,0,0,221,174.6h0ZM216,128a89.3,89.3,0,0,1-5.5,30.7l-46.4-28.5a16,16,0,0,0-6.3-2.3l-22.8-3a16.1,16.1,0,0,0-15.3,6.8h-8.6l-3.8-7.9a16.2,16.2,0,0,0-11-8.7l-6.6-1.4,2.5-5.9a8.1,8.1,0,0,1,7.4-4.9h16.1a16.1,16.1,0,0,0,7.7-2l12.2-6.8a16.1,16.1,0,0,0,3-2.1l26.9-24.4A15.7,15.7,0,0,0,170,50.7,88,88,0,0,1,216,128ZM40,128a87.1,87.1,0,0,1,9.5-39.7l10.4,27.9a16.1,16.1,0,0,0,11.6,10l5.5,1.2h.1l12,2.6a7.8,7.8,0,0,1,5.5,4.3l2.1,4.4a16.1,16.1,0,0,0,14.4,9h1.2l-7.7,17.2a15.9,15.9,0,0,0,2.8,17.4l16.1,17.4a8.3,8.3,0,0,1,2,6.9l-1.8,9.3A88.1,88.1,0,0,1,40,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$86 = [];
/* style */

const __vue_inject_styles__$86 = undefined;
/* scoped */

const __vue_scope_id__$86 = undefined;
/* module identifier */

const __vue_module_identifier__$86 = undefined;
/* functional template */

const __vue_is_functional_template__$86 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$86 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$86,
  staticRenderFns: __vue_staticRenderFns__$86
}, __vue_inject_styles__$86, __vue_script__$86, __vue_scope_id__$86, __vue_is_functional_template__$86, __vue_module_identifier__$86, false, undefined, undefined, undefined);

var script$85 = Vue.extend({
  name: "PhGlobeSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$85 = script$85;
/* template */

var __vue_render__$85 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,128A104.1,104.1,0,0,0,128,24h0a104,104,0,0,0,0,208h0A104.1,104.1,0,0,0,232,128Zm-16.4-8H175.8c-1.6-29.6-12-57-29.5-78.1A88.2,88.2,0,0,1,215.6,120ZM96.3,136h63.4c-1.8,28.8-13.3,55.7-31.7,74.4C109.6,191.7,98.1,164.8,96.3,136Zm0-16c1.8-28.8,13.3-55.7,31.7-74.4,18.4,18.7,29.9,45.6,31.7,74.4Zm50,94.1c17.5-21.1,27.9-48.5,29.5-78.1h39.8A88.2,88.2,0,0,1,146.3,214.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "40",
      "ry": "93.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$85 = [];
/* style */

const __vue_inject_styles__$85 = undefined;
/* scoped */

const __vue_scope_id__$85 = undefined;
/* module identifier */

const __vue_module_identifier__$85 = undefined;
/* functional template */

const __vue_is_functional_template__$85 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$85 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$85,
  staticRenderFns: __vue_staticRenderFns__$85
}, __vue_inject_styles__$85, __vue_script__$85, __vue_scope_id__$85, __vue_is_functional_template__$85, __vue_module_identifier__$85, false, undefined, undefined, undefined);

var script$84 = Vue.extend({
  name: "PhGlobeStand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$84 = script$84;
/* template */

var __vue_render__$84 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.5,169.5a103.9,103.9,0,0,1-147-147",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "236",
      "x2": "160",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.5,169.5a103.9,103.9,0,0,1-147-147",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "232",
      "x2": "160",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M207.2,175.2a8,8,0,0,0-11.3-11.3A96,96,0,0,1,60.1,28.1,8,8,0,1,0,48.8,16.8,112,112,0,0,0,120,207.7V224H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V207.7A111.6,111.6,0,0,0,207.2,175.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.5,169.5a103.9,103.9,0,0,1-147-147",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "232",
      "x2": "160",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.5,169.5a103.9,103.9,0,0,1-147-147",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "232",
      "x2": "160",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M201.5,169.5a103.9,103.9,0,0,1-147-147",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "232",
      "x2": "160",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$84 = [];
/* style */

const __vue_inject_styles__$84 = undefined;
/* scoped */

const __vue_scope_id__$84 = undefined;
/* module identifier */

const __vue_module_identifier__$84 = undefined;
/* functional template */

const __vue_is_functional_template__$84 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$84 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$84,
  staticRenderFns: __vue_staticRenderFns__$84
}, __vue_inject_styles__$84, __vue_script__$84, __vue_scope_id__$84, __vue_is_functional_template__$84, __vue_module_identifier__$84, false, undefined, undefined, undefined);

var script$83 = Vue.extend({
  name: "PhGoogleChromeLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$83 = script$83;
/* template */

var __vue_render__$83 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "217",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.8",
      "y1": "146",
      "x2": "52.3",
      "y2": "68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.2",
      "y1": "146",
      "x2": "114.7",
      "y2": "223.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "217",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.8",
      "y1": "146",
      "x2": "52.3",
      "y2": "68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.2",
      "y1": "146",
      "x2": "114.7",
      "y2": "223.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,16a88.1,88.1,0,0,1,76.2,44H128a44,44,0,0,0-41.2,28.6L62.1,69.8A87.6,87.6,0,0,1,128,40ZM40,128A87.7,87.7,0,0,1,51.8,84l38.1,66,.2.3a44,44,0,0,0,45.2,21.1l-24.8,42.9A88.3,88.3,0,0,1,40,128Zm88,88,38.1-66c.1-.1.1-.3.2-.4a43.8,43.8,0,0,0-4.4-49.6h49.5a86.5,86.5,0,0,1,4.6,28A88.1,88.1,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "217",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.8",
      "y1": "146",
      "x2": "52.3",
      "y2": "68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.2",
      "y1": "146",
      "x2": "114.7",
      "y2": "223.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "217",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.8",
      "y1": "146",
      "x2": "52.3",
      "y2": "68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.2",
      "y1": "146",
      "x2": "114.7",
      "y2": "223.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "217",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96.8",
      "y1": "146",
      "x2": "52.3",
      "y2": "68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.2",
      "y1": "146",
      "x2": "114.7",
      "y2": "223.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$83 = [];
/* style */

const __vue_inject_styles__$83 = undefined;
/* scoped */

const __vue_scope_id__$83 = undefined;
/* module identifier */

const __vue_module_identifier__$83 = undefined;
/* functional template */

const __vue_is_functional_template__$83 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$83 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$83,
  staticRenderFns: __vue_staticRenderFns__$83
}, __vue_inject_styles__$83, __vue_script__$83, __vue_scope_id__$83, __vue_is_functional_template__$83, __vue_module_identifier__$83, false, undefined, undefined, undefined);

var script$82 = Vue.extend({
  name: "PhGoogleLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$82 = script$82;
/* template */

var __vue_render__$82 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,184A80,80,0,1,1,184.6,71.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,1,0,191.5,136H128a8,8,0,0,1,0-16h72a8,8,0,0,1,8,8A80.1,80.1,0,0,1,128,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$82 = [];
/* style */

const __vue_inject_styles__$82 = undefined;
/* scoped */

const __vue_scope_id__$82 = undefined;
/* module identifier */

const __vue_module_identifier__$82 = undefined;
/* functional template */

const __vue_is_functional_template__$82 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$82 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$82,
  staticRenderFns: __vue_staticRenderFns__$82
}, __vue_inject_styles__$82, __vue_script__$82, __vue_scope_id__$82, __vue_is_functional_template__$82, __vue_module_identifier__$82, false, undefined, undefined, undefined);

var script$81 = Vue.extend({
  name: "PhGooglePhotosLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$81 = script$81;
/* template */

var __vue_render__$81 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,124H24A60,60,0,0,1,132,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,132H232a60,60,0,0,1-108,36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,124H24A60,60,0,0,1,132,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,132H232a60,60,0,0,1-108,36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,124H187a67.4,67.4,0,0,0,13-40,68.1,68.1,0,0,0-68-68,8,8,0,0,0-8,8V69A67.4,67.4,0,0,0,84,56a68.1,68.1,0,0,0-68,68,8,8,0,0,0,8,8H69a67.4,67.4,0,0,0-13,40,68.1,68.1,0,0,0,68,68,8,8,0,0,0,8-8V187a67.4,67.4,0,0,0,40,13,68.1,68.1,0,0,0,68-68A8,8,0,0,0,232,124ZM84,72a51.5,51.5,0,0,1,40,18.8V116H32.6A52.1,52.1,0,0,1,84,72Zm88,112a51.5,51.5,0,0,1-40-18.8V140h91.4A52.1,52.1,0,0,1,172,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,124H24A60,60,0,0,1,132,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,132H232a60,60,0,0,1-108,36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,124H24A60,60,0,0,1,132,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,132H232a60,60,0,0,1-108,36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,132V24a60,60,0,0,1,36,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,124H24A60,60,0,0,1,132,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,124V232A60,60,0,0,1,88,124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,132H232a60,60,0,0,1-108,36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$81 = [];
/* style */

const __vue_inject_styles__$81 = undefined;
/* scoped */

const __vue_scope_id__$81 = undefined;
/* module identifier */

const __vue_module_identifier__$81 = undefined;
/* functional template */

const __vue_is_functional_template__$81 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$81 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$81,
  staticRenderFns: __vue_staticRenderFns__$81
}, __vue_inject_styles__$81, __vue_script__$81, __vue_scope_id__$81, __vue_is_functional_template__$81, __vue_module_identifier__$81, false, undefined, undefined, undefined);

var script$80 = Vue.extend({
  name: "PhGooglePlayLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$80 = script$80;
/* template */

var __vue_render__$80 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "26.2",
      "x2": "175.9",
      "y2": "159.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "229.8",
      "x2": "175.9",
      "y2": "96.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.2,26.2a8.1,8.1,0,0,0-2.4,5.7V224.1a8.1,8.1,0,0,0,2.4,5.7h0L144,128,42.2,26.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "26.2",
      "x2": "175.9",
      "y2": "159.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "229.8",
      "x2": "175.9",
      "y2": "96.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.6,114.2,55.9,18.1a16.2,16.2,0,0,0-16.2.1,15.8,15.8,0,0,0-7.9,13.7V224.1a16,16,0,0,0,16,15.9,16.9,16.9,0,0,0,8.1-2.1l167.7-96.1a15.7,15.7,0,0,0,0-27.6ZM144,139.3l18.9,18.9L74.7,208.6Zm-69.3-92,88.2,50.5L144,116.7ZM177.2,149.9,155.3,128l21.9-21.9L215.6,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "26.2",
      "x2": "175.9",
      "y2": "159.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "229.8",
      "x2": "175.9",
      "y2": "96.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "26.2",
      "x2": "175.9",
      "y2": "159.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "229.8",
      "x2": "175.9",
      "y2": "96.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "26.2",
      "x2": "175.9",
      "y2": "159.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.2",
      "y1": "229.8",
      "x2": "175.9",
      "y2": "96.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$80 = [];
/* style */

const __vue_inject_styles__$80 = undefined;
/* scoped */

const __vue_scope_id__$80 = undefined;
/* module identifier */

const __vue_module_identifier__$80 = undefined;
/* functional template */

const __vue_is_functional_template__$80 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$80 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$80,
  staticRenderFns: __vue_staticRenderFns__$80
}, __vue_inject_styles__$80, __vue_script__$80, __vue_scope_id__$80, __vue_is_functional_template__$80, __vue_module_identifier__$80, false, undefined, undefined, undefined);

var script$7$ = Vue.extend({
  name: "PhGooglePodcastsLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7$ = script$7$;
/* template */

var __vue_render__$7$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "68",
      "x2": "176",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "68",
      "x2": "80",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "132",
      "x2": "176",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "116",
      "x2": "32",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "164",
      "x2": "80",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "68",
      "x2": "176",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "68",
      "x2": "80",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "124",
      "x2": "176",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "116",
      "x2": "32",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "164",
      "x2": "80",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,24V48a8,8,0,0,1-16,0V24a8,8,0,0,1,16,0Zm40,36a8,8,0,0,0-8,8V92a8,8,0,0,0,16,0V68A8,8,0,0,0,176,60ZM128,200a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V208A8,8,0,0,0,128,200Zm0-128a8,8,0,0,0-8,8v96a8,8,0,0,0,16,0V80A8,8,0,0,0,128,72ZM80,60a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V68A8,8,0,0,0,80,60Zm96,56a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V124A8,8,0,0,0,176,116ZM32,108a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,32,108Zm48,48a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V164A8,8,0,0,0,80,156Zm144-48a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,224,108Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "68",
      "x2": "176",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "68",
      "x2": "80",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "124",
      "x2": "176",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "116",
      "x2": "32",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "164",
      "x2": "80",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "68",
      "x2": "176",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "68",
      "x2": "80",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "124",
      "x2": "176",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "116",
      "x2": "32",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "164",
      "x2": "80",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "68",
      "x2": "176",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "68",
      "x2": "80",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "124",
      "x2": "176",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "116",
      "x2": "32",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "164",
      "x2": "80",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7$ = [];
/* style */

const __vue_inject_styles__$7$ = undefined;
/* scoped */

const __vue_scope_id__$7$ = undefined;
/* module identifier */

const __vue_module_identifier__$7$ = undefined;
/* functional template */

const __vue_is_functional_template__$7$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7$,
  staticRenderFns: __vue_staticRenderFns__$7$
}, __vue_inject_styles__$7$, __vue_script__$7$, __vue_scope_id__$7$, __vue_is_functional_template__$7$, __vue_module_identifier__$7$, false, undefined, undefined, undefined);

var script$7_ = Vue.extend({
  name: "PhGradient",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7_ = script$7_;
/* template */

var __vue_render__$7_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "108",
      "x2": "108",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "108",
      "x2": "224",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "148",
      "x2": "68",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188",
      "y1": "148",
      "x2": "224",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "148",
      "x2": "148",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "188",
      "x2": "52",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "188",
      "x2": "108",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "188",
      "x2": "164",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "188",
      "x2": "224",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "68",
      "x2": "224",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "76",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "56",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "112",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "168",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "224",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,104a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H32A8,8,0,0,1,24,104Zm200-8H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16ZM84,144a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H76A8,8,0,0,0,84,144Zm140-8H180a8,8,0,0,0,0,16h44a8,8,0,0,0,0-16ZM96,144a8,8,0,0,0,8,8h48a8,8,0,0,0,0-16H104A8,8,0,0,0,96,144ZM56,176H32a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm56,0H88a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm56,0H144a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm56,0H200a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM32,72H224a8,8,0,0,0,0-16H32a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "76",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "56",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "112",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "168",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "224",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "76",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "56",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "112",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "168",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "224",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "112",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "76",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "144",
      "x2": "224",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "144",
      "x2": "152",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "56",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "184",
      "x2": "112",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "168",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "224",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7_ = [];
/* style */

const __vue_inject_styles__$7_ = undefined;
/* scoped */

const __vue_scope_id__$7_ = undefined;
/* module identifier */

const __vue_module_identifier__$7_ = undefined;
/* functional template */

const __vue_is_functional_template__$7_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7_,
  staticRenderFns: __vue_staticRenderFns__$7_
}, __vue_inject_styles__$7_, __vue_script__$7_, __vue_scope_id__$7_, __vue_is_functional_template__$7_, __vue_module_identifier__$7_, false, undefined, undefined, undefined);

var script$7Z = Vue.extend({
  name: "PhGraduationCap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Z = script$7Z;
/* template */

var __vue_render__$7Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "12 96 128 32 244 96 128 160 12 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "186 240 186 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,107v58.2a7.8,7.8,0,0,1-1.9,5.1c-7.7,9.1-39,41.7-94.1,41.7s-86.4-32.6-94.1-41.7a7.8,7.8,0,0,1-1.9-5.1V107",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36,110.9v54.6a7.8,7.8,0,0,0,1.6,4.7c6.7,9,35.1,41.8,90.4,41.8s83.7-32.8,90.4-41.8a7.8,7.8,0,0,0,1.6-4.7V110.9L128,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,209.6a119.4,119.4,0,0,0,16-8.5V240a8,8,0,0,1-16,0ZM120.9,92.2a8.2,8.2,0,0,0,3.3,10.9L171,128l17-9.1-56.2-30A8.2,8.2,0,0,0,120.9,92.2Zm130.9-3.3-120-64a8.5,8.5,0,0,0-7.6,0l-120,64a8.1,8.1,0,0,0,0,14.2L28,115.7v49.8a15.5,15.5,0,0,0,3.2,9.5c7.9,10.6,38.3,45,96.8,45a128.7,128.7,0,0,0,52-10.5V132.8l-9-4.8-43,22.9-88.2-47h0L25,96,128,41.1,231,96l-14.8,7.9h0l-28.2,15,3.8,2a8.4,8.4,0,0,1,3.2,3.3,7.5,7.5,0,0,1,1,3.8v73.1A111.8,111.8,0,0,0,224.8,175a15.5,15.5,0,0,0,3.2-9.5V115.7l23.8-12.6a8.1,8.1,0,0,0,0-14.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "8 96 128 32 248 96 128 160 8 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "188 240 188 128 128 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Z = [];
/* style */

const __vue_inject_styles__$7Z = undefined;
/* scoped */

const __vue_scope_id__$7Z = undefined;
/* module identifier */

const __vue_module_identifier__$7Z = undefined;
/* functional template */

const __vue_is_functional_template__$7Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Z,
  staticRenderFns: __vue_staticRenderFns__$7Z
}, __vue_inject_styles__$7Z, __vue_script__$7Z, __vue_scope_id__$7Z, __vue_is_functional_template__$7Z, __vue_module_identifier__$7Z, false, undefined, undefined, undefined);

var script$7Y = Vue.extend({
  name: "PhGraph",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Y = script$7Y;
/* template */

var __vue_render__$7Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "100",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "188",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "118.3",
      "y1": "106.1",
      "x2": "105.7",
      "y2": "77.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.1",
      "y1": "143.9",
      "x2": "73.9",
      "y2": "176.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "172.6",
      "x2": "146.4",
      "y2": "143.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "177.6",
      "y1": "108.7",
      "x2": "150.4",
      "y2": "119.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "104",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "184",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "118.3",
      "y1": "106.1",
      "x2": "105.7",
      "y2": "77.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "177.2",
      "y1": "111.6",
      "x2": "150.8",
      "y2": "120.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.1",
      "y1": "169.3",
      "x2": "146.9",
      "y2": "142.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.1",
      "y1": "143.9",
      "x2": "73.9",
      "y2": "176.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,152a31.7,31.7,0,0,0-19.5,6.7l-23.1-18A31.7,31.7,0,0,0,160,128a16.2,16.2,0,0,0-.1-2.2l13.3-4.4A31.9,31.9,0,1,0,168,104a16.2,16.2,0,0,0,.1,2.2l-13.3,4.4A31.9,31.9,0,0,0,128,96a45.5,45.5,0,0,0-5.3.4L115.9,81A31.7,31.7,0,0,0,128,56,32,32,0,1,0,96,88a45.5,45.5,0,0,0,5.3-.4l6.8,15.4A31.7,31.7,0,0,0,96,128a32.4,32.4,0,0,0,3.5,14.6L73.8,165.4A32,32,0,1,0,88,192a32.4,32.4,0,0,0-3.5-14.6l25.7-22.8a31.9,31.9,0,0,0,37.3-1.3l23.1,18A31.7,31.7,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "104",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "184",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "118.3",
      "y1": "106.1",
      "x2": "105.7",
      "y2": "77.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "177.2",
      "y1": "111.6",
      "x2": "150.8",
      "y2": "120.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.1",
      "y1": "169.3",
      "x2": "146.9",
      "y2": "142.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.1",
      "y1": "143.9",
      "x2": "73.9",
      "y2": "176.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "104",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "184",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "118.3",
      "y1": "106.1",
      "x2": "105.7",
      "y2": "77.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "177.2",
      "y1": "111.6",
      "x2": "150.8",
      "y2": "120.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.1",
      "y1": "169.3",
      "x2": "146.9",
      "y2": "142.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.1",
      "y1": "143.9",
      "x2": "73.9",
      "y2": "176.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "104",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "184",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "118.3",
      "y1": "106.1",
      "x2": "105.7",
      "y2": "77.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "177.2",
      "y1": "111.6",
      "x2": "150.8",
      "y2": "120.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.1",
      "y1": "169.3",
      "x2": "146.9",
      "y2": "142.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.1",
      "y1": "143.9",
      "x2": "73.9",
      "y2": "176.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Y = [];
/* style */

const __vue_inject_styles__$7Y = undefined;
/* scoped */

const __vue_scope_id__$7Y = undefined;
/* module identifier */

const __vue_module_identifier__$7Y = undefined;
/* functional template */

const __vue_is_functional_template__$7Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Y,
  staticRenderFns: __vue_staticRenderFns__$7Y
}, __vue_inject_styles__$7Y, __vue_script__$7Y, __vue_scope_id__$7Y, __vue_is_functional_template__$7Y, __vue_module_identifier__$7Y, false, undefined, undefined, undefined);

var script$7X = Vue.extend({
  name: "PhGridFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7X = script$7X;
/* template */

var __vue_render__$7X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128H44V52a8,8,0,0,1,8-8h76Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Zm0,92H128V52h76ZM52,128h76v76H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "128",
      "x2": "44",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7X = [];
/* style */

const __vue_inject_styles__$7X = undefined;
/* scoped */

const __vue_scope_id__$7X = undefined;
/* module identifier */

const __vue_module_identifier__$7X = undefined;
/* functional template */

const __vue_is_functional_template__$7X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7X,
  staticRenderFns: __vue_staticRenderFns__$7X
}, __vue_inject_styles__$7X, __vue_script__$7X, __vue_scope_id__$7X, __vue_is_functional_template__$7X, __vue_module_identifier__$7X, false, undefined, undefined, undefined);

var script$7W = Vue.extend({
  name: "PhHamburger",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7W = script$7W;
/* template */

var __vue_render__$7W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,112a80,80,0,0,1,160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,160v24a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 168 68 152 108 168 148 152 188 168 228 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "112",
      "x2": "232",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,160l40,16,40-16,40,16,20-8v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 176 68 160 108 176 148 160 188 176 228 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.4,98.1a16.3,16.3,0,0,1-3.2-13.5C40.5,49.5,80.4,24,128,24s87.5,25.5,94.8,60.6A16,16,0,0,1,207.2,104H48.8A16.2,16.2,0,0,1,36.4,98.1ZM225,152.6l-20.1,8h0L188,167.4l-37-14.8a7.8,7.8,0,0,0-6,0l-37,14.8L71,152.6a7.8,7.8,0,0,0-6,0l-20.1,8h0l-19.9,8A8,8,0,0,0,28,184a8,8,0,0,0,3-.6l9-3.6V184a40,40,0,0,0,40,40h96a40,40,0,0,0,40-40V173.4l15-6a8,8,0,0,0-6-14.8Zm7-32.6H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 176 68 160 108 176 148 160 188 176 228 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 176 68 160 108 176 148 160 188 176 228 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 176 68 160 108 176 148 160 188 176 228 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7W = [];
/* style */

const __vue_inject_styles__$7W = undefined;
/* scoped */

const __vue_scope_id__$7W = undefined;
/* module identifier */

const __vue_module_identifier__$7W = undefined;
/* functional template */

const __vue_is_functional_template__$7W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7W,
  staticRenderFns: __vue_staticRenderFns__$7W
}, __vue_inject_styles__$7W, __vue_script__$7W, __vue_scope_id__$7W, __vue_is_functional_template__$7W, __vue_module_identifier__$7W, false, undefined, undefined, undefined);

var script$7V = Vue.extend({
  name: "PhHand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7V = script$7V;
/* template */

var __vue_render__$7V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V36a20,20,0,0,0-40,0V52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52V36a20,20,0,0,1,40,0V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V36a20,20,0,0,0-40,0V52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,40a28.2,28.2,0,0,0-12,2.7V36a28,28,0,0,0-54.6-8.6A27.8,27.8,0,0,0,108,24,28.1,28.1,0,0,0,80,52v75.4l-7-12.1A28,28,0,0,0,24.3,143c32.5,68.4,54.1,97,103.7,97a88.1,88.1,0,0,0,88-88V68A28.1,28.1,0,0,0,188,40Zm12,112a72.1,72.1,0,0,1-72,72c-20.2,0-34.2-5.5-47-18.2S56.3,173,38.7,135.9l-.3-.6a11.6,11.6,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,11.6,11.6,0,0,1,7.2,5.6l22,38a8.1,8.1,0,0,0,9,3.7,7.9,7.9,0,0,0,5.9-7.7V52a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v84a8,8,0,0,0,16,0V68a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V36a20,20,0,0,0-40,0V52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V36a20,20,0,0,0-40,0V52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V36a20,20,0,0,0-40,0V52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7V = [];
/* style */

const __vue_inject_styles__$7V = undefined;
/* scoped */

const __vue_scope_id__$7V = undefined;
/* module identifier */

const __vue_module_identifier__$7V = undefined;
/* functional template */

const __vue_is_functional_template__$7V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7V,
  staticRenderFns: __vue_staticRenderFns__$7V
}, __vue_inject_styles__$7V, __vue_script__$7V, __vue_scope_id__$7V, __vue_is_functional_template__$7V, __vue_module_identifier__$7V, false, undefined, undefined, undefined);

var script$7U = Vue.extend({
  name: "PhHandEye",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7U = script$7U;
/* template */

var __vue_render__$7U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "184",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,168s-8-28-40-28-40,28-40,28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,92a20.1,20.1,0,0,0-20,20V52a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V68a20,20,0,0,0-40,0v84a80,80,0,0,0,160,0V112A20.1,20.1,0,0,0,188,92Zm-14.6,80.4c-5.7,8.8-20.8,27.6-45.4,27.6s-39.7-18.8-45.4-27.6a8.2,8.2,0,0,1,0-8.8c5.7-8.8,20.8-27.6,45.4-27.6s39.7,18.8,45.4,27.6A8.2,8.2,0,0,1,173.4,172.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,84a28.2,28.2,0,0,0-12,2.7V52a28.1,28.1,0,0,0-28-28,27.8,27.8,0,0,0-13.4,3.4A28,28,0,0,0,80,36v6.7A28,28,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.1,28.1,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v64a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0Zm-72-16c-26.7,0-43,20.6-48.8,29.4a12.1,12.1,0,0,0,0,13.2C85,187.4,101.3,208,128,208s43-20.6,48.8-29.4a12.1,12.1,0,0,0,0-13.2C171,156.6,154.7,136,128,136Zm0,52a16,16,0,1,1,16-16A16,16,0,0,1,128,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7U = [];
/* style */

const __vue_inject_styles__$7U = undefined;
/* scoped */

const __vue_scope_id__$7U = undefined;
/* module identifier */

const __vue_module_identifier__$7U = undefined;
/* functional template */

const __vue_is_functional_template__$7U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7U,
  staticRenderFns: __vue_staticRenderFns__$7U
}, __vue_inject_styles__$7U, __vue_script__$7U, __vue_scope_id__$7U, __vue_is_functional_template__$7U, __vue_module_identifier__$7U, false, undefined, undefined, undefined);

var script$7T = Vue.extend({
  name: "PhHandFist",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7T = script$7T;
/* template */

var __vue_render__$7T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88h24a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0V64a24,24,0,0,1,48,0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,80H184V64a32,32,0,0,0-56-21.1A31.8,31.8,0,0,0,104,32,32.1,32.1,0,0,0,72.2,60.4,32,32,0,0,0,24,88v40a104,104,0,0,0,208,0V112A32.1,32.1,0,0,0,200,80ZM152,48a16,16,0,0,1,16,16V80H136V64A16,16,0,0,1,152,48ZM88,64a16,16,0,0,1,32,0v40a16,16,0,0,1-32,0ZM40,88a16,16,0,0,1,32,0v16a16,16,0,0,1-32,0Zm88,128a88,88,0,0,1-87.9-84.2A32,32,0,0,0,80,125.1a31.9,31.9,0,0,0,44.6,3.4,32.3,32.3,0,0,0,11.8,11.4A47.7,47.7,0,0,0,120,176a8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,8,8,0,0,0,0-16H152a16,16,0,0,1-16-16V96h64a16,16,0,0,1,16,16v16A88.1,88.1,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,64a24,24,0,0,1,48,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7T = [];
/* style */

const __vue_inject_styles__$7T = undefined;
/* scoped */

const __vue_scope_id__$7T = undefined;
/* module identifier */

const __vue_module_identifier__$7T = undefined;
/* functional template */

const __vue_is_functional_template__$7T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7T,
  staticRenderFns: __vue_staticRenderFns__$7T
}, __vue_inject_styles__$7T, __vue_script__$7T, __vue_scope_id__$7T, __vue_is_functional_template__$7T, __vue_module_identifier__$7T, false, undefined, undefined, undefined);

var script$7S = Vue.extend({
  name: "PhHandGrabbing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7S = script$7S;
/* template */

var __vue_render__$7S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,92a20,20,0,0,0-40,0v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,108V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0V92a20,20,0,0,0-40,0,20,20,0,0,0-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,92a20,20,0,0,0-40,0v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,108V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,80a27.8,27.8,0,0,0-13.4,3.4,28,28,0,0,0-46.6-11A28,28,0,0,0,80,92v16H68a28.1,28.1,0,0,0-28,28v16a88,88,0,0,0,176,0V108A28.1,28.1,0,0,0,188,80Zm12,72a72,72,0,0,1-144,0V136a12,12,0,0,1,12-12H80v24a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V108a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,92a20,20,0,0,0-40,0v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,108V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,92a20,20,0,0,0-40,0v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,108V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,92a20,20,0,0,0-40,0v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,108V92a20,20,0,0,0-40,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7S = [];
/* style */

const __vue_inject_styles__$7S = undefined;
/* scoped */

const __vue_scope_id__$7S = undefined;
/* module identifier */

const __vue_module_identifier__$7S = undefined;
/* functional template */

const __vue_is_functional_template__$7S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7S,
  staticRenderFns: __vue_staticRenderFns__$7S
}, __vue_inject_styles__$7S, __vue_script__$7S, __vue_scope_id__$7S, __vue_is_functional_template__$7S, __vue_module_identifier__$7S, false, undefined, undefined, undefined);

var script$7R = Vue.extend({
  name: "PhHandPalm",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7R = script$7R;
/* template */

var __vue_render__$7R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0V36a20,20,0,0,1,40,0V52a20,20,0,0,1,40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,84a28.2,28.2,0,0,0-12,2.7V52a28.1,28.1,0,0,0-28-28,27.8,27.8,0,0,0-13.4,3.4A28,28,0,0,0,80,36v6.7A28,28,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.1,28.1,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v72.7A48,48,0,0,0,120,172a8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,8,8,0,0,0,8-8V112a12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,52a20,20,0,0,1,40,0v60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68V36a20,20,0,0,1,40,0v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7R = [];
/* style */

const __vue_inject_styles__$7R = undefined;
/* scoped */

const __vue_scope_id__$7R = undefined;
/* module identifier */

const __vue_module_identifier__$7R = undefined;
/* functional template */

const __vue_is_functional_template__$7R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7R,
  staticRenderFns: __vue_staticRenderFns__$7R
}, __vue_inject_styles__$7R, __vue_script__$7R, __vue_scope_id__$7R, __vue_is_functional_template__$7R, __vue_module_identifier__$7R, false, undefined, undefined, undefined);

var script$7Q = Vue.extend({
  name: "PhHandPointing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7Q = script$7Q;
/* template */

var __vue_render__$7Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,84a27.6,27.6,0,0,0-14.6,4.1A28.1,28.1,0,0,0,136,74.7V36a28,28,0,0,0-56,0v91.4l-7-12.1A28,28,0,0,0,24.3,143c32.5,68.4,54.1,97,103.7,97a88.1,88.1,0,0,0,88-88V112A28.1,28.1,0,0,0,188,84Zm12,68a72.1,72.1,0,0,1-72,72c-20.2,0-34.2-5.5-47-18.2S56.3,173,38.7,135.9l-.3-.6a11.6,11.6,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,11.6,11.6,0,0,1,7.2,5.6l22,38a8.1,8.1,0,0,0,9,3.7,7.9,7.9,0,0,0,5.9-7.7V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v12a8,8,0,0,0,16,0,12,12,0,0,1,24,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7Q = [];
/* style */

const __vue_inject_styles__$7Q = undefined;
/* scoped */

const __vue_scope_id__$7Q = undefined;
/* module identifier */

const __vue_module_identifier__$7Q = undefined;
/* functional template */

const __vue_is_functional_template__$7Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7Q,
  staticRenderFns: __vue_staticRenderFns__$7Q
}, __vue_inject_styles__$7Q, __vue_script__$7Q, __vue_scope_id__$7Q, __vue_is_functional_template__$7Q, __vue_module_identifier__$7Q, false, undefined, undefined, undefined);

var script$7P = Vue.extend({
  name: "PhHandSoap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7P = script$7P;
/* template */

var __vue_render__$7P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,108h96a32,32,0,0,1,32,32v76a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V140A32,32,0,0,1,80,108Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,108V92a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,96.8V88a32.1,32.1,0,0,0-32-32H136V32h32a8,8,0,0,1,8,8,8,8,0,0,0,16,0,24.1,24.1,0,0,0-24-24H104a8,8,0,0,0,0,16h16V56H104A32.1,32.1,0,0,0,72,88v8.8A40.1,40.1,0,0,0,40,136v80a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136A40.1,40.1,0,0,0,184,96.8ZM104,72h48a16,16,0,0,1,16,16v8H88V88A16,16,0,0,1,104,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40a16,16,0,0,0-16-16H104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7P = [];
/* style */

const __vue_inject_styles__$7P = undefined;
/* scoped */

const __vue_scope_id__$7P = undefined;
/* module identifier */

const __vue_module_identifier__$7P = undefined;
/* functional template */

const __vue_is_functional_template__$7P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7P,
  staticRenderFns: __vue_staticRenderFns__$7P
}, __vue_inject_styles__$7P, __vue_script__$7P, __vue_scope_id__$7P, __vue_is_functional_template__$7P, __vue_module_identifier__$7P, false, undefined, undefined, undefined);

var script$7O = Vue.extend({
  name: "PhHandWaving",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7O = script$7O;
/* template */

var __vue_render__$7O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,23a60.1,60.1,0,0,1,52,30",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M66.9,240a121.1,121.1,0,0,1-26.8-32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.6,93.3a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l-16-27.7A20,20,0,0,1,86,47.5l8,13.9a20,20,0,0,1,34.6-20Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.1,240A110.3,110.3,0,0,1,48,204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31a51.7,51.7,0,0,1,45,26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.2,104l-20-34.7a28.1,28.1,0,0,0-47.3-1.9l-17.3-30A28.1,28.1,0,0,0,97.3,27.1a29.4,29.4,0,0,0-9.9,9.6,27.9,27.9,0,0,0-11.5-6.2,27.1,27.1,0,0,0-21.2,2.8A27.9,27.9,0,0,0,44.4,71.5l3.4,5.8A28.5,28.5,0,0,0,36,81a28.1,28.1,0,0,0-10.2,38.2l42,72.8a88,88,0,1,0,152.4-88Zm-6.7,62.6A71.2,71.2,0,0,1,180,210.3,72.1,72.1,0,0,1,81.6,184l-42-72.8a12,12,0,0,1,20.8-12l22,38.1a8,8,0,1,0,13.9-8l-22-38.1h0l-16-27.7a12,12,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,12.5,12.5,0,0,1,7.3,5.6L87,65.4h.1l26,45a7.7,7.7,0,0,0,6.9,4,7.3,7.3,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9l-26-45h0a12,12,0,1,1,20.8-12l30,51.9h0l6.3,11a48.1,48.1,0,0,0-10.9,61,8,8,0,0,0,13.8-8,32,32,0,0,1,11.7-43.7,8.1,8.1,0,0,0,3.8-4.9,8.4,8.4,0,0,0-.8-6l-10-17.4a12,12,0,0,1,13.5-17.5,11.8,11.8,0,0,1,7.2,5.5l20,34.7A70.9,70.9,0,0,1,213.5,166.6Zm-125.8,78a8.2,8.2,0,0,1-6.6,3.4,8.6,8.6,0,0,1-4.6-1.4A117.9,117.9,0,0,1,41.1,208a8,8,0,1,1,13.8-8,102.6,102.6,0,0,0,30.8,33.4A8.1,8.1,0,0,1,87.7,244.6ZM168,31a8,8,0,0,1,8-8h0a60.2,60.2,0,0,1,52,30,7.9,7.9,0,0,1-3,10.9,7.1,7.1,0,0,1-4,1.1,8,8,0,0,1-6.9-4A44,44,0,0,0,176,39,8,8,0,0,1,168,31Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.1,240A110.3,110.3,0,0,1,48,204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31a51.7,51.7,0,0,1,45,26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.1,240A110.3,110.3,0,0,1,48,204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31a51.7,51.7,0,0,1,45,26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.1,240A110.3,110.3,0,0,1,48,204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,31a51.7,51.7,0,0,1,45,26",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7O = [];
/* style */

const __vue_inject_styles__$7O = undefined;
/* scoped */

const __vue_scope_id__$7O = undefined;
/* module identifier */

const __vue_module_identifier__$7O = undefined;
/* functional template */

const __vue_is_functional_template__$7O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7O,
  staticRenderFns: __vue_staticRenderFns__$7O
}, __vue_inject_styles__$7O, __vue_script__$7O, __vue_scope_id__$7O, __vue_is_functional_template__$7O, __vue_module_identifier__$7O, false, undefined, undefined, undefined);

var script$7N = Vue.extend({
  name: "PhHandbag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7N = script$7N;
/* template */

var __vue_render__$7N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239,206.2l-14.3-128A15.9,15.9,0,0,0,208.8,64H175.3a48,48,0,0,0-94.6,0H47.2A15.9,15.9,0,0,0,31.3,78.2L17,206.2a16.2,16.2,0,0,0,4,12.5A15.9,15.9,0,0,0,32.9,224H223.1a15.9,15.9,0,0,0,11.9-5.3A16.2,16.2,0,0,0,239,206.2ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7N = [];
/* style */

const __vue_inject_styles__$7N = undefined;
/* scoped */

const __vue_scope_id__$7N = undefined;
/* module identifier */

const __vue_module_identifier__$7N = undefined;
/* functional template */

const __vue_is_functional_template__$7N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7N,
  staticRenderFns: __vue_staticRenderFns__$7N
}, __vue_inject_styles__$7N, __vue_script__$7N, __vue_scope_id__$7N, __vue_is_functional_template__$7N, __vue_module_identifier__$7N, false, undefined, undefined, undefined);

var script$7M = Vue.extend({
  name: "PhHandbagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7M = script$7M;
/* template */

var __vue_render__$7M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239,206.2l-14.3-128A15.9,15.9,0,0,0,208.8,64H175.3a48,48,0,0,0-94.6,0H47.2A15.9,15.9,0,0,0,31.3,78.2L17,206.2a16.2,16.2,0,0,0,4,12.5A15.9,15.9,0,0,0,32.9,224H223.1a15.9,15.9,0,0,0,11.9-5.3A16.2,16.2,0,0,0,239,206.2ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7M = [];
/* style */

const __vue_inject_styles__$7M = undefined;
/* scoped */

const __vue_scope_id__$7M = undefined;
/* module identifier */

const __vue_module_identifier__$7M = undefined;
/* functional template */

const __vue_is_functional_template__$7M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7M,
  staticRenderFns: __vue_staticRenderFns__$7M
}, __vue_inject_styles__$7M, __vue_script__$7M, __vue_scope_id__$7M, __vue_is_functional_template__$7M, __vue_module_identifier__$7M, false, undefined, undefined, undefined);

var script$7L = Vue.extend({
  name: "PhHandsClapping",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7L = script$7L;
/* template */

var __vue_render__$7L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,114.4l-26-45a20,20,0,0,1,34.6-20l40,69.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.4,148.3l-42-72.8A20,20,0,0,1,78,55.5l42,72.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168.6,132.5l-18-31.2a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,66.7,196l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "12",
      "x2": "156",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204",
      "y1": "24.9",
      "x2": "196",
      "y2": "38.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "239.1",
      "y1": "60",
      "x2": "225.3",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77,93.5,69,79.7a17.6,17.6,0,0,0-9.1-7.8h0l-2.4-4.1a18,18,0,1,1,31.2-18L99,67.7h0A18,18,0,0,0,77,93.5",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,94.7a18,18,0,0,0-22,25.8l-26-45A17.9,17.9,0,0,0,99,67.7h0l-2.3-4a18,18,0,1,1,31.2-18l28.3,49Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,90.7a18,18,0,1,1,31.2-18l17,29.4A72.1,72.1,0,0,1,188,191.5h0a71.5,71.5,0,0,0-5.7-59.5l-17-29.5a18.2,18.2,0,0,0-9.1-7.8h0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.8",
      "y1": "11.3",
      "x2": "172.7",
      "y2": "26.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.1",
      "y1": "25.4",
      "x2": "197.9",
      "y2": "38.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6",
      "y1": "48.9",
      "x2": "217.5",
      "y2": "58.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.5,100.1l-17-29.4a21.9,21.9,0,0,0-30-8.1A21.5,21.5,0,0,0,148.9,74L131.3,43.7a21.9,21.9,0,0,0-30-8.1A21.5,21.5,0,0,0,91.7,47a22.1,22.1,0,0,0-29.6-7.3A21.9,21.9,0,0,0,51.9,53.1a20.9,20.9,0,0,0-.4,9.6,26.5,26.5,0,0,0-11.1,3.4,26.1,26.1,0,0,0-9.5,35.6l2,3.4a24.3,24.3,0,0,0-9.7,3.3,26,26,0,0,0-9.5,35.5l37,64.1a80,80,0,0,0,146.6-19.3l.3-1.3A76.5,76.5,0,0,0,205.5,100.1Zm-23.7,84.5A63.3,63.3,0,0,1,152,223.4,64,64,0,0,1,64.6,200l-37-64.1a10,10,0,0,1,11.2-14.7,10.3,10.3,0,0,1,6.1,4.7h0l24,41.6a8.2,8.2,0,0,0,6.9,4,8,8,0,0,0,6.9-12l-38-65.8a10,10,0,0,1,17.4-10l38,65.8a8,8,0,1,0,13.8-8l-30-52h0a10.1,10.1,0,0,1,3.7-13.7,10,10,0,0,1,13.6,3.7l42,72.8a8.2,8.2,0,0,0,7,4,8.6,8.6,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9l-16-27.8h0a9.9,9.9,0,0,1-1-7.5,9.6,9.6,0,0,1,4.7-6.1,9.4,9.4,0,0,1,7.5-1,9.8,9.8,0,0,1,6.1,4.6l17,29.5A63.5,63.5,0,0,1,181.8,184.6ZM165,24.7l4.1-15.5a8,8,0,1,1,15.5,4.1l-4.2,15.5a7.9,7.9,0,0,1-7.7,5.9l-2.1-.2A8,8,0,0,1,165,24.7Zm26.3,9.2,9.2-13.1a8.1,8.1,0,0,1,11.2-2A8,8,0,0,1,213.6,30l-9.2,13.1A7.9,7.9,0,0,1,193.3,45,8,8,0,0,1,191.3,33.9Zm43.9,21.6-13.1,9.2a8.6,8.6,0,0,1-4.6,1.4,8,8,0,0,1-4.6-14.5L226,42.4a8,8,0,0,1,11.2,1.9A8.1,8.1,0,0,1,235.2,55.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.8",
      "y1": "11.3",
      "x2": "172.7",
      "y2": "26.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.1",
      "y1": "25.4",
      "x2": "197.9",
      "y2": "38.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6",
      "y1": "48.9",
      "x2": "217.5",
      "y2": "58.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.8",
      "y1": "11.3",
      "x2": "172.7",
      "y2": "26.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.1",
      "y1": "25.4",
      "x2": "197.9",
      "y2": "38.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6",
      "y1": "48.9",
      "x2": "217.5",
      "y2": "58.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176.8",
      "y1": "11.3",
      "x2": "172.7",
      "y2": "26.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "207.1",
      "y1": "25.4",
      "x2": "197.9",
      "y2": "38.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.6",
      "y1": "48.9",
      "x2": "217.5",
      "y2": "58.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7L = [];
/* style */

const __vue_inject_styles__$7L = undefined;
/* scoped */

const __vue_scope_id__$7L = undefined;
/* module identifier */

const __vue_module_identifier__$7L = undefined;
/* functional template */

const __vue_is_functional_template__$7L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7L,
  staticRenderFns: __vue_staticRenderFns__$7L
}, __vue_inject_styles__$7L, __vue_script__$7L, __vue_scope_id__$7L, __vue_is_functional_template__$7L, __vue_module_identifier__$7L, false, undefined, undefined, undefined);

var script$7K = Vue.extend({
  name: "PhHandshake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7K = script$7K;
/* template */

var __vue_render__$7K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.7,121.8,212,134.1,180,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,236.7,121.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,133.1,19.3,120.7a7.9,7.9,0,0,1-3.5-10.8L40.4,62.8A8,8,0,0,1,51,59.3L76,71.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,134.1l-12,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L44,133.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.6,71.8l47.3-15a8,8,0,0,1,5.5.4L164,72.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,220.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L52,192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,152.9l-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1,72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9H143.3a7.9,7.9,0,0,0-5.6,2.3L98.5,114.3a8.1,8.1,0,0,0,.9,12.1l5.4,4.1a32.1,32.1,0,0,0,38.4,0l12.8-9.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M119.8,214.8a8.1,8.1,0,0,1-7.8,6.1,6.3,6.3,0,0,1-1.9-.3l-30.2-7.5a15.7,15.7,0,0,1-6.6-3.5L50.8,190a7.9,7.9,0,1,1,10.4-12l22.6,19.6,30.1,7.5A8.1,8.1,0,0,1,119.8,214.8Zm132.6-95.2a15.8,15.8,0,0,1-8.1,9.3L221,140.6l-14.9,17.5h-.2c0,.1-.1.1-.1.2h-.1l-36.8,36.8a16.5,16.5,0,0,1-11.4,4.7,15.8,15.8,0,0,1-3.8-.5L95.7,185a15.2,15.2,0,0,1-6-2.9l-54-42.2-24-12a16.3,16.3,0,0,1-8.1-9.4,16,16,0,0,1,1.1-12.3L29.3,59.1a16.1,16.1,0,0,1,21.3-7L73,63.3l48.7-14.2a16.6,16.6,0,0,1,11,.8l33,15h16.4l23.3-11.7a16,16,0,0,1,21.3,6.9l24.6,47.1A16.2,16.2,0,0,1,252.4,119.6Zm-64.7,34.2-31.6-23-8.1,6.1a40.2,40.2,0,0,1-48,0l-5.4-4.1a15.9,15.9,0,0,1-1.7-24.1L132,69.5l1.8-1.5-7.7-3.5L77.4,78.7,50.2,130.9l49.4,38.6L157.5,184Zm18.7-20.7L179.2,80.9H143.3L104.2,120l5.4,4.1a24.3,24.3,0,0,0,28.8,0l12.8-9.6a8,8,0,0,1,9.5-.1l38,27.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7K = [];
/* style */

const __vue_inject_styles__$7K = undefined;
/* scoped */

const __vue_scope_id__$7K = undefined;
/* module identifier */

const __vue_module_identifier__$7K = undefined;
/* functional template */

const __vue_is_functional_template__$7K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7K,
  staticRenderFns: __vue_staticRenderFns__$7K
}, __vue_inject_styles__$7K, __vue_script__$7K, __vue_scope_id__$7K, __vue_is_functional_template__$7K, __vue_module_identifier__$7K, false, undefined, undefined, undefined);

var script$7J = Vue.extend({
  name: "PhHardDrive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7J = script$7J;
/* template */

var __vue_render__$7J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "128",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,64H32A16,16,0,0,0,16,80v96a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64Zm-36,76a12,12,0,1,1,12-12A12,12,0,0,1,188,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "72",
      "width": "208",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "128",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7J = [];
/* style */

const __vue_inject_styles__$7J = undefined;
/* scoped */

const __vue_scope_id__$7J = undefined;
/* module identifier */

const __vue_module_identifier__$7J = undefined;
/* functional template */

const __vue_is_functional_template__$7J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7J,
  staticRenderFns: __vue_staticRenderFns__$7J
}, __vue_inject_styles__$7J, __vue_script__$7J, __vue_scope_id__$7J, __vue_is_functional_template__$7J, __vue_module_identifier__$7J, false, undefined, undefined, undefined);

var script$7I = Vue.extend({
  name: "PhHardDrives",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7I = script$7I;
/* template */

var __vue_render__$7I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "40",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "88",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40ZM180,92a12,12,0,1,1,12-12A12,12,0,0,1,180,92Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,136H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm-28,52a12,12,0,1,1,12-12A12,12,0,0,1,180,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "48",
      "width": "176",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "80",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "176",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7I = [];
/* style */

const __vue_inject_styles__$7I = undefined;
/* scoped */

const __vue_scope_id__$7I = undefined;
/* module identifier */

const __vue_module_identifier__$7I = undefined;
/* functional template */

const __vue_is_functional_template__$7I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7I,
  staticRenderFns: __vue_staticRenderFns__$7I
}, __vue_inject_styles__$7I, __vue_script__$7I, __vue_scope_id__$7I, __vue_is_functional_template__$7I, __vue_module_identifier__$7I, false, undefined, undefined, undefined);

var script$7H = Vue.extend({
  name: "PhHash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7H = script$7H;
/* template */

var __vue_render__$7H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.6",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.6",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,88H175.4l8.5-46.6a8,8,0,0,0-15.8-2.8l-9,49.4H111.4l8.5-46.6a8,8,0,1,0-15.8-2.8L95.1,88H43.6a8,8,0,1,0,0,16H92.2l-8.7,48H32a8,8,0,0,0,0,16H80.6l-8.5,46.6a8,8,0,0,0,6.5,9.3H80a8,8,0,0,0,7.9-6.6l9-49.4h47.7l-8.5,46.6a8,8,0,0,0,6.5,9.3H144a8,8,0,0,0,7.9-6.6l9-49.4h51.5a8,8,0,0,0,0-16H163.8l8.7-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.8l8.7-48h47.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.6",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.6",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "43.6",
      "y1": "96",
      "x2": "224",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "212.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7H = [];
/* style */

const __vue_inject_styles__$7H = undefined;
/* scoped */

const __vue_scope_id__$7H = undefined;
/* module identifier */

const __vue_module_identifier__$7H = undefined;
/* functional template */

const __vue_is_functional_template__$7H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7H,
  staticRenderFns: __vue_staticRenderFns__$7H
}, __vue_inject_styles__$7H, __vue_script__$7H, __vue_scope_id__$7H, __vue_is_functional_template__$7H, __vue_module_identifier__$7H, false, undefined, undefined, undefined);

var script$7G = Vue.extend({
  name: "PhHashStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7G = script$7G;
/* template */

var __vue_render__$7G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "216",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "40",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7G = [];
/* style */

const __vue_inject_styles__$7G = undefined;
/* scoped */

const __vue_scope_id__$7G = undefined;
/* module identifier */

const __vue_module_identifier__$7G = undefined;
/* functional template */

const __vue_is_functional_template__$7G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7G,
  staticRenderFns: __vue_staticRenderFns__$7G
}, __vue_inject_styles__$7G, __vue_script__$7G, __vue_scope_id__$7G, __vue_is_functional_template__$7G, __vue_module_identifier__$7G, false, undefined, undefined, undefined);

var script$7F = Vue.extend({
  name: "PhHeadlights",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7F = script$7F;
/* template */

var __vue_render__$7F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80a8,8,0,0,1,8-8h72a8,8,0,0,1,0,16H168A8,8,0,0,1,160,80Zm80,88H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0-64H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM128,48H88.9C44.6,48,8.3,83.6,8,127.4A79.9,79.9,0,0,0,88,208h40a16,16,0,0,0,16-16V64A16,16,0,0,0,128,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "168",
      "y1": "80",
      "x2": "240",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "176",
      "x2": "240",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "112",
      "x2": "240",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "144",
      "x2": "240",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7F = [];
/* style */

const __vue_inject_styles__$7F = undefined;
/* scoped */

const __vue_scope_id__$7F = undefined;
/* module identifier */

const __vue_module_identifier__$7F = undefined;
/* functional template */

const __vue_is_functional_template__$7F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7F,
  staticRenderFns: __vue_staticRenderFns__$7F
}, __vue_inject_styles__$7F, __vue_script__$7F, __vue_scope_id__$7F, __vue_is_functional_template__$7F, __vue_module_identifier__$7F, false, undefined, undefined, undefined);

var script$7E = Vue.extend({
  name: "PhHeadphones",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7E = script$7E;
/* template */

var __vue_render__$7E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.7,62.2A103.1,103.1,0,0,0,129.5,32h-.8A104,104,0,0,0,24,136v56a24.1,24.1,0,0,0,24,24H64a24.1,24.1,0,0,0,24-24V152a24.1,24.1,0,0,0-24-24H40.4a87.8,87.8,0,0,1,88.3-80h.1a88,88,0,0,1,88.3,80H193.5a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h16a24.1,24.1,0,0,0,24-24V136A103.5,103.5,0,0,0,202.7,62.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7E = [];
/* style */

const __vue_inject_styles__$7E = undefined;
/* scoped */

const __vue_scope_id__$7E = undefined;
/* module identifier */

const __vue_module_identifier__$7E = undefined;
/* functional template */

const __vue_is_functional_template__$7E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7E,
  staticRenderFns: __vue_staticRenderFns__$7E
}, __vue_inject_styles__$7E, __vue_script__$7E, __vue_scope_id__$7E, __vue_is_functional_template__$7E, __vue_module_identifier__$7E, false, undefined, undefined, undefined);

var script$7D = Vue.extend({
  name: "PhHeadset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7D = script$7D;
/* template */

var __vue_render__$7D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M233.5,128v80a40.1,40.1,0,0,1-40,40H136a8,8,0,0,1,0-16h57.5a24.1,24.1,0,0,0,24-24v-1.4a23.6,23.6,0,0,1-8,1.4h-16a24,24,0,0,1-24-24V144a24,24,0,0,1,24-24h23.6a88,88,0,0,0-88.3-80h-.1a87.8,87.8,0,0,0-88.3,80H64a24.1,24.1,0,0,1,24,24v40a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V128A104,104,0,0,1,128.7,24h.8a104.1,104.1,0,0,1,104,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.5,184v24a32,32,0,0,1-32,32H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7D = [];
/* style */

const __vue_inject_styles__$7D = undefined;
/* scoped */

const __vue_scope_id__$7D = undefined;
/* module identifier */

const __vue_module_identifier__$7D = undefined;
/* functional template */

const __vue_is_functional_template__$7D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7D,
  staticRenderFns: __vue_staticRenderFns__$7D
}, __vue_inject_styles__$7D, __vue_script__$7D, __vue_scope_id__$7D, __vue_is_functional_template__$7D, __vue_module_identifier__$7D, false, undefined, undefined, undefined);

var script$7C = Vue.extend({
  name: "PhHeart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7C = script$7C;
/* template */

var __vue_render__$7C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32a60,60,0,0,0-48,24A60,60,0,0,0,20,92c0,71.9,99.9,128.6,104.1,131a7.8,7.8,0,0,0,3.9,1,7.6,7.6,0,0,0,3.9-1,314.3,314.3,0,0,0,51.5-37.6C218.3,154,236,122.6,236,92A60,60,0,0,0,176,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7C = [];
/* style */

const __vue_inject_styles__$7C = undefined;
/* scoped */

const __vue_scope_id__$7C = undefined;
/* module identifier */

const __vue_module_identifier__$7C = undefined;
/* functional template */

const __vue_is_functional_template__$7C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7C,
  staticRenderFns: __vue_staticRenderFns__$7C
}, __vue_inject_styles__$7C, __vue_script__$7C, __vue_scope_id__$7C, __vue_is_functional_template__$7C, __vue_module_identifier__$7C, false, undefined, undefined, undefined);

var script$7B = Vue.extend({
  name: "PhHeartBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7B = script$7B;
/* template */

var __vue_render__$7B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.2,55.2A52,52,0,0,1,228,92c0,68-100,124-100,124S28,160,28,92a52,52,0,0,1,98.3-23.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236,92c0,30.6-17.7,62-52.6,93.4A314.3,314.3,0,0,1,131.9,223a8.1,8.1,0,0,1-7.8,0C119.8,220.6,20,163.9,20,92a60,60,0,0,1,92.3-50.6,4,4,0,0,1,.6,6.2l-18,18a8,8,0,0,0,0,11.3l34.4,34.3-15,15.1a7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3l20.7-20.7a8,8,0,0,0,0-11.3L111.9,71.2l21.7-21.6h0A59.3,59.3,0,0,1,176,32,60,60,0,0,1,236,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7B = [];
/* style */

const __vue_inject_styles__$7B = undefined;
/* scoped */

const __vue_scope_id__$7B = undefined;
/* module identifier */

const __vue_module_identifier__$7B = undefined;
/* functional template */

const __vue_is_functional_template__$7B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7B,
  staticRenderFns: __vue_staticRenderFns__$7B
}, __vue_inject_styles__$7B, __vue_script__$7B, __vue_scope_id__$7B, __vue_is_functional_template__$7B, __vue_module_identifier__$7B, false, undefined, undefined, undefined);

var script$7A = Vue.extend({
  name: "PhHeartStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7A = script$7A;
/* template */

var __vue_render__$7A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.6,51.9a59.5,59.5,0,0,0-43-19.9,60.5,60.5,0,0,0-44,17.6L128,59.1l-7.5-7.4C97.2,28.3,59.2,26.3,35.9,47.4a59.9,59.9,0,0,0-2.3,87l83.1,83.1a15.9,15.9,0,0,0,22.6,0l81-81C243.7,113.2,245.6,75.2,224.6,51.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7A = [];
/* style */

const __vue_inject_styles__$7A = undefined;
/* scoped */

const __vue_scope_id__$7A = undefined;
/* module identifier */

const __vue_module_identifier__$7A = undefined;
/* functional template */

const __vue_is_functional_template__$7A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7A,
  staticRenderFns: __vue_staticRenderFns__$7A
}, __vue_inject_styles__$7A, __vue_script__$7A, __vue_scope_id__$7A, __vue_is_functional_template__$7A, __vue_module_identifier__$7A, false, undefined, undefined, undefined);

var script$7z = Vue.extend({
  name: "PhHeartStraightBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7z = script$7z;
/* template */

var __vue_render__$7z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 70.5 112 88 144 120 128 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 70.5 112 88 144 120 128 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.2,95a64.3,64.3,0,0,1-18.9,41.5l-81,81a15.9,15.9,0,0,1-22.6,0L33.6,134.4a59.9,59.9,0,0,1,2.3-87A57.7,57.7,0,0,1,79,32.8a64.4,64.4,0,0,1,33.8,12.3,4,4,0,0,1,.5,6.1L94.9,69.6a8,8,0,0,0,0,11.3l34.4,34.3-15,15.1a7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3l20.7-20.7a8,8,0,0,0,0-11.3L111.9,75.2l21.7-21.6h0l4-4a59.9,59.9,0,0,1,87,2.3A57.7,57.7,0,0,1,239.2,95Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 70.5 112 88 144 120 128 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 70.5 112 88 144 120 128 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 70.5 112 88 144 120 128 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7z = [];
/* style */

const __vue_inject_styles__$7z = undefined;
/* scoped */

const __vue_scope_id__$7z = undefined;
/* module identifier */

const __vue_module_identifier__$7z = undefined;
/* functional template */

const __vue_is_functional_template__$7z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7z,
  staticRenderFns: __vue_staticRenderFns__$7z
}, __vue_inject_styles__$7z, __vue_script__$7z, __vue_scope_id__$7z, __vue_is_functional_template__$7z, __vue_module_identifier__$7z, false, undefined, undefined, undefined);

var script$7y = Vue.extend({
  name: "PhHeartbeat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7y = script$7y;
/* template */

var __vue_render__$7y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.1,88.2A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-33.7-18.9-62-48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236,92c0,30.6-17.7,62-52.6,93.4A314.3,314.3,0,0,1,131.9,223a8.1,8.1,0,0,1-7.8,0c-3.2-1.8-60.4-34.3-88.6-80.9a4,4,0,0,1,3.4-6.1H72a7.9,7.9,0,0,0,6.7-3.6l9.3-14,25.3,38a8.1,8.1,0,0,0,9.2,3.2,8.8,8.8,0,0,0,4.3-3.3L140.3,136h19.4a8.2,8.2,0,0,0,8.3-7.5,8,8,0,0,0-8-8.5H136a7.9,7.9,0,0,0-6.7,3.6l-9.3,14-25.3-38a8.1,8.1,0,0,0-9.2-3.2,8.8,8.8,0,0,0-4.3,3.3L67.7,120H27.8a4,4,0,0,1-3.8-2.8A86.2,86.2,0,0,1,20,92,60,60,0,0,1,128,56,60,60,0,0,1,236,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 128 72 128 88 104 120 152 136 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7y = [];
/* style */

const __vue_inject_styles__$7y = undefined;
/* scoped */

const __vue_scope_id__$7y = undefined;
/* module identifier */

const __vue_module_identifier__$7y = undefined;
/* functional template */

const __vue_is_functional_template__$7y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7y,
  staticRenderFns: __vue_staticRenderFns__$7y
}, __vue_inject_styles__$7y, __vue_script__$7y, __vue_scope_id__$7y, __vue_is_functional_template__$7y, __vue_module_identifier__$7y, false, undefined, undefined, undefined);

var script$7x = Vue.extend({
  name: "PhHexagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7x = script$7x;
/* template */

var __vue_render__$7x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.9,66.7l-84-47.4a15.9,15.9,0,0,0-15.8,0l-84,47.4a16.2,16.2,0,0,0-8.1,14v94.6a16.2,16.2,0,0,0,8.1,14l84,47.4a15.9,15.9,0,0,0,15.8,0l84-47.4a16.2,16.2,0,0,0,8.1-14V80.7A16.2,16.2,0,0,0,219.9,66.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7x = [];
/* style */

const __vue_inject_styles__$7x = undefined;
/* scoped */

const __vue_scope_id__$7x = undefined;
/* module identifier */

const __vue_module_identifier__$7x = undefined;
/* functional template */

const __vue_is_functional_template__$7x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7x,
  staticRenderFns: __vue_staticRenderFns__$7x
}, __vue_inject_styles__$7x, __vue_script__$7x, __vue_scope_id__$7x, __vue_is_functional_template__$7x, __vue_module_identifier__$7x, false, undefined, undefined, undefined);

var script$7w = Vue.extend({
  name: "PhHighlighterCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7w = script$7w;
/* template */

var __vue_render__$7w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 148 104 104 152 80 152 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.3V156a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v59.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,60.1A96,96,0,1,0,88,215.3V152a8,8,0,0,1,8-8h8V96l48-24v72h8a8,8,0,0,1,8,8v63.3A96,96,0,0,0,195.9,60.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM96,210V152h64v58a88.3,88.3,0,0,1-64,0Zm94.2-19.8A86.8,86.8,0,0,1,176,201.8V152a16,16,0,0,0-16-16V72a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-48,24A8.2,8.2,0,0,0,96,96v40a16,16,0,0,0-16,16v49.8A88.7,88.7,0,0,1,40,128a88,88,0,1,1,150.2,62.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 144 104 96 152 72 152 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7w = [];
/* style */

const __vue_inject_styles__$7w = undefined;
/* scoped */

const __vue_scope_id__$7w = undefined;
/* module identifier */

const __vue_module_identifier__$7w = undefined;
/* functional template */

const __vue_is_functional_template__$7w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7w,
  staticRenderFns: __vue_staticRenderFns__$7w
}, __vue_inject_styles__$7w, __vue_script__$7w, __vue_scope_id__$7w, __vue_is_functional_template__$7w, __vue_module_identifier__$7w, false, undefined, undefined, undefined);

var script$7v = Vue.extend({
  name: "PhHorse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7v = script$7v;
/* template */

var __vue_render__$7v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.8,217.3a95.2,95.2,0,0,0,37.1,6.7c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.1,55A103.2,103.2,0,0,0,128,24h-8a8,8,0,0,0-8,8V59.5L11.8,121.2a8,8,0,0,0-3.6,5.2,7.8,7.8,0,0,0,1.3,6.3l13.8,19.1a31.6,31.6,0,0,0,31.3,12.8c13.7-2.3,38.6-4.2,61.6,6.2L90,207.4a91.1,91.1,0,0,1-20.7-13.8,8,8,0,0,0-11.3.6,8,8,0,0,0,.7,11.3A103.5,103.5,0,0,0,128,232h2.1a104,104,0,0,0,72-177ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,120a48,48,0,0,1-48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7v = [];
/* style */

const __vue_inject_styles__$7v = undefined;
/* scoped */

const __vue_scope_id__$7v = undefined;
/* module identifier */

const __vue_module_identifier__$7v = undefined;
/* functional template */

const __vue_is_functional_template__$7v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7v,
  staticRenderFns: __vue_staticRenderFns__$7v
}, __vue_inject_styles__$7v, __vue_script__$7v, __vue_scope_id__$7v, __vue_is_functional_template__$7v, __vue_module_identifier__$7v, false, undefined, undefined, undefined);

var script$7u = Vue.extend({
  name: "PhHourglass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7u = script$7u;
/* template */

var __vue_render__$7u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7u = [];
/* style */

const __vue_inject_styles__$7u = undefined;
/* scoped */

const __vue_scope_id__$7u = undefined;
/* module identifier */

const __vue_module_identifier__$7u = undefined;
/* functional template */

const __vue_is_functional_template__$7u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7u,
  staticRenderFns: __vue_staticRenderFns__$7u
}, __vue_inject_styles__$7u, __vue_script__$7u, __vue_scope_id__$7u, __vue_is_functional_template__$7u, __vue_module_identifier__$7u, false, undefined, undefined, undefined);

var script$7t = Vue.extend({
  name: "PhHourglassHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7t = script$7t;
/* template */

var __vue_render__$7t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V64H192V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6ZM184,40V64H72V40Zm0,176H72V180l56-42,56,42.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "64",
      "x2": "192",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7t = [];
/* style */

const __vue_inject_styles__$7t = undefined;
/* scoped */

const __vue_scope_id__$7t = undefined;
/* module identifier */

const __vue_module_identifier__$7t = undefined;
/* functional template */

const __vue_is_functional_template__$7t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7t,
  staticRenderFns: __vue_staticRenderFns__$7t
}, __vue_inject_styles__$7t, __vue_script__$7t, __vue_scope_id__$7t, __vue_is_functional_template__$7t, __vue_module_identifier__$7t, false, undefined, undefined, undefined);

var script$7s = Vue.extend({
  name: "PhHourglassLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7s = script$7s;
/* template */

var __vue_render__$7s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.4",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.4",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2a15.6,15.6,0,0,0-6.3,11.9,2.8,2.8,0,0,0-.1.9v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a2.8,2.8,0,0,0-.1-.9,15.6,15.6,0,0,0-6.3-11.9L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6ZM82.6,172.1,128,138l45.3,34.3ZM184,75.6,128,118,72,76V40H184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.4",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.4",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "180.4",
      "x2": "64",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7s = [];
/* style */

const __vue_inject_styles__$7s = undefined;
/* scoped */

const __vue_scope_id__$7s = undefined;
/* module identifier */

const __vue_module_identifier__$7s = undefined;
/* functional template */

const __vue_is_functional_template__$7s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7s,
  staticRenderFns: __vue_staticRenderFns__$7s
}, __vue_inject_styles__$7s, __vue_script__$7s, __vue_scope_id__$7s, __vue_is_functional_template__$7s, __vue_module_identifier__$7s, false, undefined, undefined, undefined);

var script$7r = Vue.extend({
  name: "PhHourglassMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7r = script$7r;
/* template */

var __vue_render__$7r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "69.3",
      "y1": "84",
      "x2": "186.2",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 180.9 88 74.7 88 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74.7",
      "y1": "88",
      "x2": "180.9",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M193.6,88.4A16.1,16.1,0,0,0,200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8l18.1,13.6h0L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128,164,110.8ZM72,40H184V75.6L178.2,80H77.3L72,76ZM184,180.4V216H72V180l48-36v24a8,8,0,0,0,16,0V144.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "74.7",
      "y1": "88",
      "x2": "180.9",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "74.7",
      "y1": "88",
      "x2": "180.9",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74.7",
      "y1": "88",
      "x2": "180.9",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7r = [];
/* style */

const __vue_inject_styles__$7r = undefined;
/* scoped */

const __vue_scope_id__$7r = undefined;
/* module identifier */

const __vue_module_identifier__$7r = undefined;
/* functional template */

const __vue_is_functional_template__$7r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7r,
  staticRenderFns: __vue_staticRenderFns__$7r
}, __vue_inject_styles__$7r, __vue_script__$7r, __vue_scope_id__$7r, __vue_is_functional_template__$7r, __vue_module_identifier__$7r, false, undefined, undefined, undefined);

var script$7q = Vue.extend({
  name: "PhHourglassSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7q = script$7q;
/* template */

var __vue_render__$7q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L53.7,202.3A8,8,0,0,0,59.3,216H196.7a8,8,0,0,0,5.6-13.7L53.7,53.7A8,8,0,0,1,59.3,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,128,208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7q = [];
/* style */

const __vue_inject_styles__$7q = undefined;
/* scoped */

const __vue_scope_id__$7q = undefined;
/* module identifier */

const __vue_module_identifier__$7q = undefined;
/* functional template */

const __vue_is_functional_template__$7q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7q,
  staticRenderFns: __vue_staticRenderFns__$7q
}, __vue_inject_styles__$7q, __vue_script__$7q, __vue_scope_id__$7q, __vue_is_functional_template__$7q, __vue_module_identifier__$7q, false, undefined, undefined, undefined);

var script$7p = Vue.extend({
  name: "PhHourglassSimpleHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7p = script$7p;
/* template */

var __vue_render__$7p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "80",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 184 72 72 72 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,128l50.4-50.3h0L208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm57.4-80-16,16H75.3l-16-16ZM59.3,208,128,139.3,196.7,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "72",
      "x2": "184",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7p = [];
/* style */

const __vue_inject_styles__$7p = undefined;
/* scoped */

const __vue_scope_id__$7p = undefined;
/* module identifier */

const __vue_module_identifier__$7p = undefined;
/* functional template */

const __vue_is_functional_template__$7p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7p,
  staticRenderFns: __vue_staticRenderFns__$7p
}, __vue_inject_styles__$7p, __vue_script__$7p, __vue_scope_id__$7p, __vue_is_functional_template__$7p, __vue_module_identifier__$7p, false, undefined, undefined, undefined);

var script$7o = Vue.extend({
  name: "PhHourglassSimpleLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7o = script$7o;
/* template */

var __vue_render__$7o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.7,202.3A8,8,0,0,0,59.3,216H196.7a8,8,0,0,0,5.6-13.7L176,176H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,128,208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm-80-80H196.7L128,116.7ZM128,139.3,156.7,168H99.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "80",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7o = [];
/* style */

const __vue_inject_styles__$7o = undefined;
/* scoped */

const __vue_scope_id__$7o = undefined;
/* module identifier */

const __vue_module_identifier__$7o = undefined;
/* functional template */

const __vue_is_functional_template__$7o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7o,
  staticRenderFns: __vue_staticRenderFns__$7o
}, __vue_inject_styles__$7o, __vue_script__$7o, __vue_scope_id__$7o, __vue_is_functional_template__$7o, __vue_module_identifier__$7o, false, undefined, undefined, undefined);

var script$7n = Vue.extend({
  name: "PhHourglassSimpleMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7n = script$7n;
/* template */

var __vue_render__$7n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 128 176 80 80 80 128 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,128l34.4-34.3h0L208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm57.4-80-24,24H83.3l-24-24ZM59.3,208,120,147.3V168a8,8,0,0,0,16,0V147.3L196.7,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "80",
      "x2": "80",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7n = [];
/* style */

const __vue_inject_styles__$7n = undefined;
/* scoped */

const __vue_scope_id__$7n = undefined;
/* module identifier */

const __vue_module_identifier__$7n = undefined;
/* functional template */

const __vue_is_functional_template__$7n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7n,
  staticRenderFns: __vue_staticRenderFns__$7n
}, __vue_inject_styles__$7n, __vue_script__$7n, __vue_scope_id__$7n, __vue_is_functional_template__$7n, __vue_module_identifier__$7n, false, undefined, undefined, undefined);

var script$7m = Vue.extend({
  name: "PhHouse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7m = script$7m;
/* template */

var __vue_render__$7m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.8,103.7,138.8,31a16,16,0,0,0-21.6,0l-80,72.7A16,16,0,0,0,32,115.5v92.1a16.4,16.4,0,0,0,4,11A15.9,15.9,0,0,0,48,224H96a8,8,0,0,0,8-8V168a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8v48a8,8,0,0,0,8,8h48a15.6,15.6,0,0,0,7.6-1.9A16.1,16.1,0,0,0,224,208V115.5A16,16,0,0,0,218.8,103.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7m = [];
/* style */

const __vue_inject_styles__$7m = undefined;
/* scoped */

const __vue_scope_id__$7m = undefined;
/* module identifier */

const __vue_module_identifier__$7m = undefined;
/* functional template */

const __vue_is_functional_template__$7m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7m,
  staticRenderFns: __vue_staticRenderFns__$7m
}, __vue_inject_styles__$7m, __vue_script__$7m, __vue_scope_id__$7m, __vue_is_functional_template__$7m, __vue_module_identifier__$7m, false, undefined, undefined, undefined);

var script$7l = Vue.extend({
  name: "PhHouseLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7l = script$7l;
/* template */

var __vue_render__$7l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,216V152H104v64H40V115.5a7.9,7.9,0,0,1,2.6-5.9l80-72.7a7.9,7.9,0,0,1,10.7,0l80.1,72.7a8.3,8.3,0,0,1,2.6,5.9V216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9L133.3,36.9a7.9,7.9,0,0,0-10.7,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,208H224V115.5a15.7,15.7,0,0,0-5.3-11.8L138.7,31a15.9,15.9,0,0,0-21.5,0l-80,72.7A16,16,0,0,0,32,115.5V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-88,0H104V160a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "216",
      "x2": "240",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7l = [];
/* style */

const __vue_inject_styles__$7l = undefined;
/* scoped */

const __vue_scope_id__$7l = undefined;
/* module identifier */

const __vue_module_identifier__$7l = undefined;
/* functional template */

const __vue_is_functional_template__$7l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7l,
  staticRenderFns: __vue_staticRenderFns__$7l
}, __vue_inject_styles__$7l, __vue_script__$7l, __vue_scope_id__$7l, __vue_is_functional_template__$7l, __vue_module_identifier__$7l, false, undefined, undefined, undefined);

var script$7k = Vue.extend({
  name: "PhHouseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7k = script$7k;
/* template */

var __vue_render__$7k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.8,103.7h0L138.8,31a16,16,0,0,0-21.6,0l-80,72.7A16,16,0,0,0,32,115.5V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V115.5A16,16,0,0,0,218.8,103.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7k = [];
/* style */

const __vue_inject_styles__$7k = undefined;
/* scoped */

const __vue_scope_id__$7k = undefined;
/* module identifier */

const __vue_module_identifier__$7k = undefined;
/* functional template */

const __vue_is_functional_template__$7k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7k,
  staticRenderFns: __vue_staticRenderFns__$7k
}, __vue_inject_styles__$7k, __vue_script__$7k, __vue_scope_id__$7k, __vue_is_functional_template__$7k, __vue_module_identifier__$7k, false, undefined, undefined, undefined);

var script$7j = Vue.extend({
  name: "PhIdentificationBadge",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7j = script$7j;
/* template */

var __vue_render__$7j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "68",
      "x2": "160",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84,187.2a60,60,0,0,1,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32ZM128,168a32,32,0,1,1,32-32A32,32,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,192a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.8,150.4a8.1,8.1,0,0,1-11.2-1.6,52,52,0,0,0-83.2,0A8,8,0,0,1,80,200a7.7,7.7,0,0,1-4.8-1.6,8,8,0,0,1-1.6-11.2A67.8,67.8,0,0,1,101,165.5a40,40,0,1,1,54,0,67.8,67.8,0,0,1,27.4,21.7A8,8,0,0,1,180.8,198.4ZM152,136a24,24,0,1,1-24-24A24.1,24.1,0,0,1,152,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,192a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,192a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "136",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,192a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "160",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7j = [];
/* style */

const __vue_inject_styles__$7j = undefined;
/* scoped */

const __vue_scope_id__$7j = undefined;
/* module identifier */

const __vue_module_identifier__$7j = undefined;
/* functional template */

const __vue_is_functional_template__$7j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7j,
  staticRenderFns: __vue_staticRenderFns__$7j
}, __vue_inject_styles__$7j, __vue_script__$7j, __vue_scope_id__$7j, __vue_is_functional_template__$7j, __vue_module_identifier__$7j, false, undefined, undefined, undefined);

var script$7i = Vue.extend({
  name: "PhIdentificationCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7i = script$7i;
/* template */

var __vue_render__$7i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "148",
      "x2": "184",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "94.1",
      "cy": "116",
      "r": "22",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.1,164a22,22,0,0,1,44,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM92.1,144a24,24,0,1,1,24-24A23.9,23.9,0,0,1,92.1,144Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.1",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.1,168a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM125.1,175.7a8,8,0,0,1-9.8-5.7,24,24,0,0,0-46.4,0,8.1,8.1,0,0,1-7.8,6l-2-.3a7.9,7.9,0,0,1-5.7-9.7,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,130.8,166,7.9,7.9,0,0,1,125.1,175.7ZM192,152H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm0-32H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.1",
      "cy": "120",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.1",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.1,168a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.1",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.1,168a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92.1",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.1,168a32,32,0,0,1,62,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7i = [];
/* style */

const __vue_inject_styles__$7i = undefined;
/* scoped */

const __vue_scope_id__$7i = undefined;
/* module identifier */

const __vue_module_identifier__$7i = undefined;
/* functional template */

const __vue_is_functional_template__$7i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7i,
  staticRenderFns: __vue_staticRenderFns__$7i
}, __vue_inject_styles__$7i, __vue_script__$7i, __vue_scope_id__$7i, __vue_is_functional_template__$7i, __vue_module_identifier__$7i, false, undefined, undefined, undefined);

var script$7h = Vue.extend({
  name: "PhImage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7h = script$7h;
/* template */

var __vue_render__$7h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,100h0a12,12,0,0,1-12,12,12,12,0,0,1-12-12,12,12,0,0,1,24,0Zm64-44V184h0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V168h0V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,164.7V56H40v92.7L76.7,112a16.1,16.1,0,0,1,22.6,0L144,156.7,164.7,136a16.1,16.1,0,0,1,22.6,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "100",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7h = [];
/* style */

const __vue_inject_styles__$7h = undefined;
/* scoped */

const __vue_scope_id__$7h = undefined;
/* module identifier */

const __vue_module_identifier__$7h = undefined;
/* functional template */

const __vue_is_functional_template__$7h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7h,
  staticRenderFns: __vue_staticRenderFns__$7h
}, __vue_inject_styles__$7h, __vue_script__$7h, __vue_scope_id__$7h, __vue_is_functional_template__$7h, __vue_module_identifier__$7h, false, undefined, undefined, undefined);

var script$7g = Vue.extend({
  name: "PhImageSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7g = script$7g;
/* template */

var __vue_render__$7g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V160h0l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V176h0v32a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-28.7,80a16.1,16.1,0,0,0-22.6,0L112,156.7,91.3,136a16.1,16.1,0,0,0-22.6,0L48,156.7V48H208v92.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "92",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7g = [];
/* style */

const __vue_inject_styles__$7g = undefined;
/* scoped */

const __vue_scope_id__$7g = undefined;
/* module identifier */

const __vue_module_identifier__$7g = undefined;
/* functional template */

const __vue_is_functional_template__$7g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7g,
  staticRenderFns: __vue_staticRenderFns__$7g
}, __vue_inject_styles__$7g, __vue_script__$7g, __vue_scope_id__$7g, __vue_is_functional_template__$7g, __vue_module_identifier__$7g, false, undefined, undefined, undefined);

var script$7f = Vue.extend({
  name: "PhInfinity",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7f = script$7f;
/* template */

var __vue_render__$7f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M101.3,158.2l-3.4,3.7a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-3.4,3.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,128a56,56,0,0,1-95.6,39.6l-.3-.4-60-67.6A39.5,39.5,0,0,0,64,88a40,40,0,1,0,0,80,39.5,39.5,0,0,0,28.1-11.6l8.5-9.6a8,8,0,0,1,12,10.6l-8.7,9.8-.3.4a56,56,0,0,1-79.2,0A56,56,0,0,1,64,72a55.5,55.5,0,0,1,39.6,16.4l.3.4,60,67.6A39.5,39.5,0,0,0,192,168a40,40,0,1,0,0-80,39.5,39.5,0,0,0-28.1,11.6l-8.5,9.6a8,8,0,0,1-12-10.6l8.7-9.8.3-.4A56,56,0,0,1,248,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7f = [];
/* style */

const __vue_inject_styles__$7f = undefined;
/* scoped */

const __vue_scope_id__$7f = undefined;
/* module identifier */

const __vue_module_identifier__$7f = undefined;
/* functional template */

const __vue_is_functional_template__$7f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7f,
  staticRenderFns: __vue_staticRenderFns__$7f
}, __vue_inject_styles__$7f, __vue_script__$7f, __vue_scope_id__$7f, __vue_is_functional_template__$7f, __vue_module_identifier__$7f, false, undefined, undefined, undefined);

var script$7e = Vue.extend({
  name: "PhInfo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7e = script$7e;
/* template */

var __vue_render__$7e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 124 128 124 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-2,48a12,12,0,1,1-12,12A12,12,0,0,1,126,72Zm10,112h-8a8,8,0,0,1-8-8V128a8,8,0,0,1,0-16h8a8,8,0,0,1,8,8v48a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "120 120 128 120 128 176 136 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "126",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7e = [];
/* style */

const __vue_inject_styles__$7e = undefined;
/* scoped */

const __vue_scope_id__$7e = undefined;
/* module identifier */

const __vue_module_identifier__$7e = undefined;
/* functional template */

const __vue_is_functional_template__$7e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7e,
  staticRenderFns: __vue_staticRenderFns__$7e
}, __vue_inject_styles__$7e, __vue_script__$7e, __vue_scope_id__$7e, __vue_is_functional_template__$7e, __vue_module_identifier__$7e, false, undefined, undefined, undefined);

var script$7d = Vue.extend({
  name: "PhInstagramLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7d = script$7d;
/* template */

var __vue_render__$7d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "32",
      "width": "192",
      "height": "192",
      "rx": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M172,36H84A48,48,0,0,0,36,84v88a48,48,0,0,0,48,48h88a48,48,0,0,0,48-48V84A48,48,0,0,0,172,36ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,28H84A56,56,0,0,0,28,84v88a56,56,0,0,0,56,56h88a56,56,0,0,0,56-56V84A56,56,0,0,0,172,28ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Zm52-88a12,12,0,1,1,12-12A12,12,0,0,1,180,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7d = [];
/* style */

const __vue_inject_styles__$7d = undefined;
/* scoped */

const __vue_scope_id__$7d = undefined;
/* module identifier */

const __vue_module_identifier__$7d = undefined;
/* functional template */

const __vue_is_functional_template__$7d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7d,
  staticRenderFns: __vue_staticRenderFns__$7d
}, __vue_inject_styles__$7d, __vue_script__$7d, __vue_scope_id__$7d, __vue_is_functional_template__$7d, __vue_module_identifier__$7d, false, undefined, undefined, undefined);

var script$7c = Vue.extend({
  name: "PhIntersect",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7c = script$7c;
/* template */

var __vue_render__$7c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.1",
      "y1": "109.1",
      "x2": "146.9",
      "y2": "146.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,160c0,2.5.5,4.8.7,7.3,2.5.2,4.8.7,7.3.7a72,72,0,0,0,72-72c0-2.5-.5-4.8-.7-7.3-2.5-.2-4.8-.7-7.3-.7A72,72,0,0,0,88,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M174.6,81.4a80,80,0,1,0-93.2,93.2,80,80,0,1,0,93.2-93.2ZM32,96A64,64,0,0,1,158,80.1,79.9,79.9,0,0,0,80.1,158,64.2,64.2,0,0,1,32,96ZM160,224a64.2,64.2,0,0,1-62-48.1A79.9,79.9,0,0,0,175.9,98,64,64,0,0,1,160,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.5",
      "y1": "98.5",
      "x2": "157.5",
      "y2": "133.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.5",
      "y1": "122.5",
      "x2": "133.5",
      "y2": "157.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.5",
      "y1": "98.5",
      "x2": "157.5",
      "y2": "133.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.5",
      "y1": "122.5",
      "x2": "133.5",
      "y2": "157.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.5",
      "y1": "98.5",
      "x2": "157.5",
      "y2": "133.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.5",
      "y1": "122.5",
      "x2": "133.5",
      "y2": "157.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7c = [];
/* style */

const __vue_inject_styles__$7c = undefined;
/* scoped */

const __vue_scope_id__$7c = undefined;
/* module identifier */

const __vue_module_identifier__$7c = undefined;
/* functional template */

const __vue_is_functional_template__$7c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7c,
  staticRenderFns: __vue_staticRenderFns__$7c
}, __vue_inject_styles__$7c, __vue_script__$7c, __vue_scope_id__$7c, __vue_is_functional_template__$7c, __vue_module_identifier__$7c, false, undefined, undefined, undefined);

var script$7b = Vue.extend({
  name: "PhJeep",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7b = script$7b;
/* template */

var __vue_render__$7b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "136",
      "x2": "128",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "136",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "136",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.7,88H226.9l-6-42.3A16,16,0,0,0,205.1,32H50.9A16,16,0,0,0,35.1,45.7L29.1,88H16.3A8.2,8.2,0,0,0,8,95.5a8,8,0,0,0,8,8.5H28V208a16,16,0,0,0,16,16H68a16,16,0,0,0,16-16V184h16a4,4,0,0,0,4-4V128.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v52a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V128.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v52a4,4,0,0,0,4,4h16v24a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V104h12a8,8,0,0,0,8-8.5A8.2,8.2,0,0,0,239.7,88ZM72,144a12,12,0,1,1,12-12A12,12,0,0,1,72,144Zm112,0a12,12,0,1,1,12-12A12,12,0,0,1,184,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "96",
      "x2": "240",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "132",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "132",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7b = [];
/* style */

const __vue_inject_styles__$7b = undefined;
/* scoped */

const __vue_scope_id__$7b = undefined;
/* module identifier */

const __vue_module_identifier__$7b = undefined;
/* functional template */

const __vue_is_functional_template__$7b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7b,
  staticRenderFns: __vue_staticRenderFns__$7b
}, __vue_inject_styles__$7b, __vue_script__$7b, __vue_scope_id__$7b, __vue_is_functional_template__$7b, __vue_module_identifier__$7b, false, undefined, undefined, undefined);

var script$7a = Vue.extend({
  name: "PhKanban",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7a = script$7a;
/* template */

var __vue_render__$7a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "56",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "160",
      "y": "56",
      "width": "56",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,120H40v88a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "56",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V208a16,16,0,0,0,16,16H88a16,16,0,0,0,16-16V160h48v16a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V56A8,8,0,0,0,216,48ZM88,64v56H48V64Zm16,80V64h48v80Zm64,32V120h40v56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "56",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "56",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "40",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "56",
      "x2": "160",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7a = [];
/* style */

const __vue_inject_styles__$7a = undefined;
/* scoped */

const __vue_scope_id__$7a = undefined;
/* module identifier */

const __vue_module_identifier__$7a = undefined;
/* functional template */

const __vue_is_functional_template__$7a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7a,
  staticRenderFns: __vue_staticRenderFns__$7a
}, __vue_inject_styles__$7a, __vue_script__$7a, __vue_scope_id__$7a, __vue_is_functional_template__$7a, __vue_module_identifier__$7a, false, undefined, undefined, undefined);

var script$79 = Vue.extend({
  name: "PhKey",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$79 = script$79;
/* template */

var __vue_render__$79 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,16A80.1,80.1,0,0,0,83.9,120.8L26.3,178.3A8.1,8.1,0,0,0,24,184v40a8,8,0,0,0,8,8H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8.1,8.1,0,0,0,5.7-2.3l9.5-9.6A80,80,0,1,0,160,16Zm20,76a16,16,0,1,1,16-16A16,16,0,0,1,180,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "76",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$79 = [];
/* style */

const __vue_inject_styles__$79 = undefined;
/* scoped */

const __vue_scope_id__$79 = undefined;
/* module identifier */

const __vue_module_identifier__$79 = undefined;
/* functional template */

const __vue_is_functional_template__$79 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$79 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$79,
  staticRenderFns: __vue_staticRenderFns__$79
}, __vue_inject_styles__$79, __vue_script__$79, __vue_scope_id__$79, __vue_is_functional_template__$79, __vue_module_identifier__$79, false, undefined, undefined, undefined);

var script$78 = Vue.extend({
  name: "PhKeyReturn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$78 = script$78;
/* template */

var __vue_render__$78 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-32,96a8,8,0,0,1-8,8H99.3l10.4,10.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.1,8.1,0,0,1,11.4,11.4L99.3,128H168V104a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 104 176 136 80 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 112 80 136 104 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$78 = [];
/* style */

const __vue_inject_styles__$78 = undefined;
/* scoped */

const __vue_scope_id__$78 = undefined;
/* module identifier */

const __vue_module_identifier__$78 = undefined;
/* functional template */

const __vue_is_functional_template__$78 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$78 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$78,
  staticRenderFns: __vue_staticRenderFns__$78
}, __vue_inject_styles__$78, __vue_script__$78, __vue_scope_id__$78, __vue_is_functional_template__$78, __vue_module_identifier__$78, false, undefined, undefined, undefined);

var script$77 = Vue.extend({
  name: "PhKeyboard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$77 = script$77;
/* template */

var __vue_render__$77 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "92",
      "x2": "192",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "164",
      "x2": "72",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "164",
      "x2": "148",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "164",
      "x2": "192",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16.97"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.5,47.5H32.5a17,17,0,0,0-17,17v127a17,17,0,0,0,17,17h191a17,17,0,0,0,17-17V64.5A17,17,0,0,0,223.5,47.5ZM64,168H56a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm40,0h-8a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "56",
      "width": "208",
      "height": "144",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16.97"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "128",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "96",
      "x2": "200",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "160",
      "x2": "64",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "160",
      "x2": "200",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$77 = [];
/* style */

const __vue_inject_styles__$77 = undefined;
/* scoped */

const __vue_scope_id__$77 = undefined;
/* module identifier */

const __vue_module_identifier__$77 = undefined;
/* functional template */

const __vue_is_functional_template__$77 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$77 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$77,
  staticRenderFns: __vue_staticRenderFns__$77
}, __vue_inject_styles__$77, __vue_script__$77, __vue_scope_id__$77, __vue_is_functional_template__$77, __vue_module_identifier__$77, false, undefined, undefined, undefined);

var script$76 = Vue.extend({
  name: "PhKeyhole",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$76 = script$76;
/* template */

var __vue_render__$76 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.6,129A28,28,0,1,0,100,108a28.5,28.5,0,0,0,9.4,21L98.9,165.8a8,8,0,0,0,7.7,10.2h42.8a8,8,0,0,0,7.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm18.4-81.8,12.5,29.1a12,12,0,0,1-11,16.7H108.1a12,12,0,0,1-11-16.7l12.5-29.1a32,32,0,0,1-2.9-50.1,32.4,32.4,0,0,1,25-7.9,32,32,0,0,1,14.7,58Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$76 = [];
/* style */

const __vue_inject_styles__$76 = undefined;
/* scoped */

const __vue_scope_id__$76 = undefined;
/* module identifier */

const __vue_module_identifier__$76 = undefined;
/* functional template */

const __vue_is_functional_template__$76 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$76 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$76,
  staticRenderFns: __vue_staticRenderFns__$76
}, __vue_inject_styles__$76, __vue_script__$76, __vue_scope_id__$76, __vue_is_functional_template__$76, __vue_module_identifier__$76, false, undefined, undefined, undefined);

var script$75 = Vue.extend({
  name: "PhKnife",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$75 = script$75;
/* template */

var __vue_render__$75 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.5,90.5l51.4-52.6a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.8,32.2a28.1,28.1,0,0,0-39.7.1L18.3,210.4a8,8,0,0,0,3.9,13.4,154.1,154.1,0,0,0,35,4c33.4,0,66.8-10.9,98.3-32.2a232,232,0,0,0,50.9-46.8,8.1,8.1,0,0,0-.7-10.5l-18.8-18.7,45-47.9A28,28,0,0,0,231.8,32.2ZM189.2,144.5a227,227,0,0,1-43.1,38.2c-34.5,23.2-70,32.6-105.8,28.1L146.6,101.9l23.3,23.3c.1.1.2.3.4.4h.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$75 = [];
/* style */

const __vue_inject_styles__$75 = undefined;
/* scoped */

const __vue_scope_id__$75 = undefined;
/* module identifier */

const __vue_module_identifier__$75 = undefined;
/* functional template */

const __vue_is_functional_template__$75 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$75 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$75,
  staticRenderFns: __vue_staticRenderFns__$75
}, __vue_inject_styles__$75, __vue_script__$75, __vue_scope_id__$75, __vue_is_functional_template__$75, __vue_module_identifier__$75, false, undefined, undefined, undefined);

var script$74 = Vue.extend({
  name: "PhLadder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$74 = script$74;
/* template */

var __vue_render__$74 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "69.1",
      "y1": "136",
      "x2": "133.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.5",
      "y1": "88",
      "x2": "150.5",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.6",
      "y1": "184",
      "x2": "115.6",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "73",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.4",
      "y1": "160",
      "x2": "187.6",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "69.1",
      "y1": "136",
      "x2": "133.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.5",
      "y1": "88",
      "x2": "150.5",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.6",
      "y1": "184",
      "x2": "115.6",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "73",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.4",
      "y1": "160",
      "x2": "187.6",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.5,213.3,164.5,73l9.1-25H184a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h4.6L32.5,213.3a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3L57.2,192h47l-7.7,21.3a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3L130,168h52l18.5,50.7A7.9,7.9,0,0,0,208,224a8.6,8.6,0,0,0,2.7-.5A7.9,7.9,0,0,0,215.5,213.3Zm-88-85.3h-47L92.1,96h47Zm29.1-80-8.1,22.3h0L144.9,80H98l11.6-32ZM63.1,176l11.6-32h47L110,176Zm72.7-24L156,96.4,176.2,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "69.1",
      "y1": "136",
      "x2": "133.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.5",
      "y1": "88",
      "x2": "150.5",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.6",
      "y1": "184",
      "x2": "115.6",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "73",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.4",
      "y1": "160",
      "x2": "187.6",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "69.1",
      "y1": "136",
      "x2": "133.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.5",
      "y1": "88",
      "x2": "150.5",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.6",
      "y1": "184",
      "x2": "115.6",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "73",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.4",
      "y1": "160",
      "x2": "187.6",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "88",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "40",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "168",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "69.1",
      "y1": "136",
      "x2": "133.1",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "86.5",
      "y1": "88",
      "x2": "150.5",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "51.6",
      "y1": "184",
      "x2": "115.6",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "73",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124.4",
      "y1": "160",
      "x2": "187.6",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$74 = [];
/* style */

const __vue_inject_styles__$74 = undefined;
/* scoped */

const __vue_scope_id__$74 = undefined;
/* module identifier */

const __vue_module_identifier__$74 = undefined;
/* functional template */

const __vue_is_functional_template__$74 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$74 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$74,
  staticRenderFns: __vue_staticRenderFns__$74
}, __vue_inject_styles__$74, __vue_script__$74, __vue_scope_id__$74, __vue_is_functional_template__$74, __vue_module_identifier__$74, false, undefined, undefined, undefined);

var script$73 = Vue.extend({
  name: "PhLadderSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$73 = script$73;
/* template */

var __vue_render__$73 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "32",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "32",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "184",
      "x2": "192",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "32",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "32",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "184",
      "x2": "192",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,24a8,8,0,0,0-8,8V64H72V32a8,8,0,0,0-16,0V224a8,8,0,0,0,16,0V192H184v32a8,8,0,0,0,16,0V32A8,8,0,0,0,192,24Zm-8,56v40H72V80ZM72,176V136H184v40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "32",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "32",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "184",
      "x2": "192",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "32",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "32",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "184",
      "x2": "192",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "64",
      "y1": "32",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "32",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "72",
      "x2": "192",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "184",
      "x2": "192",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$73 = [];
/* style */

const __vue_inject_styles__$73 = undefined;
/* scoped */

const __vue_scope_id__$73 = undefined;
/* module identifier */

const __vue_module_identifier__$73 = undefined;
/* functional template */

const __vue_is_functional_template__$73 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$73 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$73,
  staticRenderFns: __vue_staticRenderFns__$73
}, __vue_inject_styles__$73, __vue_script__$73, __vue_scope_id__$73, __vue_is_functional_template__$73, __vue_module_identifier__$73, false, undefined, undefined, undefined);

var script$72 = Vue.extend({
  name: "PhLamp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$72 = script$72;
/* template */

var __vue_render__$72 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M241.2,152.8a15.8,15.8,0,0,1-13.3,7.2H208v32a8,8,0,0,1-16,0V160H136v48h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V160H28.1a16.1,16.1,0,0,1-14.7-22.3l41.2-96A15.9,15.9,0,0,1,69.3,32H186.7a15.9,15.9,0,0,1,14.7,9.7l41.2,96A15.9,15.9,0,0,1,241.2,152.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "216",
      "x2": "160",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "152",
      "x2": "200",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$72 = [];
/* style */

const __vue_inject_styles__$72 = undefined;
/* scoped */

const __vue_scope_id__$72 = undefined;
/* module identifier */

const __vue_module_identifier__$72 = undefined;
/* functional template */

const __vue_is_functional_template__$72 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$72 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$72,
  staticRenderFns: __vue_staticRenderFns__$72
}, __vue_inject_styles__$72, __vue_script__$72, __vue_scope_id__$72, __vue_is_functional_template__$72, __vue_module_identifier__$72, false, undefined, undefined, undefined);

var script$71 = Vue.extend({
  name: "PhLaptop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$71 = script$71;
/* template */

var __vue_render__$71 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,168V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16v96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168H232a0,0,0,0,1,0,0v24a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V168a0,0,0,0,1,0,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "96",
      "x2": "112",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,168h-8V72a24.1,24.1,0,0,0-24-24H56A24.1,24.1,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24.1,24.1,0,0,0,24,24H216a24.1,24.1,0,0,0,24-24V176A8,8,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "88",
      "x2": "112",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$71 = [];
/* style */

const __vue_inject_styles__$71 = undefined;
/* scoped */

const __vue_scope_id__$71 = undefined;
/* module identifier */

const __vue_module_identifier__$71 = undefined;
/* functional template */

const __vue_is_functional_template__$71 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$71 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$71,
  staticRenderFns: __vue_staticRenderFns__$71
}, __vue_inject_styles__$71, __vue_script__$71, __vue_scope_id__$71, __vue_is_functional_template__$71, __vue_module_identifier__$71, false, undefined, undefined, undefined);

var script$70 = Vue.extend({
  name: "PhLayout",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$70 = script$70;
/* template */

var __vue_render__$70 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,208V104H32v96a8,8,0,0,0,8,8H96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40ZM216,200H112V112H216v88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$70 = [];
/* style */

const __vue_inject_styles__$70 = undefined;
/* scoped */

const __vue_scope_id__$70 = undefined;
/* module identifier */

const __vue_module_identifier__$70 = undefined;
/* functional template */

const __vue_is_functional_template__$70 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$70 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$70,
  staticRenderFns: __vue_staticRenderFns__$70
}, __vue_inject_styles__$70, __vue_script__$70, __vue_scope_id__$70, __vue_is_functional_template__$70, __vue_module_identifier__$70, false, undefined, undefined, undefined);

var script$6$ = Vue.extend({
  name: "PhLeaf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6$ = script$6$;
/* template */

var __vue_render__$6$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,39.5a8.1,8.1,0,0,0-7.5-7.5C140.2,27.5,79.1,50.5,53,93.6a87.3,87.3,0,0,0-12.8,49.1c.6,15.9,5.2,32.1,13.8,48L154.3,90.3a8.1,8.1,0,0,1,11.4,11.4L65.3,202c15.9,8.6,32.1,13.2,48,13.8h3.3A87,87,0,0,0,162.4,203C205.5,176.9,228.5,115.8,224,39.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.1,196.1c-1.1-1.8-2.1-3.6-3.1-5.4L34.3,210.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L65.3,202l-5.4-3.1A9.3,9.3,0,0,1,57.1,196.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "40",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6$ = [];
/* style */

const __vue_inject_styles__$6$ = undefined;
/* scoped */

const __vue_scope_id__$6$ = undefined;
/* module identifier */

const __vue_module_identifier__$6$ = undefined;
/* functional template */

const __vue_is_functional_template__$6$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6$,
  staticRenderFns: __vue_staticRenderFns__$6$
}, __vue_inject_styles__$6$, __vue_script__$6$, __vue_scope_id__$6$, __vue_is_functional_template__$6$, __vue_module_identifier__$6$, false, undefined, undefined, undefined);

var script$6_ = Vue.extend({
  name: "PhLifebuoy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6_ = script$6_;
/* template */

var __vue_render__$6_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "156.3",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "156.3",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,60.1a96,96,0,0,1,0,135.8l-39.6-39.6a40.1,40.1,0,0,0,0-56.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,195.9a96,96,0,0,1,0-135.8L99.7,99.7a40.1,40.1,0,0,0,0,56.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "156.3",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "156.3",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.2,200.8a103.8,103.8,0,0,0,0-145.6,2.3,2.3,0,0,0-.7-.7,2.3,2.3,0,0,0-.7-.7,103.8,103.8,0,0,0-145.6,0,2.3,2.3,0,0,0-.7.7,2.3,2.3,0,0,0-.7.7,103.8,103.8,0,0,0,0,145.6l.7.7a2.3,2.3,0,0,0,.7.7,103.8,103.8,0,0,0,145.6,0,2.3,2.3,0,0,0,.7-.7A2.3,2.3,0,0,0,202.2,200.8ZM96,128a32,32,0,1,1,32,32A32.1,32.1,0,0,1,96,128Zm88.3-67.6L155.8,88.9a47.9,47.9,0,0,0-55.6,0L71.7,60.4a87.9,87.9,0,0,1,112.6,0ZM71.7,195.6l28.5-28.5a47.9,47.9,0,0,0,55.6,0l28.5,28.5a87.9,87.9,0,0,1-112.6,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "156.3",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "156.3",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "156.3",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "156.3",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "156.3",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "156.3",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6_ = [];
/* style */

const __vue_inject_styles__$6_ = undefined;
/* scoped */

const __vue_scope_id__$6_ = undefined;
/* module identifier */

const __vue_module_identifier__$6_ = undefined;
/* functional template */

const __vue_is_functional_template__$6_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6_,
  staticRenderFns: __vue_staticRenderFns__$6_
}, __vue_inject_styles__$6_, __vue_script__$6_, __vue_scope_id__$6_, __vue_is_functional_template__$6_, __vue_module_identifier__$6_, false, undefined, undefined, undefined);

var script$6Z = Vue.extend({
  name: "PhLightbulb",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Z = script$6Z;
/* template */

var __vue_render__$6Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168a79.8,79.8,0,0,1-32-63.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,49.7,144.1A20,20,0,0,0,168,184h0a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-.2A19.6,19.6,0,0,0,80,168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.1,96A35.8,35.8,0,0,0,136,68.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.7,87.7,0,0,1-33.6,69.2A16.1,16.1,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16.2,16.2,0,0,0-6.2-12.7A87.8,87.8,0,0,1,40,104.5C39.7,56.8,78.3,17.1,125.9,16A87.9,87.9,0,0,1,216,104Zm-32.8-9.4a55.8,55.8,0,0,0-45.8-45.7,8,8,0,1,0-2.6,15.8,39.7,39.7,0,0,1,32.6,32.6,8,8,0,0,0,7.9,6.6h1.4A7.9,7.9,0,0,0,183.2,94.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Z = [];
/* style */

const __vue_inject_styles__$6Z = undefined;
/* scoped */

const __vue_scope_id__$6Z = undefined;
/* module identifier */

const __vue_module_identifier__$6Z = undefined;
/* functional template */

const __vue_is_functional_template__$6Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Z,
  staticRenderFns: __vue_staticRenderFns__$6Z
}, __vue_inject_styles__$6Z, __vue_script__$6Z, __vue_scope_id__$6Z, __vue_is_functional_template__$6Z, __vue_module_identifier__$6Z, false, undefined, undefined, undefined);

var script$6Y = Vue.extend({
  name: "PhLightbulbFilament",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Y = script$6Y;
/* template */

var __vue_render__$6Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168a79.8,79.8,0,0,1-32-63.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,49.7,144.1A20,20,0,0,0,168,184h0a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-.2A19.6,19.6,0,0,0,80,168Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.7,87.7,0,0,1-33.6,69.2A16.1,16.1,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16.2,16.2,0,0,0-6.2-12.7A87.8,87.8,0,0,1,40,104.5C39.7,56.8,78.3,17.1,125.9,16A87.9,87.9,0,0,1,216,104Zm-50.3,2.3a8.1,8.1,0,0,0-11.4,0L128,132.7l-26.3-26.4a8.1,8.1,0,0,0-11.4,11.4L120,147.3V184a8,8,0,0,0,16,0V147.3l29.7-29.6A8.1,8.1,0,0,0,165.7,106.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 112 128 144 160 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Y = [];
/* style */

const __vue_inject_styles__$6Y = undefined;
/* scoped */

const __vue_scope_id__$6Y = undefined;
/* module identifier */

const __vue_module_identifier__$6Y = undefined;
/* functional template */

const __vue_is_functional_template__$6Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Y,
  staticRenderFns: __vue_staticRenderFns__$6Y
}, __vue_inject_styles__$6Y, __vue_script__$6Y, __vue_scope_id__$6Y, __vue_is_functional_template__$6Y, __vue_module_identifier__$6Y, false, undefined, undefined, undefined);

var script$6X = Vue.extend({
  name: "PhLightning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6X = script$6X;
/* template */

var __vue_render__$6X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.8,118.2a8,8,0,0,0-5-5.7L153.2,90.9l14.6-73.3a8.1,8.1,0,0,0-4.1-8.7,7.9,7.9,0,0,0-9.5,1.6l-112,120a7.9,7.9,0,0,0-2,7.3,8.2,8.2,0,0,0,5,5.7l57.6,21.6L88.2,238.4a8.1,8.1,0,0,0,4.1,8.7,8.4,8.4,0,0,0,3.7.9,7.9,7.9,0,0,0,5.8-2.5l112-120A7.9,7.9,0,0,0,215.8,118.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6X = [];
/* style */

const __vue_inject_styles__$6X = undefined;
/* scoped */

const __vue_scope_id__$6X = undefined;
/* module identifier */

const __vue_module_identifier__$6X = undefined;
/* functional template */

const __vue_is_functional_template__$6X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6X,
  staticRenderFns: __vue_staticRenderFns__$6X
}, __vue_inject_styles__$6X, __vue_script__$6X, __vue_scope_id__$6X, __vue_is_functional_template__$6X, __vue_module_identifier__$6X, false, undefined, undefined, undefined);

var script$6W = Vue.extend({
  name: "PhLightningSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6W = script$6W;
/* template */

var __vue_render__$6W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "119.6 59.3 160 16 144 96 208 120 191.2 138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L81.3,88.5l-39.1,42a7.9,7.9,0,0,0-2,7.3,8.2,8.2,0,0,0,5,5.7l57.6,21.6L88.2,238.4a8.1,8.1,0,0,0,4.1,8.7,8.4,8.4,0,0,0,3.7.9,7.7,7.7,0,0,0,5.8-2.6l61.9-66.2,38.4,42.2A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.8,149.3a8,8,0,0,0,5.8,2.6h.1a7.7,7.7,0,0,0,5.8-2.6l22.3-23.9a7.9,7.9,0,0,0-3-12.9L153.2,90.9l14.6-73.4a8,8,0,0,0-13.6-7L108.3,59.7a7.9,7.9,0,0,0-.1,10.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6W = [];
/* style */

const __vue_inject_styles__$6W = undefined;
/* scoped */

const __vue_scope_id__$6W = undefined;
/* module identifier */

const __vue_module_identifier__$6W = undefined;
/* functional template */

const __vue_is_functional_template__$6W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6W,
  staticRenderFns: __vue_staticRenderFns__$6W
}, __vue_inject_styles__$6W, __vue_script__$6W, __vue_scope_id__$6W, __vue_is_functional_template__$6W, __vue_module_identifier__$6W, false, undefined, undefined, undefined);

var script$6V = Vue.extend({
  name: "PhLineSegment",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6V = script$6V;
/* template */

var __vue_render__$6V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175",
      "y1": "81",
      "x2": "81",
      "y2": "175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175",
      "y1": "81",
      "x2": "81",
      "y2": "175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M214.6,86.6A31.6,31.6,0,0,1,192,96a32.7,32.7,0,0,1-16.3-4.4L91.6,175.7a32,32,0,0,1-5,38.9,31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,38.9-5l84.1-84.1a32,32,0,1,1,50.2,6.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175",
      "y1": "81",
      "x2": "81",
      "y2": "175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175",
      "y1": "81",
      "x2": "81",
      "y2": "175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "192",
      "cy": "64",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175",
      "y1": "81",
      "x2": "81",
      "y2": "175",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6V = [];
/* style */

const __vue_inject_styles__$6V = undefined;
/* scoped */

const __vue_scope_id__$6V = undefined;
/* module identifier */

const __vue_module_identifier__$6V = undefined;
/* functional template */

const __vue_is_functional_template__$6V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6V,
  staticRenderFns: __vue_staticRenderFns__$6V
}, __vue_inject_styles__$6V, __vue_script__$6V, __vue_scope_id__$6V, __vue_is_functional_template__$6V, __vue_module_identifier__$6V, false, undefined, undefined, undefined);

var script$6U = Vue.extend({
  name: "PhLineSegments",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6U = script$6U;
/* template */

var __vue_render__$6U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.6",
      "y1": "117.1",
      "x2": "51.4",
      "y2": "178.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143",
      "y1": "143",
      "x2": "113",
      "y2": "113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.6",
      "y1": "77.1",
      "x2": "171.4",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.6",
      "y1": "117.1",
      "x2": "51.4",
      "y2": "178.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143",
      "y1": "143",
      "x2": "113",
      "y2": "113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.6",
      "y1": "77.1",
      "x2": "171.4",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M238.6,78.6A31.6,31.6,0,0,1,216,88a32.2,32.2,0,0,1-7.6-.9l-26.7,49.4.9.9a31.9,31.9,0,0,1,0,45.2,31.9,31.9,0,0,1-45.2,0,32,32,0,0,1-5-38.9l-20.1-20.1A32.7,32.7,0,0,1,96,128a32.2,32.2,0,0,1-7.6-.9L61.7,176.5l.9.9a31.9,31.9,0,0,1,0,45.2,31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2h0a32.1,32.1,0,0,1,30.2-8.5l26.7-49.4-.9-.9a31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,50.2,38.9l20.1,20.1a32.4,32.4,0,0,1,23.9-3.5l26.7-49.4-.9-.9a31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,45.2,45.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.6",
      "y1": "117.1",
      "x2": "51.4",
      "y2": "178.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143",
      "y1": "143",
      "x2": "113",
      "y2": "113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.6",
      "y1": "77.1",
      "x2": "171.4",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.6",
      "y1": "117.1",
      "x2": "51.4",
      "y2": "178.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143",
      "y1": "143",
      "x2": "113",
      "y2": "113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.6",
      "y1": "77.1",
      "x2": "171.4",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "96",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "160",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84.6",
      "y1": "117.1",
      "x2": "51.4",
      "y2": "178.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "143",
      "y1": "143",
      "x2": "113",
      "y2": "113",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "204.6",
      "y1": "77.1",
      "x2": "171.4",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6U = [];
/* style */

const __vue_inject_styles__$6U = undefined;
/* scoped */

const __vue_scope_id__$6U = undefined;
/* module identifier */

const __vue_module_identifier__$6U = undefined;
/* functional template */

const __vue_is_functional_template__$6U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6U,
  staticRenderFns: __vue_staticRenderFns__$6U
}, __vue_inject_styles__$6U, __vue_script__$6U, __vue_scope_id__$6U, __vue_is_functional_template__$6U, __vue_module_identifier__$6U, false, undefined, undefined, undefined);

var script$6T = Vue.extend({
  name: "PhLink",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6T = script$6T;
/* template */

var __vue_render__$6T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.5,61.3l9.6-9.7a44.1,44.1,0,0,1,62.3,62.3l-30.3,30.2a43.9,43.9,0,0,1-62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123.5,194.7l-9.6,9.7a44.1,44.1,0,0,1-62.3-62.3l30.3-30.2a43.9,43.9,0,0,1,62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210,46a51.8,51.8,0,0,0-73.5,0L116.7,65.8A8,8,0,0,0,128,77.1l19.8-19.8a36.1,36.1,0,0,1,50.9,0,35.9,35.9,0,0,1,0,50.9l-28.3,28.3a36.1,36.1,0,0,1-50.9,0,8,8,0,1,0-11.3,11.3,52,52,0,0,0,73.5,0L210,119.5A51.8,51.8,0,0,0,210,46Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,178.9l-19.8,19.8a36,36,0,0,1-50.9-50.9l28.3-28.3a36.1,36.1,0,0,1,50.9,0,8,8,0,0,0,11.3-11.3,52,52,0,0,0-73.5,0L46,136.5A52,52,0,1,0,119.5,210l19.8-19.8A8,8,0,0,0,128,178.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6T = [];
/* style */

const __vue_inject_styles__$6T = undefined;
/* scoped */

const __vue_scope_id__$6T = undefined;
/* module identifier */

const __vue_module_identifier__$6T = undefined;
/* functional template */

const __vue_is_functional_template__$6T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6T,
  staticRenderFns: __vue_staticRenderFns__$6T
}, __vue_inject_styles__$6T, __vue_script__$6T, __vue_scope_id__$6T, __vue_is_functional_template__$6T, __vue_module_identifier__$6T, false, undefined, undefined, undefined);

var script$6S = Vue.extend({
  name: "PhLinkBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6S = script$6S;
/* template */

var __vue_render__$6S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "68",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "160",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "96",
      "x2": "48",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "160",
      "x2": "188",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67,132.4l-7.3,7.3a40,40,0,0,0,56.6,56.6l7.3-7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M189,123.6l7.3-7.3a40,40,0,0,0-56.6-56.6L132.4,67",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "160",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "96",
      "x2": "48",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "160",
      "x2": "184",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,72V48a8,8,0,0,1,16,0V72a8,8,0,0,1-16,0Zm72,104a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V184A8,8,0,0,0,160,176ZM48,104H72a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm160,48H184a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm-86.1,27.3-11.3,11.3a32,32,0,0,1-45.2-45.2l11.3-11.3a8.1,8.1,0,0,0,0-11.4,8,8,0,0,0-11.3,0L54.1,134.1a47.9,47.9,0,1,0,67.8,67.8l11.4-11.3a8,8,0,0,0,0-11.3A8.1,8.1,0,0,0,121.9,179.3ZM190.6,65.4a31.9,31.9,0,0,1,0,45.2l-11.3,11.3a8.1,8.1,0,0,0,0,11.4,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l11.3-11.4a47.9,47.9,0,0,0-67.8-67.8L122.7,65.4a8,8,0,0,0,0,11.3,8.1,8.1,0,0,0,11.4,0l11.3-11.3A31.9,31.9,0,0,1,190.6,65.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "160",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "96",
      "x2": "48",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "160",
      "x2": "184",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "160",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "96",
      "x2": "48",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "160",
      "x2": "184",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "72",
      "x2": "96",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "160",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "96",
      "x2": "48",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "160",
      "x2": "184",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6S = [];
/* style */

const __vue_inject_styles__$6S = undefined;
/* scoped */

const __vue_scope_id__$6S = undefined;
/* module identifier */

const __vue_module_identifier__$6S = undefined;
/* functional template */

const __vue_is_functional_template__$6S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6S,
  staticRenderFns: __vue_staticRenderFns__$6S
}, __vue_inject_styles__$6S, __vue_script__$6S, __vue_scope_id__$6S, __vue_is_functional_template__$6S, __vue_module_identifier__$6S, false, undefined, undefined, undefined);

var script$6R = Vue.extend({
  name: "PhLinkSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6R = script$6R;
/* template */

var __vue_render__$6R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "161.9",
      "y2": "94",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "161.9",
      "y2": "94",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.3,88.4,88.4,156.3a8,8,0,0,0,0,11.3,8.1,8.1,0,0,0,11.3,0l67.9-67.9a8,8,0,0,0-11.3-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,173.3,111,201.5a39.7,39.7,0,0,1-56.5,0,40,40,0,0,1,0-56.5l28.2-28.3a8,8,0,0,0-11.3-11.3L43.1,133.7a56,56,0,0,0,79.2,79.2l28.3-28.3a8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,139.3,173.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,43.1a56,56,0,0,0-79.2,0L105.4,71.4a8,8,0,0,0,11.3,11.3L145,54.5a39.7,39.7,0,0,1,56.5,0,40,40,0,0,1,0,56.5l-28.2,28.3a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l28.3-28.3A56.1,56.1,0,0,0,212.9,43.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "161.9",
      "y2": "94",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "161.9",
      "y2": "94",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "161.9",
      "y2": "94",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6R = [];
/* style */

const __vue_inject_styles__$6R = undefined;
/* scoped */

const __vue_scope_id__$6R = undefined;
/* module identifier */

const __vue_module_identifier__$6R = undefined;
/* functional template */

const __vue_is_functional_template__$6R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6R,
  staticRenderFns: __vue_staticRenderFns__$6R
}, __vue_inject_styles__$6R, __vue_script__$6R, __vue_scope_id__$6R, __vue_is_functional_template__$6R, __vue_module_identifier__$6R, false, undefined, undefined, undefined);

var script$6Q = Vue.extend({
  name: "PhLinkSimpleBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6Q = script$6Q;
/* template */

var __vue_render__$6Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,173.3,111,201.5a39.7,39.7,0,0,1-56.5,0,40,40,0,0,1,0-56.5l28.2-28.3a8,8,0,0,0-11.3-11.3L43.1,133.7a56,56,0,0,0,79.2,79.2l28.3-28.3a8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,139.3,173.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,43.1a56,56,0,0,0-79.2,0L105.4,71.4a8,8,0,0,0,11.3,11.3L145,54.5a39.7,39.7,0,0,1,56.5,0,40,40,0,0,1,0,56.5l-28.2,28.3a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l28.3-28.3A56.1,56.1,0,0,0,212.9,43.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6Q = [];
/* style */

const __vue_inject_styles__$6Q = undefined;
/* scoped */

const __vue_scope_id__$6Q = undefined;
/* module identifier */

const __vue_module_identifier__$6Q = undefined;
/* functional template */

const __vue_is_functional_template__$6Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6Q,
  staticRenderFns: __vue_staticRenderFns__$6Q
}, __vue_inject_styles__$6Q, __vue_script__$6Q, __vue_scope_id__$6Q, __vue_is_functional_template__$6Q, __vue_module_identifier__$6Q, false, undefined, undefined, undefined);

var script$6P = Vue.extend({
  name: "PhLinkSimpleHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6P = script$6P;
/* template */

var __vue_render__$6P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128a8,8,0,0,0,8,8h96a8,8,0,0,0,0-16H80A8,8,0,0,0,72,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,168H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,72H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "176",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6P = [];
/* style */

const __vue_inject_styles__$6P = undefined;
/* scoped */

const __vue_scope_id__$6P = undefined;
/* module identifier */

const __vue_module_identifier__$6P = undefined;
/* functional template */

const __vue_is_functional_template__$6P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6P,
  staticRenderFns: __vue_staticRenderFns__$6P
}, __vue_inject_styles__$6P, __vue_script__$6P, __vue_scope_id__$6P, __vue_is_functional_template__$6P, __vue_module_identifier__$6P, false, undefined, undefined, undefined);

var script$6O = Vue.extend({
  name: "PhLinkSimpleHorizontalBreak",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6O = script$6O;
/* template */

var __vue_render__$6O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,168H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,72H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H64a48,48,0,0,1,0-96h40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176h40a48,48,0,0,0,0-96H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6O = [];
/* style */

const __vue_inject_styles__$6O = undefined;
/* scoped */

const __vue_scope_id__$6O = undefined;
/* module identifier */

const __vue_module_identifier__$6O = undefined;
/* functional template */

const __vue_is_functional_template__$6O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6O,
  staticRenderFns: __vue_staticRenderFns__$6O
}, __vue_inject_styles__$6O, __vue_script__$6O, __vue_scope_id__$6O, __vue_is_functional_template__$6O, __vue_module_identifier__$6O, false, undefined, undefined, undefined);

var script$6N = Vue.extend({
  name: "PhLinkedinLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6N = script$6N;
/* template */

var __vue_render__$6N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "124",
      "y1": "120",
      "x2": "124",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "120",
      "x2": "84",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,148a28,28,0,0,1,56,0v28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "80",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112",
      "x2": "120",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140a28,28,0,0,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "80",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,28H44A16,16,0,0,0,28,44V212a16,16,0,0,0,16,16H212a16,16,0,0,0,16-16V44A16,16,0,0,0,212,28ZM96,176a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM88,92a12,12,0,1,1,12-12A12,12,0,0,1,88,92Zm96,84a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.8-1.8A36,36,0,0,1,184,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112",
      "x2": "120",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140a28,28,0,0,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "80",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112",
      "x2": "120",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140a28,28,0,0,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "80",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "36",
      "y": "36",
      "width": "184",
      "height": "184",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "112",
      "x2": "120",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "112",
      "x2": "88",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,140a28,28,0,0,1,56,0v36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "80",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6N = [];
/* style */

const __vue_inject_styles__$6N = undefined;
/* scoped */

const __vue_scope_id__$6N = undefined;
/* module identifier */

const __vue_module_identifier__$6N = undefined;
/* functional template */

const __vue_is_functional_template__$6N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6N,
  staticRenderFns: __vue_staticRenderFns__$6N
}, __vue_inject_styles__$6N, __vue_script__$6N, __vue_scope_id__$6N, __vue_is_functional_template__$6N, __vue_module_identifier__$6N, false, undefined, undefined, undefined);

var script$6M = Vue.extend({
  name: "PhLinuxLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6M = script$6M;
/* template */

var __vue_render__$6M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "112",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "112",
      "r": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "156 152 128 164 100 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101.5,212a47.9,47.9,0,0,1,53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.2,212S60,160,60,104a68,68,0,0,1,136,0c0,56,23.8,108,23.8,108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M169.6,216a48.1,48.1,0,0,0-83.2,0H32S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 160 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.4,216a48.1,48.1,0,0,1,83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M161.2,217.7a4,4,0,0,1-3.3,6.3H98.1a4,4,0,0,1-3.3-6.3,40,40,0,0,1,66.4,0Zm68.6,3.8a8.2,8.2,0,0,1-6,2.5H184.6a4.1,4.1,0,0,1-3.8-2.7,56,56,0,0,0-105.6,0,4.1,4.1,0,0,1-3.8,2.7H32.2a8,8,0,0,1-6-2.5,7.9,7.9,0,0,1-1.1-9.5c.3-.5,30.9-55,30.9-116a72.1,72.1,0,0,1,72.5-72c39.6.3,71.4,32.9,71.5,72.5.2,60.8,30.6,115,30.9,115.5A7.9,7.9,0,0,1,229.8,221.5ZM88,108a12,12,0,1,0,12-12A12,12,0,0,0,88,108Zm79.2,32.4a8.2,8.2,0,0,0-10.8-3.6L128,151.1,99.6,136.8a8,8,0,1,0-7.2,14.4l32,16a8.5,8.5,0,0,0,7.2,0l32-16A8.2,8.2,0,0,0,167.2,140.4ZM168,108a12,12,0,1,0-12,12A12,12,0,0,0,168,108Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 160 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.4,216a48.1,48.1,0,0,1,83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 160 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.4,216a48.1,48.1,0,0,1,83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 144 128 160 96 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.4,216a48.1,48.1,0,0,1,83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6M = [];
/* style */

const __vue_inject_styles__$6M = undefined;
/* scoped */

const __vue_scope_id__$6M = undefined;
/* module identifier */

const __vue_module_identifier__$6M = undefined;
/* functional template */

const __vue_is_functional_template__$6M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6M,
  staticRenderFns: __vue_staticRenderFns__$6M
}, __vue_inject_styles__$6M, __vue_script__$6M, __vue_scope_id__$6M, __vue_is_functional_template__$6M, __vue_module_identifier__$6M, false, undefined, undefined, undefined);

var script$6L = Vue.extend({
  name: "PhList",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6L = script$6L;
/* template */

var __vue_render__$6L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,120H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6L = [];
/* style */

const __vue_inject_styles__$6L = undefined;
/* scoped */

const __vue_scope_id__$6L = undefined;
/* module identifier */

const __vue_module_identifier__$6L = undefined;
/* functional template */

const __vue_is_functional_template__$6L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6L,
  staticRenderFns: __vue_staticRenderFns__$6L
}, __vue_inject_styles__$6L, __vue_script__$6L, __vue_scope_id__$6L, __vue_is_functional_template__$6L, __vue_module_identifier__$6L, false, undefined, undefined, undefined);

var script$6K = Vue.extend({
  name: "PhListBullets",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6K = script$6K;
/* template */

var __vue_render__$6K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,116a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0-64A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,128a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "64",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "192",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6K = [];
/* style */

const __vue_inject_styles__$6K = undefined;
/* scoped */

const __vue_scope_id__$6K = undefined;
/* module identifier */

const __vue_module_identifier__$6K = undefined;
/* functional template */

const __vue_is_functional_template__$6K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6K,
  staticRenderFns: __vue_staticRenderFns__$6K
}, __vue_inject_styles__$6K, __vue_script__$6K, __vue_scope_id__$6K, __vue_is_functional_template__$6K, __vue_module_identifier__$6K, false, undefined, undefined, undefined);

var script$6J = Vue.extend({
  name: "PhListChecks",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6J = script$6J;
/* template */

var __vue_render__$6J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 48 57.3 80 40 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 112 57.3 144 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 176 57.3 208 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 48 57.3 80 40 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 112 57.3 144 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 176 57.3 208 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM86.6,42.1l-29.3,27-11.9-11A8,8,0,0,0,34.6,69.9l17.3,16A8,8,0,0,0,57.3,88a8.2,8.2,0,0,0,5.5-2.1l34.6-32A8,8,0,1,0,86.6,42.1Zm0,64-29.3,27-11.9-11a8,8,0,1,0-10.8,11.8l17.3,16a8,8,0,0,0,5.4,2.1,8.2,8.2,0,0,0,5.5-2.1l34.6-32a8,8,0,1,0-10.8-11.8Zm0,64-29.3,27-11.9-11a8,8,0,1,0-10.8,11.8l17.3,16a8,8,0,0,0,5.4,2.1,8.2,8.2,0,0,0,5.5-2.1l34.6-32a8,8,0,0,0-10.8-11.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 48 57.3 80 40 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 112 57.3 144 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 176 57.3 208 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 48 57.3 80 40 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 112 57.3 144 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 176 57.3 208 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 48 57.3 80 40 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 112 57.3 144 40 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "92 176 57.3 208 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6J = [];
/* style */

const __vue_inject_styles__$6J = undefined;
/* scoped */

const __vue_scope_id__$6J = undefined;
/* module identifier */

const __vue_module_identifier__$6J = undefined;
/* functional template */

const __vue_is_functional_template__$6J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6J,
  staticRenderFns: __vue_staticRenderFns__$6J
}, __vue_inject_styles__$6J, __vue_script__$6J, __vue_scope_id__$6J, __vue_is_functional_template__$6J, __vue_module_identifier__$6J, false, undefined, undefined, undefined);

var script$6I = Vue.extend({
  name: "PhListDashes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6I = script$6I;
/* template */

var __vue_render__$6I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm128,56H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM56,56H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "56",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "56",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6I = [];
/* style */

const __vue_inject_styles__$6I = undefined;
/* scoped */

const __vue_scope_id__$6I = undefined;
/* module identifier */

const __vue_module_identifier__$6I = undefined;
/* functional template */

const __vue_is_functional_template__$6I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6I,
  staticRenderFns: __vue_staticRenderFns__$6I
}, __vue_inject_styles__$6I, __vue_script__$6I, __vue_scope_id__$6I, __vue_is_functional_template__$6I, __vue_module_identifier__$6I, false, undefined, undefined, undefined);

var script$6H = Vue.extend({
  name: "PhListNumbers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6H = script$6H;
/* template */

var __vue_render__$6H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.6,67.2,48,64.9V108a8,8,0,0,0,16,0V52a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-16,8a8,8,0,1,0,7.2,14.4ZM72.2,170.3A21.5,21.5,0,0,0,76,158a22,22,0,0,0-42.3-8.6,8,8,0,0,0,14.8,6.3A5.8,5.8,0,0,1,54,152a6,6,0,0,1,6,6,5.7,5.7,0,0,1-.9,3.2l-25.5,34A8,8,0,0,0,40,208H68a8,8,0,0,0,0-16H56l16-21.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 60 56 52 56 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6H = [];
/* style */

const __vue_inject_styles__$6H = undefined;
/* scoped */

const __vue_scope_id__$6H = undefined;
/* module identifier */

const __vue_module_identifier__$6H = undefined;
/* functional template */

const __vue_is_functional_template__$6H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6H,
  staticRenderFns: __vue_staticRenderFns__$6H
}, __vue_inject_styles__$6H, __vue_script__$6H, __vue_scope_id__$6H, __vue_is_functional_template__$6H, __vue_module_identifier__$6H, false, undefined, undefined, undefined);

var script$6G = Vue.extend({
  name: "PhListPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6G = script$6G;
/* template */

var __vue_render__$6G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "192",
      "x2": "232",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "168",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6G = [];
/* style */

const __vue_inject_styles__$6G = undefined;
/* scoped */

const __vue_scope_id__$6G = undefined;
/* module identifier */

const __vue_module_identifier__$6G = undefined;
/* functional template */

const __vue_is_functional_template__$6G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6G,
  staticRenderFns: __vue_staticRenderFns__$6G
}, __vue_inject_styles__$6G, __vue_script__$6G, __vue_scope_id__$6G, __vue_is_functional_template__$6G, __vue_module_identifier__$6G, false, undefined, undefined, undefined);

var script$6F = Vue.extend({
  name: "PhLock",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6F = script$6F;
/* template */

var __vue_render__$6F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-80,84a12,12,0,1,1,12-12A12,12,0,0,1,128,164Zm28-84H100V52a28,28,0,0,1,56,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6F = [];
/* style */

const __vue_inject_styles__$6F = undefined;
/* scoped */

const __vue_scope_id__$6F = undefined;
/* module identifier */

const __vue_module_identifier__$6F = undefined;
/* functional template */

const __vue_is_functional_template__$6F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6F,
  staticRenderFns: __vue_staticRenderFns__$6F
}, __vue_inject_styles__$6F, __vue_script__$6F, __vue_scope_id__$6F, __vue_is_functional_template__$6F, __vue_module_identifier__$6F, false, undefined, undefined, undefined);

var script$6E = Vue.extend({
  name: "PhLockKey",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6E = script$6E;
/* template */

var __vue_render__$6E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "164",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,88H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V96A8,8,0,0,0,208,88Zm-80,72a20,20,0,1,1,20-20A20,20,0,0,1,128,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-72,86.8V184a8,8,0,0,1-16,0V166.8a28,28,0,1,1,16,0ZM156,80H100V52a28,28,0,0,1,56,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6E = [];
/* style */

const __vue_inject_styles__$6E = undefined;
/* scoped */

const __vue_scope_id__$6E = undefined;
/* module identifier */

const __vue_module_identifier__$6E = undefined;
/* functional template */

const __vue_is_functional_template__$6E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6E,
  staticRenderFns: __vue_staticRenderFns__$6E
}, __vue_inject_styles__$6E, __vue_script__$6E, __vue_scope_id__$6E, __vue_is_functional_template__$6E, __vue_module_identifier__$6E, false, undefined, undefined, undefined);

var script$6D = Vue.extend({
  name: "PhLockKeyOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6D = script$6D;
/* template */

var __vue_render__$6D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "164",
      "x2": "128",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,71.8-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,88H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V96A8,8,0,0,0,208,88Zm-80,72a20,20,0,1,1,20-20A20,20,0,0,1,128,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-72,86.8V184a8,8,0,0,1-16,0V166.8a28,28,0,1,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "160",
      "x2": "128",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6D = [];
/* style */

const __vue_inject_styles__$6D = undefined;
/* scoped */

const __vue_scope_id__$6D = undefined;
/* module identifier */

const __vue_module_identifier__$6D = undefined;
/* functional template */

const __vue_is_functional_template__$6D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6D,
  staticRenderFns: __vue_staticRenderFns__$6D
}, __vue_inject_styles__$6D, __vue_script__$6D, __vue_scope_id__$6D, __vue_is_functional_template__$6D, __vue_module_identifier__$6D, false, undefined, undefined, undefined);

var script$6C = Vue.extend({
  name: "PhLockLaminated",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6C = script$6C;
/* template */

var __vue_render__$6C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "132",
      "x2": "216",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "172",
      "x2": "216",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM100,52a28,28,0,0,1,56,0V80H100Zm84,140H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6C = [];
/* style */

const __vue_inject_styles__$6C = undefined;
/* scoped */

const __vue_scope_id__$6C = undefined;
/* module identifier */

const __vue_module_identifier__$6C = undefined;
/* functional template */

const __vue_is_functional_template__$6C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6C,
  staticRenderFns: __vue_staticRenderFns__$6C
}, __vue_inject_styles__$6C, __vue_script__$6C, __vue_scope_id__$6C, __vue_is_functional_template__$6C, __vue_module_identifier__$6C, false, undefined, undefined, undefined);

var script$6B = Vue.extend({
  name: "PhLockLaminatedOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6B = script$6B;
/* template */

var __vue_render__$6B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "132",
      "x2": "216",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "172",
      "x2": "216",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,71.8-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM184,192H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "120",
      "x2": "216",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6B = [];
/* style */

const __vue_inject_styles__$6B = undefined;
/* scoped */

const __vue_scope_id__$6B = undefined;
/* module identifier */

const __vue_module_identifier__$6B = undefined;
/* functional template */

const __vue_is_functional_template__$6B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6B,
  staticRenderFns: __vue_staticRenderFns__$6B
}, __vue_inject_styles__$6B, __vue_script__$6B, __vue_scope_id__$6B, __vue_is_functional_template__$6B, __vue_module_identifier__$6B, false, undefined, undefined, undefined);

var script$6A = Vue.extend({
  name: "PhLockOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6A = script$6A;
/* template */

var __vue_render__$6A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,71.8-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-80,84a12,12,0,1,1,12-12A12,12,0,0,1,128,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "152",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6A = [];
/* style */

const __vue_inject_styles__$6A = undefined;
/* scoped */

const __vue_scope_id__$6A = undefined;
/* module identifier */

const __vue_module_identifier__$6A = undefined;
/* functional template */

const __vue_is_functional_template__$6A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6A,
  staticRenderFns: __vue_staticRenderFns__$6A
}, __vue_inject_styles__$6A, __vue_script__$6A, __vue_scope_id__$6A, __vue_is_functional_template__$6A, __vue_module_identifier__$6A, false, undefined, undefined, undefined);

var script$6z = Vue.extend({
  name: "PhLockSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6z = script$6z;
/* template */

var __vue_render__$6z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM100,52a28,28,0,0,1,56,0V80H100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6z = [];
/* style */

const __vue_inject_styles__$6z = undefined;
/* scoped */

const __vue_scope_id__$6z = undefined;
/* module identifier */

const __vue_module_identifier__$6z = undefined;
/* functional template */

const __vue_is_functional_template__$6z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6z,
  staticRenderFns: __vue_staticRenderFns__$6z
}, __vue_inject_styles__$6z, __vue_script__$6z, __vue_scope_id__$6z, __vue_is_functional_template__$6z, __vue_module_identifier__$6z, false, undefined, undefined, undefined);

var script$6y = Vue.extend({
  name: "PhLockSimpleOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6y = script$6y;
/* template */

var __vue_render__$6y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,71.8-4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "176",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,88V52a36,36,0,0,1,72,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6y = [];
/* style */

const __vue_inject_styles__$6y = undefined;
/* scoped */

const __vue_scope_id__$6y = undefined;
/* module identifier */

const __vue_module_identifier__$6y = undefined;
/* functional template */

const __vue_is_functional_template__$6y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6y,
  staticRenderFns: __vue_staticRenderFns__$6y
}, __vue_inject_styles__$6y, __vue_script__$6y, __vue_scope_id__$6y, __vue_is_functional_template__$6y, __vue_module_identifier__$6y, false, undefined, undefined, undefined);

var script$6x = Vue.extend({
  name: "PhMagicWand",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6x = script$6x;
/* template */

var __vue_render__$6x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "220",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "196",
      "y1": "152",
      "x2": "244",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "36",
      "x2": "80",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "56",
      "x2": "100",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "188",
      "x2": "164",
      "y2": "220",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "204",
      "x2": "180",
      "y2": "204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "105.4",
      "width": "226.3",
      "height": "45.25",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M69.7,218.3a8,8,0,0,1-11.4,0L37.7,197.7a8,8,0,0,1,0-11.4L144,80l32,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "105.4",
      "width": "226.3",
      "height": "45.25",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,152a8,8,0,0,1-8,8H224v16a8,8,0,0,1-16,0V160H192a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,248,152ZM64,68H76V80a8,8,0,0,0,16,0V68h12a8,8,0,0,0,0-16H92V40a8,8,0,0,0-16,0V52H64a8,8,0,0,0,0,16ZM184,192h-8v-8a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16Zm-2.3-74.3L75.3,224a15.9,15.9,0,0,1-22.6,0L32,203.3a15.9,15.9,0,0,1,0-22.6L180.7,32a16.1,16.1,0,0,1,22.6,0L224,52.7a15.9,15.9,0,0,1,0,22.6l-42.3,42.4ZM155.3,80,176,100.7,212.7,64h0L192,43.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "105.4",
      "width": "226.3",
      "height": "45.25",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "105.4",
      "width": "226.3",
      "height": "45.25",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "128",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "40",
      "x2": "84",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "60",
      "x2": "104",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "184",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "184",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "105.4",
      "width": "226.3",
      "height": "45.25",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "80",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6x = [];
/* style */

const __vue_inject_styles__$6x = undefined;
/* scoped */

const __vue_scope_id__$6x = undefined;
/* module identifier */

const __vue_module_identifier__$6x = undefined;
/* functional template */

const __vue_is_functional_template__$6x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6x,
  staticRenderFns: __vue_staticRenderFns__$6x
}, __vue_inject_styles__$6x, __vue_script__$6x, __vue_scope_id__$6x, __vue_is_functional_template__$6x, __vue_module_identifier__$6x, false, undefined, undefined, undefined);

var script$6w = Vue.extend({
  name: "PhMagnet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6w = script$6w;
/* template */

var __vue_render__$6w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.8",
      "y1": "162.4",
      "x2": "166.6",
      "y2": "202.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54",
      "y1": "89.6",
      "x2": "93.7",
      "y2": "129.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M126.8,162.4l39.8,39.8-32.9,32.3a8.1,8.1,0,0,1-11.3-.1L93.7,205.7a8.1,8.1,0,0,1,.1-11.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,129.4,54,89.6,21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.8",
      "y1": "162.4",
      "x2": "166.6",
      "y2": "202.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54",
      "y1": "89.6",
      "x2": "93.7",
      "y2": "129.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M207,50.2A87.7,87.7,0,0,0,144.6,24h-.3A87.3,87.3,0,0,0,82,49.8L48.3,83.9h0L15.9,116.7a16.1,16.1,0,0,0,.1,22.6l28.6,28.6a15.6,15.6,0,0,0,11.3,4.7H56a15.8,15.8,0,0,0,11.4-4.8l32-32.8h0L133,100.7a16.1,16.1,0,0,1,22.4-.2,15.7,15.7,0,0,1,4.7,11.2,17,17,0,0,1-4.9,12l-34.1,33h0L88.3,188.6a15.9,15.9,0,0,0-.2,22.8l28.6,28.7a16.3,16.3,0,0,0,22.6.1l32.9-32.4h0l33.6-32.9C240.2,140.5,240.8,84.6,207,50.2ZM55.9,156.6,27.3,128,54,100.9l28.5,28.5Zm72.2,72.1L99.4,200.1l27.3-26.5,28.5,28.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.8",
      "y1": "162.4",
      "x2": "166.6",
      "y2": "202.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54",
      "y1": "89.6",
      "x2": "93.7",
      "y2": "129.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.8",
      "y1": "162.4",
      "x2": "166.6",
      "y2": "202.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54",
      "y1": "89.6",
      "x2": "93.7",
      "y2": "129.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "126.8",
      "y1": "162.4",
      "x2": "166.6",
      "y2": "202.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54",
      "y1": "89.6",
      "x2": "93.7",
      "y2": "129.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6w = [];
/* style */

const __vue_inject_styles__$6w = undefined;
/* scoped */

const __vue_scope_id__$6w = undefined;
/* module identifier */

const __vue_module_identifier__$6w = undefined;
/* functional template */

const __vue_is_functional_template__$6w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6w,
  staticRenderFns: __vue_staticRenderFns__$6w
}, __vue_inject_styles__$6w, __vue_script__$6w, __vue_scope_id__$6w, __vue_is_functional_template__$6w, __vue_module_identifier__$6w, false, undefined, undefined, undefined);

var script$6v = Vue.extend({
  name: "PhMagnetStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6v = script$6v;
/* template */

var __vue_render__$6v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8V96H48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V96H152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a87.9,87.9,0,0,0,88,88h.7c48.1-.4,87.3-40.3,87.3-89V56A16,16,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "96",
      "x2": "104",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6v = [];
/* style */

const __vue_inject_styles__$6v = undefined;
/* scoped */

const __vue_scope_id__$6v = undefined;
/* module identifier */

const __vue_module_identifier__$6v = undefined;
/* functional template */

const __vue_is_functional_template__$6v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6v,
  staticRenderFns: __vue_staticRenderFns__$6v
}, __vue_inject_styles__$6v, __vue_script__$6v, __vue_scope_id__$6v, __vue_is_functional_template__$6v, __vue_module_identifier__$6v, false, undefined, undefined, undefined);

var script$6u = Vue.extend({
  name: "PhMagnifyingGlass",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6u = script$6u;
/* template */

var __vue_render__$6u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,116a60,60,0,1,1-60-60A60,60,0,0,1,176,116Zm53.6,113.7A8,8,0,0,1,224,232a8.3,8.3,0,0,1-5.7-2.3l-43.2-43.3a92.2,92.2,0,1,1,11.3-11.3l43.2,43.2A8,8,0,0,1,229.6,229.7ZM116,192a76,76,0,1,0-76-76A76.1,76.1,0,0,0,116,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6u = [];
/* style */

const __vue_inject_styles__$6u = undefined;
/* scoped */

const __vue_scope_id__$6u = undefined;
/* module identifier */

const __vue_module_identifier__$6u = undefined;
/* functional template */

const __vue_is_functional_template__$6u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6u,
  staticRenderFns: __vue_staticRenderFns__$6u
}, __vue_inject_styles__$6u, __vue_script__$6u, __vue_scope_id__$6u, __vue_is_functional_template__$6u, __vue_module_identifier__$6u, false, undefined, undefined, undefined);

var script$6t = Vue.extend({
  name: "PhMagnifyingGlassMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6t = script$6t;
/* template */

var __vue_render__$6t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.6,218.3l-43.2-43.2a92.2,92.2,0,1,0-11.3,11.3l43.2,43.3A8.3,8.3,0,0,0,224,232a8,8,0,0,0,5.6-13.7ZM148,124H84a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6t = [];
/* style */

const __vue_inject_styles__$6t = undefined;
/* scoped */

const __vue_scope_id__$6t = undefined;
/* module identifier */

const __vue_module_identifier__$6t = undefined;
/* functional template */

const __vue_is_functional_template__$6t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6t,
  staticRenderFns: __vue_staticRenderFns__$6t
}, __vue_inject_styles__$6t, __vue_script__$6t, __vue_scope_id__$6t, __vue_is_functional_template__$6t, __vue_module_identifier__$6t, false, undefined, undefined, undefined);

var script$6s = Vue.extend({
  name: "PhMagnifyingGlassPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6s = script$6s;
/* template */

var __vue_render__$6s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.6,218.3l-43.2-43.2a92.2,92.2,0,1,0-11.3,11.3l43.2,43.3A8.3,8.3,0,0,0,224,232a8,8,0,0,0,5.6-13.7ZM148,124H124v24a8,8,0,0,1-16,0V124H84a8,8,0,0,1,0-16h24V84a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "84",
      "y1": "116",
      "x2": "148",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "84",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "116",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "175.4",
      "y1": "175.4",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6s = [];
/* style */

const __vue_inject_styles__$6s = undefined;
/* scoped */

const __vue_scope_id__$6s = undefined;
/* module identifier */

const __vue_module_identifier__$6s = undefined;
/* functional template */

const __vue_is_functional_template__$6s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6s,
  staticRenderFns: __vue_staticRenderFns__$6s
}, __vue_inject_styles__$6s, __vue_script__$6s, __vue_scope_id__$6s, __vue_is_functional_template__$6s, __vue_module_identifier__$6s, false, undefined, undefined, undefined);

var script$6r = Vue.extend({
  name: "PhMapPin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6r = script$6r;
/* template */

var __vue_render__$6r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.2,83.4,134.6a8.3,8.3,0,0,0,9.2,0C136,236.2,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6r = [];
/* style */

const __vue_inject_styles__$6r = undefined;
/* scoped */

const __vue_scope_id__$6r = undefined;
/* module identifier */

const __vue_module_identifier__$6r = undefined;
/* functional template */

const __vue_is_functional_template__$6r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6r,
  staticRenderFns: __vue_staticRenderFns__$6r
}, __vue_inject_styles__$6r, __vue_script__$6r, __vue_scope_id__$6r, __vue_is_functional_template__$6r, __vue_module_identifier__$6r, false, undefined, undefined, undefined);

var script$6q = Vue.extend({
  name: "PhMapPinLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6q = script$6q;
/* template */

var __vue_render__$6q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H150.5A253.6,253.6,0,0,0,174,200.2c27.5-31.5,42-64.8,42-96.2a88,88,0,0,0-176,0c0,31.4,14.5,64.7,42,96.2A253.6,253.6,0,0,0,105.5,224H56a8,8,0,0,0,0,16H200a8,8,0,0,0,0-16ZM128,72a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "200",
      "y2": "232",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6q = [];
/* style */

const __vue_inject_styles__$6q = undefined;
/* scoped */

const __vue_scope_id__$6q = undefined;
/* module identifier */

const __vue_module_identifier__$6q = undefined;
/* functional template */

const __vue_is_functional_template__$6q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6q,
  staticRenderFns: __vue_staticRenderFns__$6q
}, __vue_inject_styles__$6q, __vue_script__$6q, __vue_scope_id__$6q, __vue_is_functional_template__$6q, __vue_module_identifier__$6q, false, undefined, undefined, undefined);

var script$6p = Vue.extend({
  name: "PhMapTrifold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6p = script$6p;
/* template */

var __vue_render__$6p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.9,49.7a8,8,0,0,0-6.8-1.5L160.9,63.5,99.6,32.8h-.1l-.8-.3h-.2l-.7-.2h-.3l-.7-.2H94.1l-64,16A8,8,0,0,0,24,56V200a7.8,7.8,0,0,0,3.1,6.3A7.9,7.9,0,0,0,32,208l1.9-.2,61.2-15.3,61.3,30.7h.1l.7.3h.1l.8.3h3.8l64-16A8,8,0,0,0,232,200V56A7.8,7.8,0,0,0,228.9,49.7ZM152,203.1l-48-24V52.9l48,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "96 184 32 200 32 56 96 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 216 96 184 96 40 160 72 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 72 224 56 224 200 160 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6p = [];
/* style */

const __vue_inject_styles__$6p = undefined;
/* scoped */

const __vue_scope_id__$6p = undefined;
/* module identifier */

const __vue_module_identifier__$6p = undefined;
/* functional template */

const __vue_is_functional_template__$6p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6p,
  staticRenderFns: __vue_staticRenderFns__$6p
}, __vue_inject_styles__$6p, __vue_script__$6p, __vue_scope_id__$6p, __vue_is_functional_template__$6p, __vue_module_identifier__$6p, false, undefined, undefined, undefined);

var script$6o = Vue.extend({
  name: "PhMarkerCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6o = script$6o;
/* template */

var __vue_render__$6o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V136a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.8,128,135.7,84.4a8,8,0,0,0-15.4,0L108.2,128Z",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,211.2a96,96,0,1,0-96,0h0V176a8,8,0,0,1,8-8h8V144a8,8,0,0,1,8-8h4.2l12-57.6c1.7-8.5,13.9-8.5,15.6,0l12,57.6H152a8,8,0,0,1,8,8v24h8a8,8,0,0,1,8,8v35.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM88,206.4V176h80v30.4A88.8,88.8,0,0,1,88,206.4ZM104,136h48v24H104Zm86.2,54.2c-2,2-4.1,3.9-6.2,5.7V176a16,16,0,0,0-16-16V136a16,16,0,0,0-13.7-15.8L143.6,73.3a16,16,0,0,0-31.2,0l-10.7,46.9A16,16,0,0,0,88,136v24a16,16,0,0,0-16,16v19.9c-2.1-1.8-4.2-3.7-6.2-5.7a88,88,0,1,1,124.4,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6o = [];
/* style */

const __vue_inject_styles__$6o = undefined;
/* scoped */

const __vue_scope_id__$6o = undefined;
/* module identifier */

const __vue_module_identifier__$6o = undefined;
/* functional template */

const __vue_is_functional_template__$6o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6o,
  staticRenderFns: __vue_staticRenderFns__$6o
}, __vue_inject_styles__$6o, __vue_script__$6o, __vue_scope_id__$6o, __vue_is_functional_template__$6o, __vue_module_identifier__$6o, false, undefined, undefined, undefined);

var script$6n = Vue.extend({
  name: "PhMartini",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6n = script$6n;
/* template */

var __vue_render__$6n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "76",
      "x2": "196",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 72 200 72 128 144 56 72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,45.7a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,232,32H24a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L120,147.3V208H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V147.3Zm-25,2.3-16,16H59.3l-16-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 40 232 40 128 144 24 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "216",
      "x2": "168",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "72",
      "x2": "200",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6n = [];
/* style */

const __vue_inject_styles__$6n = undefined;
/* scoped */

const __vue_scope_id__$6n = undefined;
/* module identifier */

const __vue_module_identifier__$6n = undefined;
/* functional template */

const __vue_is_functional_template__$6n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6n,
  staticRenderFns: __vue_staticRenderFns__$6n
}, __vue_inject_styles__$6n, __vue_script__$6n, __vue_scope_id__$6n, __vue_is_functional_template__$6n, __vue_module_identifier__$6n, false, undefined, undefined, undefined);

var script$6m = Vue.extend({
  name: "PhMaskHappy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6m = script$6m;
/* template */

var __vue_render__$6m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,176a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,176a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M217,35.1a15.9,15.9,0,0,0-14.8-1.7C188.2,38.9,159.8,48,128,48S67.8,38.9,53.8,33.4A16,16,0,0,0,32,48.3V104c0,35.8,9.7,69.5,27.2,95s42.6,41,68.8,41,50.7-14.5,68.8-41S224,139.8,224,104V48.3A15.9,15.9,0,0,0,217,35.1ZM80.1,133.3a8,8,0,0,1-11.3.7,8,8,0,0,1-.6-11.3,31.8,31.8,0,0,1,47.6,0,8,8,0,0,1-.6,11.3,8.1,8.1,0,0,1-5.3,2,8,8,0,0,1-6-2.7,16,16,0,0,0-23.8,0ZM159,182.7a56.3,56.3,0,0,1-62,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.3,39.8,39.8,0,0,0,44.2,0,8,8,0,0,1,11.1,2.3A8.1,8.1,0,0,1,159,182.7ZM187.2,134a8.1,8.1,0,0,1-5.3,2,8,8,0,0,1-6-2.7,16,16,0,0,0-23.8,0,8,8,0,0,1-11.3.7,8,8,0,0,1-.6-11.3,31.8,31.8,0,0,1,47.6,0A8,8,0,0,1,187.2,134Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,176a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,176a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,128a24,24,0,0,1,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,176a47.9,47.9,0,0,1-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6m = [];
/* style */

const __vue_inject_styles__$6m = undefined;
/* scoped */

const __vue_scope_id__$6m = undefined;
/* module identifier */

const __vue_module_identifier__$6m = undefined;
/* functional template */

const __vue_is_functional_template__$6m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6m,
  staticRenderFns: __vue_staticRenderFns__$6m
}, __vue_inject_styles__$6m, __vue_script__$6m, __vue_scope_id__$6m, __vue_is_functional_template__$6m, __vue_module_identifier__$6m, false, undefined, undefined, undefined);

var script$6l = Vue.extend({
  name: "PhMaskSad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6l = script$6l;
/* template */

var __vue_render__$6l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,184a47.9,47.9,0,0,0-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,184a47.9,47.9,0,0,0-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M217,35.1a15.9,15.9,0,0,0-14.8-1.7C188.2,38.9,159.8,48,128,48S67.8,38.9,53.8,33.4A16,16,0,0,0,32,48.3V104c0,35.8,9.7,69.5,27.2,95s42.6,41,68.8,41,50.7-14.5,68.8-41S224,139.8,224,104V48.3A15.9,15.9,0,0,0,217,35.1ZM68.2,125.3a8,8,0,0,1,.6-11.3,8,8,0,0,1,11.3.7,16,16,0,0,0,23.8,0,8,8,0,0,1,11.3-.7,8,8,0,0,1,.6,11.3,31.8,31.8,0,0,1-47.6,0Zm93,63.1a8.1,8.1,0,0,1-11.1,2.3,39.8,39.8,0,0,0-44.2,0,8,8,0,0,1-11.1-2.3A8.1,8.1,0,0,1,97,177.3a56.3,56.3,0,0,1,62,0A8.1,8.1,0,0,1,161.2,188.4Zm26.6-63.1a31.8,31.8,0,0,1-47.6,0,8,8,0,0,1,.6-11.3,8,8,0,0,1,11.3.7,16,16,0,0,0,23.8,0,8,8,0,0,1,11.3-.7A8,8,0,0,1,187.8,125.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,184a47.9,47.9,0,0,0-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,184a47.9,47.9,0,0,0-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M146.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.1,120a24,24,0,0,0,35.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.5,184a47.9,47.9,0,0,0-53,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6l = [];
/* style */

const __vue_inject_styles__$6l = undefined;
/* scoped */

const __vue_scope_id__$6l = undefined;
/* module identifier */

const __vue_module_identifier__$6l = undefined;
/* functional template */

const __vue_is_functional_template__$6l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6l,
  staticRenderFns: __vue_staticRenderFns__$6l
}, __vue_inject_styles__$6l, __vue_script__$6l, __vue_scope_id__$6l, __vue_is_functional_template__$6l, __vue_module_identifier__$6l, false, undefined, undefined, undefined);

var script$6k = Vue.extend({
  name: "PhMathOperations",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6k = script$6k;
/* template */

var __vue_render__$6k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "164.1",
      "x2": "152",
      "y2": "164.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "203.9",
      "x2": "152",
      "y2": "203.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.1",
      "x2": "152",
      "y2": "168.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9",
      "x2": "152",
      "y2": "199.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,176H80V152a8,8,0,0,0-16,0v24H40a8,8,0,0,0,0,16H64v24a8,8,0,0,0,16,0V192h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,64H40a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,176.1h64a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,191.9H152a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,101.7a8.2,8.2,0,0,0,11.4,0L184,83.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L195.3,72l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L184,60.7,165.7,42.3a8.1,8.1,0,0,0-11.4,11.4L172.7,72,154.3,90.3A8.1,8.1,0,0,0,154.3,101.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.1",
      "x2": "152",
      "y2": "168.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9",
      "x2": "152",
      "y2": "199.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.1",
      "x2": "152",
      "y2": "168.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9",
      "x2": "152",
      "y2": "199.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "184",
      "x2": "104",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "152",
      "x2": "72",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "72",
      "x2": "40",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168.1",
      "x2": "152",
      "y2": "168.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "199.9",
      "x2": "152",
      "y2": "199.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "96",
      "x2": "160",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6k = [];
/* style */

const __vue_inject_styles__$6k = undefined;
/* scoped */

const __vue_scope_id__$6k = undefined;
/* module identifier */

const __vue_module_identifier__$6k = undefined;
/* functional template */

const __vue_is_functional_template__$6k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6k,
  staticRenderFns: __vue_staticRenderFns__$6k
}, __vue_inject_styles__$6k, __vue_script__$6k, __vue_scope_id__$6k, __vue_is_functional_template__$6k, __vue_module_identifier__$6k, false, undefined, undefined, undefined);

var script$6j = Vue.extend({
  name: "PhMedal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6j = script$6j;
/* template */

var __vue_render__$6j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 160 176 240 128 216 80 240 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 160 176 240 128 216 80 240 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "56"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,8A87.9,87.9,0,0,0,72,163.8V240a7.9,7.9,0,0,0,3.8,6.8,8,8,0,0,0,7.8.4L128,224.9l44.4,22.3a9.4,9.4,0,0,0,3.6.8,8,8,0,0,0,8-8V163.8A87.9,87.9,0,0,0,128,8Zm0,160a72,72,0,1,1,72-72A72.1,72.1,0,0,1,128,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 160 176 240 128 216 80 240 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 160 176 240 128 216 80 240 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 160 176 240 128 216 80 240 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6j = [];
/* style */

const __vue_inject_styles__$6j = undefined;
/* scoped */

const __vue_scope_id__$6j = undefined;
/* module identifier */

const __vue_module_identifier__$6j = undefined;
/* functional template */

const __vue_is_functional_template__$6j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6j,
  staticRenderFns: __vue_staticRenderFns__$6j
}, __vue_inject_styles__$6j, __vue_script__$6j, __vue_scope_id__$6j, __vue_is_functional_template__$6j, __vue_module_identifier__$6j, false, undefined, undefined, undefined);

var script$6i = Vue.extend({
  name: "PhMediumLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6i = script$6i;
/* template */

var __vue_render__$6i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "70",
      "cy": "128",
      "rx": "54",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "182",
      "cy": "128",
      "rx": "22",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72",
      "x2": "240",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72",
      "x2": "240",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,128c0,37.5-28.7,68-64,68S8,165.5,8,128,36.7,60,72,60,136,90.5,136,128Zm48-64c-5.7,0-16.4,2.8-24.3,21.3-5,11.5-7.7,26.7-7.7,42.7s2.7,31.2,7.7,42.7c7.9,18.5,18.6,21.3,24.3,21.3s16.4-2.8,24.3-21.3c5-11.5,7.7-26.7,7.7-42.7s-2.7-31.2-7.7-42.7C200.4,66.8,189.7,64,184,64Zm56,0a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8,8,0,0,0,240,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72",
      "x2": "240",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72",
      "x2": "240",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "72",
      "cy": "128",
      "rx": "56",
      "ry": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "184",
      "cy": "128",
      "rx": "24",
      "ry": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "72",
      "x2": "240",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6i = [];
/* style */

const __vue_inject_styles__$6i = undefined;
/* scoped */

const __vue_scope_id__$6i = undefined;
/* module identifier */

const __vue_module_identifier__$6i = undefined;
/* functional template */

const __vue_is_functional_template__$6i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6i,
  staticRenderFns: __vue_staticRenderFns__$6i
}, __vue_inject_styles__$6i, __vue_script__$6i, __vue_scope_id__$6i, __vue_is_functional_template__$6i, __vue_module_identifier__$6i, false, undefined, undefined, undefined);

var script$6h = Vue.extend({
  name: "PhMegaphone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6h = script$6h;
/* template */

var __vue_render__$6h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,79.5V203.1a7.9,7.9,0,0,0,4.4,7.1l18.7,9.3a7.9,7.9,0,0,0,11.3-5.2L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,160h40a40,40,0,0,0,0-80H152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,120a48,48,0,0,0-48-48H152c-.5,0-52.4-.7-101.7-42.1a15.9,15.9,0,0,0-17.1-2.2A15.7,15.7,0,0,0,24,42.2V197.8a15.7,15.7,0,0,0,9.2,14.5,16.4,16.4,0,0,0,6.8,1.5,15.9,15.9,0,0,0,10.3-3.7c37.9-31.8,77.2-39.6,93.7-41.5v35.1a15.9,15.9,0,0,0,7.1,13.3l11,7.4a16.8,16.8,0,0,0,14.7,1.6,15.9,15.9,0,0,0,9.7-11.1l11.9-47.3A48.2,48.2,0,0,0,240,120Zm-69,91-11-7.3V168h21.8Zm21-59H160V88h32a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6h = [];
/* style */

const __vue_inject_styles__$6h = undefined;
/* scoped */

const __vue_scope_id__$6h = undefined;
/* module identifier */

const __vue_module_identifier__$6h = undefined;
/* functional template */

const __vue_is_functional_template__$6h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6h,
  staticRenderFns: __vue_staticRenderFns__$6h
}, __vue_inject_styles__$6h, __vue_script__$6h, __vue_scope_id__$6h, __vue_is_functional_template__$6h, __vue_module_identifier__$6h, false, undefined, undefined, undefined);

var script$6g = Vue.extend({
  name: "PhMegaphoneSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6g = script$6g;
/* template */

var __vue_render__$6g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.2,43A8,8,0,0,0,32,50.7V189.3A8,8,0,0,0,42.2,197L136,169.7V70.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220.5,86.6,138.4,62.7h-.1L44.5,35.3a15.8,15.8,0,0,0-14.1,2.6A15.7,15.7,0,0,0,24,50.7V189.3a16,16,0,0,0,15.9,16,17.6,17.6,0,0,0,4.6-.6L128,180.3V192a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V161.7l28.5-8.3A16.1,16.1,0,0,0,232,138V102A16.1,16.1,0,0,0,220.5,86.6ZM176,192H144V175.7l32-9.4Zm40-54-34.4,10h0L144,159V81l72,21Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6g = [];
/* style */

const __vue_inject_styles__$6g = undefined;
/* scoped */

const __vue_scope_id__$6g = undefined;
/* module identifier */

const __vue_module_identifier__$6g = undefined;
/* functional template */

const __vue_is_functional_template__$6g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6g,
  staticRenderFns: __vue_staticRenderFns__$6g
}, __vue_inject_styles__$6g, __vue_script__$6g, __vue_scope_id__$6g, __vue_is_functional_template__$6g, __vue_module_identifier__$6g, false, undefined, undefined, undefined);

var script$6f = Vue.extend({
  name: "PhMessengerLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6f = script$6f;
/* template */

var __vue_render__$6f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Zm53.7,93.7-32,32a8.2,8.2,0,0,1-11.4,0L112,123.3,85.7,149.7a8.1,8.1,0,0,1-11.4-11.4l32-32a8.1,8.1,0,0,1,11.4,0L144,132.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 144 112 112 144 144 176 112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6f = [];
/* style */

const __vue_inject_styles__$6f = undefined;
/* scoped */

const __vue_scope_id__$6f = undefined;
/* module identifier */

const __vue_module_identifier__$6f = undefined;
/* functional template */

const __vue_is_functional_template__$6f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6f,
  staticRenderFns: __vue_staticRenderFns__$6f
}, __vue_inject_styles__$6f, __vue_script__$6f, __vue_scope_id__$6f, __vue_is_functional_template__$6f, __vue_module_identifier__$6f, false, undefined, undefined, undefined);

var script$6e = Vue.extend({
  name: "PhMicrophone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6e = script$6e;
/* template */

var __vue_render__$6e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "136",
      "rx": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,120a80,80,0,0,1-160,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.1,72.1,0,0,1-143.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,176a48,48,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48,48,0,0,0,128,176Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200.4,128.1a8,8,0,0,0-8.8,7,64,64,0,0,1-127.2,0,8,8,0,0,0-8.8-7,7.9,7.9,0,0,0-7.1,8.8A79.7,79.7,0,0,0,120,207.3V232a8,8,0,0,0,16,0V207.3a79.7,79.7,0,0,0,71.5-70.4A7.9,7.9,0,0,0,200.4,128.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.1,72.1,0,0,1-143.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.1,72.1,0,0,1-143.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.1,72.1,0,0,1-143.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6e = [];
/* style */

const __vue_inject_styles__$6e = undefined;
/* scoped */

const __vue_scope_id__$6e = undefined;
/* module identifier */

const __vue_module_identifier__$6e = undefined;
/* functional template */

const __vue_is_functional_template__$6e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6e,
  staticRenderFns: __vue_staticRenderFns__$6e
}, __vue_inject_styles__$6e, __vue_script__$6e, __vue_scope_id__$6e, __vue_is_functional_template__$6e, __vue_module_identifier__$6e, false, undefined, undefined, undefined);

var script$6d = Vue.extend({
  name: "PhMicrophoneSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6d = script$6d;
/* template */

var __vue_render__$6d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150.7,153a40.4,40.4,0,0,1-22.7,7h0a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.9,36.5A39.9,39.9,0,0,1,128,24h0a40,40,0,0,1,40,40v48.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177.7,182.7A80,80,0,0,1,48,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,120a79.5,79.5,0,0,1-5.9,30.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "88",
      "y": "24",
      "width": "80",
      "height": "144",
      "rx": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.4,181.3A72,72,0,0,1,56.4,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.9,210.6l-160-176A8,8,0,0,0,42.1,45.4L80,87.1V128a48,48,0,0,0,73.9,40.4l10.9,12A64,64,0,0,1,64.4,135.1a8,8,0,1,0-15.9,1.8A79.9,79.9,0,0,0,120,207.6V232a8,8,0,0,0,16,0V207.6a79.2,79.2,0,0,0,39.6-15.3l26.5,29.1A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1A7.9,7.9,0,0,0,213.9,210.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162.1,129.8a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V64a48,48,0,0,0-48-48A47.5,47.5,0,0,0,87.2,38.8a8,8,0,0,0,.8,9.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192.2,161.7a9.3,9.3,0,0,0,2.9.5,7.8,7.8,0,0,0,7.4-5.1,78.7,78.7,0,0,0,5-20.2,8,8,0,1,0-15.9-1.8,60.1,60.1,0,0,1-4,16.2A8.1,8.1,0,0,0,192.2,161.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.4,181.3A72,72,0,0,1,56.4,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.4,72.4,0,0,1-6.2,22.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176.4,181.3A72,72,0,0,1,56.4,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176.4,181.3A72,72,0,0,1,56.4,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6d = [];
/* style */

const __vue_inject_styles__$6d = undefined;
/* scoped */

const __vue_scope_id__$6d = undefined;
/* module identifier */

const __vue_module_identifier__$6d = undefined;
/* functional template */

const __vue_is_functional_template__$6d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6d,
  staticRenderFns: __vue_staticRenderFns__$6d
}, __vue_inject_styles__$6d, __vue_script__$6d, __vue_scope_id__$6d, __vue_is_functional_template__$6d, __vue_module_identifier__$6d, false, undefined, undefined, undefined);

var script$6c = Vue.extend({
  name: "PhMicrophoneStage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6c = script$6c;
/* template */

var __vue_render__$6c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.3",
      "y1": "133.3",
      "x2": "122.7",
      "y2": "42.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.1,151.2a63.9,63.9,0,0,1-53.3-53.3h0L28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.3",
      "y1": "133.3",
      "x2": "122.7",
      "y2": "42.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "88",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,88a65.1,65.1,0,0,0,.4,7.7l-74.8,102a16,16,0,0,0,1.6,20.8l14.3,14.3a16,16,0,0,0,20.8,1.6l102-74.8a65.1,65.1,0,0,0,7.7.4,71.9,71.9,0,0,0,41.1-12.9,4,4,0,0,0,.5-6.1L115,46.4a4,4,0,0,0-6.1.5A71.9,71.9,0,0,0,96,88Zm17.7,65.7-20,20a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l20-20a8.1,8.1,0,0,1,11.4,11.4ZM239.9,84a72,72,0,0,1-12.8,45.1,4,4,0,0,1-6.1.5L126.4,35a4,4,0,0,1,.5-6.1A72,72,0,0,1,239.9,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.3",
      "y1": "133.3",
      "x2": "122.7",
      "y2": "42.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "88",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.3",
      "y1": "133.3",
      "x2": "122.7",
      "y2": "42.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "88",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "88",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.3",
      "y1": "133.3",
      "x2": "122.7",
      "y2": "42.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "88",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6c = [];
/* style */

const __vue_inject_styles__$6c = undefined;
/* scoped */

const __vue_scope_id__$6c = undefined;
/* module identifier */

const __vue_module_identifier__$6c = undefined;
/* functional template */

const __vue_is_functional_template__$6c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6c,
  staticRenderFns: __vue_staticRenderFns__$6c
}, __vue_inject_styles__$6c, __vue_script__$6c, __vue_scope_id__$6c, __vue_is_functional_template__$6c, __vue_module_identifier__$6c, false, undefined, undefined, undefined);

var script$6b = Vue.extend({
  name: "PhMicrosoftExcelLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6b = script$6b;
/* template */

var __vue_render__$6b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,68V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "188",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "128",
      "height": "120",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "78",
      "y1": "104",
      "x2": "114",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "114",
      "y1": "104",
      "x2": "78",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "104",
      "x2": "110",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM69.2,158.4a8,8,0,0,1-1.6-11.2L82,128,67.6,108.8a8,8,0,1,1,12.8-9.6L92,114.7l11.6-15.5a8,8,0,0,1,12.8,9.6L102,128l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,110,160a8,8,0,0,1-6.4-3.2L92,141.3,80.4,156.8A8,8,0,0,1,74,160,7.7,7.7,0,0,1,69.2,158.4ZM128,216H72V192h56Zm0-152H72V40h56Zm72,152H144V192a16,16,0,0,0,16-16v-8h40Zm0-64H160V104h40Zm0-64H160V80a16,16,0,0,0-16-16V40h56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "104",
      "x2": "110",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "104",
      "x2": "110",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "104",
      "x2": "110",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6b = [];
/* style */

const __vue_inject_styles__$6b = undefined;
/* scoped */

const __vue_scope_id__$6b = undefined;
/* module identifier */

const __vue_module_identifier__$6b = undefined;
/* functional template */

const __vue_is_functional_template__$6b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6b,
  staticRenderFns: __vue_staticRenderFns__$6b
}, __vue_inject_styles__$6b, __vue_script__$6b, __vue_scope_id__$6b, __vue_is_functional_template__$6b, __vue_module_identifier__$6b, false, undefined, undefined, undefined);

var script$6a = Vue.extend({
  name: "PhMicrosoftPowerpointLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6a = script$6a;
/* template */

var __vue_render__$6a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "128",
      "height": "120",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82,136H98a16,16,0,0,0,0-32H82v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.1,68a96,96,0,1,1,0,120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78,136H94a16,16,0,0,0,0-32H78v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,72a96,96,0,1,1,0,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M102,120a8,8,0,0,0-8-8H86v16h8A8,8,0,0,0,102,120Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,24A104.5,104.5,0,0,0,54,64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H54A104,104,0,1,0,136,24ZM70,152V104a8,8,0,0,1,8-8H94a24,24,0,0,1,0,48H86v8a8,8,0,0,1-16,0Zm58,63.6A88.7,88.7,0,0,1,75.6,192H128ZM128,64H75.6A88.7,88.7,0,0,1,128,40.4Zm16-23.6A88,88,0,0,1,223.6,120H160V80a16,16,0,0,0-16-16Zm0,175.2V192a16,16,0,0,0,16-16V136h63.6A88,88,0,0,1,144,215.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78,136H94a16,16,0,0,0,0-32H78v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,72a96,96,0,1,1,0,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78,136H94a16,16,0,0,0,0-32H78v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,72a96,96,0,1,1,0,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "136",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "32",
      "x2": "136",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "232",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78,136H94a16,16,0,0,0,0-32H78v48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,72a96,96,0,1,1,0,112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6a = [];
/* style */

const __vue_inject_styles__$6a = undefined;
/* scoped */

const __vue_scope_id__$6a = undefined;
/* module identifier */

const __vue_module_identifier__$6a = undefined;
/* functional template */

const __vue_is_functional_template__$6a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6a,
  staticRenderFns: __vue_staticRenderFns__$6a
}, __vue_inject_styles__$6a, __vue_script__$6a, __vue_scope_id__$6a, __vue_is_functional_template__$6a, __vue_module_identifier__$6a, false, undefined, undefined, undefined);

var script$69 = Vue.extend({
  name: "PhMicrosoftTeamsLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$69 = script$69;
/* template */

var __vue_render__$69 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "128",
      "height": "120",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "114",
      "y1": "104",
      "x2": "78",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "152",
      "x2": "96",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,88h60v80a56,56,0,0,1-56,56h0a55.9,55.9,0,0,1-52.3-36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134.3,68A32,32,0,1,1,164,88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "152",
      "x2": "92",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108.3,72A32,32,0,1,1,152,83.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.1,45.2a26,26,0,1,1-3.4,28.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.3,80h-4.5A33.5,33.5,0,0,0,220,62a34,34,0,0,0-51.4-29.2A40,40,0,0,0,96,56a42.6,42.6,0,0,0,.8,8H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H76.7a64,64,0,0,0,118.7-.2A40,40,0,0,0,232,152V92.7A12.7,12.7,0,0,0,219.3,80ZM136,32a24.1,24.1,0,0,1,24,24,24.3,24.3,0,0,1-4.1,13.4A15.9,15.9,0,0,0,144,64H113.4a24.5,24.5,0,0,1-1.4-8A24.1,24.1,0,0,1,136,32ZM84,152V112H74a8,8,0,0,1,0-16h36a8,8,0,0,1,0,16H100v40a8,8,0,0,1-16,0Zm100,16a48,48,0,0,1-48,48,48.5,48.5,0,0,1-41.6-24H144a16,16,0,0,0,16-16V96h24Zm2-88a18,18,0,0,1-14-6.7A39.2,39.2,0,0,0,176,56a37.7,37.7,0,0,0-.9-8.3A17.7,17.7,0,0,1,186,44a18,18,0,0,1,0,36Zm30,72a24,24,0,0,1-16.4,22.7,49.2,49.2,0,0,0,.4-6.7V96h16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "152",
      "x2": "92",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108.3,72A32,32,0,1,1,152,83.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.1,45.2a26,26,0,1,1-3.4,28.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "152",
      "x2": "92",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108.3,72A32,32,0,1,1,152,83.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.1,45.2a26,26,0,1,1-3.4,28.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110",
      "y1": "104",
      "x2": "74",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "152",
      "x2": "92",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108.3,72A32,32,0,1,1,152,83.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.1,45.2a26,26,0,1,1-3.4,28.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$69 = [];
/* style */

const __vue_inject_styles__$69 = undefined;
/* scoped */

const __vue_scope_id__$69 = undefined;
/* module identifier */

const __vue_module_identifier__$69 = undefined;
/* functional template */

const __vue_is_functional_template__$69 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$69 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$69,
  staticRenderFns: __vue_staticRenderFns__$69
}, __vue_inject_styles__$69, __vue_script__$69, __vue_scope_id__$69, __vue_is_functional_template__$69, __vue_module_identifier__$69, false, undefined, undefined, undefined);

var script$68 = Vue.extend({
  name: "PhMicrosoftWordLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$68 = script$68;
/* template */

var __vue_render__$68 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,68V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "68 104 80 152 96 116 112 152 124 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "128",
      "height": "120",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 104 76 152 92 116 108 152 120 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM68.2,153.9l-12-48a8,8,0,0,1,15.6-3.8l6.3,25.4,6.6-14.7a8,8,0,0,1,14.6,0l6.6,14.7,6.3-25.4a8,8,0,1,1,15.6,3.8l-12,48a8.1,8.1,0,0,1-7.1,6.1H108a7.9,7.9,0,0,1-7.3-4.8L92,135.7l-8.7,19.5a8,8,0,0,1-8,4.8A8.1,8.1,0,0,1,68.2,153.9ZM200,216H72V192h72a16,16,0,0,0,16-16v-8h40Zm0-64H160V104h40Zm0-64H160V80a16,16,0,0,0-16-16H72V40H200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 104 76 152 92 116 108 152 120 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 104 76 152 92 116 108 152 120 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 104 76 152 92 116 108 152 120 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "120",
      "height": "112",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$68 = [];
/* style */

const __vue_inject_styles__$68 = undefined;
/* scoped */

const __vue_scope_id__$68 = undefined;
/* module identifier */

const __vue_module_identifier__$68 = undefined;
/* functional template */

const __vue_is_functional_template__$68 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$68 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$68,
  staticRenderFns: __vue_staticRenderFns__$68
}, __vue_inject_styles__$68, __vue_script__$68, __vue_scope_id__$68, __vue_is_functional_template__$68, __vue_module_identifier__$68, false, undefined, undefined, undefined);

var script$67 = Vue.extend({
  name: "PhMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$67 = script$67;
/* template */

var __vue_render__$67 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,136H40a8,8,0,0,1,0-16H216a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$67 = [];
/* style */

const __vue_inject_styles__$67 = undefined;
/* scoped */

const __vue_scope_id__$67 = undefined;
/* module identifier */

const __vue_module_identifier__$67 = undefined;
/* functional template */

const __vue_is_functional_template__$67 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$67 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$67,
  staticRenderFns: __vue_staticRenderFns__$67
}, __vue_inject_styles__$67, __vue_script__$67, __vue_scope_id__$67, __vue_is_functional_template__$67, __vue_module_identifier__$67, false, undefined, undefined, undefined);

var script$66 = Vue.extend({
  name: "PhMinusCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$66 = script$66;
/* template */

var __vue_render__$66 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$66 = [];
/* style */

const __vue_inject_styles__$66 = undefined;
/* scoped */

const __vue_scope_id__$66 = undefined;
/* module identifier */

const __vue_module_identifier__$66 = undefined;
/* functional template */

const __vue_is_functional_template__$66 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$66 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$66,
  staticRenderFns: __vue_staticRenderFns__$66
}, __vue_inject_styles__$66, __vue_script__$66, __vue_scope_id__$66, __vue_is_functional_template__$66, __vue_module_identifier__$66, false, undefined, undefined, undefined);

var script$65 = Vue.extend({
  name: "PhMoney",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$65 = script$65;
/* template */

var __vue_render__$65 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "64",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "192",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "64",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "192",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,64H176l64,56V72A8,8,0,0,0,232,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232,192a8,8,0,0,0,8-8V136l-64,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,72v48L80,64H24A8,8,0,0,0,16,72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,184a8,8,0,0,0,8,8H80L16,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56H24A16,16,0,0,0,8,72V184a16,16,0,0,0,16,16H232a16,16,0,0,0,16-16V72A16,16,0,0,0,232,56ZM75,184,24,140.3V115.7L75,72H181l51,43.7v24.6L181,184Zm93-56a40,40,0,1,1-40-40A40,40,0,0,1,168,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "64",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "192",
      "x2": "240",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "64",
      "x2": "16",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "192",
      "x2": "16",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$65 = [];
/* style */

const __vue_inject_styles__$65 = undefined;
/* scoped */

const __vue_scope_id__$65 = undefined;
/* module identifier */

const __vue_module_identifier__$65 = undefined;
/* functional template */

const __vue_is_functional_template__$65 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$65 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$65,
  staticRenderFns: __vue_staticRenderFns__$65
}, __vue_inject_styles__$65, __vue_script__$65, __vue_scope_id__$65, __vue_is_functional_template__$65, __vue_module_identifier__$65, false, undefined, undefined, undefined);

var script$64 = Vue.extend({
  name: "PhMonitor",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$64 = script$64;
/* template */

var __vue_render__$64 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "228",
      "x2": "96",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "40",
      "width": "208",
      "height": "160",
      "rx": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$64 = [];
/* style */

const __vue_inject_styles__$64 = undefined;
/* scoped */

const __vue_scope_id__$64 = undefined;
/* module identifier */

const __vue_module_identifier__$64 = undefined;
/* functional template */

const __vue_is_functional_template__$64 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$64 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$64,
  staticRenderFns: __vue_staticRenderFns__$64
}, __vue_inject_styles__$64, __vue_script__$64, __vue_scope_id__$64, __vue_is_functional_template__$64, __vue_module_identifier__$64, false, undefined, undefined, undefined);

var script$63 = Vue.extend({
  name: "PhMonitorPlay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$63 = script$63;
/* template */

var __vue_render__$63 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "156 120 116 92 116 148 156 120",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "228",
      "x2": "96",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48A16,16,0,0,0,32,64V176a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48ZM112,152V88l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224ZM232,64V176a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V64A24.1,24.1,0,0,1,48,40H208A24.1,24.1,0,0,1,232,64Zm-68,56a7.9,7.9,0,0,0-3.7-6.7l-44-28a7.9,7.9,0,0,0-8.1-.3,8,8,0,0,0-4.2,7v56a8,8,0,0,0,4.2,7,7.7,7.7,0,0,0,8.1-.3l44-28A7.9,7.9,0,0,0,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "144",
      "rx": "16",
      "transform": "translate(256 240) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "224",
      "x2": "96",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 120 112 88 112 152 160 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$63 = [];
/* style */

const __vue_inject_styles__$63 = undefined;
/* scoped */

const __vue_scope_id__$63 = undefined;
/* module identifier */

const __vue_module_identifier__$63 = undefined;
/* functional template */

const __vue_is_functional_template__$63 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$63 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$63,
  staticRenderFns: __vue_staticRenderFns__$63
}, __vue_inject_styles__$63, __vue_script__$63, __vue_scope_id__$63, __vue_is_functional_template__$63, __vue_module_identifier__$63, false, undefined, undefined, undefined);

var script$62 = Vue.extend({
  name: "PhMoon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$62 = script$62;
/* template */

var __vue_render__$62 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.3,150.3a8.1,8.1,0,0,0-7.8-5.7l-2.2.4A84,84,0,0,1,111,41.6a5.7,5.7,0,0,0,.3-1.8A7.9,7.9,0,0,0,101,31.7,100,100,0,1,0,224.3,154.9,7.2,7.2,0,0,0,224.3,150.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$62 = [];
/* style */

const __vue_inject_styles__$62 = undefined;
/* scoped */

const __vue_scope_id__$62 = undefined;
/* module identifier */

const __vue_module_identifier__$62 = undefined;
/* functional template */

const __vue_is_functional_template__$62 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$62 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$62,
  staticRenderFns: __vue_staticRenderFns__$62
}, __vue_inject_styles__$62, __vue_script__$62, __vue_scope_id__$62, __vue_is_functional_template__$62, __vue_module_identifier__$62, false, undefined, undefined, undefined);

var script$61 = Vue.extend({
  name: "PhMoonStars",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$61 = script$61;
/* template */

var __vue_render__$61 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,80H224V64a8,8,0,0,0-16,0V80H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V96h16a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,48h8v8a8,8,0,0,0,16,0V48h8a8,8,0,0,0,0-16h-8V24a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.5,144.6l-2.2.4A84,84,0,0,1,111,41.6a5.7,5.7,0,0,0,.3-1.8,8,8,0,0,0-5-7.9,7.8,7.8,0,0,0-5.2-.2A100,100,0,1,0,224.3,154.9a7.9,7.9,0,0,0,0-4.8A8.2,8.2,0,0,0,216.5,144.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "192",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "24",
      "x2": "168",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$61 = [];
/* style */

const __vue_inject_styles__$61 = undefined;
/* scoped */

const __vue_scope_id__$61 = undefined;
/* module identifier */

const __vue_module_identifier__$61 = undefined;
/* functional template */

const __vue_is_functional_template__$61 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$61 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$61,
  staticRenderFns: __vue_staticRenderFns__$61
}, __vue_inject_styles__$61, __vue_script__$61, __vue_scope_id__$61, __vue_is_functional_template__$61, __vue_module_identifier__$61, false, undefined, undefined, undefined);

var script$60 = Vue.extend({
  name: "PhMountains",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$60 = script$60;
/* template */

var __vue_render__$60 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,200,85.1,75.7a8.1,8.1,0,0,1,13.8,0L172,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.4",
      "y1": "128",
      "x2": "129.6",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M172,200h67.3l-52.4-88.4a8.1,8.1,0,0,0-13.8,0l-26.6,45",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.4,128h75.2L94.9,75.7a8.1,8.1,0,0,0-13.8,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50.4",
      "y1": "128",
      "x2": "125.6",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,52a24,24,0,1,1,24,24A24.1,24.1,0,0,1,140,52ZM255,204a8.1,8.1,0,0,1-7,4H8a7.8,7.8,0,0,1-6.9-4,7.9,7.9,0,0,1,0-8.1L74.2,71.7a16,16,0,0,1,27.6,0l42.3,71.9,26.1-44.1a16.1,16.1,0,0,1,27.6,0l57.1,96.4A8.3,8.3,0,0,1,255,204ZM64.3,120h47.4L88,79.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50.4",
      "y1": "128",
      "x2": "125.6",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50.4",
      "y1": "128",
      "x2": "125.6",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "164",
      "cy": "52",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50.4",
      "y1": "128",
      "x2": "125.6",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$60 = [];
/* style */

const __vue_inject_styles__$60 = undefined;
/* scoped */

const __vue_scope_id__$60 = undefined;
/* module identifier */

const __vue_module_identifier__$60 = undefined;
/* functional template */

const __vue_is_functional_template__$60 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$60 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$60,
  staticRenderFns: __vue_staticRenderFns__$60
}, __vue_inject_styles__$60, __vue_script__$60, __vue_scope_id__$60, __vue_is_functional_template__$60, __vue_module_identifier__$60, false, undefined, undefined, undefined);

var script$5$ = Vue.extend({
  name: "PhMouse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5$ = script$5$;
/* template */

var __vue_render__$5$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32H108A56,56,0,0,0,52,88v24h76Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,24H108A64.1,64.1,0,0,0,44,88v80a64.1,64.1,0,0,0,64,64h40a64.1,64.1,0,0,0,64-64V88A64.1,64.1,0,0,0,148,24Zm48,64v16H136V40h12A48,48,0,0,1,196,88ZM108,40h12v64H60V88A48,48,0,0,1,108,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "52",
      "y1": "112",
      "x2": "204",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5$ = [];
/* style */

const __vue_inject_styles__$5$ = undefined;
/* scoped */

const __vue_scope_id__$5$ = undefined;
/* module identifier */

const __vue_module_identifier__$5$ = undefined;
/* functional template */

const __vue_is_functional_template__$5$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5$,
  staticRenderFns: __vue_staticRenderFns__$5$
}, __vue_inject_styles__$5$, __vue_script__$5$, __vue_scope_id__$5$, __vue_is_functional_template__$5$, __vue_module_identifier__$5$, false, undefined, undefined, undefined);

var script$5_ = Vue.extend({
  name: "PhMouseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5_ = script$5_;
/* template */

var __vue_render__$5_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "116",
      "x2": "128",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,24H108A64.1,64.1,0,0,0,44,88v80a64.1,64.1,0,0,0,64,64h40a64.1,64.1,0,0,0,64-64V88A64.1,64.1,0,0,0,148,24Zm-12,88a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "32",
      "width": "152",
      "height": "192",
      "rx": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5_ = [];
/* style */

const __vue_inject_styles__$5_ = undefined;
/* scoped */

const __vue_scope_id__$5_ = undefined;
/* module identifier */

const __vue_module_identifier__$5_ = undefined;
/* functional template */

const __vue_is_functional_template__$5_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5_,
  staticRenderFns: __vue_staticRenderFns__$5_
}, __vue_inject_styles__$5_, __vue_script__$5_, __vue_scope_id__$5_, __vue_is_functional_template__$5_, __vue_module_identifier__$5_, false, undefined, undefined, undefined);

var script$5Z = Vue.extend({
  name: "PhMusicNote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Z = script$5Z;
/* template */

var __vue_render__$5Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,56.3l-80-24a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,120,40V148.3A47.4,47.4,0,0,0,88,136a48,48,0,1,0,48,48V98.8l69.7,20.9a8.2,8.2,0,0,0,7.1-1.3A8.1,8.1,0,0,0,216,112V64A8.1,8.1,0,0,0,210.3,56.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64 208 112 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Z = [];
/* style */

const __vue_inject_styles__$5Z = undefined;
/* scoped */

const __vue_scope_id__$5Z = undefined;
/* module identifier */

const __vue_module_identifier__$5Z = undefined;
/* functional template */

const __vue_is_functional_template__$5Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Z,
  staticRenderFns: __vue_staticRenderFns__$5Z
}, __vue_inject_styles__$5Z, __vue_script__$5Z, __vue_scope_id__$5Z, __vue_is_functional_template__$5Z, __vue_module_identifier__$5Z, false, undefined, undefined, undefined);

var script$5Y = Vue.extend({
  name: "PhMusicNoteSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Y = script$5Y;
/* template */

var __vue_render__$5Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,56.3l-80-24a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,120,40V148.3A47.4,47.4,0,0,0,88,136a48,48,0,1,0,48,48V50.8l69.7,20.9a8,8,0,1,0,4.6-15.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "184",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 184 128 40 208 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Y = [];
/* style */

const __vue_inject_styles__$5Y = undefined;
/* scoped */

const __vue_scope_id__$5Y = undefined;
/* module identifier */

const __vue_module_identifier__$5Y = undefined;
/* functional template */

const __vue_is_functional_template__$5Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Y,
  staticRenderFns: __vue_staticRenderFns__$5Y
}, __vue_inject_styles__$5Y, __vue_script__$5Y, __vue_scope_id__$5Y, __vue_is_functional_template__$5Y, __vue_module_identifier__$5Y, false, undefined, undefined, undefined);

var script$5X = Vue.extend({
  name: "PhMusicNotes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5X = script$5X;
/* template */

var __vue_render__$5X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212.9,25.7a8,8,0,0,0-6.8-1.5l-128,32A8,8,0,0,0,72,64V174.1A36,36,0,1,0,88,204V110.2l112-28v59.9A36,36,0,1,0,216,172V32A7.8,7.8,0,0,0,212.9,25.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5X = [];
/* style */

const __vue_inject_styles__$5X = undefined;
/* scoped */

const __vue_scope_id__$5X = undefined;
/* module identifier */

const __vue_module_identifier__$5X = undefined;
/* functional template */

const __vue_is_functional_template__$5X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5X,
  staticRenderFns: __vue_staticRenderFns__$5X
}, __vue_inject_styles__$5X, __vue_script__$5X, __vue_scope_id__$5X, __vue_is_functional_template__$5X, __vue_module_identifier__$5X, false, undefined, undefined, undefined);

var script$5W = Vue.extend({
  name: "PhMusicNotesPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5W = script$5W;
/* template */

var __vue_render__$5W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 128.2 52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "95",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "127.3",
      "x2": "208",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "119.2",
      "x2": "208",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 136.5 49.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.1",
      "y1": "92.2",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,56a8,8,0,0,1-8,8H208V80a8,8,0,0,1-16,0V64H176a8,8,0,0,1,0-16h16V32a8,8,0,0,1,16,0V48h16A8,8,0,0,1,232,56Zm-24,55.2a8,8,0,0,0-8,8v22.9a35.3,35.3,0,0,0-20-6.1,36,36,0,1,0,36,36V119.2A8,8,0,0,0,208,111.2ZM162.4,99.5a7.9,7.9,0,0,0,4.4-5.2,8.3,8.3,0,0,0-2-7.7,9,9,0,0,0-2.6-1.7A32.3,32.3,0,0,1,144,56a37.1,37.1,0,0,1,.3-4.7,7.9,7.9,0,0,0-2-6.9,8.1,8.1,0,0,0-7.8-2.3L78.1,56.2A8,8,0,0,0,72,64V174.1A35.3,35.3,0,0,0,52,168a36,36,0,1,0,36,36V118.2L160.8,100Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "119.2",
      "x2": "208",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 136.5 49.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.1",
      "y1": "92.2",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "119.2",
      "x2": "208",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 136.5 49.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.1",
      "y1": "92.2",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "119.2",
      "x2": "208",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 136.5 49.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "159.1",
      "y1": "92.2",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5W = [];
/* style */

const __vue_inject_styles__$5W = undefined;
/* scoped */

const __vue_scope_id__$5W = undefined;
/* module identifier */

const __vue_module_identifier__$5W = undefined;
/* functional template */

const __vue_is_functional_template__$5W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5W,
  staticRenderFns: __vue_staticRenderFns__$5W
}, __vue_inject_styles__$5W, __vue_script__$5W, __vue_scope_id__$5W, __vue_is_functional_template__$5W, __vue_module_identifier__$5W, false, undefined, undefined, undefined);

var script$5V = Vue.extend({
  name: "PhMusicNotesSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5V = script$5V;
/* template */

var __vue_render__$5V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212.9,25.7a7.9,7.9,0,0,0-6.8-1.5l-128,32A8,8,0,0,0,72,64V174.1A35.3,35.3,0,0,0,52,168a36,36,0,1,0,36,36V70.2l112-28v99.9a35.3,35.3,0,0,0-20-6.1,36,36,0,1,0,36,36V32A7.8,7.8,0,0,0,212.9,25.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 204 80 64 208 32 208 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5V = [];
/* style */

const __vue_inject_styles__$5V = undefined;
/* scoped */

const __vue_scope_id__$5V = undefined;
/* module identifier */

const __vue_module_identifier__$5V = undefined;
/* functional template */

const __vue_is_functional_template__$5V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5V,
  staticRenderFns: __vue_staticRenderFns__$5V
}, __vue_inject_styles__$5V, __vue_script__$5V, __vue_scope_id__$5V, __vue_is_functional_template__$5V, __vue_module_identifier__$5V, false, undefined, undefined, undefined);

var script$5U = Vue.extend({
  name: "PhNavigationArrow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5U = script$5U;
/* template */

var __vue_render__$5U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,88.4,50.2,29.8A16,16,0,0,0,29.8,50.2L88.4,219.5a15.8,15.8,0,0,0,15.1,10.8h.3a15.6,15.6,0,0,0,15-11.2l23.6-76.6L219,118.8a15.8,15.8,0,0,0,11.3-15A15.9,15.9,0,0,0,219.5,88.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5U = [];
/* style */

const __vue_inject_styles__$5U = undefined;
/* scoped */

const __vue_scope_id__$5U = undefined;
/* module identifier */

const __vue_module_identifier__$5U = undefined;
/* functional template */

const __vue_is_functional_template__$5U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5U,
  staticRenderFns: __vue_staticRenderFns__$5U
}, __vue_inject_styles__$5U, __vue_script__$5U, __vue_scope_id__$5U, __vue_is_functional_template__$5U, __vue_module_identifier__$5U, false, undefined, undefined, undefined);

var script$5T = Vue.extend({
  name: "PhNeedle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5T = script$5T;
/* template */

var __vue_render__$5T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "72",
      "x2": "168",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212.3,43.7a40.1,40.1,0,0,0-56.6,0l-24,24a8.1,8.1,0,0,0-2.2,4.3C120.7,123.3,36,208.7,34.4,210.3h-.1a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0h0c.8-.9,86.8-86.4,138.3-95.2a8.1,8.1,0,0,0,4.3-2.2l24-24a40.1,40.1,0,0,0,0-56.6Zm-22.6,34-16,16a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l16-16a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "72",
      "x2": "168",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "72",
      "x2": "168",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "72",
      "x2": "168",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5T = [];
/* style */

const __vue_inject_styles__$5T = undefined;
/* scoped */

const __vue_scope_id__$5T = undefined;
/* module identifier */

const __vue_module_identifier__$5T = undefined;
/* functional template */

const __vue_is_functional_template__$5T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5T,
  staticRenderFns: __vue_staticRenderFns__$5T
}, __vue_inject_styles__$5T, __vue_script__$5T, __vue_scope_id__$5T, __vue_is_functional_template__$5T, __vue_module_identifier__$5T, false, undefined, undefined, undefined);

var script$5S = Vue.extend({
  name: "PhNewspaper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5S = script$5S;
/* template */

var __vue_render__$5S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M16,88v92a20.1,20.1,0,0,0,20,20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "148",
      "x2": "176",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,180V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16H36A20.1,20.1,0,0,0,56,180Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16h0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H56A16,16,0,0,0,40,64V184a8,8,0,0,1-16,0V88A8,8,0,0,0,8,88v96H8A24,24,0,0,0,32,208H208a24.1,24.1,0,0,0,24-24V64A16,16,0,0,0,216,48ZM176,152H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16h0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16h0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,200a16,16,0,0,1-16-16h0V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5S = [];
/* style */

const __vue_inject_styles__$5S = undefined;
/* scoped */

const __vue_scope_id__$5S = undefined;
/* module identifier */

const __vue_module_identifier__$5S = undefined;
/* functional template */

const __vue_is_functional_template__$5S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5S,
  staticRenderFns: __vue_staticRenderFns__$5S
}, __vue_inject_styles__$5S, __vue_script__$5S, __vue_scope_id__$5S, __vue_is_functional_template__$5S, __vue_module_identifier__$5S, false, undefined, undefined, undefined);

var script$5R = Vue.extend({
  name: "PhNewspaperClipping",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5R = script$5R;
/* template */

var __vue_render__$5R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "108",
      "x2": "184",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "148",
      "x2": "184",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "96",
      "width": "40",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V216l32-16,32,16,32-16,32,16,32-16,32,16V56A8,8,0,0,0,216,48ZM112,160H64V96h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,104h32v48H72ZM232,56V216a7.9,7.9,0,0,1-3.8,6.8,8,8,0,0,1-7.8.4L192,208.9l-28.4,14.3a8.5,8.5,0,0,1-7.2,0L128,208.9,99.6,223.2a8.3,8.3,0,0,1-7.2,0L64,208.9,35.6,223.2a8,8,0,0,1-7.8-.4A7.9,7.9,0,0,1,24,216V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM120,96a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8Zm80,48a8,8,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8,8,0,0,0,200,144Zm0-32a8,8,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8,8,0,0,0,200,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "112",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "192",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "96",
      "width": "48",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5R = [];
/* style */

const __vue_inject_styles__$5R = undefined;
/* scoped */

const __vue_scope_id__$5R = undefined;
/* module identifier */

const __vue_module_identifier__$5R = undefined;
/* functional template */

const __vue_is_functional_template__$5R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5R,
  staticRenderFns: __vue_staticRenderFns__$5R
}, __vue_inject_styles__$5R, __vue_script__$5R, __vue_scope_id__$5R, __vue_is_functional_template__$5R, __vue_module_identifier__$5R, false, undefined, undefined, undefined);

var script$5Q = Vue.extend({
  name: "PhNote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5Q = script$5Q;
/* template */

var __vue_render__$5Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "108",
      "x2": "160",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "148",
      "x2": "116",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 156 156 156 156 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 160 160 160 160 216 216 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H156.7a15.9,15.9,0,0,0,11.3-4.7L219.3,168a15.9,15.9,0,0,0,4.7-11.3V48A16,16,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.7V160h44.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5Q = [];
/* style */

const __vue_inject_styles__$5Q = undefined;
/* scoped */

const __vue_scope_id__$5Q = undefined;
/* module identifier */

const __vue_module_identifier__$5Q = undefined;
/* functional template */

const __vue_is_functional_template__$5Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5Q,
  staticRenderFns: __vue_staticRenderFns__$5Q
}, __vue_inject_styles__$5Q, __vue_script__$5Q, __vue_scope_id__$5Q, __vue_is_functional_template__$5Q, __vue_module_identifier__$5Q, false, undefined, undefined, undefined);

var script$5P = Vue.extend({
  name: "PhNoteBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5P = script$5P;
/* template */

var __vue_render__$5P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 156 156 156 156 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 160 160 160 160 216 216 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H156.7a15.9,15.9,0,0,0,11.3-4.7L219.3,168a15.9,15.9,0,0,0,4.7-11.3V48A16,16,0,0,0,208,32ZM160,204.7V160h44.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "215.3 160 160 160 160 215.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5P = [];
/* style */

const __vue_inject_styles__$5P = undefined;
/* scoped */

const __vue_scope_id__$5P = undefined;
/* module identifier */

const __vue_module_identifier__$5P = undefined;
/* functional template */

const __vue_is_functional_template__$5P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5P,
  staticRenderFns: __vue_staticRenderFns__$5P
}, __vue_inject_styles__$5P, __vue_script__$5P, __vue_scope_id__$5P, __vue_is_functional_template__$5P, __vue_module_identifier__$5P, false, undefined, undefined, undefined);

var script$5O = Vue.extend({
  name: "PhNotePencil",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5O = script$5O;
/* template */

var __vue_render__$5O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "60",
      "x2": "196",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,128.6V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h79.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 168 56 200 88 128 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120v88a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h88a8,8,0,0,1,0,16H48V208H208V120a8,8,0,0,1,16,0Zm5.7-50.3-96,96A8.1,8.1,0,0,1,128,168H96a8,8,0,0,1-8-8V128a8.1,8.1,0,0,1,2.3-5.7l96-96a8.1,8.1,0,0,1,11.4,0l32,32A8.1,8.1,0,0,1,229.7,69.7Zm-17-5.7L192,43.3,179.3,56,200,76.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 160 96 160 96 128 192 32 224 64 128 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "56",
      "x2": "200",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5O = [];
/* style */

const __vue_inject_styles__$5O = undefined;
/* scoped */

const __vue_scope_id__$5O = undefined;
/* module identifier */

const __vue_module_identifier__$5O = undefined;
/* functional template */

const __vue_is_functional_template__$5O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5O,
  staticRenderFns: __vue_staticRenderFns__$5O
}, __vue_inject_styles__$5O, __vue_script__$5O, __vue_scope_id__$5O, __vue_is_functional_template__$5O, __vue_module_identifier__$5O, false, undefined, undefined, undefined);

var script$5N = Vue.extend({
  name: "PhNotebook",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5N = script$5N;
/* template */

var __vue_render__$5N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "148",
      "x2": "176",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "176",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "40",
      "x2": "80",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5N = [];
/* style */

const __vue_inject_styles__$5N = undefined;
/* scoped */

const __vue_scope_id__$5N = undefined;
/* module identifier */

const __vue_module_identifier__$5N = undefined;
/* functional template */

const __vue_is_functional_template__$5N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5N,
  staticRenderFns: __vue_staticRenderFns__$5N
}, __vue_inject_styles__$5N, __vue_script__$5N, __vue_scope_id__$5N, __vue_is_functional_template__$5N, __vue_module_identifier__$5N, false, undefined, undefined, undefined);

var script$5M = Vue.extend({
  name: "PhNotepad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5M = script$5M;
/* template */

var __vue_render__$5M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "124",
      "x2": "160",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "164",
      "x2": "160",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "24",
      "x2": "84",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "24",
      "x2": "172",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,32H184V24a8,8,0,0,0-16,0v8H136V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H56A16,16,0,0,0,40,48V200a32,32,0,0,0,32,32H184a32,32,0,0,0,32-32V48A16,16,0,0,0,200,32ZM160,168H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "160",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "24",
      "x2": "80",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "24",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5M = [];
/* style */

const __vue_inject_styles__$5M = undefined;
/* scoped */

const __vue_scope_id__$5M = undefined;
/* module identifier */

const __vue_module_identifier__$5M = undefined;
/* functional template */

const __vue_is_functional_template__$5M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5M,
  staticRenderFns: __vue_staticRenderFns__$5M
}, __vue_inject_styles__$5M, __vue_script__$5M, __vue_scope_id__$5M, __vue_is_functional_template__$5M, __vue_module_identifier__$5M, false, undefined, undefined, undefined);

var script$5L = Vue.extend({
  name: "PhNotification",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5L = script$5L;
/* template */

var __vue_render__$5L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V56A16,16,0,0,1,48,40h80a8,8,0,0,1,0,16H48V208H200V128a8,8,0,0,1,16,0ZM196,24a36,36,0,1,0,36,36A36,36,0,0,0,196,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "60",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5L = [];
/* style */

const __vue_inject_styles__$5L = undefined;
/* scoped */

const __vue_scope_id__$5L = undefined;
/* module identifier */

const __vue_module_identifier__$5L = undefined;
/* functional template */

const __vue_is_functional_template__$5L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5L,
  staticRenderFns: __vue_staticRenderFns__$5L
}, __vue_inject_styles__$5L, __vue_script__$5L, __vue_scope_id__$5L, __vue_is_functional_template__$5L, __vue_module_identifier__$5L, false, undefined, undefined, undefined);

var script$5K = Vue.extend({
  name: "PhNumberCircleEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5K = script$5K;
/* template */

var __vue_render__$5K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm24,150a33.9,33.9,0,1,1-48-48,26.6,26.6,0,0,1,3.1-2.6l-.3-.2a29.9,29.9,0,0,1,0-42.4c11.3-11.3,31.1-11.3,42.4,0a29.9,29.9,0,0,1,0,42.4l-.3.2A26.6,26.6,0,0,1,152,126a33.8,33.8,0,0,1,0,48Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M137.9,111.9a14,14,0,1,0-19.8,0A14.3,14.3,0,0,0,137.9,111.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,132a18,18,0,0,0-12.7,30.7,18.4,18.4,0,0,0,25.4,0A18,18,0,0,0,128,132Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5K = [];
/* style */

const __vue_inject_styles__$5K = undefined;
/* scoped */

const __vue_scope_id__$5K = undefined;
/* module identifier */

const __vue_module_identifier__$5K = undefined;
/* functional template */

const __vue_is_functional_template__$5K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5K,
  staticRenderFns: __vue_staticRenderFns__$5K
}, __vue_inject_styles__$5K, __vue_script__$5K, __vue_scope_id__$5K, __vue_is_functional_template__$5K, __vue_module_identifier__$5K, false, undefined, undefined, undefined);

var script$5J = Vue.extend({
  name: "PhNumberCircleFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5J = script$5J;
/* template */

var __vue_render__$5J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-4.1,92a36,36,0,1,1-25.5,61.5,8,8,0,1,1,11.2-11.4,20.1,20.1,0,0,0,14.3,5.9,19.9,19.9,0,0,0,14.2-5.9,19.8,19.8,0,0,0,0-28.2,19.9,19.9,0,0,0-14.2-5.9,20.1,20.1,0,0,0-14.3,5.9,8,8,0,0,1-13.5-7l7.8-48.2a8,8,0,0,1,7.9-6.7H152a8,8,0,0,1,0,16H118.6l-4.1,25.2A37.3,37.3,0,0,1,123.9,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5J = [];
/* style */

const __vue_inject_styles__$5J = undefined;
/* scoped */

const __vue_scope_id__$5J = undefined;
/* module identifier */

const __vue_module_identifier__$5J = undefined;
/* functional template */

const __vue_is_functional_template__$5J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5J,
  staticRenderFns: __vue_staticRenderFns__$5J
}, __vue_inject_styles__$5J, __vue_script__$5J, __vue_scope_id__$5J, __vue_is_functional_template__$5J, __vue_module_identifier__$5J, false, undefined, undefined, undefined);

var script$5I = Vue.extend({
  name: "PhNumberCircleFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5I = script$5I;
/* template */

var __vue_render__$5I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm28,152a8,8,0,0,1-16,0V152H100a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l24-68a8,8,0,0,1,15,5.4L111.3,136H140V112a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5I = [];
/* style */

const __vue_inject_styles__$5I = undefined;
/* scoped */

const __vue_scope_id__$5I = undefined;
/* module identifier */

const __vue_module_identifier__$5I = undefined;
/* functional template */

const __vue_is_functional_template__$5I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5I,
  staticRenderFns: __vue_staticRenderFns__$5I
}, __vue_inject_styles__$5I, __vue_script__$5I, __vue_scope_id__$5I, __vue_is_functional_template__$5I, __vue_module_identifier__$5I, false, undefined, undefined, undefined);

var script$5H = Vue.extend({
  name: "PhNumberCircleNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5H = script$5H;
/* template */

var __vue_render__$5H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,112a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,112Zm84,16A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-68-16a36,36,0,1,0-36,36h1.8l-16.7,27.9a8.1,8.1,0,0,0,2.8,11A8.7,8.7,0,0,0,120,188a8.1,8.1,0,0,0,6.9-3.9l32.2-54,.3-.5A36,36,0,0,0,164,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5H = [];
/* style */

const __vue_inject_styles__$5H = undefined;
/* scoped */

const __vue_scope_id__$5H = undefined;
/* module identifier */

const __vue_module_identifier__$5H = undefined;
/* functional template */

const __vue_is_functional_template__$5H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5H,
  staticRenderFns: __vue_staticRenderFns__$5H
}, __vue_inject_styles__$5H, __vue_script__$5H, __vue_scope_id__$5H, __vue_is_functional_template__$5H, __vue_module_identifier__$5H, false, undefined, undefined, undefined);

var script$5G = Vue.extend({
  name: "PhNumberCircleOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5G = script$5G;
/* template */

var __vue_render__$5G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm12,152a8,8,0,0,1-16,0V98.9l-11.6,7.8a8,8,0,0,1-8.8-13.4l24-16a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,140,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5G = [];
/* style */

const __vue_inject_styles__$5G = undefined;
/* scoped */

const __vue_scope_id__$5G = undefined;
/* module identifier */

const __vue_module_identifier__$5G = undefined;
/* functional template */

const __vue_is_functional_template__$5G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5G,
  staticRenderFns: __vue_staticRenderFns__$5G
}, __vue_inject_styles__$5G, __vue_script__$5G, __vue_scope_id__$5G, __vue_is_functional_template__$5G, __vue_module_identifier__$5G, false, undefined, undefined, undefined);

var script$5F = Vue.extend({
  name: "PhNumberCircleSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5F = script$5F;
/* template */

var __vue_render__$5F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm31.6,62.5-32,96A7.9,7.9,0,0,1,120,188a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L140.9,92H104a8,8,0,0,1,0-16h48a7.9,7.9,0,0,1,6.5,3.3A8.1,8.1,0,0,1,159.6,86.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5F = [];
/* style */

const __vue_inject_styles__$5F = undefined;
/* scoped */

const __vue_scope_id__$5F = undefined;
/* module identifier */

const __vue_module_identifier__$5F = undefined;
/* functional template */

const __vue_is_functional_template__$5F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5F,
  staticRenderFns: __vue_staticRenderFns__$5F
}, __vue_inject_styles__$5F, __vue_script__$5F, __vue_scope_id__$5F, __vue_is_functional_template__$5F, __vue_module_identifier__$5F, false, undefined, undefined, undefined);

var script$5E = Vue.extend({
  name: "PhNumberCircleSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5E = script$5E;
/* template */

var __vue_render__$5E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "130",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "130",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,144a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,144Zm84-16A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-68,16a36,36,0,0,0-36-36h-1.8l16.7-27.9a8,8,0,1,0-13.8-8.2l-32.2,54-.3.6A36,36,0,1,0,164,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "130",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "130",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "130",
      "x2": "136",
      "y2": "76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "144",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5E = [];
/* style */

const __vue_inject_styles__$5E = undefined;
/* scoped */

const __vue_scope_id__$5E = undefined;
/* module identifier */

const __vue_module_identifier__$5E = undefined;
/* functional template */

const __vue_is_functional_template__$5E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5E,
  staticRenderFns: __vue_staticRenderFns__$5E
}, __vue_inject_styles__$5E, __vue_script__$5E, __vue_scope_id__$5E, __vue_is_functional_template__$5E, __vue_module_identifier__$5E, false, undefined, undefined, undefined);

var script$5D = Vue.extend({
  name: "PhNumberCircleThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5D = script$5D;
/* template */

var __vue_render__$5D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm21.5,153.5a36.2,36.2,0,0,1-51,0,8.1,8.1,0,0,1,11.4-11.4A19.9,19.9,0,1,0,124,132a8.1,8.1,0,0,1-7.1-4.3,8,8,0,0,1,.5-8.3L136.6,92H104a8,8,0,0,1,0-16h48a8.1,8.1,0,0,1,7.1,4.3,8,8,0,0,1-.5,8.3l-21.1,30a37.9,37.9,0,0,1,12,7.9,36.2,36.2,0,0,1,0,51Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5D = [];
/* style */

const __vue_inject_styles__$5D = undefined;
/* scoped */

const __vue_scope_id__$5D = undefined;
/* module identifier */

const __vue_module_identifier__$5D = undefined;
/* functional template */

const __vue_is_functional_template__$5D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5D,
  staticRenderFns: __vue_staticRenderFns__$5D
}, __vue_inject_styles__$5D, __vue_script__$5D, __vue_scope_id__$5D, __vue_is_functional_template__$5D, __vue_module_identifier__$5D, false, undefined, undefined, undefined);

var script$5C = Vue.extend({
  name: "PhNumberCircleTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5C = script$5C;
/* template */

var __vue_render__$5C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm24,144a8,8,0,0,1,0,16H104a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,96,176a7.5,7.5,0,0,1,1.7-4.9l43.7-58.3A16,16,0,0,0,128,88a15.9,15.9,0,0,0-14.7,9.8,8,8,0,0,1-14.8-6.3,32,32,0,1,1,56,30.4l-.2.3L120,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5C = [];
/* style */

const __vue_inject_styles__$5C = undefined;
/* scoped */

const __vue_scope_id__$5C = undefined;
/* module identifier */

const __vue_module_identifier__$5C = undefined;
/* functional template */

const __vue_is_functional_template__$5C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5C,
  staticRenderFns: __vue_staticRenderFns__$5C
}, __vue_inject_styles__$5C, __vue_script__$5C, __vue_scope_id__$5C, __vue_is_functional_template__$5C, __vue_module_identifier__$5C, false, undefined, undefined, undefined);

var script$5B = Vue.extend({
  name: "PhNumberCircleZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5B = script$5B;
/* template */

var __vue_render__$5B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "24",
      "ry": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,160c-27.6,0-40-28.1-40-56s12.4-56,40-56,40,28.1,40,56S155.6,184,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5B = [];
/* style */

const __vue_inject_styles__$5B = undefined;
/* scoped */

const __vue_scope_id__$5B = undefined;
/* module identifier */

const __vue_module_identifier__$5B = undefined;
/* functional template */

const __vue_is_functional_template__$5B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5B,
  staticRenderFns: __vue_staticRenderFns__$5B
}, __vue_inject_styles__$5B, __vue_script__$5B, __vue_scope_id__$5B, __vue_is_functional_template__$5B, __vue_module_identifier__$5B, false, undefined, undefined, undefined);

var script$5A = Vue.extend({
  name: "PhNumberEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5A = script$5A;
/* template */

var __vue_render__$5A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.9,130a68.8,68.8,0,0,0-16.4-11.4,59.4,59.4,0,0,0,9.9-7.4,53.6,53.6,0,0,0,0-79.1,61.3,61.3,0,0,0-82.8,0,53.6,53.6,0,0,0,0,79.1,59.4,59.4,0,0,0,9.9,7.4A68.8,68.8,0,0,0,80.1,130a61.9,61.9,0,0,0,0,91.3,70.7,70.7,0,0,0,95.8,0,61.9,61.9,0,0,0,0-91.3ZM97.6,99.5a37.5,37.5,0,0,1,0-55.7,45.1,45.1,0,0,1,60.8,0,37.5,37.5,0,0,1,0,55.7,45.1,45.1,0,0,1-60.8,0ZM165,209.7a55,55,0,0,1-74,0,46,46,0,0,1,0-68,54.7,54.7,0,0,1,74,0,46,46,0,0,1,0,68Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5A = [];
/* style */

const __vue_inject_styles__$5A = undefined;
/* scoped */

const __vue_scope_id__$5A = undefined;
/* module identifier */

const __vue_module_identifier__$5A = undefined;
/* functional template */

const __vue_is_functional_template__$5A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5A,
  staticRenderFns: __vue_staticRenderFns__$5A
}, __vue_inject_styles__$5A, __vue_script__$5A, __vue_scope_id__$5A, __vue_is_functional_template__$5A, __vue_module_identifier__$5A, false, undefined, undefined, undefined);

var script$5z = Vue.extend({
  name: "PhNumberFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5z = script$5z;
/* template */

var __vue_render__$5z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.2,122.7a64,64,0,0,1,0,90.6,64.5,64.5,0,0,1-90.8,0,8,8,0,1,1,11.2-11.4,48.4,48.4,0,0,0,68.3,0A48,48,0,0,0,119.8,120a48.3,48.3,0,0,0-34.2,14.1,8,8,0,0,1-13.5-7L87.8,30.7A7.9,7.9,0,0,1,95.7,24H176a8,8,0,0,1,0,16H102.5L91,110.8a63,63,0,0,1,28.8-6.8A64.4,64.4,0,0,1,165.2,122.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5z = [];
/* style */

const __vue_inject_styles__$5z = undefined;
/* scoped */

const __vue_scope_id__$5z = undefined;
/* module identifier */

const __vue_module_identifier__$5z = undefined;
/* functional template */

const __vue_is_functional_template__$5z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5z,
  staticRenderFns: __vue_staticRenderFns__$5z
}, __vue_inject_styles__$5z, __vue_script__$5z, __vue_scope_id__$5z, __vue_is_functional_template__$5z, __vue_module_identifier__$5z, false, undefined, undefined, undefined);

var script$5y = Vue.extend({
  name: "PhNumberFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5y = script$5y;
/* template */

var __vue_render__$5y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,96V224a8,8,0,0,1-16,0V168H76a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l48-136a8,8,0,0,1,15,5.4L87.3,152H164V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 24 76 160 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "96",
      "x2": "172",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5y = [];
/* style */

const __vue_inject_styles__$5y = undefined;
/* scoped */

const __vue_scope_id__$5y = undefined;
/* module identifier */

const __vue_module_identifier__$5y = undefined;
/* functional template */

const __vue_is_functional_template__$5y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5y,
  staticRenderFns: __vue_staticRenderFns__$5y
}, __vue_inject_styles__$5y, __vue_script__$5y, __vue_scope_id__$5y, __vue_is_functional_template__$5y, __vue_module_identifier__$5y, false, undefined, undefined, undefined);

var script$5x = Vue.extend({
  name: "PhNumberNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5x = script$5x;
/* template */

var __vue_render__$5x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.5",
      "y1": "116",
      "x2": "111.7",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.5",
      "y1": "116",
      "x2": "111.7",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,88a64,64,0,1,0-64,64,65.1,65.1,0,0,0,19.4-3l-42.5,70.9a8,8,0,0,0,2.7,11,8.7,8.7,0,0,0,4.1,1.1,8,8,0,0,0,6.9-3.9l64.7-108A63.5,63.5,0,0,0,192,88ZM80,88a48,48,0,1,1,48,48A48,48,0,0,1,80,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.5",
      "y1": "116",
      "x2": "111.7",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.5",
      "y1": "116",
      "x2": "111.7",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "176.5",
      "y1": "116",
      "x2": "111.8",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5x = [];
/* style */

const __vue_inject_styles__$5x = undefined;
/* scoped */

const __vue_scope_id__$5x = undefined;
/* module identifier */

const __vue_module_identifier__$5x = undefined;
/* functional template */

const __vue_is_functional_template__$5x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5x,
  staticRenderFns: __vue_staticRenderFns__$5x
}, __vue_inject_styles__$5x, __vue_script__$5x, __vue_scope_id__$5x, __vue_is_functional_template__$5x, __vue_module_identifier__$5x, false, undefined, undefined, undefined);

var script$5w = Vue.extend({
  name: "PhNumberOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5w = script$5w;
/* template */

var __vue_render__$5w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 64 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 64 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,232a8,8,0,0,1-8-8V47L88.4,70.6a8,8,0,0,1-11.1-2.2,8.1,8.1,0,0,1,2.3-11.1l48-32a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,140,32V224A8,8,0,0,1,132,232Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 64 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 64 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "84 64 132 32 132 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5w = [];
/* style */

const __vue_inject_styles__$5w = undefined;
/* scoped */

const __vue_scope_id__$5w = undefined;
/* module identifier */

const __vue_module_identifier__$5w = undefined;
/* functional template */

const __vue_is_functional_template__$5w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5w,
  staticRenderFns: __vue_staticRenderFns__$5w
}, __vue_inject_styles__$5w, __vue_script__$5w, __vue_scope_id__$5w, __vue_is_functional_template__$5w, __vue_module_identifier__$5w, false, undefined, undefined, undefined);

var script$5v = Vue.extend({
  name: "PhNumberSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5v = script$5v;
/* template */

var __vue_render__$5v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,240a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L164.9,48H80a8,8,0,0,1,0-16h96a7.9,7.9,0,0,1,6.5,3.3,8.1,8.1,0,0,1,1.1,7.2l-64,192A7.9,7.9,0,0,1,112,240Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 40 176 40 112 232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5v = [];
/* style */

const __vue_inject_styles__$5v = undefined;
/* scoped */

const __vue_scope_id__$5v = undefined;
/* module identifier */

const __vue_module_identifier__$5v = undefined;
/* functional template */

const __vue_is_functional_template__$5v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5v,
  staticRenderFns: __vue_staticRenderFns__$5v
}, __vue_inject_styles__$5v, __vue_script__$5v, __vue_scope_id__$5v, __vue_is_functional_template__$5v, __vue_module_identifier__$5v, false, undefined, undefined, undefined);

var script$5u = Vue.extend({
  name: "PhNumberSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5u = script$5u;
/* template */

var __vue_render__$5u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.5",
      "y1": "140",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.5",
      "y1": "140",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,104a66.3,66.3,0,0,0-19.5,3l42.4-70.9a8,8,0,0,0-13.8-8.2l-64.5,108-.2.5A63,63,0,0,0,64,168a64,64,0,1,0,64-64Zm0,112a48.1,48.1,0,0,1-41.2-72.7l.2-.3a48,48,0,1,1,41,73Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.5",
      "y1": "140",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.5",
      "y1": "140",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "79.5",
      "y1": "140",
      "x2": "144",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5u = [];
/* style */

const __vue_inject_styles__$5u = undefined;
/* scoped */

const __vue_scope_id__$5u = undefined;
/* module identifier */

const __vue_module_identifier__$5u = undefined;
/* functional template */

const __vue_is_functional_template__$5u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5u,
  staticRenderFns: __vue_staticRenderFns__$5u
}, __vue_inject_styles__$5u, __vue_script__$5u, __vue_scope_id__$5u, __vue_is_functional_template__$5u, __vue_module_identifier__$5u, false, undefined, undefined, undefined);

var script$5t = Vue.extend({
  name: "PhNumberSquareEight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5t = script$5t;
/* template */

var __vue_render__$5t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M137.9,111.9a14,14,0,1,0-19.8,0A14.3,14.3,0,0,0,137.9,111.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,132a18,18,0,0,0-12.7,30.7,18.4,18.4,0,0,0,25.4,0A18,18,0,0,0,128,132Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM152,174a33.9,33.9,0,1,1-48-48,26.6,26.6,0,0,1,3.1-2.6l-.3-.2a29.9,29.9,0,0,1,0-42.4c11.3-11.3,31.1-11.3,42.4,0a29.9,29.9,0,0,1,0,42.4l-.3.2A26.6,26.6,0,0,1,152,126a33.8,33.8,0,0,1,0,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5t = [];
/* style */

const __vue_inject_styles__$5t = undefined;
/* scoped */

const __vue_scope_id__$5t = undefined;
/* module identifier */

const __vue_module_identifier__$5t = undefined;
/* functional template */

const __vue_is_functional_template__$5t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5t,
  staticRenderFns: __vue_staticRenderFns__$5t
}, __vue_inject_styles__$5t, __vue_script__$5t, __vue_scope_id__$5t, __vue_is_functional_template__$5t, __vue_module_identifier__$5t, false, undefined, undefined, undefined);

var script$5s = Vue.extend({
  name: "PhNumberSquareFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5s = script$5s;
/* template */

var __vue_render__$5s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-84.1,80a36,36,0,1,1-25.5,61.5,8,8,0,1,1,11.2-11.4,20.1,20.1,0,0,0,14.3,5.9,19.9,19.9,0,0,0,14.2-5.9,19.8,19.8,0,0,0,0-28.2,19.9,19.9,0,0,0-14.2-5.9,20.1,20.1,0,0,0-14.3,5.9,8,8,0,0,1-13.5-7l7.8-48.2a8,8,0,0,1,7.9-6.7H152a8,8,0,0,1,0,16H118.6l-4.1,25.2A37.3,37.3,0,0,1,123.9,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5s = [];
/* style */

const __vue_inject_styles__$5s = undefined;
/* scoped */

const __vue_scope_id__$5s = undefined;
/* module identifier */

const __vue_module_identifier__$5s = undefined;
/* functional template */

const __vue_is_functional_template__$5s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5s,
  staticRenderFns: __vue_staticRenderFns__$5s
}, __vue_inject_styles__$5s, __vue_script__$5s, __vue_scope_id__$5s, __vue_is_functional_template__$5s, __vue_module_identifier__$5s, false, undefined, undefined, undefined);

var script$5r = Vue.extend({
  name: "PhNumberSquareFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5r = script$5r;
/* template */

var __vue_render__$5r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM156,176a8,8,0,0,1-16,0V152H100a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l24-68a8,8,0,0,1,15,5.4L111.3,136H140V112a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "124 76 100 144 148 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "112",
      "x2": "148",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5r = [];
/* style */

const __vue_inject_styles__$5r = undefined;
/* scoped */

const __vue_scope_id__$5r = undefined;
/* module identifier */

const __vue_module_identifier__$5r = undefined;
/* functional template */

const __vue_is_functional_template__$5r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5r,
  staticRenderFns: __vue_staticRenderFns__$5r
}, __vue_inject_styles__$5r, __vue_script__$5r, __vue_scope_id__$5r, __vue_is_functional_template__$5r, __vue_module_identifier__$5r, false, undefined, undefined, undefined);

var script$5q = Vue.extend({
  name: "PhNumberSquareNine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5q = script$5q;
/* template */

var __vue_render__$5q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,112a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,112Zm76-64V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-60,64a36,36,0,1,0-36,36h1.8l-16.7,27.9a8.1,8.1,0,0,0,2.8,11A8.7,8.7,0,0,0,120,188a8.1,8.1,0,0,0,6.9-3.9l32.2-54,.3-.5A36,36,0,0,0,164,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152.2",
      "y1": "126",
      "x2": "120",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5q = [];
/* style */

const __vue_inject_styles__$5q = undefined;
/* scoped */

const __vue_scope_id__$5q = undefined;
/* module identifier */

const __vue_module_identifier__$5q = undefined;
/* functional template */

const __vue_is_functional_template__$5q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5q,
  staticRenderFns: __vue_staticRenderFns__$5q
}, __vue_inject_styles__$5q, __vue_script__$5q, __vue_scope_id__$5q, __vue_is_functional_template__$5q, __vue_module_identifier__$5q, false, undefined, undefined, undefined);

var script$5p = Vue.extend({
  name: "PhNumberSquareOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5p = script$5p;
/* template */

var __vue_render__$5p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM140,176a8,8,0,0,1-16,0V99l-11.6,7.6a7.8,7.8,0,0,1-11-2.2,8,8,0,0,1,2.2-11.1l24-16A8,8,0,0,1,140,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "108 100 132 84 132 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5p = [];
/* style */

const __vue_inject_styles__$5p = undefined;
/* scoped */

const __vue_scope_id__$5p = undefined;
/* module identifier */

const __vue_module_identifier__$5p = undefined;
/* functional template */

const __vue_is_functional_template__$5p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5p,
  staticRenderFns: __vue_staticRenderFns__$5p
}, __vue_inject_styles__$5p, __vue_script__$5p, __vue_scope_id__$5p, __vue_is_functional_template__$5p, __vue_module_identifier__$5p, false, undefined, undefined, undefined);

var script$5o = Vue.extend({
  name: "PhNumberSquareSeven",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5o = script$5o;
/* template */

var __vue_render__$5o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM159.6,86.5l-32,96A7.9,7.9,0,0,1,120,188a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L140.9,92H104a8,8,0,0,1,0-16h48a7.9,7.9,0,0,1,6.5,3.3A8.1,8.1,0,0,1,159.6,86.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "104 84 152 84 120 180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5o = [];
/* style */

const __vue_inject_styles__$5o = undefined;
/* scoped */

const __vue_scope_id__$5o = undefined;
/* module identifier */

const __vue_module_identifier__$5o = undefined;
/* functional template */

const __vue_is_functional_template__$5o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5o,
  staticRenderFns: __vue_staticRenderFns__$5o
}, __vue_inject_styles__$5o, __vue_script__$5o, __vue_scope_id__$5o, __vue_is_functional_template__$5o, __vue_module_identifier__$5o, false, undefined, undefined, undefined);

var script$5n = Vue.extend({
  name: "PhNumberSquareSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5n = script$5n;
/* template */

var __vue_render__$5n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "134",
      "x2": "136",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "134",
      "x2": "136",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,148a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,148ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM164,148a36,36,0,0,0-36-36h-1.8l16.7-27.9a8,8,0,1,0-13.8-8.2l-32.2,54-.2.3A36,36,0,1,0,164,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "134",
      "x2": "136",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "134",
      "x2": "136",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "103.8",
      "y1": "134",
      "x2": "136",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "148",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5n = [];
/* style */

const __vue_inject_styles__$5n = undefined;
/* scoped */

const __vue_scope_id__$5n = undefined;
/* module identifier */

const __vue_module_identifier__$5n = undefined;
/* functional template */

const __vue_is_functional_template__$5n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5n,
  staticRenderFns: __vue_staticRenderFns__$5n
}, __vue_inject_styles__$5n, __vue_script__$5n, __vue_scope_id__$5n, __vue_is_functional_template__$5n, __vue_module_identifier__$5n, false, undefined, undefined, undefined);

var script$5m = Vue.extend({
  name: "PhNumberSquareThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5m = script$5m;
/* template */

var __vue_render__$5m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM149.5,177.5a36.2,36.2,0,0,1-51,0,8.1,8.1,0,0,1,11.4-11.4A19.9,19.9,0,1,0,124,132a8.1,8.1,0,0,1-7.1-4.3,8,8,0,0,1,.5-8.3L136.6,92H104a8,8,0,0,1,0-16h48a8.1,8.1,0,0,1,7.1,4.3,7.8,7.8,0,0,1-.6,8.3l-21,30a37.9,37.9,0,0,1,12,7.9,36.2,36.2,0,0,1,0,51Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5m = [];
/* style */

const __vue_inject_styles__$5m = undefined;
/* scoped */

const __vue_scope_id__$5m = undefined;
/* module identifier */

const __vue_module_identifier__$5m = undefined;
/* functional template */

const __vue_is_functional_template__$5m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5m,
  staticRenderFns: __vue_staticRenderFns__$5m
}, __vue_inject_styles__$5m, __vue_script__$5m, __vue_scope_id__$5m, __vue_is_functional_template__$5m, __vue_module_identifier__$5m, false, undefined, undefined, undefined);

var script$5l = Vue.extend({
  name: "PhNumberSquareTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5l = script$5l;
/* template */

var __vue_render__$5l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM152,168a8,8,0,0,1,0,16H104a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,96,176a7.5,7.5,0,0,1,1.7-4.9l43.7-58.3A16,16,0,0,0,128,88a15.9,15.9,0,0,0-14.7,9.8,8.1,8.1,0,0,1-10.5,4.2,8,8,0,0,1-4.3-10.5,32,32,0,1,1,56,30.4l-.2.3L120,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5l = [];
/* style */

const __vue_inject_styles__$5l = undefined;
/* scoped */

const __vue_scope_id__$5l = undefined;
/* module identifier */

const __vue_module_identifier__$5l = undefined;
/* functional template */

const __vue_is_functional_template__$5l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5l,
  staticRenderFns: __vue_staticRenderFns__$5l
}, __vue_inject_styles__$5l, __vue_script__$5l, __vue_scope_id__$5l, __vue_is_functional_template__$5l, __vue_module_identifier__$5l, false, undefined, undefined, undefined);

var script$5k = Vue.extend({
  name: "PhNumberSquareZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5k = script$5k;
/* template */

var __vue_render__$5k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "24",
      "ry": "40"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,184c-27.6,0-40-28.1-40-56s12.4-56,40-56,40,28.1,40,56S155.6,184,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "32",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5k = [];
/* style */

const __vue_inject_styles__$5k = undefined;
/* scoped */

const __vue_scope_id__$5k = undefined;
/* module identifier */

const __vue_module_identifier__$5k = undefined;
/* functional template */

const __vue_is_functional_template__$5k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5k,
  staticRenderFns: __vue_staticRenderFns__$5k
}, __vue_inject_styles__$5k, __vue_script__$5k, __vue_scope_id__$5k, __vue_is_functional_template__$5k, __vue_module_identifier__$5k, false, undefined, undefined, undefined);

var script$5j = Vue.extend({
  name: "PhNumberThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5j = script$5j;
/* template */

var __vue_render__$5j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,168A64,64,0,0,1,74.8,213.3a8,8,0,0,1,11.3-11.4A47.9,47.9,0,1,0,120,120a8.1,8.1,0,0,1-7.1-4.3,7.8,7.8,0,0,1,.6-8.3L160.6,40H80a8,8,0,0,1,0-16h96a8.1,8.1,0,0,1,7.1,4.3,7.8,7.8,0,0,1-.6,8.3l-48.2,69A64.1,64.1,0,0,1,184,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5j = [];
/* style */

const __vue_inject_styles__$5j = undefined;
/* scoped */

const __vue_scope_id__$5j = undefined;
/* module identifier */

const __vue_module_identifier__$5j = undefined;
/* functional template */

const __vue_is_functional_template__$5j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5j,
  staticRenderFns: __vue_staticRenderFns__$5j
}, __vue_inject_styles__$5j, __vue_script__$5j, __vue_scope_id__$5j, __vue_is_functional_template__$5j, __vue_module_identifier__$5j, false, undefined, undefined, undefined);

var script$5i = Vue.extend({
  name: "PhNumberTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5i = script$5i;
/* template */

var __vue_render__$5i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,224a8,8,0,0,1-8,8H80a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,72,224a8,8,0,0,1,1.7-5l87.6-116.8A40,40,0,1,0,91.1,64.4a8,8,0,1,1-14.7-6.2,56,56,0,1,1,98,53.1c0,.1-.1.2-.2.3L96,216h80A8,8,0,0,1,184,224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5i = [];
/* style */

const __vue_inject_styles__$5i = undefined;
/* scoped */

const __vue_scope_id__$5i = undefined;
/* module identifier */

const __vue_module_identifier__$5i = undefined;
/* functional template */

const __vue_is_functional_template__$5i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5i,
  staticRenderFns: __vue_staticRenderFns__$5i
}, __vue_inject_styles__$5i, __vue_script__$5i, __vue_scope_id__$5i, __vue_is_functional_template__$5i, __vue_module_identifier__$5i, false, undefined, undefined, undefined);

var script$5h = Vue.extend({
  name: "PhNumberZero",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5h = script$5h;
/* template */

var __vue_render__$5h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,240c-25.8,0-47-12.6-61.4-36.4C54.6,183.8,48,157,48,128s6.6-55.9,18.6-75.6C81,28.6,102.2,16,128,16s47,12.6,61.4,36.4C201.4,72.1,208,99,208,128s-6.6,55.8-18.6,75.6C175,227.4,153.8,240,128,240Zm0-208c-44.2,0-64,48.2-64,96s19.8,96,64,96,64-48.2,64-96S172.2,32,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "72",
      "ry": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5h = [];
/* style */

const __vue_inject_styles__$5h = undefined;
/* scoped */

const __vue_scope_id__$5h = undefined;
/* module identifier */

const __vue_module_identifier__$5h = undefined;
/* functional template */

const __vue_is_functional_template__$5h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5h,
  staticRenderFns: __vue_staticRenderFns__$5h
}, __vue_inject_styles__$5h, __vue_script__$5h, __vue_scope_id__$5h, __vue_is_functional_template__$5h, __vue_module_identifier__$5h, false, undefined, undefined, undefined);

var script$5g = Vue.extend({
  name: "PhNut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5g = script$5g;
/* template */

var __vue_render__$5g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.9,73.7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5a8.1,8.1,0,0,0,4.1-7V80.7A8.1,8.1,0,0,0,215.9,73.7ZM128,164a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.9,66.7l-84-47.4a15.9,15.9,0,0,0-15.8,0l-84,47.4a16.2,16.2,0,0,0-8.1,14v94.6a16.2,16.2,0,0,0,8.1,14l84,47.4a15.9,15.9,0,0,0,15.8,0l84-47.4a16.2,16.2,0,0,0,8.1-14V80.7A16.2,16.2,0,0,0,219.9,66.7ZM128,164a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5g = [];
/* style */

const __vue_inject_styles__$5g = undefined;
/* scoped */

const __vue_scope_id__$5g = undefined;
/* module identifier */

const __vue_module_identifier__$5g = undefined;
/* functional template */

const __vue_is_functional_template__$5g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5g,
  staticRenderFns: __vue_staticRenderFns__$5g
}, __vue_inject_styles__$5g, __vue_script__$5g, __vue_scope_id__$5g, __vue_is_functional_template__$5g, __vue_module_identifier__$5g, false, undefined, undefined, undefined);

var script$5f = Vue.extend({
  name: "PhNyTimesLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5f = script$5f;
/* template */

var __vue_render__$5f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "168",
      "cy": "148",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.6,163.4A80,80,0,1,1,127.9,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.6 154.3 127.9 112 127.9 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.9",
      "y1": "131.2",
      "x2": "91.9",
      "y2": "215.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M95.9,217.3a79.7,79.7,0,0,0,32,6.7V112l-32,17.1h0v88.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "171.9",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.6,163.4A80,80,0,1,1,127.9,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.6 154.3 127.9 112 127.9 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "129.1",
      "x2": "95.9",
      "y2": "217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.9,148a12,12,0,1,1-12-12A12,12,0,0,1,183.9,148Zm29.4,17.3A87.7,87.7,0,0,1,127.9,232a86.7,86.7,0,0,1-34.6-7.1l-1.2-.5a88.4,88.4,0,0,1-51.5-69.3h0a99.9,99.9,0,0,1-.7-11A87.3,87.3,0,0,1,54,96.3,36,36,0,0,1,70,28a8.5,8.5,0,0,1,3.5.8L187.7,83.9A20,20,0,0,0,186,44a8,8,0,0,1,0-16,36,36,0,0,1,0,72,8.5,8.5,0,0,1-3.5-.8L126.3,72A72.1,72.1,0,0,0,56,141.3L92.1,122h0l32.1-17.1a8,8,0,0,1,11.7,7.1V215.5a71.7,71.7,0,0,0,61.9-54.1,8,8,0,0,1,15.5,3.9Zm-93.4-40-16,8.6v78a71.5,71.5,0,0,0,16,3.6ZM64.4,83.2a87.4,87.4,0,0,1,37.1-23.1l-33.2-16a20,20,0,0,0-3.9,39.1ZM87.9,203.8V142.4L57.4,158.7A72.1,72.1,0,0,0,87.9,203.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "172",
      "cy": "148",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.6,163.4A80,80,0,1,1,127.9,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.6 154.3 127.9 112 127.9 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "129.1",
      "x2": "95.9",
      "y2": "217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "172",
      "cy": "148",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.6,163.4A80,80,0,1,1,127.9,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.6 154.3 127.9 112 127.9 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "129.1",
      "x2": "95.9",
      "y2": "217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "171.9",
      "cy": "148",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.6,163.4A80,80,0,1,1,127.9,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48.6 154.3 127.9 112 127.9 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.9",
      "y1": "129.1",
      "x2": "95.9",
      "y2": "217.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5f = [];
/* style */

const __vue_inject_styles__$5f = undefined;
/* scoped */

const __vue_scope_id__$5f = undefined;
/* module identifier */

const __vue_module_identifier__$5f = undefined;
/* functional template */

const __vue_is_functional_template__$5f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5f,
  staticRenderFns: __vue_staticRenderFns__$5f
}, __vue_inject_styles__$5f, __vue_script__$5f, __vue_scope_id__$5f, __vue_is_functional_template__$5f, __vue_module_identifier__$5f, false, undefined, undefined, undefined);

var script$5e = Vue.extend({
  name: "PhOctagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5e = script$5e;
/* template */

var __vue_render__$5e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.3,80.2,175.8,28.7A16.1,16.1,0,0,0,164.5,24h-73a16.1,16.1,0,0,0-11.3,4.7L28.7,80.2A16.1,16.1,0,0,0,24,91.5v73a16.1,16.1,0,0,0,4.7,11.3l51.5,51.5A16.1,16.1,0,0,0,91.5,232h73a16.1,16.1,0,0,0,11.3-4.7l51.5-51.5a16.1,16.1,0,0,0,4.7-11.3v-73A16.1,16.1,0,0,0,227.3,80.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5e = [];
/* style */

const __vue_inject_styles__$5e = undefined;
/* scoped */

const __vue_scope_id__$5e = undefined;
/* module identifier */

const __vue_module_identifier__$5e = undefined;
/* functional template */

const __vue_is_functional_template__$5e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5e,
  staticRenderFns: __vue_staticRenderFns__$5e
}, __vue_inject_styles__$5e, __vue_script__$5e, __vue_scope_id__$5e, __vue_is_functional_template__$5e, __vue_module_identifier__$5e, false, undefined, undefined, undefined);

var script$5d = Vue.extend({
  name: "PhOption",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5d = script$5d;
/* template */

var __vue_render__$5d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "72",
      "x2": "224",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "224",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,184a8,8,0,0,1-8,8H161a16.2,16.2,0,0,1-14.4-8.8L95.1,80H32a8,8,0,0,1,0-16H95.1a16,16,0,0,1,14.3,8.8L161,176h63A8,8,0,0,1,232,184ZM152,80h72a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "224",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "224",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "72",
      "x2": "224",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5d = [];
/* style */

const __vue_inject_styles__$5d = undefined;
/* scoped */

const __vue_scope_id__$5d = undefined;
/* module identifier */

const __vue_module_identifier__$5d = undefined;
/* functional template */

const __vue_is_functional_template__$5d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5d,
  staticRenderFns: __vue_staticRenderFns__$5d
}, __vue_inject_styles__$5d, __vue_script__$5d, __vue_scope_id__$5d, __vue_is_functional_template__$5d, __vue_module_identifier__$5d, false, undefined, undefined, undefined);

var script$5c = Vue.extend({
  name: "PhPackage",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5c = script$5c;
/* template */

var __vue_render__$5c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 152.5 177 100.5 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.1,74.6A8.1,8.1,0,0,0,32,78.7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.6,7.6,0,0,0,3.9,1h0l.9-106.8L33.1,74.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 152.5 177 100.5 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.9,70.8h0a.1.1,0,0,1-.1-.1,16.2,16.2,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v98.6a16.1,16.1,0,0,0,8.2,14l88,49.5a16.5,16.5,0,0,0,7.2,2h1.4a15.7,15.7,0,0,0,7-2l88-49.5a16.1,16.1,0,0,0,8.2-14V78.7A15.6,15.6,0,0,0,229.9,70.8ZM128,29.2,207.7,74,177.1,91.4,96.4,46.9Zm.9,89.6L48.4,74,80,56.2l80.8,44.5Zm7.2,103.5.8-89.6L169,114.4v38.1a8,8,0,0,0,16,0V105.3l31-17.6v89.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 152.5 177 100.5 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 152.5 177 100.5 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "177 152.5 177 100.5 80 47",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "222.9 74.6 128.9 128 33.1 74.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.9",
      "y1": "128",
      "x2": "128",
      "y2": "234.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5c = [];
/* style */

const __vue_inject_styles__$5c = undefined;
/* scoped */

const __vue_scope_id__$5c = undefined;
/* module identifier */

const __vue_module_identifier__$5c = undefined;
/* functional template */

const __vue_is_functional_template__$5c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5c,
  staticRenderFns: __vue_staticRenderFns__$5c
}, __vue_inject_styles__$5c, __vue_script__$5c, __vue_scope_id__$5c, __vue_is_functional_template__$5c, __vue_module_identifier__$5c, false, undefined, undefined, undefined);

var script$5b = Vue.extend({
  name: "PhPaintBrush",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5b = script$5b;
/* template */

var __vue_render__$5b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.4,84.6a90.8,90.8,0,0,1,33,33",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M133,90.6A85.4,85.4,0,0,1,165.4,123C192.7,99.1,225,63.9,225,31,192.1,31,156.9,63.3,133,90.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133,90.6A85.4,85.4,0,0,1,165.4,123",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M225,23c-21.3,0-45.3,11.8-71.1,34.9-18.1,16.2-33.6,34.7-44.3,48.7A60.1,60.1,0,0,0,32,164c0,31.2-16.2,45.1-17,45.8a7.7,7.7,0,0,0-2.5,8.8A7.8,7.8,0,0,0,20,224H92a60.1,60.1,0,0,0,57.4-77.6c14-10.7,32.5-26.2,48.7-44.3C221.2,76.3,233,52.3,233,31A8,8,0,0,0,225,23ZM124.4,113.6c2.9-3.7,6.3-7.9,10.2-12.5a75.4,75.4,0,0,1,20.3,20.3c-4.6,3.9-8.8,7.3-12.5,10.2A59.4,59.4,0,0,0,124.4,113.6Zm42.6-2.9A93.1,93.1,0,0,0,145.3,89c19.6-21.2,46-44.4,70.8-49.1C211.4,64.7,188.2,91.1,167,110.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133,90.6A85.4,85.4,0,0,1,165.4,123",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133,90.6A85.4,85.4,0,0,1,165.4,123",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M133,90.6A85.4,85.4,0,0,1,165.4,123",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5b = [];
/* style */

const __vue_inject_styles__$5b = undefined;
/* scoped */

const __vue_scope_id__$5b = undefined;
/* module identifier */

const __vue_module_identifier__$5b = undefined;
/* functional template */

const __vue_is_functional_template__$5b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5b,
  staticRenderFns: __vue_staticRenderFns__$5b
}, __vue_inject_styles__$5b, __vue_script__$5b, __vue_scope_id__$5b, __vue_is_functional_template__$5b, __vue_module_identifier__$5b, false, undefined, undefined, undefined);

var script$5a = Vue.extend({
  name: "PhPaintBrushBroad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5a = script$5a;
/* template */

var __vue_render__$5a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "32",
      "x2": "176",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.6,152H200a16,16,0,0,0,16-16V32H72A32,32,0,0,0,40,64v72a16,16,0,0,0,16,16H99.4a8,8,0,0,1,8,8.6L104,208a24,24,0,0,0,48,0l-3.4-47.4A8,8,0,0,1,156.6,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,112H216v24a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9a8,8,0,0,0-7.9-9.1H56a16,16,0,0,1-16-16Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,24H72A40,40,0,0,0,32,64v72a24.1,24.1,0,0,0,24,24h46.8l-6.7,46.9A3.7,3.7,0,0,0,96,208a32,32,0,0,0,64,0,3.7,3.7,0,0,0-.1-1.1L153.2,160H200a24.1,24.1,0,0,0,24-24V32A8,8,0,0,0,216,24ZM72,40H176V80a8,8,0,0,0,16,0V40h16v64H48V64A24.1,24.1,0,0,1,72,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "32",
      "x2": "184",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5a = [];
/* style */

const __vue_inject_styles__$5a = undefined;
/* scoped */

const __vue_scope_id__$5a = undefined;
/* module identifier */

const __vue_module_identifier__$5a = undefined;
/* functional template */

const __vue_is_functional_template__$5a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5a,
  staticRenderFns: __vue_staticRenderFns__$5a
}, __vue_inject_styles__$5a, __vue_script__$5a, __vue_scope_id__$5a, __vue_is_functional_template__$5a, __vue_module_identifier__$5a, false, undefined, undefined, undefined);

var script$59 = Vue.extend({
  name: "PhPaintBrushHousehold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$59 = script$59;
/* template */

var __vue_render__$59 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "152",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "188",
      "x2": "70.6",
      "y2": "214.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "160",
      "x2": "42.6",
      "y2": "186.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2a8,8,0,0,0,11.6-.3L191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L152,184,72,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "152",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.8",
      "y1": "183.4",
      "x2": "70.6",
      "y2": "214.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.8",
      "y1": "155.4",
      "x2": "42.6",
      "y2": "186.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.6,25.4a31.9,31.9,0,0,0-45.2,0l-.3.3L130.2,86.9,121,77.7a23.9,23.9,0,0,0-34,0L10.3,154.3a8.1,8.1,0,0,0,0,11.4l80,80a8.2,8.2,0,0,0,11.4,0L178.3,169a23.9,23.9,0,0,0,0-34l-9.2-9.2,61.2-54.9.3-.3A31.9,31.9,0,0,0,230.6,25.4ZM96,228.7,81.9,214.6,107.4,189a8,8,0,0,0-11.3-11.3L70.6,203.3,53.9,186.6,79.4,161a8,8,0,0,0-11.3-11.3L42.6,175.3,27.3,160,72,115.3,140.7,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "152",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.8",
      "y1": "183.4",
      "x2": "70.6",
      "y2": "214.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.8",
      "y1": "155.4",
      "x2": "42.6",
      "y2": "186.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "152",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.8",
      "y1": "183.4",
      "x2": "70.6",
      "y2": "214.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.8",
      "y1": "155.4",
      "x2": "42.6",
      "y2": "186.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "72",
      "y1": "104",
      "x2": "152",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "101.8",
      "y1": "183.4",
      "x2": "70.6",
      "y2": "214.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.8",
      "y1": "155.4",
      "x2": "42.6",
      "y2": "186.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$59 = [];
/* style */

const __vue_inject_styles__$59 = undefined;
/* scoped */

const __vue_scope_id__$59 = undefined;
/* module identifier */

const __vue_module_identifier__$59 = undefined;
/* functional template */

const __vue_is_functional_template__$59 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$59 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$59,
  staticRenderFns: __vue_staticRenderFns__$59
}, __vue_inject_styles__$59, __vue_script__$59, __vue_scope_id__$59, __vue_is_functional_template__$59, __vue_module_identifier__$59, false, undefined, undefined, undefined);

var script$58 = Vue.extend({
  name: "PhPaintBucket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$58 = script$58;
/* template */

var __vue_render__$58 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,216c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "107",
      "y1": "99",
      "x2": "37.9",
      "y2": "29.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.9",
      "y1": "101.9",
      "x2": "37.9",
      "y2": "29.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,204a28,28,0,0,1-56,0c0-23,21.4-44.7,22.3-45.7a8.2,8.2,0,0,1,11.4,0C234.6,159.3,256,181,256,204ZM132.5,124.5a12,12,0,0,0,0-17,12.1,12.1,0,0,0-17,0,12,12,0,0,0,17,17Zm98.5-1a8.2,8.2,0,0,0-2.4-5.7L121.1,10.3a8,8,0,0,0-11.3,0L69.7,50.4l41,41a28,28,0,1,1-11.3,11.3l-41-41L13.7,106.5a24,24,0,0,0,0,34l84.8,84.8a24.1,24.1,0,0,0,34,0l96.1-96.2A8,8,0,0,0,231,123.5ZM43.5,24.2A8,8,0,0,0,32.2,35.5L58.4,61.7,69.7,50.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.9",
      "y1": "101.9",
      "x2": "37.9",
      "y2": "29.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.9",
      "y1": "101.9",
      "x2": "37.9",
      "y2": "29.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "124",
      "cy": "116",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "109.9",
      "y1": "101.9",
      "x2": "37.9",
      "y2": "29.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$58 = [];
/* style */

const __vue_inject_styles__$58 = undefined;
/* scoped */

const __vue_scope_id__$58 = undefined;
/* module identifier */

const __vue_module_identifier__$58 = undefined;
/* functional template */

const __vue_is_functional_template__$58 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$58 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$58,
  staticRenderFns: __vue_staticRenderFns__$58
}, __vue_inject_styles__$58, __vue_script__$58, __vue_scope_id__$58, __vue_is_functional_template__$58, __vue_module_identifier__$58, false, undefined, undefined, undefined);

var script$57 = Vue.extend({
  name: "PhPaintRoller",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$57 = script$57;
/* template */

var __vue_render__$57 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "56",
      "width": "160",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,96h28a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,104v50a16.2,16.2,0,0,1-11.6,15.4L136,198v34a8,8,0,0,1-16,0V198a16.2,16.2,0,0,1,11.6-15.4L232,154V104H216v24a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V104H16a8,8,0,0,1,0-16H32V64A16,16,0,0,1,48,48H200a16,16,0,0,1,16,16V88h16A16,16,0,0,1,248,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "168",
      "height": "80",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "96",
      "x2": "16",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$57 = [];
/* style */

const __vue_inject_styles__$57 = undefined;
/* scoped */

const __vue_scope_id__$57 = undefined;
/* module identifier */

const __vue_module_identifier__$57 = undefined;
/* functional template */

const __vue_is_functional_template__$57 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$57 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$57,
  staticRenderFns: __vue_staticRenderFns__$57
}, __vue_inject_styles__$57, __vue_script__$57, __vue_scope_id__$57, __vue_is_functional_template__$57, __vue_module_identifier__$57, false, undefined, undefined, undefined);

var script$56 = Vue.extend({
  name: "PhPalette",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$56 = script$56;
/* template */

var __vue_render__$56 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "102",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "154",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173",
      "cy": "102",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "102",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "154",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173",
      "cy": "102",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.8,53.9A103.4,103.4,0,0,0,128,24h-1.1A104,104,0,0,0,93.4,226.1,32,32,0,0,0,136,195.9V192a16,16,0,0,1,16-16h46.2a31.7,31.7,0,0,0,31.2-24.9,101.5,101.5,0,0,0,2.6-24A102.9,102.9,0,0,0,200.8,53.9ZM89,164.4A12,12,0,1,1,93.4,148,12,12,0,0,1,89,164.4ZM93.4,108A12,12,0,1,1,89,91.6,12.1,12.1,0,0,1,93.4,108ZM128,88a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm51,24.4A12,12,0,1,1,183.4,96,12.1,12.1,0,0,1,179,112.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "102",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "154",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173",
      "cy": "102",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "102",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "154",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173",
      "cy": "102",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "76",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "102",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "83",
      "cy": "154",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "173",
      "cy": "102",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$56 = [];
/* style */

const __vue_inject_styles__$56 = undefined;
/* scoped */

const __vue_scope_id__$56 = undefined;
/* module identifier */

const __vue_module_identifier__$56 = undefined;
/* functional template */

const __vue_is_functional_template__$56 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$56 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$56,
  staticRenderFns: __vue_staticRenderFns__$56
}, __vue_inject_styles__$56, __vue_script__$56, __vue_scope_id__$56, __vue_is_functional_template__$56, __vue_module_identifier__$56, false, undefined, undefined, undefined);

var script$55 = Vue.extend({
  name: "PhPaperPlane",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$55 = script$55;
/* template */

var __vue_render__$55 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.9",
      "y1": "184",
      "x2": "127.9",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.9",
      "y1": "184",
      "x2": "127.9",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.4,201.5,141.8,32.6a16,16,0,0,0-27.9,0L19.3,201.5a15.7,15.7,0,0,0,1.8,18.1,15.9,15.9,0,0,0,17.6,4.8l78.5-28.1a4.1,4.1,0,0,0,2.7-3.8V120.3a8.2,8.2,0,0,1,7.4-8.3,8,8,0,0,1,8.6,8v72.5a4,4,0,0,0,2.6,3.8l78.6,28.1a17,17,0,0,0,5.4.9,16,16,0,0,0,13.9-23.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.9",
      "y1": "184",
      "x2": "127.9",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.9",
      "y1": "184",
      "x2": "127.9",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "127.9",
      "y1": "184",
      "x2": "127.9",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$55 = [];
/* style */

const __vue_inject_styles__$55 = undefined;
/* scoped */

const __vue_scope_id__$55 = undefined;
/* module identifier */

const __vue_module_identifier__$55 = undefined;
/* functional template */

const __vue_is_functional_template__$55 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$55 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$55,
  staticRenderFns: __vue_staticRenderFns__$55
}, __vue_inject_styles__$55, __vue_script__$55, __vue_scope_id__$55, __vue_is_functional_template__$55, __vue_module_identifier__$55, false, undefined, undefined, undefined);

var script$54 = Vue.extend({
  name: "PhPaperPlaneRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$54 = script$54;
/* template */

var __vue_render__$54 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.4,114,54.9,19.7a16.3,16.3,0,0,0-18.2,1.2,15.9,15.9,0,0,0-5.1,17.9l28.1,78.5a4.1,4.1,0,0,0,3.8,2.7h72.2a8.2,8.2,0,0,1,8.3,7.5,8,8,0,0,1-8,8.5H63.5a4.1,4.1,0,0,0-3.8,2.7L31.6,217.2a16.1,16.1,0,0,0,15.1,21.4,16.5,16.5,0,0,0,7.8-2L223.4,142a16.1,16.1,0,0,0,0-28Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$54 = [];
/* style */

const __vue_inject_styles__$54 = undefined;
/* scoped */

const __vue_scope_id__$54 = undefined;
/* module identifier */

const __vue_module_identifier__$54 = undefined;
/* functional template */

const __vue_is_functional_template__$54 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$54 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$54,
  staticRenderFns: __vue_staticRenderFns__$54
}, __vue_inject_styles__$54, __vue_script__$54, __vue_scope_id__$54, __vue_is_functional_template__$54, __vue_module_identifier__$54, false, undefined, undefined, undefined);

var script$53 = Vue.extend({
  name: "PhPaperPlaneTilt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$53 = script$53;
/* template */

var __vue_render__$53 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.9",
      "y1": "145.1",
      "x2": "156.1",
      "y2": "99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.9",
      "y1": "145.1",
      "x2": "156.1",
      "y2": "99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.7,48.3,175.3,234.2a15.9,15.9,0,0,1-14.1,11.6h-1.4a16,16,0,0,1-14.4-9.1l-35.7-75.4a4.1,4.1,0,0,1,.8-4.6l51.3-51.3a8,8,0,1,0-11.3-11.3L99.2,145.5a4.1,4.1,0,0,1-4.6.8l-75-35.5a16.6,16.6,0,0,1-9.5-15.6A15.9,15.9,0,0,1,21.8,80.7L208.1,28.2a16,16,0,0,1,17.7,6.5A16.7,16.7,0,0,1,227.7,48.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.9",
      "y1": "145.1",
      "x2": "156.1",
      "y2": "99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.9",
      "y1": "145.1",
      "x2": "156.1",
      "y2": "99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "110.9",
      "y1": "145.1",
      "x2": "156.1",
      "y2": "99.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$53 = [];
/* style */

const __vue_inject_styles__$53 = undefined;
/* scoped */

const __vue_scope_id__$53 = undefined;
/* module identifier */

const __vue_module_identifier__$53 = undefined;
/* functional template */

const __vue_is_functional_template__$53 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$53 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$53,
  staticRenderFns: __vue_staticRenderFns__$53
}, __vue_inject_styles__$53, __vue_script__$53, __vue_scope_id__$53, __vue_is_functional_template__$53, __vue_module_identifier__$53, false, undefined, undefined, undefined);

var script$52 = Vue.extend({
  name: "PhPaperclip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$52 = script$52;
/* template */

var __vue_render__$52 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,176l95.8-92.2a28,28,0,0,0-39.6-39.6L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.7,122.3a8.1,8.1,0,0,1-.1,11.4l-82,81.9a56,56,0,0,1-79.2-79.2L147.7,35.8a40,40,0,1,1,56.6,56.5L105,192.9A23.8,23.8,0,0,1,88,200a24,24,0,0,1-17-41l83.3-84.6a8,8,0,1,1,11.4,11.2L82.4,170.3A8,8,0,0,0,80,176a8.1,8.1,0,0,0,13.7,5.7L192.9,81A23.8,23.8,0,0,0,200,64a24,24,0,0,0-41-17L59.8,147.7a40,40,0,1,0,56.5,56.6l82-82A8.1,8.1,0,0,1,209.7,122.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$52 = [];
/* style */

const __vue_inject_styles__$52 = undefined;
/* scoped */

const __vue_scope_id__$52 = undefined;
/* module identifier */

const __vue_module_identifier__$52 = undefined;
/* functional template */

const __vue_is_functional_template__$52 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$52 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$52,
  staticRenderFns: __vue_staticRenderFns__$52
}, __vue_inject_styles__$52, __vue_script__$52, __vue_scope_id__$52, __vue_is_functional_template__$52, __vue_module_identifier__$52, false, undefined, undefined, undefined);

var script$51 = Vue.extend({
  name: "PhPaperclipHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$51 = script$51;
/* template */

var __vue_render__$51 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,120H48a28,28,0,0,0,0,56H188a48,48,0,0,0,0-96H76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,184H46c-21.6,0-39.2-17.9-39.2-40S24.4,104,46,104H190a24,24,0,0,1,0,48H78a8,8,0,0,1,0-16H190a8,8,0,0,0,0-16H46c-12.8,0-23.2,10.8-23.2,24S33.2,168,46,168H192a40,40,0,0,0,0-80H80a8,8,0,0,1,0-16H192a56,56,0,0,1,0,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$51 = [];
/* style */

const __vue_inject_styles__$51 = undefined;
/* scoped */

const __vue_scope_id__$51 = undefined;
/* module identifier */

const __vue_module_identifier__$51 = undefined;
/* functional template */

const __vue_is_functional_template__$51 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$51 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$51,
  staticRenderFns: __vue_staticRenderFns__$51
}, __vue_inject_styles__$51, __vue_script__$51, __vue_scope_id__$51, __vue_is_functional_template__$51, __vue_module_identifier__$51, false, undefined, undefined, undefined);

var script$50 = Vue.extend({
  name: "PhParachute",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$50 = script$50;
/* template */

var __vue_render__$50 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120a96,96,0,0,0-192,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 120 128 192 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "144",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,120c0-72,40-96,40-96s40,24,40,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a96,96,0,0,0-96,96H88C88,48,128,24,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24s40,24,40,96h56A96,96,0,0,0,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120a96,96,0,0,0-192,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 120 128 192 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "144",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,120A104.2,104.2,0,0,0,128,16h0A104.2,104.2,0,0,0,24,120a8.2,8.2,0,0,0,3.2,6.4h0L120,196v20h-8a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16h-8V196l92.8-69.6h0A8.2,8.2,0,0,0,232,120Zm-16.4-8H175.8c-1.5-37.9-13.9-62.4-25.1-77A88.1,88.1,0,0,1,215.6,112Zm-61.2,16L128,175.5,101.6,128Zm-71.1,0,19.5,35.1L56,128Zm89.4,0H200l-46.8,35.1ZM105.3,35C94.1,49.6,81.7,74.1,80.2,112H40.4A88.1,88.1,0,0,1,105.3,35Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120a96,96,0,0,0-192,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 120 128 192 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "144",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120a96,96,0,0,0-192,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 120 128 192 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "144",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,120a96,96,0,0,0-192,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "224 120 128 192 32 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "144",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$50 = [];
/* style */

const __vue_inject_styles__$50 = undefined;
/* scoped */

const __vue_scope_id__$50 = undefined;
/* module identifier */

const __vue_module_identifier__$50 = undefined;
/* functional template */

const __vue_is_functional_template__$50 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$50 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$50,
  staticRenderFns: __vue_staticRenderFns__$50
}, __vue_inject_styles__$50, __vue_script__$50, __vue_scope_id__$50, __vue_is_functional_template__$50, __vue_module_identifier__$50, false, undefined, undefined, undefined);

var script$4$ = Vue.extend({
  name: "PhPassword",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4$ = script$4$;
/* template */

var __vue_render__$4$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "36",
      "y1": "56",
      "x2": "36",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.6",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.2",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.8",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "134.4",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.2",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "218.8",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.4",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.6",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.2",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.8",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "134.4",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.2",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "218.8",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.4",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0Zm84,54.5L112,117V96a8,8,0,0,0-16,0v21l-20-6.5a7.8,7.8,0,0,0-10,5.1,7.9,7.9,0,0,0,5.1,10.1l20,6.5-12.4,17a8,8,0,0,0,1.8,11.2,8.1,8.1,0,0,0,11.2-1.8l12.3-17,12.3,17a8.1,8.1,0,0,0,11.2,1.8,8,8,0,0,0,1.8-11.2l-12.4-17,20-6.5a7.9,7.9,0,0,0,5.1-10.1A7.8,7.8,0,0,0,132,110.5Zm106,5.1a7.8,7.8,0,0,0-10-5.1L208,117V96a8,8,0,0,0-16,0v21l-20-6.5a7.8,7.8,0,0,0-10,5.1,7.9,7.9,0,0,0,5.1,10.1l20,6.5-12.4,17a8,8,0,0,0,1.8,11.2,8.1,8.1,0,0,0,11.2-1.8l12.3-17,12.3,17a8.1,8.1,0,0,0,11.2,1.8,8,8,0,0,0,1.8-11.2l-12.4-17,20-6.5A7.9,7.9,0,0,0,238,115.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.6",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.2",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.8",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "134.4",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.2",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "218.8",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.4",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.6",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.2",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.8",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "134.4",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.2",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "218.8",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.4",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "73.6",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "85.2",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "122.8",
      "y1": "153.9",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "134.4",
      "y1": "118.1",
      "x2": "104",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "96",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "169.6",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.2",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "218.8",
      "y1": "153.9",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.4",
      "y1": "118.1",
      "x2": "200",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4$ = [];
/* style */

const __vue_inject_styles__$4$ = undefined;
/* scoped */

const __vue_scope_id__$4$ = undefined;
/* module identifier */

const __vue_module_identifier__$4$ = undefined;
/* functional template */

const __vue_is_functional_template__$4$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4$,
  staticRenderFns: __vue_staticRenderFns__$4$
}, __vue_inject_styles__$4$, __vue_script__$4$, __vue_scope_id__$4$, __vue_is_functional_template__$4$, __vue_module_identifier__$4$, false, undefined, undefined, undefined);

var script$4_ = Vue.extend({
  name: "PhPath",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4_ = script$4_;
/* template */

var __vue_render__$4_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,168a32.1,32.1,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "200",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4_ = [];
/* style */

const __vue_inject_styles__$4_ = undefined;
/* scoped */

const __vue_scope_id__$4_ = undefined;
/* module identifier */

const __vue_module_identifier__$4_ = undefined;
/* functional template */

const __vue_is_functional_template__$4_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4_,
  staticRenderFns: __vue_staticRenderFns__$4_
}, __vue_inject_styles__$4_, __vue_script__$4_, __vue_scope_id__$4_, __vue_is_functional_template__$4_, __vue_module_identifier__$4_, false, undefined, undefined, undefined);

var script$4Z = Vue.extend({
  name: "PhPause",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Z = script$4Z;
/* template */

var __vue_render__$4Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V208a16,16,0,0,1-16,16H164a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h36A16,16,0,0,1,216,48ZM92,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H92a16,16,0,0,0,16-16V48A16,16,0,0,0,92,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "156",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "40",
      "width": "52",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Z = [];
/* style */

const __vue_inject_styles__$4Z = undefined;
/* scoped */

const __vue_scope_id__$4Z = undefined;
/* module identifier */

const __vue_module_identifier__$4Z = undefined;
/* functional template */

const __vue_is_functional_template__$4Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Z,
  staticRenderFns: __vue_staticRenderFns__$4Z
}, __vue_inject_styles__$4Z, __vue_script__$4Z, __vue_scope_id__$4Z, __vue_is_functional_template__$4Z, __vue_module_identifier__$4Z, false, undefined, undefined, undefined);

var script$4Y = Vue.extend({
  name: "PhPauseCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Y = script$4Y;
/* template */

var __vue_render__$4Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "104",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "96",
      "x2": "152",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Y = [];
/* style */

const __vue_inject_styles__$4Y = undefined;
/* scoped */

const __vue_scope_id__$4Y = undefined;
/* module identifier */

const __vue_module_identifier__$4Y = undefined;
/* functional template */

const __vue_is_functional_template__$4Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Y,
  staticRenderFns: __vue_staticRenderFns__$4Y
}, __vue_inject_styles__$4Y, __vue_script__$4Y, __vue_scope_id__$4Y, __vue_is_functional_template__$4Y, __vue_module_identifier__$4Y, false, undefined, undefined, undefined);

var script$4X = Vue.extend({
  name: "PhPawPrint",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4X = script$4X;
/* template */

var __vue_render__$4X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "104",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "104",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "96",
      "cy": "56",
      "r": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "56",
      "r": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,108a28,28,0,1,1-28-28A28.1,28.1,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28.1,28.1,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28.1,28.1,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28.1,28.1,0,0,0,164,88Zm23.1,60.8a35.3,35.3,0,0,1-16.9-21.1,43.9,43.9,0,0,0-84.4,0A35.5,35.5,0,0,1,69,148.8,40,40,0,0,0,88,224a40.5,40.5,0,0,0,15.5-3.1,64.2,64.2,0,0,1,48.9-.1A39.6,39.6,0,0,0,168,224a40,40,0,0,0,19.1-75.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "108",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "60",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4X = [];
/* style */

const __vue_inject_styles__$4X = undefined;
/* scoped */

const __vue_scope_id__$4X = undefined;
/* module identifier */

const __vue_module_identifier__$4X = undefined;
/* functional template */

const __vue_is_functional_template__$4X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4X,
  staticRenderFns: __vue_staticRenderFns__$4X
}, __vue_inject_styles__$4X, __vue_script__$4X, __vue_scope_id__$4X, __vue_is_functional_template__$4X, __vue_module_identifier__$4X, false, undefined, undefined, undefined);

var script$4W = Vue.extend({
  name: "PhPeace",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4W = script$4W;
/* template */

var __vue_render__$4W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.4",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.4",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.6,186.9A102.9,102.9,0,0,0,232,128a104,104,0,0,0-208,0,102.9,102.9,0,0,0,18.4,58.9l.4.8.4.4a103.9,103.9,0,0,0,169.6,0l.4-.4A3,3,0,0,0,213.6,186.9ZM216,128a87.5,87.5,0,0,1-11.6,43.7L136,123.8V40.4A88.1,88.1,0,0,1,216,128ZM120,40.4v83.4L51.6,171.7A88,88,0,0,1,120,40.4ZM60.8,184.8,120,143.4v72.2A87.9,87.9,0,0,1,60.8,184.8ZM136,215.6V143.4l59.2,41.4A87.9,87.9,0,0,1,136,215.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.4",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.4",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "206.6",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "49.4",
      "y2": "183.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4W = [];
/* style */

const __vue_inject_styles__$4W = undefined;
/* scoped */

const __vue_scope_id__$4W = undefined;
/* module identifier */

const __vue_module_identifier__$4W = undefined;
/* functional template */

const __vue_is_functional_template__$4W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4W,
  staticRenderFns: __vue_staticRenderFns__$4W
}, __vue_inject_styles__$4W, __vue_script__$4W, __vue_scope_id__$4W, __vue_is_functional_template__$4W, __vue_module_identifier__$4W, false, undefined, undefined, undefined);

var script$4V = Vue.extend({
  name: "PhPen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4V = script$4V;
/* template */

var __vue_render__$4V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "164 200 204 160 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "156",
      "x2": "100",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.5",
      "y1": "160.5",
      "x2": "95.5",
      "y2": "215.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.7,88A15.9,15.9,0,0,0,224,76.7L179.3,32a16.1,16.1,0,0,0-22.6,0L36.7,152a16,16,0,0,0-3.6,5.4l-.3.8a17,17,0,0,0-.8,5.1V208a16,16,0,0,0,16,16H92.7a14.4,14.4,0,0,0,5.1-.9l.8-.2a16,16,0,0,0,5.4-3.6l83.7-83.7,3.4,13.9-36.8,36.8a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0l40-40a8.5,8.5,0,0,0,2.1-7.6l-6.9-27.6L224,99.3A15.9,15.9,0,0,0,228.7,88ZM192,108.7,147.3,64,168,43.3,212.7,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.5",
      "y1": "160.5",
      "x2": "95.5",
      "y2": "215.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.5",
      "y1": "160.5",
      "x2": "95.5",
      "y2": "215.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 192 200 152 192 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.5",
      "y1": "160.5",
      "x2": "95.5",
      "y2": "215.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4V = [];
/* style */

const __vue_inject_styles__$4V = undefined;
/* scoped */

const __vue_scope_id__$4V = undefined;
/* module identifier */

const __vue_module_identifier__$4V = undefined;
/* functional template */

const __vue_is_functional_template__$4V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4V,
  staticRenderFns: __vue_staticRenderFns__$4V
}, __vue_inject_styles__$4V, __vue_script__$4V, __vue_scope_id__$4V, __vue_is_functional_template__$4V, __vue_module_identifier__$4V, false, undefined, undefined, undefined);

var script$4U = Vue.extend({
  name: "PhPenNib",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4U = script$4U;
/* template */

var __vue_render__$4U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "224",
      "x2": "99",
      "y2": "157",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2L32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136Zm-4,104a20,20,0,1,1,20-20A20.1,20.1,0,0,1,116,160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "224",
      "x2": "101.9",
      "y2": "154.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,92.7,163.3,24a16.1,16.1,0,0,0-22.6,0L115.6,49.1,57.5,70.9A15.9,15.9,0,0,0,47.4,83.2L26.6,207.8a4,4,0,0,0,6.8,3.5l55-55.1A31.7,31.7,0,0,1,84,140a32,32,0,1,1,32,32,31.7,31.7,0,0,1-16.2-4.4l-55.1,55a4,4,0,0,0,3.5,6.8l124.6-20.7a16.2,16.2,0,0,0,12.3-10.2l21.8-58.1L232,115.3a15.9,15.9,0,0,0,0-22.6Zm-32,32L131.3,56,152,35.3,220.7,104Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "224",
      "x2": "101.9",
      "y2": "154.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "224",
      "x2": "101.9",
      "y2": "154.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "116",
      "cy": "140",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "224",
      "x2": "101.9",
      "y2": "154.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4U = [];
/* style */

const __vue_inject_styles__$4U = undefined;
/* scoped */

const __vue_scope_id__$4U = undefined;
/* module identifier */

const __vue_module_identifier__$4U = undefined;
/* functional template */

const __vue_is_functional_template__$4U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4U,
  staticRenderFns: __vue_staticRenderFns__$4U
}, __vue_inject_styles__$4U, __vue_script__$4U, __vue_scope_id__$4U, __vue_is_functional_template__$4U, __vue_module_identifier__$4U, false, undefined, undefined, undefined);

var script$4T = Vue.extend({
  name: "PhPenNibStraight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4T = script$4T;
/* template */

var __vue_render__$4T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "156",
      "x2": "128",
      "y2": "244",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "72 72 42.5 131.8 128 244 213.5 131.8 184 72 72 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.4,127.4,184,72H72L44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3A8.2,8.2,0,0,0,211.4,127.4ZM128,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,128,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "248",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.6,123.9,192,70.1V32a16,16,0,0,0-16-16H80A16,16,0,0,0,64,32V70.1L37.4,123.9a16.1,16.1,0,0,0,1.5,16.6l73.9,100.3a4,4,0,0,0,7.2-2.4V163a32,32,0,1,1,16,0v75.4a4,4,0,0,0,7.2,2.4l73.9-100.3A16.1,16.1,0,0,0,218.6,123.9ZM176,64H80V32h96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "248",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "248",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "248",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4T = [];
/* style */

const __vue_inject_styles__$4T = undefined;
/* scoped */

const __vue_scope_id__$4T = undefined;
/* module identifier */

const __vue_module_identifier__$4T = undefined;
/* functional template */

const __vue_is_functional_template__$4T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4T,
  staticRenderFns: __vue_staticRenderFns__$4T
}, __vue_inject_styles__$4T, __vue_script__$4T, __vue_scope_id__$4T, __vue_is_functional_template__$4T, __vue_module_identifier__$4T, false, undefined, undefined, undefined);

var script$4S = Vue.extend({
  name: "PhPencil",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4S = script$4S;
/* template */

var __vue_render__$4S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "156",
      "x2": "100",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "72",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.5",
      "y1": "215.5",
      "x2": "40.5",
      "y2": "160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,76.7,179.3,32a15.9,15.9,0,0,0-22.6,0L130.3,58.3h0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H92.7a15.9,15.9,0,0,0,11.3-4.7l120-120A16.1,16.1,0,0,0,224,76.7ZM51.3,160,144,67.3,160.7,84,68,176.7ZM48,179.3,76.7,208H48Zm48,25.4L79.3,188,172,95.3,188.7,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.5",
      "y1": "215.5",
      "x2": "40.5",
      "y2": "160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.5",
      "y1": "215.5",
      "x2": "40.5",
      "y2": "160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95.5",
      "y1": "215.5",
      "x2": "40.5",
      "y2": "160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4S = [];
/* style */

const __vue_inject_styles__$4S = undefined;
/* scoped */

const __vue_scope_id__$4S = undefined;
/* module identifier */

const __vue_module_identifier__$4S = undefined;
/* functional template */

const __vue_is_functional_template__$4S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4S,
  staticRenderFns: __vue_staticRenderFns__$4S
}, __vue_inject_styles__$4S, __vue_script__$4S, __vue_scope_id__$4S, __vue_is_functional_template__$4S, __vue_module_identifier__$4S, false, undefined, undefined, undefined);

var script$4R = Vue.extend({
  name: "PhPencilCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4R = script$4R;
/* template */

var __vue_render__$4R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.2 176 176 128 72 80 176 80 211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,200a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V200a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "98.5",
      "y1": "136",
      "x2": "157.5",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,211.2a96,96,0,1,1,96,0h0V176L128,72,80,176v35.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.2 176 176 128 72 80 176 80 211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "128",
      "x2": "153.8",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM128,170.9a31.9,31.9,0,0,0-32.3-9.8L111,128h34l15.3,33.1a31.9,31.9,0,0,0-32.3,9.8Zm40,35.5a89,89,0,0,1-32,9.2V192a16,16,0,0,1,32,0Zm22.2-16.2c-2,2-4.1,3.9-6.2,5.7V176a9.8,9.8,0,0,0-.7-3.4l-48-104h-.1a4.1,4.1,0,0,0-.5-.9c0-.1,0-.1-.1-.2l-.5-.7H134a4.6,4.6,0,0,0-.7-.7h-.2l-.7-.6h-.2l-.8-.5h-.1l-.9-.3h-.3l-.9-.2h-2.4l-1,.2h-.2l-.8.3h-.2l-.9.4h-.1l-.7.6h-.2l-.7.7h-.1l-.5.7-.2.2a4.1,4.1,0,0,1-.5.9l-22.1,48h0L72.7,172.6A9.8,9.8,0,0,0,72,176v19.9c-2.1-1.8-4.2-3.7-6.2-5.7a88,88,0,1,1,124.4,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.2 176 176 128 72 80 176 80 211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "128",
      "x2": "153.8",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.2 176 176 128 72 80 176 80 211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "128",
      "x2": "153.8",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 211.2 176 176 128 72 80 176 80 211.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,192a24,24,0,0,1,48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224V192a24,24,0,0,0-48,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "128",
      "x2": "153.8",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4R = [];
/* style */

const __vue_inject_styles__$4R = undefined;
/* scoped */

const __vue_scope_id__$4R = undefined;
/* module identifier */

const __vue_module_identifier__$4R = undefined;
/* functional template */

const __vue_is_functional_template__$4R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4R,
  staticRenderFns: __vue_staticRenderFns__$4R
}, __vue_inject_styles__$4R, __vue_script__$4R, __vue_scope_id__$4R, __vue_is_functional_template__$4R, __vue_module_identifier__$4R, false, undefined, undefined, undefined);

var script$4Q = Vue.extend({
  name: "PhPencilLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4Q = script$4Q;
/* template */

var __vue_render__$4Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "156",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "72",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.5 160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,76.7,179.3,32a15.9,15.9,0,0,0-22.6,0L36.7,152a15.4,15.4,0,0,0-3.6,5.5l-.2.5a16,16,0,0,0-.9,5.3V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.3L224,99.3A16.1,16.1,0,0,0,224,76.7Zm-80-9.4L160.7,84,68,176.7,51.3,160ZM48,208V179.3L76.7,208Zm48-3.3L79.3,188,172,95.3,188.7,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.5 160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.5 160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 216 96 216 40.5 160.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "92",
      "x2": "68",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4Q = [];
/* style */

const __vue_inject_styles__$4Q = undefined;
/* scoped */

const __vue_scope_id__$4Q = undefined;
/* module identifier */

const __vue_module_identifier__$4Q = undefined;
/* functional template */

const __vue_is_functional_template__$4Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4Q,
  staticRenderFns: __vue_staticRenderFns__$4Q
}, __vue_inject_styles__$4Q, __vue_script__$4Q, __vue_scope_id__$4Q, __vue_is_functional_template__$4Q, __vue_module_identifier__$4Q, false, undefined, undefined, undefined);

var script$4P = Vue.extend({
  name: "PhPencilSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4P = script$4P;
/* template */

var __vue_render__$4P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,64l56,56,26.3-26.3a8,8,0,0,0,0-11.4L173.7,37.7a8,8,0,0,0-11.4,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,76.7,179.7,32.3a16.6,16.6,0,0,0-11.3-5A16,16,0,0,0,156.7,32L130.3,58.3h0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H92.7a16.1,16.1,0,0,0,11.3-4.7l120-120A16.1,16.1,0,0,0,224,76.7Zm-32,32L147.3,64,168,43.3,212.7,88Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4P = [];
/* style */

const __vue_inject_styles__$4P = undefined;
/* scoped */

const __vue_scope_id__$4P = undefined;
/* module identifier */

const __vue_module_identifier__$4P = undefined;
/* functional template */

const __vue_is_functional_template__$4P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4P,
  staticRenderFns: __vue_staticRenderFns__$4P
}, __vue_inject_styles__$4P, __vue_script__$4P, __vue_scope_id__$4P, __vue_is_functional_template__$4P, __vue_module_identifier__$4P, false, undefined, undefined, undefined);

var script$4O = Vue.extend({
  name: "PhPencilSimpleLine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4O = script$4O;
/* template */

var __vue_render__$4O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,208H115.3l82.4-82.3h0L224,99.3a15.9,15.9,0,0,0,0-22.6L179.3,32a16.1,16.1,0,0,0-22.6,0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16ZM48,163.3l96-96L188.7,112l-96,96H48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "64",
      "x2": "192",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4O = [];
/* style */

const __vue_inject_styles__$4O = undefined;
/* scoped */

const __vue_scope_id__$4O = undefined;
/* module identifier */

const __vue_module_identifier__$4O = undefined;
/* functional template */

const __vue_is_functional_template__$4O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4O,
  staticRenderFns: __vue_staticRenderFns__$4O
}, __vue_inject_styles__$4O, __vue_script__$4O, __vue_scope_id__$4O, __vue_is_functional_template__$4O, __vue_module_identifier__$4O, false, undefined, undefined, undefined);

var script$4N = Vue.extend({
  name: "PhPercent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4N = script$4N;
/* template */

var __vue_render__$4N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.7,61.7l-144,144a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l144-144a8.1,8.1,0,0,1,11.4,11.4ZM50.5,101.5a36.2,36.2,0,0,1,0-51,36.2,36.2,0,0,1,51,0,36.1,36.1,0,0,1-51,51ZM56,76a19.7,19.7,0,0,0,5.9,14.1,19.9,19.9,0,0,0,28.2,0,19.8,19.8,0,0,0,0-28.2h0a19.8,19.8,0,0,0-28.2,0A19.7,19.7,0,0,0,56,76ZM216,180a36,36,0,1,1-61.5-25.5,36.2,36.2,0,0,1,51,0A35.9,35.9,0,0,1,216,180Zm-16,0a19.7,19.7,0,0,0-5.9-14.1,19.8,19.8,0,0,0-28.2,0A19.9,19.9,0,1,0,200,180Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4N = [];
/* style */

const __vue_inject_styles__$4N = undefined;
/* scoped */

const __vue_scope_id__$4N = undefined;
/* module identifier */

const __vue_module_identifier__$4N = undefined;
/* functional template */

const __vue_is_functional_template__$4N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4N,
  staticRenderFns: __vue_staticRenderFns__$4N
}, __vue_inject_styles__$4N, __vue_script__$4N, __vue_scope_id__$4N, __vue_is_functional_template__$4N, __vue_module_identifier__$4N, false, undefined, undefined, undefined);

var script$4M = Vue.extend({
  name: "PhPerson",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4M = script$4M;
/* template */

var __vue_render__$4M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M211.7,139.5,172.3,88.9l-.6-.7A27.8,27.8,0,0,0,151.9,80h-48a27.8,27.8,0,0,0-19.8,8.2l-.7.7L44.1,139.5a20,20,0,0,0,28.3,28.3l14.1-11L66.6,219.5a20.2,20.2,0,0,0-.4,14.7,19.9,19.9,0,0,0,10.4,11.3,19.6,19.6,0,0,0,15.2.7,20.2,20.2,0,0,0,11.1-9.8l25-39.4,25,39.4a20.4,20.4,0,0,0,11,9.8,20.9,20.9,0,0,0,6.9,1.2,19.1,19.1,0,0,0,8.4-1.9,20.2,20.2,0,0,0,10.4-11.3,19.7,19.7,0,0,0-.5-14.7l-19.8-62.7,14.1,11a20,20,0,0,0,27.9-.4,19.7,19.7,0,0,0,5.8-14.1A19.9,19.9,0,0,0,211.7,139.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "44",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4M = [];
/* style */

const __vue_inject_styles__$4M = undefined;
/* scoped */

const __vue_scope_id__$4M = undefined;
/* module identifier */

const __vue_module_identifier__$4M = undefined;
/* functional template */

const __vue_is_functional_template__$4M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4M,
  staticRenderFns: __vue_staticRenderFns__$4M
}, __vue_inject_styles__$4M, __vue_script__$4M, __vue_scope_id__$4M, __vue_is_functional_template__$4M, __vue_module_identifier__$4M, false, undefined, undefined, undefined);

var script$4L = Vue.extend({
  name: "PhPersonSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4L = script$4L;
/* template */

var __vue_render__$4L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,132s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M95.9,48a32,32,0,1,1,32,32A32,32,0,0,1,95.9,48Zm132.2,73.1C226.4,120.1,185.6,96,128,96S29.6,120.1,27.9,121.1a8,8,0,0,0,8.2,13.8c.4-.3,34.9-20.6,83.9-22.7V149L58,218.7a8,8,0,0,0,12,10.6L128,164l58,65.3a8,8,0,0,0,6,2.7,8.1,8.1,0,0,0,5.3-2,8,8,0,0,0,.7-11.3L136,149V112.2c48.8,2.1,83.5,22.4,83.9,22.7A8.7,8.7,0,0,0,224,136a8,8,0,0,0,4.1-14.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "127.9",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "64 224 128 152 192 224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128s40-24,96-24,96,24,96,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4L = [];
/* style */

const __vue_inject_styles__$4L = undefined;
/* scoped */

const __vue_scope_id__$4L = undefined;
/* module identifier */

const __vue_module_identifier__$4L = undefined;
/* functional template */

const __vue_is_functional_template__$4L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4L,
  staticRenderFns: __vue_staticRenderFns__$4L
}, __vue_inject_styles__$4L, __vue_script__$4L, __vue_scope_id__$4L, __vue_is_functional_template__$4L, __vue_module_identifier__$4L, false, undefined, undefined, undefined);

var script$4K = Vue.extend({
  name: "PhPersonSimpleRun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4K = script$4K;
/* template */

var __vue_render__$4K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,109.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,161.2C128.5,165,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.7,120.4C121.8,149.4,91.8,206,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.1,108.8C130.7,129.2,101.6,207,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,161.2C128.5,165,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,56a32,32,0,1,1,32,32A32.1,32.1,0,0,1,120,56Zm104,77.6a8,8,0,0,0-8-8,7.8,7.8,0,0,0-3.7.9h.1c-.1,0-6.5,3.1-18.2,1.9s-29.5-6.4-53.3-25.1c-15-11.7-38.3-24.6-64.4-19.6C60.7,86.7,51.6,94.8,50.6,95.7a7.9,7.9,0,0,0-.5,11.3,8,8,0,0,0,11.3.5c1.1-1,25.8-22.4,64.6,4.6a147.9,147.9,0,0,1-21.9,44.4h0l-2.4,3.1c-18.9,24.2-42.1,35-68.9,32.3a8,8,0,1,0-1.6,16c3.3.3,6.4.4,9.5.4,32.6,0,56.6-17.4,73.2-38.3,19.4,5.2,54.1,20.2,54.1,61.9a8,8,0,0,0,16,0c0-24.7-10.1-45.4-29.2-59.9-10.4-7.9-22-12.8-31.2-15.8a164.5,164.5,0,0,0,16-34.1c25.8,17.9,46.2,22.3,60,22.3s19.5-3.5,20.1-3.9h0A7.8,7.8,0,0,0,224,133.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.1,108.8C130.7,129.2,101.6,207,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,161.2C128.5,165,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.1,108.8C130.7,129.2,101.6,207,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,161.2C128.5,165,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "56",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M135.1,108.8C130.7,129.2,101.6,207,32,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.6,161.2C128.5,165,176,180,176,232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4K = [];
/* style */

const __vue_inject_styles__$4K = undefined;
/* scoped */

const __vue_scope_id__$4K = undefined;
/* module identifier */

const __vue_module_identifier__$4K = undefined;
/* functional template */

const __vue_is_functional_template__$4K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4K,
  staticRenderFns: __vue_staticRenderFns__$4K
}, __vue_inject_styles__$4K, __vue_script__$4K, __vue_scope_id__$4K, __vue_is_functional_template__$4K, __vue_module_identifier__$4K, false, undefined, undefined, undefined);

var script$4J = Vue.extend({
  name: "PhPersonSimpleWalk",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4J = script$4J;
/* template */

var __vue_render__$4J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,132s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.5 145.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128.3",
      "y1": "102.6",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.5",
      "y1": "97.4",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.5 145.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,48a32,32,0,1,1,32,32A32.1,32.1,0,0,1,120,48Zm88,88c-28.5,0-41.7-14.1-55.6-29.1-3.5-3.8-7.2-7.7-11-11.2-37.2-34.4-96.5,24.1-99.1,26.6a8.1,8.1,0,1,0,11.4,11.4,157.3,157.3,0,0,1,30.5-23.2c14.3-8.2,26.3-11.1,35.7-8.8l-17.7,40.7h0L64.7,228.8a7.9,7.9,0,0,0,4.1,10.5,7.1,7.1,0,0,0,3.2.7,7.9,7.9,0,0,0,7.3-4.8l33.6-77.3L144,180.1V232a8,8,0,0,0,16,0V176a7.8,7.8,0,0,0-3.4-6.5l-37.1-26.6,14.1-32.5,7.1,7.4C154.9,133,172.5,152,208,152a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.5",
      "y1": "97.4",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.5 145.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.5",
      "y1": "97.4",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.5 145.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "152",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.5",
      "y1": "97.4",
      "x2": "72",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 232 152 176 109.5 145.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4J = [];
/* style */

const __vue_inject_styles__$4J = undefined;
/* scoped */

const __vue_scope_id__$4J = undefined;
/* module identifier */

const __vue_module_identifier__$4J = undefined;
/* functional template */

const __vue_is_functional_template__$4J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4J,
  staticRenderFns: __vue_staticRenderFns__$4J
}, __vue_inject_styles__$4J, __vue_script__$4J, __vue_scope_id__$4J, __vue_is_functional_template__$4J, __vue_module_identifier__$4J, false, undefined, undefined, undefined);

var script$4I = Vue.extend({
  name: "PhPerspective",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4I = script$4I;
/* template */

var __vue_render__$4I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,120v16H16a8,8,0,0,1,0-16Zm0,57.3a16,16,0,0,0,13.1,15.8l160,29.1h0l2.9.2a16.5,16.5,0,0,0,10.3-3.7,16.1,16.1,0,0,0,5.7-12.3V136H32ZM240,120H224v16h16a8,8,0,0,0,0-16ZM224,49.6a16.1,16.1,0,0,0-5.7-12.3,16.6,16.6,0,0,0-13.2-3.5L45.1,62.9A16,16,0,0,0,32,78.7V120H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4I = [];
/* style */

const __vue_inject_styles__$4I = undefined;
/* scoped */

const __vue_scope_id__$4I = undefined;
/* module identifier */

const __vue_module_identifier__$4I = undefined;
/* functional template */

const __vue_is_functional_template__$4I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4I,
  staticRenderFns: __vue_staticRenderFns__$4I
}, __vue_inject_styles__$4I, __vue_script__$4I, __vue_scope_id__$4I, __vue_is_functional_template__$4I, __vue_module_identifier__$4I, false, undefined, undefined, undefined);

var script$4H = Vue.extend({
  name: "PhPhone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4H = script$4H;
/* template */

var __vue_render__$4H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4H = [];
/* style */

const __vue_inject_styles__$4H = undefined;
/* scoped */

const __vue_scope_id__$4H = undefined;
/* module identifier */

const __vue_module_identifier__$4H = undefined;
/* functional template */

const __vue_is_functional_template__$4H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4H,
  staticRenderFns: __vue_staticRenderFns__$4H
}, __vue_inject_styles__$4H, __vue_script__$4H, __vue_scope_id__$4H, __vue_is_functional_template__$4H, __vue_module_identifier__$4H, false, undefined, undefined, undefined);

var script$4G = Vue.extend({
  name: "PhPhoneCall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4G = script$4G;
/* template */

var __vue_render__$4G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.4,40A80.1,80.1,0,0,1,216,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.2,78A44.1,44.1,0,0,1,178,106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.4,40A80.1,80.1,0,0,1,216,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.1,70.9a47.9,47.9,0,0,1,34,34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157.4,47.7a72.6,72.6,0,0,1,50.9,50.9,8,8,0,0,0,7.7,6,7.6,7.6,0,0,0,2.1-.3,7.9,7.9,0,0,0,5.6-9.8,88,88,0,0,0-62.2-62.2,8,8,0,1,0-4.1,15.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.1,78.6a40.4,40.4,0,0,1,28.3,28.3,7.9,7.9,0,0,0,7.7,6,6.4,6.4,0,0,0,2-.3,7.9,7.9,0,0,0,5.7-9.8,55.8,55.8,0,0,0-39.6-39.6,8,8,0,1,0-4.1,15.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.4,40A80.1,80.1,0,0,1,216,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.1,70.9a47.9,47.9,0,0,1,34,34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.4,40A80.1,80.1,0,0,1,216,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.1,70.9a47.9,47.9,0,0,1,34,34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M159.4,40A80.1,80.1,0,0,1,216,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.1,70.9a47.9,47.9,0,0,1,34,34",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4G = [];
/* style */

const __vue_inject_styles__$4G = undefined;
/* scoped */

const __vue_scope_id__$4G = undefined;
/* module identifier */

const __vue_module_identifier__$4G = undefined;
/* functional template */

const __vue_is_functional_template__$4G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4G,
  staticRenderFns: __vue_staticRenderFns__$4G
}, __vue_inject_styles__$4G, __vue_script__$4G, __vue_scope_id__$4G, __vue_is_functional_template__$4G, __vue_module_identifier__$4G, false, undefined, undefined, undefined);

var script$4F = Vue.extend({
  name: "PhPhoneDisconnect",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4F = script$4F;
/* template */

var __vue_render__$4F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.8,90.2C173.7,34,82.3,34,26.2,90.2a56.1,56.1,0,0,0-4.7,73.9,16.2,16.2,0,0,0,12.6,6.1,17.1,17.1,0,0,0,5.9-1.1l47.4-19a16,16,0,0,0,9.7-11.7l5.9-29.5a76.3,76.3,0,0,1,49.7-.1h0l6.2,29.7a15.9,15.9,0,0,0,9.7,11.6l47.4,19a16.1,16.1,0,0,0,18.5-5A56.1,56.1,0,0,0,229.8,90.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,192H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "200",
      "x2": "216",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4F = [];
/* style */

const __vue_inject_styles__$4F = undefined;
/* scoped */

const __vue_scope_id__$4F = undefined;
/* module identifier */

const __vue_module_identifier__$4F = undefined;
/* functional template */

const __vue_is_functional_template__$4F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4F,
  staticRenderFns: __vue_staticRenderFns__$4F
}, __vue_inject_styles__$4F, __vue_script__$4F, __vue_scope_id__$4F, __vue_is_functional_template__$4F, __vue_module_identifier__$4F, false, undefined, undefined, undefined);

var script$4E = Vue.extend({
  name: "PhPhoneIncoming",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4E = script$4E;
/* template */

var __vue_render__$4E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,97.1a.9.9,0,0,0,.1.5v.3a.8.8,0,0,1,.1.4l.2.4c0,.1.1.2.1.4l.2.3c0,.1.1.2.1.4l.2.3.3.3.2.3a.8.8,0,0,0,.2.4c.1.1.3.2.4.4a.3.3,0,0,1,.1.2h.2l.4.4.4.2.3.3.3.2.3.2h.4l.3.2h.4l.4.2H200a8,8,0,0,0,0-16H179.3l34.4-34.3a8.1,8.1,0,0,0-11.4-11.4L168,76.7V56a8,8,0,0,0-16,0V96.8A.4.4,0,0,1,152.1,97.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "160 56 160 96 200 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4E = [];
/* style */

const __vue_inject_styles__$4E = undefined;
/* scoped */

const __vue_scope_id__$4E = undefined;
/* module identifier */

const __vue_module_identifier__$4E = undefined;
/* functional template */

const __vue_is_functional_template__$4E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4E,
  staticRenderFns: __vue_staticRenderFns__$4E
}, __vue_inject_styles__$4E, __vue_script__$4E, __vue_scope_id__$4E, __vue_is_functional_template__$4E, __vue_module_identifier__$4E, false, undefined, undefined, undefined);

var script$4D = Vue.extend({
  name: "PhPhoneOutgoing",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4D = script$4D;
/* template */

var __vue_render__$4D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.6,175.1A56.2,56.2,0,0,1,176,224C96.6,224,32,159.4,32,80A56.2,56.2,0,0,1,80.9,24.4,16.3,16.3,0,0,1,97.6,34l20.1,46.9A15.9,15.9,0,0,1,116.3,96L99.7,121.4h0a76.5,76.5,0,0,0,35.2,35L160,139.7a15.6,15.6,0,0,1,15.1-1.3l46.9,20A16.3,16.3,0,0,1,231.6,175.1ZM160,104a8.5,8.5,0,0,0,5.7-2.3L200,67.3V88a8,8,0,0,0,16,0V48a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h20.7L154.3,90.3a8.1,8.1,0,0,0,0,11.4A8.5,8.5,0,0,0,160,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4D = [];
/* style */

const __vue_inject_styles__$4D = undefined;
/* scoped */

const __vue_scope_id__$4D = undefined;
/* module identifier */

const __vue_module_identifier__$4D = undefined;
/* functional template */

const __vue_is_functional_template__$4D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4D,
  staticRenderFns: __vue_staticRenderFns__$4D
}, __vue_inject_styles__$4D, __vue_script__$4D, __vue_scope_id__$4D, __vue_is_functional_template__$4D, __vue_module_identifier__$4D, false, undefined, undefined, undefined);

var script$4C = Vue.extend({
  name: "PhPhoneSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4C = script$4C;
/* template */

var __vue_render__$4C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.2,72a136,136,0,0,1,93,39.8,48,48,0,0,1,4,63.3,5.8,5.8,0,0,1-1.8,1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.4,117.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,117.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120.9,108.3h-.1L89.8,74h-.1L53.9,34.6A8,8,0,0,0,42.1,45.4L70,76.1a143.9,143.9,0,0,0-43.8,30.1,56.1,56.1,0,0,0-4.7,73.9,16.2,16.2,0,0,0,12.6,6.1,17.1,17.1,0,0,0,5.9-1.1l47.4-19a16,16,0,0,0,9.7-11.7l5.9-29.5a72.1,72.1,0,0,1,9.1-2.5l90,99A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M229.8,106.2a144.4,144.4,0,0,0-109.7-42,8,8,0,0,0-5.5,13.4L209,181.4a7.2,7.2,0,0,0,2.9,2l4.1,1.7a17.1,17.1,0,0,0,5.9,1.1,16.2,16.2,0,0,0,12.6-6.1A56.1,56.1,0,0,0,229.8,106.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4C = [];
/* style */

const __vue_inject_styles__$4C = undefined;
/* scoped */

const __vue_scope_id__$4C = undefined;
/* module identifier */

const __vue_module_identifier__$4C = undefined;
/* functional template */

const __vue_is_functional_template__$4C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4C,
  staticRenderFns: __vue_staticRenderFns__$4C
}, __vue_inject_styles__$4C, __vue_script__$4C, __vue_scope_id__$4C, __vue_is_functional_template__$4C, __vue_module_identifier__$4C, false, undefined, undefined, undefined);

var script$4B = Vue.extend({
  name: "PhPhoneX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4B = script$4B;
/* template */

var __vue_render__$4B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,101.7a8.2,8.2,0,0,0,11.4,0L184,83.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L195.3,72l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L184,60.7,165.7,42.3a8.1,8.1,0,0,0-11.4,11.4L172.7,72,154.3,90.3A8.1,8.1,0,0,0,154.3,101.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "48",
      "x2": "208",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "48",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4B = [];
/* style */

const __vue_inject_styles__$4B = undefined;
/* scoped */

const __vue_scope_id__$4B = undefined;
/* module identifier */

const __vue_module_identifier__$4B = undefined;
/* functional template */

const __vue_is_functional_template__$4B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4B,
  staticRenderFns: __vue_staticRenderFns__$4B
}, __vue_inject_styles__$4B, __vue_script__$4B, __vue_scope_id__$4B, __vue_is_functional_template__$4B, __vue_module_identifier__$4B, false, undefined, undefined, undefined);

var script$4A = Vue.extend({
  name: "PhPhosphorLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4A = script$4A;
/* template */

var __vue_render__$4A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a65.9,65.9,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "68 32 68 164 134 164 68 32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a65.9,65.9,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M142,24H68a8,8,0,0,0-8,8V164a74.1,74.1,0,0,0,74,74,8,8,0,0,0,8-8V172a74,74,0,0,0,0-148ZM126,221.5A58.1,58.1,0,0,1,76.6,172H126Zm0-91.4L80.9,40H126ZM142,156V40a58,58,0,0,1,0,116Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a65.9,65.9,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a65.9,65.9,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "68",
      "y1": "32",
      "x2": "134",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "32",
      "width": "66",
      "height": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164v66a65.9,65.9,0,0,1-66-66",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134,164h8a66,66,0,0,0,0-132h-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4A = [];
/* style */

const __vue_inject_styles__$4A = undefined;
/* scoped */

const __vue_scope_id__$4A = undefined;
/* module identifier */

const __vue_module_identifier__$4A = undefined;
/* functional template */

const __vue_is_functional_template__$4A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4A,
  staticRenderFns: __vue_staticRenderFns__$4A
}, __vue_inject_styles__$4A, __vue_script__$4A, __vue_scope_id__$4A, __vue_is_functional_template__$4A, __vue_module_identifier__$4A, false, undefined, undefined, undefined);

var script$4z = Vue.extend({
  name: "PhPianoKeys",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4z = script$4z;
/* template */

var __vue_render__$4z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "216",
      "x2": "100",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "216",
      "x2": "156",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 176 144 128 144 128 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 40 128 144 80 144 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "216",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "216",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 40 184 144 144 144 144 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 40 112 144 72 144 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "40",
      "width": "40",
      "height": "104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "40",
      "width": "40",
      "height": "104",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM108,152a8,8,0,0,0,8-8V48h24v96a8,8,0,0,0,8,8h8v56H100V152ZM48,48H68v96a8,8,0,0,0,8,8h8v56H48ZM208,208H172V152h8a8,8,0,0,0,8-8V48h20V208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "216",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "216",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 40 184 144 144 144 144 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 40 112 144 72 144 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "216",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "216",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 40 184 144 144 144 144 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 40 112 144 72 144 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "216",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "216",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 40 184 144 144 144 144 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112 40 112 144 72 144 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4z = [];
/* style */

const __vue_inject_styles__$4z = undefined;
/* scoped */

const __vue_scope_id__$4z = undefined;
/* module identifier */

const __vue_module_identifier__$4z = undefined;
/* functional template */

const __vue_is_functional_template__$4z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4z,
  staticRenderFns: __vue_staticRenderFns__$4z
}, __vue_inject_styles__$4z, __vue_script__$4z, __vue_scope_id__$4z, __vue_is_functional_template__$4z, __vue_module_identifier__$4z, false, undefined, undefined, undefined);

var script$4y = Vue.extend({
  name: "PhPictureInPicture",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4y = script$4y;
/* template */

var __vue_render__$4y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,56H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8h96V136a8,8,0,0,1,8-8h80V64A8,8,0,0,0,216,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,64H216v56H144a16,16,0,0,0-16,16v56H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,200V136a8,8,0,0,1,8-8h80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4y = [];
/* style */

const __vue_inject_styles__$4y = undefined;
/* scoped */

const __vue_scope_id__$4y = undefined;
/* module identifier */

const __vue_module_identifier__$4y = undefined;
/* functional template */

const __vue_is_functional_template__$4y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4y,
  staticRenderFns: __vue_staticRenderFns__$4y
}, __vue_inject_styles__$4y, __vue_script__$4y, __vue_scope_id__$4y, __vue_is_functional_template__$4y, __vue_module_identifier__$4y, false, undefined, undefined, undefined);

var script$4x = Vue.extend({
  name: "PhPill",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4x = script$4x;
/* template */

var __vue_render__$4x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.9",
      "y": "82.7",
      "width": "226.3",
      "height": "90.51",
      "rx": "45.3",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.1",
      "y1": "104.1",
      "x2": "176.5",
      "y2": "88.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,208a45.2,45.2,0,0,1-64,0h0a45.2,45.2,0,0,1,0-64L96,96l64,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.9",
      "y": "82.7",
      "width": "226.3",
      "height": "90.51",
      "rx": "45.3",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.1",
      "y1": "112.1",
      "x2": "184.5",
      "y2": "88.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,42.3a53.4,53.4,0,0,0-75.4,0l-96,96a53.3,53.3,0,0,0,75.4,75.4l96-96A53.5,53.5,0,0,0,213.7,42.3Zm-11.4,64L160,148.7,107.3,96l42.4-42.3a36.9,36.9,0,0,1,52.6,0A37.1,37.1,0,0,1,202.3,106.3ZM190.2,82.9a7.9,7.9,0,0,1-.2,11.3l-24.4,23.6a7.9,7.9,0,0,1-11.3-.2,7.9,7.9,0,0,1,.2-11.3l24.4-23.6A8,8,0,0,1,190.2,82.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.9",
      "y": "82.7",
      "width": "226.3",
      "height": "90.51",
      "rx": "45.3",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.1",
      "y1": "112.1",
      "x2": "184.5",
      "y2": "88.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.9",
      "y": "82.7",
      "width": "226.3",
      "height": "90.51",
      "rx": "45.3",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.1",
      "y1": "112.1",
      "x2": "184.5",
      "y2": "88.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "14.9",
      "y": "82.7",
      "width": "226.3",
      "height": "90.51",
      "rx": "45.3",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "160",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160.1",
      "y1": "112.1",
      "x2": "184.5",
      "y2": "88.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4x = [];
/* style */

const __vue_inject_styles__$4x = undefined;
/* scoped */

const __vue_scope_id__$4x = undefined;
/* module identifier */

const __vue_module_identifier__$4x = undefined;
/* functional template */

const __vue_is_functional_template__$4x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4x,
  staticRenderFns: __vue_staticRenderFns__$4x
}, __vue_inject_styles__$4x, __vue_script__$4x, __vue_scope_id__$4x, __vue_is_functional_template__$4x, __vue_module_identifier__$4x, false, undefined, undefined, undefined);

var script$4w = Vue.extend({
  name: "PhPinterestLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4w = script$4w;
/* template */

var __vue_render__$4w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "88",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "88",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,131.2c-1.7,54.5-45.8,98.9-100.3,100.7a103.7,103.7,0,0,1-28.6-2.9,4.1,4.1,0,0,1-2.9-4.9l8.9-35.4A50.5,50.5,0,0,0,136,196c37,0,66.7-33.5,63.8-73.4-2.6-35.9-32-64.6-68-66.5A72,72,0,0,0,56,128a73.3,73.3,0,0,0,5.2,27,8,8,0,0,0,14.9-6A55.5,55.5,0,0,1,72,128.9a56,56,0,1,1,112-.9c0,28.7-21.5,52-48,52-10.5,0-17.8-3.7-22.8-8l14.6-58.1a8,8,0,1,0-15.6-3.8L85.4,217.5a4,4,0,0,1-5.7,2.6A104,104,0,1,1,232,131.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "88",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "88",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "88",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4w = [];
/* style */

const __vue_inject_styles__$4w = undefined;
/* scoped */

const __vue_scope_id__$4w = undefined;
/* module identifier */

const __vue_module_identifier__$4w = undefined;
/* functional template */

const __vue_is_functional_template__$4w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4w,
  staticRenderFns: __vue_staticRenderFns__$4w
}, __vue_inject_styles__$4w, __vue_script__$4w, __vue_scope_id__$4w, __vue_is_functional_template__$4w, __vue_module_identifier__$4w, false, undefined, undefined, undefined);

var script$4v = Vue.extend({
  name: "PhPinwheel",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4v = script$4v;
/* template */

var __vue_render__$4v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.5",
      "y1": "164.5",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.5",
      "y1": "164.5",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,218.3l-48.4-48.4,3.3-1a59.6,59.6,0,0,0,33.9-31.1,60.4,60.4,0,0,0,2-45.9,8.4,8.4,0,0,0-4.2-4.5,7.6,7.6,0,0,0-6.1-.2l-44.4,16.1,1-2A60,60,0,0,0,91.9,19.5a8.4,8.4,0,0,0-4.5,4.2,7.6,7.6,0,0,0-.2,6.1l16.1,44.4-2-1a60,60,0,0,0-81.8,74.9,8.4,8.4,0,0,0,4.2,4.5,7.7,7.7,0,0,0,3.4.7,6.5,6.5,0,0,0,2.7-.5l44.4-16.1-1,2a60,60,0,0,0,54.3,85.4,61.2,61.2,0,0,0,20.6-3.6,8.4,8.4,0,0,0,4.5-4.2,7.6,7.6,0,0,0,.2-6.1l-16.1-44.4,2,1a59.6,59.6,0,0,0,22.4,5.6l57.2,57.3a8.2,8.2,0,0,0,11.4,0A8.1,8.1,0,0,0,229.7,218.3ZM131.1,36a44.2,44.2,0,0,1,3.7,77.9L105.2,32.5A43.8,43.8,0,0,1,131.1,36ZM108.9,204a44.2,44.2,0,0,1-3.7-77.9l29.6,81.4A43.8,43.8,0,0,1,108.9,204Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.5",
      "y1": "164.5",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.5",
      "y1": "164.5",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164.5",
      "y1": "164.5",
      "x2": "224",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4v = [];
/* style */

const __vue_inject_styles__$4v = undefined;
/* scoped */

const __vue_scope_id__$4v = undefined;
/* module identifier */

const __vue_module_identifier__$4v = undefined;
/* functional template */

const __vue_is_functional_template__$4v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4v,
  staticRenderFns: __vue_staticRenderFns__$4v
}, __vue_inject_styles__$4v, __vue_script__$4v, __vue_scope_id__$4v, __vue_is_functional_template__$4v, __vue_module_identifier__$4v, false, undefined, undefined, undefined);

var script$4u = Vue.extend({
  name: "PhPizza",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4u = script$4u;
/* template */

var __vue_render__$4u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.1,103.4a135.9,135.9,0,0,1,173.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M159.4,190.7a28,28,0,1,1,29.1-45.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.7,132.7A28,28,0,0,1,108,152a28.1,28.1,0,0,1-19.1,26.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,156a28,28,0,0,1,49.1-18.4l26.2-41a144.1,144.1,0,0,0-182.6,0l21.2,33.3A28,28,0,1,1,84,168H82.1l39.2,61.5a7.9,7.9,0,0,0,13.4,0l29.6-46.5A28,28,0,0,1,144,156Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,182.9a28,28,0,1,1,28.8-45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.9,129.8A28,28,0,1,1,84,168H82.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.3,80a16,16,0,0,0-4.2-21.6,183.9,183.9,0,0,0-214.2,0A16,16,0,0,0,16.7,80h0l97.8,153.7a16,16,0,0,0,27,0l58.4-91.8h.1ZM23.4,75.7ZM128,225.1l-32.5-51A36,36,0,0,0,84,104a35.6,35.6,0,0,0-26,11.1L47.4,98.5a135.8,135.8,0,0,1,161.2,0l-17.3,27.1a36,36,0,0,0-38.6,60.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,182.9a28,28,0,1,1,28.8-45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.9,129.8A28,28,0,1,1,84,168H82.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,182.9a28,28,0,1,1,28.8-45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.9,129.8A28,28,0,1,1,84,168H82.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,182.9a28,28,0,1,1,28.8-45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.9,129.8A28,28,0,1,1,84,168H82.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4u = [];
/* style */

const __vue_inject_styles__$4u = undefined;
/* scoped */

const __vue_scope_id__$4u = undefined;
/* module identifier */

const __vue_module_identifier__$4u = undefined;
/* functional template */

const __vue_is_functional_template__$4u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4u,
  staticRenderFns: __vue_staticRenderFns__$4u
}, __vue_inject_styles__$4u, __vue_script__$4u, __vue_scope_id__$4u, __vue_is_functional_template__$4u, __vue_module_identifier__$4u, false, undefined, undefined, undefined);

var script$4t = Vue.extend({
  name: "PhPlaceholder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4t = script$4t;
/* template */

var __vue_render__$4t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM187.3,187.3a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4L68.7,80A8,8,0,1,1,80,68.7L187.3,176A8,8,0,0,1,187.3,187.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4t = [];
/* style */

const __vue_inject_styles__$4t = undefined;
/* scoped */

const __vue_scope_id__$4t = undefined;
/* module identifier */

const __vue_module_identifier__$4t = undefined;
/* functional template */

const __vue_is_functional_template__$4t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4t,
  staticRenderFns: __vue_staticRenderFns__$4t
}, __vue_inject_styles__$4t, __vue_script__$4t, __vue_scope_id__$4t, __vue_is_functional_template__$4t, __vue_module_identifier__$4t, false, undefined, undefined, undefined);

var script$4s = Vue.extend({
  name: "PhPlanet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4s = script$4s;
/* template */

var __vue_render__$4s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.5,61.6c30.1-8.9,52.9-8.8,59.4,2.4,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.4-11.2,4.9-31,27.7-52.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.3,116a117.3,117.3,0,0,1,.7,12A96,96,0,0,1,70,204.5c24.6-6.2,53.5-18.5,82-34.9S205.6,134.2,223.3,116Zm22.5-56c-5.5-9.5-20.3-18.4-59.8-8.5A96,96,0,0,0,32,128a117.3,117.3,0,0,0,.7,12C4.4,169.2,4.8,186.5,10.2,196c3.7,6.4,11.9,12.8,29.8,12.8a121.7,121.7,0,0,0,25.5-3.2l4.5-1.1a105,105,0,0,1-14.2-13.3c-18.7,3.3-29.3,1-31.7-3.2-1.5-2.6-.7-7.5,2.3-13.4A85.7,85.7,0,0,1,37.1,159a95.2,95.2,0,0,0,18.7,32.2l6.2-1.3c24-5.3,53.1-17.5,82-34.2s54-35.8,70.6-53.9a62,62,0,0,0,4.3-4.8,95.2,95.2,0,0,0-18.7-32.2,83.9,83.9,0,0,1,19-1.5c6.6.4,11.2,2.1,12.7,4.7,2.4,4.2-.9,14.5-13,29a107.3,107.3,0,0,1,4.4,19l3.1-3.3C251.7,85.2,250.9,68.9,245.8,60Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4s = [];
/* style */

const __vue_inject_styles__$4s = undefined;
/* scoped */

const __vue_scope_id__$4s = undefined;
/* module identifier */

const __vue_module_identifier__$4s = undefined;
/* functional template */

const __vue_is_functional_template__$4s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4s,
  staticRenderFns: __vue_staticRenderFns__$4s
}, __vue_inject_styles__$4s, __vue_script__$4s, __vue_scope_id__$4s, __vue_is_functional_template__$4s, __vue_module_identifier__$4s, false, undefined, undefined, undefined);

var script$4r = Vue.extend({
  name: "PhPlay",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4r = script$4r;
/* template */

var __vue_render__$4r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232.3,114.3,88.3,26.4a15.5,15.5,0,0,0-16.1-.3A15.8,15.8,0,0,0,64,40V216a15.8,15.8,0,0,0,8.2,13.9,15.5,15.5,0,0,0,16.1-.3l144-87.9a16,16,0,0,0,0-27.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4r = [];
/* style */

const __vue_inject_styles__$4r = undefined;
/* scoped */

const __vue_scope_id__$4r = undefined;
/* module identifier */

const __vue_module_identifier__$4r = undefined;
/* functional template */

const __vue_is_functional_template__$4r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4r,
  staticRenderFns: __vue_staticRenderFns__$4r
}, __vue_inject_styles__$4r, __vue_script__$4r, __vue_scope_id__$4r, __vue_is_functional_template__$4r, __vue_module_identifier__$4r, false, undefined, undefined, undefined);

var script$4q = Vue.extend({
  name: "PhPlayCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4q = script$4q;
/* template */

var __vue_render__$4q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "156 128 116 100 116 156 156 128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM112,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36.4,110.7-48,32A8.7,8.7,0,0,1,112,168a8.5,8.5,0,0,1-3.8-.9A8,8,0,0,1,104,160V96a8,8,0,0,1,4.2-7.1,8.3,8.3,0,0,1,8.2.4l48,32a8,8,0,0,1,0,13.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4q = [];
/* style */

const __vue_inject_styles__$4q = undefined;
/* scoped */

const __vue_scope_id__$4q = undefined;
/* module identifier */

const __vue_module_identifier__$4q = undefined;
/* functional template */

const __vue_is_functional_template__$4q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4q,
  staticRenderFns: __vue_staticRenderFns__$4q
}, __vue_inject_styles__$4q, __vue_script__$4q, __vue_scope_id__$4q, __vue_is_functional_template__$4q, __vue_module_identifier__$4q, false, undefined, undefined, undefined);

var script$4p = Vue.extend({
  name: "PhPlaylist",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4p = script$4p;
/* template */

var __vue_render__$4p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H160a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm72,48H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm130.3-67.7-40-12a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,192,112v52.3A32,32,0,1,0,208,192V122.8l29.7,8.9a8,8,0,1,0,4.6-15.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 192 200 112 240 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4p = [];
/* style */

const __vue_inject_styles__$4p = undefined;
/* scoped */

const __vue_scope_id__$4p = undefined;
/* module identifier */

const __vue_module_identifier__$4p = undefined;
/* functional template */

const __vue_is_functional_template__$4p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4p,
  staticRenderFns: __vue_staticRenderFns__$4p
}, __vue_inject_styles__$4p, __vue_script__$4p, __vue_scope_id__$4p, __vue_is_functional_template__$4p, __vue_module_identifier__$4p, false, undefined, undefined, undefined);

var script$4o = Vue.extend({
  name: "PhPlug",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4o = script$4o;
/* template */

var __vue_render__$4o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "32",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "184",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "72",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "144",
      "x2": "112",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "32",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "184",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "72",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "144",
      "x2": "112",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,77.7,203.3,112l26.4,26.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-6.3-6.4L160.3,195a40.1,40.1,0,0,1-56.6,0L88,179.3,37.7,229.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,61,152.3a40.1,40.1,0,0,1,0-56.6L112.7,44l-6.4-6.3a8.1,8.1,0,0,1,11.4-11.4L144,52.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4L155.3,64,192,100.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "32",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "184",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "72",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "144",
      "x2": "112",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "32",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "184",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "72",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "144",
      "x2": "112",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "32",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "64",
      "x2": "184",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "72",
      "x2": "192",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "144",
      "x2": "112",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4o = [];
/* style */

const __vue_inject_styles__$4o = undefined;
/* scoped */

const __vue_scope_id__$4o = undefined;
/* module identifier */

const __vue_module_identifier__$4o = undefined;
/* functional template */

const __vue_is_functional_template__$4o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4o,
  staticRenderFns: __vue_staticRenderFns__$4o
}, __vue_inject_styles__$4o, __vue_script__$4o, __vue_scope_id__$4o, __vue_is_functional_template__$4o, __vue_module_identifier__$4o, false, undefined, undefined, undefined);

var script$4n = Vue.extend({
  name: "PhPlugs",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4n = script$4n;
/* template */

var __vue_render__$4n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "200",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "148",
      "x2": "120",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "148",
      "x2": "120",
      "y2": "168",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "116",
      "x2": "88",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "116",
      "x2": "88",
      "y2": "136",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "68",
      "x2": "188",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "116",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "200",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "68",
      "x2": "188",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "116",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,29.7,211.3,56l5.4,5.4a31.9,31.9,0,0,1,0,45.2L191.3,132l2.4,2.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-8-8h0l-56-56h0l-8-8a8.1,8.1,0,0,1,11.4-11.4l2.3,2.4,25.4-25.4a31.9,31.9,0,0,1,45.2,0l5.4,5.4,26.3-26.4a8.1,8.1,0,0,1,11.4,11.4ZM138.3,138.3,120,156.7,99.3,136l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L88,124.7l-6.3-6.4h0l-8-8a8.1,8.1,0,0,0-11.4,11.4l2.4,2.3L39.3,149.4a31.9,31.9,0,0,0,0,45.2l5.4,5.4L18.3,226.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L56,211.3l5.4,5.4a31.9,31.9,0,0,0,45.2,0L132,191.3l2.3,2.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4l-8-8h0l-6.4-6.3,18.4-18.3a8.1,8.1,0,0,0-11.4-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "200",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "68",
      "x2": "188",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "116",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "200",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "68",
      "x2": "188",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "116",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "200",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "120",
      "y2": "168",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "112",
      "x2": "88",
      "y2": "136",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "68",
      "x2": "188",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "68",
      "y1": "116",
      "x2": "140",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4n = [];
/* style */

const __vue_inject_styles__$4n = undefined;
/* scoped */

const __vue_scope_id__$4n = undefined;
/* module identifier */

const __vue_module_identifier__$4n = undefined;
/* functional template */

const __vue_is_functional_template__$4n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4n,
  staticRenderFns: __vue_staticRenderFns__$4n
}, __vue_inject_styles__$4n, __vue_script__$4n, __vue_scope_id__$4n, __vue_is_functional_template__$4n, __vue_module_identifier__$4n, false, undefined, undefined, undefined);

var script$4m = Vue.extend({
  name: "PhPlugsConnected",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4m = script$4m;
/* template */

var __vue_render__$4m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "28",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "28",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "92",
      "x2": "164",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "212",
      "x2": "161.3",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "94.7",
      "y1": "28",
      "x2": "100",
      "y2": "44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "156",
      "x2": "228",
      "y2": "161.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "94.7",
      "x2": "44",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "92",
      "x2": "164",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "160",
      "x2": "200",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "104",
      "x2": "32",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "32",
      "x2": "104",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,18.3a8.1,8.1,0,0,0-11.4,0L176,68.7l-5.4-5.4a31.9,31.9,0,0,0-45.2,0L100,88.7l-2.3-2.4A8.1,8.1,0,0,0,86.3,97.7l2.4,2.3L63.3,125.4a31.9,31.9,0,0,0,0,45.2l5.4,5.4L18.3,226.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L80,187.3l5.4,5.4a32.1,32.1,0,0,0,45.2,0L156,167.3l2.3,2.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4l-2.4-2.3,25.4-25.4a31.9,31.9,0,0,0,0-45.2L187.3,80l50.4-50.3A8.1,8.1,0,0,0,237.7,18.3Zm-56.3,101L156,144.7,111.3,100l25.4-25.4a15.9,15.9,0,0,1,22.6,0l22.1,22.1a15.9,15.9,0,0,1,0,22.6Zm50.2,43.2A7.9,7.9,0,0,1,224,168a7.3,7.3,0,0,1-2.5-.4l-24-8a8,8,0,1,1,5-15.2l24,8A8,8,0,0,1,231.6,162.5ZM24.4,93.5a8,8,0,0,1,10.1-5.1l24,8A8,8,0,0,1,56,112a7.3,7.3,0,0,1-2.5-.4l-24-8A8,8,0,0,1,24.4,93.5Zm64-59a8,8,0,0,1,15.2-5l8,24a8,8,0,0,1-5.1,10.1,7.3,7.3,0,0,1-2.5.4,7.9,7.9,0,0,1-7.6-5.5Zm79.2,187a8,8,0,0,1-5.1,10.1,7.3,7.3,0,0,1-2.5.4,7.9,7.9,0,0,1-7.6-5.5l-8-24a8,8,0,1,1,15.2-5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "92",
      "x2": "164",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "160",
      "x2": "200",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "104",
      "x2": "32",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "32",
      "x2": "104",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "92",
      "x2": "164",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "160",
      "x2": "200",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "104",
      "x2": "32",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "32",
      "x2": "104",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "176",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "24",
      "x2": "176",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.1",
      "y": "88.4",
      "width": "135.8",
      "height": "79.2",
      "rx": "24",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "92",
      "x2": "164",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "160",
      "x2": "200",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "104",
      "x2": "32",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "32",
      "x2": "104",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "200",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4m = [];
/* style */

const __vue_inject_styles__$4m = undefined;
/* scoped */

const __vue_scope_id__$4m = undefined;
/* module identifier */

const __vue_module_identifier__$4m = undefined;
/* functional template */

const __vue_is_functional_template__$4m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4m,
  staticRenderFns: __vue_staticRenderFns__$4m
}, __vue_inject_styles__$4m, __vue_script__$4m, __vue_scope_id__$4m, __vue_is_functional_template__$4m, __vue_module_identifier__$4m, false, undefined, undefined, undefined);

var script$4l = Vue.extend({
  name: "PhPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4l = script$4l;
/* template */

var __vue_render__$4l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,120H136V40a8,8,0,0,0-16,0v80H40a8,8,0,0,0,0,16h80v80a8,8,0,0,0,16,0V136h80a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4l = [];
/* style */

const __vue_inject_styles__$4l = undefined;
/* scoped */

const __vue_scope_id__$4l = undefined;
/* module identifier */

const __vue_module_identifier__$4l = undefined;
/* functional template */

const __vue_is_functional_template__$4l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4l,
  staticRenderFns: __vue_staticRenderFns__$4l
}, __vue_inject_styles__$4l, __vue_script__$4l, __vue_scope_id__$4l, __vue_is_functional_template__$4l, __vue_module_identifier__$4l, false, undefined, undefined, undefined);

var script$4k = Vue.extend({
  name: "PhPlusCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4k = script$4k;
/* template */

var __vue_render__$4k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "128",
      "x2": "168",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "88",
      "x2": "128",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4k = [];
/* style */

const __vue_inject_styles__$4k = undefined;
/* scoped */

const __vue_scope_id__$4k = undefined;
/* module identifier */

const __vue_module_identifier__$4k = undefined;
/* functional template */

const __vue_is_functional_template__$4k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4k,
  staticRenderFns: __vue_staticRenderFns__$4k
}, __vue_inject_styles__$4k, __vue_script__$4k, __vue_scope_id__$4k, __vue_is_functional_template__$4k, __vue_module_identifier__$4k, false, undefined, undefined, undefined);

var script$4j = Vue.extend({
  name: "PhPlusMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4j = script$4j;
/* template */

var __vue_render__$4j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.7,50.3a8.1,8.1,0,0,0-11.4,0l-144,144a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0l144-144A8.1,8.1,0,0,0,205.7,50.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,176H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "72",
      "x2": "112",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "32",
      "x2": "72",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4j = [];
/* style */

const __vue_inject_styles__$4j = undefined;
/* scoped */

const __vue_scope_id__$4j = undefined;
/* module identifier */

const __vue_module_identifier__$4j = undefined;
/* functional template */

const __vue_is_functional_template__$4j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4j,
  staticRenderFns: __vue_staticRenderFns__$4j
}, __vue_inject_styles__$4j, __vue_script__$4j, __vue_scope_id__$4j, __vue_is_functional_template__$4j, __vue_module_identifier__$4j, false, undefined, undefined, undefined);

var script$4i = Vue.extend({
  name: "PhPokerChip",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4i = script$4i;
/* template */

var __vue_render__$4i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "94.1",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "94.1",
      "y1": "161.9",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "161.9",
      "y1": "161.9",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "161.9",
      "y1": "94.1",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm0,152a56,56,0,1,1,56-56A56,56,0,0,1,128,184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "88.4",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "167.6",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "88.4",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.2,200.8a103.8,103.8,0,0,0,0-145.6,2.3,2.3,0,0,0-.7-.7,2.3,2.3,0,0,0-.7-.7,103.8,103.8,0,0,0-145.6,0,2.3,2.3,0,0,0-.7.7,2.3,2.3,0,0,0-.7.7,103.8,103.8,0,0,0,0,145.6l.7.7a2.3,2.3,0,0,0,.7.7,103.8,103.8,0,0,0,145.6,0,2.3,2.3,0,0,0,.7-.7A2.3,2.3,0,0,0,202.2,200.8ZM40.4,136H64.5a63.6,63.6,0,0,0,13,31.2L60.4,184.3A87.5,87.5,0,0,1,40.4,136Zm20-64.3L77.5,88.8a63.6,63.6,0,0,0-13,31.2H40.4A87.5,87.5,0,0,1,60.4,71.7ZM215.6,120H191.5a63.6,63.6,0,0,0-13-31.2l17.1-17.1A87.5,87.5,0,0,1,215.6,120ZM167.2,77.5a63.6,63.6,0,0,0-31.2-13V40.4a87.5,87.5,0,0,1,48.3,20ZM120,64.5a63.6,63.6,0,0,0-31.2,13L71.7,60.4a87.5,87.5,0,0,1,48.3-20Zm-31.2,114a63.6,63.6,0,0,0,31.2,13v24.1a87.5,87.5,0,0,1-48.3-20Zm47.2,13a63.6,63.6,0,0,0,31.2-13l17.1,17.1a87.5,87.5,0,0,1-48.3,20Zm42.5-24.3a63.6,63.6,0,0,0,13-31.2h24.1a87.5,87.5,0,0,1-20,48.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "88.4",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "167.6",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "88.4",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "88.4",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "167.6",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "88.4",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "88.4",
      "x2": "60.1",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "128",
      "x2": "32",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88.4",
      "y1": "167.6",
      "x2": "60.1",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "167.6",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "167.6",
      "y1": "88.4",
      "x2": "195.9",
      "y2": "60.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4i = [];
/* style */

const __vue_inject_styles__$4i = undefined;
/* scoped */

const __vue_scope_id__$4i = undefined;
/* module identifier */

const __vue_module_identifier__$4i = undefined;
/* functional template */

const __vue_is_functional_template__$4i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4i,
  staticRenderFns: __vue_staticRenderFns__$4i
}, __vue_inject_styles__$4i, __vue_script__$4i, __vue_scope_id__$4i, __vue_is_functional_template__$4i, __vue_module_identifier__$4i, false, undefined, undefined, undefined);

var script$4h = Vue.extend({
  name: "PhPoliceCar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4h = script$4h;
/* template */

var __vue_render__$4h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "124",
      "x2": "244",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,124,194.4,71.7a8.1,8.1,0,0,0-6.8-3.7H68.4a8.1,8.1,0,0,0-6.8,3.7L28,124v48H228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "28",
      "x2": "152",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,172v32a8,8,0,0,1-8,8H196a8,8,0,0,1-8-8V172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,172v32a8,8,0,0,1-8,8H36a8,8,0,0,1-8-8V172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "32",
      "x2": "152",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,32a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,32Zm152,88a8,8,0,0,1-8,8h-8v80a16,16,0,0,1-16,16H192a16,16,0,0,1-16-16V192H80v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V128H16a8,8,0,0,1,0-16H27.4L54.8,64.1A15.9,15.9,0,0,1,68.6,56H187.4a15.9,15.9,0,0,1,13.8,8.1L228.6,112H240A8,8,0,0,1,248,120ZM88,152a8,8,0,0,0-8-8H64a8,8,0,0,0,0,16H80A8,8,0,0,0,88,152Zm112,0a8,8,0,0,0-8-8H176a8,8,0,0,0,0,16h16A8,8,0,0,0,200,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "32",
      "x2": "152",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "32",
      "x2": "152",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "32",
      "x2": "152",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4h = [];
/* style */

const __vue_inject_styles__$4h = undefined;
/* scoped */

const __vue_scope_id__$4h = undefined;
/* module identifier */

const __vue_module_identifier__$4h = undefined;
/* functional template */

const __vue_is_functional_template__$4h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4h,
  staticRenderFns: __vue_staticRenderFns__$4h
}, __vue_inject_styles__$4h, __vue_script__$4h, __vue_scope_id__$4h, __vue_is_functional_template__$4h, __vue_module_identifier__$4h, false, undefined, undefined, undefined);

var script$4g = Vue.extend({
  name: "PhPolygon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4g = script$4g;
/* template */

var __vue_render__$4g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.8",
      "y1": "65.7",
      "x2": "143.2",
      "y2": "54.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "64.1",
      "x2": "57.8",
      "y2": "103.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.4",
      "y1": "134.2",
      "x2": "140.6",
      "y2": "193.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "185.4",
      "x2": "200",
      "y2": "94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.8",
      "y1": "65.7",
      "x2": "143.2",
      "y2": "54.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "64.1",
      "x2": "57.8",
      "y2": "103.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.4",
      "y1": "134.2",
      "x2": "140.6",
      "y2": "193.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "185.4",
      "x2": "200",
      "y2": "94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M230.6,49.4a31.9,31.9,0,0,0-45.2,0h0a30.2,30.2,0,0,0-5.2,6.7L152,48.4a32,32,0,0,0-54.6-23h0a32,32,0,0,0-5.8,37.4L57.7,93.3a32,32,0,0,0-40.3,4.1h0a31.9,31.9,0,0,0,0,45.2A31.6,31.6,0,0,0,40,152a32.1,32.1,0,0,0,20.3-7.2l70,51.3a32,32,0,0,0,7.1,34.5,31.9,31.9,0,0,0,45.2,0,31.9,31.9,0,0,0,0-45.2,43.3,43.3,0,0,0-4.7-4l27.3-77.5H208a31.6,31.6,0,0,0,22.6-9.4A31.9,31.9,0,0,0,230.6,49.4ZM162.8,176.1a32.4,32.4,0,0,0-23.1,7.1l-70-51.3a32.4,32.4,0,0,0-1.3-26.7l33.9-30.5A32.4,32.4,0,0,0,120,80a31.6,31.6,0,0,0,22.6-9.4,30.2,30.2,0,0,0,5.2-6.7L176,71.6a31.6,31.6,0,0,0,9.4,23,43.3,43.3,0,0,0,4.7,4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.8",
      "y1": "65.7",
      "x2": "143.2",
      "y2": "54.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "64.1",
      "x2": "57.8",
      "y2": "103.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.4",
      "y1": "134.2",
      "x2": "140.6",
      "y2": "193.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "185.4",
      "x2": "200",
      "y2": "94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.8",
      "y1": "65.7",
      "x2": "143.2",
      "y2": "54.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "64.1",
      "x2": "57.8",
      "y2": "103.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.4",
      "y1": "134.2",
      "x2": "140.6",
      "y2": "193.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "185.4",
      "x2": "200",
      "y2": "94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "48",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "120",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "208",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "208",
      "cy": "72",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.8",
      "y1": "65.7",
      "x2": "143.2",
      "y2": "54.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.2",
      "y1": "64.1",
      "x2": "57.8",
      "y2": "103.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "59.4",
      "y1": "134.2",
      "x2": "140.6",
      "y2": "193.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "185.4",
      "x2": "200",
      "y2": "94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4g = [];
/* style */

const __vue_inject_styles__$4g = undefined;
/* scoped */

const __vue_scope_id__$4g = undefined;
/* module identifier */

const __vue_module_identifier__$4g = undefined;
/* functional template */

const __vue_is_functional_template__$4g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4g,
  staticRenderFns: __vue_staticRenderFns__$4g
}, __vue_inject_styles__$4g, __vue_script__$4g, __vue_scope_id__$4g, __vue_is_functional_template__$4g, __vue_module_identifier__$4g, false, undefined, undefined, undefined);

var script$4f = Vue.extend({
  name: "PhPopcorn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4f = script$4f;
/* template */

var __vue_render__$4f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "96",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "96",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,216,88,96,45.1,83.7a8.1,8.1,0,0,0-10,9.6L62.5,209.8a8.1,8.1,0,0,0,7.8,6.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.7,216a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,152,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "96",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "96",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.1,79.9l-.3-.4A43.9,43.9,0,0,0,168,41.7a44,44,0,0,0-80,0A43.9,43.9,0,0,0,32.2,79.5l-.3.4a15.7,15.7,0,0,0-4.6,15.2L54.8,211.7A15.9,15.9,0,0,0,70.3,224H185.7a15.9,15.9,0,0,0,15.5-12.3L228.7,95.1A15.7,15.7,0,0,0,224.1,79.9ZM76,56a27.4,27.4,0,0,1,13.1,3.3,8.4,8.4,0,0,0,7.1.2,8.2,8.2,0,0,0,4.5-5.6,28,28,0,0,1,54.6,0,8.2,8.2,0,0,0,4.5,5.6,8.4,8.4,0,0,0,7.1-.2A27.4,27.4,0,0,1,180,56a28,28,0,0,1,27,20.5L168.4,87.6,133.9,73.8a15.1,15.1,0,0,0-11.8,0L87.6,87.6,49,76.5A28,28,0,0,1,76,56ZM42.9,91.4h0l37.9,10.9L94.9,208H70.3ZM185.7,208H161.1l14.1-105.7,37.9-10.9h0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "96",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "96",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "96",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "96",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "96",
      "x2": "104",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "96",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4f = [];
/* style */

const __vue_inject_styles__$4f = undefined;
/* scoped */

const __vue_scope_id__$4f = undefined;
/* module identifier */

const __vue_module_identifier__$4f = undefined;
/* functional template */

const __vue_is_functional_template__$4f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4f,
  staticRenderFns: __vue_staticRenderFns__$4f
}, __vue_inject_styles__$4f, __vue_script__$4f, __vue_scope_id__$4f, __vue_is_functional_template__$4f, __vue_module_identifier__$4f, false, undefined, undefined, undefined);

var script$4e = Vue.extend({
  name: "PhPower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4e = script$4e;
/* template */

var __vue_render__$4e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,54.2a88,88,0,1,1-96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,54.2a88,88,0,1,1-96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-8,32a8,8,0,0,1,16,0v60a8,8,0,0,1-16,0Zm8,152A80,80,0,0,1,83.5,61.5a8,8,0,0,1,8.9,13.3,64.1,64.1,0,1,0,71.1,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.2A80,80,0,0,1,128,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,54.2a88,88,0,1,1-96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,54.2a88,88,0,1,1-96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,54.2a88,88,0,1,1-96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4e = [];
/* style */

const __vue_inject_styles__$4e = undefined;
/* scoped */

const __vue_scope_id__$4e = undefined;
/* module identifier */

const __vue_module_identifier__$4e = undefined;
/* functional template */

const __vue_is_functional_template__$4e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4e,
  staticRenderFns: __vue_staticRenderFns__$4e
}, __vue_inject_styles__$4e, __vue_script__$4e, __vue_scope_id__$4e, __vue_is_functional_template__$4e, __vue_module_identifier__$4e, false, undefined, undefined, undefined);

var script$4d = Vue.extend({
  name: "PhPrescription",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4d = script$4d;
/* template */

var __vue_render__$4d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M183.3,188l22.4-22.3a8.1,8.1,0,0,0-11.4-11.4L172,176.7,130.3,135A52,52,0,0,0,120,32H72a8,8,0,0,0-8,8V192a8,8,0,0,0,16,0V136h28.7l52,52-22.4,22.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L172,199.3l22.3,22.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM80,48h40a36,36,0,0,1,0,72H80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,128h48a44,44,0,0,0,0-88H72V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "160",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4d = [];
/* style */

const __vue_inject_styles__$4d = undefined;
/* scoped */

const __vue_scope_id__$4d = undefined;
/* module identifier */

const __vue_module_identifier__$4d = undefined;
/* functional template */

const __vue_is_functional_template__$4d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4d,
  staticRenderFns: __vue_staticRenderFns__$4d
}, __vue_inject_styles__$4d, __vue_script__$4d, __vue_scope_id__$4d, __vue_is_functional_template__$4d, __vue_module_identifier__$4d, false, undefined, undefined, undefined);

var script$4c = Vue.extend({
  name: "PhPresentation",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4c = script$4c;
/* template */

var __vue_render__$4c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.4L57.8,219A8,8,0,0,0,64,232a7.8,7.8,0,0,0,6.2-3l29.6-37h56.4l29.6,37a7.8,7.8,0,0,0,6.2,3,8,8,0,0,0,6.2-13l-21.6-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4c = [];
/* style */

const __vue_inject_styles__$4c = undefined;
/* scoped */

const __vue_scope_id__$4c = undefined;
/* module identifier */

const __vue_module_identifier__$4c = undefined;
/* functional template */

const __vue_is_functional_template__$4c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4c,
  staticRenderFns: __vue_staticRenderFns__$4c
}, __vue_inject_styles__$4c, __vue_script__$4c, __vue_scope_id__$4c, __vue_is_functional_template__$4c, __vue_module_identifier__$4c, false, undefined, undefined, undefined);

var script$4b = Vue.extend({
  name: "PhPresentationChart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4b = script$4b;
/* template */

var __vue_render__$4b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92",
      "y1": "120",
      "x2": "92",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "88",
      "x2": "164",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.4L57.8,219A8,8,0,0,0,64,232a7.8,7.8,0,0,0,6.2-3l29.6-37h56.4l29.6,37a7.8,7.8,0,0,0,6.2,3,8,8,0,0,0,6.2-13l-21.6-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "184",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "184",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "120",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "88",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4b = [];
/* style */

const __vue_inject_styles__$4b = undefined;
/* scoped */

const __vue_scope_id__$4b = undefined;
/* module identifier */

const __vue_module_identifier__$4b = undefined;
/* functional template */

const __vue_is_functional_template__$4b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4b,
  staticRenderFns: __vue_staticRenderFns__$4b
}, __vue_inject_styles__$4b, __vue_script__$4b, __vue_scope_id__$4b, __vue_is_functional_template__$4b, __vue_module_identifier__$4b, false, undefined, undefined, undefined);

var script$4a = Vue.extend({
  name: "PhPrinter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4a = script$4a;
/* template */

var __vue_render__$4a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "40",
      "width": "128",
      "height": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "156",
      "width": "128",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.7,80H45.3C35.8,80,28,87.2,28,96v80H64V152H192v24h36V96C228,87.2,220.2,80,210.7,80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "40",
      "width": "128",
      "height": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "152",
      "width": "128",
      "height": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.7,72H200V40a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8V72H45.3C31.4,72,20,82.8,20,96v80a8,8,0,0,0,8,8H56v36a8,8,0,0,0,8,8H192a8,8,0,0,0,8-8V184h28a8,8,0,0,0,8-8V96C236,82.8,224.6,72,210.7,72ZM72,48H184V72H72ZM184,212H72V160H184Zm4-84a12,12,0,1,1,12-12A12,12,0,0,1,188,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 80 64 40 192 40 192 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "152",
      "width": "128",
      "height": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 80 64 40 192 40 192 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "152",
      "width": "128",
      "height": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "64 80 64 40 192 40 192 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "152",
      "width": "128",
      "height": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4a = [];
/* style */

const __vue_inject_styles__$4a = undefined;
/* scoped */

const __vue_scope_id__$4a = undefined;
/* module identifier */

const __vue_module_identifier__$4a = undefined;
/* functional template */

const __vue_is_functional_template__$4a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4a,
  staticRenderFns: __vue_staticRenderFns__$4a
}, __vue_inject_styles__$4a, __vue_script__$4a, __vue_scope_id__$4a, __vue_is_functional_template__$4a, __vue_module_identifier__$4a, false, undefined, undefined, undefined);

var script$49 = Vue.extend({
  name: "PhProhibit",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$49 = script$49;
/* template */

var __vue_render__$49 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,128a71.3,71.3,0,0,1-15.8,44.9L83.1,71.8A71.3,71.3,0,0,1,128,56,72.1,72.1,0,0,1,200,128ZM56,128a72.1,72.1,0,0,0,72,72,71.3,71.3,0,0,0,44.9-15.8L71.8,83.1A71.3,71.3,0,0,0,56,128Zm180,0A108,108,0,1,1,128,20,108.1,108.1,0,0,1,236,128Zm-20,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "195.9",
      "y2": "195.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$49 = [];
/* style */

const __vue_inject_styles__$49 = undefined;
/* scoped */

const __vue_scope_id__$49 = undefined;
/* module identifier */

const __vue_module_identifier__$49 = undefined;
/* functional template */

const __vue_is_functional_template__$49 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$49 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$49,
  staticRenderFns: __vue_staticRenderFns__$49
}, __vue_inject_styles__$49, __vue_script__$49, __vue_scope_id__$49, __vue_is_functional_template__$49, __vue_module_identifier__$49, false, undefined, undefined, undefined);

var script$48 = Vue.extend({
  name: "PhProhibitInset",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$48 = script$48;
/* template */

var __vue_render__$48 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "156.3",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "156.3",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm22.6,137.9L94.1,105.4a8,8,0,0,1,11.3-11.3l56.5,56.5a8,8,0,0,1-11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "156.3",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "156.3",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "99.7",
      "y1": "99.7",
      "x2": "156.3",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$48 = [];
/* style */

const __vue_inject_styles__$48 = undefined;
/* scoped */

const __vue_scope_id__$48 = undefined;
/* module identifier */

const __vue_module_identifier__$48 = undefined;
/* functional template */

const __vue_is_functional_template__$48 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$48 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$48,
  staticRenderFns: __vue_staticRenderFns__$48
}, __vue_inject_styles__$48, __vue_script__$48, __vue_scope_id__$48, __vue_is_functional_template__$48, __vue_module_identifier__$48, false, undefined, undefined, undefined);

var script$47 = Vue.extend({
  name: "PhProjectorScreen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$47 = script$47;
/* template */

var __vue_render__$47 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "72",
      "width": "160",
      "height": "112",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V64A16,16,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.4a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16,16,0,0,0,232,64ZM128,240a8,8,0,1,1,8-8A8,8,0,0,1,128,240ZM40,48H216V64H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$47 = [];
/* style */

const __vue_inject_styles__$47 = undefined;
/* scoped */

const __vue_scope_id__$47 = undefined;
/* module identifier */

const __vue_module_identifier__$47 = undefined;
/* functional template */

const __vue_is_functional_template__$47 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$47 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$47,
  staticRenderFns: __vue_staticRenderFns__$47
}, __vue_inject_styles__$47, __vue_script__$47, __vue_scope_id__$47, __vue_is_functional_template__$47, __vue_module_identifier__$47, false, undefined, undefined, undefined);

var script$46 = Vue.extend({
  name: "PhProjectorScreenChart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$46 = script$46;
/* template */

var __vue_render__$46 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92",
      "y1": "128",
      "x2": "92",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "124",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "120",
      "x2": "164",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "176",
      "x2": "48",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "80",
      "x2": "208",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "40",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "176",
      "x2": "224",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "72",
      "width": "160",
      "height": "112",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V64A16,16,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.4a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16,16,0,0,0,232,64ZM104,144a8,8,0,0,1-16,0V128a8,8,0,0,1,16,0Zm24,96a8,8,0,1,1,8-8A8,8,0,0,1,128,240Zm8-96a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM40,64V48H216V64H40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "184",
      "x2": "48",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "72",
      "x2": "208",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "120",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "112",
      "x2": "160",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "40",
      "width": "192",
      "height": "32",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "232",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "184",
      "x2": "224",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$46 = [];
/* style */

const __vue_inject_styles__$46 = undefined;
/* scoped */

const __vue_scope_id__$46 = undefined;
/* module identifier */

const __vue_module_identifier__$46 = undefined;
/* functional template */

const __vue_is_functional_template__$46 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$46 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$46,
  staticRenderFns: __vue_staticRenderFns__$46
}, __vue_inject_styles__$46, __vue_script__$46, __vue_scope_id__$46, __vue_is_functional_template__$46, __vue_module_identifier__$46, false, undefined, undefined, undefined);

var script$45 = Vue.extend({
  name: "PhPushPin",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$45 = script$45;
/* template */

var __vue_render__$45 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,107.3l-58.5,58.5c4.5,12.7,6.4,33.9-13.2,60a16.3,16.3,0,0,1-11.7,6.4h-1.1a16.1,16.1,0,0,1-11.3-4.7L88,179.3,53.7,213.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,28.3,119.6a15.9,15.9,0,0,1,1.3-23.8C55,75.3,79.3,79.4,90,82.7L148.7,24h0a16.1,16.1,0,0,1,22.6,0L232,84.7a15.9,15.9,0,0,1,0,22.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$45 = [];
/* style */

const __vue_inject_styles__$45 = undefined;
/* scoped */

const __vue_scope_id__$45 = undefined;
/* module identifier */

const __vue_module_identifier__$45 = undefined;
/* functional template */

const __vue_is_functional_template__$45 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$45 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$45,
  staticRenderFns: __vue_staticRenderFns__$45
}, __vue_inject_styles__$45, __vue_script__$45, __vue_scope_id__$45, __vue_is_functional_template__$45, __vue_module_identifier__$45, false, undefined, undefined, undefined);

var script$44 = Vue.extend({
  name: "PhPushPinSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$44 = script$44;
/* template */

var __vue_render__$44 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 176 80 40 176 40 200 176 56 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,176a8,8,0,0,1-8,8H136v56a8,8,0,0,1-16,0V184H40a8,8,0,0,1,0-16h9.3L70.5,48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16h-6.5l21.2,120H216A8,8,0,0,1,224,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "176",
      "x2": "216",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "80",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$44 = [];
/* style */

const __vue_inject_styles__$44 = undefined;
/* scoped */

const __vue_scope_id__$44 = undefined;
/* module identifier */

const __vue_module_identifier__$44 = undefined;
/* functional template */

const __vue_is_functional_template__$44 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$44 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$44,
  staticRenderFns: __vue_staticRenderFns__$44
}, __vue_inject_styles__$44, __vue_script__$44, __vue_scope_id__$44, __vue_is_functional_template__$44, __vue_module_identifier__$44, false, undefined, undefined, undefined);

var script$43 = Vue.extend({
  name: "PhPushPinSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$43 = script$43;
/* template */

var __vue_render__$43 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.6",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.8",
      "y2": "69.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102.1",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "193.8",
      "y2": "140.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "56 176 80 40 176 40 200 176 56 176",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "91.2",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.4",
      "y2": "155.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.6",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.8",
      "y2": "69.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.4,221.9A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-34-37.4H136v56a8,8,0,0,1-16,0V184H40a8,8,0,0,1,0-16h9.3L66.2,72,42.1,45.4A8,8,0,0,1,53.9,34.6l75.2,82.8,48.5,53.2h0l36.3,40A7.9,7.9,0,0,1,213.4,221.9Zm-22.9-60.8a7.9,7.9,0,0,0,5.9,2.6,8.5,8.5,0,0,0,3.5-.8,8.1,8.1,0,0,0,4.4-8.6L185.5,48H192a8,8,0,0,0,0-16H91.2A8,8,0,0,0,86,34a9.4,9.4,0,0,0-1,1,8.3,8.3,0,0,0-1.7,4.5,1.1,1.1,0,0,0,0,.8,7.9,7.9,0,0,0,2,5.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.2",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.4",
      "y2": "155.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.6",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.8",
      "y2": "69.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.2",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.4",
      "y2": "155.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.6",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.8",
      "y2": "69.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "91.2",
      "y1": "40",
      "x2": "192",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "40",
      "x2": "196.4",
      "y2": "155.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "171.6",
      "y1": "176",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "74.8",
      "y2": "69.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$43 = [];
/* style */

const __vue_inject_styles__$43 = undefined;
/* scoped */

const __vue_scope_id__$43 = undefined;
/* module identifier */

const __vue_module_identifier__$43 = undefined;
/* functional template */

const __vue_is_functional_template__$43 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$43 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$43,
  staticRenderFns: __vue_staticRenderFns__$43
}, __vue_inject_styles__$43, __vue_script__$43, __vue_scope_id__$43, __vue_is_functional_template__$43, __vue_module_identifier__$43, false, undefined, undefined, undefined);

var script$42 = Vue.extend({
  name: "PhPushPinSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$42 = script$42;
/* template */

var __vue_render__$42 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,137.4l35.7-35.7a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L122,62",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-26.4-29.1c-2.5,14.2-9.9,26.2-15.4,33.5a16.3,16.3,0,0,1-11.7,6.4h-1.1a16.1,16.1,0,0,1-11.3-4.7L88,179.3,53.7,213.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,28.3,119.6a15.9,15.9,0,0,1,1.3-23.8C45.8,82.8,61.5,79.7,73.5,80L42.1,45.4A8,8,0,0,1,53.9,34.6ZM232,84.7,171.3,24a16.1,16.1,0,0,0-22.6,0l-38,38a8,8,0,0,0-.3,11L179,148.4a8.1,8.1,0,0,0,5.7,2.7h.2a8,8,0,0,0,5.7-2.4L232,107.3a15.9,15.9,0,0,0,0-22.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "168",
      "x2": "48",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$42 = [];
/* style */

const __vue_inject_styles__$42 = undefined;
/* scoped */

const __vue_scope_id__$42 = undefined;
/* module identifier */

const __vue_module_identifier__$42 = undefined;
/* functional template */

const __vue_is_functional_template__$42 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$42 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$42,
  staticRenderFns: __vue_staticRenderFns__$42
}, __vue_inject_styles__$42, __vue_script__$42, __vue_scope_id__$42, __vue_is_functional_template__$42, __vue_module_identifier__$42, false, undefined, undefined, undefined);

var script$41 = Vue.extend({
  name: "PhPuzzlePiece",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$41 = script$41;
/* template */

var __vue_render__$41 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.8,224H208a16,16,0,0,0,16-16V170.3a7.9,7.9,0,0,0-3.6-6.6,7.7,7.7,0,0,0-7.5-.7,24.3,24.3,0,0,1-8.9,1.7c-13.2,0-24-11.1-24-24.7s10.8-24.7,24-24.7a24.3,24.3,0,0,1,8.9,1.7,7.7,7.7,0,0,0,7.5-.7,7.9,7.9,0,0,0,3.6-6.6V72a16,16,0,0,0-16-16H171.8c.1-1.3.2-2.7.2-4a36,36,0,0,0-72,0c0,1.3.1,2.7.2,4H64A16,16,0,0,0,48,72v32.2l-4-.2a36,36,0,0,0,0,72l4-.2V208a16,16,0,0,0,16,16h42.2"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$41 = [];
/* style */

const __vue_inject_styles__$41 = undefined;
/* scoped */

const __vue_scope_id__$41 = undefined;
/* module identifier */

const __vue_module_identifier__$41 = undefined;
/* functional template */

const __vue_is_functional_template__$41 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$41 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$41,
  staticRenderFns: __vue_staticRenderFns__$41
}, __vue_inject_styles__$41, __vue_script__$41, __vue_scope_id__$41, __vue_is_functional_template__$41, __vue_module_identifier__$41, false, undefined, undefined, undefined);

var script$40 = Vue.extend({
  name: "PhQrCode",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$40 = script$40;
/* template */

var __vue_render__$40 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "60",
      "height": "60",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "148",
      "width": "60",
      "height": "60",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148",
      "y": "48",
      "width": "60",
      "height": "60",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "148",
      "x2": "148",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "148 208 184 208 184 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "164",
      "x2": "208",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 208 176 208 176 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "192",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,184a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8,8,0,0,0,144,184Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,152H184v-8a8,8,0,0,0-16,0v56H144a8,8,0,0,0,0,16h32a8,8,0,0,0,8-8V168h24a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8,8,0,0,0,208,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 208 176 208 176 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "192",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 208 176 208 176 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "192",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "144",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 208 176 208 176 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "160",
      "x2": "208",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "192",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$40 = [];
/* style */

const __vue_inject_styles__$40 = undefined;
/* scoped */

const __vue_scope_id__$40 = undefined;
/* module identifier */

const __vue_module_identifier__$40 = undefined;
/* functional template */

const __vue_is_functional_template__$40 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$40 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$40,
  staticRenderFns: __vue_staticRenderFns__$40
}, __vue_inject_styles__$40, __vue_script__$40, __vue_scope_id__$40, __vue_is_functional_template__$40, __vue_module_identifier__$40, false, undefined, undefined, undefined);

var script$3$ = Vue.extend({
  name: "PhQuestion",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3$ = script$3$;
/* template */

var __vue_render__$3$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,136a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.9v.9a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,144v-8a28,28,0,1,0-28-28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3$ = [];
/* style */

const __vue_inject_styles__$3$ = undefined;
/* scoped */

const __vue_scope_id__$3$ = undefined;
/* module identifier */

const __vue_module_identifier__$3$ = undefined;
/* functional template */

const __vue_is_functional_template__$3$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3$,
  staticRenderFns: __vue_staticRenderFns__$3$
}, __vue_inject_styles__$3$, __vue_script__$3$, __vue_scope_id__$3$, __vue_is_functional_template__$3$, __vue_module_identifier__$3$, false, undefined, undefined, undefined);

var script$3_ = Vue.extend({
  name: "PhQueue",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3_ = script$3_;
/* template */

var __vue_render__$3_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm108.2-30.8-64-40A8,8,0,0,0,168,120v80a8.1,8.1,0,0,0,4.1,7,8,8,0,0,0,8.1-.2l64-40a8,8,0,0,0,0-13.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "136",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 160 176 200 176 120 240 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3_ = [];
/* style */

const __vue_inject_styles__$3_ = undefined;
/* scoped */

const __vue_scope_id__$3_ = undefined;
/* module identifier */

const __vue_module_identifier__$3_ = undefined;
/* functional template */

const __vue_is_functional_template__$3_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3_,
  staticRenderFns: __vue_staticRenderFns__$3_
}, __vue_inject_styles__$3_, __vue_script__$3_, __vue_scope_id__$3_, __vue_is_functional_template__$3_, __vue_module_identifier__$3_, false, undefined, undefined, undefined);

var script$3Z = Vue.extend({
  name: "PhQuotes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Z = script$3Z;
/* template */

var __vue_render__$3Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M116,72v88a48,48,0,0,1-48,48,8,8,0,0,1,0-16,32.1,32.1,0,0,0,32-32v-8H40a16,16,0,0,1-16-16V72A16,16,0,0,1,40,56h60A16,16,0,0,1,116,72ZM216,56H156a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16h60v8a32.1,32.1,0,0,1-32,32,8,8,0,0,0,0,16,48,48,0,0,0,48-48V72A16,16,0,0,0,216,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Z = [];
/* style */

const __vue_inject_styles__$3Z = undefined;
/* scoped */

const __vue_scope_id__$3Z = undefined;
/* module identifier */

const __vue_module_identifier__$3Z = undefined;
/* functional template */

const __vue_is_functional_template__$3Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Z,
  staticRenderFns: __vue_staticRenderFns__$3Z
}, __vue_inject_styles__$3Z, __vue_script__$3Z, __vue_scope_id__$3Z, __vue_is_functional_template__$3Z, __vue_module_identifier__$3Z, false, undefined, undefined, undefined);

var script$3Y = Vue.extend({
  name: "PhRadical",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Y = script$3Y;
/* template */

var __vue_render__$3Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,208a8.1,8.1,0,0,1-7.5-5.2l-48-128a8,8,0,1,1,15-5.6L72,177.2l40.5-108A8.1,8.1,0,0,1,120,64H232a8,8,0,0,1,8,8V96a8,8,0,0,1-16,0V80H125.5l-46,122.8A8.1,8.1,0,0,1,72,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 96 232 72 120 72 72 200 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Y = [];
/* style */

const __vue_inject_styles__$3Y = undefined;
/* scoped */

const __vue_scope_id__$3Y = undefined;
/* module identifier */

const __vue_module_identifier__$3Y = undefined;
/* functional template */

const __vue_is_functional_template__$3Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Y,
  staticRenderFns: __vue_staticRenderFns__$3Y
}, __vue_inject_styles__$3Y, __vue_script__$3Y, __vue_scope_id__$3Y, __vue_is_functional_template__$3Y, __vue_module_identifier__$3Y, false, undefined, undefined, undefined);

var script$3X = Vue.extend({
  name: "PhRadio",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3X = script$3X;
/* template */

var __vue_render__$3X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "124",
      "x2": "96",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "164",
      "x2": "96",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,80H32V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V88A8,8,0,0,0,216,80Zm-56,96a32,32,0,1,1,32-32A32,32,0,0,1,160,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H86.5L194.3,39.7a8,8,0,1,0-4.6-15.4l-160,48h0l-.7.3h-.1l-.5.3H28a6.8,6.8,0,0,0-2.1,1.7.1.1,0,0,1-.1.1c-.1.1-.1.2-.2.4l-.2.2a.3.3,0,0,0-.1.2,6.7,6.7,0,0,0-1,2.3c-.1.1-.1.2-.1.4h-.1a2,2,0,0,1-.1.7h0V80h0V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM96,184H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm72,52a28,28,0,1,1,28-28A28.1,28.1,0,0,1,168,172Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "192",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "160",
      "cy": "144",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "96",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "144",
      "x2": "96",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "176",
      "x2": "96",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3X = [];
/* style */

const __vue_inject_styles__$3X = undefined;
/* scoped */

const __vue_scope_id__$3X = undefined;
/* module identifier */

const __vue_module_identifier__$3X = undefined;
/* functional template */

const __vue_is_functional_template__$3X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3X,
  staticRenderFns: __vue_staticRenderFns__$3X
}, __vue_inject_styles__$3X, __vue_script__$3X, __vue_scope_id__$3X, __vue_is_functional_template__$3X, __vue_module_identifier__$3X, false, undefined, undefined, undefined);

var script$3W = Vue.extend({
  name: "PhRadioButton",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3W = script$3W;
/* template */

var __vue_render__$3W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a64,64,0,1,1-64-64A64.1,64.1,0,0,1,192,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3W = [];
/* style */

const __vue_inject_styles__$3W = undefined;
/* scoped */

const __vue_scope_id__$3W = undefined;
/* module identifier */

const __vue_module_identifier__$3W = undefined;
/* functional template */

const __vue_is_functional_template__$3W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3W,
  staticRenderFns: __vue_staticRenderFns__$3W
}, __vue_inject_styles__$3W, __vue_script__$3W, __vue_scope_id__$3W, __vue_is_functional_template__$3W, __vue_module_identifier__$3W, false, undefined, undefined, undefined);

var script$3V = Vue.extend({
  name: "PhRainbow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3V = script$3V;
/* template */

var __vue_render__$3V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M12,180v-8a116,116,0,0,1,232,0v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,180v-4a24,24,0,0,0-48,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,180v-4a72,72,0,0,0-144,0v4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,168v16a8,8,0,0,1-16,0V168a40,40,0,0,0-80,0v16a8,8,0,0,1-16,0V168a56,56,0,0,1,112,0ZM128,80a88.1,88.1,0,0,0-88,88v16a8,8,0,0,0,16,0V168a72,72,0,0,1,144,0v16a8,8,0,0,0,16,0V168A88.1,88.1,0,0,0,128,80Zm0-32A120.1,120.1,0,0,0,8,168v16a8,8,0,0,0,16,0V168a104,104,0,0,1,208,0v16a8,8,0,0,0,16,0V168A120.1,120.1,0,0,0,128,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,184V168a48,48,0,0,0-96,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,184V168a80,80,0,0,0-160,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,184V168a112,112,0,0,0-224,0v16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3V = [];
/* style */

const __vue_inject_styles__$3V = undefined;
/* scoped */

const __vue_scope_id__$3V = undefined;
/* module identifier */

const __vue_module_identifier__$3V = undefined;
/* functional template */

const __vue_is_functional_template__$3V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3V,
  staticRenderFns: __vue_staticRenderFns__$3V
}, __vue_inject_styles__$3V, __vue_script__$3V, __vue_scope_id__$3V, __vue_is_functional_template__$3V, __vue_module_identifier__$3V, false, undefined, undefined, undefined);

var script$3U = Vue.extend({
  name: "PhRainbowCloud",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3U = script$3U;
/* template */

var __vue_render__$3U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,204,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92,176V160a20.1,20.1,0,0,1,7.7-15.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,176V160a60,60,0,0,1,90.8-51.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,176V160A100,100,0,0,1,177.6,84.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96,96,0,0,1,178.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64,64,0,0,1,101.9-51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,160a48,48,0,0,1-48,48H152c-17.6,0-32-14.8-32-32.9s14.4-32.9,32-32.9l3.3.2A48,48,0,0,1,248,160ZM112,72a87.3,87.3,0,0,1,61.3,24.9,8,8,0,1,0,11.2-11.5A104,104,0,0,0,8,160v16a8,8,0,0,0,16,0V160A88.1,88.1,0,0,1,112,72Zm0,32a56,56,0,0,1,33.1,10.8,8,8,0,1,0,9.5-12.8A70.9,70.9,0,0,0,112,88a72.1,72.1,0,0,0-72,72v16a8,8,0,0,0,16,0V160A56,56,0,0,1,112,104Zm15.2,26.7a7.9,7.9,0,0,0-5.9-9.6A42.2,42.2,0,0,0,112,120a40,40,0,0,0-40,40v16a8,8,0,0,0,16,0V160a24.1,24.1,0,0,1,24-24,26,26,0,0,1,5.6.6A7.9,7.9,0,0,0,127.2,130.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96,96,0,0,1,178.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64,64,0,0,1,101.9-51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96,96,0,0,1,178.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64,64,0,0,1,101.9-51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,176V160A96,96,0,0,1,178.9,91.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,176V160a64,64,0,0,1,101.9-51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3U = [];
/* style */

const __vue_inject_styles__$3U = undefined;
/* scoped */

const __vue_scope_id__$3U = undefined;
/* module identifier */

const __vue_module_identifier__$3U = undefined;
/* functional template */

const __vue_is_functional_template__$3U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3U,
  staticRenderFns: __vue_staticRenderFns__$3U
}, __vue_inject_styles__$3U, __vue_script__$3U, __vue_scope_id__$3U, __vue_is_functional_template__$3U, __vue_module_identifier__$3U, false, undefined, undefined, undefined);

var script$3T = Vue.extend({
  name: "PhReceipt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3T = script$3T;
/* template */

var __vue_render__$3T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "100",
      "x2": "180",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "140",
      "x2": "180",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V208a7.9,7.9,0,0,0,3.8,6.8,8,8,0,0,0,7.8.4L64,200.9l28.4,14.3a8.3,8.3,0,0,0,7.2,0L128,200.9l28.4,14.3a8.5,8.5,0,0,0,7.2,0L192,200.9l28.4,14.3a8,8,0,0,0,7.8-.4A7.9,7.9,0,0,0,232,208V56A16,16,0,0,0,216,40ZM180,144H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "76",
      "y1": "104",
      "x2": "180",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "76",
      "y1": "136",
      "x2": "180",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3T = [];
/* style */

const __vue_inject_styles__$3T = undefined;
/* scoped */

const __vue_scope_id__$3T = undefined;
/* module identifier */

const __vue_module_identifier__$3T = undefined;
/* functional template */

const __vue_is_functional_template__$3T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3T,
  staticRenderFns: __vue_staticRenderFns__$3T
}, __vue_inject_styles__$3T, __vue_script__$3T, __vue_scope_id__$3T, __vue_is_functional_template__$3T, __vue_module_identifier__$3T, false, undefined, undefined, undefined);

var script$3S = Vue.extend({
  name: "PhRecord",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3S = script$3S;
/* template */

var __vue_render__$3S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3S = [];
/* style */

const __vue_inject_styles__$3S = undefined;
/* scoped */

const __vue_scope_id__$3S = undefined;
/* module identifier */

const __vue_module_identifier__$3S = undefined;
/* functional template */

const __vue_is_functional_template__$3S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3S,
  staticRenderFns: __vue_staticRenderFns__$3S
}, __vue_inject_styles__$3S, __vue_script__$3S, __vue_scope_id__$3S, __vue_is_functional_template__$3S, __vue_module_identifier__$3S, false, undefined, undefined, undefined);

var script$3R = Vue.extend({
  name: "PhRectangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3R = script$3R;
/* template */

var __vue_render__$3R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "40",
      "width": "208",
      "height": "176",
      "rx": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3R = [];
/* style */

const __vue_inject_styles__$3R = undefined;
/* scoped */

const __vue_scope_id__$3R = undefined;
/* module identifier */

const __vue_module_identifier__$3R = undefined;
/* functional template */

const __vue_is_functional_template__$3R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3R,
  staticRenderFns: __vue_staticRenderFns__$3R
}, __vue_inject_styles__$3R, __vue_script__$3R, __vue_scope_id__$3R, __vue_is_functional_template__$3R, __vue_module_identifier__$3R, false, undefined, undefined, undefined);

var script$3Q = Vue.extend({
  name: "PhRecycle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3Q = script$3Q;
/* template */

var __vue_render__$3Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 208 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.6 75.2 185.8 108 153.1 99.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79 140.8 70.2 108 37.4 116.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,208h88a16,16,0,0,0,13.8-24l-19.9-34.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-20,34.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,108l-44,76A16,16,0,0,0,40,208H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 208 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.6 75.2 185.8 108 153.1 99.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79 140.8 70.2 108 37.4 116.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.8,204A23.9,23.9,0,0,1,216,216H160v16a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-24-24.1A7.9,7.9,0,0,1,120,208a8.1,8.1,0,0,1,2.3-5.7l24-24a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,160,184v16h56a7.9,7.9,0,0,0,6.9-4,7.8,7.8,0,0,0,0-8l-24-41.4a8,8,0,0,1,13.9-8L236.7,180A23.7,23.7,0,0,1,236.8,204ZM88,200H40a7.9,7.9,0,0,1-6.9-4,7.8,7.8,0,0,1,0-8l28-48.3,13.9,8a8,8,0,0,0,4,1.1,7.8,7.8,0,0,0,4.8-1.7,8,8,0,0,0,2.9-8.4l-8.8-32.8a8.1,8.1,0,0,0-3.7-4.8,7.7,7.7,0,0,0-6.1-.8L35.3,109a8,8,0,0,0-5.8,6.7,7.9,7.9,0,0,0,3.9,8l13.8,8L19.3,180A23.9,23.9,0,0,0,40,216H88a8,8,0,0,0,0-16ZM128,32a7.8,7.8,0,0,1,6.9,4l28,48.3-13.8,8a7.9,7.9,0,0,0,1.9,14.6l32.8,8.8,2,.3a8.1,8.1,0,0,0,7.8-5.9l8.8-32.8a8.1,8.1,0,0,0-2.9-8.5,8,8,0,0,0-8.9-.5l-13.9,8L148.8,28a24,24,0,0,0-41.6,0L83.3,69.4a8,8,0,1,0,13.8,8l24-41.4A7.8,7.8,0,0,1,128,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 208 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.6 75.2 185.8 108 153.1 99.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79 140.8 70.2 108 37.4 116.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 208 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.6 75.2 185.8 108 153.1 99.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79 140.8 70.2 108 37.4 116.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 232 128 208 152 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "194.6 75.2 185.8 108 153.1 99.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "79 140.8 70.2 108 37.4 116.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3Q = [];
/* style */

const __vue_inject_styles__$3Q = undefined;
/* scoped */

const __vue_scope_id__$3Q = undefined;
/* module identifier */

const __vue_module_identifier__$3Q = undefined;
/* functional template */

const __vue_is_functional_template__$3Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3Q,
  staticRenderFns: __vue_staticRenderFns__$3Q
}, __vue_inject_styles__$3Q, __vue_script__$3Q, __vue_scope_id__$3Q, __vue_is_functional_template__$3Q, __vue_module_identifier__$3Q, false, undefined, undefined, undefined);

var script$3P = Vue.extend({
  name: "PhRedditLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3P = script$3P;
/* template */

var __vue_render__$3P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161,172a71.9,71.9,0,0,1-66,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 176.1 30.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "128",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "128",
      "r": "20"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,104a24,24,0,0,0-43.4-14.1h0C178.3,78.7,154.3,72,128,72S77.7,78.7,59.4,89.9h0a24,24,0,1,0-31.6,34.8h0A50.7,50.7,0,0,0,24,144c0,39.8,46.6,72,104,72s104-32.2,104-72a50.7,50.7,0,0,0-3.8-19.3h0A24,24,0,0,0,240,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161,176a71.9,71.9,0,0,1-66,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.2 29.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,104a32,32,0,0,0-52.9-24.2c-16.8-8.9-36.8-14.3-57.7-15.5l5.2-31.2,21.8,3.4a24.2,24.2,0,1,0,2.5-15.8l-29.7-4.6a8,8,0,0,0-9.1,6.6l-6.9,41.5c-21.8.9-42.8,6.3-60.3,15.6a32,32,0,0,0-42.6,47.7A61.4,61.4,0,0,0,16,144c0,21.9,12,42.4,33.9,57.5S98.6,224,128,224s57.1-8,78.1-22.5S240,165.9,240,144a60.1,60.1,0,0,0-2.3-16.4A32.4,32.4,0,0,0,248,104ZM72,132a16,16,0,1,1,16,16A16,16,0,0,1,72,132Zm92.7,51.1a80.1,80.1,0,0,1-73.4,0,8,8,0,0,1,7.3-14.2,64.2,64.2,0,0,0,58.8,0,8,8,0,0,1,7.3,14.2ZM168,148a16,16,0,1,1,16-16A16,16,0,0,1,168,148Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161,176a71.9,71.9,0,0,1-66,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.2 29.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "14"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161,176a71.9,71.9,0,0,1-66,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.2 29.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "188",
      "cy": "32",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161,176a71.9,71.9,0,0,1-66,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 72 136 24 172.2 29.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "132",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "132",
      "r": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3P = [];
/* style */

const __vue_inject_styles__$3P = undefined;
/* scoped */

const __vue_scope_id__$3P = undefined;
/* module identifier */

const __vue_module_identifier__$3P = undefined;
/* functional template */

const __vue_is_functional_template__$3P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3P,
  staticRenderFns: __vue_staticRenderFns__$3P
}, __vue_inject_styles__$3P, __vue_script__$3P, __vue_scope_id__$3P, __vue_is_functional_template__$3P, __vue_module_identifier__$3P, false, undefined, undefined, undefined);

var script$3O = Vue.extend({
  name: "PhRepeat",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3O = script$3O;
/* template */

var __vue_render__$3O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A72.1,72.1,0,0,1,96,56h96V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l24,24a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,200,96a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,88V72H96a56,56,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56,56,0,0,1-56,56H64V168a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-24,24a8.1,8.1,0,0,0,0,11.4l24,24A8.3,8.3,0,0,0,56,224a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,64,216V200h96a72.1,72.1,0,0,0,72-72A8,8,0,0,0,224,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3O = [];
/* style */

const __vue_inject_styles__$3O = undefined;
/* scoped */

const __vue_scope_id__$3O = undefined;
/* module identifier */

const __vue_module_identifier__$3O = undefined;
/* functional template */

const __vue_is_functional_template__$3O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3O,
  staticRenderFns: __vue_staticRenderFns__$3O
}, __vue_inject_styles__$3O, __vue_script__$3O, __vue_scope_id__$3O, __vue_is_functional_template__$3O, __vue_module_identifier__$3O, false, undefined, undefined, undefined);

var script$3N = Vue.extend({
  name: "PhRepeatOnce",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3N = script$3N;
/* template */

var __vue_render__$3N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 112 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 112 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A72.1,72.1,0,0,1,96,56h96V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l24,24a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,200,96a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,88V72H96a56,56,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56,56,0,0,1-56,56H64V168a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-24,24a8.1,8.1,0,0,0,0,11.4l24,24A8.3,8.3,0,0,0,56,224a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,64,216V200h96a72.1,72.1,0,0,0,72-72A8,8,0,0,0,224,120Zm-92,40a8,8,0,0,0,8-8V104a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-16,8a8.2,8.2,0,0,0-3.6,10.8,8.1,8.1,0,0,0,10.8,3.5l4.4-2.2V152A8,8,0,0,0,132,160Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 112 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 112 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "200 88 224 64 200 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128A64.1,64.1,0,0,1,96,64H224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "56 168 32 192 56 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128a64.1,64.1,0,0,1-64,64H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "116 112 132 104 132 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3N = [];
/* style */

const __vue_inject_styles__$3N = undefined;
/* scoped */

const __vue_scope_id__$3N = undefined;
/* module identifier */

const __vue_module_identifier__$3N = undefined;
/* functional template */

const __vue_is_functional_template__$3N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3N,
  staticRenderFns: __vue_staticRenderFns__$3N
}, __vue_inject_styles__$3N, __vue_script__$3N, __vue_scope_id__$3N, __vue_is_functional_template__$3N, __vue_module_identifier__$3N, false, undefined, undefined, undefined);

var script$3M = Vue.extend({
  name: "PhRewind",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3M = script$3M;
/* template */

var __vue_render__$3M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,121.3l89.2-57.4A8,8,0,0,1,120,70.7V185.3a8,8,0,0,1-12.3,6.8L18.5,134.7A7.9,7.9,0,0,1,18.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M10.1,114.5,99.3,57.2A16,16,0,0,1,124,70.7v42.6l87.3-56.1A16,16,0,0,1,236,70.7V185.3a16.1,16.1,0,0,1-8.3,14.1,16.5,16.5,0,0,1-16.4-.6L124,142.7v42.6a16.1,16.1,0,0,1-8.3,14.1,16.5,16.5,0,0,1-16.4-.6L10.1,141.5a16.1,16.1,0,0,1,0-27Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3M = [];
/* style */

const __vue_inject_styles__$3M = undefined;
/* scoped */

const __vue_scope_id__$3M = undefined;
/* module identifier */

const __vue_module_identifier__$3M = undefined;
/* functional template */

const __vue_is_functional_template__$3M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3M,
  staticRenderFns: __vue_staticRenderFns__$3M
}, __vue_inject_styles__$3M, __vue_script__$3M, __vue_scope_id__$3M, __vue_is_functional_template__$3M, __vue_module_identifier__$3M, false, undefined, undefined, undefined);

var script$3L = Vue.extend({
  name: "PhRewindCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3L = script$3L;
/* template */

var __vue_render__$3L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "168 156 132 128 168 100 168 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 156 76 128 112 100 112 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM112,160,64,128l48-32Zm64,0-48-32,48-32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "176 160 128 128 176 96 176 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 160 64 128 112 96 112 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128A104,104,0,1,0,128,24,104.2,104.2,0,0,0,24,128Zm44,0a8.2,8.2,0,0,1,3.4-6.6l40-28a8,8,0,0,1,8.3-.5A8.1,8.1,0,0,1,124,100v28a8.2,8.2,0,0,1,3.4-6.6l40-28a8,8,0,0,1,8.3-.5A8.1,8.1,0,0,1,180,100v56a8,8,0,0,1-8,8,8.6,8.6,0,0,1-4.6-1.4l-40-28A8.2,8.2,0,0,1,124,128v28a8,8,0,0,1-8,8,8.6,8.6,0,0,1-4.6-1.4l-40-28A8.2,8.2,0,0,1,68,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "172 160 124 128 172 96 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "116 160 68 128 116 96 116 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "172 160 124 128 172 96 172 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "116 160 68 128 116 96 116 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "176 160 128 128 176 96 176 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "112 160 64 128 112 96 112 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3L = [];
/* style */

const __vue_inject_styles__$3L = undefined;
/* scoped */

const __vue_scope_id__$3L = undefined;
/* module identifier */

const __vue_module_identifier__$3L = undefined;
/* functional template */

const __vue_is_functional_template__$3L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3L,
  staticRenderFns: __vue_staticRenderFns__$3L
}, __vue_inject_styles__$3L, __vue_script__$3L, __vue_scope_id__$3L, __vue_is_functional_template__$3L, __vue_module_identifier__$3L, false, undefined, undefined, undefined);

var script$3K = Vue.extend({
  name: "PhRobot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3K = script$3K;
/* template */

var __vue_render__$3K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68",
      "y": "144",
      "width": "120",
      "height": "36",
      "rx": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "104",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "104",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,56H56A23.9,23.9,0,0,0,32,80V192a23.9,23.9,0,0,0,24,24H200a23.9,23.9,0,0,0,24-24V80A23.9,23.9,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,48H136V16a8,8,0,0,0-16,0V48H56A32.1,32.1,0,0,0,24,80V192a32.1,32.1,0,0,0,32,32H200a32.1,32.1,0,0,0,32-32V80A32.1,32.1,0,0,0,200,48ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm28,76H92a16,16,0,0,1,0-32h8Zm40,0H116V152h24Zm24,0h-8V152h8a16,16,0,0,1,0,32Zm8-64a12,12,0,1,1,12-12A12,12,0,0,1,172,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "160",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72",
      "y": "144",
      "width": "112",
      "height": "40",
      "rx": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "144",
      "x2": "148",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "144",
      "x2": "108",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3K = [];
/* style */

const __vue_inject_styles__$3K = undefined;
/* scoped */

const __vue_scope_id__$3K = undefined;
/* module identifier */

const __vue_module_identifier__$3K = undefined;
/* functional template */

const __vue_is_functional_template__$3K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3K,
  staticRenderFns: __vue_staticRenderFns__$3K
}, __vue_inject_styles__$3K, __vue_script__$3K, __vue_scope_id__$3K, __vue_is_functional_template__$3K, __vue_module_identifier__$3K, false, undefined, undefined, undefined);

var script$3J = Vue.extend({
  name: "PhRocket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3J = script$3J;
/* template */

var __vue_render__$3J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "228",
      "x2": "112",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M73.9,111.4h0L42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24C78.4,161.4,72.7,134.5,73.9,111.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.7h0l31.4,37.7a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.6a8,8,0,0,1-12.8,4.6l-30-24C177,160.7,182.7,133.8,181.5,110.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,216H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M219.6,143.9l-30.2-36.3a125.4,125.4,0,0,0-8-34.9c-11.6-30.2-32.1-50-43.4-59.1a15.9,15.9,0,0,0-20-.1c-11.4,9.1-32.2,28.9-43.9,59.1A121.5,121.5,0,0,0,66,108.3L36.4,143.9A16.1,16.1,0,0,0,33,157.6l12.4,55.6a15.9,15.9,0,0,0,10.3,11.6,17,17,0,0,0,5.4.9,16,16,0,0,0,9.9-3.5L98.8,200h58.4L185,222.2a16,16,0,0,0,9.9,3.5,17,17,0,0,0,5.4-.9,15.9,15.9,0,0,0,10.3-11.6L223,157.6A16.1,16.1,0,0,0,219.6,143.9ZM61,209.7,48.7,154.1l17.9-21.5q3.5,28.1,19.1,57.4ZM128,108a12,12,0,1,1,12-12A12,12,0,0,1,128,108Zm67,101.7-24.8-19.8c10.4-19.7,16.6-39,18.8-57.8l18.3,22Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "112",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3J = [];
/* style */

const __vue_inject_styles__$3J = undefined;
/* scoped */

const __vue_scope_id__$3J = undefined;
/* module identifier */

const __vue_module_identifier__$3J = undefined;
/* functional template */

const __vue_is_functional_template__$3J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3J,
  staticRenderFns: __vue_staticRenderFns__$3J
}, __vue_inject_styles__$3J, __vue_script__$3J, __vue_scope_id__$3J, __vue_is_functional_template__$3J, __vue_module_identifier__$3J, false, undefined, undefined, undefined);

var script$3I = Vue.extend({
  name: "PhRocketLaunch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3I = script$3I;
/* template */

var __vue_render__$3I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M90.6,192.4c-15.1,26.1-53.1,26.1-53.1,26.1s0-38,26.1-53.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96.6,177a7.9,7.9,0,0,0-10.1,5c-6.6,19.7-27.9,25.8-40.2,27.7,1.9-12.3,8-33.6,27.7-40.2a8,8,0,1,0-5.1-15.1c-16.4,5.4-28.4,18.4-34.8,37.5a91.8,91.8,0,0,0-4.6,26.6,8,8,0,0,0,8,8,91.8,91.8,0,0,0,26.6-4.6c19.1-6.4,32.1-18.4,37.5-34.8A7.9,7.9,0,0,0,96.6,177Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.6,41.8a15.7,15.7,0,0,0-13.4-13.4c-11.3-1.7-40.6-2.5-69.2,26.1l-9,8.9H74.7a16.2,16.2,0,0,0-11.3,4.7L31.1,100.5a15.9,15.9,0,0,0-4,15.9,16,16,0,0,0,12.2,11.1l39.5,7.9,41.8,41.8,7.9,39.5a16,16,0,0,0,11.1,12.2,14.7,14.7,0,0,0,4.6.7,15.6,15.6,0,0,0,11.3-4.7l32.4-32.3a16.2,16.2,0,0,0,4.7-11.3V120l8.9-9C230.1,82.4,229.3,53.1,227.6,41.8ZM74.7,79.4H120L80.1,119.3l-37.7-7.5ZM176.6,181.3l-32.4,32.3-7.5-37.7L176.6,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3I = [];
/* style */

const __vue_inject_styles__$3I = undefined;
/* scoped */

const __vue_scope_id__$3I = undefined;
/* module identifier */

const __vue_module_identifier__$3I = undefined;
/* functional template */

const __vue_is_functional_template__$3I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3I,
  staticRenderFns: __vue_staticRenderFns__$3I
}, __vue_inject_styles__$3I, __vue_script__$3I, __vue_scope_id__$3I, __vue_is_functional_template__$3I, __vue_module_identifier__$3I, false, undefined, undefined, undefined);

var script$3H = Vue.extend({
  name: "PhRows",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3H = script$3H;
/* template */

var __vue_render__$3H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,152v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H208A16,16,0,0,1,224,152ZM208,48H48A16,16,0,0,0,32,64v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "144",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "56",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3H = [];
/* style */

const __vue_inject_styles__$3H = undefined;
/* scoped */

const __vue_scope_id__$3H = undefined;
/* module identifier */

const __vue_module_identifier__$3H = undefined;
/* functional template */

const __vue_is_functional_template__$3H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3H,
  staticRenderFns: __vue_staticRenderFns__$3H
}, __vue_inject_styles__$3H, __vue_script__$3H, __vue_scope_id__$3H, __vue_is_functional_template__$3H, __vue_module_identifier__$3H, false, undefined, undefined, undefined);

var script$3G = Vue.extend({
  name: "PhRss",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3G = script$3G;
/* template */

var __vue_render__$3G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M98.9,157.1A71.6,71.6,0,0,1,120,208a8,8,0,0,1-16,0,56,56,0,0,0-56-56,8,8,0,0,1,0-16A71.6,71.6,0,0,1,98.9,157.1ZM48,88a8,8,0,0,0,0,16,102.9,102.9,0,0,1,73.5,30.5A102.9,102.9,0,0,1,152,208a8,8,0,0,0,16,0,119.2,119.2,0,0,0-35.2-84.9A119.3,119.3,0,0,0,48,88Zm118.8,1.2A166.9,166.9,0,0,0,48,40a8,8,0,0,0,0,16,151.1,151.1,0,0,1,107.5,44.5A151.1,151.1,0,0,1,200,208a8,8,0,0,0,16,0A166.9,166.9,0,0,0,166.8,89.2ZM52,192a12,12,0,1,0,12,12A12,12,0,0,0,52,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a64,64,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,144a63.8,63.8,0,0,1,64,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,96A112,112,0,0,1,160,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "52",
      "cy": "204",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3G = [];
/* style */

const __vue_inject_styles__$3G = undefined;
/* scoped */

const __vue_scope_id__$3G = undefined;
/* module identifier */

const __vue_module_identifier__$3G = undefined;
/* functional template */

const __vue_is_functional_template__$3G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3G,
  staticRenderFns: __vue_staticRenderFns__$3G
}, __vue_inject_styles__$3G, __vue_script__$3G, __vue_scope_id__$3G, __vue_is_functional_template__$3G, __vue_module_identifier__$3G, false, undefined, undefined, undefined);

var script$3F = Vue.extend({
  name: "PhRssSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3F = script$3F;
/* template */

var __vue_render__$3F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152.1,152.1,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152.1,152.1,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,200a8,8,0,0,1-16,0c0-79.4-64.6-144-144-144a8,8,0,0,1,0-16C144.2,40,216,111.8,216,200ZM56,112a8,8,0,0,0,0,16,72.1,72.1,0,0,1,72,72,8,8,0,0,0,16,0A88.1,88.1,0,0,0,56,112Zm0,76a12,12,0,1,0,12,12A12,12,0,0,0,56,188Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152.1,152.1,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152.1,152.1,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48A152.1,152.1,0,0,1,208,200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,120a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3F = [];
/* style */

const __vue_inject_styles__$3F = undefined;
/* scoped */

const __vue_scope_id__$3F = undefined;
/* module identifier */

const __vue_module_identifier__$3F = undefined;
/* functional template */

const __vue_is_functional_template__$3F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3F,
  staticRenderFns: __vue_staticRenderFns__$3F
}, __vue_inject_styles__$3F, __vue_script__$3F, __vue_scope_id__$3F, __vue_is_functional_template__$3F, __vue_module_identifier__$3F, false, undefined, undefined, undefined);

var script$3E = Vue.extend({
  name: "PhRug",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3E = script$3E;
/* template */

var __vue_render__$3E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "48",
      "x2": "56",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "48",
      "x2": "200",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "56",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "232",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "48",
      "x2": "152",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "232",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "232",
      "x2": "200",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 88 104 128 128 168 152 128 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,48V208H200V48Zm72,120-24-40,24-40,24,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "48",
      "x2": "56",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "48",
      "x2": "200",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "56",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "232",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "48",
      "x2": "152",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "232",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "232",
      "x2": "200",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 88 104 128 128 168 152 128 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,16a8,8,0,0,0-8,8V40H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H64V24a8,8,0,0,0-16,0V232a8,8,0,0,0,16,0V216H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V24A8,8,0,0,0,200,16ZM64,56H192V200H64Zm57.1,116.1-24-40a8,8,0,0,1,0-8.2l24-40a8.1,8.1,0,0,1,13.8,0l24,40a8,8,0,0,1,0,8.2l-24,40a8.1,8.1,0,0,1-13.8,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "48",
      "x2": "56",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "48",
      "x2": "200",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "56",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "232",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "48",
      "x2": "152",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "232",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "232",
      "x2": "200",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 88 104 128 128 168 152 128 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "48",
      "x2": "56",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "48",
      "x2": "200",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "56",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "232",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "48",
      "x2": "152",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "232",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "232",
      "x2": "200",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 88 104 128 128 168 152 128 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "56",
      "y": "48",
      "width": "144",
      "height": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "48",
      "x2": "56",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "48",
      "x2": "104",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "48",
      "x2": "200",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "232",
      "x2": "56",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "232",
      "x2": "104",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "48",
      "x2": "152",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "232",
      "x2": "152",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "232",
      "x2": "200",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 88 104 128 128 168 152 128 128 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3E = [];
/* style */

const __vue_inject_styles__$3E = undefined;
/* scoped */

const __vue_scope_id__$3E = undefined;
/* module identifier */

const __vue_module_identifier__$3E = undefined;
/* functional template */

const __vue_is_functional_template__$3E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3E,
  staticRenderFns: __vue_staticRenderFns__$3E
}, __vue_inject_styles__$3E, __vue_script__$3E, __vue_scope_id__$3E, __vue_is_functional_template__$3E, __vue_module_identifier__$3E, false, undefined, undefined, undefined);

var script$3D = Vue.extend({
  name: "PhRuler",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3D = script$3D;
/* template */

var __vue_render__$3D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.7,88.4a16.6,16.6,0,0,1-5,11.3L99.3,232a15.9,15.9,0,0,1-22.6,0L24,179.3a15.9,15.9,0,0,1,0-22.6l21.9-21.9a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,92,172a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L62.8,123.5a4,4,0,0,1,0-5.6L81.9,98.8a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,128,136a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L98.8,87.5a4,4,0,0,1,0-5.6l19.1-19.1a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,164,100a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L134.8,51.5a4,4,0,0,1,0-5.6L156.7,24a16.1,16.1,0,0,1,22.6,0L232,76.7A16,16,0,0,1,236.7,88.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "26.2",
      "y": "82.7",
      "width": "203.6",
      "height": "90.51",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "132",
      "y1": "60",
      "x2": "164",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "96",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "132",
      "x2": "92",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3D = [];
/* style */

const __vue_inject_styles__$3D = undefined;
/* scoped */

const __vue_scope_id__$3D = undefined;
/* module identifier */

const __vue_module_identifier__$3D = undefined;
/* functional template */

const __vue_is_functional_template__$3D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3D,
  staticRenderFns: __vue_staticRenderFns__$3D
}, __vue_inject_styles__$3D, __vue_script__$3D, __vue_scope_id__$3D, __vue_is_functional_template__$3D, __vue_module_identifier__$3D, false, undefined, undefined, undefined);

var script$3C = Vue.extend({
  name: "PhScales",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3C = script$3C;
/* template */

var __vue_render__$3C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.4,133l-32-80h0l-.5-.9h0l-.6-.8c-.1-.1-.1-.1-.1-.2l-.8-.8a.1.1,0,0,1-.1-.1l-.7-.5-.2-.2-.9-.5h-.2l-.8-.3h-.2l-1-.2h-3L136,62V40a8,8,0,0,0-16,0V65.6L54.3,80.2h-.7l-1,.4h-.2l-.8.4a.1.1,0,0,1-.1.1l-.9.7a.1.1,0,0,1-.1.1l-.6.7h-.1a2.4,2.4,0,0,0-.6.9l-.2.2-.4.9h-.1L16.6,165a8,8,0,0,0-.6,3c0,23.3,24.5,32,40,32s40-8.7,40-32a8,8,0,0,0-.6-3L66.9,93.8,120,82V208H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16H136V78.4l50.9-11.3L160.6,133a8,8,0,0,0-.6,3c0,23.3,24.5,32,40,32s40-8.7,40-32A8,8,0,0,0,239.4,133ZM32.6,168,56,109.5,79.4,168Zm144-32L200,77.5,223.4,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "216",
      "x2": "152",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "88",
      "x2": "200",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3C = [];
/* style */

const __vue_inject_styles__$3C = undefined;
/* scoped */

const __vue_scope_id__$3C = undefined;
/* module identifier */

const __vue_module_identifier__$3C = undefined;
/* functional template */

const __vue_is_functional_template__$3C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3C,
  staticRenderFns: __vue_staticRenderFns__$3C
}, __vue_inject_styles__$3C, __vue_script__$3C, __vue_scope_id__$3C, __vue_is_functional_template__$3C, __vue_module_identifier__$3C, false, undefined, undefined, undefined);

var script$3B = Vue.extend({
  name: "PhScan",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3B = script$3B;
/* template */

var __vue_render__$3B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 216 40 216 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 176 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 80 40 40 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "84",
      "y": "84",
      "width": "88",
      "height": "88",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 216 40 216 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 176 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 80 40 40 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,40V80a8,8,0,0,1-16,0V48H176a8,8,0,0,1,0-16h40A8,8,0,0,1,224,40ZM80,208H48V176a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H80a8,8,0,0,0,0-16Zm136-40a8,8,0,0,0-8,8v32H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V176A8,8,0,0,0,216,168ZM40,88a8,8,0,0,0,8-8V48H80a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V80A8,8,0,0,0,40,88Zm144,80V88a16,16,0,0,0-16-16H88A16,16,0,0,0,72,88v80a16,16,0,0,0,16,16h80A16,16,0,0,0,184,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 216 40 216 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 176 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 80 40 40 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 216 40 216 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 176 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 80 40 40 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 40 216 40 216 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 216 40 216 40 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216 176 216 216 176 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 80 40 40 80 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3B = [];
/* style */

const __vue_inject_styles__$3B = undefined;
/* scoped */

const __vue_scope_id__$3B = undefined;
/* module identifier */

const __vue_module_identifier__$3B = undefined;
/* functional template */

const __vue_is_functional_template__$3B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3B,
  staticRenderFns: __vue_staticRenderFns__$3B
}, __vue_inject_styles__$3B, __vue_script__$3B, __vue_scope_id__$3B, __vue_is_functional_template__$3B, __vue_module_identifier__$3B, false, undefined, undefined, undefined);

var script$3A = Vue.extend({
  name: "PhScissors",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3A = script$3A;
/* template */

var __vue_render__$3A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.1",
      "y2": "164.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.7",
      "x2": "83.1",
      "y2": "91.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.3",
      "x2": "171.4",
      "y2": "103.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.1",
      "y2": "164.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.3",
      "x2": "164.3",
      "y2": "108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.7",
      "x2": "83.1",
      "y2": "91.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M157.7,113.1a8,8,0,0,1,2.1-11.1l67.7-46.3a8,8,0,0,1,11.1,2.1,7.9,7.9,0,0,1-2.1,11.1l-67.6,46.3a7.8,7.8,0,0,1-4.6,1.4A8,8,0,0,1,157.7,113.1Zm80.9,85.1a7.9,7.9,0,0,1-6.6,3.5,8.2,8.2,0,0,1-4.5-1.4L136,137.7,93.5,166.8A36.4,36.4,0,0,1,96,180a36.1,36.1,0,1,1-11.6-26.4L121.8,128,84.4,102.4A35.5,35.5,0,0,1,60,112,36,36,0,1,1,93.5,89.2l143,97.9A7.9,7.9,0,0,1,238.6,198.2ZM80,180a19.7,19.7,0,0,0-5.9-14.1,19.8,19.8,0,0,0-28.2,0,19.8,19.8,0,0,0,0,28.2,19.9,19.9,0,0,0,28.2,0A19.7,19.7,0,0,0,80,180ZM74.1,90.1a19.8,19.8,0,0,0,0-28.2,19.8,19.8,0,0,0-28.2,0,19.8,19.8,0,0,0,0,28.2A19.9,19.9,0,0,0,74.1,90.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.1",
      "y2": "164.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.3",
      "x2": "164.3",
      "y2": "108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.7",
      "x2": "83.1",
      "y2": "91.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.1",
      "y2": "164.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.3",
      "x2": "164.3",
      "y2": "108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.7",
      "x2": "83.1",
      "y2": "91.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "76",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "180",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "128",
      "x2": "83.1",
      "y2": "164.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "62.3",
      "x2": "164.3",
      "y2": "108.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "193.7",
      "x2": "83.1",
      "y2": "91.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3A = [];
/* style */

const __vue_inject_styles__$3A = undefined;
/* scoped */

const __vue_scope_id__$3A = undefined;
/* module identifier */

const __vue_module_identifier__$3A = undefined;
/* functional template */

const __vue_is_functional_template__$3A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3A,
  staticRenderFns: __vue_staticRenderFns__$3A
}, __vue_inject_styles__$3A, __vue_script__$3A, __vue_scope_id__$3A, __vue_is_functional_template__$3A, __vue_module_identifier__$3A, false, undefined, undefined, undefined);

var script$3z = Vue.extend({
  name: "PhScreencast",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3z = script$3z;
/* template */

var __vue_render__$3z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36,68V60a8,8,0,0,1,8-8H212a8,8,0,0,1,8,8V196a8,8,0,0,1-8,8H172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,188a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,148a56,56,0,0,1,56,56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,108a96,96,0,0,1,96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V192a16,16,0,0,1,16,16H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,184a8,8,0,0,0,0,16,8,8,0,0,1,8,8,8,8,0,0,0,16,0A24.1,24.1,0,0,0,32,184Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,152a8,8,0,0,0,0,16,40,40,0,0,1,40,40,8,8,0,0,0,16,0A56,56,0,0,0,32,152Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120a8,8,0,0,0,0,16,72.1,72.1,0,0,1,72,72,8,8,0,0,0,16,0A88.1,88.1,0,0,0,32,120Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V96a8,8,0,0,0,8,8A104.2,104.2,0,0,1,136,208a8,8,0,0,0,8,8h72a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,192a16,16,0,0,1,16,16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,160a48,48,0,0,1,48,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,128a80,80,0,0,1,80,80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3z = [];
/* style */

const __vue_inject_styles__$3z = undefined;
/* scoped */

const __vue_scope_id__$3z = undefined;
/* module identifier */

const __vue_module_identifier__$3z = undefined;
/* functional template */

const __vue_is_functional_template__$3z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3z,
  staticRenderFns: __vue_staticRenderFns__$3z
}, __vue_inject_styles__$3z, __vue_script__$3z, __vue_scope_id__$3z, __vue_is_functional_template__$3z, __vue_module_identifier__$3z, false, undefined, undefined, undefined);

var script$3y = Vue.extend({
  name: "PhScribbleLoop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3y = script$3y;
/* template */

var __vue_render__$3y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.1,154.9c-1.2-1.5-22.9-27.1-59.8-41.4-2.1-17.8-8.9-34-19.6-46.6C151.7,49.3,130,40,104,40,52.5,40,18.9,86.2,17.5,88.1a8,8,0,0,0,13,9.4C30.8,97,60.8,56,104,56c21.2,0,38.6,7.4,50.5,21.3a68,68,0,0,1,14.7,30.8A134.2,134.2,0,0,0,136,104c-26.1,0-47.9,6.8-63.3,19.7C59.2,135.1,51.4,151,51.4,167.2a47.4,47.4,0,0,0,13.9,34.1c9.6,9.6,23,14.7,38.7,14.7,25.2,0,46.7-10,62.1-28.8,12.2-15,19.6-35.1,20.8-56a146.3,146.3,0,0,1,47,33.9,8,8,0,1,0,12.2-10.2ZM104,200c-25.3,0-36.6-16.4-36.6-32.8,0-22.7,21.5-47.2,68.6-47.2a117.3,117.3,0,0,1,35,5.3v.3C171,162.6,148,200,104,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3y = [];
/* style */

const __vue_inject_styles__$3y = undefined;
/* scoped */

const __vue_scope_id__$3y = undefined;
/* module identifier */

const __vue_module_identifier__$3y = undefined;
/* functional template */

const __vue_is_functional_template__$3y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3y,
  staticRenderFns: __vue_staticRenderFns__$3y
}, __vue_inject_styles__$3y, __vue_script__$3y, __vue_scope_id__$3y, __vue_is_functional_template__$3y, __vue_module_identifier__$3y, false, undefined, undefined, undefined);

var script$3x = Vue.extend({
  name: "PhScroll",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3x = script$3x;
/* template */

var __vue_render__$3x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,176V64a23.9,23.9,0,0,0-24-24H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "100",
      "x2": "168",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "140",
      "x2": "168",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,216a24,24,0,0,0,17.9-40h112A24,24,0,0,1,200,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,176V64a23.9,23.9,0,0,0-24-24H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "168",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.8,170.7a7.8,7.8,0,0,0-5.9-2.7H208V64a32.1,32.1,0,0,0-32-32H40A32.1,32.1,0,0,0,8,64a31.5,31.5,0,0,0,8.2,21.3,7.9,7.9,0,0,0,11.2.7,8,8,0,0,0,.7-11.3A16,16,0,1,1,56,64V192a32.1,32.1,0,0,0,32,32H200a32.1,32.1,0,0,0,32-32A31.5,31.5,0,0,0,223.8,170.7ZM104,96h64a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Zm-8,40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Zm104,72H115.7a32.2,32.2,0,0,0,4.3-16,30.8,30.8,0,0,0-1-8h94.9A16.1,16.1,0,0,1,200,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,176V64a23.9,23.9,0,0,0-24-24H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "168",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,176V64a23.9,23.9,0,0,0-24-24H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "168",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,176V64a23.9,23.9,0,0,0-24-24H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "168",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "136",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3x = [];
/* style */

const __vue_inject_styles__$3x = undefined;
/* scoped */

const __vue_scope_id__$3x = undefined;
/* module identifier */

const __vue_module_identifier__$3x = undefined;
/* functional template */

const __vue_is_functional_template__$3x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3x,
  staticRenderFns: __vue_staticRenderFns__$3x
}, __vue_inject_styles__$3x, __vue_script__$3x, __vue_scope_id__$3x, __vue_is_functional_template__$3x, __vue_module_identifier__$3x, false, undefined, undefined, undefined);

var script$3w = Vue.extend({
  name: "PhSelection",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3w = script$3w;
/* template */

var __vue_render__$3w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3w = [];
/* style */

const __vue_inject_styles__$3w = undefined;
/* scoped */

const __vue_scope_id__$3w = undefined;
/* module identifier */

const __vue_module_identifier__$3w = undefined;
/* functional template */

const __vue_is_functional_template__$3w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3w,
  staticRenderFns: __vue_staticRenderFns__$3w
}, __vue_inject_styles__$3w, __vue_script__$3w, __vue_scope_id__$3w, __vue_is_functional_template__$3w, __vue_module_identifier__$3w, false, undefined, undefined, undefined);

var script$3v = Vue.extend({
  name: "PhSelectionAll",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3v = script$3v;
/* template */

var __vue_render__$3v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,40H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "80",
      "width": "96",
      "height": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3v = [];
/* style */

const __vue_inject_styles__$3v = undefined;
/* scoped */

const __vue_scope_id__$3v = undefined;
/* module identifier */

const __vue_module_identifier__$3v = undefined;
/* functional template */

const __vue_is_functional_template__$3v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3v,
  staticRenderFns: __vue_staticRenderFns__$3v
}, __vue_inject_styles__$3v, __vue_script__$3v, __vue_scope_id__$3v, __vue_is_functional_template__$3v, __vue_module_identifier__$3v, false, undefined, undefined, undefined);

var script$3u = Vue.extend({
  name: "PhSelectionBackground",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3u = script$3u;
/* template */

var __vue_render__$3u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "92",
      "width": "124",
      "height": "124",
      "rx": "7.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,40H96a8,8,0,0,0-8,8V88h72a8,8,0,0,1,8,8v72h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56V48A16,16,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Zm64-8h16a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm64-16h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,56a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V96A8,8,0,0,0,216,88Zm-40,8V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80H160A16,16,0,0,1,176,96Zm-16,0H48V208H160Zm56,48a8,8,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16v-8A8,8,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "40",
      "x2": "144",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,40h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "112",
      "x2": "216",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,168h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,40H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3u = [];
/* style */

const __vue_inject_styles__$3u = undefined;
/* scoped */

const __vue_scope_id__$3u = undefined;
/* module identifier */

const __vue_module_identifier__$3u = undefined;
/* functional template */

const __vue_is_functional_template__$3u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3u,
  staticRenderFns: __vue_staticRenderFns__$3u
}, __vue_inject_styles__$3u, __vue_script__$3u, __vue_scope_id__$3u, __vue_is_functional_template__$3u, __vue_module_identifier__$3u, false, undefined, undefined, undefined);

var script$3t = Vue.extend({
  name: "PhSelectionForeground",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3t = script$3t;
/* template */

var __vue_render__$3t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "92",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "164",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,164h38.7a7.8,7.8,0,0,0,7.8-7.8V47.8a7.8,7.8,0,0,0-7.8-7.8H99.8A7.8,7.8,0,0,0,92,47.8V86.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "88",
      "width": "128",
      "height": "128",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,216a8,8,0,0,1-8,8H48a16,16,0,0,1-16-16v-8a8,8,0,0,1,16,0v8h8A8,8,0,0,1,64,216Zm48-8H96a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16ZM40,168a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v16A8,8,0,0,0,40,168Zm128,24a8,8,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Zm0-80a8,8,0,0,0,8-8V96a16,16,0,0,0-16-16h-8a8,8,0,0,0,0,16h8v8A8,8,0,0,0,168,112ZM56,80H48A16,16,0,0,0,32,96v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16ZM208,32H96A16,16,0,0,0,80,48V88a8,8,0,0,0,8,8h24a8,8,0,0,0,0-16H96V48H208V160H176V144a8,8,0,0,0-16,0v24a8,8,0,0,0,8,8h40a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,216H48a8,8,0,0,1-8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "96",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "168",
      "x2": "168",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "160",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,216h8a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,88h8a8,8,0,0,1,8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,88H48a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3t = [];
/* style */

const __vue_inject_styles__$3t = undefined;
/* scoped */

const __vue_scope_id__$3t = undefined;
/* module identifier */

const __vue_module_identifier__$3t = undefined;
/* functional template */

const __vue_is_functional_template__$3t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3t,
  staticRenderFns: __vue_staticRenderFns__$3t
}, __vue_inject_styles__$3t, __vue_script__$3t, __vue_scope_id__$3t, __vue_is_functional_template__$3t, __vue_module_identifier__$3t, false, undefined, undefined, undefined);

var script$3s = Vue.extend({
  name: "PhSelectionInverse",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3s = script$3s;
/* template */

var __vue_render__$3s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.3,42.3,213.7,213.7h0A8.4,8.4,0,0,0,216,208V48a8,8,0,0,0-8-8H48a8.4,8.4,0,0,0-5.7,2.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,216a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,216ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM224,48a16,16,0,0,0-16-16H48a16.4,16.4,0,0,0-10.7,4.1l-.6.6-.6.6A16.4,16.4,0,0,0,32,48V72a8,8,0,0,0,16,0V59.3L196.7,208H184a8,8,0,0,0,0,16h24a16.4,16.4,0,0,0,10.7-4.1l.6-.6.6-.6A16.4,16.4,0,0,0,224,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "42.3",
      "y1": "42.3",
      "x2": "213.7",
      "y2": "213.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3s = [];
/* style */

const __vue_inject_styles__$3s = undefined;
/* scoped */

const __vue_scope_id__$3s = undefined;
/* module identifier */

const __vue_module_identifier__$3s = undefined;
/* functional template */

const __vue_is_functional_template__$3s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3s,
  staticRenderFns: __vue_staticRenderFns__$3s
}, __vue_inject_styles__$3s, __vue_script__$3s, __vue_scope_id__$3s, __vue_is_functional_template__$3s, __vue_module_identifier__$3s, false, undefined, undefined, undefined);

var script$3r = Vue.extend({
  name: "PhSelectionPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3r = script$3r;
/* template */

var __vue_render__$3r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "140",
      "x2": "208",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "116",
      "x2": "48",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,208H56a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "140",
      "x2": "208",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "116",
      "x2": "48",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,208H56a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M148,48a8,8,0,0,1-8,8H116a8,8,0,0,1,0-16h24A8,8,0,0,1,148,48Zm-8,152H116a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM180,56h20V76a8,8,0,0,0,16,0V56a16,16,0,0,0-16-16H180a8,8,0,0,0,0,16Zm28,52a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,208,108ZM48,148a8,8,0,0,0,8-8V116a8,8,0,0,0-16,0v24A8,8,0,0,0,48,148Zm28,52H56V180a8,8,0,0,0-16,0v20a16,16,0,0,0,16,16H76a8,8,0,0,0,0-16ZM76,40H56A16,16,0,0,0,40,56V76a8,8,0,0,0,16,0V56H76a8,8,0,0,0,0-16ZM236,200H216V180a8,8,0,0,0-16,0v20H180a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V216h20a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "140",
      "x2": "208",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "116",
      "x2": "48",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,208H56a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "140",
      "x2": "208",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "116",
      "x2": "48",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,208H56a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "140",
      "y1": "48",
      "x2": "116",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "116",
      "y1": "208",
      "x2": "140",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,48h20a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "140",
      "x2": "208",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "116",
      "x2": "48",
      "y2": "140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,208H56a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,48H56a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "180",
      "x2": "208",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "208",
      "x2": "180",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3r = [];
/* style */

const __vue_inject_styles__$3r = undefined;
/* scoped */

const __vue_scope_id__$3r = undefined;
/* module identifier */

const __vue_module_identifier__$3r = undefined;
/* functional template */

const __vue_is_functional_template__$3r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3r,
  staticRenderFns: __vue_staticRenderFns__$3r
}, __vue_inject_styles__$3r, __vue_script__$3r, __vue_scope_id__$3r, __vue_is_functional_template__$3r, __vue_module_identifier__$3r, false, undefined, undefined, undefined);

var script$3q = Vue.extend({
  name: "PhSelectionSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3q = script$3q;
/* template */

var __vue_render__$3q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.9,34.6A8,8,0,0,0,42.1,45.4l160,176A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "144",
      "y1": "40",
      "x2": "112",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "216",
      "x2": "144",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,40h24a8,8,0,0,1,8,8V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "144",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "112",
      "x2": "40",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,216H48a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3q = [];
/* style */

const __vue_inject_styles__$3q = undefined;
/* scoped */

const __vue_scope_id__$3q = undefined;
/* module identifier */

const __vue_module_identifier__$3q = undefined;
/* functional template */

const __vue_is_functional_template__$3q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3q,
  staticRenderFns: __vue_staticRenderFns__$3q
}, __vue_inject_styles__$3q, __vue_script__$3q, __vue_scope_id__$3q, __vue_is_functional_template__$3q, __vue_module_identifier__$3q, false, undefined, undefined, undefined);

var script$3p = Vue.extend({
  name: "PhShare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3p = script$3p;
/* template */

var __vue_render__$3p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75,176a96.1,96.1,0,0,1,93-72h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75,176a96.1,96.1,0,0,1,93-72h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,109.7l-48,48A8.3,8.3,0,0,1,176,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,152V112a87.9,87.9,0,0,0-85.2,66,8.1,8.1,0,0,1-7.8,6l-2-.3a8,8,0,0,1-5.7-9.7A103.9,103.9,0,0,1,168,96V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,109.7ZM192,208H40V88a8,8,0,0,0-16,0V208a16,16,0,0,0,16,16H192a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75,176a96.1,96.1,0,0,1,93-72h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75,176a96.1,96.1,0,0,1,93-72h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "176 152 224 104 176 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,216H40a8,8,0,0,1-8-8V88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75,176a96.1,96.1,0,0,1,93-72h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3p = [];
/* style */

const __vue_inject_styles__$3p = undefined;
/* scoped */

const __vue_scope_id__$3p = undefined;
/* module identifier */

const __vue_module_identifier__$3p = undefined;
/* functional template */

const __vue_is_functional_template__$3p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3p,
  staticRenderFns: __vue_staticRenderFns__$3p
}, __vue_inject_styles__$3p, __vue_script__$3p, __vue_scope_id__$3p, __vue_is_functional_template__$3p, __vue_module_identifier__$3p, false, undefined, undefined, undefined);

var script$3o = Vue.extend({
  name: "PhShareNetwork",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3o = script$3o;
/* template */

var __vue_render__$3o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.1",
      "y1": "73.3",
      "x2": "90.9",
      "y2": "110.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9",
      "y1": "145.3",
      "x2": "149.1",
      "y2": "182.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.1",
      "y1": "73.3",
      "x2": "90.9",
      "y2": "110.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9",
      "y1": "145.3",
      "x2": "149.1",
      "y2": "182.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,160a39.7,39.7,0,0,0-28.6,12.1l-46.1-29.6a40.3,40.3,0,0,0,0-29l46.1-29.6A40,40,0,1,0,136,56a41,41,0,0,0,2.7,14.5L92.6,100.1a40,40,0,1,0,0,55.8l46.1,29.6A41,41,0,0,0,136,200a40,40,0,1,0,40-40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.1",
      "y1": "73.3",
      "x2": "90.9",
      "y2": "110.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9",
      "y1": "145.3",
      "x2": "149.1",
      "y2": "182.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.1",
      "y1": "73.3",
      "x2": "90.9",
      "y2": "110.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9",
      "y1": "145.3",
      "x2": "149.1",
      "y2": "182.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "200",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "56",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "149.1",
      "y1": "73.3",
      "x2": "90.9",
      "y2": "110.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.9",
      "y1": "145.3",
      "x2": "149.1",
      "y2": "182.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3o = [];
/* style */

const __vue_inject_styles__$3o = undefined;
/* scoped */

const __vue_scope_id__$3o = undefined;
/* module identifier */

const __vue_module_identifier__$3o = undefined;
/* functional template */

const __vue_is_functional_template__$3o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3o,
  staticRenderFns: __vue_staticRenderFns__$3o
}, __vue_inject_styles__$3o, __vue_script__$3o, __vue_scope_id__$3o, __vue_is_functional_template__$3o, __vue_module_identifier__$3o, false, undefined, undefined, undefined);

var script$3n = Vue.extend({
  name: "PhShield",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3n = script$3n;
/* template */

var __vue_render__$3n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3n = [];
/* style */

const __vue_inject_styles__$3n = undefined;
/* scoped */

const __vue_scope_id__$3n = undefined;
/* module identifier */

const __vue_module_identifier__$3n = undefined;
/* functional template */

const __vue_is_functional_template__$3n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3n,
  staticRenderFns: __vue_staticRenderFns__$3n
}, __vue_inject_styles__$3n, __vue_script__$3n, __vue_scope_id__$3n, __vue_is_functional_template__$3n, __vue_module_identifier__$3n, false, undefined, undefined, undefined);

var script$3m = Vue.extend({
  name: "PhShieldCheck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3m = script$3m;
/* template */

var __vue_render__$3m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-30.5,69.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "172 104 113.3 160 84 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3m = [];
/* style */

const __vue_inject_styles__$3m = undefined;
/* scoped */

const __vue_scope_id__$3m = undefined;
/* module identifier */

const __vue_module_identifier__$3m = undefined;
/* functional template */

const __vue_is_functional_template__$3m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3m,
  staticRenderFns: __vue_staticRenderFns__$3m
}, __vue_inject_styles__$3m, __vue_script__$3m, __vue_scope_id__$3m, __vue_is_functional_template__$3m, __vue_module_identifier__$3m, false, undefined, undefined, undefined);

var script$3l = Vue.extend({
  name: "PhShieldCheckered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3l = script$3l;
/* template */

var __vue_render__$3l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.6",
      "y1": "128",
      "x2": "215.4",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,48h80a0,0,0,0,1,0,0v80a0,0,0,0,1,0,0H40a0,0,0,0,1,0,0V56A8,8,0,0,1,48,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M215.4,128c-7.1,73.7-71.5,98.8-84.9,103.2a7.7,7.7,0,0,1-2.5.4h0V128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.6",
      "y1": "128",
      "x2": "215.4",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM128,223.6C115.3,219.4,55.7,196,48.7,128H128V56h80v58.7a114.9,114.9,0,0,1-.7,13.3H128v95.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.6",
      "y1": "128",
      "x2": "215.4",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.6",
      "y1": "128",
      "x2": "215.4",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.6",
      "y1": "128",
      "x2": "215.4",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "128",
      "y2": "231.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3l = [];
/* style */

const __vue_inject_styles__$3l = undefined;
/* scoped */

const __vue_scope_id__$3l = undefined;
/* module identifier */

const __vue_module_identifier__$3l = undefined;
/* functional template */

const __vue_is_functional_template__$3l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3l,
  staticRenderFns: __vue_staticRenderFns__$3l
}, __vue_inject_styles__$3l, __vue_script__$3l, __vue_scope_id__$3l, __vue_is_functional_template__$3l, __vue_module_identifier__$3l, false, undefined, undefined, undefined);

var script$3k = Vue.extend({
  name: "PhShieldChevron",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3k = script$3k;
/* template */

var __vue_render__$3k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.4 172.1 128 120 53.6 172.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M202.4,172.1c-21.4,40.2-61.6,55.7-71.9,59.1a7.2,7.2,0,0,1-5,0c-10.3-3.4-50.5-18.9-71.9-59.1h0L128,120l74.4,52.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.4 172.1 128 120 53.6 172.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM48,56H208v58.7a115.1,115.1,0,0,1-8.8,45.4l-66.6-46.7a8.1,8.1,0,0,0-9.2,0L56.8,160.1A115.1,115.1,0,0,1,48,114.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.4 172.1 128 120 53.6 172.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.4 172.1 128 120 53.6 172.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "202.4 172.1 128 120 53.6 172.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3k = [];
/* style */

const __vue_inject_styles__$3k = undefined;
/* scoped */

const __vue_scope_id__$3k = undefined;
/* module identifier */

const __vue_module_identifier__$3k = undefined;
/* functional template */

const __vue_is_functional_template__$3k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3k,
  staticRenderFns: __vue_staticRenderFns__$3k
}, __vue_inject_styles__$3k, __vue_script__$3k, __vue_scope_id__$3k, __vue_is_functional_template__$3k, __vue_module_identifier__$3k, false, undefined, undefined, undefined);

var script$3j = Vue.extend({
  name: "PhShieldPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3j = script$3j;
/* template */

var __vue_render__$3j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-48,96H136v24a8,8,0,0,1-16,0V136H96a8,8,0,0,1,0-16h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "128",
      "x2": "160",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3j = [];
/* style */

const __vue_inject_styles__$3j = undefined;
/* scoped */

const __vue_scope_id__$3j = undefined;
/* module identifier */

const __vue_module_identifier__$3j = undefined;
/* functional template */

const __vue_is_functional_template__$3j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3j,
  staticRenderFns: __vue_staticRenderFns__$3j
}, __vue_inject_styles__$3j, __vue_script__$3j, __vue_scope_id__$3j, __vue_is_functional_template__$3j, __vue_module_identifier__$3j, false, undefined, undefined, undefined);

var script$3i = Vue.extend({
  name: "PhShieldSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3i = script$3i;
/* template */

var __vue_render__$3i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M109.4,48H208a8,8,0,0,1,8,8v58.7a126.2,126.2,0,0,1-7.1,42.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.9,237.9a8.2,8.2,0,0,1-5.4,2.1,8,8,0,0,1-5.9-2.6l-29.2-32.1A146.4,146.4,0,0,1,133,238.8a14.3,14.3,0,0,1-10,0c-15.2-5-91-34.7-91-124.1V56a15.9,15.9,0,0,1,7.5-13.5L27.6,29.4a7.9,7.9,0,0,1,.5-11.3,8,8,0,0,1,11.3.5l21.8,24h0L193.5,188.1h0l34.9,38.4A8,8,0,0,1,227.9,237.9Zm-28.3-66.8a7.9,7.9,0,0,0,5.9,2.6h1.3a7.9,7.9,0,0,0,6-4.6c7.4-16.3,11.2-34.6,11.2-54.3V56a16,16,0,0,0-16-16H98.5a8.1,8.1,0,0,0-7.3,4.8,8,8,0,0,0,1.4,8.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "33.5",
      "y1": "24",
      "x2": "222.5",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3i = [];
/* style */

const __vue_inject_styles__$3i = undefined;
/* scoped */

const __vue_scope_id__$3i = undefined;
/* module identifier */

const __vue_module_identifier__$3i = undefined;
/* functional template */

const __vue_is_functional_template__$3i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3i,
  staticRenderFns: __vue_staticRenderFns__$3i
}, __vue_inject_styles__$3i, __vue_script__$3i, __vue_scope_id__$3i, __vue_is_functional_template__$3i, __vue_module_identifier__$3i, false, undefined, undefined, undefined);

var script$3h = Vue.extend({
  name: "PhShieldStar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3h = script$3h;
/* template */

var __vue_render__$3h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90",
      "y1": "119.6",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.5",
      "y1": "164.4",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.5",
      "y1": "164.4",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166",
      "y1": "119.6",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-39.5,91.2-27.6,9L158,163.7a7.9,7.9,0,0,1-1.8,11.1,7.6,7.6,0,0,1-4.7,1.6,8.2,8.2,0,0,1-6.5-3.3l-17-23.5-17,23.5a8.2,8.2,0,0,1-6.5,3.3,7.6,7.6,0,0,1-4.7-1.6A7.9,7.9,0,0,1,98,163.7l17.1-23.5-27.6-9a8,8,0,0,1-5.2-10A8.1,8.1,0,0,1,92.4,116l27.6,9V96a8,8,0,0,1,16,0v29l27.6-9a8.1,8.1,0,0,1,10.1,5.2A8,8,0,0,1,168.5,131.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "151.5",
      "y1": "168.4",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166",
      "y1": "123.6",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3h = [];
/* style */

const __vue_inject_styles__$3h = undefined;
/* scoped */

const __vue_scope_id__$3h = undefined;
/* module identifier */

const __vue_module_identifier__$3h = undefined;
/* functional template */

const __vue_is_functional_template__$3h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3h,
  staticRenderFns: __vue_staticRenderFns__$3h
}, __vue_inject_styles__$3h, __vue_script__$3h, __vue_scope_id__$3h, __vue_is_functional_template__$3h, __vue_module_identifier__$3h, false, undefined, undefined, undefined);

var script$3g = Vue.extend({
  name: "PhShieldWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3g = script$3g;
/* template */

var __vue_render__$3g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "92",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM120,96a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "96",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3g = [];
/* style */

const __vue_inject_styles__$3g = undefined;
/* scoped */

const __vue_scope_id__$3g = undefined;
/* module identifier */

const __vue_module_identifier__$3g = undefined;
/* functional template */

const __vue_is_functional_template__$3g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3g,
  staticRenderFns: __vue_staticRenderFns__$3g
}, __vue_inject_styles__$3g, __vue_script__$3g, __vue_scope_id__$3g, __vue_is_functional_template__$3g, __vue_module_identifier__$3g, false, undefined, undefined, undefined);

var script$3f = Vue.extend({
  name: "PhShoppingBag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3f = script$3f;
/* template */

var __vue_render__$3f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-88,96A48,48,0,0,1,80,88a8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48,48,0,0,1,128,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,88a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3f = [];
/* style */

const __vue_inject_styles__$3f = undefined;
/* scoped */

const __vue_scope_id__$3f = undefined;
/* module identifier */

const __vue_module_identifier__$3f = undefined;
/* functional template */

const __vue_is_functional_template__$3f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3f,
  staticRenderFns: __vue_staticRenderFns__$3f
}, __vue_inject_styles__$3f, __vue_script__$3f, __vue_scope_id__$3f, __vue_is_functional_template__$3f, __vue_module_identifier__$3f, false, undefined, undefined, undefined);

var script$3e = Vue.extend({
  name: "PhShoppingBagOpen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3e = script$3e;
/* template */

var __vue_render__$3e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "224",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,124a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,80H224V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM128,160a48,48,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48,48,0,0,1,128,160ZM40,72V56H216V72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "224",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,112a40,40,0,0,1-80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3e = [];
/* style */

const __vue_inject_styles__$3e = undefined;
/* scoped */

const __vue_scope_id__$3e = undefined;
/* module identifier */

const __vue_module_identifier__$3e = undefined;
/* functional template */

const __vue_is_functional_template__$3e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3e,
  staticRenderFns: __vue_staticRenderFns__$3e
}, __vue_inject_styles__$3e, __vue_script__$3e, __vue_scope_id__$3e, __vue_is_functional_template__$3e, __vue_module_identifier__$3e, false, undefined, undefined, undefined);

var script$3d = Vue.extend({
  name: "PhShoppingCart",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3d = script$3d;
/* template */

var __vue_render__$3d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9,65.4l-12.2,66.9A24,24,0,0,1,188.1,152H72.1l4.4,24H184a24,24,0,1,1-24,24,23.6,23.6,0,0,1,1.4-8H102.6a23.6,23.6,0,0,1,1.4,8,24,24,0,1,1-42.2-15.6L34.1,32H16a8,8,0,0,1,0-16H34.1A16,16,0,0,1,49.8,29.1L54.7,56H216a7.9,7.9,0,0,1,6.1,2.9A7.7,7.7,0,0,1,223.9,65.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "204",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3d = [];
/* style */

const __vue_inject_styles__$3d = undefined;
/* scoped */

const __vue_scope_id__$3d = undefined;
/* module identifier */

const __vue_module_identifier__$3d = undefined;
/* functional template */

const __vue_is_functional_template__$3d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3d,
  staticRenderFns: __vue_staticRenderFns__$3d
}, __vue_inject_styles__$3d, __vue_script__$3d, __vue_scope_id__$3d, __vue_is_functional_template__$3d, __vue_module_identifier__$3d, false, undefined, undefined, undefined);

var script$3c = Vue.extend({
  name: "PhShoppingCartSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3c = script$3c;
/* template */

var __vue_render__$3c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-24.1,84.4A16,16,0,0,1,182.2,168H81.8a16,16,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,216a16,16,0,1,1-16-16A16,16,0,0,1,96,216Zm88-16a16,16,0,1,0,16,16A16,16,0,0,0,184,200ZM228.1,67.2a8.1,8.1,0,0,0-6.4-3.2H48.3L40.2,35.6A16.1,16.1,0,0,0,24.8,24H8A8,8,0,0,0,8,40H24.8l9.8,34.1v.2L61,166.6A24.1,24.1,0,0,0,84.1,184h95.8A24.1,24.1,0,0,0,203,166.6l26.4-92.4A8,8,0,0,0,228.1,67.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "14"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "216",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3c = [];
/* style */

const __vue_inject_styles__$3c = undefined;
/* scoped */

const __vue_scope_id__$3c = undefined;
/* module identifier */

const __vue_module_identifier__$3c = undefined;
/* functional template */

const __vue_is_functional_template__$3c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3c,
  staticRenderFns: __vue_staticRenderFns__$3c
}, __vue_inject_styles__$3c, __vue_script__$3c, __vue_scope_id__$3c, __vue_is_functional_template__$3c, __vue_module_identifier__$3c, false, undefined, undefined, undefined);

var script$3b = Vue.extend({
  name: "PhShower",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3b = script$3b;
/* template */

var __vue_render__$3b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M244,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,64.4,86.1a8,8,0,0,0-4.7,13.6l96.6,96.6a8,8,0,0,0,13.6-4.7L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M72,228a12,12,0,1,1-12-12A12,12,0,0,1,72,228Zm16-40a12,12,0,1,0,12,12A12,12,0,0,0,88,188Zm-60-4a12,12,0,1,0,12,12A12,12,0,0,0,28,184Zm40-16a12,12,0,1,0-12,12A12,12,0,0,0,68,168ZM248,32H219.3A15.9,15.9,0,0,0,208,36.7L180.2,64.5,54,85.6A15.7,15.7,0,0,0,41.4,96.5a16,16,0,0,0,3.9,16.1l98.1,98.1a16,16,0,0,0,11.2,4.7,16.2,16.2,0,0,0,4.9-.8A15.7,15.7,0,0,0,170.4,202L191.5,75.8h0L219.3,48H248a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "228",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "200",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "28",
      "cy": "196",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "168",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3b = [];
/* style */

const __vue_inject_styles__$3b = undefined;
/* scoped */

const __vue_scope_id__$3b = undefined;
/* module identifier */

const __vue_module_identifier__$3b = undefined;
/* functional template */

const __vue_is_functional_template__$3b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3b,
  staticRenderFns: __vue_staticRenderFns__$3b
}, __vue_inject_styles__$3b, __vue_script__$3b, __vue_scope_id__$3b, __vue_is_functional_template__$3b, __vue_module_identifier__$3b, false, undefined, undefined, undefined);

var script$3a = Vue.extend({
  name: "PhShuffle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3a = script$3a;
/* template */

var __vue_render__$3a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.8,93.9A63.7,63.7,0,0,1,200.9,72H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.1a63.7,63.7,0,0,0,48.1-21.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,178.3a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,208,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,200,208V192a72.2,72.2,0,0,1-57.7-30.2l-41.7-58.3A56.1,56.1,0,0,0,55.1,80H32a8,8,0,0,1,0-16H55.1a72.2,72.2,0,0,1,58.6,30.2l41.7,58.3A55.9,55.9,0,0,0,200,176V160a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM143,107a8,8,0,0,0,11.2-1.9l1.2-1.6A55.9,55.9,0,0,1,200,80V96a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,48V64a72.2,72.2,0,0,0-57.7,30.2l-1.1,1.6A8,8,0,0,0,143,107Zm-30,42a8,8,0,0,0-11.2,1.9l-1.2,1.6A56.1,56.1,0,0,1,55.1,176H32a8,8,0,0,0,0,16H55.1a72.2,72.2,0,0,0,58.6-30.2l1.1-1.6A8,8,0,0,0,113,149Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3a = [];
/* style */

const __vue_inject_styles__$3a = undefined;
/* scoped */

const __vue_scope_id__$3a = undefined;
/* module identifier */

const __vue_module_identifier__$3a = undefined;
/* functional template */

const __vue_is_functional_template__$3a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3a,
  staticRenderFns: __vue_staticRenderFns__$3a
}, __vue_inject_styles__$3a, __vue_script__$3a, __vue_scope_id__$3a, __vue_is_functional_template__$3a, __vue_module_identifier__$3a, false, undefined, undefined, undefined);

var script$39 = Vue.extend({
  name: "PhShuffleAngular",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$39 = script$39;
/* template */

var __vue_render__$39 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l13-18.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.6,93.6l13-18.2a7.8,7.8,0,0,1,6.5-3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,178.3a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,208,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,200,208V192H172.1a16.1,16.1,0,0,1-13-6.7L83.9,80H32a8,8,0,0,1,0-16H83.9a16.1,16.1,0,0,1,13,6.7L172.1,176H200V160a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM143,107a8,8,0,0,0,11.2-1.9L172.1,80H200V96a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,48V64H172.1a16.1,16.1,0,0,0-13,6.7L141.2,95.8A8,8,0,0,0,143,107Zm-30,42a8,8,0,0,0-11.2,1.9L83.9,176H32a8,8,0,0,0,0,16H83.9a16.1,16.1,0,0,0,13-6.7l17.9-25.1A8,8,0,0,0,113,149Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 48 232 72 208 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 160 232 184 208 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$39 = [];
/* style */

const __vue_inject_styles__$39 = undefined;
/* scoped */

const __vue_scope_id__$39 = undefined;
/* module identifier */

const __vue_module_identifier__$39 = undefined;
/* functional template */

const __vue_is_functional_template__$39 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$39 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$39,
  staticRenderFns: __vue_staticRenderFns__$39
}, __vue_inject_styles__$39, __vue_script__$39, __vue_scope_id__$39, __vue_is_functional_template__$39, __vue_module_identifier__$39, false, undefined, undefined, undefined);

var script$38 = Vue.extend({
  name: "PhShuffleSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$38 = script$38;
/* template */

var __vue_render__$38 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156.3",
      "y1": "99.7",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "99.7",
      "y2": "156.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.6",
      "y1": "105.4",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.4",
      "y2": "150.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,79.3,156.3,111a8,8,0,0,1-5.7,2.4A7.7,7.7,0,0,1,145,111a7.9,7.9,0,0,1,0-11.3L176.7,68,162.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48Zm-4.9,112.6a8.4,8.4,0,0,0-8.8,1.7L188,176.7,53.7,42.3A8.1,8.1,0,0,0,42.3,53.7L176.7,188l-14.4,14.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM99.7,145,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L111,156.3A8,8,0,0,0,99.7,145Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.6",
      "y1": "105.4",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.4",
      "y2": "150.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.6",
      "y1": "105.4",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.4",
      "y2": "150.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "168 48 208 48 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "208 168 208 208 168 208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "48",
      "x2": "208",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "150.6",
      "y1": "105.4",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "105.4",
      "y2": "150.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$38 = [];
/* style */

const __vue_inject_styles__$38 = undefined;
/* scoped */

const __vue_scope_id__$38 = undefined;
/* module identifier */

const __vue_module_identifier__$38 = undefined;
/* functional template */

const __vue_is_functional_template__$38 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$38 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$38,
  staticRenderFns: __vue_staticRenderFns__$38
}, __vue_inject_styles__$38, __vue_script__$38, __vue_scope_id__$38, __vue_is_functional_template__$38, __vue_module_identifier__$38, false, undefined, undefined, undefined);

var script$37 = Vue.extend({
  name: "PhSidebar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$37 = script$37;
/* template */

var __vue_render__$37 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "88",
      "x2": "88",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "88",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,208a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H88V208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "56",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "56",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM64,152H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16ZM216,200H88V56H216V200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "56",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "56",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "56",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "56",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "80",
      "x2": "56",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "112",
      "x2": "56",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "144",
      "x2": "56",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$37 = [];
/* style */

const __vue_inject_styles__$37 = undefined;
/* scoped */

const __vue_scope_id__$37 = undefined;
/* module identifier */

const __vue_module_identifier__$37 = undefined;
/* functional template */

const __vue_is_functional_template__$37 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$37 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$37,
  staticRenderFns: __vue_staticRenderFns__$37
}, __vue_inject_styles__$37, __vue_script__$37, __vue_scope_id__$37, __vue_is_functional_template__$37, __vue_module_identifier__$37, false, undefined, undefined, undefined);

var script$36 = Vue.extend({
  name: "PhSidebarSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$36 = script$36;
/* template */

var __vue_render__$36 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,208a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H88V208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H88V56H216V200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "88",
      "y1": "48",
      "x2": "88",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$36 = [];
/* style */

const __vue_inject_styles__$36 = undefined;
/* scoped */

const __vue_scope_id__$36 = undefined;
/* module identifier */

const __vue_module_identifier__$36 = undefined;
/* functional template */

const __vue_is_functional_template__$36 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$36 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$36,
  staticRenderFns: __vue_staticRenderFns__$36
}, __vue_inject_styles__$36, __vue_script__$36, __vue_scope_id__$36, __vue_is_functional_template__$36, __vue_module_identifier__$36, false, undefined, undefined, undefined);

var script$35 = Vue.extend({
  name: "PhSignIn",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$35 = script$35;
/* template */

var __vue_render__$35 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94 170 136 128 94 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94 170 136 128 94 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M141.7,133.7l-42,42A8.3,8.3,0,0,1,94,178a7.7,7.7,0,0,1-3-.6,8,8,0,0,1-5-7.4V136H24a8,8,0,0,1,0-16H86V86a8,8,0,0,1,5-7.4,8.2,8.2,0,0,1,8.7,1.7l42,42A8.1,8.1,0,0,1,141.7,133.7ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94 170 136 128 94 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94 170 136 128 94 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "94 170 136 128 94 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "128",
      "x2": "136",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$35 = [];
/* style */

const __vue_inject_styles__$35 = undefined;
/* scoped */

const __vue_scope_id__$35 = undefined;
/* module identifier */

const __vue_module_identifier__$35 = undefined;
/* functional template */

const __vue_is_functional_template__$35 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$35 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$35,
  staticRenderFns: __vue_staticRenderFns__$35
}, __vue_inject_styles__$35, __vue_script__$35, __vue_scope_id__$35, __vue_is_functional_template__$35, __vue_module_identifier__$35, false, undefined, undefined, undefined);

var script$34 = Vue.extend({
  name: "PhSignOut",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$34 = script$34;
/* template */

var __vue_render__$34 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174 86 216 128 174 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174 86 216 128 174 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.7,133.7l-42,42A8.3,8.3,0,0,1,174,178a7.7,7.7,0,0,1-3-.6,8,8,0,0,1-5-7.4V136H104a8,8,0,0,1,0-16h62V86a8,8,0,0,1,5-7.4,8.2,8.2,0,0,1,8.7,1.7l42,42A8.1,8.1,0,0,1,221.7,133.7ZM104,208H48V48h56a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16h56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174 86 216 128 174 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174 86 216 128 174 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "174 86 216 128 174 170",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$34 = [];
/* style */

const __vue_inject_styles__$34 = undefined;
/* scoped */

const __vue_scope_id__$34 = undefined;
/* module identifier */

const __vue_module_identifier__$34 = undefined;
/* functional template */

const __vue_is_functional_template__$34 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$34 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$34,
  staticRenderFns: __vue_staticRenderFns__$34
}, __vue_inject_styles__$34, __vue_script__$34, __vue_scope_id__$34, __vue_is_functional_template__$34, __vue_module_identifier__$34, false, undefined, undefined, undefined);

var script$33 = Vue.extend({
  name: "PhSignpost",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$33 = script$33;
/* template */

var __vue_render__$33 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.9,117.4l-36,40A8.1,8.1,0,0,1,204,160H136v64a8,8,0,0,1-16,0V160H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64h80V32a8,8,0,0,1,16,0V64h68a8.1,8.1,0,0,1,5.9,2.6l36,40A8,8,0,0,1,245.9,117.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$33 = [];
/* style */

const __vue_inject_styles__$33 = undefined;
/* scoped */

const __vue_scope_id__$33 = undefined;
/* module identifier */

const __vue_module_identifier__$33 = undefined;
/* functional template */

const __vue_is_functional_template__$33 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$33 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$33,
  staticRenderFns: __vue_staticRenderFns__$33
}, __vue_inject_styles__$33, __vue_script__$33, __vue_scope_id__$33, __vue_is_functional_template__$33, __vue_module_identifier__$33, false, undefined, undefined, undefined);

var script$32 = Vue.extend({
  name: "PhSimCard",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$32 = script$32;
/* template */

var __vue_render__$32 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "124",
      "width": "80",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "164",
      "x2": "128",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM200,216H56V40h92.7L200,91.3V216Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,112H80a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V120A8,8,0,0,0,176,112Zm-56,64a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "80",
      "y": "120",
      "width": "96",
      "height": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "152",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "152",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$32 = [];
/* style */

const __vue_inject_styles__$32 = undefined;
/* scoped */

const __vue_scope_id__$32 = undefined;
/* module identifier */

const __vue_module_identifier__$32 = undefined;
/* functional template */

const __vue_is_functional_template__$32 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$32 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$32,
  staticRenderFns: __vue_staticRenderFns__$32
}, __vue_inject_styles__$32, __vue_script__$32, __vue_scope_id__$32, __vue_is_functional_template__$32, __vue_module_identifier__$32, false, undefined, undefined, undefined);

var script$31 = Vue.extend({
  name: "PhSketchLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$31 = script$31;
/* template */

var __vue_render__$31 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.1 104 128 224 78.9 104 128 40 177.1 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "184 40 128 40 78.9 104 128 224 240 104 184 40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.1 104 128 224 78.9 104 128 40 177.1 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246,98.7l-56-64a8,8,0,0,0-6-2.7H72a8,8,0,0,0-6,2.7l-56,64a8.1,8.1,0,0,0,.2,10.8l112,120a8,8,0,0,0,11.6,0l112-120A8.1,8.1,0,0,0,246,98.7ZM222.4,96H181L144.2,48h36.2ZM73.5,112l30.6,74.6L34.4,112Zm109,0h39.1l-69.7,74.6ZM75.6,48h36.2L75,96H33.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.1 104 128 224 78.9 104 128 40 177.1 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.1 104 128 224 78.9 104 128 40 177.1 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "72 40 184 40 240 104 128 224 16 104 72 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "177.1 104 128 224 78.9 104 128 40 177.1 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "240",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$31 = [];
/* style */

const __vue_inject_styles__$31 = undefined;
/* scoped */

const __vue_scope_id__$31 = undefined;
/* module identifier */

const __vue_module_identifier__$31 = undefined;
/* functional template */

const __vue_is_functional_template__$31 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$31 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$31,
  staticRenderFns: __vue_staticRenderFns__$31
}, __vue_inject_styles__$31, __vue_script__$31, __vue_scope_id__$31, __vue_is_functional_template__$31, __vue_module_identifier__$31, false, undefined, undefined, undefined);

var script$30 = Vue.extend({
  name: "PhSkipBack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$30 = script$30;
/* template */

var __vue_render__$30 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,32a8,8,0,0,1,8,8v73.7L183.7,40.6A16,16,0,0,1,208,54.3V201.7a15.9,15.9,0,0,1-8.2,14,15.4,15.4,0,0,1-7.8,2,16.2,16.2,0,0,1-8.3-2.3L64,142.3V216a8,8,0,0,1-16,0V40A8,8,0,0,1,56,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$30 = [];
/* style */

const __vue_inject_styles__$30 = undefined;
/* scoped */

const __vue_scope_id__$30 = undefined;
/* module identifier */

const __vue_module_identifier__$30 = undefined;
/* functional template */

const __vue_is_functional_template__$30 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$30 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$30,
  staticRenderFns: __vue_staticRenderFns__$30
}, __vue_inject_styles__$30, __vue_script__$30, __vue_scope_id__$30, __vue_is_functional_template__$30, __vue_module_identifier__$30, false, undefined, undefined, undefined);

var script$2$ = Vue.extend({
  name: "PhSkipBackCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2$ = script$2$;
/* template */

var __vue_render__$2$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "156 156 120 128 156 100 156 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "100",
      "x2": "100",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm28,128-48-32,48-32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,136a8,8,0,0,1-4.2,7.1,8.5,8.5,0,0,1-3.8.9,8.7,8.7,0,0,1-4.4-1.3L108,137.6V160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0v22.4l43.6-29.1a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,164,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "108 128 156 96 156 160 108 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "96",
      "x2": "100",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2$ = [];
/* style */

const __vue_inject_styles__$2$ = undefined;
/* scoped */

const __vue_scope_id__$2$ = undefined;
/* module identifier */

const __vue_module_identifier__$2$ = undefined;
/* functional template */

const __vue_is_functional_template__$2$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2$,
  staticRenderFns: __vue_staticRenderFns__$2$
}, __vue_inject_styles__$2$, __vue_script__$2$, __vue_scope_id__$2$, __vue_is_functional_template__$2$, __vue_module_identifier__$2$, false, undefined, undefined, undefined);

var script$2_ = Vue.extend({
  name: "PhSkipForward",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2_ = script$2_;
/* template */

var __vue_render__$2_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40V216a8,8,0,0,1-16,0V142.3L72.3,215.4a16.2,16.2,0,0,1-8.3,2.3,15.4,15.4,0,0,1-7.8-2,15.9,15.9,0,0,1-8.2-14V54.3A16,16,0,0,1,72.3,40.6L192,113.7V40a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2_ = [];
/* style */

const __vue_inject_styles__$2_ = undefined;
/* scoped */

const __vue_scope_id__$2_ = undefined;
/* module identifier */

const __vue_module_identifier__$2_ = undefined;
/* functional template */

const __vue_is_functional_template__$2_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2_,
  staticRenderFns: __vue_staticRenderFns__$2_
}, __vue_inject_styles__$2_, __vue_script__$2_, __vue_scope_id__$2_, __vue_is_functional_template__$2_, __vue_module_identifier__$2_, false, undefined, undefined, undefined);

var script$2Z = Vue.extend({
  name: "PhSkipForwardCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Z = script$2Z;
/* template */

var __vue_render__$2Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "100 156 136 128 100 100 100 156",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "100",
      "x2": "156",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM100,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,136a8,8,0,0,1-16,0V137.6l-43.6,29.1A8.7,8.7,0,0,1,100,168a8.5,8.5,0,0,1-3.8-.9A8,8,0,0,1,92,160V96a8,8,0,0,1,4.2-7.1,8.3,8.3,0,0,1,8.2.4L148,118.4V96a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "148 128 100 96 100 160 148 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "96",
      "x2": "156",
      "y2": "160",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Z = [];
/* style */

const __vue_inject_styles__$2Z = undefined;
/* scoped */

const __vue_scope_id__$2Z = undefined;
/* module identifier */

const __vue_module_identifier__$2Z = undefined;
/* functional template */

const __vue_is_functional_template__$2Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Z,
  staticRenderFns: __vue_staticRenderFns__$2Z
}, __vue_inject_styles__$2Z, __vue_script__$2Z, __vue_scope_id__$2Z, __vue_is_functional_template__$2Z, __vue_module_identifier__$2Z, false, undefined, undefined, undefined);

var script$2Y = Vue.extend({
  name: "PhSkull",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Y = script$2Y;
/* template */

var __vue_render__$2Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "132",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "132",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "224",
      "x2": "108",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "224",
      "x2": "148",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,224H76a8,8,0,0,1-8-8V185.7a92,92,0,0,1-32-69.5C35.9,66.1,76.6,24.7,126.7,24A92,92,0,0,1,188,185.7V216A8,8,0,0,1,180,224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A92,92,0,0,0,80,194.5V216a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V194.5A92,92,0,0,0,128,24ZM92,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,92,152Zm72,0a20,20,0,1,1,20-20A20.1,20.1,0,0,1,164,152Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M124.1,16.1c-51.6,1.9-93.7,43.6-96,95.3A99.4,99.4,0,0,0,72,198.9V216a16,16,0,0,0,16,16h8a4,4,0,0,0,4-4V204.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v24a4,4,0,0,0,4,4h16a4,4,0,0,0,4-4V204.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v24a4,4,0,0,0,4,4h8a16,16,0,0,0,16-16V198.9A100,100,0,0,0,124.1,16.1ZM92,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,92,152Zm72,0a20,20,0,1,1,20-20A20.1,20.1,0,0,1,164,152Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "92",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "132",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "224",
      "x2": "112",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "224",
      "x2": "144",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Y = [];
/* style */

const __vue_inject_styles__$2Y = undefined;
/* scoped */

const __vue_scope_id__$2Y = undefined;
/* module identifier */

const __vue_module_identifier__$2Y = undefined;
/* functional template */

const __vue_is_functional_template__$2Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Y,
  staticRenderFns: __vue_staticRenderFns__$2Y
}, __vue_inject_styles__$2Y, __vue_script__$2Y, __vue_scope_id__$2Y, __vue_is_functional_template__$2Y, __vue_module_identifier__$2Y, false, undefined, undefined, undefined);

var script$2X = Vue.extend({
  name: "PhSlackLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2X = script$2X;
/* template */

var __vue_render__$2X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
      "transform": "translate(304 160) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(24 328) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(24 328) rotate(-90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
      "transform": "translate(304 160) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(24 328) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.1,128A32,32,0,0,0,200,72a32.2,32.2,0,0,0-16,4.3V56a32,32,0,0,0-56-21.1A32,32,0,0,0,72,56a32.2,32.2,0,0,0,4.3,16H56a32,32,0,0,0-21.1,56A32,32,0,0,0,56,184a32.2,32.2,0,0,0,16-4.3V200a32,32,0,0,0,56,21.1A32,32,0,0,0,184,200a32.2,32.2,0,0,0-4.3-16H200a32,32,0,0,0,21.1-56ZM88,56a16,16,0,0,1,32,0V72H104A16,16,0,0,1,88,56ZM40,104A16,16,0,0,1,56,88h48a16,16,0,0,1,16,16v16H56A16,16,0,0,1,40,104Zm128,96a16,16,0,0,1-32,0V184h16A16,16,0,0,1,168,200Zm32-32H152a16,16,0,0,1-16-16V136h64a16,16,0,0,1,0,32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
      "transform": "translate(304 160) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128A24,24,0,0,1,176,104Z",
      "transform": "translate(24 328) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
      "transform": "translate(304 160) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(24 328) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
      "transform": "translate(184 24) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
      "transform": "translate(304 160) rotate(180)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
      "transform": "translate(24 328) rotate(-90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2X = [];
/* style */

const __vue_inject_styles__$2X = undefined;
/* scoped */

const __vue_scope_id__$2X = undefined;
/* module identifier */

const __vue_module_identifier__$2X = undefined;
/* functional template */

const __vue_is_functional_template__$2X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2X,
  staticRenderFns: __vue_staticRenderFns__$2X
}, __vue_inject_styles__$2X, __vue_script__$2X, __vue_scope_id__$2X, __vue_is_functional_template__$2X, __vue_module_identifier__$2X, false, undefined, undefined, undefined);

var script$2W = Vue.extend({
  name: "PhSliders",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2W = script$2W;
/* template */

var __vue_render__$2W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,65.4V40a8,8,0,0,0-16,0V65.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V110.6a24,24,0,0,0,0-45.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,168a24,24,0,0,0-16-22.6V40a8,8,0,0,0-16,0V145.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V190.6A24,24,0,0,0,224,168Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,113.4V40a8,8,0,0,0-16,0v73.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V158.6a24,24,0,0,0,0-45.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "108",
      "x2": "128",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "40",
      "x2": "128",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "188",
      "x2": "200",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "156",
      "x2": "56",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "40",
      "x2": "56",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "136",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2W = [];
/* style */

const __vue_inject_styles__$2W = undefined;
/* scoped */

const __vue_scope_id__$2W = undefined;
/* module identifier */

const __vue_module_identifier__$2W = undefined;
/* functional template */

const __vue_is_functional_template__$2W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2W,
  staticRenderFns: __vue_staticRenderFns__$2W
}, __vue_inject_styles__$2W, __vue_script__$2W, __vue_scope_id__$2W, __vue_is_functional_template__$2W, __vue_module_identifier__$2W, false, undefined, undefined, undefined);

var script$2V = Vue.extend({
  name: "PhSlidersHorizontal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2V = script$2V;
/* template */

var __vue_render__$2V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "148",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "188",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "172",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "124",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "148",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "188",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "172",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "124",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,164H194.8a28,28,0,0,0-53.6,0H40a8,8,0,0,0,0,16H141.2a28,28,0,0,0,53.6,0H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,92H77.2a28,28,0,0,0,53.6,0H216a8,8,0,0,0,0-16H130.8a28,28,0,0,0-53.6,0H40a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "148",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "188",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "172",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "124",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "148",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "188",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "172",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "124",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "148",
      "y1": "172",
      "x2": "40",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "188",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "172",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "84",
      "x2": "40",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "84",
      "x2": "124",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "104",
      "cy": "84",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2V = [];
/* style */

const __vue_inject_styles__$2V = undefined;
/* scoped */

const __vue_scope_id__$2V = undefined;
/* module identifier */

const __vue_module_identifier__$2V = undefined;
/* functional template */

const __vue_is_functional_template__$2V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2V,
  staticRenderFns: __vue_staticRenderFns__$2V
}, __vue_inject_styles__$2V, __vue_script__$2V, __vue_scope_id__$2V, __vue_is_functional_template__$2V, __vue_module_identifier__$2V, false, undefined, undefined, undefined);

var script$2U = Vue.extend({
  name: "PhSmiley",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2U = script$2U;
/* template */

var __vue_render__$2U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2U = [];
/* style */

const __vue_inject_styles__$2U = undefined;
/* scoped */

const __vue_scope_id__$2U = undefined;
/* module identifier */

const __vue_module_identifier__$2U = undefined;
/* functional template */

const __vue_is_functional_template__$2U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2U,
  staticRenderFns: __vue_staticRenderFns__$2U
}, __vue_inject_styles__$2U, __vue_script__$2U, __vue_scope_id__$2U, __vue_is_functional_template__$2U, __vue_module_identifier__$2U, false, undefined, undefined, undefined);

var script$2T = Vue.extend({
  name: "PhSmileyBlank",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2T = script$2T;
/* template */

var __vue_render__$2T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,120a12,12,0,1,1,12-12A12,12,0,0,1,92,120Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2T = [];
/* style */

const __vue_inject_styles__$2T = undefined;
/* scoped */

const __vue_scope_id__$2T = undefined;
/* module identifier */

const __vue_module_identifier__$2T = undefined;
/* functional template */

const __vue_is_functional_template__$2T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2T,
  staticRenderFns: __vue_staticRenderFns__$2T
}, __vue_inject_styles__$2T, __vue_script__$2T, __vue_scope_id__$2T, __vue_is_functional_template__$2T, __vue_module_identifier__$2T, false, undefined, undefined, undefined);

var script$2S = Vue.extend({
  name: "PhSmileyMeh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2S = script$2S;
/* template */

var __vue_render__$2S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm76,72H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm-4-48a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "160",
      "x2": "168",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2S = [];
/* style */

const __vue_inject_styles__$2S = undefined;
/* scoped */

const __vue_scope_id__$2S = undefined;
/* module identifier */

const __vue_module_identifier__$2S = undefined;
/* functional template */

const __vue_is_functional_template__$2S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2S,
  staticRenderFns: __vue_staticRenderFns__$2S
}, __vue_inject_styles__$2S, __vue_script__$2S, __vue_scope_id__$2S, __vue_is_functional_template__$2S, __vue_module_identifier__$2S, false, undefined, undefined, undefined);

var script$2R = Vue.extend({
  name: "PhSmileyNervous",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2R = script$2R;
/* template */

var __vue_render__$2R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "85.8 164.8 96 152 112 172 128 152 144 172 160 152 170.2 164.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm89,82.2a7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3L160,164.8,150.2,177a7.9,7.9,0,0,1-12.4,0L128,164.8,118.2,177a7.9,7.9,0,0,1-12.4,0L96,164.8,86.2,177a8,8,0,0,1-12.4-10l16-20a7.9,7.9,0,0,1,12.4,0l9.8,12.2,9.8-12.2a7.9,7.9,0,0,1,12.4,0l9.8,12.2,9.8-12.2a7.9,7.9,0,0,1,12.4,0l16,20A7.9,7.9,0,0,1,181,178.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2R = [];
/* style */

const __vue_inject_styles__$2R = undefined;
/* scoped */

const __vue_scope_id__$2R = undefined;
/* module identifier */

const __vue_module_identifier__$2R = undefined;
/* functional template */

const __vue_is_functional_template__$2R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2R,
  staticRenderFns: __vue_staticRenderFns__$2R
}, __vue_inject_styles__$2R, __vue_script__$2R, __vue_scope_id__$2R, __vue_is_functional_template__$2R, __vue_module_identifier__$2R, false, undefined, undefined, undefined);

var script$2Q = Vue.extend({
  name: "PhSmileySad",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2Q = script$2Q;
/* template */

var __vue_render__$2Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M165.3,169.8a48,48,0,0,0-74.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,176a48.1,48.1,0,0,0-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm81.6,86.9a7.6,7.6,0,0,1-4,1.1,7.7,7.7,0,0,1-6.9-4,40.1,40.1,0,0,0-69.4,0,8,8,0,1,1-13.8-8,56,56,0,0,1,97,0A8,8,0,0,1,173.6,182.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,176a48.1,48.1,0,0,0-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,176a48.1,48.1,0,0,0-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,176a48.1,48.1,0,0,0-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2Q = [];
/* style */

const __vue_inject_styles__$2Q = undefined;
/* scoped */

const __vue_scope_id__$2Q = undefined;
/* module identifier */

const __vue_module_identifier__$2Q = undefined;
/* functional template */

const __vue_is_functional_template__$2Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Q,
  staticRenderFns: __vue_staticRenderFns__$2Q
}, __vue_inject_styles__$2Q, __vue_script__$2Q, __vue_scope_id__$2Q, __vue_is_functional_template__$2Q, __vue_module_identifier__$2Q, false, undefined, undefined, undefined);

var script$2P = Vue.extend({
  name: "PhSmileySticker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2P = script$2P;
/* template */

var __vue_render__$2P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24a104,104,0,0,0,0,208,102.2,102.2,0,0,0,30.6-4.6,6.7,6.7,0,0,0,3.3-2l63.5-63.5a7.2,7.2,0,0,0,2-3.3A102.2,102.2,0,0,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "164",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2P = [];
/* style */

const __vue_inject_styles__$2P = undefined;
/* scoped */

const __vue_scope_id__$2P = undefined;
/* module identifier */

const __vue_module_identifier__$2P = undefined;
/* functional template */

const __vue_is_functional_template__$2P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2P,
  staticRenderFns: __vue_staticRenderFns__$2P
}, __vue_inject_styles__$2P, __vue_script__$2P, __vue_scope_id__$2P, __vue_is_functional_template__$2P, __vue_module_identifier__$2P, false, undefined, undefined, undefined);

var script$2O = Vue.extend({
  name: "PhSmileyWink",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2O = script$2O;
/* template */

var __vue_render__$2O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Zm3.5-40H148a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "92",
      "cy": "108",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "108",
      "x2": "176",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2O = [];
/* style */

const __vue_inject_styles__$2O = undefined;
/* scoped */

const __vue_scope_id__$2O = undefined;
/* module identifier */

const __vue_module_identifier__$2O = undefined;
/* functional template */

const __vue_is_functional_template__$2O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2O,
  staticRenderFns: __vue_staticRenderFns__$2O
}, __vue_inject_styles__$2O, __vue_script__$2O, __vue_scope_id__$2O, __vue_is_functional_template__$2O, __vue_module_identifier__$2O, false, undefined, undefined, undefined);

var script$2N = Vue.extend({
  name: "PhSmileyXEyes",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2N = script$2N;
/* template */

var __vue_render__$2N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "96",
      "x2": "148",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "148",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "96",
      "x2": "76",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "128",
      "x2": "76",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-18.3,98.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L88,123.3,77.7,133.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,112,66.3,101.7A8.1,8.1,0,0,1,77.7,90.3L88,100.7,98.3,90.3a8.1,8.1,0,0,1,11.4,11.4L99.3,112ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm61.7-69.7a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L168,123.3l-10.3,10.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L156.7,112l-10.4-10.3a8.1,8.1,0,0,1,11.4-11.4L168,100.7l10.3-10.4a8.1,8.1,0,0,1,11.4,11.4L179.3,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "96",
      "x2": "152",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "128",
      "x2": "152",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "96",
      "x2": "72",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "128",
      "x2": "72",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2N = [];
/* style */

const __vue_inject_styles__$2N = undefined;
/* scoped */

const __vue_scope_id__$2N = undefined;
/* module identifier */

const __vue_module_identifier__$2N = undefined;
/* functional template */

const __vue_is_functional_template__$2N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2N,
  staticRenderFns: __vue_staticRenderFns__$2N
}, __vue_inject_styles__$2N, __vue_script__$2N, __vue_scope_id__$2N, __vue_is_functional_template__$2N, __vue_module_identifier__$2N, false, undefined, undefined, undefined);

var script$2M = Vue.extend({
  name: "PhSnapchatLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2M = script$2M;
/* template */

var __vue_render__$2M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3",
      "y1": "122.7",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.7",
      "y1": "122.7",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3",
      "y1": "122.7",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.7",
      "y1": "122.7",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M243,194.5c-7.2,6.7-17.5,7.4-26.6,8-5.7.4-11.7.8-15.2,2.7s-6.8,6.7-10.2,11.3c-5.4,7.4-11.5,15.8-21.2,18.3s-18.6-1.9-26.8-5.7c-5.3-2.5-10.8-5.1-15-5.1s-9.7,2.6-15,5.1-13.7,6.4-21.2,6.4a27.7,27.7,0,0,1-5.6-.7c-9.7-2.5-15.8-10.9-21.2-18.3-3.4-4.6-6.8-9.4-10.2-11.3s-9.5-2.3-15.2-2.7c-9.1-.6-19.4-1.3-26.6-8a8,8,0,0,1,2.1-13.1c.3-.1,12.5-6,24.5-21.3a105.5,105.5,0,0,0,17.3-32.7l-19.9-8a8,8,0,1,1,6-14.8l18,7.2A160.5,160.5,0,0,0,64,80a64,64,0,0,1,128,0,160.5,160.5,0,0,0,3,31.8l18-7.2a8,8,0,0,1,6,14.8l-19.9,8a105.5,105.5,0,0,0,17.3,32.7c12.1,15.3,24.3,21.3,24.5,21.3a8,8,0,0,1,2.1,13.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3",
      "y1": "122.7",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.7",
      "y1": "122.7",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3",
      "y1": "122.7",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.7",
      "y1": "122.7",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "189.3",
      "y1": "122.7",
      "x2": "216",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "66.7",
      "y1": "122.7",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2M = [];
/* style */

const __vue_inject_styles__$2M = undefined;
/* scoped */

const __vue_scope_id__$2M = undefined;
/* module identifier */

const __vue_module_identifier__$2M = undefined;
/* functional template */

const __vue_is_functional_template__$2M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2M,
  staticRenderFns: __vue_staticRenderFns__$2M
}, __vue_inject_styles__$2M, __vue_script__$2M, __vue_scope_id__$2M, __vue_is_functional_template__$2M, __vue_module_identifier__$2M, false, undefined, undefined, undefined);

var script$2L = Vue.extend({
  name: "PhSnowflake",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2L = script$2L;
/* template */

var __vue_render__$2L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "96",
      "x2": "183.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.8 104.8 72.6 96 63.8 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.2 192.8 183.4 160 216.2 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "160",
      "x2": "183.4",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.8 192.8 72.6 160 39.8 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.2 104.8 183.4 96 192.2 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "96",
      "x2": "183.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.8 104.8 72.6 96 63.8 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.2 192.8 183.4 160 216.2 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "160",
      "x2": "183.4",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.8 192.8 72.6 160 39.8 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.2 104.8 183.4 96 192.2 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M223.9,149.1a7.9,7.9,0,0,1-5.6,9.8l-25.1,6.8,6.7,25a7.9,7.9,0,0,1-5.6,9.8l-2.1.3a8,8,0,0,1-7.7-5.9l-7.9-29.6L136,141.9v46.8l21.7,21.6a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,203.3l-18.3,18.4a8.1,8.1,0,0,1-11.4-11.4L120,188.7V141.9L79.4,165.3l-7.9,29.6a8,8,0,0,1-7.7,5.9l-2.1-.3a7.9,7.9,0,0,1-5.6-9.8l6.7-25-25.1-6.8a8,8,0,1,1,4.2-15.4l29.5,7.9L112,128,71.4,104.6l-29.5,7.9a7.6,7.6,0,0,1-2.1.3,8,8,0,0,1-2.1-15.7l25.1-6.8-6.7-25a8,8,0,0,1,15.4-4.2l7.9,29.6L120,114.1V67.3L98.3,45.7a8.1,8.1,0,0,1,11.4-11.4L128,52.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L136,67.3v46.8l40.6-23.4,7.9-29.6a8,8,0,1,1,15.4,4.2l-6.7,25,25.1,6.8a8,8,0,0,1-2.1,15.7l-2.1-.3-29.5-7.9L144,128l40.6,23.4,29.5-7.9A7.9,7.9,0,0,1,223.9,149.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "96",
      "x2": "183.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.8 104.8 72.6 96 63.8 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.2 192.8 183.4 160 216.2 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "160",
      "x2": "183.4",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.8 192.8 72.6 160 39.8 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.2 104.8 183.4 96 192.2 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "96",
      "x2": "183.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.8 104.8 72.6 96 63.8 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.2 192.8 183.4 160 216.2 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "160",
      "x2": "183.4",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.8 192.8 72.6 160 39.8 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.2 104.8 183.4 96 192.2 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 40 128 64 152 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 216 128 192 152 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "96",
      "x2": "183.4",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "39.8 104.8 72.6 96 63.8 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "192.2 192.8 183.4 160 216.2 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72.6",
      "y1": "160",
      "x2": "183.4",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "63.8 192.8 72.6 160 39.8 151.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "216.2 104.8 183.4 96 192.2 63.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2L = [];
/* style */

const __vue_inject_styles__$2L = undefined;
/* scoped */

const __vue_scope_id__$2L = undefined;
/* module identifier */

const __vue_module_identifier__$2L = undefined;
/* functional template */

const __vue_is_functional_template__$2L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2L,
  staticRenderFns: __vue_staticRenderFns__$2L
}, __vue_inject_styles__$2L, __vue_script__$2L, __vue_scope_id__$2L, __vue_is_functional_template__$2L, __vue_module_identifier__$2L, false, undefined, undefined, undefined);

var script$2K = Vue.extend({
  name: "PhSoccerBall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2K = script$2K;
/* template */

var __vue_render__$2K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 74 76.7 111.3 96.3 171.7 159.7 171.7 179.3 111.3 128 74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "74",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36.7",
      "y1": "98.3",
      "x2": "76.7",
      "y2": "111.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "71.6",
      "y1": "205.7",
      "x2": "96.3",
      "y2": "171.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184.4",
      "y1": "205.7",
      "x2": "159.7",
      "y2": "171.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "219.3",
      "y1": "98.3",
      "x2": "179.3",
      "y2": "111.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93,38.6a96.1,96.1,0,0,1,70,0h0L128,64,93,38.6Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.1,133.7a98.4,98.4,0,0,1,4.6-35.4A95.5,95.5,0,0,1,53.8,67.1h0l13.3,41.1-35,25.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.8,220.9a95.9,95.9,0,0,1-32.2-15.2,97,97,0,0,1-24.5-25.9H90.4l13.4,41.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.9,179.8a97,97,0,0,1-24.5,25.9,95.9,95.9,0,0,1-32.2,15.2h0l13.4-41.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M202.2,67.1a95.5,95.5,0,0,1,17.1,31.2,98.4,98.4,0,0,1,4.6,35.4h0l-35-25.5,13.3-41.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163 38.6 128 64 93 38.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.1",
      "y1": "108.2",
      "x2": "88.1",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.8 67.1 67.1 108.2 32.1 133.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.4",
      "y1": "179.8",
      "x2": "103.3",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.1 179.8 90.4 179.8 103.8 220.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.6",
      "y1": "179.8",
      "x2": "152.7",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.2 220.9 165.6 179.8 208.9 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.9",
      "y1": "108.2",
      "x2": "167.9",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.9 133.7 188.9 108.2 202.2 67.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.8,134.8a4.8,4.8,0,0,0,0-1.2c.1-1.9.2-3.7.2-5.6a103.2,103.2,0,0,0-23-65.1,5.5,5.5,0,0,0-1.4-1.7,103.9,103.9,0,0,0-41.1-29.8l-1.1-.4a103.4,103.4,0,0,0-74.8,0l-1.1.4A103.9,103.9,0,0,0,48.4,61.2,5.5,5.5,0,0,0,47,62.9,103.2,103.2,0,0,0,24,128c0,1.9.1,3.7.2,5.6a4.8,4.8,0,0,0,0,1.2,104.2,104.2,0,0,0,15.7,48.4,9.9,9.9,0,0,0,1.1,1.7,104.3,104.3,0,0,0,60.3,43.6h.3a104.2,104.2,0,0,0,52.8,0h.3A104.3,104.3,0,0,0,215,184.9a9.9,9.9,0,0,0,1.1-1.7A104.2,104.2,0,0,0,231.8,134.8ZM68.5,117.1l13.2,4.3,12.7,39.2-8.1,11.2H51.7a86.2,86.2,0,0,1-11.2-34.3Zm119,0,28,20.4a86.2,86.2,0,0,1-11.2,34.3H169.7l-8.1-11.2,12.7-39.2ZM193.2,69l-10.7,32.9-13.2,4.3L136,81.9V68.1l28-20.4A87,87,0,0,1,193.2,69ZM92,47.7l28,20.4V81.9L86.7,106.2l-13.2-4.3L62.8,69A87,87,0,0,1,92,47.7Zm18,166.4L99.3,181.2l8.1-11.2h41.2l8.1,11.2L146,214.1a86.2,86.2,0,0,1-36,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163 38.6 128 64 93 38.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.1",
      "y1": "108.2",
      "x2": "88.1",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.8 67.1 67.1 108.2 32.1 133.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.4",
      "y1": "179.8",
      "x2": "103.3",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.1 179.8 90.4 179.8 103.8 220.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.6",
      "y1": "179.8",
      "x2": "152.7",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.2 220.9 165.6 179.8 208.9 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.9",
      "y1": "108.2",
      "x2": "167.9",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.9 133.7 188.9 108.2 202.2 67.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163 38.6 128 64 93 38.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.1",
      "y1": "108.2",
      "x2": "88.1",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.8 67.1 67.1 108.2 32.1 133.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.4",
      "y1": "179.8",
      "x2": "103.3",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.1 179.8 90.4 179.8 103.8 220.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.6",
      "y1": "179.8",
      "x2": "152.7",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.2 220.9 165.6 179.8 208.9 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.9",
      "y1": "108.2",
      "x2": "167.9",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.9 133.7 188.9 108.2 202.2 67.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "64",
      "x2": "128",
      "y2": "86",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "163 38.6 128 64 93 38.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "67.1",
      "y1": "108.2",
      "x2": "88.1",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "53.8 67.1 67.1 108.2 32.1 133.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "90.4",
      "y1": "179.8",
      "x2": "103.3",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "47.1 179.8 90.4 179.8 103.8 220.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "165.6",
      "y1": "179.8",
      "x2": "152.7",
      "y2": "162",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152.2 220.9 165.6 179.8 208.9 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.9",
      "y1": "108.2",
      "x2": "167.9",
      "y2": "115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "223.9 133.7 188.9 108.2 202.2 67.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2K = [];
/* style */

const __vue_inject_styles__$2K = undefined;
/* scoped */

const __vue_scope_id__$2K = undefined;
/* module identifier */

const __vue_module_identifier__$2K = undefined;
/* functional template */

const __vue_is_functional_template__$2K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2K,
  staticRenderFns: __vue_staticRenderFns__$2K
}, __vue_inject_styles__$2K, __vue_script__$2K, __vue_scope_id__$2K, __vue_is_functional_template__$2K, __vue_module_identifier__$2K, false, undefined, undefined, undefined);

var script$2J = Vue.extend({
  name: "PhSortAscending",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2J = script$2J;
/* template */

var __vue_render__$2J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 168 184 208 224 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "112",
      "x2": "184",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "184",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "104",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 168 184 208 224 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "112",
      "x2": "184",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "184",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "104",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.7,173.7l-40,40a8.2,8.2,0,0,1-11.4,0l-40-40a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,144,160h32V112a8,8,0,0,1,16,0v48h32a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,173.7ZM120,120H48a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM48,72H184a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 168 184 208 224 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "112",
      "x2": "184",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "184",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "104",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 168 184 208 224 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "112",
      "x2": "184",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "184",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "104",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 168 184 208 224 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "112",
      "x2": "184",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "184",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "104",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2J = [];
/* style */

const __vue_inject_styles__$2J = undefined;
/* scoped */

const __vue_scope_id__$2J = undefined;
/* module identifier */

const __vue_module_identifier__$2J = undefined;
/* functional template */

const __vue_is_functional_template__$2J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2J,
  staticRenderFns: __vue_staticRenderFns__$2J
}, __vue_inject_styles__$2J, __vue_script__$2J, __vue_scope_id__$2J, __vue_is_functional_template__$2J, __vue_module_identifier__$2J, false, undefined, undefined, undefined);

var script$2I = Vue.extend({
  name: "PhSortDescending",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2I = script$2I;
/* template */

var __vue_render__$2I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 88 184 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "144",
      "x2": "184",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "104",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "184",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 88 184 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "144",
      "x2": "184",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "104",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "184",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.4,91a8,8,0,0,1-7.4,5H192v48a8,8,0,0,1-16,0V96H144a8.1,8.1,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l40-40a8.1,8.1,0,0,1,11.4,0l40,40A8.2,8.2,0,0,1,231.4,91ZM48,136h72a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm0-64h56a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16ZM184,184H48a8,8,0,0,0,0,16H184a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 88 184 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "144",
      "x2": "184",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "104",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "184",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 88 184 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "144",
      "x2": "184",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "104",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "184",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 88 184 48 224 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "144",
      "x2": "184",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "64",
      "x2": "104",
      "y2": "64",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "192",
      "x2": "184",
      "y2": "192",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2I = [];
/* style */

const __vue_inject_styles__$2I = undefined;
/* scoped */

const __vue_scope_id__$2I = undefined;
/* module identifier */

const __vue_module_identifier__$2I = undefined;
/* functional template */

const __vue_is_functional_template__$2I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2I,
  staticRenderFns: __vue_staticRenderFns__$2I
}, __vue_inject_styles__$2I, __vue_script__$2I, __vue_scope_id__$2I, __vue_is_functional_template__$2I, __vue_module_identifier__$2I, false, undefined, undefined, undefined);

var script$2H = Vue.extend({
  name: "PhSpade",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2H = script$2H;
/* template */

var __vue_render__$2H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,232H96l8.7-46.2A52.1,52.1,0,0,1,28,140C28,88,128,24,128,24S228,88,228,140a52.1,52.1,0,0,1-76.7,45.8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,140a56,56,0,0,1-56,56,55.2,55.2,0,0,1-25.9-6.4L162,225.5a7.8,7.8,0,0,1-1.1,7.2,7.9,7.9,0,0,1-6.4,3.3h-53a7.9,7.9,0,0,1-6.4-3.3,7.8,7.8,0,0,1-1.1-7.2l11.9-35.9A55.2,55.2,0,0,1,80,196a56,56,0,0,1-56-56C24,86.4,121.7,23.3,125.8,20.6a4.3,4.3,0,0,1,4.4,0C134.3,23.3,232,86.4,232,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2H = [];
/* style */

const __vue_inject_styles__$2H = undefined;
/* scoped */

const __vue_scope_id__$2H = undefined;
/* module identifier */

const __vue_module_identifier__$2H = undefined;
/* functional template */

const __vue_is_functional_template__$2H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2H,
  staticRenderFns: __vue_staticRenderFns__$2H
}, __vue_inject_styles__$2H, __vue_script__$2H, __vue_scope_id__$2H, __vue_is_functional_template__$2H, __vue_module_identifier__$2H, false, undefined, undefined, undefined);

var script$2G = Vue.extend({
  name: "PhSparkle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2G = script$2G;
/* template */

var __vue_render__$2G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.9,144a15.8,15.8,0,0,1-10.5,15l-52.2,19.2L127,230.4a16,16,0,0,1-30,0L77.8,178.2,25.6,159a16,16,0,0,1,0-30l52.2-19.2L97,57.6a16,16,0,0,1,30,0l19.2,52.2L198.4,129A15.8,15.8,0,0,1,208.9,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "16",
      "x2": "176",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "152",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "72",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "88",
      "x2": "208",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2G = [];
/* style */

const __vue_inject_styles__$2G = undefined;
/* scoped */

const __vue_scope_id__$2G = undefined;
/* module identifier */

const __vue_module_identifier__$2G = undefined;
/* functional template */

const __vue_is_functional_template__$2G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2G,
  staticRenderFns: __vue_staticRenderFns__$2G
}, __vue_inject_styles__$2G, __vue_script__$2G, __vue_scope_id__$2G, __vue_is_functional_template__$2G, __vue_module_identifier__$2G, false, undefined, undefined, undefined);

var script$2F = Vue.extend({
  name: "PhSpeakerHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2F = script$2F;
/* template */

var __vue_render__$2F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224.6,71.4a8,8,0,1,0-11.3,11.4,64.1,64.1,0,0,1,0,90.5,7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,80.2,80.2,0,0,0,0-113.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A7.8,7.8,0,0,0,160,224V32A8.1,8.1,0,0,0,155.5,24.8ZM32,96H72v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185,99.7a7.9,7.9,0,0,0,0,11.3,24.1,24.1,0,0,1,0,34,7.9,7.9,0,0,0,0,11.3,7.6,7.6,0,0,0,5.6,2.3,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6A8,8,0,0,0,185,99.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2F = [];
/* style */

const __vue_inject_styles__$2F = undefined;
/* scoped */

const __vue_scope_id__$2F = undefined;
/* module identifier */

const __vue_module_identifier__$2F = undefined;
/* functional template */

const __vue_is_functional_template__$2F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2F,
  staticRenderFns: __vue_staticRenderFns__$2F
}, __vue_inject_styles__$2F, __vue_script__$2F, __vue_scope_id__$2F, __vue_is_functional_template__$2F, __vue_module_identifier__$2F, false, undefined, undefined, undefined);

var script$2E = Vue.extend({
  name: "PhSpeakerLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2E = script$2E;
/* template */

var __vue_render__$2E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8.1,8.1,0,0,0,155.5,24.8ZM32,96H72v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196.3,99.7a8,8,0,0,0-11.3,0,7.9,7.9,0,0,0,0,11.3,24.1,24.1,0,0,1,0,34,7.9,7.9,0,0,0,0,11.3,7.6,7.6,0,0,0,5.6,2.3,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2E = [];
/* style */

const __vue_inject_styles__$2E = undefined;
/* scoped */

const __vue_scope_id__$2E = undefined;
/* module identifier */

const __vue_module_identifier__$2E = undefined;
/* functional template */

const __vue_is_functional_template__$2E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2E,
  staticRenderFns: __vue_staticRenderFns__$2E
}, __vue_inject_styles__$2E, __vue_script__$2E, __vue_scope_id__$2E, __vue_is_functional_template__$2E, __vue_module_identifier__$2E, false, undefined, undefined, undefined);

var script$2D = Vue.extend({
  name: "PhSpeakerNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2D = script$2D;
/* template */

var __vue_render__$2D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8ZM32,96H72v64H32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2D = [];
/* style */

const __vue_inject_styles__$2D = undefined;
/* scoped */

const __vue_scope_id__$2D = undefined;
/* module identifier */

const __vue_module_identifier__$2D = undefined;
/* functional template */

const __vue_is_functional_template__$2D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2D,
  staticRenderFns: __vue_staticRenderFns__$2D
}, __vue_inject_styles__$2D, __vue_script__$2D, __vue_scope_id__$2D, __vue_is_functional_template__$2D, __vue_module_identifier__$2D, false, undefined, undefined, undefined);

var script$2C = Vue.extend({
  name: "PhSpeakerSimpleHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2C = script$2C;
/* template */

var __vue_render__$2C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "88",
      "x2": "228",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,192,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,224,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2C = [];
/* style */

const __vue_inject_styles__$2C = undefined;
/* scoped */

const __vue_scope_id__$2C = undefined;
/* module identifier */

const __vue_module_identifier__$2C = undefined;
/* functional template */

const __vue_is_functional_template__$2C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2C,
  staticRenderFns: __vue_staticRenderFns__$2C
}, __vue_inject_styles__$2C, __vue_script__$2C, __vue_scope_id__$2C, __vue_is_functional_template__$2C, __vue_module_identifier__$2C, false, undefined, undefined, undefined);

var script$2B = Vue.extend({
  name: "PhSpeakerSimpleLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2B = script$2B;
/* template */

var __vue_render__$2B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,192,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2B = [];
/* style */

const __vue_inject_styles__$2B = undefined;
/* scoped */

const __vue_scope_id__$2B = undefined;
/* module identifier */

const __vue_module_identifier__$2B = undefined;
/* functional template */

const __vue_is_functional_template__$2B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2B,
  staticRenderFns: __vue_staticRenderFns__$2B
}, __vue_inject_styles__$2B, __vue_script__$2B, __vue_scope_id__$2B, __vue_is_functional_template__$2B, __vue_module_identifier__$2B, false, undefined, undefined, undefined);

var script$2A = Vue.extend({
  name: "PhSpeakerSimpleNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2A = script$2A;
/* template */

var __vue_render__$2A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2A = [];
/* style */

const __vue_inject_styles__$2A = undefined;
/* scoped */

const __vue_scope_id__$2A = undefined;
/* module identifier */

const __vue_module_identifier__$2A = undefined;
/* functional template */

const __vue_is_functional_template__$2A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2A,
  staticRenderFns: __vue_staticRenderFns__$2A
}, __vue_inject_styles__$2A, __vue_script__$2A, __vue_scope_id__$2A, __vue_is_functional_template__$2A, __vue_module_identifier__$2A, false, undefined, undefined, undefined);

var script$2z = Vue.extend({
  name: "PhSpeakerSimpleSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2z = script$2z;
/* template */

var __vue_render__$2z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "228",
      "y1": "88",
      "x2": "228",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.5 58.1 152 32 152 94.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "138.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,160a8,8,0,0,0,8-8V104a8,8,0,0,0-16,0v48A8,8,0,0,0,192,160Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,224,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L73.6,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V175.1l42.1,46.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.1,112.2a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V32a8,8,0,0,0-12.9-6.3l-39.9,31a8.1,8.1,0,0,0-1,11.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "88",
      "x2": "224",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2z = [];
/* style */

const __vue_inject_styles__$2z = undefined;
/* scoped */

const __vue_scope_id__$2z = undefined;
/* module identifier */

const __vue_module_identifier__$2z = undefined;
/* functional template */

const __vue_is_functional_template__$2z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2z,
  staticRenderFns: __vue_staticRenderFns__$2z
}, __vue_inject_styles__$2z, __vue_script__$2z, __vue_scope_id__$2z, __vue_is_functional_template__$2z, __vue_module_identifier__$2z, false, undefined, undefined, undefined);

var script$2y = Vue.extend({
  name: "PhSpeakerSimpleX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2y = script$2y;
/* template */

var __vue_render__$2y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.3,128l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L216,116.7,197.7,98.3a8.1,8.1,0,0,0-11.4,11.4L204.7,128l-18.4,18.3a8.1,8.1,0,0,0,0,11.4A8.3,8.3,0,0,0,192,160a8.5,8.5,0,0,0,5.7-2.3L216,139.3l18.3,18.4A8.3,8.3,0,0,0,240,160a8.5,8.5,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2y = [];
/* style */

const __vue_inject_styles__$2y = undefined;
/* scoped */

const __vue_scope_id__$2y = undefined;
/* module identifier */

const __vue_module_identifier__$2y = undefined;
/* functional template */

const __vue_is_functional_template__$2y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2y,
  staticRenderFns: __vue_staticRenderFns__$2y
}, __vue_inject_styles__$2y, __vue_script__$2y, __vue_scope_id__$2y, __vue_is_functional_template__$2y, __vue_module_identifier__$2y, false, undefined, undefined, undefined);

var script$2x = Vue.extend({
  name: "PhSpeakerSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2x = script$2x;
/* template */

var __vue_render__$2x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "118.5 58.1 152 32 152 94.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,5.5,37.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,4.7,96.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42.1,45.4L73.6,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3h0A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V175.1l42.1,46.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM72,160H32V96H72Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M146.1,112.2a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V32a8,8,0,0,0-12.9-6.3l-39.9,31a8.2,8.2,0,0,0-3,5.6,8.1,8.1,0,0,0,2,6.1Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224.5,71.4a8,8,0,0,0-11.3,0,8.1,8.1,0,0,0,0,11.4,63.9,63.9,0,0,1,0,90.5,8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3,79.9,79.9,0,0,0,0-113.2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,128a23.8,23.8,0,0,1-7.1,17,8,8,0,0,0,5.7,13.6,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6,8.1,8.1,0,0,0-11.4,0,8,8,0,0,0,0,11.3A23.8,23.8,0,0,1,192,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "112.2 63 152 32 152 106.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2x = [];
/* style */

const __vue_inject_styles__$2x = undefined;
/* scoped */

const __vue_scope_id__$2x = undefined;
/* module identifier */

const __vue_module_identifier__$2x = undefined;
/* functional template */

const __vue_is_functional_template__$2x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2x,
  staticRenderFns: __vue_staticRenderFns__$2x
}, __vue_inject_styles__$2x, __vue_script__$2x, __vue_scope_id__$2x, __vue_is_functional_template__$2x, __vue_module_identifier__$2x, false, undefined, undefined, undefined);

var script$2w = Vue.extend({
  name: "PhSpeakerX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2w = script$2w;
/* template */

var __vue_render__$2w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8ZM32,96H72v64H32Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M227.3,128l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L216,116.7,197.7,98.3a8.1,8.1,0,0,0-11.4,11.4L204.7,128l-18.4,18.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L216,139.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "152",
      "x2": "192",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "88",
      "x2": "80",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2w = [];
/* style */

const __vue_inject_styles__$2w = undefined;
/* scoped */

const __vue_scope_id__$2w = undefined;
/* module identifier */

const __vue_module_identifier__$2w = undefined;
/* functional template */

const __vue_is_functional_template__$2w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2w,
  staticRenderFns: __vue_staticRenderFns__$2w
}, __vue_inject_styles__$2w, __vue_script__$2w, __vue_scope_id__$2w, __vue_is_functional_template__$2w, __vue_module_identifier__$2w, false, undefined, undefined, undefined);

var script$2v = Vue.extend({
  name: "PhSpinner",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2v = script$2v;
/* template */

var __vue_render__$2v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "173.3",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "173.3",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.3,58.7a7.8,7.8,0,0,0,5.6-2.3l22.6-22.6a8,8,0,1,0-11.3-11.3L167.6,77.1a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,173.3,90.7ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.1,47.6a8,8,0,0,0-11.3,11.3l22.6,22.6a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,5.6-2.4,7.9,7.9,0,0,0,0-11.3ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.1,167.6,54.5,190.2a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l22.6-22.6a8,8,0,0,0-11.3-11.3ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.8,54.5A8,8,0,0,0,54.5,65.8L77.1,88.4a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "173.3",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "173.3",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "60.1",
      "x2": "173.3",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2v = [];
/* style */

const __vue_inject_styles__$2v = undefined;
/* scoped */

const __vue_scope_id__$2v = undefined;
/* module identifier */

const __vue_module_identifier__$2v = undefined;
/* functional template */

const __vue_is_functional_template__$2v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2v,
  staticRenderFns: __vue_staticRenderFns__$2v
}, __vue_inject_styles__$2v, __vue_script__$2v, __vue_scope_id__$2v, __vue_is_functional_template__$2v, __vue_module_identifier__$2v, false, undefined, undefined, undefined);

var script$2u = Vue.extend({
  name: "PhSpinnerGap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2u = script$2u;
/* template */

var __vue_render__$2u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.1,47.6a8,8,0,0,0-11.3,11.3l22.6,22.6a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,5.6-2.4,7.9,7.9,0,0,0,0-11.3ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.1,167.6,54.5,190.2a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l22.6-22.6a8,8,0,0,0-11.3-11.3ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.8,54.5A8,8,0,0,0,54.5,65.8L77.1,88.4a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "32",
      "x2": "128",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "192",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "195.9",
      "y1": "195.9",
      "x2": "173.3",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "224",
      "x2": "128",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "195.9",
      "x2": "82.7",
      "y2": "173.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "128",
      "x2": "64",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60.1",
      "y1": "60.1",
      "x2": "82.7",
      "y2": "82.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2u = [];
/* style */

const __vue_inject_styles__$2u = undefined;
/* scoped */

const __vue_scope_id__$2u = undefined;
/* module identifier */

const __vue_module_identifier__$2u = undefined;
/* functional template */

const __vue_is_functional_template__$2u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2u,
  staticRenderFns: __vue_staticRenderFns__$2u
}, __vue_inject_styles__$2u, __vue_script__$2u, __vue_scope_id__$2u, __vue_is_functional_template__$2u, __vue_module_identifier__$2u, false, undefined, undefined, undefined);

var script$2t = Vue.extend({
  name: "PhSpiral",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2t = script$2t;
/* template */

var __vue_render__$2t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M124,136a8,8,0,0,1-8-8,16,16,0,0,1,16-16,25.9,25.9,0,0,1,26,26,36,36,0,0,1-36,36,46,46,0,0,1-46-46,56,56,0,0,1,56-56,65.9,65.9,0,0,1,66,66,76,76,0,0,1-76,76,86,86,0,0,1-86-86,96,96,0,0,1,96-96A106.1,106.1,0,0,1,238,138",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,144a8,8,0,0,1-16,0,96.2,96.2,0,0,0-96-96,88.1,88.1,0,0,0-88,88,80.1,80.1,0,0,0,80,80,72.1,72.1,0,0,0,72-72,64.1,64.1,0,0,0-64-64,56,56,0,0,0-56,56,48,48,0,0,0,48,48,40,40,0,0,0,40-40,32.1,32.1,0,0,0-32-32,24.1,24.1,0,0,0-24,24,16,16,0,0,0,16,16,8,8,0,0,0,8-8,8,8,0,0,1,0-16,16,16,0,0,1,16,16,24.1,24.1,0,0,1-24,24,32.1,32.1,0,0,1-32-32,40,40,0,0,1,40-40,48,48,0,0,1,48,48,56,56,0,0,1-56,56,64.1,64.1,0,0,1-64-64,72.1,72.1,0,0,1,72-72,80.1,80.1,0,0,1,80,80,88.1,88.1,0,0,1-88,88,96.2,96.2,0,0,1-96-96A104.2,104.2,0,0,1,136,32,112.1,112.1,0,0,1,248,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2t = [];
/* style */

const __vue_inject_styles__$2t = undefined;
/* scoped */

const __vue_scope_id__$2t = undefined;
/* module identifier */

const __vue_module_identifier__$2t = undefined;
/* functional template */

const __vue_is_functional_template__$2t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2t,
  staticRenderFns: __vue_staticRenderFns__$2t
}, __vue_inject_styles__$2t, __vue_script__$2t, __vue_scope_id__$2t, __vue_is_functional_template__$2t, __vue_module_identifier__$2t, false, undefined, undefined, undefined);

var script$2s = Vue.extend({
  name: "PhSpotifyLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2s = script$2s;
/* template */

var __vue_render__$2s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1,116.3a112.1,112.1,0,0,0-102.3.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.7,155.3A68.4,68.4,0,0,0,128,148a67.6,67.6,0,0,0-30.8,7.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm28.6,144.7a8,8,0,0,1-10.7,3.5A39.6,39.6,0,0,0,128,168a39.1,39.1,0,0,0-18,4.3,8.6,8.6,0,0,1-3.6.8,8,8,0,0,1-3.6-15.1,55.3,55.3,0,0,1,25.2-6,56.1,56.1,0,0,1,25.1,5.9A8.1,8.1,0,0,1,156.6,168.7Zm14.8-28.3a7.9,7.9,0,0,1-10.7,3.4,72,72,0,0,0-65.4.1,8.4,8.4,0,0,1-3.7.9,7.9,7.9,0,0,1-7.1-4.4A8,8,0,0,1,88,129.6a87.9,87.9,0,0,1,79.9,0A8,8,0,0,1,171.4,140.4ZM186.2,112a7.9,7.9,0,0,1-10.7,3.4A104.3,104.3,0,0,0,128,104a103.2,103.2,0,0,0-47.6,11.5,7.7,7.7,0,0,1-3.6.9,8,8,0,0,1-3.7-15.1,120.2,120.2,0,0,1,109.7-.1A8,8,0,0,1,186.2,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2s = [];
/* style */

const __vue_inject_styles__$2s = undefined;
/* scoped */

const __vue_scope_id__$2s = undefined;
/* module identifier */

const __vue_module_identifier__$2s = undefined;
/* functional template */

const __vue_is_functional_template__$2s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2s,
  staticRenderFns: __vue_staticRenderFns__$2s
}, __vue_inject_styles__$2s, __vue_script__$2s, __vue_scope_id__$2s, __vue_is_functional_template__$2s, __vue_module_identifier__$2s, false, undefined, undefined, undefined);

var script$2r = Vue.extend({
  name: "PhSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2r = script$2r;
/* template */

var __vue_render__$2r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "32",
      "width": "192",
      "height": "192",
      "rx": "16"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2r = [];
/* style */

const __vue_inject_styles__$2r = undefined;
/* scoped */

const __vue_scope_id__$2r = undefined;
/* module identifier */

const __vue_module_identifier__$2r = undefined;
/* functional template */

const __vue_is_functional_template__$2r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2r,
  staticRenderFns: __vue_staticRenderFns__$2r
}, __vue_inject_styles__$2r, __vue_script__$2r, __vue_scope_id__$2r, __vue_is_functional_template__$2r, __vue_module_identifier__$2r, false, undefined, undefined, undefined);

var script$2q = Vue.extend({
  name: "PhSquareHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2q = script$2q;
/* template */

var __vue_render__$2q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "84",
      "x2": "212",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "172",
      "x2": "212",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,44h76a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36ZM52,52h76V204H52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "212",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "212",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "212",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "212",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "212",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "212",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "44",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "212",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "144",
      "x2": "212",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "212",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2q = [];
/* style */

const __vue_inject_styles__$2q = undefined;
/* scoped */

const __vue_scope_id__$2q = undefined;
/* module identifier */

const __vue_module_identifier__$2q = undefined;
/* functional template */

const __vue_is_functional_template__$2q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2q,
  staticRenderFns: __vue_staticRenderFns__$2q
}, __vue_inject_styles__$2q, __vue_script__$2q, __vue_scope_id__$2q, __vue_is_functional_template__$2q, __vue_module_identifier__$2q, false, undefined, undefined, undefined);

var script$2p = Vue.extend({
  name: "PhSquareHalfBottom",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2p = script$2p;
/* template */

var __vue_render__$2p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "84",
      "y1": "128",
      "x2": "84",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "172",
      "y1": "128",
      "x2": "172",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M44,128H212v76a8,8,0,0,1-8,8H52a8,8,0,0,1-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Zm0,16v76H52V52Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "80",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "176",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "80",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "176",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "80",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "112",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "128",
      "x2": "144",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "128",
      "x2": "176",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2p = [];
/* style */

const __vue_inject_styles__$2p = undefined;
/* scoped */

const __vue_scope_id__$2p = undefined;
/* module identifier */

const __vue_module_identifier__$2p = undefined;
/* functional template */

const __vue_is_functional_template__$2p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2p,
  staticRenderFns: __vue_staticRenderFns__$2p
}, __vue_inject_styles__$2p, __vue_script__$2p, __vue_scope_id__$2p, __vue_is_functional_template__$2p, __vue_module_identifier__$2p, false, undefined, undefined, undefined);

var script$2o = Vue.extend({
  name: "PhSquareLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2o = script$2o;
/* template */

var __vue_render__$2o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM168,96v64a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h64A8,8,0,0,1,168,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "96",
      "y": "96",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2o = [];
/* style */

const __vue_inject_styles__$2o = undefined;
/* scoped */

const __vue_scope_id__$2o = undefined;
/* module identifier */

const __vue_module_identifier__$2o = undefined;
/* functional template */

const __vue_is_functional_template__$2o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2o,
  staticRenderFns: __vue_staticRenderFns__$2o
}, __vue_inject_styles__$2o, __vue_script__$2o, __vue_scope_id__$2o, __vue_is_functional_template__$2o, __vue_module_identifier__$2o, false, undefined, undefined, undefined);

var script$2n = Vue.extend({
  name: "PhSquaresFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2n = script$2n;
/* template */

var __vue_render__$2n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "60",
      "height": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148",
      "y": "48",
      "width": "60",
      "height": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "148",
      "width": "60",
      "height": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148",
      "y": "148",
      "width": "60",
      "height": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "40",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "136",
      "y": "136",
      "width": "80",
      "height": "80",
      "rx": "8"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "48",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "48",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "144",
      "y": "144",
      "width": "64",
      "height": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2n = [];
/* style */

const __vue_inject_styles__$2n = undefined;
/* scoped */

const __vue_scope_id__$2n = undefined;
/* module identifier */

const __vue_module_identifier__$2n = undefined;
/* functional template */

const __vue_is_functional_template__$2n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2n,
  staticRenderFns: __vue_staticRenderFns__$2n
}, __vue_inject_styles__$2n, __vue_script__$2n, __vue_scope_id__$2n, __vue_is_functional_template__$2n, __vue_module_identifier__$2n, false, undefined, undefined, undefined);

var script$2m = Vue.extend({
  name: "PhStack",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2m = script$2m;
/* template */

var __vue_render__$2m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M220,169.1l-92,53.6L36,169.1a8,8,0,0,0-8,13.8l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,1,0-8-13.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,121.1l-92,53.6L36,121.1a8,8,0,0,0-8,13.8l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,1,0-8-13.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28,86.9l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,0,0,0-13.8l-96-56a7.7,7.7,0,0,0-8,0l-96,56a8,8,0,0,0,0,13.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "32 176 128 232 224 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "32 128 128 184 224 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "32 80 128 136 224 80 128 24 32 80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2m = [];
/* style */

const __vue_inject_styles__$2m = undefined;
/* scoped */

const __vue_scope_id__$2m = undefined;
/* module identifier */

const __vue_module_identifier__$2m = undefined;
/* functional template */

const __vue_is_functional_template__$2m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2m,
  staticRenderFns: __vue_staticRenderFns__$2m
}, __vue_inject_styles__$2m, __vue_script__$2m, __vue_scope_id__$2m, __vue_is_functional_template__$2m, __vue_module_identifier__$2m, false, undefined, undefined, undefined);

var script$2l = Vue.extend({
  name: "PhStackOverflowLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2l = script$2l;
/* template */

var __vue_render__$2l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 152 48 216 208 216 208 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "172",
      "x2": "168",
      "y2": "172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100.3",
      "y1": "102.2",
      "x2": "175.5",
      "y2": "129.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "135.7",
      "y1": "40.9",
      "x2": "197",
      "y2": "92.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 152 48 216 208 216 208 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95",
      "y1": "123.2",
      "x2": "172.2",
      "y2": "143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.3",
      "y1": "74",
      "x2": "184.6",
      "y2": "114",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "147.8",
      "y1": "31.8",
      "x2": "204.3",
      "y2": "88.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,152v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152a8,8,0,0,1,16,0v56H200V152a8,8,0,0,1,16,0ZM88,184h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Zm4.9-53.1,77.3,20.7a6.4,6.4,0,0,0,2,.3,8,8,0,0,0,2.1-15.7L97,115.5a8,8,0,1,0-4.1,15.4Zm18.4-50,69.3,40a7.3,7.3,0,0,0,4,1.1,7.7,7.7,0,0,0,6.9-4,7.9,7.9,0,0,0-2.9-10.9l-69.3-40a8,8,0,0,0-8,13.8ZM198.7,94a8,8,0,0,0,5.6,2.3A8.3,8.3,0,0,0,210,94a8,8,0,0,0,0-11.3L153.4,26.1a8,8,0,0,0-11.3,11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 152 48 216 208 216 208 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95",
      "y1": "123.2",
      "x2": "172.2",
      "y2": "143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.3",
      "y1": "74",
      "x2": "184.6",
      "y2": "114",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "147.8",
      "y1": "31.8",
      "x2": "204.3",
      "y2": "88.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 152 48 216 208 216 208 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95",
      "y1": "123.2",
      "x2": "172.2",
      "y2": "143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.3",
      "y1": "74",
      "x2": "184.6",
      "y2": "114",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "147.8",
      "y1": "31.8",
      "x2": "204.3",
      "y2": "88.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "48 152 48 216 208 216 208 152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "176",
      "x2": "168",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "95",
      "y1": "123.2",
      "x2": "172.2",
      "y2": "143.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "115.3",
      "y1": "74",
      "x2": "184.6",
      "y2": "114",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "147.8",
      "y1": "31.8",
      "x2": "204.3",
      "y2": "88.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2l = [];
/* style */

const __vue_inject_styles__$2l = undefined;
/* scoped */

const __vue_scope_id__$2l = undefined;
/* module identifier */

const __vue_module_identifier__$2l = undefined;
/* functional template */

const __vue_is_functional_template__$2l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2l,
  staticRenderFns: __vue_staticRenderFns__$2l
}, __vue_inject_styles__$2l, __vue_script__$2l, __vue_scope_id__$2l, __vue_is_functional_template__$2l, __vue_module_identifier__$2l, false, undefined, undefined, undefined);

var script$2k = Vue.extend({
  name: "PhStackSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2k = script$2k;
/* template */

var __vue_render__$2k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 100 128 164 240 100 128 36 16 100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 148 128 212 240 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M12,110.9l112,64a7.8,7.8,0,0,0,8,0l112-64a8,8,0,0,0,0-13.8l-112-64a7.7,7.7,0,0,0-8,0L12,97.1a8,8,0,0,0,0,13.8Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M236,137.1,128,198.8,20,137.1a8,8,0,0,0-8,13.8l112,64a7.8,7.8,0,0,0,8,0l112-64a8,8,0,1,0-8-13.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "16 104 128 168 240 104 128 40 16 104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 144 128 208 240 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2k = [];
/* style */

const __vue_inject_styles__$2k = undefined;
/* scoped */

const __vue_scope_id__$2k = undefined;
/* module identifier */

const __vue_module_identifier__$2k = undefined;
/* functional template */

const __vue_is_functional_template__$2k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2k,
  staticRenderFns: __vue_staticRenderFns__$2k
}, __vue_inject_styles__$2k, __vue_script__$2k, __vue_scope_id__$2k, __vue_is_functional_template__$2k, __vue_module_identifier__$2k, false, undefined, undefined, undefined);

var script$2j = Vue.extend({
  name: "PhStamp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2j = script$2j;
/* template */

var __vue_render__$2j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "224",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "176",
      "height": "48",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "224",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,224a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,224Zm0-80v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V144a16,16,0,0,1,16-16h54.1L86.4,54.7A32,32,0,0,1,117.7,16h20.6a32,32,0,0,1,31.3,38.7L153.9,128H208A16,16,0,0,1,224,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "224",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "224",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "224",
      "x2": "216",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "136",
      "width": "176",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2j = [];
/* style */

const __vue_inject_styles__$2j = undefined;
/* scoped */

const __vue_scope_id__$2j = undefined;
/* module identifier */

const __vue_module_identifier__$2j = undefined;
/* functional template */

const __vue_is_functional_template__$2j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2j,
  staticRenderFns: __vue_staticRenderFns__$2j
}, __vue_inject_styles__$2j, __vue_script__$2j, __vue_scope_id__$2j, __vue_is_functional_template__$2j, __vue_module_identifier__$2j, false, undefined, undefined, undefined);

var script$2i = Vue.extend({
  name: "PhStar",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2i = script$2i;
/* template */

var __vue_render__$2i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.2,97.4A16.4,16.4,0,0,0,224.6,86l-59.4-4.1-22-55.5A16.4,16.4,0,0,0,128,16h0a16.4,16.4,0,0,0-15.2,10.4L90.4,82.2,31.4,86A16.5,16.5,0,0,0,16.8,97.4,16.8,16.8,0,0,0,22,115.5l45.4,38.4L53.9,207a18.5,18.5,0,0,0,7,19.6,18,18,0,0,0,20.1.6l46.9-29.7h.2l50.5,31.9a16.1,16.1,0,0,0,8.7,2.6,16.5,16.5,0,0,0,15.8-20.8l-14.3-58.1L234,115.5A16.8,16.8,0,0,0,239.2,97.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2i = [];
/* style */

const __vue_inject_styles__$2i = undefined;
/* scoped */

const __vue_scope_id__$2i = undefined;
/* module identifier */

const __vue_module_identifier__$2i = undefined;
/* functional template */

const __vue_is_functional_template__$2i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2i,
  staticRenderFns: __vue_staticRenderFns__$2i
}, __vue_inject_styles__$2i, __vue_script__$2i, __vue_scope_id__$2i, __vue_is_functional_template__$2i, __vue_module_identifier__$2i, false, undefined, undefined, undefined);

var script$2h = Vue.extend({
  name: "PhStarFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2h = script$2h;
/* template */

var __vue_render__$2h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.6,128a15.8,15.8,0,0,1-10.5,15l-63.9,23.2L143,230.1a16,16,0,0,1-30,0L89.8,166.2,25.9,143a16,16,0,0,1,0-30L89.8,89.8,113,25.9a16,16,0,0,1,30,0l23.2,63.9L230.1,113A15.8,15.8,0,0,1,240.6,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2h = [];
/* style */

const __vue_inject_styles__$2h = undefined;
/* scoped */

const __vue_scope_id__$2h = undefined;
/* module identifier */

const __vue_module_identifier__$2h = undefined;
/* functional template */

const __vue_is_functional_template__$2h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2h,
  staticRenderFns: __vue_staticRenderFns__$2h
}, __vue_inject_styles__$2h, __vue_script__$2h, __vue_scope_id__$2h, __vue_is_functional_template__$2h, __vue_module_identifier__$2h, false, undefined, undefined, undefined);

var script$2g = Vue.extend({
  name: "PhStarHalf",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2g = script$2g;
/* template */

var __vue_render__$2g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "189.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M182,160.5l-1.2-4.7a8.7,8.7,0,0,1,2.9-8.8l3.4-2.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.6,90.5l-4.5-.3a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l4.3,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,189.4a8.7,8.7,0,0,0-4.4,1.3L76.7,220.4c-7.7,4.9-17.3-2.4-15-11.4l13.5-53.2a8.7,8.7,0,0,0-2.9-8.8L27.1,109.3c-5.9-4.9-2.9-14.8,4.8-15.3l59-3.8a8.3,8.3,0,0,0,7.3-5.4l22-55.4A8.3,8.3,0,0,1,128,24h0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "189.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.2,97.4A16.4,16.4,0,0,0,224.6,86l-59-3.8a.5.5,0,0,1-.4-.3l-22-55.5a16.3,16.3,0,0,0-30.4,0l-22,55.5a.5.5,0,0,1-.4.3L31.4,86A16.4,16.4,0,0,0,16.8,97.4,16.8,16.8,0,0,0,22,115.5l45.2,37.6a.8.8,0,0,1,.2.8L53.9,207a18.6,18.6,0,0,0,7,19.6,18,18,0,0,0,20.1.6l46.9-29.7h.2l50.5,31.9a16.1,16.1,0,0,0,8.7,2.6,16.8,16.8,0,0,0,9.5-3.1,16.6,16.6,0,0,0,6.3-17.7l-14.5-57.3a.8.8,0,0,1,.2-.8L234,115.5A16.8,16.8,0,0,0,239.2,97.4Zm-15.4,5.8-45.3,37.6a16.8,16.8,0,0,0-5.4,17l14.5,57.3c.1.4.1.5,0,.6a.7.7,0,0,1-.3.3h-.2L136.7,184a16,16,0,0,0-8.7-2.5V32c.1,0,.2,0,.3.3l22.1,55.5a16.4,16.4,0,0,0,14.1,10.4l59.1,3.8c.1,0,.2,0,.3.4S223.9,103.1,223.8,103.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "189.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "189.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "24",
      "x2": "128",
      "y2": "189.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2g = [];
/* style */

const __vue_inject_styles__$2g = undefined;
/* scoped */

const __vue_scope_id__$2g = undefined;
/* module identifier */

const __vue_module_identifier__$2g = undefined;
/* functional template */

const __vue_is_functional_template__$2g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2g,
  staticRenderFns: __vue_staticRenderFns__$2g
}, __vue_inject_styles__$2g, __vue_script__$2g, __vue_scope_id__$2g, __vue_is_functional_template__$2g, __vue_module_identifier__$2g, false, undefined, undefined, undefined);

var script$2f = Vue.extend({
  name: "PhSticker",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2f = script$2f;
/* template */

var __vue_render__$2f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32C208,160,160,208,136,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,32H88A56,56,0,0,0,32,88v80a56,56,0,0,0,56,56h48a6.9,6.9,0,0,0,2.5-.4c26.3-8.8,76.3-58.8,85.1-85.1a6.9,6.9,0,0,0,.4-2.5V88A56,56,0,0,0,168,32ZM136,207.4V176a40,40,0,0,1,40-40h31.4C198.2,157.6,157.6,198.2,136,207.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,216V184a48,48,0,0,1,48-48h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2f = [];
/* style */

const __vue_inject_styles__$2f = undefined;
/* scoped */

const __vue_scope_id__$2f = undefined;
/* module identifier */

const __vue_module_identifier__$2f = undefined;
/* functional template */

const __vue_is_functional_template__$2f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2f,
  staticRenderFns: __vue_staticRenderFns__$2f
}, __vue_inject_styles__$2f, __vue_script__$2f, __vue_scope_id__$2f, __vue_is_functional_template__$2f, __vue_module_identifier__$2f, false, undefined, undefined, undefined);

var script$2e = Vue.extend({
  name: "PhStop",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2e = script$2e;
/* template */

var __vue_render__$2e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "44",
      "width": "168",
      "height": "168",
      "rx": "14.9"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "52",
      "y": "52",
      "width": "152",
      "height": "152",
      "rx": "6.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2e = [];
/* style */

const __vue_inject_styles__$2e = undefined;
/* scoped */

const __vue_scope_id__$2e = undefined;
/* module identifier */

const __vue_module_identifier__$2e = undefined;
/* functional template */

const __vue_is_functional_template__$2e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2e,
  staticRenderFns: __vue_staticRenderFns__$2e
}, __vue_inject_styles__$2e, __vue_script__$2e, __vue_scope_id__$2e, __vue_is_functional_template__$2e, __vue_module_identifier__$2e, false, undefined, undefined, undefined);

var script$2d = Vue.extend({
  name: "PhStopCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2d = script$2d;
/* template */

var __vue_render__$2d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "108",
      "y": "108",
      "width": "40",
      "height": "40",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm24,120H104V104h48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm32,128a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "104",
      "y": "104",
      "width": "48",
      "height": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2d = [];
/* style */

const __vue_inject_styles__$2d = undefined;
/* scoped */

const __vue_scope_id__$2d = undefined;
/* module identifier */

const __vue_module_identifier__$2d = undefined;
/* functional template */

const __vue_is_functional_template__$2d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2d,
  staticRenderFns: __vue_staticRenderFns__$2d
}, __vue_inject_styles__$2d, __vue_script__$2d, __vue_scope_id__$2d, __vue_is_functional_template__$2d, __vue_module_identifier__$2d, false, undefined, undefined, undefined);

var script$2c = Vue.extend({
  name: "PhStorefront",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2c = script$2c;
/* template */

var __vue_render__$2c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,95.8v-.4a4.3,4.3,0,0,1-.1-.5v-.3c-.1-.2-.1-.4-.2-.6v-.2L217.4,43.6A16.2,16.2,0,0,0,202,32H54A16.2,16.2,0,0,0,38.6,43.6L24.3,93.8V94c-.1.2-.1.4-.2.6v.3a4.3,4.3,0,0,1-.1.5V112a40,40,0,0,0,16,32v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V144a40,40,0,0,0,16-32V95.8ZM40,104H88v8a24,24,0,0,1-35.1,21.3,8.7,8.7,0,0,0-1.8-1.1A23.9,23.9,0,0,1,40,112Zm112,8a24,24,0,0,1-48,0v-8h48Zm52.9,20.2a8.7,8.7,0,0,0-1.8,1.1A24,24,0,0,1,168,112v-8h48v8A23.9,23.9,0,0,1,204.9,132.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,96v16a32,32,0,0,1-64,0V96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2c = [];
/* style */

const __vue_inject_styles__$2c = undefined;
/* scoped */

const __vue_scope_id__$2c = undefined;
/* module identifier */

const __vue_module_identifier__$2c = undefined;
/* functional template */

const __vue_is_functional_template__$2c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2c,
  staticRenderFns: __vue_staticRenderFns__$2c
}, __vue_inject_styles__$2c, __vue_script__$2c, __vue_scope_id__$2c, __vue_is_functional_template__$2c, __vue_module_identifier__$2c, false, undefined, undefined, undefined);

var script$2b = Vue.extend({
  name: "PhStrategy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2b = script$2b;
/* template */

var __vue_render__$2b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "72",
      "cy": "184",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "76",
      "x2": "80",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "76",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "172",
      "x2": "216",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "172",
      "x2": "176",
      "y2": "212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "140 84 140 44 180 44",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,44l12,12c38.3,38.3,10.5,84-20,94.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "72",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "216",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 80 136 40 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40l16,16c40,40,8,88-24,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,188a36,36,0,1,1-36-36A36,36,0,0,1,104,188ZM34.3,117.7a8.2,8.2,0,0,0,11.4,0L60,103.3l14.3,14.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L71.3,92,85.7,77.7A8.1,8.1,0,0,0,74.3,66.3L60,80.7,45.7,66.3A8.1,8.1,0,0,0,34.3,77.7L48.7,92,34.3,106.3A8.1,8.1,0,0,0,34.3,117.7Zm173,70.3,14.4-14.3a8.1,8.1,0,0,0-11.4-11.4L196,176.7l-14.3-14.4a8.1,8.1,0,0,0-11.4,11.4L184.7,188l-14.4,14.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L196,199.3l14.3,14.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM157.7,50.3,155.3,48H176a8,8,0,0,0,0-16H136a8,8,0,0,0-8,8V80a8,8,0,0,0,16,0V59.3l2.3,2.4c18,17.9,17.9,35.4,14.8,46.9-4.7,16.7-19.4,31.7-35,35.6a8.1,8.1,0,0,0-5.9,9.7A8,8,0,0,0,128,160l1.9-.2c21.3-5.3,40.4-24.6,46.6-47S175.9,68.6,157.7,50.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "72",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "216",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 80 136 40 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40l16,16c40,40,8,88-24,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "72",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "216",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 80 136 40 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40l16,16c40,40,8,88-24,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "68",
      "cy": "188",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "80",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "72",
      "x2": "40",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "168",
      "x2": "216",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "168",
      "x2": "176",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "136 80 136 40 176 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,40l16,16c40,40,8,88-24,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2b = [];
/* style */

const __vue_inject_styles__$2b = undefined;
/* scoped */

const __vue_scope_id__$2b = undefined;
/* module identifier */

const __vue_module_identifier__$2b = undefined;
/* functional template */

const __vue_is_functional_template__$2b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2b,
  staticRenderFns: __vue_staticRenderFns__$2b
}, __vue_inject_styles__$2b, __vue_script__$2b, __vue_scope_id__$2b, __vue_is_functional_template__$2b, __vue_module_identifier__$2b, false, undefined, undefined, undefined);

var script$2a = Vue.extend({
  name: "PhStripeLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2a = script$2a;
/* template */

var __vue_render__$2a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,184c-24.7,0-44.1-14.1-44.1-32a8,8,0,0,1,16,0c0,7.6,11.6,16,28.1,16,13.3,0,28.1-6.6,28.1-16s-12.2-13.4-30.8-18.2c-8.7-2.2-17.7-4.5-24.8-8.2-9.7-5.2-14.6-12.4-14.6-21.6,0-18.2,18.1-32,42.1-32,17.2,0,31.9,7.2,38.5,18.7a8,8,0,0,1-3,10.9,7.9,7.9,0,0,1-10.9-3C148.9,92.2,139.3,88,128,88c-14.6,0-26.1,7-26.1,16,0,6.8,10.8,10.1,27.3,14.3,19.1,4.9,42.9,11,42.9,33.7C172.1,169.9,152.7,184,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2a = [];
/* style */

const __vue_inject_styles__$2a = undefined;
/* scoped */

const __vue_scope_id__$2a = undefined;
/* module identifier */

const __vue_module_identifier__$2a = undefined;
/* functional template */

const __vue_is_functional_template__$2a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2a,
  staticRenderFns: __vue_staticRenderFns__$2a
}, __vue_inject_styles__$2a, __vue_script__$2a, __vue_scope_id__$2a, __vue_is_functional_template__$2a, __vue_module_identifier__$2a, false, undefined, undefined, undefined);

var script$29 = Vue.extend({
  name: "PhStudent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$29 = script$29;
/* template */

var __vue_render__$29 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.2,216a88.1,88.1,0,0,1,147.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.3,82.2a56,56,0,1,1-82.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.2,216a88.1,88.1,0,0,1,147.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.3,82.2a56,56,0,1,1-82.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.5,56.4l-96-32a8.5,8.5,0,0,0-5,0l-95.9,32h-.2l-1,.5h-.1l-1,.6c0,.1-.1.1-.2.2l-.8.7h0l-.7.8c0,.1-.1.1-.1.2l-.6.9c0,.1,0,.1-.1.2l-.4.9h0l-.3,1.1v.3A3.7,3.7,0,0,0,24,64v80a8,8,0,0,0,16,0V75.1L73.6,86.3A63.2,63.2,0,0,0,64,120a64,64,0,0,0,30,54.2,96.1,96.1,0,0,0-46.5,37.4,8.1,8.1,0,0,0,2.4,11.1,7.9,7.9,0,0,0,11-2.3,80,80,0,0,1,134.2,0,8,8,0,0,0,6.7,3.6,7.5,7.5,0,0,0,4.3-1.3,8.1,8.1,0,0,0,2.4-11.1A96.1,96.1,0,0,0,162,174.2,64,64,0,0,0,192,120a63.2,63.2,0,0,0-9.6-33.7l44.1-14.7a8,8,0,0,0,0-15.2ZM128,168a48,48,0,0,1-48-48,48.6,48.6,0,0,1,9.3-28.5l36.2,12.1a8,8,0,0,0,5,0l36.2-12.1A48.6,48.6,0,0,1,176,120,48,48,0,0,1,128,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.2,216a88.1,88.1,0,0,1,147.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.3,82.2a56,56,0,1,1-82.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.2,216a88.1,88.1,0,0,1,147.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.3,82.2a56,56,0,1,1-82.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "32",
      "y1": "64",
      "x2": "32",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.2,216a88.1,88.1,0,0,1,147.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "224 64 128 96 32 64 128 32 224 64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.3,82.2a56,56,0,1,1-82.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$29 = [];
/* style */

const __vue_inject_styles__$29 = undefined;
/* scoped */

const __vue_scope_id__$29 = undefined;
/* module identifier */

const __vue_module_identifier__$29 = undefined;
/* functional template */

const __vue_is_functional_template__$29 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$29 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$29,
  staticRenderFns: __vue_staticRenderFns__$29
}, __vue_inject_styles__$29, __vue_script__$29, __vue_scope_id__$29, __vue_is_functional_template__$29, __vue_module_identifier__$29, false, undefined, undefined, undefined);

var script$28 = Vue.extend({
  name: "PhSuitcase",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$28 = script$28;
/* template */

var __vue_render__$28 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,212V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,72V216H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V216h48a8,8,0,0,0,8-8V80a8,8,0,0,0-8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,80h64V208H96Zm0-24a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$28 = [];
/* style */

const __vue_inject_styles__$28 = undefined;
/* scoped */

const __vue_scope_id__$28 = undefined;
/* module identifier */

const __vue_module_identifier__$28 = undefined;
/* functional template */

const __vue_is_functional_template__$28 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$28 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$28,
  staticRenderFns: __vue_staticRenderFns__$28
}, __vue_inject_styles__$28, __vue_script__$28, __vue_scope_id__$28, __vue_is_functional_template__$28, __vue_module_identifier__$28, false, undefined, undefined, undefined);

var script$27 = Vue.extend({
  name: "PhSuitcaseSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$27 = script$27;
/* template */

var __vue_render__$27 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "68",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,160v48a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,80v72H40V80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "144",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "160",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$27 = [];
/* style */

const __vue_inject_styles__$27 = undefined;
/* scoped */

const __vue_scope_id__$27 = undefined;
/* module identifier */

const __vue_module_identifier__$27 = undefined;
/* functional template */

const __vue_is_functional_template__$27 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$27 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$27,
  staticRenderFns: __vue_staticRenderFns__$27
}, __vue_inject_styles__$27, __vue_script__$27, __vue_scope_id__$27, __vue_is_functional_template__$27, __vue_module_identifier__$27, false, undefined, undefined, undefined);

var script$26 = Vue.extend({
  name: "PhSun",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$26 = script$26;
/* template */

var __vue_render__$26 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "28",
      "x2": "128",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.7",
      "y1": "57.3",
      "x2": "210",
      "y2": "46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.7",
      "y1": "198.7",
      "x2": "210",
      "y2": "210",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "228",
      "x2": "128",
      "y2": "244",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.3",
      "y1": "198.7",
      "x2": "46",
      "y2": "210",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "128",
      "x2": "12",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.3",
      "y1": "57.3",
      "x2": "46",
      "y2": "46",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "48.8",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "48.8",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "207.2",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "207.2",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "68"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,44a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V36A8,8,0,0,0,128,44Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.3,68.6a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3L54.5,43.1A8.1,8.1,0,1,0,43.1,54.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H36A8,8,0,0,0,44,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.3,187.4,43.1,201.5a8.1,8.1,0,0,0,0,11.4,8.5,8.5,0,0,0,5.7,2.3,8.3,8.3,0,0,0,5.7-2.3l14.1-14.2a8,8,0,0,0-11.3-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,212a8,8,0,0,0-8,8v20a8,8,0,0,0,16,0V220A8,8,0,0,0,128,212Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.7,187.4a8,8,0,0,0-11.3,11.3l14.1,14.2a8.3,8.3,0,0,0,5.7,2.3,8.5,8.5,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,120H220a8,8,0,0,0,0,16h20a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.1,70.9a7.8,7.8,0,0,0,5.6-2.3l14.2-14.1a8.1,8.1,0,0,0-11.4-11.4L187.4,57.3a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,193.1,70.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "48.8",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "48.8",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "207.2",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "207.2",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "48.8",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "48.8",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "207.2",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "207.2",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "48.8",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "16",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "48.8",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "207.2",
      "y2": "207.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "240",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "207.2",
      "y2": "48.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$26 = [];
/* style */

const __vue_inject_styles__$26 = undefined;
/* scoped */

const __vue_scope_id__$26 = undefined;
/* module identifier */

const __vue_module_identifier__$26 = undefined;
/* functional template */

const __vue_is_functional_template__$26 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$26 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$26,
  staticRenderFns: __vue_staticRenderFns__$26
}, __vue_inject_styles__$26, __vue_script__$26, __vue_scope_id__$26, __vue_is_functional_template__$26, __vue_module_identifier__$26, false, undefined, undefined, undefined);

var script$25 = Vue.extend({
  name: "PhSunDim",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$25 = script$25;
/* template */

var __vue_render__$25 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "28",
      "x2": "128",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.7",
      "y1": "57.3",
      "x2": "204.4",
      "y2": "51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "228",
      "y1": "128",
      "x2": "236",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "198.7",
      "y1": "198.7",
      "x2": "204.4",
      "y2": "204.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "228",
      "x2": "128",
      "y2": "236",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.3",
      "y1": "198.7",
      "x2": "51.6",
      "y2": "204.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28",
      "y1": "128",
      "x2": "20",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "57.3",
      "y1": "57.3",
      "x2": "51.6",
      "y2": "51.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "57.3",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "57.3",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "198.7",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "198.7",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "68"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,44a8,8,0,0,0,8-8V28a8,8,0,0,0-16,0v8A8,8,0,0,0,128,44Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.3,68.6a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3l-5.7-5.7A8,8,0,0,0,51.6,62.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,120H28a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.3,187.4l-5.7,5.7a8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l5.7-5.7a8,8,0,0,0-11.3-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,212a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A8,8,0,0,0,128,212Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.7,187.4a8,8,0,0,0-11.3,11.3l5.7,5.7a8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,8,8,0,0,0,0-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,120h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.1,70.9a7.8,7.8,0,0,0,5.6-2.3l5.7-5.7a8,8,0,1,0-11.3-11.3l-5.7,5.7a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,193.1,70.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "57.3",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "57.3",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "198.7",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "198.7",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "57.3",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "57.3",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "198.7",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "198.7",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "36",
      "x2": "128",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "62.9",
      "x2": "57.3",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "128",
      "x2": "28",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "62.9",
      "y1": "193.1",
      "x2": "57.3",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "220",
      "x2": "128",
      "y2": "228",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "193.1",
      "x2": "198.7",
      "y2": "198.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "128",
      "x2": "228",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.1",
      "y1": "62.9",
      "x2": "198.7",
      "y2": "57.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$25 = [];
/* style */

const __vue_inject_styles__$25 = undefined;
/* scoped */

const __vue_scope_id__$25 = undefined;
/* module identifier */

const __vue_module_identifier__$25 = undefined;
/* functional template */

const __vue_is_functional_template__$25 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$25 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$25,
  staticRenderFns: __vue_staticRenderFns__$25
}, __vue_inject_styles__$25, __vue_script__$25, __vue_scope_id__$25, __vue_is_functional_template__$25, __vue_module_identifier__$25, false, undefined, undefined, undefined);

var script$24 = Vue.extend({
  name: "PhSunHorizon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$24 = script$24;
/* template */

var __vue_render__$24 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.8",
      "y1": "59",
      "x2": "85.1",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43",
      "y1": "108.8",
      "x2": "24.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213",
      "y1": "108.8",
      "x2": "231.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.2",
      "y1": "59",
      "x2": "170.9",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.4,160A53.2,53.2,0,0,1,76,148a52,52,0,0,1,104,0,53.2,53.2,0,0,1-1.4,12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.2,160a60,60,0,1,1,115.6,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "92.8",
      "y1": "59",
      "x2": "85.1",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43",
      "y1": "108.8",
      "x2": "24.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213",
      "y1": "108.8",
      "x2": "231.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.2",
      "y1": "59",
      "x2": "170.9",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,160a60,60,0,1,1,115.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M77.7,43.6a8.1,8.1,0,0,1,4.4-10.5,7.9,7.9,0,0,1,10.4,4.4l7.7,18.4a8.1,8.1,0,0,1-4.3,10.5,8.5,8.5,0,0,1-3.1.6,8.2,8.2,0,0,1-7.4-4.9ZM21.5,108.5l18.4,7.7a8.5,8.5,0,0,0,3.1.6,8,8,0,0,0,3.1-15.4L27.6,93.7a8.1,8.1,0,0,0-10.5,4.4A7.9,7.9,0,0,0,21.5,108.5ZM213,116.8a8.5,8.5,0,0,0,3.1-.6l18.4-7.7a7.9,7.9,0,0,0,4.4-10.4,8.1,8.1,0,0,0-10.5-4.4l-18.5,7.7a8,8,0,0,0,3.1,15.4ZM160.1,66.4a8.5,8.5,0,0,0,3.1.6,8.2,8.2,0,0,0,7.4-4.9l7.7-18.5a8.1,8.1,0,0,0-4.4-10.5,7.9,7.9,0,0,0-10.4,4.4l-7.7,18.4A8.1,8.1,0,0,0,160.1,66.4ZM240,152H195.5a70.1,70.1,0,0,0,.5-8,68,68,0,0,0-136,0,70.1,70.1,0,0,0,.5,8H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-32,40H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.8",
      "y1": "59",
      "x2": "85.1",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43",
      "y1": "108.8",
      "x2": "24.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213",
      "y1": "108.8",
      "x2": "231.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.2",
      "y1": "59",
      "x2": "170.9",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,160a60,60,0,1,1,115.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.8",
      "y1": "59",
      "x2": "85.1",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43",
      "y1": "108.8",
      "x2": "24.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213",
      "y1": "108.8",
      "x2": "231.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.2",
      "y1": "59",
      "x2": "170.9",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,160a60,60,0,1,1,115.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "92.8",
      "y1": "59",
      "x2": "85.1",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "43",
      "y1": "108.8",
      "x2": "24.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213",
      "y1": "108.8",
      "x2": "231.5",
      "y2": "101.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "163.2",
      "y1": "59",
      "x2": "170.9",
      "y2": "40.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "160",
      "x2": "16",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "200",
      "x2": "48",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.2,160a60,60,0,1,1,115.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$24 = [];
/* style */

const __vue_inject_styles__$24 = undefined;
/* scoped */

const __vue_scope_id__$24 = undefined;
/* module identifier */

const __vue_module_identifier__$24 = undefined;
/* functional template */

const __vue_is_functional_template__$24 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$24 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$24,
  staticRenderFns: __vue_staticRenderFns__$24
}, __vue_inject_styles__$24, __vue_script__$24, __vue_scope_id__$24, __vue_is_functional_template__$24, __vue_module_identifier__$24, false, undefined, undefined, undefined);

var script$23 = Vue.extend({
  name: "PhSunglasses",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$23 = script$23;
/* template */

var __vue_render__$23 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "140",
      "x2": "93.5",
      "y2": "189.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "140",
      "x2": "213.5",
      "y2": "189.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "140",
      "x2": "215.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "140",
      "x2": "95.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,40a8,8,0,0,0,0,16,16,16,0,0,1,16,16v60H40V72A16,16,0,0,1,56,56a8,8,0,0,0,0-16A32.1,32.1,0,0,0,24,72v92a44,44,0,0,0,88,0V148h32v16a44,44,0,0,0,88,0V72A32.1,32.1,0,0,0,200,40ZM85,177a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4L58.3,161.7a8.1,8.1,0,0,1,11.4-11.4L85,165.7A7.9,7.9,0,0,1,85,177Zm120,0a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4l-15.4-15.3a8.1,8.1,0,0,1,11.4-11.4L205,165.7A7.9,7.9,0,0,1,205,177Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "140",
      "x2": "215.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "140",
      "x2": "95.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "140",
      "x2": "215.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "140",
      "x2": "95.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,140v24a36,36,0,0,1-72,0V140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "140",
      "x2": "215.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "140",
      "x2": "95.4",
      "y2": "187.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$23 = [];
/* style */

const __vue_inject_styles__$23 = undefined;
/* scoped */

const __vue_scope_id__$23 = undefined;
/* module identifier */

const __vue_module_identifier__$23 = undefined;
/* functional template */

const __vue_is_functional_template__$23 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$23 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$23,
  staticRenderFns: __vue_staticRenderFns__$23
}, __vue_inject_styles__$23, __vue_script__$23, __vue_scope_id__$23, __vue_is_functional_template__$23, __vue_module_identifier__$23, false, undefined, undefined, undefined);

var script$22 = Vue.extend({
  name: "PhSwap",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$22 = script$22;
/* template */

var __vue_render__$22 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 120 176 96 152 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H96a8,8,0,0,0-8,8V96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8V160h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 120 176 96 152 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48V152a16,16,0,0,1-16,16H112v16a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,112,136v16h96V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104h96v16a8.1,8.1,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.2,8.2,0,0,0-8.8-1.7A8,8,0,0,0,144,72V88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 120 176 96 152 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 120 176 96 152 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "104 136 80 160 104 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "152 120 176 96 152 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$22 = [];
/* style */

const __vue_inject_styles__$22 = undefined;
/* scoped */

const __vue_scope_id__$22 = undefined;
/* module identifier */

const __vue_module_identifier__$22 = undefined;
/* functional template */

const __vue_is_functional_template__$22 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$22 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$22,
  staticRenderFns: __vue_staticRenderFns__$22
}, __vue_inject_styles__$22, __vue_script__$22, __vue_scope_id__$22, __vue_is_functional_template__$22, __vue_module_identifier__$22, false, undefined, undefined, undefined);

var script$21 = Vue.extend({
  name: "PhSwatches",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$21 = script$21;
/* template */

var __vue_render__$21 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,162.5V208a8,8,0,0,1-8,8H72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "72",
      "y1": "180",
      "x2": "74.1",
      "y2": "168.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,162.5V208a8,8,0,0,1-8,8H72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M228.2,153,209,100.3a16,16,0,0,0-20.5-9.5l-59.9,21.8,11-62.8a16,16,0,0,0-2.6-12,16.2,16.2,0,0,0-10.3-6.6L71.5,21.5A16.1,16.1,0,0,0,53,34.5L28.8,171.7a45,45,0,0,0,7.7,33.9,43.4,43.4,0,0,0,28.7,17.9,51.6,51.6,0,0,0,6.7.5H212a16,16,0,0,0,16-16V164.3A15.7,15.7,0,0,0,228.2,153ZM72,192a12,12,0,1,1,12-12A12,12,0,0,1,72,192Zm140,16H123.7L212,175.9Zm-98.5-13.3a41,41,0,0,0,1.8-7.1l10.1-56.8,68.6-25,19.1,52.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,162.5V208a8,8,0,0,1-8,8H72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,162.5V208a8,8,0,0,1-8,8H72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M220,162.5V208a8,8,0,0,1-8,8H72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "72",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$21 = [];
/* style */

const __vue_inject_styles__$21 = undefined;
/* scoped */

const __vue_scope_id__$21 = undefined;
/* module identifier */

const __vue_module_identifier__$21 = undefined;
/* functional template */

const __vue_is_functional_template__$21 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$21 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$21,
  staticRenderFns: __vue_staticRenderFns__$21
}, __vue_inject_styles__$21, __vue_script__$21, __vue_scope_id__$21, __vue_is_functional_template__$21, __vue_module_identifier__$21, false, undefined, undefined, undefined);

var script$20 = Vue.extend({
  name: "PhSword",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$20 = script$20;
/* template */

var __vue_render__$20 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "72.2 128.2 152.2 40.2 216 40 215.8 103.8 127.8 183.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1,205.5,60.2,227.4a8,8,0,0,1-11.3,0L28.6,207.1a8,8,0,0,1,0-11.3l21.9-21.9a8,8,0,0,0,0-11.4L33.7,145.7a8,8,0,0,1,0-11.4l16.6-16.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-16.6,16.6a8,8,0,0,1-11.4,0L93.5,205.5A8,8,0,0,0,82.1,205.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M221.7,34.3A8.1,8.1,0,0,0,216,32h0l-63.8.2a8.1,8.1,0,0,0-6.2,2.9L75.6,120.3,67.3,112a16.1,16.1,0,0,0-22.6,0L32,124.7a15.9,15.9,0,0,0,0,22.6l20.9,20.9-30,29.9a16.2,16.2,0,0,0,0,22.7l12.3,12.3a16.3,16.3,0,0,0,22.7,0l29.9-30L108.7,224a16.1,16.1,0,0,0,22.6,0L144,211.3a15.9,15.9,0,0,0,0-22.6l-8.3-8.3L220.9,110a8.1,8.1,0,0,0,2.9-6.2L224,40A8.1,8.1,0,0,0,221.7,34.3ZM207.8,100l-83.5,69-13-13,54.4-54.3a8.1,8.1,0,0,0-11.4-11.4L100,144.7l-13-13,69-83.5,52-.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "156",
      "x2": "160",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$20 = [];
/* style */

const __vue_inject_styles__$20 = undefined;
/* scoped */

const __vue_scope_id__$20 = undefined;
/* module identifier */

const __vue_module_identifier__$20 = undefined;
/* functional template */

const __vue_is_functional_template__$20 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$20 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$20,
  staticRenderFns: __vue_staticRenderFns__$20
}, __vue_inject_styles__$20, __vue_script__$20, __vue_scope_id__$20, __vue_is_functional_template__$20, __vue_module_identifier__$20, false, undefined, undefined, undefined);

var script$1$ = Vue.extend({
  name: "PhSyringe",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1$ = script$1$;
/* template */

var __vue_render__$1$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "24",
      "x2": "232",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102",
      "y1": "98",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "126",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "184",
      "y1": "24",
      "x2": "232",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102",
      "y1": "98",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "126",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,77.7a8.2,8.2,0,0,1-11.4,0L208,59.3,179.3,88l34.4,34.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-6.3-6.4-84,84a16.1,16.1,0,0,1-11.3,4.7H51.3L29.7,237.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L40,204.7V155.3A16.1,16.1,0,0,1,44.7,144l11.2-11.2a4,4,0,0,1,5.6,0l28.8,28.9a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L72.8,121.5a4,4,0,0,1,0-5.6L91.9,96.8a4,4,0,0,1,5.6,0l28.8,28.9a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L108.8,85.5a4,4,0,0,1,0-5.6L128.7,60l-6.1-6.1a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L168,76.7,196.7,48,178.6,29.9a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2l48,48A8.1,8.1,0,0,1,237.7,77.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "24",
      "x2": "232",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102",
      "y1": "98",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "126",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "24",
      "x2": "232",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102",
      "y1": "98",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "126",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "184",
      "y1": "24",
      "x2": "232",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "48",
      "x2": "208",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "102",
      "y1": "98",
      "x2": "128",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "74",
      "y1": "126",
      "x2": "100",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "208",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "208",
      "x2": "24",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1$ = [];
/* style */

const __vue_inject_styles__$1$ = undefined;
/* scoped */

const __vue_scope_id__$1$ = undefined;
/* module identifier */

const __vue_module_identifier__$1$ = undefined;
/* functional template */

const __vue_is_functional_template__$1$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1$,
  staticRenderFns: __vue_staticRenderFns__$1$
}, __vue_inject_styles__$1$, __vue_script__$1$, __vue_scope_id__$1$, __vue_is_functional_template__$1$, __vue_module_identifier__$1$, false, undefined, undefined, undefined);

var script$1_ = Vue.extend({
  name: "PhTShirt",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1_ = script$1_;
/* template */

var __vue_render__$1_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h26.7a8.1,8.1,0,0,0,7.4-4.9l15.3-36.8a8.1,8.1,0,0,0-3.2-9.9L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H37.3a8.1,8.1,0,0,1-7.4-4.9L14.6,78.3a8.1,8.1,0,0,1,3.2-9.9L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.4,61.3,196,33.1h0a8,8,0,0,0-4-1.1H160a8,8,0,0,0-8,8,24,24,0,0,1-48,0,8,8,0,0,0-8-8H64a8,8,0,0,0-4,1.1h0L10.6,61.3a15.9,15.9,0,0,0-6.4,21l18.4,36.9A16,16,0,0,0,36.9,128H56v80a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V128h19.1a16,16,0,0,0,14.3-8.8l18.4-36.9A15.9,15.9,0,0,0,245.4,61.3ZM36.9,112,18.5,75.2,56,53.8V112Zm182.2,0H200V53.8l37.5,21.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1_ = [];
/* style */

const __vue_inject_styles__$1_ = undefined;
/* scoped */

const __vue_scope_id__$1_ = undefined;
/* module identifier */

const __vue_module_identifier__$1_ = undefined;
/* functional template */

const __vue_is_functional_template__$1_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1_,
  staticRenderFns: __vue_staticRenderFns__$1_
}, __vue_inject_styles__$1_, __vue_script__$1_, __vue_scope_id__$1_, __vue_is_functional_template__$1_, __vue_module_identifier__$1_, false, undefined, undefined, undefined);

var script$1Z = Vue.extend({
  name: "PhTable",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Z = script$1Z;
/* template */

var __vue_render__$1Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "104",
      "x2": "88",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "104",
      "width": "56",
      "height": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "104",
      "x2": "88",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM40,160H80v32H40Zm176,32H96V160H216v32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "104",
      "x2": "88",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "104",
      "x2": "88",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "104",
      "x2": "88",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Z = [];
/* style */

const __vue_inject_styles__$1Z = undefined;
/* scoped */

const __vue_scope_id__$1Z = undefined;
/* module identifier */

const __vue_module_identifier__$1Z = undefined;
/* functional template */

const __vue_is_functional_template__$1Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Z,
  staticRenderFns: __vue_staticRenderFns__$1Z
}, __vue_inject_styles__$1Z, __vue_script__$1Z, __vue_scope_id__$1Z, __vue_is_functional_template__$1Z, __vue_module_identifier__$1Z, false, undefined, undefined, undefined);

var script$1Y = Vue.extend({
  name: "PhTabs",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Y = script$1Y;
/* template */

var __vue_render__$1Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M12,168,34.3,93.7A8,8,0,0,1,42,88h60a8,8,0,0,1,7.7,5.7L132,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M148,88h10a8,8,0,0,1,7.7,5.7L188,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204,88h10a8,8,0,0,1,7.7,5.7L244,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "168",
      "x2": "244",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "168",
      "x2": "248",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,168a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8,8.5,8.5,0,0,1,.3-2.3H.4L22.6,91.4A16,16,0,0,1,38,80h84a16,16,0,0,1,15.4,11.4L158,160h31.2L170,96H160a8,8,0,0,1,0-16h10a16,16,0,0,1,15.4,11.4L206,160h31.2L218,96H208a8,8,0,0,1,0-16h10a16,16,0,0,1,15.4,11.4l22.2,74.2h.1A8.5,8.5,0,0,1,256,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "168",
      "x2": "248",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "168",
      "x2": "248",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "168",
      "x2": "248",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Y = [];
/* style */

const __vue_inject_styles__$1Y = undefined;
/* scoped */

const __vue_scope_id__$1Y = undefined;
/* module identifier */

const __vue_module_identifier__$1Y = undefined;
/* functional template */

const __vue_is_functional_template__$1Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Y,
  staticRenderFns: __vue_staticRenderFns__$1Y
}, __vue_inject_styles__$1Y, __vue_script__$1Y, __vue_scope_id__$1Y, __vue_is_functional_template__$1Y, __vue_module_identifier__$1Y, false, undefined, undefined, undefined);

var script$1X = Vue.extend({
  name: "PhTag",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1X = script$1X;
/* template */

var __vue_render__$1X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,126.9,135.5,22.4A15.9,15.9,0,0,0,121.1,18L40.4,34.2a7.9,7.9,0,0,0-6.2,6.2L18,121.1a15.9,15.9,0,0,0,4.4,14.4L126.9,240a15.9,15.9,0,0,0,22.6,0L240,149.5a15.9,15.9,0,0,0,0-22.6ZM84,96A12,12,0,1,1,96,84,12,12,0,0,1,84,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "84",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1X = [];
/* style */

const __vue_inject_styles__$1X = undefined;
/* scoped */

const __vue_scope_id__$1X = undefined;
/* module identifier */

const __vue_module_identifier__$1X = undefined;
/* functional template */

const __vue_is_functional_template__$1X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1X,
  staticRenderFns: __vue_staticRenderFns__$1X
}, __vue_inject_styles__$1X, __vue_script__$1X, __vue_scope_id__$1X, __vue_is_functional_template__$1X, __vue_module_identifier__$1X, false, undefined, undefined, undefined);

var script$1W = Vue.extend({
  name: "PhTagChevron",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1W = script$1W;
/* template */

var __vue_render__$1W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.7,136.9l-42.7,64h0a15.9,15.9,0,0,1-13.3,7.1H24a7.8,7.8,0,0,1-7-4.2,8,8,0,0,1,.3-8.2L62.4,128,17.3,60.4a8,8,0,0,1-.3-8.2A7.8,7.8,0,0,1,24,48H179.7A15.9,15.9,0,0,1,193,55.1l42.7,64A16,16,0,0,1,235.7,136.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1W = [];
/* style */

const __vue_inject_styles__$1W = undefined;
/* scoped */

const __vue_scope_id__$1W = undefined;
/* module identifier */

const __vue_module_identifier__$1W = undefined;
/* functional template */

const __vue_is_functional_template__$1W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1W,
  staticRenderFns: __vue_staticRenderFns__$1W
}, __vue_inject_styles__$1W, __vue_script__$1W, __vue_scope_id__$1W, __vue_is_functional_template__$1W, __vue_module_identifier__$1W, false, undefined, undefined, undefined);

var script$1V = Vue.extend({
  name: "PhTagSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1V = script$1V;
/* template */

var __vue_render__$1V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.7,123.6,201,55.1A15.9,15.9,0,0,0,187.7,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H187.7a15.9,15.9,0,0,0,13.3-7.1h0l45.7-68.5A8.2,8.2,0,0,0,246.7,123.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1V = [];
/* style */

const __vue_inject_styles__$1V = undefined;
/* scoped */

const __vue_scope_id__$1V = undefined;
/* module identifier */

const __vue_module_identifier__$1V = undefined;
/* functional template */

const __vue_is_functional_template__$1V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1V,
  staticRenderFns: __vue_staticRenderFns__$1V
}, __vue_inject_styles__$1V, __vue_script__$1V, __vue_scope_id__$1V, __vue_is_functional_template__$1V, __vue_module_identifier__$1V, false, undefined, undefined, undefined);

var script$1U = Vue.extend({
  name: "PhTarget",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1U = script$1U;
/* template */

var __vue_render__$1U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,94.1a47.9,47.9,0,1,0,0,67.8,47.1,47.1,0,0,0,13.2-24.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1A96.1,96.1,0,1,0,218,94.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M211.2,79.4a8,8,0,0,0-3.8,10.7,88,88,0,1,1-23.1-29.7L161.5,83.2a56,56,0,0,0-73.1,84.4h0a56,56,0,0,0,95.5-42.8,7.9,7.9,0,0,0-8.4-7.5,8,8,0,0,0-7.6,8.4,40,40,0,0,1-62,35.7l24-24,37.7-37.7h0l62.1-62a8.1,8.1,0,0,0-11.4-11.4L195.7,49A104,104,0,0,0,54.5,54.5a103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0A104,104,0,0,0,221.9,83.2,8,8,0,0,0,211.2,79.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "224",
      "y2": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1U = [];
/* style */

const __vue_inject_styles__$1U = undefined;
/* scoped */

const __vue_scope_id__$1U = undefined;
/* module identifier */

const __vue_module_identifier__$1U = undefined;
/* functional template */

const __vue_is_functional_template__$1U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1U,
  staticRenderFns: __vue_staticRenderFns__$1U
}, __vue_inject_styles__$1U, __vue_script__$1U, __vue_scope_id__$1U, __vue_is_functional_template__$1U, __vue_module_identifier__$1U, false, undefined, undefined, undefined);

var script$1T = Vue.extend({
  name: "PhTaxi",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1T = script$1T;
/* template */

var __vue_render__$1T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,68,146,33a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "124",
      "x2": "244",
      "y2": "124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,172v32a8,8,0,0,1-8,8H196a8,8,0,0,1-8-8V172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,172v32a8,8,0,0,1-8,8H36a8,8,0,0,1-8-8V172",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M228,124,194.4,71.7a8.1,8.1,0,0,0-6.8-3.7H68.4a8.1,8.1,0,0,0-6.8,3.7L28,124v48H228Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,112H228.6L201.2,64.1A15.9,15.9,0,0,0,187.4,56h-22l-12-29.9A15.7,15.7,0,0,0,138.6,16H117.4a15.7,15.7,0,0,0-14.8,10.1L90.6,56h-22a15.9,15.9,0,0,0-13.8,8.1L27.4,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM117.4,32h21.2l9.6,24H107.8ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm112,0H176a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "16",
      "y1": "120",
      "x2": "240",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "152",
      "x2": "80",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "192",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1T = [];
/* style */

const __vue_inject_styles__$1T = undefined;
/* scoped */

const __vue_scope_id__$1T = undefined;
/* module identifier */

const __vue_module_identifier__$1T = undefined;
/* functional template */

const __vue_is_functional_template__$1T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1T,
  staticRenderFns: __vue_staticRenderFns__$1T
}, __vue_inject_styles__$1T, __vue_script__$1T, __vue_scope_id__$1T, __vue_is_functional_template__$1T, __vue_module_identifier__$1T, false, undefined, undefined, undefined);

var script$1S = Vue.extend({
  name: "PhTelegramLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1S = script$1S;
/* template */

var __vue_render__$1S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.9",
      "x2": "224.1",
      "y2": "36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.9,224.1,36.6h0a7.8,7.8,0,0,0-6.2-.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.9",
      "x2": "224.1",
      "y2": "36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.3,31.7A16.1,16.1,0,0,0,215,29L30.4,101.5a15.8,15.8,0,0,0-10.1,16.3,16,16,0,0,0,12.8,14.3L80,141.4V200a16,16,0,0,0,9.9,14.8A16.6,16.6,0,0,0,96,216a15.8,15.8,0,0,0,11.3-4.7l26-25.9L172.6,220a16,16,0,0,0,10.5,4,14.2,14.2,0,0,0,5-.8,15.9,15.9,0,0,0,10.7-11.6L236.4,47.4A16,16,0,0,0,231.3,31.7ZM183.2,208l-82.4-72.5L219.5,49.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.9",
      "x2": "224.1",
      "y2": "36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.9",
      "x2": "224.1",
      "y2": "36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "134.9",
      "x2": "224.1",
      "y2": "36.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1S = [];
/* style */

const __vue_inject_styles__$1S = undefined;
/* scoped */

const __vue_scope_id__$1S = undefined;
/* module identifier */

const __vue_module_identifier__$1S = undefined;
/* functional template */

const __vue_is_functional_template__$1S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1S,
  staticRenderFns: __vue_staticRenderFns__$1S
}, __vue_inject_styles__$1S, __vue_script__$1S, __vue_scope_id__$1S, __vue_is_functional_template__$1S, __vue_module_identifier__$1S, false, undefined, undefined, undefined);

var script$1R = Vue.extend({
  name: "PhTelevision",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1R = script$1R;
/* template */

var __vue_render__$1R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "116",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "184",
      "cy": "164",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "140",
      "y1": "208",
      "x2": "140",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,208V72H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,64H147.3l34.4-34.3a8.1,8.1,0,0,0-11.4-11.4L128,60.7,85.7,18.3A8.1,8.1,0,0,0,74.3,29.7L108.7,64H40A16,16,0,0,0,24,80V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm0,136H160V80h56V200Zm-16-84a12,12,0,1,1-12-12A12,12,0,0,1,200,116Zm0,48a12,12,0,1,1-12-12A12,12,0,0,1,200,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "116",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "164",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "208",
      "x2": "152",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1R = [];
/* style */

const __vue_inject_styles__$1R = undefined;
/* scoped */

const __vue_scope_id__$1R = undefined;
/* module identifier */

const __vue_module_identifier__$1R = undefined;
/* functional template */

const __vue_is_functional_template__$1R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1R,
  staticRenderFns: __vue_staticRenderFns__$1R
}, __vue_inject_styles__$1R, __vue_script__$1R, __vue_scope_id__$1R, __vue_is_functional_template__$1R, __vue_module_identifier__$1R, false, undefined, undefined, undefined);

var script$1Q = Vue.extend({
  name: "PhTelevisionSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1Q = script$1Q;
/* template */

var __vue_render__$1Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,80V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64h68.7L74.3,29.7A8.1,8.1,0,0,1,85.7,18.3L128,60.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4L147.3,64H216A16,16,0,0,1,232,80Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "72",
      "width": "192",
      "height": "136",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 24 128 72 176 24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1Q = [];
/* style */

const __vue_inject_styles__$1Q = undefined;
/* scoped */

const __vue_scope_id__$1Q = undefined;
/* module identifier */

const __vue_module_identifier__$1Q = undefined;
/* functional template */

const __vue_is_functional_template__$1Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1Q, __vue_script__$1Q, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, undefined, undefined, undefined);

var script$1P = Vue.extend({
  name: "PhTennisBall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1P = script$1P;
/* template */

var __vue_render__$1P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.8,32A95.9,95.9,0,0,1,32,127.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128.2A95.9,95.9,0,0,0,128.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,128a95.9,95.9,0,0,1,95.8-96h0A95.9,95.9,0,0,1,32,127.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.2,224.2a95.9,95.9,0,0,1,95.8-96h0A95.9,95.9,0,0,1,128.2,224Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.8,32A95.9,95.9,0,0,1,32,127.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128.2A95.9,95.9,0,0,0,128.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,136h3.3a4,4,0,0,1,3.9,4.5,104.2,104.2,0,0,1-94.8,91.1A88,88,0,0,1,224,136Zm-73.5,14.5A102.9,102.9,0,0,1,224,120h3.1a4,4,0,0,0,4.1-4.4,104.1,104.1,0,0,0-90.9-90.9,4,4,0,0,0-4.4,4.1,103.7,103.7,0,0,1-30.4,76.7A102.9,102.9,0,0,1,32,136H28.9a4,4,0,0,0-4.1,4.4,104.1,104.1,0,0,0,90.9,90.9,4,4,0,0,0,4.4-4.1A103.7,103.7,0,0,1,150.5,150.5ZM94.2,94.2a87.6,87.6,0,0,0,25.7-65.7,4,4,0,0,0-4.5-3.7,104,104,0,0,0-90.6,90.6,4,4,0,0,0,3.8,4.5A87.8,87.8,0,0,0,94.2,94.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.8,32A95.9,95.9,0,0,1,32,127.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128.2A95.9,95.9,0,0,0,128.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.8,32A95.9,95.9,0,0,1,32,127.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128.2A95.9,95.9,0,0,0,128.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M127.8,32A95.9,95.9,0,0,1,32,127.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,128.2A95.9,95.9,0,0,0,128.2,224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1P = [];
/* style */

const __vue_inject_styles__$1P = undefined;
/* scoped */

const __vue_scope_id__$1P = undefined;
/* module identifier */

const __vue_module_identifier__$1P = undefined;
/* functional template */

const __vue_is_functional_template__$1P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1P, __vue_script__$1P, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, undefined, undefined, undefined);

var script$1O = Vue.extend({
  name: "PhTerminal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1O = script$1O;
/* template */

var __vue_render__$1O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M120,128a8,8,0,0,0-2.7-6l-72-64A8,8,0,1,0,34.7,70L100,128,34.7,186A8,8,0,0,0,40,200a8.1,8.1,0,0,0,5.3-2l72-64A8,8,0,0,0,120,128Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "40 64 112 128 40 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1O = [];
/* style */

const __vue_inject_styles__$1O = undefined;
/* scoped */

const __vue_scope_id__$1O = undefined;
/* module identifier */

const __vue_module_identifier__$1O = undefined;
/* functional template */

const __vue_is_functional_template__$1O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1O, __vue_script__$1O, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, undefined, undefined, undefined);

var script$1N = Vue.extend({
  name: "PhTerminalWindow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1N = script$1N;
/* template */

var __vue_render__$1N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "160",
      "x2": "176",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "160",
      "x2": "176",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16.97"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M215.5,39.5H40.5a17,17,0,0,0-17,17v143a17,17,0,0,0,17,17h175a17,17,0,0,0,17-17V56.5A17,17,0,0,0,215.5,39.5ZM121,134.2l-40,32a7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3A7.9,7.9,0,0,1,71,153.8L103.2,128,71,102.2A8,8,0,1,1,81,89.8l40,32a7.9,7.9,0,0,1,0,12.4ZM180,168H140a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "160",
      "x2": "176",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "160",
      "x2": "176",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "80 96 120 128 80 160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "160",
      "x2": "176",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16.97"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1N = [];
/* style */

const __vue_inject_styles__$1N = undefined;
/* scoped */

const __vue_scope_id__$1N = undefined;
/* module identifier */

const __vue_module_identifier__$1N = undefined;
/* functional template */

const __vue_is_functional_template__$1N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1N, __vue_script__$1N, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, undefined, undefined, undefined);

var script$1M = Vue.extend({
  name: "PhTestTube",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1M = script$1M;
/* template */

var __vue_render__$1M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0L94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,86.3l-60-60a8.1,8.1,0,0,0-11.4,0L62.4,130.3h0l-26.1,26a44.8,44.8,0,0,0,63.4,63.4l77.9-78h0L212.3,107l22.2-7.4a8.2,8.2,0,0,0,5.3-5.8A8.3,8.3,0,0,0,237.7,86.3Zm-32.2,6.1a9.4,9.4,0,0,0-3.2,1.9l-35.6,35.6c-2.1,1.6-17.9,11.6-43.1-1.1-11-5.5-20.8-7.6-29.2-7.9L172,43.3l45.2,45.2Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,136s20-16,52,0,52,0,52,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1M = [];
/* style */

const __vue_inject_styles__$1M = undefined;
/* scoped */

const __vue_scope_id__$1M = undefined;
/* module identifier */

const __vue_module_identifier__$1M = undefined;
/* functional template */

const __vue_is_functional_template__$1M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1M, __vue_script__$1M, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, undefined, undefined, undefined);

var script$1L = Vue.extend({
  name: "PhTextAa",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1L = script$1L;
/* template */

var __vue_render__$1L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "140 192 76 56 12 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "121.2",
      "y1": "152",
      "x2": "30.8",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "204",
      "cy": "167",
      "rx": "32",
      "ry": "27",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,109a35.1,35.1,0,0,1,20-6.1c17.7,0,32,12.5,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.8",
      "y1": "152",
      "x2": "29.2",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M137.9,148.2h0L87.1,52.3a8,8,0,0,0-14.2,0L22.1,148.2h0L.9,188.3a8.1,8.1,0,0,0,3.4,10.8,8.1,8.1,0,0,0,10.8-3.4L34,160h92l18.9,35.7A7.9,7.9,0,0,0,152,200a8,8,0,0,0,7.1-11.7ZM42.5,144,80,73.1,117.5,144ZM208,94.9a42,42,0,0,0-29.6,11.8,8,8,0,1,0,11.2,11.4,26,26,0,0,1,18.4-7.2c13.2,0,24,9,24,20v7.2a43,43,0,0,0-24-7.2c-22.1,0-40,16.1-40,36s17.9,36,40,36a42.9,42.9,0,0,0,24.7-7.7A7.9,7.9,0,0,0,240,200a8,8,0,0,0,8-8V130.9C248,111,230.1,94.9,208,94.9Zm0,92c-13.2,0-24-9-24-20s10.8-20,24-20,24,9,24,20S221.2,186.9,208,186.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.8",
      "y1": "152",
      "x2": "29.2",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.8",
      "y1": "152",
      "x2": "29.2",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "152 192 80 56 8 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "208",
      "cy": "166.9",
      "rx": "32",
      "ry": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "130.8",
      "y1": "152",
      "x2": "29.2",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1L = [];
/* style */

const __vue_inject_styles__$1L = undefined;
/* scoped */

const __vue_scope_id__$1L = undefined;
/* module identifier */

const __vue_module_identifier__$1L = undefined;
/* functional template */

const __vue_is_functional_template__$1L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1L, __vue_script__$1L, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, undefined, undefined, undefined);

var script$1K = Vue.extend({
  name: "PhTextAlignCenter",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1K = script$1K;
/* template */

var __vue_render__$1K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "188",
      "x2": "192",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "188",
      "x2": "192",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,100a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,180H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "188",
      "x2": "192",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "188",
      "x2": "192",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "108",
      "x2": "192",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "188",
      "x2": "192",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1K = [];
/* style */

const __vue_inject_styles__$1K = undefined;
/* scoped */

const __vue_scope_id__$1K = undefined;
/* module identifier */

const __vue_module_identifier__$1K = undefined;
/* functional template */

const __vue_is_functional_template__$1K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1K, __vue_script__$1K, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, undefined, undefined, undefined);

var script$1J = Vue.extend({
  name: "PhTextAlignJustify",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1J = script$1J;
/* template */

var __vue_render__$1J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,100H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,180H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1J = [];
/* style */

const __vue_inject_styles__$1J = undefined;
/* scoped */

const __vue_scope_id__$1J = undefined;
/* module identifier */

const __vue_module_identifier__$1J = undefined;
/* functional template */

const __vue_is_functional_template__$1J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1J, __vue_script__$1J, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, undefined, undefined, undefined);

var script$1I = Vue.extend({
  name: "PhTextAlignLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1I = script$1I;
/* template */

var __vue_render__$1I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,116H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,180H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "108",
      "x2": "168",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "188",
      "x2": "168",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1I = [];
/* style */

const __vue_inject_styles__$1I = undefined;
/* scoped */

const __vue_scope_id__$1I = undefined;
/* module identifier */

const __vue_module_identifier__$1I = undefined;
/* functional template */

const __vue_is_functional_template__$1I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1I, __vue_script__$1I, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, undefined, undefined, undefined);

var script$1H = Vue.extend({
  name: "PhTextAlignRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1H = script$1H;
/* template */

var __vue_render__$1H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,100H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,180H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "68",
      "x2": "216",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "108",
      "x2": "216",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "148",
      "x2": "216",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "188",
      "x2": "216",
      "y2": "188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1H = [];
/* style */

const __vue_inject_styles__$1H = undefined;
/* scoped */

const __vue_scope_id__$1H = undefined;
/* module identifier */

const __vue_module_identifier__$1H = undefined;
/* functional template */

const __vue_is_functional_template__$1H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1H, __vue_script__$1H, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, undefined, undefined, undefined);

var script$1G = Vue.extend({
  name: "PhTextBolder",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1G = script$1G;
/* template */

var __vue_render__$1G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M170.5,115.7A44,44,0,0,0,140,40H64a7.9,7.9,0,0,0-8,8V200a8,8,0,0,0,8,8h88a48,48,0,0,0,18.5-92.3ZM72,56h68a28,28,0,0,1,0,56H72Zm80,136H72V128h80a32,32,0,0,1,0,64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1G = [];
/* style */

const __vue_inject_styles__$1G = undefined;
/* scoped */

const __vue_scope_id__$1G = undefined;
/* module identifier */

const __vue_module_identifier__$1G = undefined;
/* functional template */

const __vue_is_functional_template__$1G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1G, __vue_script__$1G, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, undefined, undefined, undefined);

var script$1F = Vue.extend({
  name: "PhTextH",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1F = script$1F;
/* template */

var __vue_render__$1F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "56",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "128",
      "x2": "56",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1F = [];
/* style */

const __vue_inject_styles__$1F = undefined;
/* scoped */

const __vue_scope_id__$1F = undefined;
/* module identifier */

const __vue_module_identifier__$1F = undefined;
/* functional template */

const __vue_is_functional_template__$1F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1F, __vue_script__$1F, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, undefined, undefined, undefined);

var script$1E = Vue.extend({
  name: "PhTextHFive",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1E = script$1E;
/* template */

var __vue_render__$1E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm59.9,84a37.3,37.3,0,0,0-9.4,1.2l4.1-25.2H240a8,8,0,0,0,0-16H199.8a8,8,0,0,0-7.9,6.7l-7.8,48.2a8,8,0,0,0,13.5,7,20.1,20.1,0,0,1,14.3-5.9,19.9,19.9,0,0,1,14.2,5.9,19.8,19.8,0,0,1,0,28.2,19.9,19.9,0,0,1-14.2,5.9,20.1,20.1,0,0,1-14.3-5.9,8,8,0,1,0-11.2,11.4A36.1,36.1,0,1,0,211.9,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1E = [];
/* style */

const __vue_inject_styles__$1E = undefined;
/* scoped */

const __vue_scope_id__$1E = undefined;
/* module identifier */

const __vue_module_identifier__$1E = undefined;
/* functional template */

const __vue_is_functional_template__$1E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1E, __vue_script__$1E, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, undefined, undefined, undefined);

var script$1D = Vue.extend({
  name: "PhTextHFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1D = script$1D;
/* template */

var __vue_render__$1D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm84,72a8,8,0,0,0-8,8v24H199.3l20.2-57.3a8,8,0,0,0-15-5.4l-24,68a7.9,7.9,0,0,0,1,7.3A8,8,0,0,0,188,176h40v24a8,8,0,0,0,16,0V136A8,8,0,0,0,236,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "212 100 188 168 236 168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "236",
      "y1": "136",
      "x2": "236",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1D = [];
/* style */

const __vue_inject_styles__$1D = undefined;
/* scoped */

const __vue_scope_id__$1D = undefined;
/* module identifier */

const __vue_module_identifier__$1D = undefined;
/* functional template */

const __vue_is_functional_template__$1D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1D, __vue_script__$1D, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, undefined, undefined, undefined);

var script$1C = Vue.extend({
  name: "PhTextHOne",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1C = script$1C;
/* template */

var __vue_render__$1C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 124 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 124 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm71.8,44.9a8.3,8.3,0,0,0-8.2.4l-24,16a8,8,0,0,0,8.8,13.4l11.6-7.8V200a8,8,0,0,0,16,0V108A8,8,0,0,0,223.8,100.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 124 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 124 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "196 124 220 108 220 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1C = [];
/* style */

const __vue_inject_styles__$1C = undefined;
/* scoped */

const __vue_scope_id__$1C = undefined;
/* module identifier */

const __vue_module_identifier__$1C = undefined;
/* functional template */

const __vue_is_functional_template__$1C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1C, __vue_script__$1C, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, undefined, undefined, undefined);

var script$1B = Vue.extend({
  name: "PhTextHSix",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1B = script$1B;
/* template */

var __vue_render__$1B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.8",
      "y1": "154",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.8",
      "y1": "154",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM252,168a36,36,0,1,1-67.4-17.5l.3-.6,32.2-54a8,8,0,0,1,13.8,8.2L214.2,132H216A36,36,0,0,1,252,168Zm-16,0a20,20,0,1,0-20,20A20.1,20.1,0,0,0,236,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.8",
      "y1": "154",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.8",
      "y1": "154",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "191.8",
      "y1": "154",
      "x2": "224",
      "y2": "100",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "216",
      "cy": "168",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1B = [];
/* style */

const __vue_inject_styles__$1B = undefined;
/* scoped */

const __vue_scope_id__$1B = undefined;
/* module identifier */

const __vue_module_identifier__$1B = undefined;
/* functional template */

const __vue_is_functional_template__$1B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1B, __vue_script__$1B, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, undefined, undefined, undefined);

var script$1A = Vue.extend({
  name: "PhTextHThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1A = script$1A;
/* template */

var __vue_render__$1A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm85.5,94.5a37.9,37.9,0,0,0-12-7.9l21.1-30a8,8,0,0,0,.5-8.3A8.1,8.1,0,0,0,240,100H192a8,8,0,0,0,0,16h32.6l-19.2,27.4a8,8,0,0,0-.5,8.3A8.1,8.1,0,0,0,212,156a20,20,0,1,1-14.1,34.1,8.1,8.1,0,0,0-11.4,11.4,36.1,36.1,0,0,0,51-51Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1A = [];
/* style */

const __vue_inject_styles__$1A = undefined;
/* scoped */

const __vue_scope_id__$1A = undefined;
/* module identifier */

const __vue_module_identifier__$1A = undefined;
/* functional template */

const __vue_is_functional_template__$1A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1A, __vue_script__$1A, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, undefined, undefined, undefined);

var script$1z = Vue.extend({
  name: "PhTextHTwo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1z = script$1z;
/* template */

var __vue_render__$1z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm88,136H208l34.3-45.8.2-.3A31.8,31.8,0,0,0,248,128a32,32,0,0,0-61.5-12.5,8,8,0,0,0,14.8,6.3A15.9,15.9,0,0,1,216,112a16,16,0,0,1,13.4,24.8l-43.7,58.3A7.5,7.5,0,0,0,184,200a8,8,0,0,0,5.5,7.6,7.3,7.3,0,0,0,2.5.4h48a8,8,0,0,0,0-16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "56",
      "x2": "40",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "116",
      "x2": "40",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "144",
      "y1": "56",
      "x2": "144",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1z = [];
/* style */

const __vue_inject_styles__$1z = undefined;
/* scoped */

const __vue_scope_id__$1z = undefined;
/* module identifier */

const __vue_module_identifier__$1z = undefined;
/* functional template */

const __vue_is_functional_template__$1z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1z, __vue_script__$1z, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, undefined, undefined, undefined);

var script$1y = Vue.extend({
  name: "PhTextIndent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1y = script$1y;
/* template */

var __vue_render__$1y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 80 96 40 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 80 96 40 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h96A8,8,0,0,1,224,128ZM120,72h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Zm96,112H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM36.9,143.4a8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l40-40a8.1,8.1,0,0,0,0-11.4l-40-40a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,32,56v80A8,8,0,0,0,36.9,143.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 80 96 40 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 80 96 40 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 56 80 96 40 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1y = [];
/* style */

const __vue_inject_styles__$1y = undefined;
/* scoped */

const __vue_scope_id__$1y = undefined;
/* module identifier */

const __vue_module_identifier__$1y = undefined;
/* functional template */

const __vue_is_functional_template__$1y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1y, __vue_script__$1y, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, undefined, undefined, undefined);

var script$1x = Vue.extend({
  name: "PhTextItalic",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1x = script$1x;
/* template */

var __vue_render__$1x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "56",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "144",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "56",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "144",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,56a8,8,0,0,1-8,8H157.8L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.2L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "56",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "144",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "56",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "144",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "152",
      "y1": "56",
      "x2": "104",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "144",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "56",
      "x2": "192",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1x = [];
/* style */

const __vue_inject_styles__$1x = undefined;
/* scoped */

const __vue_scope_id__$1x = undefined;
/* module identifier */

const __vue_module_identifier__$1x = undefined;
/* functional template */

const __vue_is_functional_template__$1x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1x, __vue_script__$1x, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, undefined, undefined, undefined);

var script$1w = Vue.extend({
  name: "PhTextOutdent",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1w = script$1w;
/* template */

var __vue_render__$1w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "120",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 56 32 96 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 56 32 96 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h96A8,8,0,0,1,224,128ZM120,72h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Zm96,112H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,80,136V56a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-40,40a8.1,8.1,0,0,0,0,11.4l40,40A8.3,8.3,0,0,0,72,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 56 32 96 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 56 32 96 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "64",
      "x2": "216",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "192",
      "x2": "216",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "72 56 32 96 72 136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1w = [];
/* style */

const __vue_inject_styles__$1w = undefined;
/* scoped */

const __vue_scope_id__$1w = undefined;
/* module identifier */

const __vue_module_identifier__$1w = undefined;
/* functional template */

const __vue_is_functional_template__$1w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1w, __vue_script__$1w, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, undefined, undefined, undefined);

var script$1v = Vue.extend({
  name: "PhTextStrikethrough",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1v = script$1v;
/* template */

var __vue_render__$1v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.1,88c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,128a8,8,0,0,1-8,8H175.9c9.2,7.1,16.1,17.2,16.1,32s-7,25.7-19.8,34.8S144.6,216,128,216s-32.3-4.7-44.2-13.2S64,181.3,64,168a8,8,0,0,1,16,0c0,17.3,22,32,48,32s48-14.7,48-32c0-14.9-10.5-23.6-38.8-32H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM76.3,104a6.9,6.9,0,0,0,2.5-.4,8,8,0,0,0,5.1-10.1,19.2,19.2,0,0,1-.8-5.5c0-18.2,19.3-32,44.9-32,19.5,0,36.1,8.3,42.3,21A8.1,8.1,0,0,0,181,80.7,7.9,7.9,0,0,0,184.7,70c-9-18.5-30.7-30-56.7-30C93.3,40,67.1,60.6,67.1,88a36,36,0,0,0,1.6,10.5A8,8,0,0,0,76.3,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "128",
      "x2": "216",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1v = [];
/* style */

const __vue_inject_styles__$1v = undefined;
/* scoped */

const __vue_scope_id__$1v = undefined;
/* module identifier */

const __vue_module_identifier__$1v = undefined;
/* functional template */

const __vue_is_functional_template__$1v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1v, __vue_script__$1v, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, undefined, undefined, undefined);

var script$1u = Vue.extend({
  name: "PhTextT",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1u = script$1u;
/* template */

var __vue_render__$1u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 56 208 56 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 56 208 56 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,48H48a8,8,0,0,0-8,8V88a8,8,0,0,0,16,0V64h64V192H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V64h64V88a8,8,0,0,0,16,0V56A8,8,0,0,0,208,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 56 208 56 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 56 208 56 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "56",
      "x2": "128",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "48 88 48 56 208 56 208 88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "200",
      "x2": "160",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1u = [];
/* style */

const __vue_inject_styles__$1u = undefined;
/* scoped */

const __vue_scope_id__$1u = undefined;
/* module identifier */

const __vue_module_identifier__$1u = undefined;
/* functional template */

const __vue_is_functional_template__$1u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1u, __vue_script__$1u, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, undefined, undefined, undefined);

var script$1t = Vue.extend({
  name: "PhTextUnderline",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1t = script$1t;
/* template */

var __vue_render__$1t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v60a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216Zm-96-24a72.1,72.1,0,0,0,72-72V56a8,8,0,0,0-16,0v64a56,56,0,0,1-112,0V56a8,8,0,0,0-16,0v64A72.1,72.1,0,0,0,128,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "40",
      "y1": "216",
      "x2": "216",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,56v64a64,64,0,0,0,128,0V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1t = [];
/* style */

const __vue_inject_styles__$1t = undefined;
/* scoped */

const __vue_scope_id__$1t = undefined;
/* module identifier */

const __vue_module_identifier__$1t = undefined;
/* functional template */

const __vue_is_functional_template__$1t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1t, __vue_script__$1t, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, undefined, undefined, undefined);

var script$1s = Vue.extend({
  name: "PhTextbox",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1s = script$1s;
/* template */

var __vue_render__$1s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "48",
      "x2": "112",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,72h80a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "112",
      "x2": "78",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "64",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "72",
      "width": "224",
      "height": "112",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "112",
      "y1": "48",
      "x2": "112",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "112",
      "x2": "78",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "64",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h88A16,16,0,0,1,248,80ZM120,48V208a8,8,0,0,1-16,0V192H24A16,16,0,0,1,8,176V80A16,16,0,0,1,24,64h80V48a8,8,0,0,1,16,0ZM86,112a8,8,0,0,0-8-8H50a8,8,0,0,0,0,16h6v28a8,8,0,0,0,16,0V120h6A8,8,0,0,0,86,112Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "48",
      "x2": "112",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "112",
      "x2": "78",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "64",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "48",
      "x2": "112",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "112",
      "x2": "78",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "64",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "112",
      "y1": "48",
      "x2": "112",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "112",
      "x2": "78",
      "y2": "112",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "112",
      "x2": "64",
      "y2": "148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1s = [];
/* style */

const __vue_inject_styles__$1s = undefined;
/* scoped */

const __vue_scope_id__$1s = undefined;
/* module identifier */

const __vue_module_identifier__$1s = undefined;
/* functional template */

const __vue_is_functional_template__$1s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1s, __vue_script__$1s, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, undefined, undefined, undefined);

var script$1r = Vue.extend({
  name: "PhThermometer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1r = script$1r;
/* template */

var __vue_render__$1r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "216",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "168",
      "x2": "108",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,52a28,28,0,1,0,28,28A28.1,28.1,0,0,0,212,52Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,212,92Zm-52,51.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,60,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,160,143.3ZM120,24a24.1,24.1,0,0,1,24,24V80H96V48A24.1,24.1,0,0,1,120,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "212",
      "cy": "80",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1r = [];
/* style */

const __vue_inject_styles__$1r = undefined;
/* scoped */

const __vue_scope_id__$1r = undefined;
/* module identifier */

const __vue_module_identifier__$1r = undefined;
/* functional template */

const __vue_is_functional_template__$1r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1r, __vue_script__$1r, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, undefined, undefined, undefined);

var script$1q = Vue.extend({
  name: "PhThermometerCold",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1q = script$1q;
/* template */

var __vue_render__$1q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "176",
      "x2": "108",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.2",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.8",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.4",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.2",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.8",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.4",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M244.9,77.7l-20,6.5,12.4,17a8,8,0,0,1-1.8,11.2,8.1,8.1,0,0,1-11.2-1.8L212,93.6l-12.3,17a8.1,8.1,0,0,1-11.2,1.8,8,8,0,0,1-1.8-11.2l12.4-17-20-6.5A7.9,7.9,0,0,1,174,67.6a7.8,7.8,0,0,1,10-5.1L204,69V48a8,8,0,0,1,16,0V69l20-6.5a7.8,7.8,0,0,1,10,5.1A7.9,7.9,0,0,1,244.9,77.7ZM180,188a60,60,0,0,1-120,0,59.4,59.4,0,0,1,20-44.7V48a40,40,0,0,1,80,0v95.3A59.4,59.4,0,0,1,180,188ZM96,48v56h48V48a24,24,0,0,0-48,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.2",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.8",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.4",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.2",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.8",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.4",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "48",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "181.6",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "193.2",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "230.8",
      "y1": "105.9",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "242.4",
      "y1": "70.1",
      "x2": "212",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1q = [];
/* style */

const __vue_inject_styles__$1q = undefined;
/* scoped */

const __vue_scope_id__$1q = undefined;
/* module identifier */

const __vue_module_identifier__$1q = undefined;
/* functional template */

const __vue_is_functional_template__$1q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1q, __vue_script__$1q, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, undefined, undefined, undefined);

var script$1p = Vue.extend({
  name: "PhThermometerHot",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1p = script$1p;
/* template */

var __vue_render__$1p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "108",
      "y1": "176",
      "x2": "108",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,143.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,60,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,160,143.3ZM120,24a24.1,24.1,0,0,1,24,24v8H96V48A24.1,24.1,0,0,1,120,24Zm58.1,61.7a8,8,0,0,1,0-11.4,28,28,0,0,1,19.8-8.2,28.4,28.4,0,0,1,19.8,8.2,11.9,11.9,0,0,0,16.9,0,8,8,0,0,1,11.3,11.4,28,28,0,0,1-19.8,8.2,28.4,28.4,0,0,1-19.8-8.2,11.9,11.9,0,0,0-16.9,0A8,8,0,0,1,178.1,85.7Zm67.8,28.6a8,8,0,0,1,0,11.4,28,28,0,0,1-19.8,8.2,28.4,28.4,0,0,1-19.8-8.2,11.9,11.9,0,0,0-16.9,0,8,8,0,0,1-11.3-11.4,28,28,0,0,1,19.8-8.2,28.4,28.4,0,0,1,19.8,8.2,11.9,11.9,0,0,0,16.9,0A8,8,0,0,1,245.9,114.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "120",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "168",
      "x2": "120",
      "y2": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1p = [];
/* style */

const __vue_inject_styles__$1p = undefined;
/* scoped */

const __vue_scope_id__$1p = undefined;
/* module identifier */

const __vue_module_identifier__$1p = undefined;
/* functional template */

const __vue_is_functional_template__$1p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1p, __vue_script__$1p, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, undefined, undefined, undefined);

var script$1o = Vue.extend({
  name: "PhThermometerSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1o = script$1o;
/* template */

var __vue_render__$1o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "92",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,128,208Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,143.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,68,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,168,143.3ZM128,24a24.1,24.1,0,0,1,24,24V80H104V48A24.1,24.1,0,0,1,128,24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "188",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "168",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1o = [];
/* style */

const __vue_inject_styles__$1o = undefined;
/* scoped */

const __vue_scope_id__$1o = undefined;
/* module identifier */

const __vue_module_identifier__$1o = undefined;
/* functional template */

const __vue_is_functional_template__$1o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1o, __vue_script__$1o, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, undefined, undefined, undefined);

var script$1n = Vue.extend({
  name: "PhThumbsDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1n = script$1n;
/* template */

var __vue_render__$1n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M237.7,157l-12-96a24.1,24.1,0,0,0-23.8-21H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75l37.8,75.6A8.2,8.2,0,0,0,120,240a40.1,40.1,0,0,0,40-40V184h53.9a23.9,23.9,0,0,0,23.8-27ZM72,144H32V56H72Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56A8,8,0,0,1,32,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56A8,8,0,0,1,32,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1n = [];
/* style */

const __vue_inject_styles__$1n = undefined;
/* scoped */

const __vue_scope_id__$1n = undefined;
/* module identifier */

const __vue_module_identifier__$1n = undefined;
/* functional template */

const __vue_is_functional_template__$1n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1n, __vue_script__$1n, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, undefined, undefined, undefined);

var script$1m = Vue.extend({
  name: "PhThumbsUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1m = script$1m;
/* template */

var __vue_render__$1m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.9,80.1a24.4,24.4,0,0,0-18-8.1H160V56a40.1,40.1,0,0,0-40-40,8.2,8.2,0,0,0-7.2,4.4L75,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H201.9a24.1,24.1,0,0,0,23.8-21l12-96A24.5,24.5,0,0,0,231.9,80.1ZM32,112H72v88H32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1m = [];
/* style */

const __vue_inject_styles__$1m = undefined;
/* scoped */

const __vue_scope_id__$1m = undefined;
/* module identifier */

const __vue_module_identifier__$1m = undefined;
/* functional template */

const __vue_is_functional_template__$1m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1m, __vue_script__$1m, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, undefined, undefined, undefined);

var script$1l = Vue.extend({
  name: "PhTicket",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1l = script$1l;
/* template */

var __vue_render__$1l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M96,56H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H96Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.2,104.5A16.1,16.1,0,0,0,240,88.8V64a16,16,0,0,0-16-16H32A16,16,0,0,0,16,64V88.8a16.1,16.1,0,0,0,12.8,15.7,24,24,0,0,1,0,47A16.1,16.1,0,0,0,16,167.2V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V167.2a16.1,16.1,0,0,0-12.8-15.7,24,24,0,0,1,0-47ZM32,167.2a40,40,0,0,0,0-78.4V64H88V192H32Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "96",
      "y1": "56",
      "x2": "96",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1l = [];
/* style */

const __vue_inject_styles__$1l = undefined;
/* scoped */

const __vue_scope_id__$1l = undefined;
/* module identifier */

const __vue_module_identifier__$1l = undefined;
/* functional template */

const __vue_is_functional_template__$1l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, undefined, undefined, undefined);

var script$1k = Vue.extend({
  name: "PhTiktokLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1k = script$1k;
/* template */

var __vue_render__$1k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,84v40a8,8,0,0,1-8,8,103.2,103.2,0,0,1-48-11.7V156A76,76,0,1,1,86.6,81.2a8,8,0,0,1,6.5,1.7A7.8,7.8,0,0,1,96,89.1v41.6a7.9,7.9,0,0,1-4.6,7.2A20,20,0,1,0,120,156V28a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8,48,48,0,0,0,48,48A8,8,0,0,1,232,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1k = [];
/* style */

const __vue_inject_styles__$1k = undefined;
/* scoped */

const __vue_scope_id__$1k = undefined;
/* module identifier */

const __vue_module_identifier__$1k = undefined;
/* functional template */

const __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);

var script$1j = Vue.extend({
  name: "PhTimer",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1j = script$1j;
/* template */

var __vue_render__$1j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "140",
      "x2": "161.9",
      "y2": "106.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "12",
      "x2": "152",
      "y2": "12",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.6",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M104,16h48a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32a96,96,0,1,0,96,96A96.2,96.2,0,0,0,128,32Zm45.3,62.1-39.6,39.6a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l39.6-39.6a8.1,8.1,0,1,1,11.4,11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.6",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.6",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "167.6",
      "y2": "88.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "8",
      "x2": "152",
      "y2": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1j = [];
/* style */

const __vue_inject_styles__$1j = undefined;
/* scoped */

const __vue_scope_id__$1j = undefined;
/* module identifier */

const __vue_module_identifier__$1j = undefined;
/* functional template */

const __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);

var script$1i = Vue.extend({
  name: "PhToggleLeft",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1i = script$1i;
/* template */

var __vue_render__$1i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144ZM80,168a40,40,0,1,1,40-40A40,40,0,0,1,80,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1i = [];
/* style */

const __vue_inject_styles__$1i = undefined;
/* scoped */

const __vue_scope_id__$1i = undefined;
/* module identifier */

const __vue_module_identifier__$1i = undefined;
/* functional template */

const __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);

var script$1h = Vue.extend({
  name: "PhToggleRight",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1h = script$1h;
/* template */

var __vue_render__$1h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,176,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "64",
      "width": "224",
      "height": "128",
      "rx": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1h = [];
/* style */

const __vue_inject_styles__$1h = undefined;
/* scoped */

const __vue_scope_id__$1h = undefined;
/* module identifier */

const __vue_module_identifier__$1h = undefined;
/* functional template */

const __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);

var script$1g = Vue.extend({
  name: "PhToilet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1g = script$1g;
/* template */

var __vue_render__$1g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,108V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "100",
      "y1": "68",
      "x2": "116",
      "y2": "68",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,108a88,88,0,0,1-176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1,189.2l-4.8,33.7a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1l-4.8-33.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193h0a88,88,0,0,1-68.8,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "112",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,112a88,88,0,0,1-176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,112.1a8,8,0,0,0-8-8.1H40a8,8,0,0,0-8,8.1,96,96,0,0,0,52.8,85.6l-3.4,23.7a16.2,16.2,0,0,0,1.7,10.1A16,16,0,0,0,97.2,240h61.2a16.9,16.9,0,0,0,9.8-3,16.2,16.2,0,0,0,6.4-15.3l-3.4-24A96,96,0,0,0,224,112.1ZM97.2,224l2.9-20.1a97,97,0,0,0,55.8,0l2.9,20.1ZM60,88H196a4,4,0,0,0,4-4V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V84A4,4,0,0,0,60,88ZM88,48h15.7a8.2,8.2,0,0,1,8.3,7.5,8,8,0,0,1-8,8.5H88.3A8.2,8.2,0,0,1,80,56.5,8,8,0,0,1,88,48Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "112",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,112a88,88,0,0,1-176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "112",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,112a88,88,0,0,1-176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "64",
      "x2": "112",
      "y2": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,112a88,88,0,0,1-176,0Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1g = [];
/* style */

const __vue_inject_styles__$1g = undefined;
/* scoped */

const __vue_scope_id__$1g = undefined;
/* module identifier */

const __vue_module_identifier__$1g = undefined;
/* functional template */

const __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

var script$1f = Vue.extend({
  name: "PhToiletPaper",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "124",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "120",
      "x2": "172",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "212",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,120a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h16A8,8,0,0,1,184,120Zm56,0v88a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V186.3C87.4,200.4,76.2,208,64,208c-13.9,0-26.5-9.9-35.4-27.9C20.5,163.9,16,142.6,16,120s4.5-43.9,12.6-60.1C37.5,41.9,50.1,32,64,32H192c13.9,0,26.5,9.9,35.4,27.9C235.5,76.1,240,97.4,240,120ZM76,120a12,12,0,1,0-12,12A12,12,0,0,0,76,120Zm148,8H208a8,8,0,0,1,0-16h15.8c-2-38.1-17.6-64-31.8-64H92.1a65,65,0,0,1,7.3,11.9c7.2,14.2,11.5,32.5,12.4,52.1H128a8,8,0,0,1,0,16H112v80H224Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "10"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "r": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "64",
      "cy": "120",
      "rx": "40",
      "ry": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "120",
      "x2": "128",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "120",
      "x2": "176",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "120",
      "x2": "232",
      "y2": "120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1f = undefined;
/* scoped */

const __vue_scope_id__$1f = undefined;
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

var script$1e = Vue.extend({
  name: "PhTote",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235,69.3A15.9,15.9,0,0,0,223.1,64H175.3a48,48,0,0,0-94.6,0H32.9A15.9,15.9,0,0,0,21,69.3a16.2,16.2,0,0,0-4,12.5l14.3,128A15.9,15.9,0,0,0,47.2,224H208.8a15.9,15.9,0,0,0,15.9-14.2L239,81.8A16.2,16.2,0,0,0,235,69.3ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,104V72a40,40,0,0,1,80,0v32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1e = undefined;
/* scoped */

const __vue_scope_id__$1e = undefined;
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);

var script$1d = Vue.extend({
  name: "PhToteSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235,69.3A15.9,15.9,0,0,0,223.1,64H175.3a48,48,0,0,0-94.6,0H32.9A15.9,15.9,0,0,0,21,69.3a16.2,16.2,0,0,0-4,12.5l14.3,128A15.9,15.9,0,0,0,47.2,224H208.8a15.9,15.9,0,0,0,15.9-14.2L239,81.8A16.2,16.2,0,0,0,235,69.3ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,72a40,40,0,0,1,80,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1d = undefined;
/* scoped */

const __vue_scope_id__$1d = undefined;
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

var script$1c = Vue.extend({
  name: "PhTrademarkRegistered",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$1c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,136h32a24,24,0,0,0,0-48H104v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "137.6",
      "y1": "135.9",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,136h32a24,24,0,0,0,0-48H104v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "137.6",
      "y1": "135.9",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,56a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm28.5,110.6A8.2,8.2,0,0,1,152,168a8,8,0,0,1-6.6-3.5L131.3,144H116v16a8,8,0,0,1-16,0V96a8,8,0,0,1,8-8h24a28,28,0,0,1,15.5,51.3l11.1,16.2A7.9,7.9,0,0,1,156.5,166.6ZM144,116a12,12,0,0,1-12,12H116V104h16A12,12,0,0,1,144,116ZM128,20A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,136h32a24,24,0,0,0,0-48H104v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "137.6",
      "y1": "135.9",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,136h32a24,24,0,0,0,0-48H104v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "137.6",
      "y1": "135.9",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,136h32a24,24,0,0,0,0-48H104v80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "137.6",
      "y1": "135.9",
      "x2": "160",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1c = undefined;
/* scoped */

const __vue_scope_id__$1c = undefined;
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

var script$1b = Vue.extend({
  name: "PhTrafficCone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "216",
      "x2": "24",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166.3",
      "y1": "96",
      "x2": "89.7",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.5",
      "y1": "160",
      "x2": "67.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "67.5 160 188.5 160 166.3 96 89.7 96 67.5 160",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "216",
      "x2": "24",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166.3",
      "y1": "96",
      "x2": "89.7",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.5",
      "y1": "160",
      "x2": "67.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,208H213.7L153.4,34.7A16,16,0,0,0,138.3,24H117.7a16,16,0,0,0-15.1,10.7L42.3,208H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM95.4,104h65.2l16.7,48H78.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "216",
      "x2": "24",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166.3",
      "y1": "96",
      "x2": "89.7",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.5",
      "y1": "160",
      "x2": "67.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "216",
      "x2": "24",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166.3",
      "y1": "96",
      "x2": "89.7",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.5",
      "y1": "160",
      "x2": "67.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "232",
      "y1": "216",
      "x2": "24",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "166.3",
      "y1": "96",
      "x2": "89.7",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "188.5",
      "y1": "160",
      "x2": "67.5",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1b = undefined;
/* scoped */

const __vue_scope_id__$1b = undefined;
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

var script$1a = Vue.extend({
  name: "PhTrafficSign",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,148v-4a23.9,23.9,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M244,116.7,139.3,12a15.9,15.9,0,0,0-22.6,0L12,116.7a16.1,16.1,0,0,0,0,22.6L116.7,244a15.9,15.9,0,0,0,22.6,0L244,139.3A16.1,16.1,0,0,0,244,116.7ZM176,120v.8a.4.4,0,0,0-.1.3.9.9,0,0,1-.1.5.8.8,0,0,1-.1.4v.3l-.2.4c0,.1-.1.2-.1.4l-.2.3v.4l-.2.3c-.1.1-.2.2-.2.3l-.3.4-.2.3-.5.5h0l-24,24a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L148.7,128H112a16,16,0,0,0-16,16v8a8,8,0,0,1-16,0v-8a32.1,32.1,0,0,1,32-32h36.7l-10.4-10.3a8.1,8.1,0,0,1,11.4-11.4l24,24h0l.5.5.2.3.3.4c0,.1.1.2.2.3l.2.3v.4l.2.3c0,.2.1.3.1.4l.2.4v.3a.8.8,0,0,1,.1.4.9.9,0,0,1,.1.5.4.4,0,0,0,.1.3v.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "144 144 168 120 144 96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "46",
      "y": "46",
      "width": "164",
      "height": "164.05",
      "rx": "8",
      "transform": "translate(-53 128) rotate(-45)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1a = undefined;
/* scoped */

const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

var script$19 = Vue.extend({
  name: "PhTrafficSignal",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "32",
      "width": "128",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "64",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "64",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,32H72a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40A8,8,0,0,0,184,32ZM128,192a24,24,0,1,1,24-24A23.9,23.9,0,0,1,128,192Zm0-80a24,24,0,1,1,24-24A23.9,23.9,0,0,1,128,112Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64",
      "y": "32",
      "width": "128",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "64",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "64",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,144H200V80h16a8,8,0,0,0,0-16H200V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V64H40a8,8,0,0,0,0,16H56v64H40a8,8,0,0,0,0,16H56v56a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-88-28a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,116Zm0,24a28,28,0,1,1-28,28A28.1,28.1,0,0,1,128,140Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "32",
      "width": "128",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "64",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "64",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "32",
      "width": "128",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "64",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "64",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "64",
      "y": "32",
      "width": "128",
      "height": "192",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "88",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "168",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "72",
      "x2": "216",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "152",
      "x2": "216",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "72",
      "x2": "64",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40",
      "y1": "152",
      "x2": "64",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$19 = undefined;
/* scoped */

const __vue_scope_id__$19 = undefined;
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);

var script$18 = Vue.extend({
  name: "PhTrain",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "44",
      "y": "72",
      "width": "168",
      "height": "56",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,24H68A32.1,32.1,0,0,0,36,56V184a32.1,32.1,0,0,0,32,32H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h12a32.1,32.1,0,0,0,32-32V56A32.1,32.1,0,0,0,188,24ZM84,184a12,12,0,1,1,12-12A12,12,0,0,1,84,184Zm36-64H52V80h68Zm52,64a12,12,0,1,1,12-12A12,12,0,0,1,172,184Zm32-64H136V80h68Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "72",
      "x2": "212",
      "y2": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "72",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$18 = undefined;
/* scoped */

const __vue_scope_id__$18 = undefined;
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);

var script$17 = Vue.extend({
  name: "PhTrainRegional",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,120l88,16,88-16-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M160,80H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,119.9a2.2,2.2,0,0,0-.1-.8v-.5c-.1-.2-.1-.4-.2-.6h0l-22.4-82A15.9,15.9,0,0,0,185.9,24H70.1A15.9,15.9,0,0,0,54.7,35.8l-22.4,82h0c-.1.2-.1.4-.2.6v.5a2.2,2.2,0,0,0-.1.8v.2a2.8,2.8,0,0,0,.1.9h0a2.9,2.9,0,0,0,.2.9h0l22.4,82.1A15.9,15.9,0,0,0,70.1,216H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h9.9a15.9,15.9,0,0,0,15.4-11.8l22.4-82.1h0a2.9,2.9,0,0,0,.2-.9h0a2.8,2.8,0,0,0,.1-.9ZM136,192a8,8,0,0,1-16,0V152a8,8,0,0,1,16,0Zm-8-64.1L50,113.7,70.1,40H185.9L206,113.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "208",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "40 120 128 136 216 120",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "88",
      "x2": "160",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$17 = undefined;
/* scoped */

const __vue_scope_id__$17 = undefined;
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);

var script$16 = Vue.extend({
  name: "PhTrainSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "168",
      "r": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "168",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M212,56a23.9,23.9,0,0,0-24-24H68A23.9,23.9,0,0,0,44,56v72H212Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M188,24H68A32.1,32.1,0,0,0,36,56V184a32.1,32.1,0,0,0,32,32H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h12a32.1,32.1,0,0,0,32-32V56A32.1,32.1,0,0,0,188,24Zm0,176H68a16,16,0,0,1-16-16V136H204v48A16,16,0,0,1,188,200Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "44",
      "y1": "128",
      "x2": "212",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "208",
      "x2": "72",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "208",
      "x2": "184",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "44",
      "y": "32",
      "width": "168",
      "height": "176",
      "rx": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "84",
      "cy": "172",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "172",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$16 = undefined;
/* scoped */

const __vue_scope_id__$16 = undefined;
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

var script$15 = Vue.extend({
  name: "PhTranslate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.7,96A96.1,96.1,0,0,0,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.4,88A96.1,96.1,0,0,0,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.1,212.4l-56-112A7.9,7.9,0,0,0,176,96a8,8,0,0,0-7.2,4.4l-21.7,43.4A87.4,87.4,0,0,1,100,126.9,104.1,104.1,0,0,0,127.7,64H152a8,8,0,0,0,0-16H96V32a8,8,0,0,0-16,0V48H24a8,8,0,0,0,0,16h87.6A87.5,87.5,0,0,1,88,116.3a87.1,87.1,0,0,1-19-31,8,8,0,0,0-10.2-4.8,7.9,7.9,0,0,0-4.9,10.2A103.8,103.8,0,0,0,76,126.9,87.1,87.1,0,0,1,24,144a8,8,0,0,0,0,16,103.8,103.8,0,0,0,64-22.1,103.6,103.6,0,0,0,51.4,21.3l-26.6,53.2a8,8,0,1,0,14.3,7.2L140.9,192H211l13.8,27.6A8,8,0,0,0,232,224a9.4,9.4,0,0,0,3.6-.8A8.1,8.1,0,0,0,239.1,212.4ZM148.9,176,176,121.9,203,176Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,88A95.9,95.9,0,0,0,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,88A96,96,0,0,0,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 216 176 104 120 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "136",
      "y1": "184",
      "x2": "216",
      "y2": "184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "32",
      "x2": "88",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "24",
      "y1": "56",
      "x2": "152",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,56a96,96,0,0,1-96,96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.5,88A96,96,0,0,0,152,152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$15 = undefined;
/* scoped */

const __vue_scope_id__$15 = undefined;
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

var script$14 = Vue.extend({
  name: "PhTrash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "60",
      "x2": "40",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,60V36a16,16,0,0,0-16-16H104A16,16,0,0,0,88,36V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H176V40a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "104",
      "y1": "104",
      "x2": "104",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "104",
      "x2": "152",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$14 = undefined;
/* scoped */

const __vue_scope_id__$14 = undefined;
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

var script$13 = Vue.extend({
  name: "PhTrashSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "60",
      "x2": "40",
      "y2": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "20",
      "x2": "168",
      "y2": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,56a8,8,0,0,1-8,8h-8V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,56ZM88,32h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "216",
      "y1": "56",
      "x2": "40",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "24",
      "x2": "168",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$13 = undefined;
/* scoped */

const __vue_scope_id__$13 = undefined;
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

var script$12 = Vue.extend({
  name: "PhTray",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,156H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M76.7,160a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V160Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V159.9h0V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V168H76.7L96,187.3a15.9,15.9,0,0,0,11.3,4.7h41.4a15.9,15.9,0,0,0,11.3-4.7L179.3,168H208v40Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$12 = undefined;
/* scoped */

const __vue_scope_id__$12 = undefined;
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

var script$11 = Vue.extend({
  name: "PhTree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,187.9h0a91.6,91.6,0,0,1-8,4.6V232a8,8,0,0,0,16,0V192.5a91.6,91.6,0,0,1-8-4.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.1,62.6a76,76,0,0,0-140.2,0A72.3,72.3,0,0,0,16,127.8C15.9,166.6,47.4,199,86.1,200a71.9,71.9,0,0,0,33.9-7.5V156.9L76.4,135.2a8,8,0,1,1,7.2-14.4L120,139.1V88a8,8,0,0,1,16,0v27.1l36.4-18.3a8,8,0,0,1,7.2,14.4L136,132.9v59.6a72,72,0,0,0,32,7.5h1.9c38.7-1,70.2-33.4,70.1-72.2A72.3,72.3,0,0,0,198.1,62.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "232",
      "x2": "128",
      "y2": "88",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "80",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$11 = [];
/* style */

const __vue_inject_styles__$11 = undefined;
/* scoped */

const __vue_scope_id__$11 = undefined;
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

var script$10 = Vue.extend({
  name: "PhTreeEvergreen",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.2,195.5A8,8,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a8,8,0,0,1-6.3-12.9L71.6,128H48a8,8,0,0,1-6.3-12.9l80-104a8,8,0,0,1,12.6,0l80,104A8,8,0,0,1,208,128H184.4l45.9,59.1A8,8,0,0,1,231.2,195.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "192",
      "x2": "128",
      "y2": "240",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$10 = undefined;
/* scoped */

const __vue_scope_id__$10 = undefined;
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

var script$$ = Vue.extend({
  name: "PhTreeStructure",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M156,92V80H144a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16h12V164a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H172a16,16,0,0,1-16-16V192H144a32.1,32.1,0,0,1-32-32V136H84v8a16,16,0,0,1-16,16H36a16,16,0,0,1-16-16V112A16,16,0,0,1,36,96H68a16,16,0,0,1,16,16v8h28V96a32.1,32.1,0,0,1,32-32h12V52a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16V92a16,16,0,0,1-16,16H172A16,16,0,0,1,156,92Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "100",
      "width": "56",
      "height": "56",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "40",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "160",
      "y": "152",
      "width": "64",
      "height": "64",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "128",
      "x2": "120",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$$ = undefined;
/* scoped */

const __vue_scope_id__$$ = undefined;
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

var script$_ = Vue.extend({
  name: "PhTrendDown",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 200 136 104 96 144 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 136 232 200 168 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 200 136 104 96 144 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 136 232 200 168 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,136v64a8,8,0,0,1-8,8H168a8.1,8.1,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L188.7,168,136,115.3l-34.3,34.4a8.1,8.1,0,0,1-11.4,0l-72-72A8.1,8.1,0,0,1,29.7,66.3L96,132.7l34.3-34.4a8.1,8.1,0,0,1,11.4,0L200,156.7l26.3-26.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,240,136Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 200 136 104 96 144 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 136 232 200 168 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 200 136 104 96 144 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 136 232 200 168 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 200 136 104 96 144 24 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 136 232 200 168 200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = undefined;
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var script$Z = Vue.extend({
  name: "PhTrendUp",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 56 136 152 96 112 24 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 120 232 56 168 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 56 136 152 96 112 24 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 120 232 56 168 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240,56v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L200,99.3l-58.3,58.4a8.1,8.1,0,0,1-11.4,0L96,123.3,29.7,189.7A8.3,8.3,0,0,1,24,192a8.5,8.5,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4l72-72a8.1,8.1,0,0,1,11.4,0L136,140.7,188.7,88,162.3,61.7a8.4,8.4,0,0,1-1.7-8.8A8.1,8.1,0,0,1,168,48h64A8,8,0,0,1,240,56Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 56 136 152 96 112 24 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 120 232 56 168 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 56 136 152 96 112 24 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 120 232 56 168 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 56 136 152 96 112 24 184",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 120 232 56 168 56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$Z = undefined;
/* scoped */

const __vue_scope_id__$Z = undefined;
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

var script$Y = Vue.extend({
  name: "PhTriangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.7,188,148.8,36a24,24,0,0,0-41.6,0h0L19.3,188A23.9,23.9,0,0,0,40,224H216a23.9,23.9,0,0,0,20.7-36Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Y = undefined;
/* scoped */

const __vue_scope_id__$Y = undefined;
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

var script$X = Vue.extend({
  name: "PhTrophy",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,64H208V56a16,16,0,0,0-16-16H64A16,16,0,0,0,48,56v8H23.9a16,16,0,0,0-16,16V96a40,40,0,0,0,40,40h4c9.7,29.9,36.2,52.3,68.1,55.6V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.6A79.7,79.7,0,0,0,204.3,136H208a40,40,0,0,0,40-40V80A16,16,0,0,0,232,64ZM47.9,120a24,24,0,0,1-24-24V80H48v31.1a86.9,86.9,0,0,0,.5,8.9ZM232,96a24.1,24.1,0,0,1-24,24h-.4a70.3,70.3,0,0,0,.4-8V80h24Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "96",
      "y1": "224",
      "x2": "160",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "184",
      "x2": "128",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$X = [];
/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = undefined;
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

var script$W = Vue.extend({
  name: "PhTruck",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "76",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "156",
      "y1": "192",
      "x2": "100",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V168.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120h64v64a8,8,0,0,1-8,8H204",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,144H16v40a8,8,0,0,0,8,8H44a24,24,0,0,1,48,0h72a24,24,0,0,1,12-20.8Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M212,192a24,24,0,0,0-36-20.8V120h64v64a8,8,0,0,1-8,8H212",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M248,119.9v-.2a1.7,1.7,0,0,0-.1-.7v-.3c0-.2-.1-.4-.1-.6v-.2l-.2-.8h-.1l-14-34.8A15.7,15.7,0,0,0,218.6,72H184V64a8,8,0,0,0-8-8H24A16,16,0,0,0,8,72V184a16,16,0,0,0,16,16H37a32,32,0,0,0,62,0h58a32,32,0,0,0,62,0h13a16,16,0,0,0,16-16V120ZM184,88h34.6l9.6,24H184ZM24,72H168v64H24ZM68,208a16,16,0,1,1,16-16A16,16,0,0,1,68,208Zm120,0a16,16,0,1,1,16-16A16,16,0,0,1,188,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "144",
      "x2": "176",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "68",
      "cy": "192",
      "r": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "164",
      "y1": "192",
      "x2": "92",
      "y2": "192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,120h64v64a8,8,0,0,1-8,8H212",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$W = [];
/* style */

const __vue_inject_styles__$W = undefined;
/* scoped */

const __vue_scope_id__$W = undefined;
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

var script$V = Vue.extend({
  name: "PhTwitchLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "120",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "120",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V192a16,16,0,0,0,16,16H64v32a7.9,7.9,0,0,0,4.6,7.2,6.8,6.8,0,0,0,3.4.8,7.5,7.5,0,0,0,5.1-1.9L122.9,208h42.2a15.8,15.8,0,0,0,10.2-3.7l42.9-35.8a15.7,15.7,0,0,0,5.8-12.2V48A16,16,0,0,0,208,32ZM128,136a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "120",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "120",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "168",
      "y1": "88",
      "x2": "168",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "120",
      "y1": "88",
      "x2": "120",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$V = undefined;
/* scoped */

const __vue_scope_id__$V = undefined;
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

var script$U = Vue.extend({
  name: "PhTwitterLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M245.7,77.7l-30.2,30.1C209.5,177.7,150.5,232,80,232c-14.5,0-26.5-2.3-35.6-6.8-7.3-3.7-10.3-7.6-11.1-8.8a8,8,0,0,1,3.9-11.9c.2-.1,23.8-9.1,39.1-26.4a108.6,108.6,0,0,1-24.7-24.4c-13.7-18.6-28.2-50.9-19.5-99.1a8.1,8.1,0,0,1,5.5-6.2,8,8,0,0,1,8.1,1.9c.3.4,33.6,33.2,74.3,43.8V88a48.3,48.3,0,0,1,48.6-48,48.2,48.2,0,0,1,41,24H240a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,245.7,77.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$U = undefined;
/* scoped */

const __vue_scope_id__$U = undefined;
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

var script$T = Vue.extend({
  name: "PhUmbrella",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a103.9,103.9,0,0,1,103.6,95.3,7.9,7.9,0,0,1-7.9,8.7H168c0-72-40-104-40-104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,32A103.9,103.9,0,0,0,24.4,127.3a7.9,7.9,0,0,0,7.9,8.7H88c0-72,40-104,40-104",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M239.6,126.6A112.1,112.1,0,0,0,128,24h0A112.1,112.1,0,0,0,16.4,126.6a15.7,15.7,0,0,0,4.2,12.2A15.9,15.9,0,0,0,32.3,144H120v56a32,32,0,0,0,64,0,8,8,0,0,0-16,0,16,16,0,0,1-32,0V144h87.7a15.9,15.9,0,0,0,11.7-5.2A15.7,15.7,0,0,0,239.6,126.6ZM32.3,128a95.9,95.9,0,0,1,75.9-85.9c-11.7,16-26.4,44-28,85.9Zm143.5,0c-1.6-41.9-16.3-69.9-28-85.9A95.9,95.9,0,0,1,223.7,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,136c0-72,40-104,40-104s40,32,40,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = undefined;
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

var script$S = Vue.extend({
  name: "PhUmbrellaSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M235.4,138.8a15.9,15.9,0,0,1-11.7,5.2H136v56a16,16,0,0,0,32,0,8,8,0,0,1,16,0,32,32,0,0,1-64,0V144H32.3a15.9,15.9,0,0,1-11.7-5.2,15.7,15.7,0,0,1-4.2-12.2A111.9,111.9,0,0,1,204,53.8a110.9,110.9,0,0,1,35.6,72.8A15.7,15.7,0,0,1,235.4,138.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,200a24,24,0,0,1-48,0V136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$S = undefined;
/* scoped */

const __vue_scope_id__$S = undefined;
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

var script$R = Vue.extend({
  name: "PhUpload",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M172,128h52a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "24",
      "y": "128",
      "width": "208",
      "height": "80",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M74.3,77.7a8.1,8.1,0,0,1,0-11.4l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L136,43.3V128a8,8,0,0,1-16,0V43.3L85.7,77.7A8.1,8.1,0,0,1,74.3,77.7ZM240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16h68a4,4,0,0,1,4,4v3.5c0,13.4,11,24.8,24.5,24.5A24,24,0,0,0,152,128v-4a4,4,0,0,1,4-4h68A16,16,0,0,1,240,136Zm-40,32a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "128",
      "x2": "128",
      "y2": "24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "80 72 128 24 176 72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "188",
      "cy": "168",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = undefined;
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var script$Q = Vue.extend({
  name: "PhUploadSimple",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 82 128 40 170 82",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 82 128 40 170 82",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M78.6,85a8.2,8.2,0,0,1,1.7-8.7l42-42a8.1,8.1,0,0,1,11.4,0l42,42a8.2,8.2,0,0,1,1.7,8.7,8,8,0,0,1-7.4,5H136v62a8,8,0,0,1-16,0V90H86A8,8,0,0,1,78.6,85ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 82 128 40 170 82",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 82 128 40 170 82",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "86 82 128 40 170 82",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "152",
      "x2": "128",
      "y2": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$Q = undefined;
/* scoped */

const __vue_scope_id__$Q = undefined;
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

var script$P = Vue.extend({
  name: "PhUser",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,216a112,112,0,0,1,194,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,216a112,112,0,0,1,194,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M231.9,212a120.7,120.7,0,0,0-67.1-54.2,72,72,0,1,0-73.6,0A120.7,120.7,0,0,0,24.1,212a7.7,7.7,0,0,0,0,8,7.8,7.8,0,0,0,6.9,4H225a7.8,7.8,0,0,0,6.9-4A7.7,7.7,0,0,0,231.9,212Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,216a112,112,0,0,1,194,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,216a112,112,0,0,1,194,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "96",
      "r": "64",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,216a112,112,0,0,1,194,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = undefined;
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

var script$O = Vue.extend({
  name: "PhUserCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm65.8,162.4a81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23,88,88,0,1,1,131.6,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = undefined;
/* scoped */

const __vue_scope_id__$O = undefined;
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

var script$N = Vue.extend({
  name: "PhUserCircleGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "200",
      "y2": "36",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "181",
      "y2": "49.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "188.2",
      "y2": "72.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "211.8",
      "y2": "72.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "219",
      "y2": "49.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M205.3,71.1a15.5,15.5,0,0,1-5.3.9,16,16,0,0,1-16-16,15.5,15.5,0,0,1,.9-5.3A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,205.3,71.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "48",
      "x2": "175.8",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "64",
      "x2": "175.8",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "64",
      "x2": "224.2",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "48",
      "x2": "224.2",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm103.2-2a8,8,0,0,1-7,4,7.6,7.6,0,0,1-4-1.1l-4.6-2.7a24,24,0,0,1-7.6,4.4V84a8,8,0,0,1-16,0V78.6a24,24,0,0,1-7.6-4.4l-4.6,2.7a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l4.6-2.7A21.2,21.2,0,0,1,176,56a21.2,21.2,0,0,1,.4-4.4l-4.6-2.7a7.9,7.9,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9l4.6,2.7a24,24,0,0,1,7.6-4.4V28a8,8,0,0,1,16,0v5.4a24,24,0,0,1,7.6,4.4l4.6-2.7a8.1,8.1,0,0,1,11,2.9,7.9,7.9,0,0,1-3,10.9l-4.6,2.7A21.2,21.2,0,0,1,224,56a21.2,21.2,0,0,1-.4,4.4l4.6,2.7A7.9,7.9,0,0,1,231.2,74ZM200,64a8,8,0,1,0-8-8A8,8,0,0,0,200,64Zm22.4,44.6a8,8,0,0,0-7,8.8A94.2,94.2,0,0,1,216,128a87.6,87.6,0,0,1-22.2,58.4,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a75,75,0,0,1,8.2.4,8,8,0,1,0,1.4-16c-3.1-.3-6.4-.4-9.6-.4A104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A103.7,103.7,0,0,0,232,128a101.9,101.9,0,0,0-.7-12.4A8,8,0,0,0,222.4,108.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "48",
      "x2": "175.8",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "64",
      "x2": "175.8",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "64",
      "x2": "224.2",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "48",
      "x2": "224.2",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "48",
      "x2": "175.8",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "64",
      "x2": "175.8",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "64",
      "x2": "224.2",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "48",
      "x2": "224.2",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "56",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "40",
      "x2": "200",
      "y2": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "48",
      "x2": "175.8",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "186.1",
      "y1": "64",
      "x2": "175.8",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "72",
      "x2": "200",
      "y2": "84",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "64",
      "x2": "224.2",
      "y2": "70",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "213.9",
      "y1": "48",
      "x2": "224.2",
      "y2": "42",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = undefined;
/* scoped */

const __vue_scope_id__$N = undefined;
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

var script$M = Vue.extend({
  name: "PhUserCircleMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.9,24.5A7.9,7.9,0,0,0,211,98.7a88,88,0,0,1-17.2,87.7,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a92,92,0,0,1,13.9,1.1,8,8,0,0,0,2.5-15.8A99.8,99.8,0,0,0,128,24,104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A104.2,104.2,0,0,0,226.1,93.3,8,8,0,0,0,215.9,88.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = undefined;
/* scoped */

const __vue_scope_id__$M = undefined;
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

var script$L = Vue.extend({
  name: "PhUserCirclePlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.6,41a7.9,7.9,0,0,0-6.7,9.1A92,92,0,0,1,216,128a87.6,87.6,0,0,1-22.2,58.4,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a92,92,0,0,1,13.9,1.1,8,8,0,0,0,2.5-15.8A99.8,99.8,0,0,0,128,24,104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A103.7,103.7,0,0,0,232,128a99.8,99.8,0,0,0-1.3-16.4A7.9,7.9,0,0,0,221.6,105Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "56",
      "x2": "224",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "32",
      "x2": "200",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = undefined;
/* scoped */

const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

var script$K = Vue.extend({
  name: "PhUserFocus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,168a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.9,176a60.1,60.1,0,0,1,106.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M224,48V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h28A16,16,0,0,1,224,48Zm-8,124a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h28a16,16,0,0,0,16-16V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v28a16,16,0,0,0,16,16H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V76A8,8,0,0,0,40,84Zm61.1,57.5a69.1,69.1,0,0,0-33.3,30.8,7.8,7.8,0,0,0,.3,7.8,7.9,7.9,0,0,0,6.8,3.9H181.1a7.9,7.9,0,0,0,6.8-3.9,7.8,7.8,0,0,0,.3-7.8,69.1,69.1,0,0,0-33.3-30.8A39.5,39.5,0,0,0,168,112a40,40,0,0,0-80,0A39.5,39.5,0,0,0,101.1,141.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.9,176a60.1,60.1,0,0,1,106.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.9,176a60.1,60.1,0,0,1,106.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,40h28a8,8,0,0,1,8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M180,216h28a8,8,0,0,0,8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,216H48a8,8,0,0,1-8-8V180",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76,40H48a8,8,0,0,0-8,8V76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "112",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.9,176a60.1,60.1,0,0,1,106.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = undefined;
/* scoped */

const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

var script$J = Vue.extend({
  name: "PhUserGear",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "224",
      "y2": "116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "205",
      "y2": "129.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "212.2",
      "y2": "152.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "235.8",
      "y2": "152.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "136",
      "x2": "243",
      "y2": "129.8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "128",
      "x2": "195.8",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "144",
      "x2": "195.8",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "144",
      "x2": "244.2",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "128",
      "x2": "244.2",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M199.9,194.9a7.8,7.8,0,0,1,1.1,8.5,7.9,7.9,0,0,1-7.2,4.6H22.2a7.9,7.9,0,0,1-7.2-4.6,7.8,7.8,0,0,1,1.1-8.5,118.4,118.4,0,0,1,55.8-37.3,68,68,0,1,1,72.2,0A118.4,118.4,0,0,1,199.9,194.9ZM251.2,154a8,8,0,0,1-7,4,7.6,7.6,0,0,1-4-1.1l-4.6-2.7a24,24,0,0,1-7.6,4.4V164a8,8,0,0,1-16,0v-5.4a24,24,0,0,1-7.6-4.4l-4.6,2.7a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l4.6-2.7a24.4,24.4,0,0,1,0-8.8l-4.6-2.7a7.9,7.9,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9l4.6,2.7a24,24,0,0,1,7.6-4.4V108a8,8,0,0,1,16,0v5.4a24,24,0,0,1,7.6,4.4l4.6-2.7a8.1,8.1,0,0,1,11,2.9,7.9,7.9,0,0,1-3,10.9l-4.6,2.7a24.4,24.4,0,0,1,0,8.8l4.6,2.7A7.9,7.9,0,0,1,251.2,154ZM220,144a8,8,0,1,0-8-8A8,8,0,0,0,220,144Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "128",
      "x2": "195.8",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "144",
      "x2": "195.8",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "144",
      "x2": "244.2",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "128",
      "x2": "244.2",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "128",
      "x2": "195.8",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "144",
      "x2": "195.8",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "144",
      "x2": "244.2",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "128",
      "x2": "244.2",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "220",
      "cy": "136",
      "r": "16",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "120",
      "x2": "220",
      "y2": "108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "128",
      "x2": "195.8",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "206.1",
      "y1": "144",
      "x2": "195.8",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "152",
      "x2": "220",
      "y2": "164",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "144",
      "x2": "244.2",
      "y2": "150",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "233.9",
      "y1": "128",
      "x2": "244.2",
      "y2": "122",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = undefined;
/* scoped */

const __vue_scope_id__$J = undefined;
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var script$I = Vue.extend({
  name: "PhUserList",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "244",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "244",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "244",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18,192a64,64,0,0,1,124,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18,192a64,64,0,0,1,124,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M144,80a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H152A8,8,0,0,1,144,80Zm104,40H152a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,48H176a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM109.1,142.1a48,48,0,1,0-58.2,0A72,72,0,0,0,10.3,190a8.1,8.1,0,0,0,1.4,6.9A7.8,7.8,0,0,0,18,200H142a7.8,7.8,0,0,0,6.3-3.1,8.1,8.1,0,0,0,1.4-6.9A72,72,0,0,0,109.1,142.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18,192a64,64,0,0,1,124,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18,192a64,64,0,0,1,124,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "104",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "80",
      "x2": "248",
      "y2": "80",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "248",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "176",
      "x2": "248",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18,192a64,64,0,0,1,124,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = undefined;
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var script$H = Vue.extend({
  name: "PhUserMinus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "136",
      "x2": "244",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,136a8,8,0,0,1-8,8H200a8,8,0,0,1,0-16h48A8,8,0,0,1,256,136ZM144.1,157.6a68,68,0,1,0-72.2,0,118.4,118.4,0,0,0-55.8,37.3,7.8,7.8,0,0,0-1.1,8.5,7.9,7.9,0,0,0,7.2,4.6H193.8a7.9,7.9,0,0,0,7.2-4.6,7.8,7.8,0,0,0-1.1-8.5A118.4,118.4,0,0,0,144.1,157.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

var script$G = Vue.extend({
  name: "PhUserPlus",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "204",
      "y1": "136",
      "x2": "244",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "116",
      "x2": "224",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M256,136a8,8,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A8,8,0,0,1,256,136ZM144.1,157.6a68,68,0,1,0-72.2,0,118.4,118.4,0,0,0-55.8,37.3,7.8,7.8,0,0,0-1.1,8.5,7.9,7.9,0,0,0,7.2,4.6H193.8a7.9,7.9,0,0,0,7.2-4.6,7.8,7.8,0,0,0-1.1-8.5A118.4,118.4,0,0,0,144.1,157.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "136",
      "x2": "248",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "112",
      "x2": "224",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "108",
      "cy": "100",
      "r": "60",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.2,200a112,112,0,0,1,171.6,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$G = undefined;
/* scoped */

const __vue_scope_id__$G = undefined;
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

var script$F = Vue.extend({
  name: "PhUserRectangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.5,208a72,72,0,0,1,129,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H60.1A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,67.9,48H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,208a72,72,0,0,1,135.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H201.3a80.2,80.2,0,0,0-32-36.5,59.9,59.9,0,0,1-82.6,0,80.2,80.2,0,0,0-32,36.5H40V56H216V200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,208a72,72,0,0,1,135.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,208a72,72,0,0,1,135.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.1,208a72,72,0,0,1,135.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = undefined;
/* scoped */

const __vue_scope_id__$F = undefined;
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

var script$E = Vue.extend({
  name: "PhUserSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.8,216a72,72,0,0,1,140.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM57.8,216A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,70.2,56Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.8,216a72,72,0,0,1,140.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176h-3.7a80.7,80.7,0,0,0-26-38.2,76.8,76.8,0,0,0-9-6.3,59.9,59.9,0,0,1-82.6,0,76.8,76.8,0,0,0-9,6.3,80.7,80.7,0,0,0-26,38.2H48V48H208V208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.8,216a72,72,0,0,1,140.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.8,216a72,72,0,0,1,140.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.8,216a72,72,0,0,1,140.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = undefined;
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

var script$D = Vue.extend({
  name: "PhUserSwitch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "204 132 224 152 244 132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "12 124 32 104 52 124",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152V128A96,96,0,0,0,52,69.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104v24a96,96,0,0,0,172,58.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 128 224 152 248 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8 128 32 104 56 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152V128A96,96,0,0,0,47.3,75.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104v24a96,96,0,0,0,176.7,52.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M253.7,133.7l-24,24a8.2,8.2,0,0,1-11.4,0l-24-24a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,200,120h15.6A87.9,87.9,0,0,0,54.1,80.3,8,8,0,0,1,43,82.6a7.9,7.9,0,0,1-2.4-11A104,104,0,0,1,231.7,120H248a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,253.7,133.7ZM213,173.4a8,8,0,0,0-11.1,2.3,86.9,86.9,0,0,1-8.1,10.8h0a81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23h0A87.6,87.6,0,0,1,40.4,136H56a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-24-24a8.1,8.1,0,0,0-11.4,0l-24,24a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,8,136H24.3a103.7,103.7,0,0,0,34.5,69.6h0l.4.3a103.9,103.9,0,0,0,156.2-21.5A7.9,7.9,0,0,0,213,173.4ZM128,164a44,44,0,1,0-44-44A44,44,0,0,0,128,164Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 128 224 152 248 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8 128 32 104 56 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152V128A96,96,0,0,0,47.3,75.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104v24a96,96,0,0,0,176.7,52.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 128 224 152 248 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8 128 32 104 56 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152V128A96,96,0,0,0,47.3,75.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104v24a96,96,0,0,0,176.7,52.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "120",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.8,199.4a72,72,0,0,1,128.4,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "200 128 224 152 248 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8 128 32 104 56 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,152V128A96,96,0,0,0,47.3,75.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,104v24a96,96,0,0,0,176.7,52.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = undefined;
/* scoped */

const __vue_scope_id__$D = undefined;
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var script$C = Vue.extend({
  name: "PhUsers",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.4a88,88,0,0,1,144,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,160a87.9,87.9,0,0,1,72,37.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.4a88,88,0,0,1,144,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,160a87.9,87.9,0,0,1,72,37.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M121.2,157.9a60,60,0,1,0-66.4,0A95.5,95.5,0,0,0,9.5,192.8a7.8,7.8,0,0,0-.6,8.3,8.1,8.1,0,0,0,7.1,4.3H160a8.1,8.1,0,0,0,7.1-4.3,7.8,7.8,0,0,0-.6-8.3A95.5,95.5,0,0,0,121.2,157.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M248.1,192.8a96.3,96.3,0,0,0-45.4-34.9A59.9,59.9,0,0,0,169.5,48a64,64,0,0,0-16.3,2.2,8.2,8.2,0,0,0-5.4,5.2,8,8,0,0,0,1.2,7.3,75.8,75.8,0,0,1,3.8,84.9,8.1,8.1,0,0,0,2.1,10.6q4.5,3.5,8.7,7.2l.5.5a112.6,112.6,0,0,1,25.5,34.9,7.9,7.9,0,0,0,7.2,4.6h44.7a8.1,8.1,0,0,0,7.1-4.3A8,8,0,0,0,248.1,192.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.4a88,88,0,0,1,144,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,160a87.9,87.9,0,0,1,72,37.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.4a88,88,0,0,1,144,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,160a87.9,87.9,0,0,1,72,37.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "88",
      "cy": "108",
      "r": "52",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,197.4a88,88,0,0,1,144,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.5,160a87.9,87.9,0,0,1,72,37.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = undefined;
/* scoped */

const __vue_scope_id__$C = undefined;
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

var script$B = Vue.extend({
  name: "PhUsersFour",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,116a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "172",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,116a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M25.6,115.2A67.8,67.8,0,0,1,53,93.5a40,40,0,1,1,54,0,68.1,68.1,0,0,1,21,14.3,68.1,68.1,0,0,1,21-14.3,40,40,0,1,1,54,0,67.8,67.8,0,0,1,27.4,21.7,8,8,0,0,1-1.6,11.2,8.1,8.1,0,0,1-11.2-1.6,52,52,0,0,0-83.2,0h0l-.6.6h-.1l-.5.5-.3.2a.1.1,0,0,1-.1.1l-.3.2-.3.2-.5.3h-.2l-1.7.6h-3.3l-.8-.2h-.3l-.9-.4-.3-.2a4.7,4.7,0,0,1-.9-.6h-.1l-.3-.3h-.2c-.2-.2-.4-.3-.5-.5h-.1l-.6-.7a52,52,0,0,0-83.1.1A8,8,0,0,1,32,128a7.7,7.7,0,0,1-4.8-1.6A8,8,0,0,1,25.6,115.2ZM203,197.5a40,40,0,1,0-54,0,68.1,68.1,0,0,0-21,14.3,68.1,68.1,0,0,0-21-14.3,40,40,0,1,0-54,0,67.8,67.8,0,0,0-27.4,21.7A8,8,0,0,0,32,232H224a8,8,0,0,0,6.4-12.8A67.8,67.8,0,0,0,203,197.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "168",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "176",
      "cy": "64",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,120a60,60,0,0,1,96,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = undefined;
/* scoped */

const __vue_scope_id__$B = undefined;
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

var script$A = Vue.extend({
  name: "PhUsersThree",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4,216a64.1,64.1,0,0,1,115.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M204.5,116.6A60.1,60.1,0,0,1,244,140",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.1,70.2A32,32,0,1,1,204,115",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,115A32,32,0,1,1,88.9,70.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,140a60.1,60.1,0,0,1,39.5-23.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "60",
      "cy": "84",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "84",
      "r": "32",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.8,59.8,0,0,1,48,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,140a59.8,59.8,0,0,1,48-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4,216a64.1,64.1,0,0,1,115.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.4,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.6,78A32,32,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M64,140a7.9,7.9,0,0,1-8,8H12a8.2,8.2,0,0,1-7.2-4.4,8.2,8.2,0,0,1,.8-8.4A67.8,67.8,0,0,1,33,113.5a40,40,0,1,1,66.3-37,8.1,8.1,0,0,1-3.8,8.4,64.3,64.3,0,0,0-27.8,33.8A61.6,61.6,0,0,0,64,140Zm186.4-4.8A67.8,67.8,0,0,0,223,113.5a40,40,0,1,0-66.3-37,8.1,8.1,0,0,0,3.8,8.4,64,64,0,0,1,27.8,33.8A61.6,61.6,0,0,1,192,140a7.9,7.9,0,0,0,8,8h44a8,8,0,0,0,6.4-12.8Zm-93.2,42.9a48,48,0,1,0-58.4,0,72.1,72.1,0,0,0-35.6,34.4,7.8,7.8,0,0,0,.5,7.7,7.8,7.8,0,0,0,6.7,3.8H185.6a7.8,7.8,0,0,0,6.7-3.8,7.8,7.8,0,0,0,.5-7.7A72.1,72.1,0,0,0,157.2,178.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.8,59.8,0,0,1,48,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,140a59.8,59.8,0,0,1,48-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4,216a64.1,64.1,0,0,1,115.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.4,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.6,78A32,32,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.8,59.8,0,0,1,48,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,140a59.8,59.8,0,0,1,48-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4,216a64.1,64.1,0,0,1,115.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.4,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.6,78A32,32,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "140",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M196,116a59.8,59.8,0,0,1,48,24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12,140a59.8,59.8,0,0,1,48-24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4,216a64.1,64.1,0,0,1,115.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60,116A32,32,0,1,1,91.4,78",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.6,78A32,32,0,1,1,196,116",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = undefined;
/* scoped */

const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var script$z = Vue.extend({
  name: "PhVault",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "200",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "180",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "148",
      "cy": "128",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM152,168a40,40,0,1,1,40-40A40,40,0,0,1,152,168Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "192",
      "y1": "200",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V192a16,16,0,0,0,16,16H56v16a8,8,0,0,0,16,0V208H184v16a8,8,0,0,0,16,0V208h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-8,96H179.1a36,36,0,1,1,0-16H208a8,8,0,0,1,0,16Zm-44-8a20,20,0,1,1-20-20A20.1,20.1,0,0,1,164,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "200",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "14"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "200",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "192",
      "y1": "200",
      "x2": "192",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "64",
      "y1": "200",
      "x2": "64",
      "y2": "224",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "152",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "152",
      "y1": "128",
      "x2": "224",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "152",
      "cy": "128",
      "r": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = undefined;
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

var script$y = Vue.extend({
  name: "PhVibrate",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "76",
      "width": "176",
      "height": "104",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "220",
      "y1": "100",
      "x2": "220",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "36",
      "y1": "100",
      "x2": "36",
      "y2": "156",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "88",
      "x2": "208",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('rect', {
    attrs: {
      "x": "72",
      "y": "32",
      "width": "112",
      "height": "192",
      "rx": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M208,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,208,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M240,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,240,96Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,48,80Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,16,96Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "88",
      "x2": "208",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "88",
      "x2": "208",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "80",
      "width": "176",
      "height": "96",
      "rx": "16",
      "transform": "translate(256) rotate(90)",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "208",
      "y1": "88",
      "x2": "208",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "240",
      "y1": "104",
      "x2": "240",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "88",
      "x2": "48",
      "y2": "168",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "104",
      "x2": "16",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = undefined;
/* scoped */

const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var script$x = Vue.extend({
  name: "PhVideoCamera",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M176,92v96a16,16,0,0,1-16,16H48A40,40,0,0,1,8,164V68A16,16,0,0,1,24,52H136A40,40,0,0,1,176,92Zm68-18.9a7.7,7.7,0,0,0-8,0L196,95.9a8,8,0,0,0-4,7v50.2a8,8,0,0,0,4,7l40,22.8a8.3,8.3,0,0,0,4,1.1,8,8,0,0,0,4-1.1,7.8,7.8,0,0,0,4-6.9V80A7.8,7.8,0,0,0,244,73.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "184 112 240 80 240 176 184 144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = undefined;
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var script$w = Vue.extend({
  name: "PhVideoCameraSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121.7,60H176a8,8,0,0,1,8,8V188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "16",
      "y": "60",
      "width": "168",
      "height": "136",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.9,60H176a8,8,0,0,1,8,8v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.9,226.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,224,240a8,8,0,0,1-5.9-2.6l-42.4-46.6A15.9,15.9,0,0,1,160,204H24A16,16,0,0,1,8,188V68A16,16,0,0,1,24,52H49.6L29,29.4a8,8,0,0,1,.5-11.3,7.9,7.9,0,0,1,11.3.5ZM245.5,74.2a7.9,7.9,0,0,0-9.5-1.1L196,95.9a8,8,0,0,0-4,7v50.2a8,8,0,0,0,4,7l40,22.8a8.3,8.3,0,0,0,4,1.1,7.9,7.9,0,0,0,5.8-2.5,8,8,0,0,0,2.2-5.7V80.2A8,8,0,0,0,245.5,74.2Zm-83.4,54a8,8,0,0,0,9.8,1.6,8.2,8.2,0,0,0,4.1-7.3V68a16,16,0,0,0-16-16H111.1a8.5,8.5,0,0,0-6.6,3.1,8,8,0,0,0,.5,10.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.9,60H176a8,8,0,0,1,8,8v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.9,60H176a8,8,0,0,1,8,8v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "240 176 184 144 184 112 240 80 240 176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.9",
      "y1": "24",
      "x2": "224",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.9,60H176a8,8,0,0,1,8,8v76",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = undefined;
/* scoped */

const __vue_scope_id__$w = undefined;
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var script$v = Vue.extend({
  name: "PhVignette",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "56",
      "ry": "40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM128,176c-35.3,0-64-21.5-64-48s28.7-48,64-48,64,21.5,64,48S163.3,176,128,176Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "64",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-16,88c0,30.9-32.2,56-72,56s-72-25.1-72-56,32.2-56,72-56S200,97.1,200,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "64",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "64",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "48",
      "width": "192",
      "height": "160",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "rx": "64",
      "ry": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = undefined;
/* scoped */

const __vue_scope_id__$v = undefined;
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var script$u = Vue.extend({
  name: "PhVoicemail",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "196",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "60",
      "y1": "176",
      "x2": "196",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200,72a55.9,55.9,0,0,0-39.1,96H95.1A55.9,55.9,0,1,0,56,184H200a56,56,0,0,0,0-112ZM16,128a40,40,0,1,1,40,40A40,40,0,0,1,16,128Zm184,40a40,40,0,1,1,40-40A40,40,0,0,1,200,168Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "56",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "200",
      "cy": "128",
      "r": "48",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "56",
      "y1": "176",
      "x2": "200",
      "y2": "176",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = undefined;
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var script$t = Vue.extend({
  name: "PhVolleyball",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.9",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.1",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.1,185.6A96,96,0,0,1,105.5,89",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.3,165.8A96,96,0,0,1,105.5,167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M80,211.2a96.2,96.2,0,0,0,136.3-45.4h0A96,96,0,0,1,105.5,167L80,211.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,211.1a96.3,96.3,0,0,1-28.9-25.5h0A96,96,0,0,1,105.5,89L128,128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,44.9a96,96,0,0,1,36.6-12.2h0A96.1,96.1,0,0,1,173.1,128H128Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.9",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.1",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.1,185.6A96,96,0,0,1,105.5,89",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.3,165.8A96,96,0,0,1,105.5,167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,127.6A104,104,0,1,0,37.9,180c2,3.4,4.2,6.7,6.5,9.9l.5.7a103.9,103.9,0,0,0,178.2-20.7,7.2,7.2,0,0,0,.9-2,105.7,105.7,0,0,0,8-39.3v-1ZM44.5,155.9A88.2,88.2,0,0,1,77.3,56.1L94.4,85.8a104.4,104.4,0,0,0-49.9,70.1Zm32.8,44a84.2,84.2,0,0,1-18.4-17.4,88,88,0,0,1,43.5-82.9L118.8,128Zm132.4-39.3a88.2,88.2,0,0,1-93.5,3.8L132.6,136h83A89.3,89.3,0,0,1,209.7,160.6ZM181.4,120a105,105,0,0,0-35.7-78.2A87.9,87.9,0,0,1,215.6,120Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.9",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.1",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.1,185.6A96,96,0,0,1,105.5,89",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.3,165.8A96,96,0,0,1,105.5,167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.9",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.1",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.1,185.6A96,96,0,0,1,105.5,89",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.3,165.8A96,96,0,0,1,105.5,167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "44.9",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "211.1",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "128",
      "x2": "128",
      "y2": "128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.1,185.6A96,96,0,0,1,105.5,89",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.3,165.8A96,96,0,0,1,105.5,167",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = undefined;
/* scoped */

const __vue_scope_id__$t = undefined;
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var script$s = Vue.extend({
  name: "PhWall",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "128",
      "y": "152",
      "width": "96",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "176",
      "y": "104",
      "width": "48",
      "height": "48",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M136,92h92a4,4,0,0,0,4-4V56a8,8,0,0,0-8-8H140a4,4,0,0,0-4,4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184,152h44a4,4,0,0,0,4-4V112a4,4,0,0,0-4-4H184Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "88",
      "y": "108",
      "width": "80",
      "height": "44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72,108H28a4,4,0,0,0-4,4v36a4,4,0,0,0,4,4H72Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136,168v36a4,4,0,0,0,4,4h84a8,8,0,0,0,8-8V172a4,4,0,0,0-4-4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,92V52a4,4,0,0,0-4-4H32a8,8,0,0,0-8,8V88a4,4,0,0,0,4,4Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120,168H28a4,4,0,0,0-4,4v28a8,8,0,0,0,8,8h84a4,4,0,0,0,4-4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "80",
      "y1": "152",
      "x2": "80",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "176",
      "y1": "152",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "200",
      "x2": "128",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "104",
      "x2": "224",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "152",
      "x2": "224",
      "y2": "152",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "56",
      "width": "192",
      "height": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = undefined;
/* scoped */

const __vue_scope_id__$s = undefined;
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var script$r = Vue.extend({
  name: "PhWallet",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,68V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V96a8,8,0,0,0-8-8H60.5A20.3,20.3,0,0,1,40,68.7,20,20,0,0,1,60,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M216,72H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24.1,24.1,0,0,0,32,64V192a24.1,24.1,0,0,0,24,24H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72Zm-36,84a12,12,0,1,1,12-12A12,12,0,0,1,180,156Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "180",
      "cy": "144",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = undefined;
/* scoped */

const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var script$q = Vue.extend({
  name: "PhWarning",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "112",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M236.7,188,148.8,36a24,24,0,0,0-41.6,0h0L19.3,188A23.9,23.9,0,0,0,40,224H216a23.9,23.9,0,0,0,20.7-36ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "104",
      "x2": "128",
      "y2": "144",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "180",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var script$p = Vue.extend({
  name: "PhWarningCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = undefined;
/* scoped */

const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var script$o = Vue.extend({
  name: "PhWarningOctagon",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "132",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M227.3,80.2,175.8,28.7A16.1,16.1,0,0,0,164.5,24h-73a16.1,16.1,0,0,0-11.3,4.7L28.7,80.2A16.1,16.1,0,0,0,24,91.5v73a16.1,16.1,0,0,0,4.7,11.3l51.5,51.5A16.1,16.1,0,0,0,91.5,232h73a16.1,16.1,0,0,0,11.3-4.7l51.5-51.5a16.1,16.1,0,0,0,4.7-11.3v-73A16.1,16.1,0,0,0,227.3,80.2ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "80",
      "x2": "128",
      "y2": "136",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "172",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = undefined;
/* scoped */

const __vue_scope_id__$o = undefined;
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var script$n = Vue.extend({
  name: "PhWatch",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 96 128 128 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.1l7-45.3a8,8,0,0,1,7.9-6.8h50.2a8,8,0,0,1,7.9,6.8l7,45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.9l7,45.3a8,8,0,0,0,7.9,6.8h50.2a8,8,0,0,0,7.9-6.8l7-45.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M175.3,63.5l-6.2-34.4A16,16,0,0,0,153.3,16H102.7A16,16,0,0,0,86.9,29.1L80.7,63.5a80,80,0,0,0,0,129l6.2,34.4A16,16,0,0,0,102.7,240h50.6a16,16,0,0,0,15.8-13.1l6.2-34.4a80,80,0,0,0,0-129ZM102.7,32h50.6l3.9,21.6a78.9,78.9,0,0,0-58.4,0Zm50.6,192H102.7l-3.9-21.6a78.9,78.9,0,0,0,58.4,0ZM168,136H128a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "128 88 128 128 168 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = undefined;
/* scoped */

const __vue_scope_id__$n = undefined;
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var script$m = Vue.extend({
  name: "PhWaveSawtooth",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128 24 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,200a7.8,7.8,0,0,1-3.9-1,8.1,8.1,0,0,1-4.1-7V78.3L28.2,134.8a8,8,0,0,1-8.4-13.6l104-64A8,8,0,0,1,136,64V177.7l91.8-56.5a8,8,0,0,1,8.4,13.6l-104,64A7.9,7.9,0,0,1,128,200Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 128 64 128 192 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = undefined;
/* scoped */

const __vue_scope_id__$m = undefined;
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

var script$l = Vue.extend({
  name: "PhWaveSine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M178,200.7c-25.1,0-40.7-33.7-57.3-69.3-13-28.2-27.8-60.1-42.7-60.1s-36.3,37.6-46.7,60.1a8.1,8.1,0,1,1-14.6-6.8C38.7,77.4,58.1,55.3,78,55.3c25.1,0,40.7,33.7,57.3,69.3,13,28.2,27.8,60.1,42.7,60.1,16.4,0,36.3-37.6,46.7-60.1a8.1,8.1,0,0,1,14.6,6.8C217.3,178.6,197.9,200.7,178,200.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M24,128c104-224,104,224,208,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var script$k = Vue.extend({
  name: "PhWaveSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128 232 128",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M232,192H128a8,8,0,0,1-8-8V80H32v48a8,8,0,0,1-16,0V72a8,8,0,0,1,8-8H128a8,8,0,0,1,8,8V176h88V128a8,8,0,0,1,16,0v56A8,8,0,0,1,232,192Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "232 128 232 184 128 184 128 72 24 72 24 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var script$j = Vue.extend({
  name: "PhWaveTriangle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128 24 128",
      "opacity": "0.2"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M180,208a7.9,7.9,0,0,1-6.5-3.3L76,69.7l-45.5,63a8,8,0,1,1-13-9.4l52-72a8.1,8.1,0,0,1,13,0l97.5,135,45.5-63a8,8,0,0,1,13,9.4l-52,72A7.9,7.9,0,0,1,180,208Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polyline', {
    attrs: {
      "points": "24 128 76 56 180 200 232 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var script$i = Vue.extend({
  name: "PhWaves",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M33.7,77A8,8,0,0,1,35,65.8,81.8,81.8,0,0,1,64.1,52.2c16.1-4,41.1-5,68.3,13.1,42.4,28.3,77.2,1.6,78.6.4A8.2,8.2,0,0,1,222.3,67,8,8,0,0,1,221,78.2a81.8,81.8,0,0,1-29.1,13.6,81,81,0,0,1-19.7,2.4c-14,0-30.8-3.7-48.6-15.5C81.2,50.4,46.4,77.1,45,78.3A8.2,8.2,0,0,1,33.7,77ZM211,121.7c-1.4,1.2-36.2,27.9-78.6-.4-27.2-18.1-52.2-17.1-68.3-13.1A81.8,81.8,0,0,0,35,121.8,8,8,0,0,0,33.7,133,8.2,8.2,0,0,0,45,134.3c1.4-1.2,36.2-27.9,78.6.4,17.8,11.8,34.6,15.5,48.6,15.5a81,81,0,0,0,19.7-2.4A81.8,81.8,0,0,0,221,134.2a8,8,0,0,0,1.3-11.2A8.2,8.2,0,0,0,211,121.7Zm0,56c-1.4,1.2-36.2,27.9-78.6-.4-27.2-18.1-52.2-17.1-68.3-13.1A81.8,81.8,0,0,0,35,177.8,8,8,0,0,0,33.7,189,8.2,8.2,0,0,0,45,190.3c1.4-1.2,36.2-27.9,78.6.4,17.8,11.8,34.6,15.5,48.6,15.5a82.6,82.6,0,0,0,48.8-16,8,8,0,0,0,1.3-11.2A8.2,8.2,0,0,0,211,177.7Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M40,72s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,128s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40,184s40-32,88,0,88,0,88,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = undefined;
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var script$h = Vue.extend({
  name: "PhWebcam",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "28",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "208",
      "x2": "224",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32a72,72,0,1,0,72,72A72,72,0,0,0,128,32Zm0,104a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "208",
      "x2": "224",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M224,200H136V183.6a80,80,0,1,0-16,0V200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM80,104a48,48,0,1,1,48,48A48,48,0,0,1,80,104Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "208",
      "x2": "224",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "208",
      "x2": "224",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "72",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "104",
      "r": "32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32",
      "y1": "208",
      "x2": "224",
      "y2": "208",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var script$g = Vue.extend({
  name: "PhWhatsappLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,103.5A23.9,23.9,0,0,1,104,80h3.5a7.9,7.9,0,0,1,6.8,3.9l7.4,12.3a7.8,7.8,0,0,1,.3,7.7l-4.7,9.6h0a36,36,0,0,0,25.2,25.2h0l9.6-4.7a7.8,7.8,0,0,1,7.7.3l12.3,7.4a7.9,7.9,0,0,1,3.9,6.8V152a23.9,23.9,0,0,1-23.5,24A71.9,71.9,0,0,1,80,103.5Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,32A96.1,96.1,0,0,0,45.4,177h0L36,210.2a7.9,7.9,0,0,0,9.8,9.8L79,210.6h0A96,96,0,1,0,128,32Zm24.1,152A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6A28.1,28.1,0,0,1,152.1,184Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Zm24.1,168H152a88.1,88.1,0,0,1-88-88.1A36,36,0,0,1,100,68a14.9,14.9,0,0,1,12.9,7.5L124.6,96a15.8,15.8,0,0,1-.2,16.1L117.3,124A41.4,41.4,0,0,0,132,138.7l11.9-7.1a15.8,15.8,0,0,1,16.1-.2l20.5,11.7A14.9,14.9,0,0,1,188,156,36,36,0,0,1,152.1,192Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.5,154.7a8.1,8.1,0,0,1-7.4.4,55.4,55.4,0,0,1-28.2-28.2,8.1,8.1,0,0,1,.4-7.4l9.4-15.6L99.4,84A19.9,19.9,0,0,0,80,103.9,72,72,0,0,0,152,176h.1A19.9,19.9,0,0,0,172,156.6l-19.9-11.3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var script$f = Vue.extend({
  name: "PhWheelchair",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.9 60 95.9 136 183.9 136 215.9 200 239.9 192",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M163.2,184.1A64,64,0,1,1,103.9,96h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.8,164a64,64,0,1,1-63.9-68h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M247.5,185.5a8,8,0,0,0-10.1-5.1l-17.5,5.8L191,128.4a7.9,7.9,0,0,0-7.1-4.4h-80V104h56a8,8,0,0,0,0-16h-56V62.6a24,24,0,1,0-16,0V89.8a72,72,0,1,0,87.8,74.7,8,8,0,1,0-15.9-1,56,56,0,1,1-71.9-57.2V132a8,8,0,0,0,8,8h83l29.8,59.6a8,8,0,0,0,7.2,4.4,7.3,7.3,0,0,0,2.5-.4l24-8A8,8,0,0,0,247.5,185.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.8,164a64,64,0,1,1-63.9-68h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.8,164a64,64,0,1,1-63.9-68h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "95.9",
      "cy": "40",
      "r": "20",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.8,164a64,64,0,1,1-63.9-68h56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = undefined;
/* scoped */

const __vue_scope_id__$f = undefined;
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var script$e = Vue.extend({
  name: "PhWifiHigh",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.9,80.5a15.6,15.6,0,0,0-6.2-10.9c-66.4-50.1-159-50.1-225.3-.1a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3l103,121.3a15.9,15.9,0,0,0,24.2,0l103-121.4A16.4,16.4,0,0,0,246.9,80.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$d = Vue.extend({
  name: "PhWifiLow",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M71.1,148.9a87.9,87.9,0,0,1,113.8,0l-50.9,60a7.9,7.9,0,0,1-12.1-.1Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.1,148.9a87.9,87.9,0,0,1,113.8,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M246.8,80.5a15.7,15.7,0,0,0-6.2-11c-66.3-50-158.9-50-225.2,0h0a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3L115.8,214a16.4,16.4,0,0,0,4,3.4,15.6,15.6,0,0,0,8.2,2.3h0a15.7,15.7,0,0,0,10.9-4.4,6.8,6.8,0,0,0,1.2-1.2l103-121.4A16,16,0,0,0,246.8,80.5Zm-15.9,1.9-47.1,55.5a95.9,95.9,0,0,0-111.6,0L25.1,82.4h0c60.6-45.7,145.3-45.7,205.8,0Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = undefined;
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$c = Vue.extend({
  name: "PhWifiMedium",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M134,208.9a7.9,7.9,0,0,1-12.1-.1L50.4,124.5a119.9,119.9,0,0,1,155.2,0Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.4,124.5a119.9,119.9,0,0,1,155.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M240.6,69.6C174.3,19.5,81.7,19.5,15.4,69.5a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3L115.8,214a16.1,16.1,0,0,0,12.2,5.7h0a16,16,0,0,0,12.1-5.6h0l103-121.4a16,16,0,0,0,3.7-12.2A15.6,15.6,0,0,0,240.6,69.6ZM25,82.3Zm179.5,31.2a131,131,0,0,0-17-10.7l-.8-.4a122.1,122.1,0,0,0-17.8-7.6l-1.5-.4A115.2,115.2,0,0,0,149,89.8l-1.6-.2a118.4,118.4,0,0,0-38.8,0l-1.6.2a126.7,126.7,0,0,0-18.4,4.5l-1.5.5a127,127,0,0,0-17.8,7.6l-.8.4a123.5,123.5,0,0,0-16.9,10.7h0L25.1,82.3c60.6-45.7,145.3-45.7,205.8.1Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1a98.8,98.8,0,0,1,138,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var script$b = Vue.extend({
  name: "PhWifiNone",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8.1,8.1,0,0,1,237,87.5c-19,22.5-83,97.8-103,121.4a7.9,7.9,0,0,1-12,0C102,185.3,38,110,19,87.5A8.1,8.1,0,0,1,20.2,75.9Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,219.7a16,16,0,0,1-12.1-5.6L12.9,92.7A15.8,15.8,0,0,1,9.2,80.5a16.3,16.3,0,0,1,6.2-11c66.3-50,158.9-50,225.2,0a16.3,16.3,0,0,1,6.2,11,16,16,0,0,1-3.7,12.2l-103,121.4A16,16,0,0,1,128,219.7ZM25.1,82.3h0L128,203.6,230.9,82.4v-.2C170.4,36.6,85.7,36.6,25.1,82.3Zm-.1,0Zm-4.8-6.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$a = Vue.extend({
  name: "PhWifiSlash",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25,98.2A147.2,147.2,0,0,1,72.4,66.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A98.3,98.3,0,0,1,108,106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M117,56.4c3.6-.3,7.3-.4,11-.4A145.6,145.6,0,0,1,230.9,98.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.8,112.3A99.2,99.2,0,0,1,197,132.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M166.6,170.5,134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6a8.1,8.1,0,0,1,1.2-11.7A177.8,177.8,0,0,1,60.1,53.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.2,43.2A179.3,179.3,0,0,1,235.8,75.9,8,8,0,0,1,237,87.5l-49.5,58.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M53.9,34.6A8,8,0,0,0,42,45.4l4.7,5.1A182.8,182.8,0,0,0,15.3,69.6,15.6,15.6,0,0,0,9.1,80.5a16.3,16.3,0,0,0,3.8,12.3L115.8,214a15.9,15.9,0,0,0,24.3.1l26.7-31.5,35.3,38.8A8.2,8.2,0,0,0,208,224a7.8,7.8,0,0,0,5.4-2.1,8,8,0,0,0,.6-11.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M246.9,80.5a15.6,15.6,0,0,0-6.2-10.9A188,188,0,0,0,92.6,35.3a8.3,8.3,0,0,0-6.1,5.4,8.2,8.2,0,0,0,1.7,7.9l93.4,102.7a8.3,8.3,0,0,0,5.9,2.6h.2a8.3,8.3,0,0,0,5.9-2.8l49.6-58.4A16.4,16.4,0,0,0,246.9,80.5Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,107A97.5,97.5,0,0,1,197,132.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A98.3,98.3,0,0,1,108,106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,107A97.5,97.5,0,0,1,197,132.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A98.3,98.3,0,0,1,108,106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "48",
      "y1": "40",
      "x2": "208",
      "y2": "216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M152.1,107A97.5,97.5,0,0,1,197,132.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A98.7,98.7,0,0,1,108,106",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var script$9 = Vue.extend({
  name: "PhWifiX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.6,145.6,0,0,1,128,56l8,.2",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A97.8,97.8,0,0,1,128,104c2.7,0,5.4.1,8,.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M202.7,127.9l-68.7,81a7.9,7.9,0,0,1-12.1-.1L19,87.6a8.1,8.1,0,0,1,1.2-11.7A178.9,178.9,0,0,1,147.7,41.1",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M229.4,98.1a8.2,8.2,0,0,1,.6,11.1,7.8,7.8,0,0,1-6,2.8,8.3,8.3,0,0,1-5.7-2.3L200,91.3l-18.3,18.4A8.5,8.5,0,0,1,176,112a8,8,0,0,1-6.1-2.8,8.3,8.3,0,0,1,.6-11.1L188.7,80,170.6,61.9a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L200,68.7l18.3-18.4a8.1,8.1,0,0,1,11.5.2,8.3,8.3,0,0,1-.4,11.4L211.3,80Zm-26.6,18.7a3.9,3.9,0,0,0-5.6,0l-3.9,3.8a24,24,0,0,1-34.3.4,24.2,24.2,0,0,1,0-34l7.1-7-6.7-6.6c-9-9-9.9-23.6-1.5-33.2a11.4,11.4,0,0,1,1.1-1.1,2.9,2.9,0,0,0-1.5-4.8A187.4,187.4,0,0,0,15.4,69.6,15.6,15.6,0,0,0,9.2,80.5a16.6,16.6,0,0,0,3.7,12.3l103,121.3a15.9,15.9,0,0,0,24.2,0l71.5-84.2a4,4,0,0,0-.9-5.9,26.9,26.9,0,0,1-3.7-3Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "56",
      "x2": "176",
      "y2": "104",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "224",
      "y1": "104",
      "x2": "176",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "200",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var script$8 = Vue.extend({
  name: "PhWind",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M102.1,52A24,24,0,1,1,120,92H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M190.1,92A24,24,0,1,1,208,132H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M134.1,212A24,24,0,1,0,152,172H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.5,192.3A24,24,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.5,63.7A24,24,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.5,95.7A24,24,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M184,184a32,32,0,0,1-62,11.1,8,8,0,1,1,15-5.5A16,16,0,1,0,152,168H40a8,8,0,0,1,0-16H152A32.1,32.1,0,0,1,184,184Zm-64-80A32,32,0,1,0,90,60.9a8,8,0,1,0,15,5.5A16,16,0,1,1,120,88H24a8,8,0,0,0,0,16Zm88-32a32.1,32.1,0,0,0-30,20.9,8,8,0,1,0,15,5.5A16,16,0,1,1,208,120H32a8,8,0,0,0,0,16H208a32,32,0,0,0,0-64Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.5,192.3A24,24,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.5,63.7A24,24,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.5,95.7A24,24,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.5,192.3A24,24,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.5,63.7A24,24,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.5,95.7A24,24,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M129.5,192.3A24,24,0,1,0,152,160H40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.5,63.7A24,24,0,1,1,120,96H24",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M185.5,95.7A24,24,0,1,1,208,128H32",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var script$7 = Vue.extend({
  name: "PhWindowsLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "100 108 100 61.1 40 72 40 108 100 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 108 216 40 140 53.8 140 108 216 108",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "100 148 100 194.9 40 184 40 148 100 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 148 216 216 140 202.2 140 148 216 148",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.6 40 184 40 144 104 144 104 195.6",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.4 40 72 40 112 104 112 104 60.4",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.6 40 184 40 144 104 144 104 195.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.4 40 72 40 112 104 112 104 60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M112,144v51.6a8.1,8.1,0,0,1-2.9,6.2,7.8,7.8,0,0,1-5.1,1.8h-1.4l-64-11.6A8,8,0,0,1,32,184V144a8,8,0,0,1,8-8h64A8,8,0,0,1,112,144Zm-2.9-89.8a8,8,0,0,0-6.5-1.7l-64,11.6A8,8,0,0,0,32,72v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V60.4A8.1,8.1,0,0,0,109.1,54.2ZM216,136H136a8,8,0,0,0-8,8v57.5a8,8,0,0,0,6.6,7.8l80,14.6H216a7.4,7.4,0,0,0,5.1-1.9A7.9,7.9,0,0,0,224,216V144A8,8,0,0,0,216,136Zm5.1-102.1a7.7,7.7,0,0,0-6.5-1.8l-80,14.6a8,8,0,0,0-6.6,7.8V112a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V40A7.9,7.9,0,0,0,221.1,33.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.6 40 184 40 144 104 144 104 195.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.4 40 72 40 112 104 112 104 60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.6 40 184 40 144 104 144 104 195.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.4 40 72 40 112 104 112 104 60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 195.6 40 184 40 144 104 144 104 195.6",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "104 60.4 40 72 40 112 104 112 104 60.4",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var script$6 = Vue.extend({
  name: "PhWine",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M200.4,106.7l1.7,5.6a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7l3.6-12h0C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M209.7,110l-26-88.3A8,8,0,0,0,176,16H80a8,8,0,0,0-7.7,5.7L46.3,110a31.5,31.5,0,0,0,1.5,22.2A88.1,88.1,0,0,0,120,183.6V224H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.6a88.1,88.1,0,0,0,72.2-51.4A31.5,31.5,0,0,0,209.7,110ZM131.6,96.8c-26.2-13-47.2-13-61.9-9.5L86,32h84l20.8,70.5C180.1,107,159.8,110.9,131.6,96.8Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "128",
      "y1": "176",
      "x2": "128",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "88",
      "y1": "232",
      "x2": "168",
      "y2": "232",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var script$5 = Vue.extend({
  name: "PhWrench",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M210.9,146.9A72.6,72.6,0,0,1,131,162L79,222.2c-.1.2-.3.3-.4.4a31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2l.4-.4L94,125a72,72,0,0,1,94.1-95.2,7.9,7.9,0,0,1,4.7,5.8,8,8,0,0,1-2.2,7.2L151.7,81.7l3.7,18.9,18.9,3.7,38.9-38.9a8,8,0,0,1,7.2-2.2,7.9,7.9,0,0,1,5.8,4.7A71.7,71.7,0,0,1,210.9,146.9Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('path', {
    attrs: {
      "d": "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var script$4 = Vue.extend({
  name: "PhX",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M139.3,128l66.4-66.3a8.1,8.1,0,0,0-11.4-11.4L128,116.7,61.7,50.3A8.1,8.1,0,0,0,50.3,61.7L116.7,128,50.3,194.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L128,139.3l66.3,66.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "200",
      "y1": "56",
      "x2": "56",
      "y2": "200",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "200",
      "y1": "200",
      "x2": "56",
      "y2": "56",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$3 = Vue.extend({
  name: "PhXCircle",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm37.7,130.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,139.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,128,90.3,101.7a8.1,8.1,0,0,1,11.4-11.4L128,116.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4L139.3,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-miterlimit": "10",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var script$2 = Vue.extend({
  name: "PhXSquare",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM165.7,154.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,139.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,128,90.3,101.7a8.1,8.1,0,0,1,11.4-11.4L128,116.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4L139.3,128Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('line', {
    attrs: {
      "x1": "160",
      "y1": "96",
      "x2": "96",
      "y2": "160",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "160",
      "y1": "160",
      "x2": "96",
      "y2": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "40",
      "y": "40",
      "width": "176",
      "height": "176",
      "rx": "8",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$1 = Vue.extend({
  name: "PhYinYang",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "16"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96,96,96,0,0,1,0,192Z"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M140,80a12,12,0,1,1-12-12A12,12,0,0,1,140,80Zm92,48A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-92,48a12,12,0,1,0-12,12A12,12,0,0,0,140,176Zm32-92a44,44,0,0,0-44-44A88,88,0,0,0,81.1,202.4,51.1,51.1,0,0,1,76,180a52,52,0,0,1,52-52A44,44,0,0,0,172,84Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "10"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('circle', {
    attrs: {
      "cx": "128",
      "cy": "128",
      "r": "96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "176",
      "r": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "128",
      "cy": "80",
      "r": "12"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script = Vue.extend({
  name: "PhYoutubeLogo",
  props: PropValidator,
  inject: ContextGetter,
  computed: {
    displayWeight() {
      const {
        weight,
        contextWeight
      } = this;
      return weight ?? contextWeight;
    },

    displaySize() {
      const {
        size,
        contextSize
      } = this;
      return size ?? contextSize;
    },

    displayColor() {
      const {
        color,
        contextColor
      } = this;
      return color ?? contextColor;
    },

    displayMirrored() {
      const {
        mirrored,
        contextMirrored
      } = this;
      return mirrored ?? contextMirrored ? "scale(-1, 1)" : undefined;
    }

  }
});

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 256",
      "width": _vm.displaySize,
      "height": _vm.displaySize,
      "fill": _vm.displayColor,
      "transform": _vm.displayMirrored
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.displayWeight === 'bold' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "164 128 108 92 108 164 164 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }
  })]) : _vm.displayWeight === 'duotone' ? _c('g', [_c('path', {
    attrs: {
      "d": "M226.6,71.8A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128s3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2S228.9,80.8,226.6,71.8ZM112,160V96l48,32Z",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm.displayWeight === 'fill' ? _c('g', [_c('path', {
    attrs: {
      "d": "M234.3,69.8a23.5,23.5,0,0,0-14.5-16.3C185.6,40.3,131,40.4,128,40.4s-57.6-.1-91.8,13.1A23.5,23.5,0,0,0,21.7,69.8C19.1,79.7,16,97.9,16,128s3.1,48.3,5.7,58.2a23.5,23.5,0,0,0,14.5,16.3c32.8,12.7,84.2,13.1,91.1,13.1h1.4c6.9,0,58.3-.4,91.1-13.1a23.5,23.5,0,0,0,14.5-16.3c2.6-9.9,5.7-28.1,5.7-58.2S236.9,79.7,234.3,69.8Zm-72.1,61.5-48,32a3.6,3.6,0,0,1-2.2.7,4.5,4.5,0,0,1-1.9-.5A3.9,3.9,0,0,1,108,160V96a3.9,3.9,0,0,1,2.1-3.5,4,4,0,0,1,4.1.2l48,32a3.9,3.9,0,0,1,0,6.6Z"
    }
  })]) : _vm.displayWeight === 'light' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "12"
    }
  })]) : _vm.displayWeight === 'thin' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "8"
    }
  })]) : _vm.displayWeight === 'regular' ? _c('g', [_c('polygon', {
    attrs: {
      "points": "160 128 112 96 112 160 160 128",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
      "fill": "none",
      "stroke": _vm.displayColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PhActivity: __vue_component__$gm,
  PhAddressBook: __vue_component__$gl,
  PhAirplane: __vue_component__$gk,
  PhAirplaneInFlight: __vue_component__$gj,
  PhAirplaneLanding: __vue_component__$gi,
  PhAirplaneTakeoff: __vue_component__$gh,
  PhAirplaneTilt: __vue_component__$gg,
  PhAirplay: __vue_component__$gf,
  PhAlarm: __vue_component__$ge,
  PhAlien: __vue_component__$gd,
  PhAlignBottom: __vue_component__$gc,
  PhAlignBottomSimple: __vue_component__$gb,
  PhAlignCenterHorizontal: __vue_component__$ga,
  PhAlignCenterHorizontalSimple: __vue_component__$g9,
  PhAlignCenterVertical: __vue_component__$g8,
  PhAlignCenterVerticalSimple: __vue_component__$g7,
  PhAlignLeft: __vue_component__$g6,
  PhAlignLeftSimple: __vue_component__$g5,
  PhAlignRight: __vue_component__$g4,
  PhAlignRightSimple: __vue_component__$g3,
  PhAlignTop: __vue_component__$g2,
  PhAlignTopSimple: __vue_component__$g1,
  PhAnchor: __vue_component__$g0,
  PhAnchorSimple: __vue_component__$f$,
  PhAndroidLogo: __vue_component__$f_,
  PhAngularLogo: __vue_component__$fZ,
  PhAperture: __vue_component__$fY,
  PhAppStoreLogo: __vue_component__$fX,
  PhAppWindow: __vue_component__$fW,
  PhAppleLogo: __vue_component__$fV,
  PhApplePodcastsLogo: __vue_component__$fU,
  PhArchive: __vue_component__$fT,
  PhArchiveBox: __vue_component__$fS,
  PhArchiveTray: __vue_component__$fR,
  PhArmchair: __vue_component__$fQ,
  PhArrowArcLeft: __vue_component__$fP,
  PhArrowArcRight: __vue_component__$fO,
  PhArrowBendDoubleUpLeft: __vue_component__$fN,
  PhArrowBendDoubleUpRight: __vue_component__$fM,
  PhArrowBendDownLeft: __vue_component__$fL,
  PhArrowBendDownRight: __vue_component__$fK,
  PhArrowBendLeftDown: __vue_component__$fJ,
  PhArrowBendLeftUp: __vue_component__$fI,
  PhArrowBendRightDown: __vue_component__$fH,
  PhArrowBendRightUp: __vue_component__$fG,
  PhArrowBendUpLeft: __vue_component__$fF,
  PhArrowBendUpRight: __vue_component__$fE,
  PhArrowCircleDown: __vue_component__$fD,
  PhArrowCircleDownLeft: __vue_component__$fC,
  PhArrowCircleDownRight: __vue_component__$fB,
  PhArrowCircleLeft: __vue_component__$fA,
  PhArrowCircleRight: __vue_component__$fz,
  PhArrowCircleUp: __vue_component__$fy,
  PhArrowCircleUpLeft: __vue_component__$fx,
  PhArrowCircleUpRight: __vue_component__$fw,
  PhArrowClockwise: __vue_component__$fv,
  PhArrowCounterClockwise: __vue_component__$fu,
  PhArrowDown: __vue_component__$ft,
  PhArrowDownLeft: __vue_component__$fs,
  PhArrowDownRight: __vue_component__$fr,
  PhArrowElbowDownLeft: __vue_component__$fq,
  PhArrowElbowDownRight: __vue_component__$fp,
  PhArrowElbowLeft: __vue_component__$fo,
  PhArrowElbowLeftDown: __vue_component__$fn,
  PhArrowElbowLeftUp: __vue_component__$fm,
  PhArrowElbowRight: __vue_component__$fl,
  PhArrowElbowRightDown: __vue_component__$fk,
  PhArrowElbowRightUp: __vue_component__$fj,
  PhArrowElbowUpLeft: __vue_component__$fi,
  PhArrowElbowUpRight: __vue_component__$fh,
  PhArrowFatDown: __vue_component__$fg,
  PhArrowFatLeft: __vue_component__$ff,
  PhArrowFatLineDown: __vue_component__$fe,
  PhArrowFatLineLeft: __vue_component__$fd,
  PhArrowFatLineRight: __vue_component__$fc,
  PhArrowFatLineUp: __vue_component__$fb,
  PhArrowFatLinesDown: __vue_component__$fa,
  PhArrowFatLinesLeft: __vue_component__$f9,
  PhArrowFatLinesRight: __vue_component__$f8,
  PhArrowFatLinesUp: __vue_component__$f7,
  PhArrowFatRight: __vue_component__$f6,
  PhArrowFatUp: __vue_component__$f5,
  PhArrowLeft: __vue_component__$f4,
  PhArrowLineDown: __vue_component__$f3,
  PhArrowLineDownLeft: __vue_component__$f2,
  PhArrowLineDownRight: __vue_component__$f1,
  PhArrowLineLeft: __vue_component__$f0,
  PhArrowLineRight: __vue_component__$e$,
  PhArrowLineUp: __vue_component__$e_,
  PhArrowLineUpLeft: __vue_component__$eZ,
  PhArrowLineUpRight: __vue_component__$eY,
  PhArrowRight: __vue_component__$eX,
  PhArrowSquareDown: __vue_component__$eW,
  PhArrowSquareDownLeft: __vue_component__$eV,
  PhArrowSquareDownRight: __vue_component__$eU,
  PhArrowSquareIn: __vue_component__$eT,
  PhArrowSquareLeft: __vue_component__$eS,
  PhArrowSquareOut: __vue_component__$eR,
  PhArrowSquareRight: __vue_component__$eQ,
  PhArrowSquareUp: __vue_component__$eP,
  PhArrowSquareUpLeft: __vue_component__$eO,
  PhArrowSquareUpRight: __vue_component__$eN,
  PhArrowUDownLeft: __vue_component__$eM,
  PhArrowUDownRight: __vue_component__$eL,
  PhArrowULeftDown: __vue_component__$eK,
  PhArrowULeftUp: __vue_component__$eJ,
  PhArrowURightDown: __vue_component__$eI,
  PhArrowURightUp: __vue_component__$eH,
  PhArrowUUpLeft: __vue_component__$eG,
  PhArrowUUpRight: __vue_component__$eF,
  PhArrowUp: __vue_component__$eE,
  PhArrowUpLeft: __vue_component__$eD,
  PhArrowUpRight: __vue_component__$eC,
  PhArrowsClockwise: __vue_component__$eB,
  PhArrowsCounterClockwise: __vue_component__$eA,
  PhArrowsDownUp: __vue_component__$ez,
  PhArrowsHorizontal: __vue_component__$ey,
  PhArrowsIn: __vue_component__$ex,
  PhArrowsInCardinal: __vue_component__$ew,
  PhArrowsInLineHorizontal: __vue_component__$ev,
  PhArrowsInLineVertical: __vue_component__$eu,
  PhArrowsInSimple: __vue_component__$et,
  PhArrowsLeftRight: __vue_component__$es,
  PhArrowsOut: __vue_component__$er,
  PhArrowsOutCardinal: __vue_component__$eq,
  PhArrowsOutLineHorizontal: __vue_component__$ep,
  PhArrowsOutLineVertical: __vue_component__$eo,
  PhArrowsOutSimple: __vue_component__$en,
  PhArrowsVertical: __vue_component__$em,
  PhArticle: __vue_component__$el,
  PhArticleMedium: __vue_component__$ek,
  PhArticleNyTimes: __vue_component__$ej,
  PhAsterisk: __vue_component__$ei,
  PhAsteriskSimple: __vue_component__$eh,
  PhAt: __vue_component__$eg,
  PhAtom: __vue_component__$ef,
  PhBaby: __vue_component__$ee,
  PhBackpack: __vue_component__$ed,
  PhBackspace: __vue_component__$ec,
  PhBag: __vue_component__$eb,
  PhBagSimple: __vue_component__$ea,
  PhBalloon: __vue_component__$e9,
  PhBandaids: __vue_component__$e8,
  PhBank: __vue_component__$e7,
  PhBarbell: __vue_component__$e6,
  PhBarcode: __vue_component__$e5,
  PhBarricade: __vue_component__$e4,
  PhBaseball: __vue_component__$e3,
  PhBasketball: __vue_component__$e2,
  PhBathtub: __vue_component__$e1,
  PhBatteryCharging: __vue_component__$e0,
  PhBatteryChargingVertical: __vue_component__$d$,
  PhBatteryEmpty: __vue_component__$d_,
  PhBatteryFull: __vue_component__$dZ,
  PhBatteryHigh: __vue_component__$dY,
  PhBatteryLow: __vue_component__$dX,
  PhBatteryMedium: __vue_component__$dW,
  PhBatteryPlus: __vue_component__$dV,
  PhBatteryWarning: __vue_component__$dU,
  PhBatteryWarningVertical: __vue_component__$dT,
  PhBed: __vue_component__$dS,
  PhBeerBottle: __vue_component__$dR,
  PhBehanceLogo: __vue_component__$dQ,
  PhBell: __vue_component__$dP,
  PhBellRinging: __vue_component__$dO,
  PhBellSimple: __vue_component__$dN,
  PhBellSimpleRinging: __vue_component__$dM,
  PhBellSimpleSlash: __vue_component__$dL,
  PhBellSimpleZ: __vue_component__$dK,
  PhBellSlash: __vue_component__$dJ,
  PhBellZ: __vue_component__$dI,
  PhBezierCurve: __vue_component__$dH,
  PhBicycle: __vue_component__$dG,
  PhBinoculars: __vue_component__$dF,
  PhBird: __vue_component__$dE,
  PhBluetooth: __vue_component__$dD,
  PhBluetoothConnected: __vue_component__$dC,
  PhBluetoothSlash: __vue_component__$dB,
  PhBluetoothX: __vue_component__$dA,
  PhBoat: __vue_component__$dz,
  PhBook: __vue_component__$dy,
  PhBookBookmark: __vue_component__$dx,
  PhBookOpen: __vue_component__$dw,
  PhBookmark: __vue_component__$dv,
  PhBookmarkSimple: __vue_component__$du,
  PhBookmarks: __vue_component__$dt,
  PhBookmarksSimple: __vue_component__$ds,
  PhBooks: __vue_component__$dr,
  PhBoundingBox: __vue_component__$dq,
  PhBracketsAngle: __vue_component__$dp,
  PhBracketsCurly: __vue_component__$do,
  PhBracketsRound: __vue_component__$dn,
  PhBracketsSquare: __vue_component__$dm,
  PhBrain: __vue_component__$dl,
  PhBrandy: __vue_component__$dk,
  PhBriefcase: __vue_component__$dj,
  PhBriefcaseMetal: __vue_component__$di,
  PhBroadcast: __vue_component__$dh,
  PhBrowser: __vue_component__$dg,
  PhBrowsers: __vue_component__$df,
  PhBug: __vue_component__$de,
  PhBugBeetle: __vue_component__$dd,
  PhBugDroid: __vue_component__$dc,
  PhBuildings: __vue_component__$db,
  PhBus: __vue_component__$da,
  PhButterfly: __vue_component__$d9,
  PhCactus: __vue_component__$d8,
  PhCake: __vue_component__$d7,
  PhCalculator: __vue_component__$d6,
  PhCalendar: __vue_component__$d5,
  PhCalendarBlank: __vue_component__$d4,
  PhCalendarCheck: __vue_component__$d3,
  PhCalendarPlus: __vue_component__$d2,
  PhCalendarX: __vue_component__$d1,
  PhCamera: __vue_component__$d0,
  PhCameraRotate: __vue_component__$c$,
  PhCameraSlash: __vue_component__$c_,
  PhCampfire: __vue_component__$cZ,
  PhCar: __vue_component__$cY,
  PhCarSimple: __vue_component__$cX,
  PhCardholder: __vue_component__$cW,
  PhCards: __vue_component__$cV,
  PhCaretCircleDoubleDown: __vue_component__$cU,
  PhCaretCircleDoubleLeft: __vue_component__$cT,
  PhCaretCircleDoubleRight: __vue_component__$cS,
  PhCaretCircleDoubleUp: __vue_component__$cR,
  PhCaretCircleDown: __vue_component__$cQ,
  PhCaretCircleLeft: __vue_component__$cP,
  PhCaretCircleRight: __vue_component__$cO,
  PhCaretCircleUp: __vue_component__$cN,
  PhCaretDoubleDown: __vue_component__$cM,
  PhCaretDoubleLeft: __vue_component__$cL,
  PhCaretDoubleRight: __vue_component__$cK,
  PhCaretDoubleUp: __vue_component__$cJ,
  PhCaretDown: __vue_component__$cI,
  PhCaretLeft: __vue_component__$cH,
  PhCaretRight: __vue_component__$cG,
  PhCaretUp: __vue_component__$cF,
  PhCat: __vue_component__$cE,
  PhCellSignalFull: __vue_component__$cD,
  PhCellSignalHigh: __vue_component__$cC,
  PhCellSignalLow: __vue_component__$cB,
  PhCellSignalMedium: __vue_component__$cA,
  PhCellSignalNone: __vue_component__$cz,
  PhCellSignalSlash: __vue_component__$cy,
  PhCellSignalX: __vue_component__$cx,
  PhChalkboard: __vue_component__$cw,
  PhChalkboardSimple: __vue_component__$cv,
  PhChalkboardTeacher: __vue_component__$cu,
  PhChartBar: __vue_component__$ct,
  PhChartBarHorizontal: __vue_component__$cs,
  PhChartLine: __vue_component__$cr,
  PhChartLineUp: __vue_component__$cq,
  PhChartPie: __vue_component__$cp,
  PhChartPieSlice: __vue_component__$co,
  PhChat: __vue_component__$cn,
  PhChatCentered: __vue_component__$cm,
  PhChatCenteredDots: __vue_component__$cl,
  PhChatCenteredText: __vue_component__$ck,
  PhChatCircle: __vue_component__$cj,
  PhChatCircleDots: __vue_component__$ci,
  PhChatCircleText: __vue_component__$ch,
  PhChatDots: __vue_component__$cg,
  PhChatTeardrop: __vue_component__$cf,
  PhChatTeardropDots: __vue_component__$ce,
  PhChatTeardropText: __vue_component__$cd,
  PhChatText: __vue_component__$cc,
  PhChats: __vue_component__$cb,
  PhChatsCircle: __vue_component__$ca,
  PhChatsTeardrop: __vue_component__$c9,
  PhCheck: __vue_component__$c8,
  PhCheckCircle: __vue_component__$c7,
  PhCheckSquare: __vue_component__$c6,
  PhCheckSquareOffset: __vue_component__$c5,
  PhChecks: __vue_component__$c4,
  PhCircle: __vue_component__$c3,
  PhCircleDashed: __vue_component__$c2,
  PhCircleHalf: __vue_component__$c1,
  PhCircleHalfTilt: __vue_component__$c0,
  PhCircleNotch: __vue_component__$b$,
  PhCircleWavy: __vue_component__$b_,
  PhCircleWavyCheck: __vue_component__$bZ,
  PhCircleWavyQuestion: __vue_component__$bY,
  PhCircleWavyWarning: __vue_component__$bX,
  PhCirclesFour: __vue_component__$bW,
  PhCirclesThree: __vue_component__$bV,
  PhCirclesThreePlus: __vue_component__$bU,
  PhClipboard: __vue_component__$bT,
  PhClipboardText: __vue_component__$bS,
  PhClock: __vue_component__$bR,
  PhClockAfternoon: __vue_component__$bQ,
  PhClockClockwise: __vue_component__$bP,
  PhClockCounterClockwise: __vue_component__$bO,
  PhClosedCaptioning: __vue_component__$bN,
  PhCloud: __vue_component__$bM,
  PhCloudArrowDown: __vue_component__$bL,
  PhCloudArrowUp: __vue_component__$bK,
  PhCloudCheck: __vue_component__$bJ,
  PhCloudFog: __vue_component__$bI,
  PhCloudLightning: __vue_component__$bH,
  PhCloudMoon: __vue_component__$bG,
  PhCloudRain: __vue_component__$bF,
  PhCloudSlash: __vue_component__$bE,
  PhCloudSnow: __vue_component__$bD,
  PhCloudSun: __vue_component__$bC,
  PhClub: __vue_component__$bB,
  PhCoatHanger: __vue_component__$bA,
  PhCode: __vue_component__$bz,
  PhCodeSimple: __vue_component__$by,
  PhCodepenLogo: __vue_component__$bx,
  PhCodesandboxLogo: __vue_component__$bw,
  PhCoffee: __vue_component__$bv,
  PhCoin: __vue_component__$bu,
  PhCoinVertical: __vue_component__$bt,
  PhCoins: __vue_component__$bs,
  PhColumns: __vue_component__$br,
  PhCommand: __vue_component__$bq,
  PhCompass: __vue_component__$bp,
  PhComputerTower: __vue_component__$bo,
  PhConfetti: __vue_component__$bn,
  PhCookie: __vue_component__$bm,
  PhCookingPot: __vue_component__$bl,
  PhCopy: __vue_component__$bk,
  PhCopySimple: __vue_component__$bj,
  PhCopyleft: __vue_component__$bi,
  PhCopyright: __vue_component__$bh,
  PhCornersIn: __vue_component__$bg,
  PhCornersOut: __vue_component__$bf,
  PhCpu: __vue_component__$be,
  PhCreditCard: __vue_component__$bd,
  PhCrop: __vue_component__$bc,
  PhCrosshair: __vue_component__$bb,
  PhCrosshairSimple: __vue_component__$ba,
  PhCrown: __vue_component__$b9,
  PhCrownSimple: __vue_component__$b8,
  PhCube: __vue_component__$b7,
  PhCurrencyBtc: __vue_component__$b6,
  PhCurrencyCircleDollar: __vue_component__$b5,
  PhCurrencyCny: __vue_component__$b4,
  PhCurrencyDollar: __vue_component__$b3,
  PhCurrencyDollarSimple: __vue_component__$b2,
  PhCurrencyEth: __vue_component__$b1,
  PhCurrencyEur: __vue_component__$b0,
  PhCurrencyGbp: __vue_component__$a$,
  PhCurrencyInr: __vue_component__$a_,
  PhCurrencyJpy: __vue_component__$aZ,
  PhCurrencyKrw: __vue_component__$aY,
  PhCurrencyKzt: __vue_component__$aX,
  PhCurrencyNgn: __vue_component__$aW,
  PhCurrencyRub: __vue_component__$aV,
  PhCursor: __vue_component__$aU,
  PhCursorText: __vue_component__$aT,
  PhCylinder: __vue_component__$aS,
  PhDatabase: __vue_component__$aR,
  PhDesktop: __vue_component__$aQ,
  PhDesktopTower: __vue_component__$aP,
  PhDetective: __vue_component__$aO,
  PhDeviceMobile: __vue_component__$aN,
  PhDeviceMobileCamera: __vue_component__$aM,
  PhDeviceMobileSpeaker: __vue_component__$aL,
  PhDeviceTablet: __vue_component__$aK,
  PhDeviceTabletCamera: __vue_component__$aJ,
  PhDeviceTabletSpeaker: __vue_component__$aI,
  PhDiamond: __vue_component__$aH,
  PhDiamondsFour: __vue_component__$aG,
  PhDiceFive: __vue_component__$aF,
  PhDiceFour: __vue_component__$aE,
  PhDiceOne: __vue_component__$aD,
  PhDiceSix: __vue_component__$aC,
  PhDiceThree: __vue_component__$aB,
  PhDiceTwo: __vue_component__$aA,
  PhDisc: __vue_component__$az,
  PhDiscordLogo: __vue_component__$ay,
  PhDivide: __vue_component__$ax,
  PhDog: __vue_component__$aw,
  PhDoor: __vue_component__$av,
  PhDotsNine: __vue_component__$au,
  PhDotsSix: __vue_component__$at,
  PhDotsSixVertical: __vue_component__$as,
  PhDotsThree: __vue_component__$ar,
  PhDotsThreeCircle: __vue_component__$aq,
  PhDotsThreeCircleVertical: __vue_component__$ap,
  PhDotsThreeOutline: __vue_component__$ao,
  PhDotsThreeOutlineVertical: __vue_component__$an,
  PhDotsThreeVertical: __vue_component__$am,
  PhDownload: __vue_component__$al,
  PhDownloadSimple: __vue_component__$ak,
  PhDribbbleLogo: __vue_component__$aj,
  PhDrop: __vue_component__$ai,
  PhDropHalf: __vue_component__$ah,
  PhDropHalfBottom: __vue_component__$ag,
  PhEar: __vue_component__$af,
  PhEarSlash: __vue_component__$ae,
  PhEgg: __vue_component__$ad,
  PhEggCrack: __vue_component__$ac,
  PhEject: __vue_component__$ab,
  PhEjectSimple: __vue_component__$aa,
  PhEnvelope: __vue_component__$a9,
  PhEnvelopeOpen: __vue_component__$a8,
  PhEnvelopeSimple: __vue_component__$a7,
  PhEnvelopeSimpleOpen: __vue_component__$a6,
  PhEqualizer: __vue_component__$a5,
  PhEquals: __vue_component__$a4,
  PhEraser: __vue_component__$a3,
  PhExam: __vue_component__$a2,
  PhExport: __vue_component__$a1,
  PhEye: __vue_component__$a0,
  PhEyeClosed: __vue_component__$9$,
  PhEyeSlash: __vue_component__$9_,
  PhEyedropper: __vue_component__$9Z,
  PhEyedropperSample: __vue_component__$9Y,
  PhEyeglasses: __vue_component__$9X,
  PhFaceMask: __vue_component__$9W,
  PhFacebookLogo: __vue_component__$9V,
  PhFactory: __vue_component__$9U,
  PhFaders: __vue_component__$9T,
  PhFadersHorizontal: __vue_component__$9S,
  PhFastForward: __vue_component__$9R,
  PhFastForwardCircle: __vue_component__$9Q,
  PhFigmaLogo: __vue_component__$9P,
  PhFile: __vue_component__$9O,
  PhFileArrowDown: __vue_component__$9N,
  PhFileArrowUp: __vue_component__$9M,
  PhFileAudio: __vue_component__$9L,
  PhFileCloud: __vue_component__$9K,
  PhFileCode: __vue_component__$9J,
  PhFileCss: __vue_component__$9I,
  PhFileCsv: __vue_component__$9H,
  PhFileDoc: __vue_component__$9G,
  PhFileDotted: __vue_component__$9F,
  PhFileHtml: __vue_component__$9E,
  PhFileImage: __vue_component__$9D,
  PhFileJpg: __vue_component__$9C,
  PhFileJs: __vue_component__$9B,
  PhFileJsx: __vue_component__$9A,
  PhFileLock: __vue_component__$9z,
  PhFileMinus: __vue_component__$9y,
  PhFilePdf: __vue_component__$9x,
  PhFilePlus: __vue_component__$9w,
  PhFilePng: __vue_component__$9v,
  PhFilePpt: __vue_component__$9u,
  PhFileRs: __vue_component__$9t,
  PhFileSearch: __vue_component__$9s,
  PhFileText: __vue_component__$9r,
  PhFileTs: __vue_component__$9q,
  PhFileTsx: __vue_component__$9p,
  PhFileVideo: __vue_component__$9o,
  PhFileVue: __vue_component__$9n,
  PhFileX: __vue_component__$9m,
  PhFileXls: __vue_component__$9l,
  PhFileZip: __vue_component__$9k,
  PhFiles: __vue_component__$9j,
  PhFilmScript: __vue_component__$9i,
  PhFilmSlate: __vue_component__$9h,
  PhFilmStrip: __vue_component__$9g,
  PhFingerprint: __vue_component__$9f,
  PhFingerprintSimple: __vue_component__$9e,
  PhFinnTheHuman: __vue_component__$9d,
  PhFire: __vue_component__$9c,
  PhFireSimple: __vue_component__$9b,
  PhFirstAid: __vue_component__$9a,
  PhFirstAidKit: __vue_component__$99,
  PhFish: __vue_component__$98,
  PhFishSimple: __vue_component__$97,
  PhFlag: __vue_component__$96,
  PhFlagBanner: __vue_component__$95,
  PhFlagCheckered: __vue_component__$94,
  PhFlame: __vue_component__$93,
  PhFlashlight: __vue_component__$92,
  PhFlask: __vue_component__$91,
  PhFloppyDisk: __vue_component__$90,
  PhFloppyDiskBack: __vue_component__$8$,
  PhFlowArrow: __vue_component__$8_,
  PhFlower: __vue_component__$8Z,
  PhFlowerLotus: __vue_component__$8Y,
  PhFlyingSaucer: __vue_component__$8X,
  PhFolder: __vue_component__$8W,
  PhFolderDotted: __vue_component__$8V,
  PhFolderLock: __vue_component__$8U,
  PhFolderMinus: __vue_component__$8T,
  PhFolderNotch: __vue_component__$8S,
  PhFolderNotchMinus: __vue_component__$8R,
  PhFolderNotchOpen: __vue_component__$8Q,
  PhFolderNotchPlus: __vue_component__$8P,
  PhFolderOpen: __vue_component__$8O,
  PhFolderPlus: __vue_component__$8N,
  PhFolderSimple: __vue_component__$8M,
  PhFolderSimpleDotted: __vue_component__$8L,
  PhFolderSimpleLock: __vue_component__$8K,
  PhFolderSimpleMinus: __vue_component__$8J,
  PhFolderSimplePlus: __vue_component__$8I,
  PhFolderSimpleStar: __vue_component__$8H,
  PhFolderSimpleUser: __vue_component__$8G,
  PhFolderStar: __vue_component__$8F,
  PhFolderUser: __vue_component__$8E,
  PhFolders: __vue_component__$8D,
  PhFootball: __vue_component__$8C,
  PhForkKnife: __vue_component__$8B,
  PhFrameCorners: __vue_component__$8A,
  PhFramerLogo: __vue_component__$8z,
  PhFunction: __vue_component__$8y,
  PhFunnel: __vue_component__$8x,
  PhFunnelSimple: __vue_component__$8w,
  PhGameController: __vue_component__$8v,
  PhGasPump: __vue_component__$8u,
  PhGauge: __vue_component__$8t,
  PhGear: __vue_component__$8s,
  PhGearSix: __vue_component__$8r,
  PhGenderFemale: __vue_component__$8q,
  PhGenderIntersex: __vue_component__$8p,
  PhGenderMale: __vue_component__$8o,
  PhGenderNeuter: __vue_component__$8n,
  PhGenderNonbinary: __vue_component__$8m,
  PhGenderTransgender: __vue_component__$8l,
  PhGhost: __vue_component__$8k,
  PhGif: __vue_component__$8j,
  PhGift: __vue_component__$8i,
  PhGitBranch: __vue_component__$8h,
  PhGitCommit: __vue_component__$8g,
  PhGitDiff: __vue_component__$8f,
  PhGitFork: __vue_component__$8e,
  PhGitMerge: __vue_component__$8d,
  PhGitPullRequest: __vue_component__$8c,
  PhGithubLogo: __vue_component__$8b,
  PhGitlabLogo: __vue_component__$8a,
  PhGitlabLogoSimple: __vue_component__$89,
  PhGlobe: __vue_component__$88,
  PhGlobeHemisphereEast: __vue_component__$87,
  PhGlobeHemisphereWest: __vue_component__$86,
  PhGlobeSimple: __vue_component__$85,
  PhGlobeStand: __vue_component__$84,
  PhGoogleChromeLogo: __vue_component__$83,
  PhGoogleLogo: __vue_component__$82,
  PhGooglePhotosLogo: __vue_component__$81,
  PhGooglePlayLogo: __vue_component__$80,
  PhGooglePodcastsLogo: __vue_component__$7$,
  PhGradient: __vue_component__$7_,
  PhGraduationCap: __vue_component__$7Z,
  PhGraph: __vue_component__$7Y,
  PhGridFour: __vue_component__$7X,
  PhHamburger: __vue_component__$7W,
  PhHand: __vue_component__$7V,
  PhHandEye: __vue_component__$7U,
  PhHandFist: __vue_component__$7T,
  PhHandGrabbing: __vue_component__$7S,
  PhHandPalm: __vue_component__$7R,
  PhHandPointing: __vue_component__$7Q,
  PhHandSoap: __vue_component__$7P,
  PhHandWaving: __vue_component__$7O,
  PhHandbag: __vue_component__$7N,
  PhHandbagSimple: __vue_component__$7M,
  PhHandsClapping: __vue_component__$7L,
  PhHandshake: __vue_component__$7K,
  PhHardDrive: __vue_component__$7J,
  PhHardDrives: __vue_component__$7I,
  PhHash: __vue_component__$7H,
  PhHashStraight: __vue_component__$7G,
  PhHeadlights: __vue_component__$7F,
  PhHeadphones: __vue_component__$7E,
  PhHeadset: __vue_component__$7D,
  PhHeart: __vue_component__$7C,
  PhHeartBreak: __vue_component__$7B,
  PhHeartStraight: __vue_component__$7A,
  PhHeartStraightBreak: __vue_component__$7z,
  PhHeartbeat: __vue_component__$7y,
  PhHexagon: __vue_component__$7x,
  PhHighlighterCircle: __vue_component__$7w,
  PhHorse: __vue_component__$7v,
  PhHourglass: __vue_component__$7u,
  PhHourglassHigh: __vue_component__$7t,
  PhHourglassLow: __vue_component__$7s,
  PhHourglassMedium: __vue_component__$7r,
  PhHourglassSimple: __vue_component__$7q,
  PhHourglassSimpleHigh: __vue_component__$7p,
  PhHourglassSimpleLow: __vue_component__$7o,
  PhHourglassSimpleMedium: __vue_component__$7n,
  PhHouse: __vue_component__$7m,
  PhHouseLine: __vue_component__$7l,
  PhHouseSimple: __vue_component__$7k,
  PhIdentificationBadge: __vue_component__$7j,
  PhIdentificationCard: __vue_component__$7i,
  PhImage: __vue_component__$7h,
  PhImageSquare: __vue_component__$7g,
  PhInfinity: __vue_component__$7f,
  PhInfo: __vue_component__$7e,
  PhInstagramLogo: __vue_component__$7d,
  PhIntersect: __vue_component__$7c,
  PhJeep: __vue_component__$7b,
  PhKanban: __vue_component__$7a,
  PhKey: __vue_component__$79,
  PhKeyReturn: __vue_component__$78,
  PhKeyboard: __vue_component__$77,
  PhKeyhole: __vue_component__$76,
  PhKnife: __vue_component__$75,
  PhLadder: __vue_component__$74,
  PhLadderSimple: __vue_component__$73,
  PhLamp: __vue_component__$72,
  PhLaptop: __vue_component__$71,
  PhLayout: __vue_component__$70,
  PhLeaf: __vue_component__$6$,
  PhLifebuoy: __vue_component__$6_,
  PhLightbulb: __vue_component__$6Z,
  PhLightbulbFilament: __vue_component__$6Y,
  PhLightning: __vue_component__$6X,
  PhLightningSlash: __vue_component__$6W,
  PhLineSegment: __vue_component__$6V,
  PhLineSegments: __vue_component__$6U,
  PhLink: __vue_component__$6T,
  PhLinkBreak: __vue_component__$6S,
  PhLinkSimple: __vue_component__$6R,
  PhLinkSimpleBreak: __vue_component__$6Q,
  PhLinkSimpleHorizontal: __vue_component__$6P,
  PhLinkSimpleHorizontalBreak: __vue_component__$6O,
  PhLinkedinLogo: __vue_component__$6N,
  PhLinuxLogo: __vue_component__$6M,
  PhList: __vue_component__$6L,
  PhListBullets: __vue_component__$6K,
  PhListChecks: __vue_component__$6J,
  PhListDashes: __vue_component__$6I,
  PhListNumbers: __vue_component__$6H,
  PhListPlus: __vue_component__$6G,
  PhLock: __vue_component__$6F,
  PhLockKey: __vue_component__$6E,
  PhLockKeyOpen: __vue_component__$6D,
  PhLockLaminated: __vue_component__$6C,
  PhLockLaminatedOpen: __vue_component__$6B,
  PhLockOpen: __vue_component__$6A,
  PhLockSimple: __vue_component__$6z,
  PhLockSimpleOpen: __vue_component__$6y,
  PhMagicWand: __vue_component__$6x,
  PhMagnet: __vue_component__$6w,
  PhMagnetStraight: __vue_component__$6v,
  PhMagnifyingGlass: __vue_component__$6u,
  PhMagnifyingGlassMinus: __vue_component__$6t,
  PhMagnifyingGlassPlus: __vue_component__$6s,
  PhMapPin: __vue_component__$6r,
  PhMapPinLine: __vue_component__$6q,
  PhMapTrifold: __vue_component__$6p,
  PhMarkerCircle: __vue_component__$6o,
  PhMartini: __vue_component__$6n,
  PhMaskHappy: __vue_component__$6m,
  PhMaskSad: __vue_component__$6l,
  PhMathOperations: __vue_component__$6k,
  PhMedal: __vue_component__$6j,
  PhMediumLogo: __vue_component__$6i,
  PhMegaphone: __vue_component__$6h,
  PhMegaphoneSimple: __vue_component__$6g,
  PhMessengerLogo: __vue_component__$6f,
  PhMicrophone: __vue_component__$6e,
  PhMicrophoneSlash: __vue_component__$6d,
  PhMicrophoneStage: __vue_component__$6c,
  PhMicrosoftExcelLogo: __vue_component__$6b,
  PhMicrosoftPowerpointLogo: __vue_component__$6a,
  PhMicrosoftTeamsLogo: __vue_component__$69,
  PhMicrosoftWordLogo: __vue_component__$68,
  PhMinus: __vue_component__$67,
  PhMinusCircle: __vue_component__$66,
  PhMoney: __vue_component__$65,
  PhMonitor: __vue_component__$64,
  PhMonitorPlay: __vue_component__$63,
  PhMoon: __vue_component__$62,
  PhMoonStars: __vue_component__$61,
  PhMountains: __vue_component__$60,
  PhMouse: __vue_component__$5$,
  PhMouseSimple: __vue_component__$5_,
  PhMusicNote: __vue_component__$5Z,
  PhMusicNoteSimple: __vue_component__$5Y,
  PhMusicNotes: __vue_component__$5X,
  PhMusicNotesPlus: __vue_component__$5W,
  PhMusicNotesSimple: __vue_component__$5V,
  PhNavigationArrow: __vue_component__$5U,
  PhNeedle: __vue_component__$5T,
  PhNewspaper: __vue_component__$5S,
  PhNewspaperClipping: __vue_component__$5R,
  PhNote: __vue_component__$5Q,
  PhNoteBlank: __vue_component__$5P,
  PhNotePencil: __vue_component__$5O,
  PhNotebook: __vue_component__$5N,
  PhNotepad: __vue_component__$5M,
  PhNotification: __vue_component__$5L,
  PhNumberCircleEight: __vue_component__$5K,
  PhNumberCircleFive: __vue_component__$5J,
  PhNumberCircleFour: __vue_component__$5I,
  PhNumberCircleNine: __vue_component__$5H,
  PhNumberCircleOne: __vue_component__$5G,
  PhNumberCircleSeven: __vue_component__$5F,
  PhNumberCircleSix: __vue_component__$5E,
  PhNumberCircleThree: __vue_component__$5D,
  PhNumberCircleTwo: __vue_component__$5C,
  PhNumberCircleZero: __vue_component__$5B,
  PhNumberEight: __vue_component__$5A,
  PhNumberFive: __vue_component__$5z,
  PhNumberFour: __vue_component__$5y,
  PhNumberNine: __vue_component__$5x,
  PhNumberOne: __vue_component__$5w,
  PhNumberSeven: __vue_component__$5v,
  PhNumberSix: __vue_component__$5u,
  PhNumberSquareEight: __vue_component__$5t,
  PhNumberSquareFive: __vue_component__$5s,
  PhNumberSquareFour: __vue_component__$5r,
  PhNumberSquareNine: __vue_component__$5q,
  PhNumberSquareOne: __vue_component__$5p,
  PhNumberSquareSeven: __vue_component__$5o,
  PhNumberSquareSix: __vue_component__$5n,
  PhNumberSquareThree: __vue_component__$5m,
  PhNumberSquareTwo: __vue_component__$5l,
  PhNumberSquareZero: __vue_component__$5k,
  PhNumberThree: __vue_component__$5j,
  PhNumberTwo: __vue_component__$5i,
  PhNumberZero: __vue_component__$5h,
  PhNut: __vue_component__$5g,
  PhNyTimesLogo: __vue_component__$5f,
  PhOctagon: __vue_component__$5e,
  PhOption: __vue_component__$5d,
  PhPackage: __vue_component__$5c,
  PhPaintBrush: __vue_component__$5b,
  PhPaintBrushBroad: __vue_component__$5a,
  PhPaintBrushHousehold: __vue_component__$59,
  PhPaintBucket: __vue_component__$58,
  PhPaintRoller: __vue_component__$57,
  PhPalette: __vue_component__$56,
  PhPaperPlane: __vue_component__$55,
  PhPaperPlaneRight: __vue_component__$54,
  PhPaperPlaneTilt: __vue_component__$53,
  PhPaperclip: __vue_component__$52,
  PhPaperclipHorizontal: __vue_component__$51,
  PhParachute: __vue_component__$50,
  PhPassword: __vue_component__$4$,
  PhPath: __vue_component__$4_,
  PhPause: __vue_component__$4Z,
  PhPauseCircle: __vue_component__$4Y,
  PhPawPrint: __vue_component__$4X,
  PhPeace: __vue_component__$4W,
  PhPen: __vue_component__$4V,
  PhPenNib: __vue_component__$4U,
  PhPenNibStraight: __vue_component__$4T,
  PhPencil: __vue_component__$4S,
  PhPencilCircle: __vue_component__$4R,
  PhPencilLine: __vue_component__$4Q,
  PhPencilSimple: __vue_component__$4P,
  PhPencilSimpleLine: __vue_component__$4O,
  PhPercent: __vue_component__$4N,
  PhPerson: __vue_component__$4M,
  PhPersonSimple: __vue_component__$4L,
  PhPersonSimpleRun: __vue_component__$4K,
  PhPersonSimpleWalk: __vue_component__$4J,
  PhPerspective: __vue_component__$4I,
  PhPhone: __vue_component__$4H,
  PhPhoneCall: __vue_component__$4G,
  PhPhoneDisconnect: __vue_component__$4F,
  PhPhoneIncoming: __vue_component__$4E,
  PhPhoneOutgoing: __vue_component__$4D,
  PhPhoneSlash: __vue_component__$4C,
  PhPhoneX: __vue_component__$4B,
  PhPhosphorLogo: __vue_component__$4A,
  PhPianoKeys: __vue_component__$4z,
  PhPictureInPicture: __vue_component__$4y,
  PhPill: __vue_component__$4x,
  PhPinterestLogo: __vue_component__$4w,
  PhPinwheel: __vue_component__$4v,
  PhPizza: __vue_component__$4u,
  PhPlaceholder: __vue_component__$4t,
  PhPlanet: __vue_component__$4s,
  PhPlay: __vue_component__$4r,
  PhPlayCircle: __vue_component__$4q,
  PhPlaylist: __vue_component__$4p,
  PhPlug: __vue_component__$4o,
  PhPlugs: __vue_component__$4n,
  PhPlugsConnected: __vue_component__$4m,
  PhPlus: __vue_component__$4l,
  PhPlusCircle: __vue_component__$4k,
  PhPlusMinus: __vue_component__$4j,
  PhPokerChip: __vue_component__$4i,
  PhPoliceCar: __vue_component__$4h,
  PhPolygon: __vue_component__$4g,
  PhPopcorn: __vue_component__$4f,
  PhPower: __vue_component__$4e,
  PhPrescription: __vue_component__$4d,
  PhPresentation: __vue_component__$4c,
  PhPresentationChart: __vue_component__$4b,
  PhPrinter: __vue_component__$4a,
  PhProhibit: __vue_component__$49,
  PhProhibitInset: __vue_component__$48,
  PhProjectorScreen: __vue_component__$47,
  PhProjectorScreenChart: __vue_component__$46,
  PhPushPin: __vue_component__$45,
  PhPushPinSimple: __vue_component__$44,
  PhPushPinSimpleSlash: __vue_component__$43,
  PhPushPinSlash: __vue_component__$42,
  PhPuzzlePiece: __vue_component__$41,
  PhQrCode: __vue_component__$40,
  PhQuestion: __vue_component__$3$,
  PhQueue: __vue_component__$3_,
  PhQuotes: __vue_component__$3Z,
  PhRadical: __vue_component__$3Y,
  PhRadio: __vue_component__$3X,
  PhRadioButton: __vue_component__$3W,
  PhRainbow: __vue_component__$3V,
  PhRainbowCloud: __vue_component__$3U,
  PhReceipt: __vue_component__$3T,
  PhRecord: __vue_component__$3S,
  PhRectangle: __vue_component__$3R,
  PhRecycle: __vue_component__$3Q,
  PhRedditLogo: __vue_component__$3P,
  PhRepeat: __vue_component__$3O,
  PhRepeatOnce: __vue_component__$3N,
  PhRewind: __vue_component__$3M,
  PhRewindCircle: __vue_component__$3L,
  PhRobot: __vue_component__$3K,
  PhRocket: __vue_component__$3J,
  PhRocketLaunch: __vue_component__$3I,
  PhRows: __vue_component__$3H,
  PhRss: __vue_component__$3G,
  PhRssSimple: __vue_component__$3F,
  PhRug: __vue_component__$3E,
  PhRuler: __vue_component__$3D,
  PhScales: __vue_component__$3C,
  PhScan: __vue_component__$3B,
  PhScissors: __vue_component__$3A,
  PhScreencast: __vue_component__$3z,
  PhScribbleLoop: __vue_component__$3y,
  PhScroll: __vue_component__$3x,
  PhSelection: __vue_component__$3w,
  PhSelectionAll: __vue_component__$3v,
  PhSelectionBackground: __vue_component__$3u,
  PhSelectionForeground: __vue_component__$3t,
  PhSelectionInverse: __vue_component__$3s,
  PhSelectionPlus: __vue_component__$3r,
  PhSelectionSlash: __vue_component__$3q,
  PhShare: __vue_component__$3p,
  PhShareNetwork: __vue_component__$3o,
  PhShield: __vue_component__$3n,
  PhShieldCheck: __vue_component__$3m,
  PhShieldCheckered: __vue_component__$3l,
  PhShieldChevron: __vue_component__$3k,
  PhShieldPlus: __vue_component__$3j,
  PhShieldSlash: __vue_component__$3i,
  PhShieldStar: __vue_component__$3h,
  PhShieldWarning: __vue_component__$3g,
  PhShoppingBag: __vue_component__$3f,
  PhShoppingBagOpen: __vue_component__$3e,
  PhShoppingCart: __vue_component__$3d,
  PhShoppingCartSimple: __vue_component__$3c,
  PhShower: __vue_component__$3b,
  PhShuffle: __vue_component__$3a,
  PhShuffleAngular: __vue_component__$39,
  PhShuffleSimple: __vue_component__$38,
  PhSidebar: __vue_component__$37,
  PhSidebarSimple: __vue_component__$36,
  PhSignIn: __vue_component__$35,
  PhSignOut: __vue_component__$34,
  PhSignpost: __vue_component__$33,
  PhSimCard: __vue_component__$32,
  PhSketchLogo: __vue_component__$31,
  PhSkipBack: __vue_component__$30,
  PhSkipBackCircle: __vue_component__$2$,
  PhSkipForward: __vue_component__$2_,
  PhSkipForwardCircle: __vue_component__$2Z,
  PhSkull: __vue_component__$2Y,
  PhSlackLogo: __vue_component__$2X,
  PhSliders: __vue_component__$2W,
  PhSlidersHorizontal: __vue_component__$2V,
  PhSmiley: __vue_component__$2U,
  PhSmileyBlank: __vue_component__$2T,
  PhSmileyMeh: __vue_component__$2S,
  PhSmileyNervous: __vue_component__$2R,
  PhSmileySad: __vue_component__$2Q,
  PhSmileySticker: __vue_component__$2P,
  PhSmileyWink: __vue_component__$2O,
  PhSmileyXEyes: __vue_component__$2N,
  PhSnapchatLogo: __vue_component__$2M,
  PhSnowflake: __vue_component__$2L,
  PhSoccerBall: __vue_component__$2K,
  PhSortAscending: __vue_component__$2J,
  PhSortDescending: __vue_component__$2I,
  PhSpade: __vue_component__$2H,
  PhSparkle: __vue_component__$2G,
  PhSpeakerHigh: __vue_component__$2F,
  PhSpeakerLow: __vue_component__$2E,
  PhSpeakerNone: __vue_component__$2D,
  PhSpeakerSimpleHigh: __vue_component__$2C,
  PhSpeakerSimpleLow: __vue_component__$2B,
  PhSpeakerSimpleNone: __vue_component__$2A,
  PhSpeakerSimpleSlash: __vue_component__$2z,
  PhSpeakerSimpleX: __vue_component__$2y,
  PhSpeakerSlash: __vue_component__$2x,
  PhSpeakerX: __vue_component__$2w,
  PhSpinner: __vue_component__$2v,
  PhSpinnerGap: __vue_component__$2u,
  PhSpiral: __vue_component__$2t,
  PhSpotifyLogo: __vue_component__$2s,
  PhSquare: __vue_component__$2r,
  PhSquareHalf: __vue_component__$2q,
  PhSquareHalfBottom: __vue_component__$2p,
  PhSquareLogo: __vue_component__$2o,
  PhSquaresFour: __vue_component__$2n,
  PhStack: __vue_component__$2m,
  PhStackOverflowLogo: __vue_component__$2l,
  PhStackSimple: __vue_component__$2k,
  PhStamp: __vue_component__$2j,
  PhStar: __vue_component__$2i,
  PhStarFour: __vue_component__$2h,
  PhStarHalf: __vue_component__$2g,
  PhSticker: __vue_component__$2f,
  PhStop: __vue_component__$2e,
  PhStopCircle: __vue_component__$2d,
  PhStorefront: __vue_component__$2c,
  PhStrategy: __vue_component__$2b,
  PhStripeLogo: __vue_component__$2a,
  PhStudent: __vue_component__$29,
  PhSuitcase: __vue_component__$28,
  PhSuitcaseSimple: __vue_component__$27,
  PhSun: __vue_component__$26,
  PhSunDim: __vue_component__$25,
  PhSunHorizon: __vue_component__$24,
  PhSunglasses: __vue_component__$23,
  PhSwap: __vue_component__$22,
  PhSwatches: __vue_component__$21,
  PhSword: __vue_component__$20,
  PhSyringe: __vue_component__$1$,
  PhTShirt: __vue_component__$1_,
  PhTable: __vue_component__$1Z,
  PhTabs: __vue_component__$1Y,
  PhTag: __vue_component__$1X,
  PhTagChevron: __vue_component__$1W,
  PhTagSimple: __vue_component__$1V,
  PhTarget: __vue_component__$1U,
  PhTaxi: __vue_component__$1T,
  PhTelegramLogo: __vue_component__$1S,
  PhTelevision: __vue_component__$1R,
  PhTelevisionSimple: __vue_component__$1Q,
  PhTennisBall: __vue_component__$1P,
  PhTerminal: __vue_component__$1O,
  PhTerminalWindow: __vue_component__$1N,
  PhTestTube: __vue_component__$1M,
  PhTextAa: __vue_component__$1L,
  PhTextAlignCenter: __vue_component__$1K,
  PhTextAlignJustify: __vue_component__$1J,
  PhTextAlignLeft: __vue_component__$1I,
  PhTextAlignRight: __vue_component__$1H,
  PhTextBolder: __vue_component__$1G,
  PhTextH: __vue_component__$1F,
  PhTextHFive: __vue_component__$1E,
  PhTextHFour: __vue_component__$1D,
  PhTextHOne: __vue_component__$1C,
  PhTextHSix: __vue_component__$1B,
  PhTextHThree: __vue_component__$1A,
  PhTextHTwo: __vue_component__$1z,
  PhTextIndent: __vue_component__$1y,
  PhTextItalic: __vue_component__$1x,
  PhTextOutdent: __vue_component__$1w,
  PhTextStrikethrough: __vue_component__$1v,
  PhTextT: __vue_component__$1u,
  PhTextUnderline: __vue_component__$1t,
  PhTextbox: __vue_component__$1s,
  PhThermometer: __vue_component__$1r,
  PhThermometerCold: __vue_component__$1q,
  PhThermometerHot: __vue_component__$1p,
  PhThermometerSimple: __vue_component__$1o,
  PhThumbsDown: __vue_component__$1n,
  PhThumbsUp: __vue_component__$1m,
  PhTicket: __vue_component__$1l,
  PhTiktokLogo: __vue_component__$1k,
  PhTimer: __vue_component__$1j,
  PhToggleLeft: __vue_component__$1i,
  PhToggleRight: __vue_component__$1h,
  PhToilet: __vue_component__$1g,
  PhToiletPaper: __vue_component__$1f,
  PhTote: __vue_component__$1e,
  PhToteSimple: __vue_component__$1d,
  PhTrademarkRegistered: __vue_component__$1c,
  PhTrafficCone: __vue_component__$1b,
  PhTrafficSign: __vue_component__$1a,
  PhTrafficSignal: __vue_component__$19,
  PhTrain: __vue_component__$18,
  PhTrainRegional: __vue_component__$17,
  PhTrainSimple: __vue_component__$16,
  PhTranslate: __vue_component__$15,
  PhTrash: __vue_component__$14,
  PhTrashSimple: __vue_component__$13,
  PhTray: __vue_component__$12,
  PhTree: __vue_component__$11,
  PhTreeEvergreen: __vue_component__$10,
  PhTreeStructure: __vue_component__$$,
  PhTrendDown: __vue_component__$_,
  PhTrendUp: __vue_component__$Z,
  PhTriangle: __vue_component__$Y,
  PhTrophy: __vue_component__$X,
  PhTruck: __vue_component__$W,
  PhTwitchLogo: __vue_component__$V,
  PhTwitterLogo: __vue_component__$U,
  PhUmbrella: __vue_component__$T,
  PhUmbrellaSimple: __vue_component__$S,
  PhUpload: __vue_component__$R,
  PhUploadSimple: __vue_component__$Q,
  PhUser: __vue_component__$P,
  PhUserCircle: __vue_component__$O,
  PhUserCircleGear: __vue_component__$N,
  PhUserCircleMinus: __vue_component__$M,
  PhUserCirclePlus: __vue_component__$L,
  PhUserFocus: __vue_component__$K,
  PhUserGear: __vue_component__$J,
  PhUserList: __vue_component__$I,
  PhUserMinus: __vue_component__$H,
  PhUserPlus: __vue_component__$G,
  PhUserRectangle: __vue_component__$F,
  PhUserSquare: __vue_component__$E,
  PhUserSwitch: __vue_component__$D,
  PhUsers: __vue_component__$C,
  PhUsersFour: __vue_component__$B,
  PhUsersThree: __vue_component__$A,
  PhVault: __vue_component__$z,
  PhVibrate: __vue_component__$y,
  PhVideoCamera: __vue_component__$x,
  PhVideoCameraSlash: __vue_component__$w,
  PhVignette: __vue_component__$v,
  PhVoicemail: __vue_component__$u,
  PhVolleyball: __vue_component__$t,
  PhWall: __vue_component__$s,
  PhWallet: __vue_component__$r,
  PhWarning: __vue_component__$q,
  PhWarningCircle: __vue_component__$p,
  PhWarningOctagon: __vue_component__$o,
  PhWatch: __vue_component__$n,
  PhWaveSawtooth: __vue_component__$m,
  PhWaveSine: __vue_component__$l,
  PhWaveSquare: __vue_component__$k,
  PhWaveTriangle: __vue_component__$j,
  PhWaves: __vue_component__$i,
  PhWebcam: __vue_component__$h,
  PhWhatsappLogo: __vue_component__$g,
  PhWheelchair: __vue_component__$f,
  PhWifiHigh: __vue_component__$e,
  PhWifiLow: __vue_component__$d,
  PhWifiMedium: __vue_component__$c,
  PhWifiNone: __vue_component__$b,
  PhWifiSlash: __vue_component__$a,
  PhWifiX: __vue_component__$9,
  PhWind: __vue_component__$8,
  PhWindowsLogo: __vue_component__$7,
  PhWine: __vue_component__$6,
  PhWrench: __vue_component__$5,
  PhX: __vue_component__$4,
  PhXCircle: __vue_component__$3,
  PhXSquare: __vue_component__$2,
  PhYinYang: __vue_component__$1,
  PhYoutubeLogo: __vue_component__
});

// Import vue components
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// install function executed by Vue.use()
const install = function installPhosphorVueTs(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.entries(components).forEach(_ref => {
    let [componentName, component] = _ref;
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install on non-es builds, when vue is found

export { __vue_component__$gm as PhActivity, __vue_component__$gl as PhAddressBook, __vue_component__$gk as PhAirplane, __vue_component__$gj as PhAirplaneInFlight, __vue_component__$gi as PhAirplaneLanding, __vue_component__$gh as PhAirplaneTakeoff, __vue_component__$gg as PhAirplaneTilt, __vue_component__$gf as PhAirplay, __vue_component__$ge as PhAlarm, __vue_component__$gd as PhAlien, __vue_component__$gc as PhAlignBottom, __vue_component__$gb as PhAlignBottomSimple, __vue_component__$ga as PhAlignCenterHorizontal, __vue_component__$g9 as PhAlignCenterHorizontalSimple, __vue_component__$g8 as PhAlignCenterVertical, __vue_component__$g7 as PhAlignCenterVerticalSimple, __vue_component__$g6 as PhAlignLeft, __vue_component__$g5 as PhAlignLeftSimple, __vue_component__$g4 as PhAlignRight, __vue_component__$g3 as PhAlignRightSimple, __vue_component__$g2 as PhAlignTop, __vue_component__$g1 as PhAlignTopSimple, __vue_component__$g0 as PhAnchor, __vue_component__$f$ as PhAnchorSimple, __vue_component__$f_ as PhAndroidLogo, __vue_component__$fZ as PhAngularLogo, __vue_component__$fY as PhAperture, __vue_component__$fX as PhAppStoreLogo, __vue_component__$fW as PhAppWindow, __vue_component__$fV as PhAppleLogo, __vue_component__$fU as PhApplePodcastsLogo, __vue_component__$fT as PhArchive, __vue_component__$fS as PhArchiveBox, __vue_component__$fR as PhArchiveTray, __vue_component__$fQ as PhArmchair, __vue_component__$fP as PhArrowArcLeft, __vue_component__$fO as PhArrowArcRight, __vue_component__$fN as PhArrowBendDoubleUpLeft, __vue_component__$fM as PhArrowBendDoubleUpRight, __vue_component__$fL as PhArrowBendDownLeft, __vue_component__$fK as PhArrowBendDownRight, __vue_component__$fJ as PhArrowBendLeftDown, __vue_component__$fI as PhArrowBendLeftUp, __vue_component__$fH as PhArrowBendRightDown, __vue_component__$fG as PhArrowBendRightUp, __vue_component__$fF as PhArrowBendUpLeft, __vue_component__$fE as PhArrowBendUpRight, __vue_component__$fD as PhArrowCircleDown, __vue_component__$fC as PhArrowCircleDownLeft, __vue_component__$fB as PhArrowCircleDownRight, __vue_component__$fA as PhArrowCircleLeft, __vue_component__$fz as PhArrowCircleRight, __vue_component__$fy as PhArrowCircleUp, __vue_component__$fx as PhArrowCircleUpLeft, __vue_component__$fw as PhArrowCircleUpRight, __vue_component__$fv as PhArrowClockwise, __vue_component__$fu as PhArrowCounterClockwise, __vue_component__$ft as PhArrowDown, __vue_component__$fs as PhArrowDownLeft, __vue_component__$fr as PhArrowDownRight, __vue_component__$fq as PhArrowElbowDownLeft, __vue_component__$fp as PhArrowElbowDownRight, __vue_component__$fo as PhArrowElbowLeft, __vue_component__$fn as PhArrowElbowLeftDown, __vue_component__$fm as PhArrowElbowLeftUp, __vue_component__$fl as PhArrowElbowRight, __vue_component__$fk as PhArrowElbowRightDown, __vue_component__$fj as PhArrowElbowRightUp, __vue_component__$fi as PhArrowElbowUpLeft, __vue_component__$fh as PhArrowElbowUpRight, __vue_component__$fg as PhArrowFatDown, __vue_component__$ff as PhArrowFatLeft, __vue_component__$fe as PhArrowFatLineDown, __vue_component__$fd as PhArrowFatLineLeft, __vue_component__$fc as PhArrowFatLineRight, __vue_component__$fb as PhArrowFatLineUp, __vue_component__$fa as PhArrowFatLinesDown, __vue_component__$f9 as PhArrowFatLinesLeft, __vue_component__$f8 as PhArrowFatLinesRight, __vue_component__$f7 as PhArrowFatLinesUp, __vue_component__$f6 as PhArrowFatRight, __vue_component__$f5 as PhArrowFatUp, __vue_component__$f4 as PhArrowLeft, __vue_component__$f3 as PhArrowLineDown, __vue_component__$f2 as PhArrowLineDownLeft, __vue_component__$f1 as PhArrowLineDownRight, __vue_component__$f0 as PhArrowLineLeft, __vue_component__$e$ as PhArrowLineRight, __vue_component__$e_ as PhArrowLineUp, __vue_component__$eZ as PhArrowLineUpLeft, __vue_component__$eY as PhArrowLineUpRight, __vue_component__$eX as PhArrowRight, __vue_component__$eW as PhArrowSquareDown, __vue_component__$eV as PhArrowSquareDownLeft, __vue_component__$eU as PhArrowSquareDownRight, __vue_component__$eT as PhArrowSquareIn, __vue_component__$eS as PhArrowSquareLeft, __vue_component__$eR as PhArrowSquareOut, __vue_component__$eQ as PhArrowSquareRight, __vue_component__$eP as PhArrowSquareUp, __vue_component__$eO as PhArrowSquareUpLeft, __vue_component__$eN as PhArrowSquareUpRight, __vue_component__$eM as PhArrowUDownLeft, __vue_component__$eL as PhArrowUDownRight, __vue_component__$eK as PhArrowULeftDown, __vue_component__$eJ as PhArrowULeftUp, __vue_component__$eI as PhArrowURightDown, __vue_component__$eH as PhArrowURightUp, __vue_component__$eG as PhArrowUUpLeft, __vue_component__$eF as PhArrowUUpRight, __vue_component__$eE as PhArrowUp, __vue_component__$eD as PhArrowUpLeft, __vue_component__$eC as PhArrowUpRight, __vue_component__$eB as PhArrowsClockwise, __vue_component__$eA as PhArrowsCounterClockwise, __vue_component__$ez as PhArrowsDownUp, __vue_component__$ey as PhArrowsHorizontal, __vue_component__$ex as PhArrowsIn, __vue_component__$ew as PhArrowsInCardinal, __vue_component__$ev as PhArrowsInLineHorizontal, __vue_component__$eu as PhArrowsInLineVertical, __vue_component__$et as PhArrowsInSimple, __vue_component__$es as PhArrowsLeftRight, __vue_component__$er as PhArrowsOut, __vue_component__$eq as PhArrowsOutCardinal, __vue_component__$ep as PhArrowsOutLineHorizontal, __vue_component__$eo as PhArrowsOutLineVertical, __vue_component__$en as PhArrowsOutSimple, __vue_component__$em as PhArrowsVertical, __vue_component__$el as PhArticle, __vue_component__$ek as PhArticleMedium, __vue_component__$ej as PhArticleNyTimes, __vue_component__$ei as PhAsterisk, __vue_component__$eh as PhAsteriskSimple, __vue_component__$eg as PhAt, __vue_component__$ef as PhAtom, __vue_component__$ee as PhBaby, __vue_component__$ed as PhBackpack, __vue_component__$ec as PhBackspace, __vue_component__$eb as PhBag, __vue_component__$ea as PhBagSimple, __vue_component__$e9 as PhBalloon, __vue_component__$e8 as PhBandaids, __vue_component__$e7 as PhBank, __vue_component__$e6 as PhBarbell, __vue_component__$e5 as PhBarcode, __vue_component__$e4 as PhBarricade, __vue_component__$e3 as PhBaseball, __vue_component__$e2 as PhBasketball, __vue_component__$e1 as PhBathtub, __vue_component__$e0 as PhBatteryCharging, __vue_component__$d$ as PhBatteryChargingVertical, __vue_component__$d_ as PhBatteryEmpty, __vue_component__$dZ as PhBatteryFull, __vue_component__$dY as PhBatteryHigh, __vue_component__$dX as PhBatteryLow, __vue_component__$dW as PhBatteryMedium, __vue_component__$dV as PhBatteryPlus, __vue_component__$dU as PhBatteryWarning, __vue_component__$dT as PhBatteryWarningVertical, __vue_component__$dS as PhBed, __vue_component__$dR as PhBeerBottle, __vue_component__$dQ as PhBehanceLogo, __vue_component__$dP as PhBell, __vue_component__$dO as PhBellRinging, __vue_component__$dN as PhBellSimple, __vue_component__$dM as PhBellSimpleRinging, __vue_component__$dL as PhBellSimpleSlash, __vue_component__$dK as PhBellSimpleZ, __vue_component__$dJ as PhBellSlash, __vue_component__$dI as PhBellZ, __vue_component__$dH as PhBezierCurve, __vue_component__$dG as PhBicycle, __vue_component__$dF as PhBinoculars, __vue_component__$dE as PhBird, __vue_component__$dD as PhBluetooth, __vue_component__$dC as PhBluetoothConnected, __vue_component__$dB as PhBluetoothSlash, __vue_component__$dA as PhBluetoothX, __vue_component__$dz as PhBoat, __vue_component__$dy as PhBook, __vue_component__$dx as PhBookBookmark, __vue_component__$dw as PhBookOpen, __vue_component__$dv as PhBookmark, __vue_component__$du as PhBookmarkSimple, __vue_component__$dt as PhBookmarks, __vue_component__$ds as PhBookmarksSimple, __vue_component__$dr as PhBooks, __vue_component__$dq as PhBoundingBox, __vue_component__$dp as PhBracketsAngle, __vue_component__$do as PhBracketsCurly, __vue_component__$dn as PhBracketsRound, __vue_component__$dm as PhBracketsSquare, __vue_component__$dl as PhBrain, __vue_component__$dk as PhBrandy, __vue_component__$dj as PhBriefcase, __vue_component__$di as PhBriefcaseMetal, __vue_component__$dh as PhBroadcast, __vue_component__$dg as PhBrowser, __vue_component__$df as PhBrowsers, __vue_component__$de as PhBug, __vue_component__$dd as PhBugBeetle, __vue_component__$dc as PhBugDroid, __vue_component__$db as PhBuildings, __vue_component__$da as PhBus, __vue_component__$d9 as PhButterfly, __vue_component__$d8 as PhCactus, __vue_component__$d7 as PhCake, __vue_component__$d6 as PhCalculator, __vue_component__$d5 as PhCalendar, __vue_component__$d4 as PhCalendarBlank, __vue_component__$d3 as PhCalendarCheck, __vue_component__$d2 as PhCalendarPlus, __vue_component__$d1 as PhCalendarX, __vue_component__$d0 as PhCamera, __vue_component__$c$ as PhCameraRotate, __vue_component__$c_ as PhCameraSlash, __vue_component__$cZ as PhCampfire, __vue_component__$cY as PhCar, __vue_component__$cX as PhCarSimple, __vue_component__$cW as PhCardholder, __vue_component__$cV as PhCards, __vue_component__$cU as PhCaretCircleDoubleDown, __vue_component__$cT as PhCaretCircleDoubleLeft, __vue_component__$cS as PhCaretCircleDoubleRight, __vue_component__$cR as PhCaretCircleDoubleUp, __vue_component__$cQ as PhCaretCircleDown, __vue_component__$cP as PhCaretCircleLeft, __vue_component__$cO as PhCaretCircleRight, __vue_component__$cN as PhCaretCircleUp, __vue_component__$cM as PhCaretDoubleDown, __vue_component__$cL as PhCaretDoubleLeft, __vue_component__$cK as PhCaretDoubleRight, __vue_component__$cJ as PhCaretDoubleUp, __vue_component__$cI as PhCaretDown, __vue_component__$cH as PhCaretLeft, __vue_component__$cG as PhCaretRight, __vue_component__$cF as PhCaretUp, __vue_component__$cE as PhCat, __vue_component__$cD as PhCellSignalFull, __vue_component__$cC as PhCellSignalHigh, __vue_component__$cB as PhCellSignalLow, __vue_component__$cA as PhCellSignalMedium, __vue_component__$cz as PhCellSignalNone, __vue_component__$cy as PhCellSignalSlash, __vue_component__$cx as PhCellSignalX, __vue_component__$cw as PhChalkboard, __vue_component__$cv as PhChalkboardSimple, __vue_component__$cu as PhChalkboardTeacher, __vue_component__$ct as PhChartBar, __vue_component__$cs as PhChartBarHorizontal, __vue_component__$cr as PhChartLine, __vue_component__$cq as PhChartLineUp, __vue_component__$cp as PhChartPie, __vue_component__$co as PhChartPieSlice, __vue_component__$cn as PhChat, __vue_component__$cm as PhChatCentered, __vue_component__$cl as PhChatCenteredDots, __vue_component__$ck as PhChatCenteredText, __vue_component__$cj as PhChatCircle, __vue_component__$ci as PhChatCircleDots, __vue_component__$ch as PhChatCircleText, __vue_component__$cg as PhChatDots, __vue_component__$cf as PhChatTeardrop, __vue_component__$ce as PhChatTeardropDots, __vue_component__$cd as PhChatTeardropText, __vue_component__$cc as PhChatText, __vue_component__$cb as PhChats, __vue_component__$ca as PhChatsCircle, __vue_component__$c9 as PhChatsTeardrop, __vue_component__$c8 as PhCheck, __vue_component__$c7 as PhCheckCircle, __vue_component__$c6 as PhCheckSquare, __vue_component__$c5 as PhCheckSquareOffset, __vue_component__$c4 as PhChecks, __vue_component__$c3 as PhCircle, __vue_component__$c2 as PhCircleDashed, __vue_component__$c1 as PhCircleHalf, __vue_component__$c0 as PhCircleHalfTilt, __vue_component__$b$ as PhCircleNotch, __vue_component__$b_ as PhCircleWavy, __vue_component__$bZ as PhCircleWavyCheck, __vue_component__$bY as PhCircleWavyQuestion, __vue_component__$bX as PhCircleWavyWarning, __vue_component__$bW as PhCirclesFour, __vue_component__$bV as PhCirclesThree, __vue_component__$bU as PhCirclesThreePlus, __vue_component__$bT as PhClipboard, __vue_component__$bS as PhClipboardText, __vue_component__$bR as PhClock, __vue_component__$bQ as PhClockAfternoon, __vue_component__$bP as PhClockClockwise, __vue_component__$bO as PhClockCounterClockwise, __vue_component__$bN as PhClosedCaptioning, __vue_component__$bM as PhCloud, __vue_component__$bL as PhCloudArrowDown, __vue_component__$bK as PhCloudArrowUp, __vue_component__$bJ as PhCloudCheck, __vue_component__$bI as PhCloudFog, __vue_component__$bH as PhCloudLightning, __vue_component__$bG as PhCloudMoon, __vue_component__$bF as PhCloudRain, __vue_component__$bE as PhCloudSlash, __vue_component__$bD as PhCloudSnow, __vue_component__$bC as PhCloudSun, __vue_component__$bB as PhClub, __vue_component__$bA as PhCoatHanger, __vue_component__$bz as PhCode, __vue_component__$by as PhCodeSimple, __vue_component__$bx as PhCodepenLogo, __vue_component__$bw as PhCodesandboxLogo, __vue_component__$bv as PhCoffee, __vue_component__$bu as PhCoin, __vue_component__$bt as PhCoinVertical, __vue_component__$bs as PhCoins, __vue_component__$br as PhColumns, __vue_component__$bq as PhCommand, __vue_component__$bp as PhCompass, __vue_component__$bo as PhComputerTower, __vue_component__$bn as PhConfetti, __vue_component__$bm as PhCookie, __vue_component__$bl as PhCookingPot, __vue_component__$bk as PhCopy, __vue_component__$bj as PhCopySimple, __vue_component__$bi as PhCopyleft, __vue_component__$bh as PhCopyright, __vue_component__$bg as PhCornersIn, __vue_component__$bf as PhCornersOut, __vue_component__$be as PhCpu, __vue_component__$bd as PhCreditCard, __vue_component__$bc as PhCrop, __vue_component__$bb as PhCrosshair, __vue_component__$ba as PhCrosshairSimple, __vue_component__$b9 as PhCrown, __vue_component__$b8 as PhCrownSimple, __vue_component__$b7 as PhCube, __vue_component__$b6 as PhCurrencyBtc, __vue_component__$b5 as PhCurrencyCircleDollar, __vue_component__$b4 as PhCurrencyCny, __vue_component__$b3 as PhCurrencyDollar, __vue_component__$b2 as PhCurrencyDollarSimple, __vue_component__$b1 as PhCurrencyEth, __vue_component__$b0 as PhCurrencyEur, __vue_component__$a$ as PhCurrencyGbp, __vue_component__$a_ as PhCurrencyInr, __vue_component__$aZ as PhCurrencyJpy, __vue_component__$aY as PhCurrencyKrw, __vue_component__$aX as PhCurrencyKzt, __vue_component__$aW as PhCurrencyNgn, __vue_component__$aV as PhCurrencyRub, __vue_component__$aU as PhCursor, __vue_component__$aT as PhCursorText, __vue_component__$aS as PhCylinder, __vue_component__$aR as PhDatabase, __vue_component__$aQ as PhDesktop, __vue_component__$aP as PhDesktopTower, __vue_component__$aO as PhDetective, __vue_component__$aN as PhDeviceMobile, __vue_component__$aM as PhDeviceMobileCamera, __vue_component__$aL as PhDeviceMobileSpeaker, __vue_component__$aK as PhDeviceTablet, __vue_component__$aJ as PhDeviceTabletCamera, __vue_component__$aI as PhDeviceTabletSpeaker, __vue_component__$aH as PhDiamond, __vue_component__$aG as PhDiamondsFour, __vue_component__$aF as PhDiceFive, __vue_component__$aE as PhDiceFour, __vue_component__$aD as PhDiceOne, __vue_component__$aC as PhDiceSix, __vue_component__$aB as PhDiceThree, __vue_component__$aA as PhDiceTwo, __vue_component__$az as PhDisc, __vue_component__$ay as PhDiscordLogo, __vue_component__$ax as PhDivide, __vue_component__$aw as PhDog, __vue_component__$av as PhDoor, __vue_component__$au as PhDotsNine, __vue_component__$at as PhDotsSix, __vue_component__$as as PhDotsSixVertical, __vue_component__$ar as PhDotsThree, __vue_component__$aq as PhDotsThreeCircle, __vue_component__$ap as PhDotsThreeCircleVertical, __vue_component__$ao as PhDotsThreeOutline, __vue_component__$an as PhDotsThreeOutlineVertical, __vue_component__$am as PhDotsThreeVertical, __vue_component__$al as PhDownload, __vue_component__$ak as PhDownloadSimple, __vue_component__$aj as PhDribbbleLogo, __vue_component__$ai as PhDrop, __vue_component__$ah as PhDropHalf, __vue_component__$ag as PhDropHalfBottom, __vue_component__$af as PhEar, __vue_component__$ae as PhEarSlash, __vue_component__$ad as PhEgg, __vue_component__$ac as PhEggCrack, __vue_component__$ab as PhEject, __vue_component__$aa as PhEjectSimple, __vue_component__$a9 as PhEnvelope, __vue_component__$a8 as PhEnvelopeOpen, __vue_component__$a7 as PhEnvelopeSimple, __vue_component__$a6 as PhEnvelopeSimpleOpen, __vue_component__$a5 as PhEqualizer, __vue_component__$a4 as PhEquals, __vue_component__$a3 as PhEraser, __vue_component__$a2 as PhExam, __vue_component__$a1 as PhExport, __vue_component__$a0 as PhEye, __vue_component__$9$ as PhEyeClosed, __vue_component__$9_ as PhEyeSlash, __vue_component__$9Z as PhEyedropper, __vue_component__$9Y as PhEyedropperSample, __vue_component__$9X as PhEyeglasses, __vue_component__$9W as PhFaceMask, __vue_component__$9V as PhFacebookLogo, __vue_component__$9U as PhFactory, __vue_component__$9T as PhFaders, __vue_component__$9S as PhFadersHorizontal, __vue_component__$9R as PhFastForward, __vue_component__$9Q as PhFastForwardCircle, __vue_component__$9P as PhFigmaLogo, __vue_component__$9O as PhFile, __vue_component__$9N as PhFileArrowDown, __vue_component__$9M as PhFileArrowUp, __vue_component__$9L as PhFileAudio, __vue_component__$9K as PhFileCloud, __vue_component__$9J as PhFileCode, __vue_component__$9I as PhFileCss, __vue_component__$9H as PhFileCsv, __vue_component__$9G as PhFileDoc, __vue_component__$9F as PhFileDotted, __vue_component__$9E as PhFileHtml, __vue_component__$9D as PhFileImage, __vue_component__$9C as PhFileJpg, __vue_component__$9B as PhFileJs, __vue_component__$9A as PhFileJsx, __vue_component__$9z as PhFileLock, __vue_component__$9y as PhFileMinus, __vue_component__$9x as PhFilePdf, __vue_component__$9w as PhFilePlus, __vue_component__$9v as PhFilePng, __vue_component__$9u as PhFilePpt, __vue_component__$9t as PhFileRs, __vue_component__$9s as PhFileSearch, __vue_component__$9r as PhFileText, __vue_component__$9q as PhFileTs, __vue_component__$9p as PhFileTsx, __vue_component__$9o as PhFileVideo, __vue_component__$9n as PhFileVue, __vue_component__$9m as PhFileX, __vue_component__$9l as PhFileXls, __vue_component__$9k as PhFileZip, __vue_component__$9j as PhFiles, __vue_component__$9i as PhFilmScript, __vue_component__$9h as PhFilmSlate, __vue_component__$9g as PhFilmStrip, __vue_component__$9f as PhFingerprint, __vue_component__$9e as PhFingerprintSimple, __vue_component__$9d as PhFinnTheHuman, __vue_component__$9c as PhFire, __vue_component__$9b as PhFireSimple, __vue_component__$9a as PhFirstAid, __vue_component__$99 as PhFirstAidKit, __vue_component__$98 as PhFish, __vue_component__$97 as PhFishSimple, __vue_component__$96 as PhFlag, __vue_component__$95 as PhFlagBanner, __vue_component__$94 as PhFlagCheckered, __vue_component__$93 as PhFlame, __vue_component__$92 as PhFlashlight, __vue_component__$91 as PhFlask, __vue_component__$90 as PhFloppyDisk, __vue_component__$8$ as PhFloppyDiskBack, __vue_component__$8_ as PhFlowArrow, __vue_component__$8Z as PhFlower, __vue_component__$8Y as PhFlowerLotus, __vue_component__$8X as PhFlyingSaucer, __vue_component__$8W as PhFolder, __vue_component__$8V as PhFolderDotted, __vue_component__$8U as PhFolderLock, __vue_component__$8T as PhFolderMinus, __vue_component__$8S as PhFolderNotch, __vue_component__$8R as PhFolderNotchMinus, __vue_component__$8Q as PhFolderNotchOpen, __vue_component__$8P as PhFolderNotchPlus, __vue_component__$8O as PhFolderOpen, __vue_component__$8N as PhFolderPlus, __vue_component__$8M as PhFolderSimple, __vue_component__$8L as PhFolderSimpleDotted, __vue_component__$8K as PhFolderSimpleLock, __vue_component__$8J as PhFolderSimpleMinus, __vue_component__$8I as PhFolderSimplePlus, __vue_component__$8H as PhFolderSimpleStar, __vue_component__$8G as PhFolderSimpleUser, __vue_component__$8F as PhFolderStar, __vue_component__$8E as PhFolderUser, __vue_component__$8D as PhFolders, __vue_component__$8C as PhFootball, __vue_component__$8B as PhForkKnife, __vue_component__$8A as PhFrameCorners, __vue_component__$8z as PhFramerLogo, __vue_component__$8y as PhFunction, __vue_component__$8x as PhFunnel, __vue_component__$8w as PhFunnelSimple, __vue_component__$8v as PhGameController, __vue_component__$8u as PhGasPump, __vue_component__$8t as PhGauge, __vue_component__$8s as PhGear, __vue_component__$8r as PhGearSix, __vue_component__$8q as PhGenderFemale, __vue_component__$8p as PhGenderIntersex, __vue_component__$8o as PhGenderMale, __vue_component__$8n as PhGenderNeuter, __vue_component__$8m as PhGenderNonbinary, __vue_component__$8l as PhGenderTransgender, __vue_component__$8k as PhGhost, __vue_component__$8j as PhGif, __vue_component__$8i as PhGift, __vue_component__$8h as PhGitBranch, __vue_component__$8g as PhGitCommit, __vue_component__$8f as PhGitDiff, __vue_component__$8e as PhGitFork, __vue_component__$8d as PhGitMerge, __vue_component__$8c as PhGitPullRequest, __vue_component__$8b as PhGithubLogo, __vue_component__$8a as PhGitlabLogo, __vue_component__$89 as PhGitlabLogoSimple, __vue_component__$88 as PhGlobe, __vue_component__$87 as PhGlobeHemisphereEast, __vue_component__$86 as PhGlobeHemisphereWest, __vue_component__$85 as PhGlobeSimple, __vue_component__$84 as PhGlobeStand, __vue_component__$83 as PhGoogleChromeLogo, __vue_component__$82 as PhGoogleLogo, __vue_component__$81 as PhGooglePhotosLogo, __vue_component__$80 as PhGooglePlayLogo, __vue_component__$7$ as PhGooglePodcastsLogo, __vue_component__$7_ as PhGradient, __vue_component__$7Z as PhGraduationCap, __vue_component__$7Y as PhGraph, __vue_component__$7X as PhGridFour, __vue_component__$7W as PhHamburger, __vue_component__$7V as PhHand, __vue_component__$7U as PhHandEye, __vue_component__$7T as PhHandFist, __vue_component__$7S as PhHandGrabbing, __vue_component__$7R as PhHandPalm, __vue_component__$7Q as PhHandPointing, __vue_component__$7P as PhHandSoap, __vue_component__$7O as PhHandWaving, __vue_component__$7N as PhHandbag, __vue_component__$7M as PhHandbagSimple, __vue_component__$7L as PhHandsClapping, __vue_component__$7K as PhHandshake, __vue_component__$7J as PhHardDrive, __vue_component__$7I as PhHardDrives, __vue_component__$7H as PhHash, __vue_component__$7G as PhHashStraight, __vue_component__$7F as PhHeadlights, __vue_component__$7E as PhHeadphones, __vue_component__$7D as PhHeadset, __vue_component__$7C as PhHeart, __vue_component__$7B as PhHeartBreak, __vue_component__$7A as PhHeartStraight, __vue_component__$7z as PhHeartStraightBreak, __vue_component__$7y as PhHeartbeat, __vue_component__$7x as PhHexagon, __vue_component__$7w as PhHighlighterCircle, __vue_component__$7v as PhHorse, __vue_component__$7u as PhHourglass, __vue_component__$7t as PhHourglassHigh, __vue_component__$7s as PhHourglassLow, __vue_component__$7r as PhHourglassMedium, __vue_component__$7q as PhHourglassSimple, __vue_component__$7p as PhHourglassSimpleHigh, __vue_component__$7o as PhHourglassSimpleLow, __vue_component__$7n as PhHourglassSimpleMedium, __vue_component__$7m as PhHouse, __vue_component__$7l as PhHouseLine, __vue_component__$7k as PhHouseSimple, __vue_component__$7j as PhIdentificationBadge, __vue_component__$7i as PhIdentificationCard, __vue_component__$7h as PhImage, __vue_component__$7g as PhImageSquare, __vue_component__$7f as PhInfinity, __vue_component__$7e as PhInfo, __vue_component__$7d as PhInstagramLogo, __vue_component__$7c as PhIntersect, __vue_component__$7b as PhJeep, __vue_component__$7a as PhKanban, __vue_component__$79 as PhKey, __vue_component__$78 as PhKeyReturn, __vue_component__$77 as PhKeyboard, __vue_component__$76 as PhKeyhole, __vue_component__$75 as PhKnife, __vue_component__$74 as PhLadder, __vue_component__$73 as PhLadderSimple, __vue_component__$72 as PhLamp, __vue_component__$71 as PhLaptop, __vue_component__$70 as PhLayout, __vue_component__$6$ as PhLeaf, __vue_component__$6_ as PhLifebuoy, __vue_component__$6Z as PhLightbulb, __vue_component__$6Y as PhLightbulbFilament, __vue_component__$6X as PhLightning, __vue_component__$6W as PhLightningSlash, __vue_component__$6V as PhLineSegment, __vue_component__$6U as PhLineSegments, __vue_component__$6T as PhLink, __vue_component__$6S as PhLinkBreak, __vue_component__$6R as PhLinkSimple, __vue_component__$6Q as PhLinkSimpleBreak, __vue_component__$6P as PhLinkSimpleHorizontal, __vue_component__$6O as PhLinkSimpleHorizontalBreak, __vue_component__$6N as PhLinkedinLogo, __vue_component__$6M as PhLinuxLogo, __vue_component__$6L as PhList, __vue_component__$6K as PhListBullets, __vue_component__$6J as PhListChecks, __vue_component__$6I as PhListDashes, __vue_component__$6H as PhListNumbers, __vue_component__$6G as PhListPlus, __vue_component__$6F as PhLock, __vue_component__$6E as PhLockKey, __vue_component__$6D as PhLockKeyOpen, __vue_component__$6C as PhLockLaminated, __vue_component__$6B as PhLockLaminatedOpen, __vue_component__$6A as PhLockOpen, __vue_component__$6z as PhLockSimple, __vue_component__$6y as PhLockSimpleOpen, __vue_component__$6x as PhMagicWand, __vue_component__$6w as PhMagnet, __vue_component__$6v as PhMagnetStraight, __vue_component__$6u as PhMagnifyingGlass, __vue_component__$6t as PhMagnifyingGlassMinus, __vue_component__$6s as PhMagnifyingGlassPlus, __vue_component__$6r as PhMapPin, __vue_component__$6q as PhMapPinLine, __vue_component__$6p as PhMapTrifold, __vue_component__$6o as PhMarkerCircle, __vue_component__$6n as PhMartini, __vue_component__$6m as PhMaskHappy, __vue_component__$6l as PhMaskSad, __vue_component__$6k as PhMathOperations, __vue_component__$6j as PhMedal, __vue_component__$6i as PhMediumLogo, __vue_component__$6h as PhMegaphone, __vue_component__$6g as PhMegaphoneSimple, __vue_component__$6f as PhMessengerLogo, __vue_component__$6e as PhMicrophone, __vue_component__$6d as PhMicrophoneSlash, __vue_component__$6c as PhMicrophoneStage, __vue_component__$6b as PhMicrosoftExcelLogo, __vue_component__$6a as PhMicrosoftPowerpointLogo, __vue_component__$69 as PhMicrosoftTeamsLogo, __vue_component__$68 as PhMicrosoftWordLogo, __vue_component__$67 as PhMinus, __vue_component__$66 as PhMinusCircle, __vue_component__$65 as PhMoney, __vue_component__$64 as PhMonitor, __vue_component__$63 as PhMonitorPlay, __vue_component__$62 as PhMoon, __vue_component__$61 as PhMoonStars, __vue_component__$60 as PhMountains, __vue_component__$5$ as PhMouse, __vue_component__$5_ as PhMouseSimple, __vue_component__$5Z as PhMusicNote, __vue_component__$5Y as PhMusicNoteSimple, __vue_component__$5X as PhMusicNotes, __vue_component__$5W as PhMusicNotesPlus, __vue_component__$5V as PhMusicNotesSimple, __vue_component__$5U as PhNavigationArrow, __vue_component__$5T as PhNeedle, __vue_component__$5S as PhNewspaper, __vue_component__$5R as PhNewspaperClipping, __vue_component__$5Q as PhNote, __vue_component__$5P as PhNoteBlank, __vue_component__$5O as PhNotePencil, __vue_component__$5N as PhNotebook, __vue_component__$5M as PhNotepad, __vue_component__$5L as PhNotification, __vue_component__$5K as PhNumberCircleEight, __vue_component__$5J as PhNumberCircleFive, __vue_component__$5I as PhNumberCircleFour, __vue_component__$5H as PhNumberCircleNine, __vue_component__$5G as PhNumberCircleOne, __vue_component__$5F as PhNumberCircleSeven, __vue_component__$5E as PhNumberCircleSix, __vue_component__$5D as PhNumberCircleThree, __vue_component__$5C as PhNumberCircleTwo, __vue_component__$5B as PhNumberCircleZero, __vue_component__$5A as PhNumberEight, __vue_component__$5z as PhNumberFive, __vue_component__$5y as PhNumberFour, __vue_component__$5x as PhNumberNine, __vue_component__$5w as PhNumberOne, __vue_component__$5v as PhNumberSeven, __vue_component__$5u as PhNumberSix, __vue_component__$5t as PhNumberSquareEight, __vue_component__$5s as PhNumberSquareFive, __vue_component__$5r as PhNumberSquareFour, __vue_component__$5q as PhNumberSquareNine, __vue_component__$5p as PhNumberSquareOne, __vue_component__$5o as PhNumberSquareSeven, __vue_component__$5n as PhNumberSquareSix, __vue_component__$5m as PhNumberSquareThree, __vue_component__$5l as PhNumberSquareTwo, __vue_component__$5k as PhNumberSquareZero, __vue_component__$5j as PhNumberThree, __vue_component__$5i as PhNumberTwo, __vue_component__$5h as PhNumberZero, __vue_component__$5g as PhNut, __vue_component__$5f as PhNyTimesLogo, __vue_component__$5e as PhOctagon, __vue_component__$5d as PhOption, __vue_component__$5c as PhPackage, __vue_component__$5b as PhPaintBrush, __vue_component__$5a as PhPaintBrushBroad, __vue_component__$59 as PhPaintBrushHousehold, __vue_component__$58 as PhPaintBucket, __vue_component__$57 as PhPaintRoller, __vue_component__$56 as PhPalette, __vue_component__$55 as PhPaperPlane, __vue_component__$54 as PhPaperPlaneRight, __vue_component__$53 as PhPaperPlaneTilt, __vue_component__$52 as PhPaperclip, __vue_component__$51 as PhPaperclipHorizontal, __vue_component__$50 as PhParachute, __vue_component__$4$ as PhPassword, __vue_component__$4_ as PhPath, __vue_component__$4Z as PhPause, __vue_component__$4Y as PhPauseCircle, __vue_component__$4X as PhPawPrint, __vue_component__$4W as PhPeace, __vue_component__$4V as PhPen, __vue_component__$4U as PhPenNib, __vue_component__$4T as PhPenNibStraight, __vue_component__$4S as PhPencil, __vue_component__$4R as PhPencilCircle, __vue_component__$4Q as PhPencilLine, __vue_component__$4P as PhPencilSimple, __vue_component__$4O as PhPencilSimpleLine, __vue_component__$4N as PhPercent, __vue_component__$4M as PhPerson, __vue_component__$4L as PhPersonSimple, __vue_component__$4K as PhPersonSimpleRun, __vue_component__$4J as PhPersonSimpleWalk, __vue_component__$4I as PhPerspective, __vue_component__$4H as PhPhone, __vue_component__$4G as PhPhoneCall, __vue_component__$4F as PhPhoneDisconnect, __vue_component__$4E as PhPhoneIncoming, __vue_component__$4D as PhPhoneOutgoing, __vue_component__$4C as PhPhoneSlash, __vue_component__$4B as PhPhoneX, __vue_component__$4A as PhPhosphorLogo, __vue_component__$4z as PhPianoKeys, __vue_component__$4y as PhPictureInPicture, __vue_component__$4x as PhPill, __vue_component__$4w as PhPinterestLogo, __vue_component__$4v as PhPinwheel, __vue_component__$4u as PhPizza, __vue_component__$4t as PhPlaceholder, __vue_component__$4s as PhPlanet, __vue_component__$4r as PhPlay, __vue_component__$4q as PhPlayCircle, __vue_component__$4p as PhPlaylist, __vue_component__$4o as PhPlug, __vue_component__$4n as PhPlugs, __vue_component__$4m as PhPlugsConnected, __vue_component__$4l as PhPlus, __vue_component__$4k as PhPlusCircle, __vue_component__$4j as PhPlusMinus, __vue_component__$4i as PhPokerChip, __vue_component__$4h as PhPoliceCar, __vue_component__$4g as PhPolygon, __vue_component__$4f as PhPopcorn, __vue_component__$4e as PhPower, __vue_component__$4d as PhPrescription, __vue_component__$4c as PhPresentation, __vue_component__$4b as PhPresentationChart, __vue_component__$4a as PhPrinter, __vue_component__$49 as PhProhibit, __vue_component__$48 as PhProhibitInset, __vue_component__$47 as PhProjectorScreen, __vue_component__$46 as PhProjectorScreenChart, __vue_component__$45 as PhPushPin, __vue_component__$44 as PhPushPinSimple, __vue_component__$43 as PhPushPinSimpleSlash, __vue_component__$42 as PhPushPinSlash, __vue_component__$41 as PhPuzzlePiece, __vue_component__$40 as PhQrCode, __vue_component__$3$ as PhQuestion, __vue_component__$3_ as PhQueue, __vue_component__$3Z as PhQuotes, __vue_component__$3Y as PhRadical, __vue_component__$3X as PhRadio, __vue_component__$3W as PhRadioButton, __vue_component__$3V as PhRainbow, __vue_component__$3U as PhRainbowCloud, __vue_component__$3T as PhReceipt, __vue_component__$3S as PhRecord, __vue_component__$3R as PhRectangle, __vue_component__$3Q as PhRecycle, __vue_component__$3P as PhRedditLogo, __vue_component__$3O as PhRepeat, __vue_component__$3N as PhRepeatOnce, __vue_component__$3M as PhRewind, __vue_component__$3L as PhRewindCircle, __vue_component__$3K as PhRobot, __vue_component__$3J as PhRocket, __vue_component__$3I as PhRocketLaunch, __vue_component__$3H as PhRows, __vue_component__$3G as PhRss, __vue_component__$3F as PhRssSimple, __vue_component__$3E as PhRug, __vue_component__$3D as PhRuler, __vue_component__$3C as PhScales, __vue_component__$3B as PhScan, __vue_component__$3A as PhScissors, __vue_component__$3z as PhScreencast, __vue_component__$3y as PhScribbleLoop, __vue_component__$3x as PhScroll, __vue_component__$3w as PhSelection, __vue_component__$3v as PhSelectionAll, __vue_component__$3u as PhSelectionBackground, __vue_component__$3t as PhSelectionForeground, __vue_component__$3s as PhSelectionInverse, __vue_component__$3r as PhSelectionPlus, __vue_component__$3q as PhSelectionSlash, __vue_component__$3p as PhShare, __vue_component__$3o as PhShareNetwork, __vue_component__$3n as PhShield, __vue_component__$3m as PhShieldCheck, __vue_component__$3l as PhShieldCheckered, __vue_component__$3k as PhShieldChevron, __vue_component__$3j as PhShieldPlus, __vue_component__$3i as PhShieldSlash, __vue_component__$3h as PhShieldStar, __vue_component__$3g as PhShieldWarning, __vue_component__$3f as PhShoppingBag, __vue_component__$3e as PhShoppingBagOpen, __vue_component__$3d as PhShoppingCart, __vue_component__$3c as PhShoppingCartSimple, __vue_component__$3b as PhShower, __vue_component__$3a as PhShuffle, __vue_component__$39 as PhShuffleAngular, __vue_component__$38 as PhShuffleSimple, __vue_component__$37 as PhSidebar, __vue_component__$36 as PhSidebarSimple, __vue_component__$35 as PhSignIn, __vue_component__$34 as PhSignOut, __vue_component__$33 as PhSignpost, __vue_component__$32 as PhSimCard, __vue_component__$31 as PhSketchLogo, __vue_component__$30 as PhSkipBack, __vue_component__$2$ as PhSkipBackCircle, __vue_component__$2_ as PhSkipForward, __vue_component__$2Z as PhSkipForwardCircle, __vue_component__$2Y as PhSkull, __vue_component__$2X as PhSlackLogo, __vue_component__$2W as PhSliders, __vue_component__$2V as PhSlidersHorizontal, __vue_component__$2U as PhSmiley, __vue_component__$2T as PhSmileyBlank, __vue_component__$2S as PhSmileyMeh, __vue_component__$2R as PhSmileyNervous, __vue_component__$2Q as PhSmileySad, __vue_component__$2P as PhSmileySticker, __vue_component__$2O as PhSmileyWink, __vue_component__$2N as PhSmileyXEyes, __vue_component__$2M as PhSnapchatLogo, __vue_component__$2L as PhSnowflake, __vue_component__$2K as PhSoccerBall, __vue_component__$2J as PhSortAscending, __vue_component__$2I as PhSortDescending, __vue_component__$2H as PhSpade, __vue_component__$2G as PhSparkle, __vue_component__$2F as PhSpeakerHigh, __vue_component__$2E as PhSpeakerLow, __vue_component__$2D as PhSpeakerNone, __vue_component__$2C as PhSpeakerSimpleHigh, __vue_component__$2B as PhSpeakerSimpleLow, __vue_component__$2A as PhSpeakerSimpleNone, __vue_component__$2z as PhSpeakerSimpleSlash, __vue_component__$2y as PhSpeakerSimpleX, __vue_component__$2x as PhSpeakerSlash, __vue_component__$2w as PhSpeakerX, __vue_component__$2v as PhSpinner, __vue_component__$2u as PhSpinnerGap, __vue_component__$2t as PhSpiral, __vue_component__$2s as PhSpotifyLogo, __vue_component__$2r as PhSquare, __vue_component__$2q as PhSquareHalf, __vue_component__$2p as PhSquareHalfBottom, __vue_component__$2o as PhSquareLogo, __vue_component__$2n as PhSquaresFour, __vue_component__$2m as PhStack, __vue_component__$2l as PhStackOverflowLogo, __vue_component__$2k as PhStackSimple, __vue_component__$2j as PhStamp, __vue_component__$2i as PhStar, __vue_component__$2h as PhStarFour, __vue_component__$2g as PhStarHalf, __vue_component__$2f as PhSticker, __vue_component__$2e as PhStop, __vue_component__$2d as PhStopCircle, __vue_component__$2c as PhStorefront, __vue_component__$2b as PhStrategy, __vue_component__$2a as PhStripeLogo, __vue_component__$29 as PhStudent, __vue_component__$28 as PhSuitcase, __vue_component__$27 as PhSuitcaseSimple, __vue_component__$26 as PhSun, __vue_component__$25 as PhSunDim, __vue_component__$24 as PhSunHorizon, __vue_component__$23 as PhSunglasses, __vue_component__$22 as PhSwap, __vue_component__$21 as PhSwatches, __vue_component__$20 as PhSword, __vue_component__$1$ as PhSyringe, __vue_component__$1_ as PhTShirt, __vue_component__$1Z as PhTable, __vue_component__$1Y as PhTabs, __vue_component__$1X as PhTag, __vue_component__$1W as PhTagChevron, __vue_component__$1V as PhTagSimple, __vue_component__$1U as PhTarget, __vue_component__$1T as PhTaxi, __vue_component__$1S as PhTelegramLogo, __vue_component__$1R as PhTelevision, __vue_component__$1Q as PhTelevisionSimple, __vue_component__$1P as PhTennisBall, __vue_component__$1O as PhTerminal, __vue_component__$1N as PhTerminalWindow, __vue_component__$1M as PhTestTube, __vue_component__$1L as PhTextAa, __vue_component__$1K as PhTextAlignCenter, __vue_component__$1J as PhTextAlignJustify, __vue_component__$1I as PhTextAlignLeft, __vue_component__$1H as PhTextAlignRight, __vue_component__$1G as PhTextBolder, __vue_component__$1F as PhTextH, __vue_component__$1E as PhTextHFive, __vue_component__$1D as PhTextHFour, __vue_component__$1C as PhTextHOne, __vue_component__$1B as PhTextHSix, __vue_component__$1A as PhTextHThree, __vue_component__$1z as PhTextHTwo, __vue_component__$1y as PhTextIndent, __vue_component__$1x as PhTextItalic, __vue_component__$1w as PhTextOutdent, __vue_component__$1v as PhTextStrikethrough, __vue_component__$1u as PhTextT, __vue_component__$1t as PhTextUnderline, __vue_component__$1s as PhTextbox, __vue_component__$1r as PhThermometer, __vue_component__$1q as PhThermometerCold, __vue_component__$1p as PhThermometerHot, __vue_component__$1o as PhThermometerSimple, __vue_component__$1n as PhThumbsDown, __vue_component__$1m as PhThumbsUp, __vue_component__$1l as PhTicket, __vue_component__$1k as PhTiktokLogo, __vue_component__$1j as PhTimer, __vue_component__$1i as PhToggleLeft, __vue_component__$1h as PhToggleRight, __vue_component__$1g as PhToilet, __vue_component__$1f as PhToiletPaper, __vue_component__$1e as PhTote, __vue_component__$1d as PhToteSimple, __vue_component__$1c as PhTrademarkRegistered, __vue_component__$1b as PhTrafficCone, __vue_component__$1a as PhTrafficSign, __vue_component__$19 as PhTrafficSignal, __vue_component__$18 as PhTrain, __vue_component__$17 as PhTrainRegional, __vue_component__$16 as PhTrainSimple, __vue_component__$15 as PhTranslate, __vue_component__$14 as PhTrash, __vue_component__$13 as PhTrashSimple, __vue_component__$12 as PhTray, __vue_component__$11 as PhTree, __vue_component__$10 as PhTreeEvergreen, __vue_component__$$ as PhTreeStructure, __vue_component__$_ as PhTrendDown, __vue_component__$Z as PhTrendUp, __vue_component__$Y as PhTriangle, __vue_component__$X as PhTrophy, __vue_component__$W as PhTruck, __vue_component__$V as PhTwitchLogo, __vue_component__$U as PhTwitterLogo, __vue_component__$T as PhUmbrella, __vue_component__$S as PhUmbrellaSimple, __vue_component__$R as PhUpload, __vue_component__$Q as PhUploadSimple, __vue_component__$P as PhUser, __vue_component__$O as PhUserCircle, __vue_component__$N as PhUserCircleGear, __vue_component__$M as PhUserCircleMinus, __vue_component__$L as PhUserCirclePlus, __vue_component__$K as PhUserFocus, __vue_component__$J as PhUserGear, __vue_component__$I as PhUserList, __vue_component__$H as PhUserMinus, __vue_component__$G as PhUserPlus, __vue_component__$F as PhUserRectangle, __vue_component__$E as PhUserSquare, __vue_component__$D as PhUserSwitch, __vue_component__$C as PhUsers, __vue_component__$B as PhUsersFour, __vue_component__$A as PhUsersThree, __vue_component__$z as PhVault, __vue_component__$y as PhVibrate, __vue_component__$x as PhVideoCamera, __vue_component__$w as PhVideoCameraSlash, __vue_component__$v as PhVignette, __vue_component__$u as PhVoicemail, __vue_component__$t as PhVolleyball, __vue_component__$s as PhWall, __vue_component__$r as PhWallet, __vue_component__$q as PhWarning, __vue_component__$p as PhWarningCircle, __vue_component__$o as PhWarningOctagon, __vue_component__$n as PhWatch, __vue_component__$m as PhWaveSawtooth, __vue_component__$l as PhWaveSine, __vue_component__$k as PhWaveSquare, __vue_component__$j as PhWaveTriangle, __vue_component__$i as PhWaves, __vue_component__$h as PhWebcam, __vue_component__$g as PhWhatsappLogo, __vue_component__$f as PhWheelchair, __vue_component__$e as PhWifiHigh, __vue_component__$d as PhWifiLow, __vue_component__$c as PhWifiMedium, __vue_component__$b as PhWifiNone, __vue_component__$a as PhWifiSlash, __vue_component__$9 as PhWifiX, __vue_component__$8 as PhWind, __vue_component__$7 as PhWindowsLogo, __vue_component__$6 as PhWine, __vue_component__$5 as PhWrench, __vue_component__$4 as PhX, __vue_component__$3 as PhXCircle, __vue_component__$2 as PhXSquare, __vue_component__$1 as PhYinYang, __vue_component__ as PhYoutubeLogo, plugin as default };
